(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ecCom"), require("antd"), require("ReactDOM"), require("weaPortalPublic"), require("mobxReact"), require("ReactRouter"), require("loadjs"), require("comsMobx"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ecCom", "antd", "ReactDOM", "weaPortalPublic", "mobxReact", "ReactRouter", "loadjs", "comsMobx"], factory);
	else if(typeof exports === 'object')
		exports["weaPortal"] = factory(require("React"), require("ecCom"), require("antd"), require("ReactDOM"), require("weaPortalPublic"), require("mobxReact"), require("ReactRouter"), require("loadjs"), require("comsMobx"));
	else
		root["weaPortal"] = factory(root["React"], root["ecCom"], root["antd"], root["ReactDOM"], root["weaPortalPublic"], root["mobxReact"], root["ReactRouter"], root["loadjs"], root["comsMobx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_65__, __WEBPACK_EXTERNAL_MODULE_103__, __WEBPACK_EXTERNAL_MODULE_111__, __WEBPACK_EXTERNAL_MODULE_162__, __WEBPACK_EXTERNAL_MODULE_279__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/portal/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 170);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(197);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(201);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(119);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(88);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34), __webpack_require__(75)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _ActionTypes=__webpack_require__(101);var _objectAssign=__webpack_require__(37);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var RSS=_ActionTypes.ELEMENT_TYPES.RSS,NEWS=_ActionTypes.ELEMENT_TYPES.NEWS,WORKFLOW=_ActionTypes.ELEMENT_TYPES.WORKFLOW,CUSTOMPAGE=_ActionTypes.ELEMENT_TYPES.CUSTOMPAGE,REPORTFORM=_ActionTypes.ELEMENT_TYPES.REPORTFORM,OUTDATA=_ActionTypes.ELEMENT_TYPES.OUTDATA,FORMMODECUSTOMSEARCH=_ActionTypes.ELEMENT_TYPES.FORMMODECUSTOMSEARCH,ADDWF=_ActionTypes.ELEMENT_TYPES.ADDWF,TASK=_ActionTypes.ELEMENT_TYPES.TASK,BLOGSTATUS=_ActionTypes.ELEMENT_TYPES.BLOGSTATUS,CONTACTS=_ActionTypes.ELEMENT_TYPES.CONTACTS,UNREAD_DOCS=_ActionTypes.ELEMENT_TYPES.UNREAD_DOCS,MESSAGE_REMINDING=_ActionTypes.ELEMENT_TYPES.MESSAGE_REMINDING,MY_PROJECTS=_ActionTypes.ELEMENT_TYPES.MY_PROJECTS,NEW_CUSTOMERS=_ActionTypes.ELEMENT_TYPES.NEW_CUSTOMERS,NEW_MEETING=_ActionTypes.ELEMENT_TYPES.NEW_MEETING,UNREAD_COOPERATION=_ActionTypes.ELEMENT_TYPES.UNREAD_COOPERATION,MONTH_TARGET=_ActionTypes.ELEMENT_TYPES.MONTH_TARGET,DAY_PLAN=_ActionTypes.ELEMENT_TYPES.DAY_PLAN,SUBSCRIBE_KONWLEDG=_ActionTypes.ELEMENT_TYPES.SUBSCRIBE_KONWLEDG,MORE_NEWS=_ActionTypes.ELEMENT_TYPES.MORE_NEWS,MAGAZINE=_ActionTypes.ELEMENT_TYPES.MAGAZINE,STOCK=_ActionTypes.ELEMENT_TYPES.STOCK,DOC_CONTENT=_ActionTypes.ELEMENT_TYPES.DOC_CONTENT,AUDIO=_ActionTypes.ELEMENT_TYPES.AUDIO,FAVOURITE=_ActionTypes.ELEMENT_TYPES.FAVOURITE,FLASH=_ActionTypes.ELEMENT_TYPES.FLASH,PICTURE=_ActionTypes.ELEMENT_TYPES.PICTURE,MYCALENDAR=_ActionTypes.ELEMENT_TYPES.MYCALENDAR,IMGSLIDE=_ActionTypes.ELEMENT_TYPES.IMGSLIDE,NEWNOTICE=_ActionTypes.ELEMENT_TYPES.NEWNOTICE,OUTTERSYS=_ActionTypes.ELEMENT_TYPES.OUTTERSYS,SCRATCHPAD=_ActionTypes.ELEMENT_TYPES.SCRATCHPAD,WEATHER=_ActionTypes.ELEMENT_TYPES.WEATHER,VIDEO=_ActionTypes.ELEMENT_TYPES.VIDEO,SLIDE=_ActionTypes.ELEMENT_TYPES.SLIDE,DATACENTER=_ActionTypes.ELEMENT_TYPES.DATACENTER,JOBSINFO=_ActionTypes.ELEMENT_TYPES.JOBSINFO,SEARCHENGINE=_ActionTypes.ELEMENT_TYPES.SEARCHENGINE,NOTICE=_ActionTypes.ELEMENT_TYPES.NOTICE,PLAN=_ActionTypes.ELEMENT_TYPES.PLAN,CUSTOMMENU=_ActionTypes.ELEMENT_TYPES.CUSTOMMENU,WORKTASK=_ActionTypes.ELEMENT_TYPES.WORKTASK,MAIL=_ActionTypes.ELEMENT_TYPES.MAIL,MEETINGCALENDAR=_ActionTypes.ELEMENT_TYPES.MEETINGCALENDAR,LOGIN_NEWS=_ActionTypes.ELEMENT_TYPES.LOGIN_NEWS,MYTASK=_ActionTypes.ELEMENT_TYPES.MYTASK,NEW_DY=_ActionTypes.ELEMENT_TYPES.NEW_DY;//判断元素是否为E9改造后的元素
var isE9Element=function isE9Element(ebaseid){for(var key in _ActionTypes.ELEMENT_TYPES){if(ebaseid===_ActionTypes.ELEMENT_TYPES[key])return true;}return false;};//无权访问的元素的组件
var NoRightCom=function(_React$Component){(0,_inherits3.default)(NoRightCom,_React$Component);function NoRightCom(){(0,_classCallCheck3.default)(this,NoRightCom);return(0,_possibleConstructorReturn3.default)(this,(NoRightCom.__proto__||(0,_getPrototypeOf2.default)(NoRightCom)).apply(this,arguments));}(0,_createClass3.default)(NoRightCom,[{key:'render',value:function render(){return _react2.default.createElement('div',{style:{width:'100%',height:'50px',lineHeight:'50px',textAlign:'center'}},_react2.default.createElement(_antd.Icon,{type:'exclamation-circle',style:{marginRight:'8px',color:'#fa0'}}),_react2.default.createElement('span',null,getLabel(2012,'对不起，您暂时没有权限！')));}}]);return NoRightCom;}(_react2.default.Component);//处理计算E9元素高度
var handleHeight=function handleHeight(oldstyle){var style={};if(!(0,_lodash.isEmpty)(oldstyle)){style=(0,_extends3.default)({},oldstyle);if(style.height){var height=style.height.replace("px","");var nherght=parseInt((parseInt(height)-32+1)/25)*31+32;style['height']=nherght+'px';}}return style;};//返回前一个tab
var doPrev=function doPrev(eid){$("#tabContainer_"+eid).scrollTo({top:'0px',left:$("#tabContainer_"+eid).get(0).scrollLeft-77+'px'},500);};//进入下一个tab
var doNext=function doNext(eid){$("#tabContainer_"+eid).scrollTo({top:'0px',left:$("#tabContainer_"+eid).get(0).scrollLeft+77+'px'},500);};//处理多tab的宽度，并判断是否显示左右箭头导航
var handleWidth=function handleWidth(eid,hpid,length,canHeadbar,displayPosition){var divWidth=length*77+36;var hpWidth=$("#content_"+eid).width();if(parseInt(hpid)<0){// var hpdom = $("#item_"+eid).parents("div[class='homepage']")[0];
var hpdom=$("#item_"+eid).parents('div.homepage')[0];hpWidth=$(hpdom).parent().width();hpWidth=hpWidth-20;divWidth=divWidth-36;}var titleWidth=hpWidth-10;if(!canHeadbar){hpWidth=hpWidth-$("#content_"+eid).find(".optoolbar").width();}if(parseFloat(divWidth)>parseFloat(hpWidth)){$("#tabnavprev_"+eid).css("display","block");$("#tabnavnext_"+eid).css("display","block");if(length>1){if(!canHeadbar){var width=$("#content_"+eid).find(".optoolbar").width()+5;$("#tabContainer_"+eid).css("width",hpWidth-55);$("#tabnavnext_"+eid).css("right",width+'px');}else{$("#tabContainer_"+eid).css("width",hpWidth-55);if(displayPosition&&displayPosition=='bottom'){$("#titleContainer_"+eid).css("width",hpWidth);}}$("#tabContainer_"+eid).css("display","");$("#tabContainer_"+eid).css("margin-left","0px");$("#tabContainer_"+eid).css("margin-right","0px");}else{$("#tabnavprev_"+eid).css("display","none");$("#tabnavnext_"+eid).css("display","none");$("#tabContainer_"+eid).css("display","none");}}else{$("#tabnavprev_"+eid).css("display","none");$("#tabnavnext_"+eid).css("display","none");if(length>1){if(!canHeadbar){$("#tabContainer_"+eid).css("width",hpWidth-50);}else{$("#tabContainer_"+eid).css("width",hpWidth);}$("#tabContainer_"+eid).css("display","");$("#tabContainer_"+eid).css("margin-left","0");$("#tabContainer_"+eid).css("margin-right","0");}else{$("#tabContainer_"+eid).css("display","none");}}$("#tabContainer_"+eid+" table").css("min-width",length*77);};//处理antd Table数据，返回columns
var formatData=function formatData(obj,esetting,fun){var imgSymbol=esetting.imgSymbol,linkmode=esetting.linkmode,isremind=esetting.isremind,widths=esetting.widths,titles=esetting.titles,ebaseid=esetting.ebaseid,eid=esetting.eid,_esetting$fontStyle=esetting.fontStyle,fontStyle=_esetting$fontStyle===undefined?{}:_esetting$fontStyle;var _fontStyle$contentfon=fontStyle.contentfontsize,contentfontsize=_fontStyle$contentfon===undefined?'12':_fontStyle$contentfon;var columns=new Array();var i=0;//加载行小图标
if(imgSymbol){var iObj={dataIndex:'imgSymbol',key:'imgSymbol',width:ebaseid=='FormModeCustomSearch'?'1%':'8px',render:function render(){return _react2.default.createElement('img',{style:{marginBottom:'4px'},name:'esymbol',src:imgSymbol});}};columns.push(iObj);}for(var k in obj){if(k==='key')continue;var colObj=new Object();var kv=obj[k];if(kv&&(typeof kv==='undefined'?'undefined':(0,_typeof3.default)(kv))==='object'&&kv.constructor===Object){//判断属性值的类型，Object类型
colObj={dataIndex:k,className:ebaseid===_ActionTypes.ELEMENT_TYPES.WORKFLOW&&k==='requestname'?'reqdetail':'',key:k,render:function render(text){return loadRemind(text,linkmode,isremind,fun,contentfontsize,ebaseid,eid);}};}else if(kv&&(typeof kv==='undefined'?'undefined':(0,_typeof3.default)(kv))==='object'&&kv.constructor===Array){//判断属性值的类型，List类型，建模查询中心元素用到
colObj={dataIndex:k,key:k,render:function render(text){return loadListName(contentfontsize,text,linkmode);}};}else{//判断属性值的类型，字符串类型
colObj={dataIndex:k,key:k,render:function render(text){if(typeof text==='string'){if(_isHtml(text)){//判断字符串是否含有html
return _react2.default.createElement('font',{className:text.indexOf("class='font'")==-1?'font wea-f'+contentfontsize:'wea-f'+contentfontsize,dangerouslySetInnerHTML:{__html:text}});}else{return _react2.default.createElement('font',{className:'font wea-f'+contentfontsize},text);}}else{return _react2.default.createElement('font',{className:'font wea-f'+contentfontsize});}}};}if(k=='finish'){colObj={dataIndex:'finish',key:'finish',render:function render(text){return _react2.default.createElement(_ecCom.WeaProgress,{percent:text,strokeColor:'#B37BFA'});}};}if(titles)colObj['title']=titles[i];var width=colObj.dataIndex&&widths[colObj.dataIndex];if(widths[colObj.dataIndex]!=''&&widths[colObj.dataIndex]!='*'){if(width&&width.indexOf('%')==-1){width+='px';}}if(widths)colObj['width']=width;columns.push(colObj);i+=1;}/*if (ebaseid === ELEMENT_TYPES.WORKFLOW) {                                               //加载流程签字意见查看小图标
        const iObj = {
            dataIndex: 'requestname',
            key: 'imgdetail',
            width: '10px',
            render: (text= {}) => <img title={'查看流转意见'} data_requestid={text.requestid||'-1'} className="imgdetail" style={{cursor:'pointer',display:'none',marginLeft:'-8px',marginBottom:'-1px'}} src="/images/ecology8/homepage/req_wev8.png" width="12px" height="12px"/>
        }
        columns.push(iObj);
    }*/return columns;};//处理属性为集合的数据
var loadListName=function loadListName(contentfontsize,list,linkmode){if(!list||list.length===0)return _react2.default.createElement('span',null);var html=list.map(function(obj,o){var dotstr=o===0?"":" , ";if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Object){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";if(obj.usertype&&obj.usertype=='1'){ahtml="<a target='_blank' href='/spa/crm/static/index.html#/main/crm/customerView?customerId="+obj.userid+"' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";}return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('font',null,dotstr,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name)));}else if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Array){var shtml=obj.map(function(obj,s){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";if(obj.usertype&&obj.usertype=='1'){ahtml="<a target='_blank' href='/spa/crm/static/index.html#/main/crm/customerView?customerId="+obj.userid+"' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";}return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name));});return _react2.default.createElement('font',null,dotstr,shtml);}});return _react2.default.createElement('span',{className:'td-span-formmodecustomsearch'},html);};//加载提醒方式
var loadRemind=function loadRemind(obj,linkmode,isremind,fun,contentfontsize,ebaseid,eid,style){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font class='font wea-f"+contentfontsize+"'>"+obj.name+"</font></a>";if(obj.usertype&&obj.usertype=='1'){ahtml="<a target='_blank' href='/spa/crm/static/index.html#/main/crm/customerView?customerId="+obj.userid+"' title="+obj.name+"><font class='font wea-f"+contentfontsize+"'>"+obj.name+"</font></a>";}return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}var nametitle=obj.name;if(obj.pretitle)nametitle=obj.pretitle+nametitle;if(obj.lasttitle)nametitle=nametitle+obj.lasttitle;if(obj.coworkTitle)nametitle=obj.coworkTitle;var showName=_react2.default.createElement('font',{dangerouslySetInnerHTML:{__html:obj.name}});var nametitle_new='';if(nametitle){nametitle_new=nametitle.replace(/<\/?[^>]*>/g,'');//去除HTML Tag
nametitle_new=nametitle_new.replace(/[\r\n]/g,"");//去除换行
}var lasttitle_new=_react2.default.createElement('font',{dangerouslySetInnerHTML:{__html:obj.lasttitle}});var signNturesIcon=ebaseid=='8'?_react2.default.createElement('img',{onClick:function onClick(){return fun(obj.requestid);},title:getLabel(386528,'查看流转意见'),'data-requestid':obj.requestid||'-1',className:'portal_workflow_signaturesIcon ',src:'/images/ecology8/homepage/req_wev8.png',width:'14px',height:'16px',alt:''}):'';var wfremindimgId='portal_wfremindimg_'+obj.requestid;if(!obj.requestid&&obj.link&&(ebaseid=='7'||ebaseid=='7_DY')){var index=obj.link.indexOf('&');if(index>0)wfremindimgId='portal_wfremindimg_news_'+obj.link.substring(0,index).replace(/[^0-9]/ig,"");};if(obj.img){if(isremind){var style={};var tempremind="";if(isremind.indexOf("#")>-1){tempremind=isremind.substring(0,isremind.indexOf("#")-1);}else{tempremind=isremind;}if(tempremind.indexOf("3")!==-1){var color=isremind.substr(isremind.indexOf("#"));style['color']=color;}if(tempremind.indexOf("1")!==-1){style['fontWeight']='bold';}if(tempremind.indexOf("2")!==-1){style['fontStyle']='italic';}if(tempremind.indexOf("0")===-1){return _react2.default.createElement('span',{className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,(0,_extends3.default)({},obj,{ebaseid:ebaseid,eid:eid}));},'data-link':obj.link,id:obj.requestid,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{style:{width:'100%'},className:'font wea-f'+contentfontsize},_react2.default.createElement('font',{style:style},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},lasttitle_new):null))),signNturesIcon);}else{return _react2.default.createElement('span',{id:wfremindimgId,className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,(0,_extends3.default)({},obj,{ebaseid:ebaseid,id:wfremindimgId,eid:eid}));},'data-link':obj.link,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize,style:{width:"100%"}},_react2.default.createElement('font',{style:style},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},lasttitle_new):null))),_react2.default.createElement('img',{className:'wfremindimg',src:obj.img}),signNturesIcon);}}return _react2.default.createElement('span',{id:wfremindimgId,className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,(0,_extends3.default)({},obj,{ebaseid:ebaseid,id:wfremindimgId,eid:eid}));},'data-link':obj.link,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize,style:{width:"100%"}},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},lasttitle_new):null)),_react2.default.createElement('img',{className:'wfremindimg',src:obj.img}),signNturesIcon);}if(style){return _react2.default.createElement('span',{className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,obj.requestid);},'data-link':obj.link,id:obj.requestid,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{style:style,className:'font wea-f'+contentfontsize},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},obj.lasttitle):null)),signNturesIcon);}else return _react2.default.createElement('span',{className:'td-span'},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return openLinkUrl(obj.link,linkmode,obj.requestid);},'data-link':obj.link,id:obj.requestid,'data-requestid':obj.requestid,title:nametitle_new},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize,style:{width:'100%'}},obj.pretitle?obj.pretitle:'',showName,obj.lasttitle?_react2.default.createElement('b',{style:{fontWeight:'bold'}},obj.lasttitle):null)),signNturesIcon);};//获取当前时间戳(以s为单位)
var formatDate=function formatDate(_date,format){var date={"M+":_date.getMonth()+1,"d+":_date.getDate(),"h+":_date.getHours(),"m+":_date.getMinutes(),"s+":_date.getSeconds(),"q+":Math.floor((_date.getMonth()+3)/3),"S+":_date.getMilliseconds()};if(/(y+)/i.test(format)){format=format.replace(RegExp.$1,(_date.getFullYear()+'').substr(4-RegExp.$1.length));}for(var k in date){if(new RegExp("("+k+")").test(format)){format=format.replace(RegExp.$1,RegExp.$1.length==1?date[k]:("00"+date[k]).substr((""+date[k]).length));}}return format;};//数组contains函数
var isContain=function isContain(arr,element){for(var i=0;i<arr.length;i++){if(arr[i]==element){return true;}}return false;};//定义map函数，实现间隔遍历
var intervalMap=function intervalMap(arr,fn){var mul=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var a=[];if(mul>0){for(var i=0;i<arr.length;i+=mul){var value=fn(arr[i],i);if(value==null){continue;//如果函数fn返回null，则从数组中删除该项
}a.push(value);}}return a;};/** --------- 元素工具栏功能js函数 -----------**/function onSetting(eid,ebaseid,hpid,subCompanyId){// 获取设置页面内容
var settingUrl="/page/element/setting.jsp"+"?eid="+eid+"&ebaseid="+ebaseid+"&hpid="+hpid+"&subcompanyid="+subCompanyId;$.post(settingUrl,null,function(data){if($.trim(data)!=""){$("#setting_"+eid).hide();$("#setting_"+eid).remove();$("#content_"+eid).prepend($.trim(data));$(".tabs").PortalTabs({getLine:1,topHeight:40});$(".tab_box").height(0);$("#setting_"+eid).show();$("#weavertabs-content-"+eid).show();var urlContent=$.trim($("#weavertabs-content-"+eid).attr("url")).replace(/&amp;/g,"&");var urlStyle=$.trim($("#weavertabs-style-"+eid).attr("url")).replace(/&amp;/g,"&");var urlShare=$.trim($("#weavertabs-share-"+eid).attr("url")).replace(/&amp;/g,"&");if(urlContent!=""){var randomValue=new Date().getTime();if(ebaseid==7||ebaseid==8||ebaseid==1||ebaseid=='news'||ebaseid==29||ebaseid=='reportForm'){$("#setting_"+eid).attr("randomValue",randomValue);}urlContent=urlContent+"&random="+randomValue;$("#weavertabs-content-"+eid).html("");$("#weavertabs-content-"+eid).html("<img src=/images/loading2_wev8.gif> loading...");$("#weavertabs-content-"+eid).load(urlContent,{},function(){//$("#sync_datacenter_"+eid).tzCheckbox({labels:['','']});
$(".filetree").filetree();//$(".vtip").simpletooltip();
//fixedPosition(eid);
jscolor.init();// 初始化layout组件
initLayout();});}if(urlStyle!=""){$("#weavertabs-style-"+eid).load(urlStyle,{},function(){// 初始化layout组件
initLayout();$("#weavertabs-style-"+eid).hide();});}if(urlShare!=""){$("#weavertabs-share-"+eid).load(urlShare,{},function(){$("#weavertabs-share-"+eid).hide();});}}});}//处理hpid页面元素缓存数据
var hpinfoHandle=function hpinfoHandle(){var param=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var eid=arguments[1];var _param$hpinfo=param.hpinfo,hpinfo=_param$hpinfo===undefined?{}:_param$hpinfo;var _hpinfo$layoutFlags=hpinfo.layoutFlags,layoutFlags=_hpinfo$layoutFlags===undefined?{}:_hpinfo$layoutFlags;layoutFlags.map(function(item){if(item.areaElements.length>0){for(var i=0;i<item.areaElements.length;i++){if(item.areaElements[i].item.eid==eid){item.areaElements.splice(i,1);break;}}}return item;});return(0,_objectAssign2.default)({},param,{hpinfo:(0,_objectAssign2.default)({},param.hpinfo,{layoutFlags:layoutFlags})});};var getMoreRouteUrl=function getMoreRouteUrl(eid,ebaseid){var paramsObj=window.elements_more_params[eid]||{};switch(ebaseid){//公告元素
case NEWNOTICE:if(paramsObj.createMethod&&paramsObj.createMethod=='1'){return'/spa/portal/moreStatic/index_more.html#/more?ebaseid='+ebaseid+'&eid='+eid+'&canAddNotice='+paramsObj.canAddNotice;// return '/spa/portal/moreStatic/index_more.html#/more?ebaseid=${ebaseid}&eid=${eid}&canAdd=${paramsObj.canAddNotice};
}return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//RSS阅读器
case RSS:return'/spa/portal/moreStatic/index_more.html#/more?ebaseid='+ebaseid+'&eid='+eid+'&tabid='+paramsObj.tabid;//流程中心
case WORKFLOW:var urger=paramsObj.urger||false;if(urger){return'/spa/workflow/index_mobx.jsp#/main/workflow/supervise?fromwhere=jsonFilter';}return'/spa/workflow/index_mobx.jsp#/main/workflow/queryFlowResult?fromwhere=jsonFilter';//集成登录
case OUTTERSYS:return'/spa/portal/moreStatic/index_more.html#/more?ebaseid='+ebaseid+'&eid='+eid;//外部数据
case OUTDATA:return'/spa/inte/static/index.html#/main/inte/portal/'+eid+'/'+paramsObj.tabid;//我的项目
case MY_PROJECTS:return'/spa/prj/index.html#/main/prj/queryProjectResult';//未读协作
case UNREAD_COOPERATION:return'/spa/cowork/static/index.html#/main/cowork/main';//通讯录
case CONTACTS:return'/spa/hrm/index_mobx.html#/main/hrm/addressBook';//微博
case BLOGSTATUS:return'/spa/blog/index_mobx.html#/main/blog/myBlog';//最新客户
case NEW_CUSTOMERS:return'/spa/crm/static4report/index.html#/main/crmReport/customer/newList';//建模查询中心元素
case FORMMODECUSTOMSEARCH:if(paramsObj.morehref||paramsObj.morehref!=''){return paramsObj.morehref;}return'/spa/cube/index.html#/main/cube/search?customid='+paramsObj.customid;//最新会议
case NEW_MEETING:return'/spa/meeting/static/index.html#/main/meeting/CalView';//日程
case DAY_PLAN:return'/spa/workplan/index_mobx.html#/main/wp/myWorkPlan';//新建流程
case ADDWF:return'/spa/workflow/static/index.html#/main/workflow/add';//未读文档
case UNREAD_DOCS:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter&isNew=1';//文档中心
case NEWS:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//文档中心(特殊)
case NEW_DY:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//我的邮件
case MAIL:return'/spa/email/static/index.html#/main/email/inbox?folderid=0';//公司新闻
case LOGIN_NEWS:return'/spa/document/static/index.html#/main/document/more?fromwhere=jsonFilter';//自定义页面元素
case CUSTOMPAGE:return paramsObj.moreurl;//收藏元素
case FAVOURITE:return'/spa/favourite/index.html#/main/favourite/tree';//日历日程
case MYCALENDAR:return'/spa/workplan/static/index.html#/main/wp/myWorkPlan ';// 会议日历
case MEETINGCALENDAR:return'/spa/meeting/static/index.html#/main/meeting/CalView';// 我的任务
case MYTASK:return'/spa/prj/index.html#/main/prj/queryTaskResult?searchfrom=portal';default:return'';}};//没有more页面的元素
var isNoMoreElement=function isNoMoreElement(ebaseid){switch(ebaseid){//任务计划
case WORKTASK://多图元素
case IMGSLIDE://视频元素
case VIDEO://便签元素
case SCRATCHPAD://天气元素
case WEATHER://个人数据
case DATACENTER://多岗位办理事项
case JOBSINFO://音频元素
case AUDIO://flash元素
case FLASH://自定义菜单
case CUSTOMMENU://图片元素
case PICTURE://图表元素
case REPORTFORM://搜索元素
case SEARCHENGINE://幻灯片
case SLIDE://消息提醒
case MESSAGE_REMINDING://多新闻中心
case MORE_NEWS://期刊中心
case MAGAZINE://股票元素
case STOCK://文档内容
case DOC_CONTENT:return true;default:return false;}};//  OUTTERSYS  OUTDATA  UNREAD_COOPERATION  MY_PROJECTS  NEWNOTICE(0)  NEW_CUSTOMERS  NEW_MEETING  DAY_PLAN  ADDWF
//  ADDWF  CONTACTS  RSS  CUSTOMPAGE  WORKFLOW
var openMoreWin=function openMoreWin(eid,ebaseid,_moreurl,moreRouteurl){if(!_moreurl&&ebaseid!==ADDWF&&ebaseid!==MEETINGCALENDAR&&ebaseid!==MYCALENDAR&&ebaseid!==NEW_DY)return;//没有more页面的元素
if(isNoMoreElement(ebaseid))return;if(moreRouteurl!=''){openLinkUrl(moreRouteurl);return;}var routeurl=getMoreRouteUrl(eid,ebaseid);var url=routeurl||_moreurl;var paramsObj=window.elements_more_params[eid];var getTimestamp=new Date().getTime();if(paramsObj){var moreurl=paramsObj.moreurl,isRouteUrl=paramsObj.isRouteUrl,_paramsObj$paramsStr=paramsObj.paramsStr,paramsStr=_paramsObj$paramsStr===undefined?'':_paramsObj$paramsStr;if(moreurl!==undefined){url=moreurl;}else{if(isRouteUrl){url=routeurl+paramsStr;}else{url=_moreurl+paramsStr;}}if(url.indexOf("?")>-1){url=url+"&timestamp="+getTimestamp;}else{url=url+"?timestamp="+getTimestamp;}}openLinkUrl(url);};var _s2Int=function _s2Int(s){return _str2Int(s,-1);};var _str2Int=function _str2Int(s,def){return isNaN(parseInt(s))?isNaN(parseInt(def))?-1:parseInt(def):parseInt(s);};var _isHtml=function _isHtml(htmlStr){if(!htmlStr)return false;var reg=/<[^>]+>/g;return reg.test(htmlStr)||htmlStr.indexOf("&")>-1;};window.openHref=function(url){if(window.doThemeAction){window.doThemeAction('onLoadMain',{url:url});}else{window.location.href=url;}};var openLinkUrl=function openLinkUrl(url,linkmode){var obj=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(!url)return;if(linkmode=='1'){// 当前页打开
if(window.doThemeAction){window.doThemeAction('onLoadMain',{url:url});}else{window.location.href=url;}}else{// 弹出页打开
var redirectUrl=url;var width=screen.availWidth;var height=screen.availHeight;var szFeatures="top=0,";szFeatures+="left=0,";if(url.indexOf("ebaseid=15")!=-1){//td61285
//szFeatures +="width=800," ;
szFeatures+="width="+(width-10)+",";}else{szFeatures+="width="+(width-10)+",";}szFeatures+="height="+(height-60)+",";szFeatures+="directories=no,";szFeatures+="status=yes,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";if(obj&&obj>0){window.open(redirectUrl,'_blank');}else{var opebObj=window.open(redirectUrl,'_blank')||{};if(obj.ebaseid=='6'){var loop1=setInterval(function(){clearInterval(loop1);setTimeout(function(){try{if(obj.eid){window.element_unReadDoc_reLoad(obj.eid);}}catch(e){}},500);},1000);}var loop=setInterval(function(){if(opebObj.closed){clearInterval(loop);setTimeout(function(){try{// obj.ebaseid == '7' || obj.ebaseid == '7_DY' && window.element_news_reLoad();
if((obj.ebaseid=='7'||obj.ebaseid=='7_DY')&&obj.eid&&window.element_workflow_reLoad){// // 去掉未读标识
// $(`#${obj.id}`).find("img.wfremindimg").remove();
// //去掉提醒方式样式
// $(`#${obj.id}`).find("a font").removeAttr('style');
window.element_news_reLoad(obj.eid);}obj.ebaseid=='8'&&window.element_workflow_reLoad();}catch(e){}},500);}},1000);}}};function onShowOrHideE(eid){$("#content_"+eid).toggle();}module.exports={NoRightCom:NoRightCom,handleHeight:handleHeight,doPrev:doPrev,doNext:doNext,handleWidth:handleWidth,isE9Element:isE9Element,formatData:formatData,loadRemind:loadRemind,formatDate:formatDate,isContain:isContain,intervalMap:intervalMap,onSetting:onSetting,_s2Int:_s2Int,_str2Int:_str2Int,openMoreWin:openMoreWin,openLinkUrl:openLinkUrl,onShowOrHideE:onShowOrHideE,hpinfoHandle:hpinfoHandle//流程元素全局刷新方法
};window.element_workflow_reLoad=function(){if(window.element_workflow_refresh&&(0,_typeof3.default)(window.element_workflow_refresh)=='object'){for(var eid in element_workflow_refresh){if(typeof element_workflow_refresh[eid]=='function'){element_workflow_refresh[eid]();}}}};//文档中心元素全局刷新方法
window.element_news_reLoad=function(eid){if(window.element_news_refresh&&(0,_typeof3.default)(window.element_news_refresh)=='object'&&eid){element_news_refresh[eid]();}};//未读文档元素全局刷新方法
window.element_unReadDoc_reLoad=function(eid){if(window.element_unReadDoc_refresh&&(0,_typeof3.default)(window.element_unReadDoc_refresh)=='object'){element_unReadDoc_refresh[eid]();}};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 元素类型
var EType=function(_React$Component){(0,_inherits3.default)(EType,_React$Component);function EType(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EType);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EType.__proto__||(0,_getPrototypeOf2.default)(EType)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EType,[{key:'render',value:function render(){return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(382251,'元素类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.value,viewAttr:1}));}}]);return EType;}(_react2.default.Component);exports.default=EType;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 元素标题
var ETitle=function(_React$Component){(0,_inherits3.default)(ETitle,_React$Component);function ETitle(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ETitle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ETitle.__proto__||(0,_getPrototypeOf2.default)(ETitle)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ETitle,[{key:'render',value:function render(){var _this2=this;var _props$hasLink=this.props.hasLink,hasLink=_props$hasLink===undefined?true:_props$hasLink;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19491,'元素标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{id:'element_title_name_input_'+this.props.eid,inputType:'multilang',isBase64:true,value:this.state.value,onChange:function onChange(value){return _this2.setState({value:value});}}),hasLink&&_react2.default.createElement('i',{className:'icon-coms-link portal-esetting-content-title-icon',title:getLabel(16208,'链接地址'),onClick:function onClick(){return window.open('/spa/portal/element/index.html#/main/portal/element?eid='+_this2.props.eid);}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return ETitle;}(_react2.default.Component);exports.default=ETitle;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ActionTypes=__webpack_require__(101);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _drag=__webpack_require__(218);var _Toolbar=__webpack_require__(219);var _Toolbar2=_interopRequireDefault(_Toolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//头部组件  元素标题 设置图标等
var getLabel=_ecCom.WeaLocaleProvider.getLabel;var EHeader=function(_React$Component){(0,_inherits3.default)(EHeader,_React$Component);function EHeader(props){(0,_classCallCheck3.default)(this,EHeader);var _this=(0,_possibleConstructorReturn3.default)(this,(EHeader.__proto__||(0,_getPrototypeOf2.default)(EHeader)).call(this,props));_this.state={};_this.handleDragStart=_this.handleDragStart.bind(_this);_this.setPosition=_this.setPosition.bind(_this);return _this;}(0,_createClass3.default)(EHeader,[{key:'handleDragStart',value:function handleDragStart(event){var _props=this.props,config=_props.config,handleRefresh=_props.handleRefresh;if(!config.item.header.onmousedown)return;var callback=void 0;if(config.item.ebaseid===_ActionTypes.ELEMENT_TYPES.CUSTOMPAGE)callback=handleRefresh;(0,_drag.dragStart)(event,event.target,callback);}},{key:'componentDidMount',value:function componentDidMount(){this.setPosition();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.setPosition();}},{key:'setPosition',value:function setPosition(){var config=this.props.config;var _state=this.state,left=_state.left,width=_state.width;var eid=config.item.eid;var titleWidth=$('#title_'+eid).width();var titleLeft=$('#title_'+eid).position()&&$('#title_'+eid).position().left;var toolbarWidth=$('#toolbar_'+eid).width();if((!width||!(0,_lodash.isEqual)(width,titleWidth+titleLeft+90+20+5))&&titleWidth!=null){this.setState({left:titleWidth+titleLeft+10,width:titleWidth+titleLeft+90+20+5});}}},{key:'render',value:function render(){var _state2=this.state,_state2$left=_state2.left,left=_state2$left===undefined?0:_state2$left,_state2$width=_state2.width,width=_state2$width===undefined?0:_state2$width;var _props2=this.props,config=_props2.config,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,_props2$fontSizeMp=_props2.fontSizeMp,fontSizeMp=_props2$fontSizeMp===undefined?{}:_props2$fontSizeMp,_props2$datas=_props2.datas,datas=_props2$datas===undefined?{}:_props2$datas;var _datas$tabids=datas.tabids,tabids=_datas$tabids===undefined?[]:_datas$tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header,ebaseid=_config$item.ebaseid;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';return _react2.default.createElement('div',{className:'header',style:header.style,'data-issetting':'false','data-sharelevel':'2',id:'header_'+eid,onMouseDown:this.handleDragStart},_react2.default.createElement('span',{className:'icon',id:'icon_'+eid,style:{position:'absolute',cursor:'pointer'}},_react2.default.createElement('img',{alt:'',border:'0',src:header.iconimg.src,title:header.iconimg.title,onClick:_common.onShowOrHideE.bind(this,eid)})),_react2.default.createElement('span',{className:fontStyle.titlefontsize?'wea-f'+fontStyle.titlefontsize+' title':'title',id:'title_'+eid,style:{position:'absolute',lineHeight:1}},_react2.default.createElement('font',{'class':'title-font',id:'element_title_name_'+eid,dangerouslySetInnerHTML:{__html:header.title}}),_react2.default.createElement('span',{id:'count_'+eid})),header.displayPosition&&header.displayPosition=='right'&&_react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className,style:{position:'relative',left:left+'px',width:'calc(100% - '+width+'px)',zIndex:'1',backgroundColor:'white'}},_react2.default.createElement(_TitleTabPane2.default,{datas:datas,fontStyle:fontStyle,ebaseid:ebaseid})),_react2.default.createElement(_Toolbar2.default,{datas:datas,config:config,handleDelete:handleDelete,handleRefresh:handleRefresh,getElementStyle:this.props.getElementStyle}),_react2.default.createElement('span',{className:'toolbarSub',id:'toolbarSub_'+eid}));}}]);return EHeader;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EHeader=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EHeader);exports.default=EHeader;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 链接方式
var ELinkMode=function(_React$Component){(0,_inherits3.default)(ELinkMode,_React$Component);function ELinkMode(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ELinkMode);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ELinkMode.__proto__||(0,_getPrototypeOf2.default)(ELinkMode)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ELinkMode,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19494,'链接方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.value,detailtype:3,onChange:function onChange(value){_this2.setState({value:value});}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return ELinkMode;}(_react2.default.Component);exports.default=ELinkMode;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(119);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 显示条数
var EShowNum=function(_React$Component){(0,_inherits3.default)(EShowNum,_React$Component);function EShowNum(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EShowNum);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EShowNum.__proto__||(0,_getPrototypeOf2.default)(EShowNum)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EShowNum,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19493,'显示条数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.value,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({value:value});}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return EShowNum;}(_react2.default.Component);exports.default=EShowNum;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);__webpack_require__(244);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 流程中心，数据来源，排序字段
var EField_New=function(_React$Component){(0,_inherits3.default)(EField_New,_React$Component);function EField_New(props){(0,_classCallCheck3.default)(this,EField_New);var _this=(0,_possibleConstructorReturn3.default)(this,(EField_New.__proto__||(0,_getPrototypeOf2.default)(EField_New)).call(this,props));_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.state={visible:true,eFieldNewDataSource:props.eFieldNewDataSource||[],eFieldNewUsedKeys:props.eFieldNewUsedKeys||[],leftSearchName:'',rightSearchName:''};return _this;}(0,_createClass3.default)(EField_New,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,searchName=_state.searchName;return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(32317,'显示字段设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaTransfer,{className:'portal-element-showfieldnew',data:eFieldNewDataSource,selectedKeys:eFieldNewUsedKeys,onChange:function onChange(keys){return _this2.setState({eFieldNewUsedKeys:keys});},leftHeader:_react2.default.createElement('div',{style:{display:'inline-block',position:'relative'}},_react2.default.createElement('span',{style:{paddingLeft:'15px',position:'absolute',width:'100px',textAlign:'left',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',display:'block',top:'-25px'}},getLabel(83302,'待选')),_react2.default.createElement('div',{style:{position:'absolute',top:'-25px',width:'90px',left:'238px'}},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearch:function onSearch(value){return _this2.setState({leftSearchName:value});}}))),rightHeader:_react2.default.createElement('div',{style:{display:'inline-block',position:'relative'}},_react2.default.createElement('span',{style:{paddingLeft:'15px',position:'absolute',width:'100px',textAlign:'left',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',display:'block',top:'-25px'}},getLabel(83303,'已选')),_react2.default.createElement('div',{style:{position:'absolute',top:'-25px',width:'90px',left:'238px'}},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearch:function onSearch(value){return _this2.setState({rightSearchName:value});}}))),filterLeft:this.filterLeft.bind(this,eFieldNewDataSource),filterRight:this.filterRight.bind(this,eFieldNewUsedKeys)}));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){this.props.onOk(this.state);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'filterLeft',value:function filterLeft(items){var leftSearchName=this.state.leftSearchName;if(leftSearchName){items=items.filter(function(item){return item.name.indexOf(leftSearchName.trim())!=-1;});}return items;}},{key:'filterRight',value:function filterRight(items){var _state2=this.state,rightSearchName=_state2.rightSearchName,eFieldNewDataSource=_state2.eFieldNewDataSource;var itemss=[];for(var i=0;i<items.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(items[i]==eFieldNewDataSource[j].key){itemss.push(eFieldNewDataSource[j]);continue;}}}if(rightSearchName){itemss=itemss.filter(function(item){return item.name.indexOf(rightSearchName.trim())!=-1;});}return itemss;}}]);return EField_New;}(_react2.default.Component);exports.default=EField_New;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(174);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(183);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcTabs=__webpack_require__(398);var _rcTabs2=_interopRequireDefault(_rcTabs);var _TabContent=__webpack_require__(413);var _TabContent2=_interopRequireDefault(_TabContent);var _ScrollableInkTabBar=__webpack_require__(414);var _ScrollableInkTabBar2=_interopRequireDefault(_ScrollableInkTabBar);__webpack_require__(430);var _lodash=__webpack_require__(9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TitleTabPane=function(_React$Component){(0,_inherits3.default)(TitleTabPane,_React$Component);function TitleTabPane(props){(0,_classCallCheck3.default)(this,TitleTabPane);var _this=(0,_possibleConstructorReturn3.default)(this,(TitleTabPane.__proto__||(0,_getPrototypeOf2.default)(TitleTabPane)).call(this,props));_this.state={tabid:props.datas.currentTab};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(TitleTabPane,[{key:'handleTabData',value:function handleTabData(tabid){var _props$datas=this.props.datas,datas=_props$datas===undefined?{}:_props$datas;var _datas$handleTabData=datas.handleTabData,handleTabData=_datas$handleTabData===undefined?{}:_datas$handleTabData;handleTabData(tabid);this.setState({tabid:tabid});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var tabid=this.state.tabid;if(!(0,_lodash.isEqual)(tabid,nextProps.datas.currentTab)){this.setState({tabid:nextProps.datas.currentTab});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$datas2=_props.datas,datas=_props$datas2===undefined?{}:_props$datas2,fontStyle=_props.fontStyle,_props$ebaseid=_props.ebaseid,ebaseid=_props$ebaseid===undefined?'':_props$ebaseid;var tabid=this.state.tabid;var _datas$config=datas.config,config=_datas$config===undefined?{}:_datas$config,_datas$isShowSettingS=datas.isShowSettingShowType,isShowSettingShowType=_datas$isShowSettingS===undefined?'0':_datas$isShowSettingS;var _config$item=config.item,item=_config$item===undefined?{}:_config$item;var _item$header=item.header,header=_item$header===undefined?{}:_item$header;if((0,_lodash.isEmpty)(datas))return _react2.default.createElement('div',null);var _datas$currentTab=datas.currentTab,currentTab=_datas$currentTab===undefined?'1':_datas$currentTab,_datas$tabids=datas.tabids,tabids=_datas$tabids===undefined?[]:_datas$tabids,_datas$titles=datas.titles,titles=_datas$titles===undefined?[]:_datas$titles,methodvalue=datas.methodvalue,tabwidth=datas.tabwidth,counts=datas.counts;var tdStyle={width:'auto',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px'};var tdStyle1={width:'auto',marginRight:'10px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px'};var style={marginLeft:'10px',marginRight:'10px'};var style1={width:tabwidth+'px',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis',display:'block'};var titleStyle={width:'100%'};// if(header.canHeadbar) titleStyle={width: 'calc( 100% - 95px )'}
var tHtml_new=_react2.default.createElement(_rcTabs2.default,{activeKey:tabid,renderTabBar:function renderTabBar(){return _react2.default.createElement(_ScrollableInkTabBar2.default,null);},renderTabContent:function renderTabContent(){return _react2.default.createElement(_TabContent2.default,null);},className:'tabcontainer tab2',style:titleStyle},titles.map(function(title,i){if(ebaseid=='8'&&counts&&counts[i]!==-1&&counts[i]!==''&&counts[i]!==null){title+=' ('+counts[i]+')';}else if(ebaseid=='blogStatus'&&counts&&'0'!==counts[i]){title+=' ('+counts[i]+')';}else if(ebaseid=='7_DY'&&counts&&'0'!==counts[i]){title+=' ('+counts[i].noReadNum+')';}else if(isShowSettingShowType=='1'&&ebaseid=='7'&&counts&&counts[i]&&counts[i].noReadNum){title+=' ('+counts[i].noReadNum+')';}else if(ebaseid=='7'&&counts&&counts[i]&&counts[i].isHaveNoRead&&counts[i].isHaveNoRead=='1'){title=title;}var className=tabids[i]==tabid?'tab2selected wea-f'+(fontStyle.tab1fontsize||12):'tab2unselected wea-f'+(fontStyle.tab2fontsize||12);var pointClassName=ebaseid=='7'&&counts&&counts[i]&&counts[i].isHaveNoRead&&counts[i].isHaveNoRead=='1'?'portal-new-unreadpoint':'';return _react2.default.createElement(_rcTabs.TabPane,{key:i+1,style:{width:'200px'},tab:_react2.default.createElement('div',{title:title,className:className,style:methodvalue=='2'?tdStyle1:tdStyle,'data-tabid':tabids[i],onClick:function onClick(){return _this2.handleTabData(tabids[i]);}},_react2.default.createElement('span',{style:methodvalue=='2'?style:style1},title,_react2.default.createElement('div',{className:pointClassName})))});}));return tHtml_new;}}]);return TitleTabPane;}(_react2.default.Component);exports.default=TitleTabPane;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(20);var _reactDom2=_interopRequireDefault(_reactDom);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _ESetting=__webpack_require__(122);var _ESetting2=_interopRequireDefault(_ESetting);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var OpToolbar=function(_React$Component){(0,_inherits3.default)(OpToolbar,_React$Component);function OpToolbar(props){(0,_classCallCheck3.default)(this,OpToolbar);var _this=(0,_possibleConstructorReturn3.default)(this,(OpToolbar.__proto__||(0,_getPrototypeOf2.default)(OpToolbar)).call(this,props));_this.state={islock:'',icon:'',moreRouteurl:''};_this.handleLock=_this.handleLock.bind(_this);_this.handleOnSetting=_this.handleOnSetting.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(OpToolbar,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//判断流程元素是否存在自定义more页面
var config=this.props.config;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var moreRouteurl='';if(ebaseid=='8'||ebaseid=='7'){_ecCom.WeaTools.callApi('/api/portal/customMore/getRouteurl','POST',{ebaseid:ebaseid,eid:eid}).then(function(result){if(result.status=='200'&&result.moreRouteurl){_this2.setState({moreRouteurl:result.moreRouteurl});}});}}},{key:'handleDelete',value:function handleDelete(){var _props=this.props,config=_props.config,handleDelete=_props.handleDelete;var _config$params2=config.params,eid=_config$params2.eid,hpid=_config$params2.hpid,subCompanyId=_config$params2.subCompanyId;var group=$($("#item_"+eid).parents(".group")[0]);var flag=group.attr('data-areaflag');portal-4-false;var eids="";group.find(".item").each(function(){if($(this).attr("data-eid")!=eid)eids+=$(this).attr("data-eid")+",";});var portalHpinfo_setting=ls.getJSONObj('portal-'+hpid+'-true');var portalHpinfo=ls.getJSONObj('portal-'+hpid+'-false');ls.set('portal-'+hpid+'-true',(0,_common.hpinfoHandle)(portalHpinfo_setting,eid));ls.set('portal-'+hpid+'-false',(0,_common.hpinfoHandle)(portalHpinfo,eid));_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/delete','POST',{hpid:hpid,eid:eid,delFlag:flag,delAreaElement:eids,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){handleDelete();}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleLock',value:function handleLock(){var _this3=this;var islock=this.state.islock;var _props$config$params=this.props.config.params,eid=_props$config$params.eid,hpid=_props$config$params.hpid,subCompanyId=_props$config$params.subCompanyId;_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/'+(islock?'unlock':'lock'),'POST',{eid:eid,hpid:hpid,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){_this3.setState({islock:!islock,icon:result.icon});}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleOnSetting',value:function handleOnSetting(){var _props2=this.props,config=_props2.config,handleRefresh=_props2.handleRefresh;var isSynergySetting=config.isSynergySetting,synergyParams=config.synergyParams;var _config$params3=config.params,eid=_config$params3.eid,ebaseid=_config$params3.ebaseid,hpid=_config$params3.hpid,subCompanyId=_config$params3.subCompanyId;var readyElement=['1','7','8','11','12','6','13','14','15','16','9','10','17','18','19','25','29','32','34','audio','blogStatus','favourite','Flash','menu','notice','picture','reportForm','searchengine','Slide','video','weather','scratchpad','DataCenter','MyCalendar','Task','plan','jobsinfo','outterSys','contacts','addwf','imgSlide','newNotice','OutData','FormModeCustomSearch','MeetingCalendar','CalendarEle','bookshelf','newMobilePicture','fnaBudgetAssistant','fnaBudgetAssistant1','CoreMail','news','processTask','login','NEW_DY'];if((0,_common.isContain)(readyElement,ebaseid)||/^Custom_/.test(ebaseid)){_reactDom2.default.render(_react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement(_antd.Spin,null)),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);_ecCom.WeaTools.callApi('/api/portal/setting/esetting','POST',{eid:eid,ebaseid:ebaseid,hpid:hpid,subCompanyId:subCompanyId},'json').then(function(result){result.hpid=hpid;result.subCompanyId=subCompanyId;result.eid=eid;result.ebaseid=ebaseid;_reactDom2.default.render(_react2.default.createElement(_ESetting2.default,{data:result,isSynergySetting:isSynergySetting,synergyParams:synergyParams,handleRefresh:handleRefresh,isSetting:config.isSetting}),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);});}else{(0,_common.onSetting)(eid,ebaseid,hpid,subCompanyId);}}},{key:'render',value:function render(){var _props3=this.props,config=_props3.config,clsname=_props3.clsname,islock=_props3.islock,handleRefresh=_props3.handleRefresh;var _config$item=config.item,eid=_config$item.eid,ebaseid=_config$item.ebaseid,header=_config$item.header;var toolbar=header.toolbar;var lock=toolbar.lock,refresh=toolbar.refresh,setting=toolbar.setting,close=toolbar.close,more=toolbar.more;var _state=this.state,icon=_state.icon,moreRouteurl=_state.moreRouteurl;return _react2.default.createElement('div',{className:'optoolbar '+clsname,id:'toolbar_'+eid},_react2.default.createElement('ul',null,lock?_react2.default.createElement('li',{style:{width:'11px'}},_react2.default.createElement(_antd.Popconfirm,{title:getLabel(19745,'此操作可能花较长的时间，是否继续？'),onConfirm:this.handleLock,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{'data-status':islock?'locked':'unlocked',href:'javascript:void(0);',title:lock.title},_react2.default.createElement('img',{src:icon||lock.img,border:'0',alt:''})))):'',refresh?_react2.default.createElement('li',{style:{width:'11px'}},_react2.default.createElement('a',{href:'javascript:void(0);',name:'refreshbtn',id:'refresh_'+eid,onClick:handleRefresh,title:refresh.title},_react2.default.createElement('img',{src:refresh.img,border:'0',alt:''}))):'',setting?_react2.default.createElement('li',{style:{width:'12px'}},_react2.default.createElement('a',{href:'javascript:void(0)',onClick:this.handleOnSetting,title:setting.title},_react2.default.createElement('img',{className:'img_setting',src:setting.img,border:'0',alt:''}))):'',close?_react2.default.createElement('li',{style:{width:'12px'}},_react2.default.createElement(_antd.Popconfirm,{placement:'leftTop',title:getLabel(19747,'此元素被删除后将不能被恢复，是否继续？'),onConfirm:this.handleDelete,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{href:'javascript:void(0);',title:close.title},_react2.default.createElement('img',{src:close.img,border:'0',alt:''})))):'',more?_react2.default.createElement('li',{style:{width:'34px'}},_react2.default.createElement('a',{id:'more_'+eid,href:'javascript:void(0);',onClick:_common.openMoreWin.bind(this,eid,ebaseid,more.morehref,moreRouteurl)},_react2.default.createElement('img',{className:'img_more',id:'imgMore',border:'0',src:more.img,title:more.title,alt:''}))):''));}}]);return OpToolbar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OpToolbar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OpToolbar);exports.default=OpToolbar;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _SynergySetting4Designer=__webpack_require__(102);var _SynergySetting4Designer2=_interopRequireDefault(_SynergySetting4Designer);var _SynergySetting4WfVersions=__webpack_require__(242);var _SynergySetting4WfVersions2=_interopRequireDefault(_SynergySetting4WfVersions);var _Content_1_DataSource=__webpack_require__(243);var _Content_1_DataSource2=_interopRequireDefault(_Content_1_DataSource);var _Content_7_DataSource=__webpack_require__(245);var _Content_7_DataSource2=_interopRequireDefault(_Content_7_DataSource);var _Content_8_DataSource=__webpack_require__(247);var _Content_8_DataSource2=_interopRequireDefault(_Content_8_DataSource);var _Content_29_DataSource=__webpack_require__(248);var _Content_29_DataSource2=_interopRequireDefault(_Content_29_DataSource);var _Content_reportForm_DataSource=__webpack_require__(249);var _Content_reportForm_DataSource2=_interopRequireDefault(_Content_reportForm_DataSource);var _Content_OutData_DataSource=__webpack_require__(280);var _Content_OutData_DataSource2=_interopRequireDefault(_Content_OutData_DataSource);var _Content_13_DataSource=__webpack_require__(281);var _Content_13_DataSource2=_interopRequireDefault(_Content_13_DataSource);var _Content_10_DataSource=__webpack_require__(282);var _Content_10_DataSource2=_interopRequireDefault(_Content_10_DataSource);var _Content_news_DataSource=__webpack_require__(283);var _Content_news_DataSource2=_interopRequireDefault(_Content_news_DataSource);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var DataSourceTable=function(_React$Component){(0,_inherits3.default)(DataSourceTable,_React$Component);function DataSourceTable(props){(0,_classCallCheck3.default)(this,DataSourceTable);var _this=(0,_possibleConstructorReturn3.default)(this,(DataSourceTable.__proto__||(0,_getPrototypeOf2.default)(DataSourceTable)).call(this,props));_this.state={tabNew:_this.props.tabNew,tabCount:_this.props.tabCount,tabIds:_this.props.tabIds,tabList:_this.props.tabList,dsVisible:false,tabData:{},selectedTabIds:[]};_this.onAddTab=_this.onAddTab.bind(_this);_this.onEditTab=_this.onEditTab.bind(_this);_this.onSortTab=_this.onSortTab.bind(_this);_this.onDeleteTab=_this.onDeleteTab.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.getSaveValues=_this.getSaveValues.bind(_this);return _this;}(0,_createClass3.default)(DataSourceTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,_props$synergyParams=_props.synergyParams,synergyParams=_props$synergyParams===undefined?{}:_props$synergyParams;var stype=synergyParams.stype;var _state=this.state,tabNew=_state.tabNew,tabData=_state.tabData,tabList=_state.tabList,dsVisible=_state.dsVisible,selectedTabIds=_state.selectedTabIds;var dataSourceComponent=_react2.default.createElement('div',null);if(dsVisible){var props={eid:eid,tabNew:tabNew,tabData:tabData,onOk:this.onOk,onCancel:this.onCancel};switch(this.props.ebaseid){// RSS阅读器
case'1':dataSourceComponent=_react2.default.createElement(_Content_1_DataSource2.default,props);break;// 文档中心
case'7':dataSourceComponent=_react2.default.createElement(_Content_7_DataSource2.default,props);break;// 流程中心
case'8':dataSourceComponent=_react2.default.createElement(_Content_8_DataSource2.default,props);break;//我的协作
case'13':dataSourceComponent=_react2.default.createElement(_Content_13_DataSource2.default,props);break;// 自定义页面
case'29':dataSourceComponent=_react2.default.createElement(_Content_29_DataSource2.default,props);break;// 图表
case'reportForm':dataSourceComponent=_react2.default.createElement(_Content_reportForm_DataSource2.default,(0,_extends3.default)({},props,{synergyParams:synergyParams}));break;// 外部数据元素
case'OutData':dataSourceComponent=_react2.default.createElement(_Content_OutData_DataSource2.default,props);break;// 我的项目元素
case'10':dataSourceComponent=_react2.default.createElement(_Content_10_DataSource2.default,props);break;// 公司新闻元素
case'news':dataSourceComponent=_react2.default.createElement(_Content_news_DataSource2.default,props);break;default:dataSourceComponent=_react2.default.createElement('div',null);}}// 记录选中的行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedTabIds:selectedRowKeys});}};var columns=[{key:'tabTitle',title:getLabel(24986,'标题'),dataIndex:'tabTitle',width:'50%'},{key:'operation',title:getLabel(30585,'操作'),width:'50%',render:function render(text,record){return _react2.default.createElement('span',null,_react2.default.createElement('span',{className:'portal-esetting-dst-button',onClick:function onClick(){return _this2.onEditTab(record.tabId);}},getLabel(30747,'设置')),_react2.default.createElement('span',{className:'portal-esetting-dst-button',onClick:function onClick(){return _this2.onAddTab('saveas',record.tabId);}},getLabel(350,'另存为')),hpid<0&&ebaseid=='8'&&(stype=='wf'||stype=='wf_form')?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4wv.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,tabid:record.tabId,isGlobal:false}));}},getLabel(17632,'参数设置')):'');}}];return _react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(20885,'内容来源'),needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',null,hpid<0&&(ebaseid=='8'||ebaseid=='7')?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4d.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,isGlobal:true}));}},getLabel(17632,'参数设置')):'',_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',onClick:function onClick(){return _this2.onAddTab('add');}},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedTabIds&&selectedTabIds.length),className:'portal-esetting-wsg-btn',onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},dataSourceComponent,_react2.default.createElement(_SynergySetting4Designer2.default,{ref:function ref(ss4d){return _this2.ss4d=ss4d;}}),_react2.default.createElement(_SynergySetting4WfVersions2.default,{ref:function ref(ss4wv){return _this2.ss4wv=ss4wv;}}),_react2.default.createElement(_ecCom.WeaTable,{rowSelection:rowSelection,columns:columns,dataSource:tabList,pagination:false,draggable:true,onDrop:this.onSortTab}));}},{key:'onAddTab',value:function onAddTab(type,tabId){if('saveas'==type){var tabData={};var tabList=this.state.tabList;for(var i=0;i<tabList.length;i++){if(tabList[i].tabId==tabId){tabData=(0,_lodash.cloneDeep)(tabList[i].data);break;}}tabData.id='';this.setState({tabData:tabData,dsVisible:true});}else{this.setState({tabData:{},dsVisible:true});}}},{key:'onDeleteTabs',value:function onDeleteTabs(){var selectedTabIds=this.state.selectedTabIds;for(var i=0,len=selectedTabIds.length;i<len;i++){this.onDeleteTab(selectedTabIds[i]);}this.setState({selectedTabIds:[]});}},{key:'onDeleteTab',value:function onDeleteTab(tabId){var tabList=this.state.tabList;for(var i=0,len=tabList.length;i<len;i++){if(tabList[i].tabId==tabId){tabList.splice(i,1);break;}}this.setState({tabList:tabList});}},{key:'onEditTab',value:function onEditTab(tabId){var tabData={};var tabList=this.state.tabList;for(var i=0,len=tabList.length;i<len;i++){if(tabList[i].tabId==tabId){tabData=tabList[i].data;break;}}this.setState({tabData:tabData,dsVisible:true});}},{key:'onOk',value:function onOk(values){var tabList=this.state.tabList;var tabCount=this.state.tabCount;var id=values.id;// 根据id是否存在判断是新增还是编辑
if(!!id){// 编辑保存
for(var i=0,len=tabList.length;i<len;i++){if(tabList[i].tabId==id){tabList[i].tabTitle=_ecCom.WeaInputLocale.getCurrentLabel(values.title);tabList[i].data=values;}}}else{// 新建保存
id=String(++tabCount);values.id=id;tabList.push({key:id,tabId:id,tabTitle:_ecCom.WeaInputLocale.getCurrentLabel(values.title),data:values});}this.setState({tabCount:tabCount,tabList:tabList,dsVisible:false});}},{key:'onCancel',value:function onCancel(){this.setState({dsVisible:false});}},{key:'onSortTab',value:function onSortTab(tabList){this.setState({tabList:tabList});}},{key:'getSaveValues',value:function getSaveValues(){return{tabIds:this.state.tabIds,tabList:this.state.tabList};}}]);return DataSourceTable;}(_react2.default.Component);exports.default=DataSourceTable;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(23);
var core = __webpack_require__(18);
var ctx = __webpack_require__(55);
var hide = __webpack_require__(39);
var has = __webpack_require__(33);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(258)();
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(400)();
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(29)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(60)('wks');
var uid = __webpack_require__(51);
var Symbol = __webpack_require__(23).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var IE8_DOM_DEFINE = __webpack_require__(70);
var toPrimitive = __webpack_require__(56);
var dP = Object.defineProperty;

exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(57);
var defined = __webpack_require__(44);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(154);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var createDesc = __webpack_require__(42);
module.exports = __webpack_require__(28) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(225);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(72);
var enumBugKeys = __webpack_require__(61);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(44);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(360);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);

    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MarqueeCom=function(_React$Component){(0,_inherits3.default)(MarqueeCom,_React$Component);function MarqueeCom(props){(0,_classCallCheck3.default)(this,MarqueeCom);var _this=(0,_possibleConstructorReturn3.default)(this,(MarqueeCom.__proto__||(0,_getPrototypeOf2.default)(MarqueeCom)).call(this,props));_this.autoMarquee=_this.autoMarquee.bind(_this);_this.isMarquee=_this.isMarquee.bind(_this);return _this;}(0,_createClass3.default)(MarqueeCom,[{key:'autoMarquee',value:function autoMarquee(eid,scolltype,height,scrollSpeed,ebaseid){var _this2=this;// this.addMarqueeAttrs(eid,scolltype,height);
$("#titleContainer_"+eid).css({'position':'relative','z-index':'1','background-color':'white'});var div=$("#content_"+eid+" .ant-spin-container")[1];var div2=$("#content_"+eid+" .ant-spin-container")[0];if(!div&&!div2){return;}if(!div){div=div2;}if(ebaseid&&ebaseid=='notice'){div=$("#content_"+eid+" .newnotice-add-Carousel")[0];}var offsetWidth=parseInt(div.offsetWidth);var offsetHeight=parseInt($("#tabcontant_"+eid)[0].offsetHeight);div.style.left=0;div.style.top=0;if(this.isMarquee(scolltype)){if(scolltype=='right'){div.style.left=-offsetWidth+"px";this.myInterval=setInterval(function(){var left=parseInt(div.style.left.split("px")[0]);if(left>=offsetWidth){div.style.left=-div.offsetWidth+"px";}else{var i=(div.style.left+"").split('px')[0];div.style.left=parseInt(i)+1+"px";}}.bind(this),scrollSpeed);}else if(scolltype=='left'){div.style.left=offsetWidth+"px";this.myInterval=setInterval(function(){var left=parseInt(div.style.left.split("px")[0]);if(left<=-offsetWidth){div.style.left=div.offsetWidth+"px";}else{var i=(div.style.left+"").split('px')[0];div.style.left=parseInt(i)-1+"px";}}.bind(this),scrollSpeed);}else if(scolltype=='up'){$('.homepage').find('#content_view_id_'+eid).css("overflow-y","hidden");div.style.top=offsetHeight+"px";this.myInterval=setInterval(function(){var top=parseInt(div.style.top.split("px")[0]);if(top<=-offsetHeight){div.style.top=div.offsetHeight+"px";}else{var i=(div.style.top+"").split('px')[0];div.style.top=parseInt(i)-1+"px";}}.bind(this),scrollSpeed);}else if(scolltype=='down'){$('.homepage').find('#content_view_id_'+eid).css("overflow-y","hidden");div.style.top=-offsetHeight+"px";this.myInterval=setInterval(function(){var top=parseInt(div.style.top.split("px")[0]);if(top>=offsetHeight){div.style.top=-div.offsetHeight+"px";}else{var i=(div.style.top+"").split('px')[0];div.style.top=parseInt(i)+1+"px";}}.bind(this),scrollSpeed);}}else{$('.homepage').find('#content_view_id_'+eid).css("overflow-y","auto");}div.onmouseover=function(){clearInterval(_this2.myInterval);};div.onmouseout=function(){var div=$("#content_"+eid+" .ant-spin-container")[1];if(ebaseid&&ebaseid=='notice'){div=$("#content_"+eid+" .newnotice-add-Carousel")[0];}if(scolltype=='right'){_this2.myInterval=setInterval(function(){var left=parseInt(div.style.left.split("px")[0]);if(left>=offsetWidth){div.style.left=-div.offsetWidth+"px";}else{var i=(div.style.left+"").split('px')[0];div.style.left=parseInt(i)+1+"px";}}.bind(_this2),scrollSpeed);}else if(scolltype=='left'){_this2.myInterval=setInterval(function(){var left=parseInt(div.style.left.split("px")[0]);if(left<=-offsetWidth){div.style.left=div.offsetWidth+"px";}else{var i=(div.style.left+"").split('px')[0];div.style.left=parseInt(i)-1+"px";}}.bind(_this2),scrollSpeed);}else if(scolltype=='up'){_this2.myInterval=setInterval(function(){var top=parseInt(div.style.top.split("px")[0]);if(top<=-offsetHeight){div.style.top=div.offsetHeight+"px";}else{var i=(div.style.top+"").split('px')[0];div.style.top=parseInt(i)-1+"px";}}.bind(_this2),scrollSpeed);}else if(scolltype=='down'){_this2.myInterval=setInterval(function(){var top=parseInt(div.style.top.split("px")[0]);if(top>=offsetHeight){div.style.top=-div.offsetHeight+"px";}else{var i=(div.style.top+"").split('px')[0];div.style.top=parseInt(i)+1+"px";}}.bind(_this2),scrollSpeed);}};}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,scolltype=_props.scolltype,height=_props.height,tabdata=_props.tabdata,_props$scrollSpeed=_props.scrollSpeed,scrollSpeed=_props$scrollSpeed===undefined?'20':_props$scrollSpeed,ebaseid=_props.ebaseid;if(tabdata&&tabdata.data&&tabdata.data.length==0){this.autoMarquee(eid,"none",height,scrollSpeed);}else{this.autoMarquee(eid,scolltype,height,scrollSpeed,ebaseid);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,eid=_props2.eid,scolltype=_props2.scolltype,height=_props2.height,tabdata=_props2.tabdata,_props2$scrollSpeed=_props2.scrollSpeed,scrollSpeed=_props2$scrollSpeed===undefined?'20':_props2$scrollSpeed,ebaseid=_props2.ebaseid;clearInterval(this.myInterval);if(tabdata&&tabdata.data&&tabdata.data.length==0){this.autoMarquee(eid,"none",height,scrollSpeed);}else{this.autoMarquee(eid,scolltype,height,scrollSpeed,ebaseid);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var scolltype=this.props.scolltype;if(this.isMarquee(scolltype)){clearInterval(this.myInterval);}}},{key:'isMarquee',value:function isMarquee(scolltype){var arr=['up','down','left','right'];return(0,_common.isContain)(arr,scolltype);}},{key:'addMarqueeAttrs',value:function addMarqueeAttrs(eid,scolltype,height){var attrs={direction:scolltype,onmouseover:'this.stop()',onmouseout:'this.start()',scrolldelay:'200'};if(scolltype==='up'||scolltype==='down'){attrs['width']='100%';attrs['height']=height;}$("#webjx_"+eid).attr(attrs);}},{key:'render',value:function render(){var _props3=this.props,eid=_props3.eid,children=_props3.children,scolltype=_props3.scolltype,height=_props3.height,ebaseid=_props3.ebaseid;if(this.isMarquee(scolltype)){//return <marquee id={`webjx_${eid}`}> { children } </marquee>
if(ebaseid&&ebaseid=='notice'){return _react2.default.createElement('div',{style:{position:'relative',display:'inline-block',width:'100%',overflow:'hidden'}},children);}return _react2.default.createElement('div',{style:{position:'relative',display:'inline-block',width:'100%'}},children);}else return _react2.default.createElement('div',null,children);}}]);return MarqueeCom;}(_react2.default.Component);exports.default=MarqueeCom;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(448),
    getValue = __webpack_require__(453);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(91);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(32);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(58);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(60)('keys');
var uid = __webpack_require__(51);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var global = __webpack_require__(23);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(50) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 62 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(173), __esModule: true };

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _weaPortalPublic=__webpack_require__(65);exports.default=_weaPortalPublic.WeaMaterialLib;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_65__;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tinycolor = __webpack_require__(378);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Color = function () {
  function Color(input) {
    var _this = this;

    _classCallCheck(this, Color);

    this.initRgb = function () {
      var _color$toRgb = _this.color.toRgb(),
          r = _color$toRgb.r,
          g = _color$toRgb.g,
          b = _color$toRgb.b;

      _this.redValue = r;
      _this.greenValue = g;
      _this.blueValue = b;
    };

    this.initHsb = function () {
      var _color$toHsv = _this.color.toHsv(),
          h = _color$toHsv.h,
          s = _color$toHsv.s,
          v = _color$toHsv.v;

      _this.hueValue = h;
      _this.saturationValue = s;
      _this.brightnessValue = v;
    };

    this.toHexString = function () {
      return _this.color.toHexString();
    };

    this.toRgbString = function () {
      return _this.color.toRgbString();
    };

    this.color = (0, _tinycolor2["default"])(input);

    this.initRgb();
    this.initHsb();

    var initAlpha = input && input.alpha || this.color.toRgb().a;
    this.alphaValue = Math.min(1, initAlpha) * 100;
  }

  Color.isValidHex = function isValidHex(hex) {
    return (0, _tinycolor2["default"])(hex).isValid();
  };

  _createClass(Color, [{
    key: 'hex',
    get: function get() {
      return this.color.toHex();
    }

    // 色调

  }, {
    key: 'hue',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: value,
        s: this.saturation,
        v: this.brightness
      });

      this.initRgb();
      this.hueValue = value;
    },
    get: function get() {
      return this.hueValue;
    }

    // 饱和度

  }, {
    key: 'saturation',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: this.hue,
        s: value,
        v: this.brightness
      });

      this.initRgb();
      this.saturationValue = value;
    },
    get: function get() {
      return this.saturationValue;
    }

    // 亮度

  }, {
    key: 'lightness',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: this.hue,
        s: this.saturation,
        l: value
      });

      this.initRgb();
      this.lightnessValue = value;
    },
    get: function get() {
      return this.lightnessValue;
    }
  }, {
    key: 'brightness',
    set: function set(value) {
      this.color = (0, _tinycolor2["default"])({
        h: this.hue,
        s: this.saturation,
        v: value
      });

      this.initRgb();
      this.brightnessValue = value;
    },
    get: function get() {
      return this.brightnessValue;
    }

    // red

  }, {
    key: 'red',
    set: function set(value) {
      var rgb = this.color.toRgb();
      this.color = (0, _tinycolor2["default"])(_extends({}, rgb, {
        r: value
      }));

      this.initHsb();
      this.redValue = value;
    },
    get: function get() {
      return this.redValue;
    }

    // green

  }, {
    key: 'green',
    set: function set(value) {
      var rgb = this.color.toRgb();
      this.color = (0, _tinycolor2["default"])(_extends({}, rgb, {
        g: value
      }));

      this.initHsb();
      this.greenValue = value;
    },
    get: function get() {
      return this.greenValue;
    }

    // blue

  }, {
    key: 'blue',
    set: function set(value) {
      var rgb = this.color.toRgb();
      this.color = (0, _tinycolor2["default"])(_extends({}, rgb, {
        b: value
      }));

      this.initHsb();
      this.blueValue = value;
    },
    get: function get() {
      return this.blueValue;
    }

    // alpha

  }, {
    key: 'alpha',
    set: function set(value) {
      this.color.setAlpha(value / 100);
    },
    get: function get() {
      return this.color.getAlpha() * 100;
    }
  }, {
    key: 'RGB',
    get: function get() {
      return [this.red, this.green, this.blue];
    }
  }, {
    key: 'HSB',
    get: function get() {
      return [this.hue, this.saturation, this.brightness];
    }
  }]);

  return Color;
}();

exports["default"] = Color;
module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(15);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.toArray = toArray;
exports.getActiveIndex = getActiveIndex;
exports.getActiveKey = getActiveKey;
exports.setTransform = setTransform;
exports.isTransform3dSupported = isTransform3dSupported;
exports.setTransition = setTransition;
exports.getTransformPropValue = getTransformPropValue;
exports.isVertical = isVertical;
exports.getTransformByIndex = getTransformByIndex;
exports.getMarginStyle = getMarginStyle;
exports.getStyle = getStyle;
exports.setPxStyle = setPxStyle;
exports.getDataAttr = getDataAttr;
exports.getLeft = getLeft;
exports.getTop = getTop;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  _react2['default'].Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransform3dSupported(style) {
  return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}

function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

function toNum(style, property) {
  return +style.getPropertyValue(property).replace('px', '');
}

function getTypeValue(start, current, end, tabNode, wrapperNode) {
  var total = getStyle(wrapperNode, 'padding-' + start);
  if (!tabNode || !tabNode.parentNode) {
    return total;
  }

  var childNodes = tabNode.parentNode.childNodes;

  Array.prototype.some.call(childNodes, function (node) {
    var style = window.getComputedStyle(node);

    if (node !== tabNode) {
      total += toNum(style, 'margin-' + start);
      total += node[current];
      total += toNum(style, 'margin-' + end);

      if (style.boxSizing === 'content-box') {
        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
      }
      return false;
    }

    // We need count current node margin
    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
    total += toNum(style, 'margin-' + start);

    return true;
  });

  return total;
}

function getLeft(tabNode, wrapperNode) {
  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}

function getTop(tabNode, wrapperNode) {
  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(63);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _PortalSetting=__webpack_require__(120);var _PortalSetting2=_interopRequireDefault(_PortalSetting);var _LayoutFlags=__webpack_require__(205);var _LayoutFlags2=_interopRequireDefault(_LayoutFlags);var _objectAssign=__webpack_require__(37);var _objectAssign2=_interopRequireDefault(_objectAssign);var _rcmenu=__webpack_require__(76);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ls=_ecCom.WeaTools.ls;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//引入元素组件
//门户组件
var Homepage=function(_React$Component){(0,_inherits3.default)(Homepage,_React$Component);function Homepage(props){(0,_classCallCheck3.default)(this,Homepage);var _this=(0,_possibleConstructorReturn3.default)(this,(Homepage.__proto__||(0,_getPrototypeOf2.default)(Homepage)).call(this,props));_this.state={hpdata:null,params:{},isShrink:false};_this.handleParams=_this.handleParams.bind(_this);_this.getPortalData=_this.getPortalData.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.handleAddElement=_this.handleAddElement.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.onChangeLabel=_this.onChangeLabel.bind(_this);window.portalGetElementStyle=_this.getPortalData.bind(_this);return _this;}(0,_createClass3.default)(Homepage,[{key:'handleParams',value:function handleParams(props){var query={};if(props.location)query=props.location.query;var params=(0,_objectAssign2.default)({},props.params,query);if(props.hpid){if(props.formData&&(0,_typeof3.default)(props.formData)==='object')props.formData=(0,_stringify2.default)(props.formData);params=(0,_objectAssign2.default)(params,props);if(!params.isSetting)params.isSetting=false;}else{params.isSetting=false;params.isfromportal=1;params.isfromhp=0;}window.element_custompage_loadIframe=params.loadIframe!='false';return params;}},{key:'getPortalData',value:function getPortalData(params){var _this2=this;window.isPortalRender=true;var hpid=params.hpid,isSetting=params.isSetting;var cacheData=ls.getJSONObj('portal-'+hpid+'-'+isSetting);this.setState({hpdata:cacheData,params:params});_ecCom.WeaTools.callApi('/api/portal/homepage/hpdata','POST',params).then(function(data){if(data.status==='failed'){_antd.message.error(data.errormsg);}else{if(_this2.state.params.hpid){if(_this2.state.params.hpid===hpid){ls.set('portal-'+hpid+'-'+isSetting,data);window.isPortalRender=false;_this2.setState({hpdata:data,params:params});}else{}}else{ls.set('portal-'+hpid+'-'+isSetting,data);window.isPortalRender=false;_this2.setState({hpdata:data,params:params});}}});}},{key:'handleRefresh',value:function handleRefresh(nParams){var params=this.handleParams(this.props);this.getPortalData((0,_extends3.default)({},params,nParams));}},{key:'handleAddElement',value:function handleAddElement(element,areaflag,index){var _state$params=this.state.params,hpid=_state$params.hpid,isSetting=_state$params.isSetting;//获取当前设置门户信息
var hpdata=(0,_extends3.default)({},this.state.hpdata);var layoutFlags=hpdata.hpinfo.layoutFlags;for(var i=0;i<layoutFlags.length;i++){var layoutFlag=layoutFlags[i];if(layoutFlag.areaflag===areaflag){var areaElements=layoutFlag.areaElements;areaElements.splice(index,0,element.config);break;}}hpdata.hpCss+=element.eCss;ls.set('portal-'+hpid+'-'+isSetting,hpdata);this.setState({hpdata:hpdata});}},{key:'getHpRefreshData',value:function getHpRefreshData(params){var _this3=this;clearInterval(this.portalRefreshInterval);_ecCom.WeaTools.callApi('/api/portal/portalSetting/getHpRefreshData','GET').then(function(result){var _result$data=result.data,data=_result$data===undefined?{}:_result$data;var needRefresh=data.needRefresh,_data$refreshMins=data.refreshMins,refreshMins=_data$refreshMins===undefined?999:_data$refreshMins;if(needRefresh){_this3.portalRefreshInterval=setInterval(function(){return _this3.getPortalData(params);},refreshMins*60*1000);}});}},{key:'componentWillMount',value:function componentWillMount(){var params=this.handleParams(this.props);this.getPortalData(params);this.getHpRefreshData(params);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.portalRefreshInterval);}},{key:'componentDidMount',value:function componentDidMount(){var _this4=this;var params=this.handleParams(this.props);if(this.refs.btnWfCenterReload)this.refs.btnWfCenterReload.setAttribute("onclick","element_workflow_reLoad()");if(this.refs.homepageContainer)$(this.refs.homepageContainer).css("min-height",$(".homepage[data-isSetting="+params.isSetting+"]").height());$(window).resize(function(){//当浏览器大小变化时
if(_this4.refs.homepageContainer)$(_this4.refs.homepageContainer).css("min-height",$(".homepage[data-isSetting="+params.isSetting+"]").height());});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return window.isPortalRender||!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var params=this.handleParams(this.props);var nParams=this.handleParams(nextProps);if(window.isPortalRender||!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(params,nParams)){this.getPortalData(nParams);this.getHpRefreshData(nParams);}}},{key:'render',value:function render(){var _props=this.props,isSynergySetting=_props.isSynergySetting,synergyParams=_props.synergyParams,location=_props.location;var _state=this.state,params=_state.params,hpdata=_state.hpdata;if(params.hpid){var style={};var hpHtml=_react2.default.createElement('div',null);var styleStr="";var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;var layoutid='';if(hpdata){if(hpdata.hasRight){layoutid=hpdata.hpinfo.bLayoutid;style={background:hpdata.hpinfo.bgcolor};var queryParams={};if(location)queryParams=location.query;var layoutObj={config:{isRender:window.isPortalRender,isremembertab:hpdata.hpinfo.isremembertab,isSetting:hpdata.hpinfo.isSetting,isSynergySetting:isSynergySetting,synergyParams:(0,_objectAssign2.default)({},synergyParams,queryParams)},layoutFlags:hpdata.hpinfo.layoutFlags,layoutid:hpdata.hpinfo.bLayoutid,layoutHtml:hpdata.hpinfo.html};styleStr=hpdata.hpCss.replace(/\"/g,"");hpHtml=_react2.default.createElement(_LayoutFlags2.default,layoutObj);}else{hpHtml=_react2.default.createElement(NoRightPage,{msg:hpdata.msg});}}if(jQuery('#portal-style')&&jQuery('#portal-style').length){jQuery('#portal-style').html(styleStr);}else{jQuery(jQuery('head')[0]).append('<style id="portal-style" type="text/css">'+styleStr+'</style>');}var classname='homepage';if(isSetting){classname='homepage homepage-setting';}return _react2.default.createElement('div',{className:classname,'data-hpid':hpid,'data-subcompanyid':subCompanyId,'data-issetting':isSetting,'data-layoutid':layoutid,style:style},!isSetting?_react2.default.createElement(_PortalSetting2.default,{ref:'portalsetting'}):'',_react2.default.createElement('div',{style:{margin:'-10px -10px 0 0'}},_react2.default.createElement('input',{type:'hidden',ref:'btnWfCenterReload',value:'btnWfCenterReload',id:'btnWfCenterReload',name:'btnWfCenterReload'}),isSetting?hpHtml:_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{ref:'homepageContainer',style:{height:'100%'}},hpHtml))));}else{return _react2.default.createElement('div',{className:'homepage'});}}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];var hpdata=this.state.hpdata;if(hpdata){hpdata.rcmenu.map(function(menu){btns.push({key:menu.key,icon:_react2.default.createElement('i',{className:menu.icon}),content:menu.label});});}return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var _this5=this;var _state2=this.state,params=_state2.params,hpdata=_state2.hpdata;var _params=(0,_extends3.default)({},params);_params.isSetting=true;_params.viewtype='edit';_params.from='addElement';_params.isfromportal=undefined;_params.title=hpdata.hpinfo.hpname;switch(key){case'resethp':case'updatesynihp':case'completesynihp':(0,_rcmenu.handlePortalSynize)({hpid:_params.hpid,subCompanyId:_params.subCompanyId,method:key},function(){return _this5.getPortalData(params);});break;case'shrinkAll':this.setState({isShrink:!this.state.isShrink});this.onChangeLabel(this.state.hpdata.rcmenu,'shrinkAll',this.state.isShrink);(0,_rcmenu.onShowOrHideAllE)(params.isSetting);break;case'settingElement':window.handlePortalSetting(_params);break;case'store':(0,_rcmenu.openFavouriteBrowser)();break;case'help':(0,_rcmenu.showHelp)();break;case'5':break;}}},{key:'onChangeLabel',value:function onChangeLabel(rcmenu,key,bool){var lable1=getLabel(18466,'全部收缩');var lable2=getLabel(16216,'全部展开');rcmenu.map(function(item){if(item.key==key){if(bool){item.label=lable1;}else{item.label=lable2;}}});}}]);return Homepage;}(_react2.default.Component);//无权限门户
var NoRightPage=function NoRightPage(_ref){var msg=_ref.msg;return _react2.default.createElement('div',{className:'page-noright'},_react2.default.createElement('img',{src:'/images/ecology8/noright_wev8.png',width:'162px',height:'162px'}),_react2.default.createElement('div',{style:{color:'rgb(255,187,14)'}},msg));};var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Homepage=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Homepage);exports.default=Homepage;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(28) && !__webpack_require__(29)(function () {
  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);
var document = __webpack_require__(23).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(33);
var toIObject = __webpack_require__(36);
var arrayIndexOf = __webpack_require__(93)(false);
var IE_PROTO = __webpack_require__(59)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(49);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(176)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(113)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;function handlePortalSynize(params,callback){var hpid=params.hpid,subCompanyId=params.subCompanyId,method=params.method;var content='';if(method=='resethp'){content=getLabel(388036,"确定重置首页吗？");}else if(method=='updatesynihp'){content=getLabel(388037,"确定同步首页吗？");}else if(method=='completesynihp'){content=getLabel(127000,"同步后，用户在此门户中的个性化设置会丢失。确定要同步吗？");}_antd.Modal.confirm({title:getLabel(386786,"信息确认"),content:content,onOk:function onOk(){_ecCom.WeaTools.callApi('/api/portal/portalrcmenu/'+(method=='resethp'?'updatesynihp':method),'POST',{hpid:hpid,subCompanyId:subCompanyId}).then(function(data){if(data.status==='2'){_antd.message.error(getLabel(83322,"处理失败！"));}else{_antd.message.success(getLabel(83323,"处理成功！"));if(callback&&typeof callback=='function')callback();}});}});}function onShowOrHideAllE(isSetting){$(".homepage[data-issetting="+isSetting+"]").find(".content").toggle();}function openFavouriteBrowser(){var BacoTitle=jQuery("#BacoTitle");var pagename="";var navName="";var fav_uri="%2Fhomepage%2FHomepage.jsp";var fav_querystring="isfromportal%3D1%5Ee71494489609747%3D%5Ehpid%3D26%5EsubCompanyId%3D34%5Eisfromhp%3D0";try{var e8tabcontainer=jQuery("div[_e8tabcontainer='true']",parent.document);if(e8tabcontainer.length>0){fav_uri=escape(parent.window.location.pathname);fav_querystring=escape(parent.window.location.search);navName=e8tabcontainer.find("#objName").text();}else{navName=jQuery("#objName").text();}}catch(e){}if(BacoTitle){pagename=BacoTitle.text();}if(!pagename){pagename=navName;}pagename=escape(pagename);//window.showModalDialog('/systeminfo/BrowserMain.jsp?url=/favourite/FavouriteBrowser.jsp&fav_pagename='+pagename+'&fav_uri='+fav_uri+'&fav_querystring='+fav_querystring+'&mouldID=doc');
var e8tabcontainer2=jQuery("div[_e8tabcontainer='true']",parent.document);var dialogurl="";if(e8tabcontainer2.length>0){dialogurl='/systeminfo/BrowserMain.jsp?url=/favourite/FavouriteBrowser.jsp&fav_pagename='+pagename+'&fav_uri='+fav_uri+'&fav_querystring='+fav_querystring+'&mouldID=doc';}else{dialogurl='/systeminfo/BrowserMain.jsp?url=/favourite/FavouriteBrowser.jsp&fav_uri='+fav_uri+'&mouldID=doc';//fav_pagename和fav_querystring不通过url传值，而通过session获取，避免url过长时，导致问题
}var dialog=new window.Dialog();dialog.currentWindow=window;dialog.URL=dialogurl;dialog.Title=getLabel(2081,"收藏夹");dialog.Width=550;dialog.Height=600;dialog.Drag=true;dialog.show();}function showHelp(){var pathKey="%2Fhomepage%2FHomepage.jsp%3Fhpid%3D1%26subCompanyId%3D1%26isfromportal%3D1%26isfromhp%3D0%26e71494487903719%3D";var operationPage="https://help.e-cology.com.cn/help/RemoteHelp.jsp";var screenWidth=window.screen.width*1;var screenHeight=window.screen.height*1;var isEnableExtranetHelp=1;if(isEnableExtranetHelp==1){//operationPage = "http://e-cology.com.cn/formmode/apps/ktree/ktreeHelp.jsp";
operationPage='https://www.e-cology.com.cn/formmode/apps/ktree/ktreeHelp.jsp';}window.open(operationPage+"?pathKey="+pathKey,"_blank","top=0,left="+(screenWidth-800)/2+",height="+(screenHeight-90)+",width=1000,status=no,scrollbars=yes,toolbar=yes,menubar=no,location=no");}module.exports={handlePortalSynize:handlePortalSynize,onShowOrHideAllE:onShowOrHideAllE,openFavouriteBrowser:openFavouriteBrowser,showHelp:showHelp,dragBaseElement:dragBaseElement/**-----------左边栏baseelement拖动特效------------**/};function dragBaseElement(ebaseid,callback){return;var hoveritem=void 0;var itemholder=$("#itemholder");var itemholderClass=$(".itemholderClass");var index=0;$(".portal-setting-left-hpbaseelement-item div a").draggable({helper:"clone",start:function start(event,ui){var helper=ui.helper;helper.addClass("dragitemholder");},drag:function drag(event,ui){if(hoveritem!==undefined){var items=hoveritem.find(".item");var itemtemp;var offset=ui.offset;var itemoffset;var itemheight;var flag=true;for(var i=0,len=items.length;i<len;i++){itemtemp=$(items[i]);itemoffset=itemtemp.offset();itemheight=itemtemp.height();if(offset.top>itemoffset.top&&offset.top<itemoffset.top+itemheight){if(itemtemp.prev()===itemholder){return;}itemholder.insertBefore(itemtemp);itemholder.show();index=i;return;}if(i===len-1)flag=false;}if(!flag||items.length===0){hoveritem.find(".group").append(itemholder);itemholder.show();}}}});//将td注册drop事件
$(".group").parent().droppable({over:function over(event,ui){hoveritem=$(event.target);},drop:function drop(event,ui){var areaflag=hoveritem.find(".group").attr("data-areaflag");if(ebaseid==null){return;}callback(ebaseid,areaflag,index);//鼠标移除则隐藏占位框
},out:function out(event,ui){// itemholderClass.hide();
$(".dragitemholder").hide();}});}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 新闻模板
var ENewsMould=function(_React$Component){(0,_inherits3.default)(ENewsMould,_React$Component);function ENewsMould(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ENewsMould);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ENewsMould.__proto__||(0,_getPrototypeOf2.default)(ENewsMould)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ENewsMould,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(23088,'新闻模板'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.value,style:{width:'100px'},onChange:function onChange(value){_this2.setState({value:value});}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return ENewsMould;}(_react2.default.Component);exports.default=ENewsMould;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(8);var _extends4=_interopRequireDefault(_extends3);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 提醒方式
var ERemindMode=function(_React$Component){(0,_inherits3.default)(ERemindMode,_React$Component);function ERemindMode(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ERemindMode);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ERemindMode.__proto__||(0,_getPrototypeOf2.default)(ERemindMode)).call.apply(_ref,[this].concat(args))),_this),_this.state={eRemindMode:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ERemindMode,[{key:'render',value:function render(){var _this2=this;var eRemindMode=this.state.eRemindMode;var eRemindModeList=[];var _loop=function _loop(key){if(eRemindMode.hasOwnProperty(key)){eRemindModeList.push(_react2.default.createElement('li',{style:{display:'inline-block'}},_react2.default.createElement(_antd.Checkbox,{checked:eRemindMode[key].checked,onChange:function onChange(e){return _this2.setState({eRemindMode:(0,_extends4.default)({},eRemindMode,(0,_defineProperty3.default)({},key,(0,_extends4.default)({},eRemindMode[key],{checked:e.target.checked})))});}},eRemindMode[key].label),key=='color'?_react2.default.createElement('div',{style:{display:'inline-block',width:'100px'}},_react2.default.createElement(_ecCom.WeaColorPicker,{value:eRemindMode[key].color,onChange:function onChange(value){return _this2.setState({eRemindMode:(0,_extends4.default)({},eRemindMode,{'color':(0,_extends4.default)({},eRemindMode['color'],{color:value})})});}})):''));}};for(var key in eRemindMode){_loop(key);}return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(18713,'提醒方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{ref:'eRemindMode'},eRemindModeList));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.eRemindMode;}}]);return ERemindMode;}(_react2.default.Component);exports.default=ERemindMode;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(346)();
}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = addEventListenerWrap;

var _addDomEventListener = __webpack_require__(135);

var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
    _reactDom2['default'].unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener2['default'])(target, eventType, callback);
}
module.exports = exports['default'];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(438),
    listCacheDelete = __webpack_require__(439),
    listCacheGet = __webpack_require__(440),
    listCacheHas = __webpack_require__(441),
    listCacheSet = __webpack_require__(442);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(152);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(109),
    getRawTag = __webpack_require__(449),
    objectToString = __webpack_require__(450);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(54);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(462);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(89), __esModule: true };

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90);
module.exports = __webpack_require__(18).Object.assign;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(25);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(92) });


/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(43);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(52);
var toObject = __webpack_require__(45);
var IObject = __webpack_require__(57);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(29)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(36);
var toLength = __webpack_require__(73);
var toAbsoluteIndex = __webpack_require__(94);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(35);
var dPs = __webpack_require__(178);
var enumBugKeys = __webpack_require__(61);
var IE_PROTO = __webpack_require__(59)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(71)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(179).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(31).f;
var has = __webpack_require__(33);
var TAG = __webpack_require__(30)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180);
var global = __webpack_require__(23);
var hide = __webpack_require__(39);
var Iterators = __webpack_require__(53);
var TO_STRING_TAG = __webpack_require__(30)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(30);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(23);
var core = __webpack_require__(18);
var LIBRARY = __webpack_require__(50);
var wksExt = __webpack_require__(98);
var defineProperty = __webpack_require__(31).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(207);__webpack_require__(112);__webpack_require__(212);var _components=__webpack_require__(216);var _components2=_interopRequireDefault(_components);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}window.elements_more_params={};module.exports={Element:_components2.default};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//元素类型统一管理
var ELEMENT_TYPES={/** ---------- 可变tab元素 ---------- **/RSS:'1',// RSS元素
NEWS:'7',// 文档元素
WORKFLOW:'8',// 流程元素
CUSTOMPAGE:'29',// 自定义页面元素
REPORTFORM:'reportForm',// 图表元素
OUTDATA:'OutData',// 外部数据元素
FORMMODECUSTOMSEARCH:'FormModeCustomSearch',// 建模查询中心元素
/** ---------- 不可变tab元素 ---------- **/MAIL:'16',// 我的邮件
ADDWF:'addwf',// 新建流程
TASK:'Task',// 任务元素
BLOGSTATUS:'blogStatus',// 微博元素
CONTACTS:'contacts',// 通讯录
/** ---------- 以view.jsp页面显示的元素 ---------- **/UNREAD_DOCS:'6',// 未读文档
MESSAGE_REMINDING:'9',// 消息提醒 
MY_PROJECTS:'10',// 我的项目 
NEW_CUSTOMERS:'11',// 最新客户 
NEW_MEETING:'12',// 最新会议 
UNREAD_COOPERATION:'13',// 未读协作  
MONTH_TARGET:'14',// 当月目标 
DAY_PLAN:'15',// 当日计划
SUBSCRIBE_KONWLEDG:'34',// 知识订阅
/** ---------- 元素 ---------- **/MORE_NEWS:'17',// 多新闻中心
MAGAZINE:'18',// 期刊元素
STOCK:'19',// 股票元素
DOC_CONTENT:'25',// 文档内容
AUDIO:'audio',// 音频元素 
FAVOURITE:'favourite',// 收藏元素
FLASH:'Flash',// Flash元素
PICTURE:'picture',// 图片元素
MYCALENDAR:'MyCalendar',// 日历日程
MEETINGCALENDAR:'MeetingCalendar',// 会议日历
IMGSLIDE:'imgSlide',// 多图元素
NEWNOTICE:'newNotice',// 最新通告  
OUTTERSYS:'outterSys',// 集成登录
SCRATCHPAD:'scratchpad',// 便签元素
WEATHER:'weather',// 天气元素
VIDEO:'video',// 视频元素 
SLIDE:'Slide',// 幻灯片元素 
DATACENTER:'DataCenter',// 个人中心
JOBSINFO:'jobsinfo',// 多岗位办理事项
SEARCHENGINE:'searchengine',// 搜索元素
NOTICE:'notice',// 通告栏元素
PLAN:'plan',// 计划元素
CUSTOMMENU:'menu',// 自定义菜单
WORKTASK:'32',// 任务计划
LOGIN:'login',// 登录系统
LOGIN_NEWS:'news',// 公司新闻
CALENDARELE:'CalendarEle',// 日历元素
BOOKSHELF:'bookshelf',// 书柜元素
NEWMOBILEPICTURE:'newMobilePicture',// 移动门户图片
FNABUDGETASSISTANT:'fnaBudgetAssistant',// 费用报销智能助手
FNABUDGETASSISTANT1:'fnaBudgetAssistant1',// 审批助手元素
COREMAIL:'CoreMail',// CoreMail邮箱
MYTASK:'processTask',// 我的任务元素      
ELEMENTTABLE:'elementTable',// 通用列表组件           
CUSTOMELEMENT:'customElement',// 自定义元素
// DY_DOCUMENTCENTER: 'DY_documentCenter',         // 自定义元素
NEW_DY:'7_DY'// 自定义元素
};module.exports={ELEMENT_TYPES:ELEMENT_TYPES};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _slicedToArray2=__webpack_require__(232);var _slicedToArray3=_interopRequireDefault(_slicedToArray2);var _stringify=__webpack_require__(63);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _util=__webpack_require__(239);__webpack_require__(240);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SynergySetting4Designer=function(_React$Component){(0,_inherits3.default)(SynergySetting4Designer,_React$Component);function SynergySetting4Designer(props){(0,_classCallCheck3.default)(this,SynergySetting4Designer);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergySetting4Designer.__proto__||(0,_getPrototypeOf2.default)(SynergySetting4Designer)).call(this,props));_this.state={visible:false,loading:false,settingParams:{},paramObj:{},compareTypeObj:{},valueTypeObj:{},paramValueOptions:[],paramValueObj:{},expsObj:{},selectedExps:[],selectedExpsPKey:''};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onParamObjChange=_this.onParamObjChange.bind(_this);_this.onCompareTypeObjChange=_this.onCompareTypeObjChange.bind(_this);_this.onValueTypeObjChange=_this.onValueTypeObjChange.bind(_this);_this.onParamValueObjChange=_this.onParamValueObjChange.bind(_this);_this.onParamValueObj4DateChange=_this.onParamValueObj4DateChange.bind(_this);_this.getExpsComp=_this.getExpsComp.bind(_this);_this.onExpClick=_this.onExpClick.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.onDel=_this.onDel.bind(_this);_this.onAnd=_this.onAnd.bind(_this);_this.onOr=_this.onOr.bind(_this);_this.onSplit=_this.onSplit.bind(_this);return _this;}(0,_createClass3.default)(SynergySetting4Designer,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,loading=_state.loading,settingParams=_state.settingParams,paramObj=_state.paramObj,compareTypeObj=_state.compareTypeObj,valueTypeObj=_state.valueTypeObj,paramValueOptions=_state.paramValueOptions,paramValueObj=_state.paramValueObj,expsObj=_state.expsObj,selectedExps=_state.selectedExps;var hpid=settingParams.hpid,ebaseid=settingParams.ebaseid,wfid=settingParams.wfid;var _paramObj$paramData=paramObj.paramData,paramData=_paramObj$paramData===undefined?{id:'0',name:'请选择参数'}:_paramObj$paramData,htmlType=paramObj.htmlType,fieldType=paramObj.fieldType,isMulti=paramObj.isMulti;var compareTypeOptions=compareTypeObj.compareTypeOptions,compareType=compareTypeObj.compareType;var valueTypeOptions=valueTypeObj.valueTypeOptions,valueType=valueTypeObj.valueType;var paramValue=paramValueObj.paramValue,_paramValueObj$paramV=paramValueObj.paramValueData,paramValueData=_paramValueObj$paramV===undefined?{id:'0',name:''}:_paramValueObj$paramV;var paramComp=_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,"请选择"),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',type:'synergyParams',modalStyle:{width:500},isSingle:true,dataParams:{type:'param',ebaseid:ebaseid,wfid:wfid},replaceDatas:[paramData],onChange:this.onParamObjChange});var compareTypeComp=_react2.default.createElement('div',null);var valueTypeComp=_react2.default.createElement('div',null);var paramValueComp=_react2.default.createElement('div',null);if(paramData.id&&paramData.id!='0'){compareTypeComp=_react2.default.createElement(_ecCom.WeaSelect,{options:compareTypeOptions,value:compareType,onChange:function onChange(key){return _this2.onCompareTypeObjChange(key,(0,_util.getSelectedName)(compareTypeOptions,key));}});valueTypeComp=_react2.default.createElement(_ecCom.WeaSelect,{options:valueTypeOptions,value:valueType,onChange:function onChange(key){return _this2.onValueTypeObjChange(key,(0,_util.getSelectedName)(valueTypeOptions,key));}});if(htmlType=='1'||htmlType=='2'){// 单行文本框、多行文本框
paramValueComp=_react2.default.createElement(_ecCom.WeaInput,{value:paramValue,onChange:function onChange(value){return _this2.onParamValueObjChange(value,value);}});}else if(htmlType=='3'){// 浏览框
if(valueType=='2'){// 固定值
if(fieldType=='2'){// 日期类型
paramValueComp=_react2.default.createElement(_ecCom.WeaDateGroup,{isMobx:true,datas:_util.DATE_TYPES,value:paramValue.split(','),onChange:this.onParamValueObj4DateChange});}else{paramValueComp=_react2.default.createElement(_ecCom.WeaBrowser,{type:fieldType,isSingle:!isMulti,replaceDatas:isMulti?[]:[paramValueData],onChange:this.onParamValueObjChange});}}else if(valueType=='3'){// 系统变量
paramValueComp=_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,"请选择"),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',type:'synergyParams',modalStyle:{width:500},isSingle:true,dataParams:{type:'paramvalue',ebaseid:'sysparam',htmlType:htmlType,fieldType:fieldType},replaceDatas:[paramValueData],onChange:this.onParamValueObjChange});}}else if(htmlType=='5'){// 单选框
paramValueComp=_react2.default.createElement(_ecCom.WeaSelect,{options:paramValueOptions,value:paramValue,style:{width:'100px'},onChange:function onChange(key){return _this2.onParamValueObjChange(key,(0,_util.getSelectedName)(paramValueOptions,key));}});}if(valueType=='6'){// 表单变量
paramValueComp=_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,"请选择"),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',type:'synergyParams',modalStyle:{width:500},isSingle:true,dataParams:{type:'paramvalue',ebaseid:ebaseid,hpid:hpid,htmlType:htmlType,fieldType:fieldType},replaceDatas:[paramValueData],onChange:this.onParamValueObjChange});}}return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:loading,title:'\u5143\u7D20\u53C2\u6570\u8BBE\u7F6E',icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',style:{width:800,height:400},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement('div',{className:'synergy-setting-designer'},_react2.default.createElement('div',{className:'synergy-setting-select'},_react2.default.createElement(_antd.Row,{gutter:8},_react2.default.createElement(_antd.Col,{span:6},paramComp),_react2.default.createElement(_antd.Col,{span:4},compareTypeComp),_react2.default.createElement(_antd.Col,{span:4},valueTypeComp),_react2.default.createElement(_antd.Col,{span:10},paramValueComp))),_react2.default.createElement('div',{className:'synergy-setting-op'},_react2.default.createElement('div',{className:'synergy-setting-op-add',title:'\u6DFB\u52A0',onClick:this.onAdd}),_react2.default.createElement('div',{className:'synergy-setting-op-del',title:'\u5220\u9664',onClick:this.onDel}),_react2.default.createElement('div',{className:'synergy-setting-op-and',title:'\u6DFB\u52A0\u4E0E\u5173\u7CFB',onClick:this.onAnd}),_react2.default.createElement('div',{className:'synergy-setting-op-or',title:'\u6DFB\u52A0\u6216\u5173\u7CFB',onClick:this.onOr}),_react2.default.createElement('div',{className:'synergy-setting-op-split',title:'\u62C6\u5206\u5173\u7CFB',onClick:this.onSplit})),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement('div',{className:'synergy-setting-preview'},this.getExpsComp(expsObj,selectedExps)))));}},{key:'onShow',value:function onShow(params){var _this3=this;this.setState({visible:true,loading:true,settingParams:params});_ecCom.WeaTools.callApi('/api/portal/synergy/getParams','GET',params).then(function(data){_this3.setState({loading:false,expsObj:data.expsObj});});}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _state2=this.state,settingParams=_state2.settingParams,expsObj=_state2.expsObj;_ecCom.WeaTools.callApi('/api/portal/synergy/setParams','POST',(0,_extends3.default)({},settingParams,{expsStr:(0,_stringify2.default)(expsObj)})).then(function(data){});this.onCancel();}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,settingParams:{},paramObj:{},compareTypeObj:{},valueTypeObj:{},paramValueOptions:[],paramValueObj:{},expsObj:{},selectedExps:[],selectedExpsPKey:''});}},{key:'onParamObjChange',value:function onParamObjChange(ids,names,datas){var _this4=this;var settingParams=this.state.settingParams;var stype=settingParams.stype,pagetype=settingParams.pagetype,ispagedeal=settingParams.ispagedeal;var _ref=datas[0]||{},id=_ref.id,fromtype=_ref.fromtype,formid=_ref.formid,isbill=_ref.isbill,htmltype=_ref.htmltype,fieldtype=_ref.fieldtype;if(fieldtype=='17'){fieldtype='1';}var isMulti=(0,_util.isMultiBrowserType)(fieldtype);// 判断当前字段是否是多选类型
this.setState({paramObj:{paramData:datas[0]||{},fromType:fromtype,formId:formid,isBill:isbill,paramId:ids,paramName:names,htmlType:htmltype,fieldType:fieldtype,isMulti:isMulti}});var compareTypeOptions4={key:'4',selected:false,showname:'等于'};var compareTypeOptions5={key:'5',selected:false,showname:'不等于'};var compareTypeOptions6={key:'6',selected:false,showname:'包含'};var compareTypeOptions7={key:'7',selected:false,showname:'不包含'};var compareTypeOptions8={key:'8',selected:false,showname:'属于'};var compareTypeOptions9={key:'9',selected:false,showname:'不属于'};var valueTypeOption0={key:'0',selected:false,showname:'输入值'};var valueTypeOption2={key:'2',selected:false,showname:'固定值'};var valueTypeOption3={key:'3',selected:false,showname:'系统变量'};var valueTypeOption4={key:'4',selected:false,showname:'下拉选择'};var valueTypeOption6={key:'6',selected:false,showname:'表单变量'};// 流程查看处理页和流程表单才有表单变量
var isNeedFormVar=stype=='wf'&&pagetype=='operat'&&ispagedeal=='1'||stype=='wf_form';if(htmltype=='1'||htmltype=='2'){// 单行文本框、多行文本框
var compareTypeOptions=[compareTypeOptions4,compareTypeOptions5,compareTypeOptions6,compareTypeOptions7];var valueTypeOptions=[valueTypeOption0];if(isNeedFormVar){valueTypeOptions.push(valueTypeOption6);}this.setState({compareTypeObj:{compareTypeOptions:compareTypeOptions,compareType:compareTypeOptions[0].key,compareName:compareTypeOptions[0].showname},valueTypeObj:{valueTypeOptions:valueTypeOptions,valueType:valueTypeOptions[0].key,valueTypeName:valueTypeOptions[0].showname},paramValueOptions:[],paramValueObj:{paramValue:'',paramValueName:''}});}else if(htmltype=='3'){// 浏览框
var _compareTypeOptions=isMulti?[compareTypeOptions6,compareTypeOptions7]:[compareTypeOptions8,compareTypeOptions9];var _valueTypeOptions=[valueTypeOption2,valueTypeOption3];if(isNeedFormVar){_valueTypeOptions.push(valueTypeOption6);}this.setState({compareTypeObj:{compareTypeOptions:_compareTypeOptions,compareType:_compareTypeOptions[0].key,compareName:_compareTypeOptions[0].showname},valueTypeObj:{valueTypeOptions:_valueTypeOptions,valueType:_valueTypeOptions[0].key,valueTypeName:_valueTypeOptions[0].showname},paramValueOptions:[],paramValueObj:{paramValue:fieldtype=='2'?'0':'',// fieldtype == '2' 为日期类型
paramValueName:fieldtype=='2'?(0,_util.getDateTypeName)('0'):''}});}else if(htmltype=='5'){// 单选框
var _compareTypeOptions2=[compareTypeOptions4,compareTypeOptions5];var _valueTypeOptions2=[valueTypeOption4];if(isNeedFormVar){_valueTypeOptions2.push(valueTypeOption6);}_ecCom.WeaTools.callApi('/api/portal/synergy/getWfSelectItems','GET',{fieldtype:fieldtype,fieldid:id}).then(function(data){var selectItems=data.data||[];var paramValueOptions=[];for(var i=0,len=selectItems.length;i<len;i++){paramValueOptions.push({key:selectItems[i].value,selected:false,showname:selectItems[i].name});}_this4.setState({compareTypeObj:{compareTypeOptions:_compareTypeOptions2,compareType:_compareTypeOptions2[0].key,compareName:_compareTypeOptions2[0].showname},valueTypeObj:{valueTypeOptions:_valueTypeOptions2,valueType:_valueTypeOptions2[0].key,valueTypeName:_valueTypeOptions2[0].showname},paramValueOptions:paramValueOptions,paramValueObj:{paramValue:paramValueOptions.length?paramValueOptions[0].key:'',paramValueName:paramValueOptions.length?paramValueOptions[0].showname:''}});});}}},{key:'onCompareTypeObjChange',value:function onCompareTypeObjChange(type,name){var compareTypeObj=this.state.compareTypeObj;this.setState({compareTypeObj:(0,_extends3.default)({},compareTypeObj,{compareType:type,compareName:name})});}},{key:'onValueTypeObjChange',value:function onValueTypeObjChange(type,name){var _state3=this.state,paramObj=_state3.paramObj,valueTypeObj=_state3.valueTypeObj,paramValueOptions=_state3.paramValueOptions;var htmlType=paramObj.htmlType,fieldType=paramObj.fieldType;var paramValueObj={};if(htmlType=='3'){// 浏览框
if(type=='2'&&fieldType=='2'){// 固定值，并且为日期类型
paramValueObj={paramValue:'0',paramValueName:(0,_util.getDateTypeName)('0')};}}else if(htmlType=='5'){// 单选框
if(type=='4'){// 下拉选择
paramValueObj={paramValue:paramValueOptions.length?paramValueOptions[0].key:'',paramValueName:paramValueOptions.length?paramValueOptions[0].showname:''};}}this.setState({valueTypeObj:(0,_extends3.default)({},valueTypeObj,{valueType:type,valueTypeName:name}),paramValueObj:paramValueObj});}},{key:'onParamValueObjChange',value:function onParamValueObjChange(ids,names,datas){var _state4=this.state,valueTypeObj=_state4.valueTypeObj,paramValueObj=_state4.paramValueObj;var valueType=valueTypeObj.valueType;if(valueType=='6'&&datas&&datas.length){// 表单变量
var _datas$=datas[0],formid=_datas$.formid,isbill=_datas$.isbill,id=_datas$.id;this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:ids,paramValueName:names,paramValueData:datas[0],filterFormId:formid,filterIsBill:isbill,filterId:id})});}else{if(datas&&datas.length){this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:ids,paramValueName:names,paramValueData:datas[0]})});}else{this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:ids,paramValueName:names})});}}}},{key:'onParamValueObj4DateChange',value:function onParamValueObj4DateChange(value){var paramValueObj=this.state.paramValueObj;var _value=(0,_slicedToArray3.default)(value,3),dateType=_value[0],startDate=_value[1],endDate=_value[2];var paramValue=dateType;var paramValueName=(0,_util.getDateTypeName)(dateType);if(dateType=='6'){// 指定日期范围
paramValue=value.join(',');paramValueName+='('+startDate+' 至 '+endDate+')';}this.setState({paramValueObj:(0,_extends3.default)({},paramValueObj,{paramValue:paramValue,paramValueName:paramValueName})});}},{key:'getExpsComp',value:function getExpsComp(expsObj,selectedExps){var _this5=this;var _expsObj$relation=expsObj.relation,relation=_expsObj$relation===undefined?'1':_expsObj$relation,_expsObj$expressions=expsObj.expressions,expressions=_expsObj$expressions===undefined?[]:_expsObj$expressions;var expsComp=_react2.default.createElement('div',null);if(expressions&&expressions.length){expsComp=_react2.default.createElement('div',{className:'synergy-setting-exps'},_react2.default.createElement('div',{className:'synergy-setting-relation'},relation=='1'?'AND':'OR'),_react2.default.createElement('div',{className:'synergy-setting-line'}),expressions.map(function(item){var selected=false;for(var i=0,len=selectedExps.length;i<len;i++){if(selectedExps[i].key==item.key){selected=true;}}var style={border:selected?'2px dashed #17d68c':'2px solid #fff'};if(item.relation==0||item.relation==1){return _react2.default.createElement('div',{key:item.key,className:'synergy-setting-exps-child',style:style,onClick:function onClick(e){return _this5.onExpClick(e,selected,item);}},_this5.getExpsComp(item,selectedExps));}else{return _react2.default.createElement('div',{key:item.key,className:'synergy-setting-exp'},_react2.default.createElement('span',{style:style,onClick:function onClick(e){return _this5.onExpClick(e,selected,item);}},item.paramName,' ',item.compareName,' ',item.paramValueName));}}));}return expsComp;}},{key:'onExpClick',value:function onExpClick(e,selected,exp){e.stopPropagation();var _state5=this.state,selectedExps=_state5.selectedExps,selectedExpsPKey=_state5.selectedExpsPKey;if(selected){var _selectedExps=[];for(var i=0,len=selectedExps.length;i<len;i++){if(selectedExps[i].key!=exp.key){_selectedExps.push(selectedExps[i]);}}selectedExps=_selectedExps;}else{if(selectedExpsPKey&&selectedExpsPKey!=exp.parentKey){selectedExps=[];}selectedExps.push(exp);}this.setState({selectedExps:selectedExps,selectedExpsPKey:exp.parentKey});}},{key:'onAdd',value:function onAdd(){var _state6=this.state,paramObj=_state6.paramObj,compareTypeObj=_state6.compareTypeObj,valueTypeObj=_state6.valueTypeObj,paramValueObj=_state6.paramValueObj;var fromType=paramObj.fromType,formId=paramObj.formId,isBill=paramObj.isBill,paramId=paramObj.paramId,paramName=paramObj.paramName,fieldType=paramObj.fieldType;var compareType=compareTypeObj.compareType,compareName=compareTypeObj.compareName;var valueType=valueTypeObj.valueType;var paramValue=paramValueObj.paramValue,paramValueName=paramValueObj.paramValueName,filterFormId=paramValueObj.filterFormId,filterIsBill=paramValueObj.filterIsBill,filterId=paramValueObj.filterId;if(!paramId||paramId=='0'){_antd.message.warning('请选择参数！');}else if(!paramValue){_antd.message.warning('请选择参数值！');}else{var expsObj=this.state.expsObj;var curTime=new Date().getTime();var expression={key:'exp_'+curTime,parentKey:expsObj.key||'exps_'+curTime,id:'exp_'+curTime,variableId:'exp_'+curTime,fromType:fromType,formId:formId,isBill:isBill,paramId:paramId,paramName:paramName,paramType:valueType=='0'?'0':'1',fieldType:fieldType,compareType:compareType,compareName:compareName,valueType:valueType,paramValue:paramValue,paramValueName:paramValueName,valueVariableId:fieldType,filterFormId:filterFormId,filterIsBill:filterIsBill,filterId:filterId};var _expsObj2=expsObj,_expsObj2$expressions=_expsObj2.expressions,expressions=_expsObj2$expressions===undefined?[]:_expsObj2$expressions;if(expressions&&expressions.length){expressions.push(expression);}else{expsObj={key:'exps_'+curTime,parentKey:'exps_0',relation:'1',expressions:[expression]};}this.setState({expsObj:expsObj});}}},{key:'onDel',value:function onDel(){var _state7=this.state,expsObj=_state7.expsObj,selectedExps=_state7.selectedExps,selectedExpsPKey=_state7.selectedExpsPKey;if(selectedExps&&selectedExps.length){this._onDel(expsObj,selectedExps,selectedExpsPKey,false);this.setState({expsObj:expsObj,selectedExps:[],selectedExpsPKey:''});}else{_antd.message.warning('请选择需要删除的条件！');}}},{key:'_onDel',value:function _onDel(expsObj,selectedExps,selectedExpsPKey,flag){var key=expsObj.key,_expsObj$expressions2=expsObj.expressions,expressions=_expsObj$expressions2===undefined?[]:_expsObj$expressions2;if(key==selectedExpsPKey){var _expressions=[];for(var i=0,len=expressions.length;i<len;i++){var count=0;for(var j=0,len2=selectedExps.length;j<len2;j++){if(expressions[i].key==selectedExps[j].key){count++;}}if(count==0){_expressions.push(expressions[i]);}}expsObj.expressions=_expressions;}else{var _expressions2=[];for(var _i=0,_len=expressions.length;_i<_len;_i++){var _expsObj=expressions[_i];if(_expsObj.expressions){this._onDel(_expsObj,selectedExps,selectedExpsPKey,flag);if(flag||_expsObj.expressions&&_expsObj.expressions.length){_expressions2.push(_expsObj);}}else{_expressions2.push(_expsObj);}}expsObj.expressions=_expressions2;}}},{key:'onAnd',value:function onAnd(){this.onAndOr('1');}},{key:'onOr',value:function onOr(){this.onAndOr('0');}},{key:'onAndOr',value:function onAndOr(relation){var _state8=this.state,expsObj=_state8.expsObj,selectedExps=_state8.selectedExps,selectedExpsPKey=_state8.selectedExpsPKey;if(selectedExps&&selectedExps.length){this._onDel(expsObj,selectedExps,selectedExpsPKey,true);var curTime=new Date().getTime();for(var i=0,len=selectedExps.length;i<len;i++){selectedExps[i].parentKey='exps_'+curTime;}var exps={key:'exps_'+curTime,parentKey:selectedExpsPKey,relation:relation,expressions:selectedExps};this._onAndOr(expsObj,selectedExpsPKey,exps);this.setState({expsObj:expsObj,selectedExps:[],selectedExpsPKey:''});}}},{key:'_onAndOr',value:function _onAndOr(expsObj,selectedExpsPKey,exps){var key=expsObj.key,_expsObj$expressions3=expsObj.expressions,expressions=_expsObj$expressions3===undefined?[]:_expsObj$expressions3;if(key==selectedExpsPKey){expressions.push(exps);expsObj.expressions=expressions;}else{for(var i=0,len=expressions.length;i<len;i++){var _expsObj=expressions[i];if(_expsObj.expressions){this._onAndOr(_expsObj,selectedExpsPKey,exps);}}}}},{key:'onSplit',value:function onSplit(){var _state9=this.state,expsObj=_state9.expsObj,selectedExps=_state9.selectedExps,selectedExpsPKey=_state9.selectedExpsPKey;for(var i=0,len=selectedExps.length;i<len;i++){var _selectedExps$i=selectedExps[i],key=_selectedExps$i.key,expressions=_selectedExps$i.expressions;if(expressions&&expressions.length){for(var j=0,len2=expressions.length;j<len2;j++){expressions[j].parentKey=selectedExpsPKey;}this._onSplit(expsObj,key,expressions);}}this.setState({expsObj:expsObj,selectedExps:[],selectedExpsPKey:''});}},{key:'_onSplit',value:function _onSplit(expsObj,selectedExpsKey,exps){var _expsObj$expressions4=expsObj.expressions,expressions=_expsObj$expressions4===undefined?[]:_expsObj$expressions4;for(var i=0,len=expressions.length;i<len;i++){if(expressions[i].key==selectedExpsKey){expressions.splice.apply(expressions,[i,1].concat((0,_toConsumableArray3.default)(exps)));break;}else if(expressions[i].expressions){this._onSplit(expressions[i],selectedExpsKey,exps);}}}}]);return SynergySetting4Designer;}(_react2.default.Component);exports.default=SynergySetting4Designer;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_103__;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 滚动方向
var EScrollDirection=function(_React$Component){(0,_inherits3.default)(EScrollDirection,_React$Component);function EScrollDirection(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EScrollDirection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EScrollDirection.__proto__||(0,_getPrototypeOf2.default)(EScrollDirection)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EScrollDirection,[{key:'render',value:function render(){var _this2=this;var _onChange=this.props.onChange;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.value,style:{width:'100px'},onChange:function onChange(value){_this2.setState({value:value});if(_onChange&&typeof _onChange=='function'){_onChange(value);}}}));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.value;}}]);return EScrollDirection;}(_react2.default.Component);exports.default=EScrollDirection;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(311), __esModule: true };

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends6=__webpack_require__(8);var _extends7=_interopRequireDefault(_extends6);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 显示字段
var EField=function(_React$Component){(0,_inherits3.default)(EField,_React$Component);function EField(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,EField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=EField.__proto__||(0,_getPrototypeOf2.default)(EField)).call.apply(_ref,[this].concat(args))),_this),_this.state={eField:_this.props.value},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(EField,[{key:'render',value:function render(){var _this2=this;var eField=this.state.eField;var eFieldList=[];var _loop=function _loop(key){if(eField.hasOwnProperty(key)){eFieldList.push(_react2.default.createElement('li',{style:{display:'inline-block'}},_react2.default.createElement(_antd.Checkbox,{checked:eField[key].checked,onChange:function onChange(e){_this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{checked:e.target.checked})))});}},eField[key].label),_this2.props.eShareLevel=='2'&&eField[key].type=='image'?_react2.default.createElement('span',null,_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eField[key].width,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{width:value})))});}}),!eField[key].autoHeight?_react2.default.createElement('span',null,_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eField[key].height,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{height:value})))});}})):'',_react2.default.createElement(_antd.Checkbox,{checked:eField[key].autoHeight,onChange:function onChange(e){return _this2.setState({eField:(0,_extends7.default)({},eField,(0,_defineProperty3.default)({},key,(0,_extends7.default)({},eField[key],{autoHeight:e.target.checked})))});}},getLabel(22494,'自适应高度'))):''));}};for(var key in eField){_loop(key);}return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{style:{lineHeight:'29px'}},eFieldList));}},{key:'getSaveValues',value:function getSaveValues(){return this.state.eField;}}]);return EField;}(_react2.default.Component);exports.default=EField;

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toArray */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveIndex;
/* unused harmony export getActiveKey */
/* unused harmony export setTransform */
/* unused harmony export isTransform3dSupported */
/* unused harmony export setTransition */
/* harmony export (immutable) */ __webpack_exports__["e"] = getTransformPropValue;
/* unused harmony export isVertical */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTransformByIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMarginStyle;
/* unused harmony export getStyle */
/* unused harmony export setPxStyle */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataAttr;
/* unused harmony export getLeft */
/* unused harmony export getTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransform3dSupported(style) {
  return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}

function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

function toNum(style, property) {
  return +style.getPropertyValue(property).replace('px', '');
}

function getTypeValue(start, current, end, tabNode, wrapperNode) {
  var total = getStyle(wrapperNode, 'padding-' + start);
  if (!tabNode || !tabNode.parentNode) {
    return total;
  }

  var childNodes = tabNode.parentNode.childNodes;

  Array.prototype.some.call(childNodes, function (node) {
    var style = window.getComputedStyle(node);

    if (node !== tabNode) {
      total += toNum(style, 'margin-' + start);
      total += node[current];
      total += toNum(style, 'margin-' + end);

      if (style.boxSizing === 'content-box') {
        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
      }
      return false;
    }

    // We need count current node margin
    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
    total += toNum(style, 'margin-' + start);

    return true;
  });

  return total;
}

function getLeft(tabNode, wrapperNode) {
  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}

function getTop(tabNode, wrapperNode) {
  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(54),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(38);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_111__;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(171);__webpack_require__(172);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(50);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(114);
var hide = __webpack_require__(39);
var Iterators = __webpack_require__(53);
var $iterCreate = __webpack_require__(177);
var setToStringTag = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(115);
var ITERATOR = __webpack_require__(30)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(39);


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(33);
var toObject = __webpack_require__(45);
var IE_PROTO = __webpack_require__(59)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(72);
var hiddenKeys = __webpack_require__(61).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(52);
var createDesc = __webpack_require__(42);
var toIObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(56);
var has = __webpack_require__(33);
var IE8_DOM_DEFINE = __webpack_require__(70);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(25);
var core = __webpack_require__(18);
var fails = __webpack_require__(29);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(195), __esModule: true };

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _HpBaseElement=__webpack_require__(121);var _HpBaseElement2=_interopRequireDefault(_HpBaseElement);var _Homepage=__webpack_require__(69);var _Homepage2=_interopRequireDefault(_Homepage);var _PortalMenu=__webpack_require__(204);var _PortalMenu2=_interopRequireDefault(_PortalMenu);var _rcmenu=__webpack_require__(76);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Item=_antd.Menu.Item;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var PortalSetting=function(_React$Component){(0,_inherits3.default)(PortalSetting,_React$Component);function PortalSetting(props){(0,_classCallCheck3.default)(this,PortalSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(PortalSetting.__proto__||(0,_getPrototypeOf2.default)(PortalSetting)).call(this,props));_this.state={params:{},visible:false,loading:false,title:getLabel(19650,'设置元素'),data:{portalinfo:{},hpbaseelements:[],hpsettingmenu:[],rcmenu:[]},showLeft:true,portalmenu:{},showDrop:false,isShrink:false};_this.onChangeLabel=_this.onChangeLabel.bind(_this);_this.onShowDrop=_this.onShowDrop.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.handleOnSetting=_this.handleOnSetting.bind(_this);_this.handleCancel=_this.handleCancel.bind(_this);_this.handleRefreshPortal=_this.handleRefreshPortal.bind(_this);_this.handleAddElementToPortalStart=_this.handleAddElementToPortalStart.bind(_this);_this.handleAddElementToPortal=_this.handleAddElementToPortal.bind(_this);return _this;}(0,_createClass3.default)(PortalSetting,[{key:'onShowDrop',value:function onShowDrop(){this.setState({showDrop:!this.state.showDrop});}},{key:'getButtons',value:function getButtons(){var _this2=this;var isRedirectUrl='0';if(this.state.data.portalinfo){isRedirectUrl=this.state.data.portalinfo.isRedirectUrl;}var btns=[];if(isRedirectUrl!='1'){var hpsettingmenu=this.state.data.hpsettingmenu;if(hpsettingmenu&&hpsettingmenu.length){hpsettingmenu.map(function(menu,i){if(menu.key=='more'){btns.push(_react2.default.createElement(OperateMenu,{dropMenuDatas:_this2.getRightMenu(),onShowDrop:_this2.onShowDrop,onDropMenuClick:_this2.onRightMenuClick,showDrop:_this2.state.showDrop},_react2.default.createElement(_antd.Button,{onClick:_this2.onShowDrop},menu.label)));}else{btns.push(_react2.default.createElement(_antd.Button,{type:i===4?'':'primary',onClick:_this2.onRightMenuClick.bind(_this2,menu.key)},menu.label));}});}else{btns.push(_react2.default.createElement(_ecCom.WeaMoreButton,{datas:[]}));}}return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];var isRedirectUrl='0';if(this.state.data.portalinfo){isRedirectUrl=this.state.data.portalinfo.isRedirectUrl;}if(isRedirectUrl!='1'){var rcmenu=this.state.data.rcmenu;if(rcmenu){rcmenu.map(function(menu){btns.push({key:menu.key,icon:_react2.default.createElement('i',{className:menu.icon}),content:menu.label});});}}return btns;}},{key:'onChangeLabel',value:function onChangeLabel(list,key,bool,label1,lable2){for(var i=0;i<list.length;i++){var item=list[i]||{};if(item.key==key){if(bool){item.label=label1;}else{item.label=lable2;}break;}}}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var _state=this.state,params=_state.params,showLeft=_state.showLeft,isShrink=_state.isShrink,data=_state.data;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;switch(key){case'updatesynihp':case'completesynihp':(0,_rcmenu.handlePortalSynize)({hpid:hpid,subCompanyId:subCompanyId,method:key});break;case'shrinkAll':this.setState({isShrink:!isShrink});this.onChangeLabel(data.rcmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(16216,'全部展开'));this.onChangeLabel(data.hpsettingmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(16216,'全部展开'));(0,_rcmenu.onShowOrHideAllE)(isSetting);break;case'store':(0,_rcmenu.openFavouriteBrowser)();break;case'help':(0,_rcmenu.showHelp)();break;case'hiddenElementLib':this.setState({showLeft:!showLeft});this.onChangeLabel(data.rcmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));this.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));break;}}},{key:'handleOnSetting',value:function handleOnSetting(params){var _this3=this;this.setState({visible:true,loading:true});var title=params.title||'';if(params.viewtype==='priview'){_ecCom.WeaTools.callApi('/api/portal/hpsetting/hpsettinginfo','POST',params).then(function(result){if(result.status=='2'){_antd.message.error(result.errormsg);return;}if(params.module==='mainpage'){_ecCom.WeaTools.callApi('/api/portal/hpsetting/portalmenu','POST',{hpid:params.hpid}).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);return;}window.isPortalRender=true;_this3.setState({params:params,loading:false,portalmenu:data,data:{hpbaseelements:[],hpsettingmenu:[],rcmenu:[],portalinfo:result.portalinfo},title:title?title+' - '+getLabel(221,'预览'):getLabel(221,'预览')});});}else{_this3.setState({params:params,loading:false,data:{hpbaseelements:[],hpsettingmenu:[],rcmenu:[],portalinfo:result.portalinfo},portalmenu:{},title:title?title+' - '+getLabel(221,'预览'):getLabel(221,'预览')});}});}else{_ecCom.WeaTools.callApi('/api/portal/hpsetting/hpsettinginfo','POST',params).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);return;}window.isPortalRender=true;_this3.setState({params:params,loading:false,data:data,portalmenu:{},title:title?title+' - '+getLabel(19650,'设置元素'):getLabel(19650,'设置元素')});});}}},{key:'handleCancel',value:function handleCancel(){this.setState({visible:false});}},{key:'handleRefreshPortal',value:function handleRefreshPortal(params){if(this.refs.homepage)this.refs.homepage.handleRefresh(params);}},{key:'handleAddElementToPortalStart',value:function handleAddElementToPortalStart(){this.setState({loading:true});}},{key:'handleAddElementToPortal',value:function handleAddElementToPortal(element,areaflag,index){this.setState({loading:false});window.isPortalRender=true;this.refs.homepage.handleAddElement(element,areaflag,index);}},{key:'componentDidMount',value:function componentDidMount(){window.handlePortalSetting=this.handleOnSetting.bind(this);}},{key:'render',value:function render(){var _this4=this;var _state2=this.state,params=_state2.params,title=_state2.title,visible=_state2.visible,loading=_state2.loading,data=_state2.data,portalmenu=_state2.portalmenu,showLeft=_state2.showLeft;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting,viewtype=params.viewtype,module=params.module;var portalinfo=data.portalinfo;var html=_react2.default.createElement('div',null);if(hpid){if(portalinfo.isRedirectUrl=='1'){html=_react2.default.createElement('iframe',{frameBorder:'no',className:'custompageIframe',src:portalinfo.redirectUrl,style:{borderCollapse:'collapse',width:'100%',height:'100%'}});}else{html=_react2.default.createElement('div',{id:'e9PortalSetting',className:'portal-e9setting'},_react2.default.createElement(_Homepage2.default,(0,_extends3.default)({},params,{ref:'homepage'})));if(viewtype!=='priview'){html=visible&&_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement(_ecCom.WeaLeftRightLayout,{isNew:true,showLeft:showLeft,leftWidth:150,leftCom:_react2.default.createElement(_HpBaseElement2.default,{handleRefreshPortal:this.handleRefreshPortal,handleAddStart:this.handleAddElementToPortalStart,handleAdd:this.handleAddElementToPortal,params:params,list:data.hpbaseelements}),onCollapse:function onCollapse(bool){_this4.setState({showLeft:bool});_this4.onChangeLabel(data.rcmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel('19613',"显示元素库"));_this4.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel('19613',"显示元素库"));}},html));}}}return _react2.default.createElement(_ecCom.WeaDialog,{title:title,visible:visible,scalable:true,loading:loading,closable:true,onCancel:this.handleCancel,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:document.body.clientWidth-100,height:document.body.clientHeight-180},zIndex:800},module==='mainpage'?_react2.default.createElement(_PortalMenu2.default,{hpid:hpid,subCompanyId:subCompanyId,portalmenu:portalmenu,handleRefresh:this.handleRefreshPortal}):'',html);}}]);return PortalSetting;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);PortalSetting=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(PortalSetting);exports.default=PortalSetting;var OperateMenu=function(_React$Component3){(0,_inherits3.default)(OperateMenu,_React$Component3);function OperateMenu(){(0,_classCallCheck3.default)(this,OperateMenu);return(0,_possibleConstructorReturn3.default)(this,(OperateMenu.__proto__||(0,_getPrototypeOf2.default)(OperateMenu)).apply(this,arguments));}(0,_createClass3.default)(OperateMenu,[{key:'render',value:function render(){var _props=this.props,dropMenuDatas=_props.dropMenuDatas,onDropMenuClick=_props.onDropMenuClick,onShowDrop=_props.onShowDrop,showDrop=_props.showDrop,children=_props.children;var menu=dropMenuDatas?_react2.default.createElement(_antd.Menu,{mode:'vertical',onClick:function onClick(o){if(typeof onDropMenuClick==='function')onDropMenuClick(o.key);dropMenuDatas.forEach(function(d){if(d.key===o.key&&typeof d.onClick==='function')d.onClick(o.key);});}},dropMenuDatas.map(function(d,i){return _react2.default.createElement(Item,{key:d.key||i,disabled:d.disabled},_react2.default.createElement('span',{className:'wea-right-menu-icon'},d.icon),d.content);})):'';return _react2.default.createElement('div',{className:'portal-portalsetting-moremenu-pop'},_react2.default.createElement('div',{className:'wea-new-top-drop-menu wea-right-menu',style:{display:showDrop?'block':'none'},onMouseLeave:onShowDrop},_react2.default.createElement('div',{className:'wea-right-menu-icon-background'}),menu),children);}}]);return OperateMenu;}(_react2.default.Component);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _rcmenu=__webpack_require__(76);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HpBaseElement=function(_React$Component){(0,_inherits3.default)(HpBaseElement,_React$Component);function HpBaseElement(props){(0,_classCallCheck3.default)(this,HpBaseElement);var _this=(0,_possibleConstructorReturn3.default)(this,(HpBaseElement.__proto__||(0,_getPrototypeOf2.default)(HpBaseElement)).call(this,props));_this.state={value:'',addFinish:true};_this.handleOnShow=_this.handleOnShow.bind(_this);_this.handleAddElement=_this.handleAddElement.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.handleOnSearch=_this.handleOnSearch.bind(_this);_this.onSave=_this.onSave.bind(_this);return _this;}(0,_createClass3.default)(HpBaseElement,[{key:'handleOnShow',value:function handleOnShow(){this.refs.ElementTemplate.onShow();}},{key:'handleAddElement',value:function handleAddElement(ebaseid){var _this2=this;var areaflag=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'A';var index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;if(!this.state.addFinish)return;if($("#e9PortalSetting").find(".item").length===10){_antd.Modal.confirm({title:getLabel(15172,"系统提示"),content:getLabel(84090,"继续添加会影响页面性能，还要继续吗？"),onOk:function onOk(){_this2.onAdd(ebaseid,areaflag,index);}});}else{this.onAdd(ebaseid,areaflag,index);}}},{key:'onAdd',value:function onAdd(ebaseid,areaflag,index){var _this3=this;var _props=this.props,params=_props.params,handleAddStart=_props.handleAddStart,handleAdd=_props.handleAdd;var hpid=params.hpid,isSetting=params.isSetting;params.ebaseid=ebaseid;params.areaflag=areaflag;params.index=index;this.setState({addFinish:false});handleAddStart();_ecCom.WeaTools.callApi('/api/portal/hpbaseelement/addElement','POST',params).then(function(data){if(data.status==='2'){_antd.message.error(data.errormsg,2);}else{_this3.setState({addFinish:true});try{handleAdd(data,areaflag,index);}catch(e){window.console?console.log(getLabel(387990,"添加元素后刷新门户异常："),e):alert(getLabel(387990,"添加元素后刷新门户异常：")+e);}}});}},{key:'handleOnSearch',value:function handleOnSearch(value){this.setState({value:value});}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,isSynergySetting=_props2.isSynergySetting,list=_props2.list,params=_props2.params,handleRefreshPortal=_props2.handleRefreshPortal;var hpid=params.hpid,subCompanyId=params.subCompanyId;var pageType=subCompanyId=='-1'||subCompanyId==''?'1':'2';var value=this.state.value;//特殊处理抽藏元素（zang）多音字
if(value=='sc')value='sz';else if(value=='scy')value='szy';else if(value=='scys')value='szys';var htmlArr=new Array();list.map(function(item){if(value&&item.title.toLowerCase().indexOf(value.toLowerCase())==-1&&item.id.toLowerCase()!==value.toLowerCase()&&item.pinyin.toLowerCase().indexOf(value.toLowerCase())==-1){return;}htmlArr.push(_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-item',title:item.title,onMouseDown:_rcmenu.dragBaseElement.bind(_this4,item.id,_this4.handleAddElement)},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-icon'},_react2.default.createElement('img',{src:item.icon,alt:'',onError:function onError(e){return e.target.src='/spa/portal/images/icon-element.png';}})),_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-name'},_react2.default.createElement('span',{onClick:_this4.handleAddElement.bind(_this4,item.id,'A',0)},item.title))));});return _react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement'},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-addElement'},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-search',style:{width:isSynergySetting?'140px':'110px'}},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearchChange:this.handleOnSearch})),!isSynergySetting?_react2.default.createElement(_ecCom.WeaBrowser,{tabs:[{name:getLabel(387984,"已有元素"),key:'1',dataParams:{sourcetype:'1',pageType:pageType},conditionDataParams:{sourcetype:'1',pageType:pageType}},{name:getLabel(386539,'元素模板'),key:'2',selected:true,dataParams:{sourcetype:'2',pageType:pageType},conditionDataParams:{sourcetype:'2',pageType:pageType}}],type:'element',inputStyle:{width:'373px',marginLeft:'15px'},title:getLabel(386382,"请选择"),isSingle:false,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',customized:true,onChange:this.onSave},_react2.default.createElement(_antd.Tooltip,{placement:'right',title:getLabel(32385,"从模板导入")},_react2.default.createElement('div',{className:'portal-setting-left-hpbaseelement-template'},_react2.default.createElement('i',{className:'icon-coms-leading-in'})))):''),_react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'hpbaseelement',height:'100%'},htmlArr));}},{key:'onSave',value:function onSave(ids){var _props3=this.props,params=_props3.params,handleRefreshPortal=_props3.handleRefreshPortal;if(ids!=''){_ecCom.WeaTools.callApi('/api/portal/elementtemplateadd/save','POST',(0,_extends3.default)({areaflag:'A'},params,{ids:ids})).then(function(result){if(status=='2'){_antd.message.error(result.errormsg);return;}_antd.message.success(getLabel(83880,"添加成功！"));handleRefreshPortal();});}}}]);return HpBaseElement;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);HpBaseElement=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(HpBaseElement);exports.default=HpBaseElement;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(63);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(20);var _reactDom2=_interopRequireDefault(_reactDom);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);__webpack_require__(123);var _Tab4Content=__webpack_require__(222);var _Tab4Content2=_interopRequireDefault(_Tab4Content);var _Tab4Style=__webpack_require__(394);var _Tab4Style2=_interopRequireDefault(_Tab4Style);var _Tab4Share=__webpack_require__(396);var _Tab4Share2=_interopRequireDefault(_Tab4Share);var _ElementTemplate=__webpack_require__(397);var _ElementTemplate2=_interopRequireDefault(_ElementTemplate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TabPane=_antd.Tabs.TabPane;var ls=_ecCom.WeaTools.ls;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ESetting=function(_React$Component){(0,_inherits3.default)(ESetting,_React$Component);function ESetting(props){(0,_classCallCheck3.default)(this,ESetting);var _this=(0,_possibleConstructorReturn3.default)(this,(ESetting.__proto__||(0,_getPrototypeOf2.default)(ESetting)).call(this,props));_this.state={loading:false};_this.onSave=_this.onSave.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onSaveTemplate=_this.onSaveTemplate.bind(_this);return _this;}(0,_createClass3.default)(ESetting,[{key:'onSaveTemplate',value:function onSaveTemplate(){this.refs.ElementTemplate.onShow();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,isSynergySetting=_props.isSynergySetting,synergyParams=_props.synergyParams;var loading=this.state.loading;var canSaveTemplate=!/^Custom_/.test(data.ebaseid)&&data.eShareLevel=='2'&&!isSynergySetting;return _react2.default.createElement('div',{className:'portal-esetting-container'},_react2.default.createElement(_ElementTemplate2.default,{ref:'ElementTemplate',eid:data.eid,templateTitle:data.eContent.eTitle,onSave:this.onSave}),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement(_antd.Tabs,{defaultActiveKey:'1',className:'portal-esetting-tabs'},_react2.default.createElement(TabPane,{tab:getLabel(33368,'内容'),key:'1'},_react2.default.createElement(_Tab4Content2.default,(0,_extends3.default)({ref:'tab4Content'},data,{synergyParams:synergyParams}))),_react2.default.createElement(TabPane,{tab:getLabel(1014,'样式'),key:'2'},_react2.default.createElement(_Tab4Style2.default,(0,_extends3.default)({ref:'tab4Style'},data))),_react2.default.createElement(TabPane,{tab:getLabel(119,'共享'),key:'3'},_react2.default.createElement(_Tab4Share2.default,(0,_extends3.default)({ref:'tab4Share'},data)))),_react2.default.createElement('div',{className:'portal-esetting-confirm'},_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.onSave();}},getLabel(30986,'保存')),canSaveTemplate&&_react2.default.createElement(_antd.Button,{type:'primary',style:{marginLeft:'10px'},onClick:this.onSaveTemplate},getLabel(386538,'保存并存为模板')),_react2.default.createElement(_antd.Button,{type:'ghost',style:{marginLeft:'10px'},onClick:this.onCancel},getLabel(31129,'取消')))));}},{key:'onSave',value:function onSave(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fn=arguments[1];var _props2=this.props,data=_props2.data,handleRefresh=_props2.handleRefresh,isSetting=_props2.isSetting,getElementStyle=_props2.getElementStyle;var hpid=data.hpid,subCompanyId=data.subCompanyId,eid=data.eid,ebaseid=data.ebaseid,_data$eStyle=data.eStyle,eStyle=_data$eStyle===undefined?{}:_data$eStyle;var _eStyle$eHeight=eStyle.eHeight,eHeight=_eStyle$eHeight===undefined?'':_eStyle$eHeight;var contentValues=this.refs['tab4Content']?this.refs['tab4Content'].getSaveValues(ebaseid):null;if(!contentValues)return;this.setState({loading:true});// const contentValues = this.refs['tab4Content'] ? this.refs['tab4Content'].getSaveValues(ebaseid) : {};
var styleValues=this.refs['tab4Style']?this.refs['tab4Style'].getSaveValues():{};var shareValues=this.refs['tab4Share']?this.refs['tab4Share'].getSaveValues():{};_ecCom.WeaTools.callApi('/api/portal/setting/saveSetting','POST',{jsonStr:(0,_stringify2.default)((0,_extends3.default)({hpid:hpid,subCompanyId:subCompanyId,eid:eid,ebaseid:ebaseid},contentValues,styleValues,shareValues,params))}).then(function(result){// 刷新元素标题
var name=jQuery('#element_title_name_input_'+eid).val();if(isSetting){// true: 门户设置页面
jQuery('#e9PortalSetting').find('#element_title_name_'+eid).text(name);}else{jQuery('#element_title_name_'+eid).html(name);}// 刷新元素内容
handleRefresh(eid,ebaseid);//刷新元素样式
_ecCom.WeaTools.callApi('/api/portal/setting/getStyle','POST',{hpid:hpid,eid:eid,subCompanyId:subCompanyId,ebaseid:ebaseid}).then(function(result){if(result){var styleStr=result.hpCss.replace(/\"/g,"");if(jQuery('#portal-element-style-'+eid)&&jQuery('#portal-element-style-'+eid).length){jQuery('#portal-element-style-'+eid).html(styleStr);}else{jQuery(jQuery('head')[0]).append('<style id="portal-element-style-'+eid+'" type="text/css">'+styleStr+'</style>');}getElementStyle&&getElementStyle(eid,result.fontSizeMp);}});!(0,_lodash.isEmpty)(styleValues)&&window.portalGetElementStyle({hpid:hpid,isSetting:isSetting,subCompanyId:subCompanyId,isfromportal:1,isfromhp:0});// 卸载设置界面
_reactDom2.default.render(_react2.default.createElement('div',null),$('.homepage[data-isSetting='+_this3.props.isSetting+'] #setting_'+_this3.props.data.eid)[0]);});if(fn&&typeof fn=='function')fn();}},{key:'onCancel',value:function onCancel(){_reactDom2.default.render(_react2.default.createElement('div',null),$('.homepage[data-isSetting='+this.props.isSetting+'] #setting_'+this.props.data.eid)[0]);}}]);return ESetting;}(_react2.default.Component);exports.default=ESetting;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(220);__webpack_require__(221);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(125);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(53);
module.exports = __webpack_require__(18).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(58);
var TAG = __webpack_require__(30)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 元素数据来源，排序字段
var Content_8_DataSource_OrderCol=function(_React$Component){(0,_inherits3.default)(Content_8_DataSource_OrderCol,_React$Component);function Content_8_DataSource_OrderCol(props){(0,_classCallCheck3.default)(this,Content_8_DataSource_OrderCol);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_8_DataSource_OrderCol.__proto__||(0,_getPrototypeOf2.default)(Content_8_DataSource_OrderCol)).call(this,props));_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onOrderTypeChange=_this.onOrderTypeChange.bind(_this);_this.state={visible:true,orderColDataSource:props.orderColDataSource||[],orderColUsedKeys:props.orderColUsedKeys||[]};return _this;}(0,_createClass3.default)(Content_8_DataSource_OrderCol,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,orderColDataSource=_state.orderColDataSource,orderColUsedKeys=_state.orderColUsedKeys;return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(386541,'排序字段设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:500,height:312},buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaTransfer,{height:300,data:orderColDataSource,selectedKeys:orderColUsedKeys,renderItem:function renderItem(item){if(item.orderType=='')item.orderType='0';var orderTypeComp=_react2.default.createElement('div',null);if(orderColUsedKeys.indexOf(item.key)!=-1){orderTypeComp=_react2.default.createElement('span',{style:{float:'right',cursor:'pointer'},onClick:function onClick(e){return _this2.onOrderTypeChange(e,item);},onDoubleClick:function onDoubleClick(e){return e.stopPropagation();}},item.orderType=='0'?getLabel(340,'降序'):getLabel(339,'升序'));}return _react2.default.createElement('div',{style:{height:'37px',lineHeight:'37px',padding:'0 15px',borderBottom:'1px solid #e2e2e2'},title:item.fieldName},_react2.default.createElement('span',null,item.fieldName),orderTypeComp);},onChange:function onChange(keys){return _this2.setState({orderColUsedKeys:keys});}}));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){this.props.onOk(this.state);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'onOrderTypeChange',value:function onOrderTypeChange(e,item){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();var ds=this.state.orderColDataSource;for(var i=0,len=ds.length;i<len;i++){if(ds[i].key==item.key){ds[i].orderType=ds[i].orderType=='0'?'1':'0';}}this.setState({orderColDataSource:ds});}}]);return Content_8_DataSource_OrderCol;}(_react2.default.Component);exports.default=Content_8_DataSource_OrderCol;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _antd=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 缩略图设置
var ELinkMode=function(_React$Component){(0,_inherits3.default)(ELinkMode,_React$Component);function ELinkMode(){(0,_classCallCheck3.default)(this,ELinkMode);return(0,_possibleConstructorReturn3.default)(this,(ELinkMode.__proto__||(0,_getPrototypeOf2.default)(ELinkMode)).apply(this,arguments));}(0,_createClass3.default)(ELinkMode,[{key:'render',value:function render(){var _props=this.props,pictureWidth=_props.pictureWidth,pictureHeight=_props.pictureHeight,widthUnit=_props.widthUnit,heightUnit=_props.heightUnit,autoHeight=_props.autoHeight,authoHeight=_props.authoHeight,onChangeSize=_props.onChangeSize;return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386551,'缩略图设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{style:{lineHeight:'29px'}},_react2.default.createElement('li',{style:{display:'inline-block'}},_react2.default.createElement('span',null,_react2.default.createElement('span',null,_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:pictureWidth,style:{width:'40px',marginRight:'8px',marginBottom:'4px'},onChange:function onChange(value){return onChangeSize('pictureWidth',value);}}),_react2.default.createElement(_ecCom.WeaSelect,{className:'portal-news-picture',value:widthUnit=='px'?'1':'2',onChange:function onChange(value){return onChangeSize('widthUnit',value=='1'?'px':'%');},options:[{key:"1",selected:true,showname:"px"},{key:"2",selected:false,showname:"%"}],style:{width:'50px',marginRight:'8px',marginBottom:'4px'}})),autoHeight?'':_react2.default.createElement('span',{style:{marginLeft:'12px'}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:pictureHeight,style:{width:'40px',marginRight:'8px',marginBottom:'4px'},onChange:function onChange(value){return onChangeSize('pictureHeight',value);}}),_react2.default.createElement(_ecCom.WeaSelect,{className:'portal-news-picture',value:heightUnit=='px'?'1':'2',onChange:function onChange(value){return onChangeSize('heightUnit',value=='1'?'px':'%');},options:[{key:"1",selected:true,showname:"px"},{key:"2",selected:false,showname:"%"}],style:{width:'50px',marginRight:'8px',marginBottom:'4px'}})),_react2.default.createElement(_antd.Checkbox,{className:authoHeight,style:{marginLeft:'0px'},checked:autoHeight,onChange:function onChange(e){return onChangeSize('autoHeight',e.target.checked);}},getLabel(22494,'自适应高度'))))));}}]);return ELinkMode;}(_react2.default.Component);exports.default=ELinkMode;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(251);var _EChartView=__webpack_require__(252);var _EChartView2=_interopRequireDefault(_EChartView);var _EchartTemplate=__webpack_require__(253);var _EchartTemplate2=_interopRequireDefault(_EchartTemplate);var _options=__webpack_require__(278);var _options2=_interopRequireDefault(_options);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}module.exports={EchartView:_EChartView2.default,EchartTemplate:_EchartTemplate2.default,getEChartOption:_options2.default};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */

/**
 * Define a module along with a payload
 * @param module a name for the payload
 * @param payload a function to call with (acequire, exports, module) params
 */

(function() {

var ACE_NAMESPACE = "ace";

var global = (function() { return this; })();
if (!global && typeof window != "undefined") global = window; // strict mode


if (!ACE_NAMESPACE && typeof acequirejs !== "undefined")
    return;


var define = function(module, deps, payload) {
    if (typeof module !== "string") {
        if (define.original)
            define.original.apply(this, arguments);
        else {
            console.error("dropping module because define wasn\'t a string.");
            console.trace();
        }
        return;
    }
    if (arguments.length == 2)
        payload = deps;
    if (!define.modules[module]) {
        define.payloads[module] = payload;
        define.modules[module] = null;
    }
};

define.modules = {};
define.payloads = {};

/**
 * Get at functionality define()ed using the function above
 */
var _acequire = function(parentId, module, callback) {
    if (typeof module === "string") {
        var payload = lookup(parentId, module);
        if (payload != undefined) {
            callback && callback();
            return payload;
        }
    } else if (Object.prototype.toString.call(module) === "[object Array]") {
        var params = [];
        for (var i = 0, l = module.length; i < l; ++i) {
            var dep = lookup(parentId, module[i]);
            if (dep == undefined && acequire.original)
                return;
            params.push(dep);
        }
        return callback && callback.apply(null, params) || true;
    }
};

var acequire = function(module, callback) {
    var packagedModule = _acequire("", module, callback);
    if (packagedModule == undefined && acequire.original)
        return acequire.original.apply(this, arguments);
    return packagedModule;
};

var normalizeModule = function(parentId, moduleName) {
    // normalize plugin acequires
    if (moduleName.indexOf("!") !== -1) {
        var chunks = moduleName.split("!");
        return normalizeModule(parentId, chunks[0]) + "!" + normalizeModule(parentId, chunks[1]);
    }
    // normalize relative acequires
    if (moduleName.charAt(0) == ".") {
        var base = parentId.split("/").slice(0, -1).join("/");
        moduleName = base + "/" + moduleName;

        while(moduleName.indexOf(".") !== -1 && previous != moduleName) {
            var previous = moduleName;
            moduleName = moduleName.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
        }
    }
    return moduleName;
};

/**
 * Internal function to lookup moduleNames and resolve them by calling the
 * definition function if needed.
 */
var lookup = function(parentId, moduleName) {
    moduleName = normalizeModule(parentId, moduleName);

    var module = define.modules[moduleName];
    if (!module) {
        module = define.payloads[moduleName];
        if (typeof module === 'function') {
            var exports = {};
            var mod = {
                id: moduleName,
                uri: '',
                exports: exports,
                packaged: true
            };

            var req = function(module, callback) {
                return _acequire(moduleName, module, callback);
            };

            var returnValue = module(req, exports, mod);
            exports = returnValue || mod.exports;
            define.modules[moduleName] = exports;
            delete define.payloads[moduleName];
        }
        module = define.modules[moduleName] = exports || module;
    }
    return module;
};

function exportAce(ns) {
    var root = global;
    if (ns) {
        if (!global[ns])
            global[ns] = {};
        root = global[ns];
    }

    if (!root.define || !root.define.packaged) {
        define.original = root.define;
        root.define = define;
        root.define.packaged = true;
    }

    if (!root.acequire || !root.acequire.packaged) {
        acequire.original = root.acequire;
        root.acequire = acequire;
        root.acequire.packaged = true;
    }
}

exportAce(ACE_NAMESPACE);

})();

ace.define("ace/lib/regexp",["require","exports","module"], function(acequire, exports, module) {
"use strict";

    var real = {
            exec: RegExp.prototype.exec,
            test: RegExp.prototype.test,
            match: String.prototype.match,
            replace: String.prototype.replace,
            split: String.prototype.split
        },
        compliantExecNpcg = real.exec.call(/()??/, "")[1] === undefined, // check `exec` handling of nonparticipating capturing groups
        compliantLastIndexIncrement = function () {
            var x = /^/g;
            real.test.call(x, "");
            return !x.lastIndex;
        }();

    if (compliantLastIndexIncrement && compliantExecNpcg)
        return;
    RegExp.prototype.exec = function (str) {
        var match = real.exec.apply(this, arguments),
            name, r2;
        if ( typeof(str) == 'string' && match) {
            if (!compliantExecNpcg && match.length > 1 && indexOf(match, "") > -1) {
                r2 = RegExp(this.source, real.replace.call(getNativeFlags(this), "g", ""));
                real.replace.call(str.slice(match.index), r2, function () {
                    for (var i = 1; i < arguments.length - 2; i++) {
                        if (arguments[i] === undefined)
                            match[i] = undefined;
                    }
                });
            }
            if (this._xregexp && this._xregexp.captureNames) {
                for (var i = 1; i < match.length; i++) {
                    name = this._xregexp.captureNames[i - 1];
                    if (name)
                       match[name] = match[i];
                }
            }
            if (!compliantLastIndexIncrement && this.global && !match[0].length && (this.lastIndex > match.index))
                this.lastIndex--;
        }
        return match;
    };
    if (!compliantLastIndexIncrement) {
        RegExp.prototype.test = function (str) {
            var match = real.exec.call(this, str);
            if (match && this.global && !match[0].length && (this.lastIndex > match.index))
                this.lastIndex--;
            return !!match;
        };
    }

    function getNativeFlags (regex) {
        return (regex.global     ? "g" : "") +
               (regex.ignoreCase ? "i" : "") +
               (regex.multiline  ? "m" : "") +
               (regex.extended   ? "x" : "") + // Proposed for ES4; included in AS3
               (regex.sticky     ? "y" : "");
    }

    function indexOf (array, item, from) {
        if (Array.prototype.indexOf) // Use the native array method if available
            return array.indexOf(item, from);
        for (var i = from || 0; i < array.length; i++) {
            if (array[i] === item)
                return i;
        }
        return -1;
    }

});

ace.define("ace/lib/es5-shim",["require","exports","module"], function(acequire, exports, module) {

function Empty() {}

if (!Function.prototype.bind) {
    Function.prototype.bind = function bind(that) { // .length is 1
        var target = this;
        if (typeof target != "function") {
            throw new TypeError("Function.prototype.bind called on incompatible " + target);
        }
        var args = slice.call(arguments, 1); // for normal call
        var bound = function () {

            if (this instanceof bound) {

                var result = target.apply(
                    this,
                    args.concat(slice.call(arguments))
                );
                if (Object(result) === result) {
                    return result;
                }
                return this;

            } else {
                return target.apply(
                    that,
                    args.concat(slice.call(arguments))
                );

            }

        };
        if(target.prototype) {
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
        }
        return bound;
    };
}
var call = Function.prototype.call;
var prototypeOfArray = Array.prototype;
var prototypeOfObject = Object.prototype;
var slice = prototypeOfArray.slice;
var _toString = call.bind(prototypeOfObject.toString);
var owns = call.bind(prototypeOfObject.hasOwnProperty);
var defineGetter;
var defineSetter;
var lookupGetter;
var lookupSetter;
var supportsAccessors;
if ((supportsAccessors = owns(prototypeOfObject, "__defineGetter__"))) {
    defineGetter = call.bind(prototypeOfObject.__defineGetter__);
    defineSetter = call.bind(prototypeOfObject.__defineSetter__);
    lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
    lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
}
if ([1,2].splice(0).length != 2) {
    if(function() { // test IE < 9 to splice bug - see issue #138
        function makeArray(l) {
            var a = new Array(l+2);
            a[0] = a[1] = 0;
            return a;
        }
        var array = [], lengthBefore;
        
        array.splice.apply(array, makeArray(20));
        array.splice.apply(array, makeArray(26));

        lengthBefore = array.length; //46
        array.splice(5, 0, "XXX"); // add one element

        lengthBefore + 1 == array.length

        if (lengthBefore + 1 == array.length) {
            return true;// has right splice implementation without bugs
        }
    }()) {//IE 6/7
        var array_splice = Array.prototype.splice;
        Array.prototype.splice = function(start, deleteCount) {
            if (!arguments.length) {
                return [];
            } else {
                return array_splice.apply(this, [
                    start === void 0 ? 0 : start,
                    deleteCount === void 0 ? (this.length - start) : deleteCount
                ].concat(slice.call(arguments, 2)))
            }
        };
    } else {//IE8
        Array.prototype.splice = function(pos, removeCount){
            var length = this.length;
            if (pos > 0) {
                if (pos > length)
                    pos = length;
            } else if (pos == void 0) {
                pos = 0;
            } else if (pos < 0) {
                pos = Math.max(length + pos, 0);
            }

            if (!(pos+removeCount < length))
                removeCount = length - pos;

            var removed = this.slice(pos, pos+removeCount);
            var insert = slice.call(arguments, 2);
            var add = insert.length;            
            if (pos === length) {
                if (add) {
                    this.push.apply(this, insert);
                }
            } else {
                var remove = Math.min(removeCount, length - pos);
                var tailOldPos = pos + remove;
                var tailNewPos = tailOldPos + add - remove;
                var tailCount = length - tailOldPos;
                var lengthAfterRemove = length - remove;

                if (tailNewPos < tailOldPos) { // case A
                    for (var i = 0; i < tailCount; ++i) {
                        this[tailNewPos+i] = this[tailOldPos+i];
                    }
                } else if (tailNewPos > tailOldPos) { // case B
                    for (i = tailCount; i--; ) {
                        this[tailNewPos+i] = this[tailOldPos+i];
                    }
                } // else, add == remove (nothing to do)

                if (add && pos === lengthAfterRemove) {
                    this.length = lengthAfterRemove; // truncate array
                    this.push.apply(this, insert);
                } else {
                    this.length = lengthAfterRemove + add; // reserves space
                    for (i = 0; i < add; ++i) {
                        this[pos+i] = insert[i];
                    }
                }
            }
            return removed;
        };
    }
}
if (!Array.isArray) {
    Array.isArray = function isArray(obj) {
        return _toString(obj) == "[object Array]";
    };
}
var boxedString = Object("a"),
    splitString = boxedString[0] != "a" || !(0 in boxedString);

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function forEach(fun /*, thisp*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            thisp = arguments[1],
            i = -1,
            length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(); // TODO message
        }

        while (++i < length) {
            if (i in self) {
                fun.call(thisp, self[i], i, object);
            }
        }
    };
}
if (!Array.prototype.map) {
    Array.prototype.map = function map(fun /*, thisp*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0,
            result = Array(length),
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self)
                result[i] = fun.call(thisp, self[i], i, object);
        }
        return result;
    };
}
if (!Array.prototype.filter) {
    Array.prototype.filter = function filter(fun /*, thisp */) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                    object,
            length = self.length >>> 0,
            result = [],
            value,
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self) {
                value = self[i];
                if (fun.call(thisp, value, i, object)) {
                    result.push(value);
                }
            }
        }
        return result;
    };
}
if (!Array.prototype.every) {
    Array.prototype.every = function every(fun /*, thisp */) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0,
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self && !fun.call(thisp, self[i], i, object)) {
                return false;
            }
        }
        return true;
    };
}
if (!Array.prototype.some) {
    Array.prototype.some = function some(fun /*, thisp */) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0,
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self && fun.call(thisp, self[i], i, object)) {
                return true;
            }
        }
        return false;
    };
}
if (!Array.prototype.reduce) {
    Array.prototype.reduce = function reduce(fun /*, initial*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }
        if (!length && arguments.length == 1) {
            throw new TypeError("reduce of empty array with no initial value");
        }

        var i = 0;
        var result;
        if (arguments.length >= 2) {
            result = arguments[1];
        } else {
            do {
                if (i in self) {
                    result = self[i++];
                    break;
                }
                if (++i >= length) {
                    throw new TypeError("reduce of empty array with no initial value");
                }
            } while (true);
        }

        for (; i < length; i++) {
            if (i in self) {
                result = fun.call(void 0, result, self[i], i, object);
            }
        }

        return result;
    };
}
if (!Array.prototype.reduceRight) {
    Array.prototype.reduceRight = function reduceRight(fun /*, initial*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }
        if (!length && arguments.length == 1) {
            throw new TypeError("reduceRight of empty array with no initial value");
        }

        var result, i = length - 1;
        if (arguments.length >= 2) {
            result = arguments[1];
        } else {
            do {
                if (i in self) {
                    result = self[i--];
                    break;
                }
                if (--i < 0) {
                    throw new TypeError("reduceRight of empty array with no initial value");
                }
            } while (true);
        }

        do {
            if (i in this) {
                result = fun.call(void 0, result, self[i], i, object);
            }
        } while (i--);

        return result;
    };
}
if (!Array.prototype.indexOf || ([0, 1].indexOf(1, 2) != -1)) {
    Array.prototype.indexOf = function indexOf(sought /*, fromIndex */ ) {
        var self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                toObject(this),
            length = self.length >>> 0;

        if (!length) {
            return -1;
        }

        var i = 0;
        if (arguments.length > 1) {
            i = toInteger(arguments[1]);
        }
        i = i >= 0 ? i : Math.max(0, length + i);
        for (; i < length; i++) {
            if (i in self && self[i] === sought) {
                return i;
            }
        }
        return -1;
    };
}
if (!Array.prototype.lastIndexOf || ([0, 1].lastIndexOf(0, -3) != -1)) {
    Array.prototype.lastIndexOf = function lastIndexOf(sought /*, fromIndex */) {
        var self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                toObject(this),
            length = self.length >>> 0;

        if (!length) {
            return -1;
        }
        var i = length - 1;
        if (arguments.length > 1) {
            i = Math.min(i, toInteger(arguments[1]));
        }
        i = i >= 0 ? i : length - Math.abs(i);
        for (; i >= 0; i--) {
            if (i in self && sought === self[i]) {
                return i;
            }
        }
        return -1;
    };
}
if (!Object.getPrototypeOf) {
    Object.getPrototypeOf = function getPrototypeOf(object) {
        return object.__proto__ || (
            object.constructor ?
            object.constructor.prototype :
            prototypeOfObject
        );
    };
}
if (!Object.getOwnPropertyDescriptor) {
    var ERR_NON_OBJECT = "Object.getOwnPropertyDescriptor called on a " +
                         "non-object: ";
    Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
        if ((typeof object != "object" && typeof object != "function") || object === null)
            throw new TypeError(ERR_NON_OBJECT + object);
        if (!owns(object, property))
            return;

        var descriptor, getter, setter;
        descriptor =  { enumerable: true, configurable: true };
        if (supportsAccessors) {
            var prototype = object.__proto__;
            object.__proto__ = prototypeOfObject;

            var getter = lookupGetter(object, property);
            var setter = lookupSetter(object, property);
            object.__proto__ = prototype;

            if (getter || setter) {
                if (getter) descriptor.get = getter;
                if (setter) descriptor.set = setter;
                return descriptor;
            }
        }
        descriptor.value = object[property];
        return descriptor;
    };
}
if (!Object.getOwnPropertyNames) {
    Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
        return Object.keys(object);
    };
}
if (!Object.create) {
    var createEmpty;
    if (Object.prototype.__proto__ === null) {
        createEmpty = function () {
            return { "__proto__": null };
        };
    } else {
        createEmpty = function () {
            var empty = {};
            for (var i in empty)
                empty[i] = null;
            empty.constructor =
            empty.hasOwnProperty =
            empty.propertyIsEnumerable =
            empty.isPrototypeOf =
            empty.toLocaleString =
            empty.toString =
            empty.valueOf =
            empty.__proto__ = null;
            return empty;
        }
    }

    Object.create = function create(prototype, properties) {
        var object;
        if (prototype === null) {
            object = createEmpty();
        } else {
            if (typeof prototype != "object")
                throw new TypeError("typeof prototype["+(typeof prototype)+"] != 'object'");
            var Type = function () {};
            Type.prototype = prototype;
            object = new Type();
            object.__proto__ = prototype;
        }
        if (properties !== void 0)
            Object.defineProperties(object, properties);
        return object;
    };
}

function doesDefinePropertyWork(object) {
    try {
        Object.defineProperty(object, "sentinel", {});
        return "sentinel" in object;
    } catch (exception) {
    }
}
if (Object.defineProperty) {
    var definePropertyWorksOnObject = doesDefinePropertyWork({});
    var definePropertyWorksOnDom = typeof document == "undefined" ||
        doesDefinePropertyWork(document.createElement("div"));
    if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) {
        var definePropertyFallback = Object.defineProperty;
    }
}

if (!Object.defineProperty || definePropertyFallback) {
    var ERR_NON_OBJECT_DESCRIPTOR = "Property description must be an object: ";
    var ERR_NON_OBJECT_TARGET = "Object.defineProperty called on non-object: "
    var ERR_ACCESSORS_NOT_SUPPORTED = "getters & setters can not be defined " +
                                      "on this javascript engine";

    Object.defineProperty = function defineProperty(object, property, descriptor) {
        if ((typeof object != "object" && typeof object != "function") || object === null)
            throw new TypeError(ERR_NON_OBJECT_TARGET + object);
        if ((typeof descriptor != "object" && typeof descriptor != "function") || descriptor === null)
            throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
        if (definePropertyFallback) {
            try {
                return definePropertyFallback.call(Object, object, property, descriptor);
            } catch (exception) {
            }
        }
        if (owns(descriptor, "value")) {

            if (supportsAccessors && (lookupGetter(object, property) ||
                                      lookupSetter(object, property)))
            {
                var prototype = object.__proto__;
                object.__proto__ = prototypeOfObject;
                delete object[property];
                object[property] = descriptor.value;
                object.__proto__ = prototype;
            } else {
                object[property] = descriptor.value;
            }
        } else {
            if (!supportsAccessors)
                throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
            if (owns(descriptor, "get"))
                defineGetter(object, property, descriptor.get);
            if (owns(descriptor, "set"))
                defineSetter(object, property, descriptor.set);
        }

        return object;
    };
}
if (!Object.defineProperties) {
    Object.defineProperties = function defineProperties(object, properties) {
        for (var property in properties) {
            if (owns(properties, property))
                Object.defineProperty(object, property, properties[property]);
        }
        return object;
    };
}
if (!Object.seal) {
    Object.seal = function seal(object) {
        return object;
    };
}
if (!Object.freeze) {
    Object.freeze = function freeze(object) {
        return object;
    };
}
try {
    Object.freeze(function () {});
} catch (exception) {
    Object.freeze = (function freeze(freezeObject) {
        return function freeze(object) {
            if (typeof object == "function") {
                return object;
            } else {
                return freezeObject(object);
            }
        };
    })(Object.freeze);
}
if (!Object.preventExtensions) {
    Object.preventExtensions = function preventExtensions(object) {
        return object;
    };
}
if (!Object.isSealed) {
    Object.isSealed = function isSealed(object) {
        return false;
    };
}
if (!Object.isFrozen) {
    Object.isFrozen = function isFrozen(object) {
        return false;
    };
}
if (!Object.isExtensible) {
    Object.isExtensible = function isExtensible(object) {
        if (Object(object) === object) {
            throw new TypeError(); // TODO message
        }
        var name = '';
        while (owns(object, name)) {
            name += '?';
        }
        object[name] = true;
        var returnValue = owns(object, name);
        delete object[name];
        return returnValue;
    };
}
if (!Object.keys) {
    var hasDontEnumBug = true,
        dontEnums = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ],
        dontEnumsLength = dontEnums.length;

    for (var key in {"toString": null}) {
        hasDontEnumBug = false;
    }

    Object.keys = function keys(object) {

        if (
            (typeof object != "object" && typeof object != "function") ||
            object === null
        ) {
            throw new TypeError("Object.keys called on a non-object");
        }

        var keys = [];
        for (var name in object) {
            if (owns(object, name)) {
                keys.push(name);
            }
        }

        if (hasDontEnumBug) {
            for (var i = 0, ii = dontEnumsLength; i < ii; i++) {
                var dontEnum = dontEnums[i];
                if (owns(object, dontEnum)) {
                    keys.push(dontEnum);
                }
            }
        }
        return keys;
    };

}
if (!Date.now) {
    Date.now = function now() {
        return new Date().getTime();
    };
}
var ws = "\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003" +
    "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028" +
    "\u2029\uFEFF";
if (!String.prototype.trim || ws.trim()) {
    ws = "[" + ws + "]";
    var trimBeginRegexp = new RegExp("^" + ws + ws + "*"),
        trimEndRegexp = new RegExp(ws + ws + "*$");
    String.prototype.trim = function trim() {
        return String(this).replace(trimBeginRegexp, "").replace(trimEndRegexp, "");
    };
}

function toInteger(n) {
    n = +n;
    if (n !== n) { // isNaN
        n = 0;
    } else if (n !== 0 && n !== (1/0) && n !== -(1/0)) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
    }
    return n;
}

function isPrimitive(input) {
    var type = typeof input;
    return (
        input === null ||
        type === "undefined" ||
        type === "boolean" ||
        type === "number" ||
        type === "string"
    );
}

function toPrimitive(input) {
    var val, valueOf, toString;
    if (isPrimitive(input)) {
        return input;
    }
    valueOf = input.valueOf;
    if (typeof valueOf === "function") {
        val = valueOf.call(input);
        if (isPrimitive(val)) {
            return val;
        }
    }
    toString = input.toString;
    if (typeof toString === "function") {
        val = toString.call(input);
        if (isPrimitive(val)) {
            return val;
        }
    }
    throw new TypeError();
}
var toObject = function (o) {
    if (o == null) { // this matches both null and undefined
        throw new TypeError("can't convert "+o+" to object");
    }
    return Object(o);
};

});

ace.define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/regexp","ace/lib/es5-shim"], function(acequire, exports, module) {
"use strict";

acequire("./regexp");
acequire("./es5-shim");

});

ace.define("ace/lib/dom",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var XHTML_NS = "http://www.w3.org/1999/xhtml";

exports.getDocumentHead = function(doc) {
    if (!doc)
        doc = document;
    return doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
};

exports.createElement = function(tag, ns) {
    return document.createElementNS ?
           document.createElementNS(ns || XHTML_NS, tag) :
           document.createElement(tag);
};

exports.hasCssClass = function(el, name) {
    var classes = (el.className + "").split(/\s+/g);
    return classes.indexOf(name) !== -1;
};
exports.addCssClass = function(el, name) {
    if (!exports.hasCssClass(el, name)) {
        el.className += " " + name;
    }
};
exports.removeCssClass = function(el, name) {
    var classes = el.className.split(/\s+/g);
    while (true) {
        var index = classes.indexOf(name);
        if (index == -1) {
            break;
        }
        classes.splice(index, 1);
    }
    el.className = classes.join(" ");
};

exports.toggleCssClass = function(el, name) {
    var classes = el.className.split(/\s+/g), add = true;
    while (true) {
        var index = classes.indexOf(name);
        if (index == -1) {
            break;
        }
        add = false;
        classes.splice(index, 1);
    }
    if (add)
        classes.push(name);

    el.className = classes.join(" ");
    return add;
};
exports.setCssClass = function(node, className, include) {
    if (include) {
        exports.addCssClass(node, className);
    } else {
        exports.removeCssClass(node, className);
    }
};

exports.hasCssString = function(id, doc) {
    var index = 0, sheets;
    doc = doc || document;

    if (doc.createStyleSheet && (sheets = doc.styleSheets)) {
        while (index < sheets.length)
            if (sheets[index++].owningElement.id === id) return true;
    } else if ((sheets = doc.getElementsByTagName("style"))) {
        while (index < sheets.length)
            if (sheets[index++].id === id) return true;
    }

    return false;
};

exports.importCssString = function importCssString(cssText, id, doc) {
    doc = doc || document;
    if (id && exports.hasCssString(id, doc))
        return null;
    
    var style;
    
    if (id)
        cssText += "\n/*# sourceURL=ace/css/" + id + " */";
    
    if (doc.createStyleSheet) {
        style = doc.createStyleSheet();
        style.cssText = cssText;
        if (id)
            style.owningElement.id = id;
    } else {
        style = exports.createElement("style");
        style.appendChild(doc.createTextNode(cssText));
        if (id)
            style.id = id;

        exports.getDocumentHead(doc).appendChild(style);
    }
};

exports.importCssStylsheet = function(uri, doc) {
    if (doc.createStyleSheet) {
        doc.createStyleSheet(uri);
    } else {
        var link = exports.createElement('link');
        link.rel = 'stylesheet';
        link.href = uri;

        exports.getDocumentHead(doc).appendChild(link);
    }
};

exports.getInnerWidth = function(element) {
    return (
        parseInt(exports.computedStyle(element, "paddingLeft"), 10) +
        parseInt(exports.computedStyle(element, "paddingRight"), 10) + 
        element.clientWidth
    );
};

exports.getInnerHeight = function(element) {
    return (
        parseInt(exports.computedStyle(element, "paddingTop"), 10) +
        parseInt(exports.computedStyle(element, "paddingBottom"), 10) +
        element.clientHeight
    );
};

exports.scrollbarWidth = function(document) {
    var inner = exports.createElement("ace_inner");
    inner.style.width = "100%";
    inner.style.minWidth = "0px";
    inner.style.height = "200px";
    inner.style.display = "block";

    var outer = exports.createElement("ace_outer");
    var style = outer.style;

    style.position = "absolute";
    style.left = "-10000px";
    style.overflow = "hidden";
    style.width = "200px";
    style.minWidth = "0px";
    style.height = "150px";
    style.display = "block";

    outer.appendChild(inner);

    var body = document.documentElement;
    body.appendChild(outer);

    var noScrollbar = inner.offsetWidth;

    style.overflow = "scroll";
    var withScrollbar = inner.offsetWidth;

    if (noScrollbar == withScrollbar) {
        withScrollbar = outer.clientWidth;
    }

    body.removeChild(outer);

    return noScrollbar-withScrollbar;
};

if (typeof document == "undefined") {
    exports.importCssString = function() {};
    return;
}

if (window.pageYOffset !== undefined) {
    exports.getPageScrollTop = function() {
        return window.pageYOffset;
    };

    exports.getPageScrollLeft = function() {
        return window.pageXOffset;
    };
}
else {
    exports.getPageScrollTop = function() {
        return document.body.scrollTop;
    };

    exports.getPageScrollLeft = function() {
        return document.body.scrollLeft;
    };
}

if (window.getComputedStyle)
    exports.computedStyle = function(element, style) {
        if (style)
            return (window.getComputedStyle(element, "") || {})[style] || "";
        return window.getComputedStyle(element, "") || {};
    };
else
    exports.computedStyle = function(element, style) {
        if (style)
            return element.currentStyle[style];
        return element.currentStyle;
    };
exports.setInnerHtml = function(el, innerHtml) {
    var element = el.cloneNode(false);//document.createElement("div");
    element.innerHTML = innerHtml;
    el.parentNode.replaceChild(element, el);
    return element;
};

if ("textContent" in document.documentElement) {
    exports.setInnerText = function(el, innerText) {
        el.textContent = innerText;
    };

    exports.getInnerText = function(el) {
        return el.textContent;
    };
}
else {
    exports.setInnerText = function(el, innerText) {
        el.innerText = innerText;
    };

    exports.getInnerText = function(el) {
        return el.innerText;
    };
}

exports.getParentWindow = function(document) {
    return document.defaultView || document.parentWindow;
};

});

ace.define("ace/lib/oop",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.inherits = function(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};

exports.mixin = function(obj, mixin) {
    for (var key in mixin) {
        obj[key] = mixin[key];
    }
    return obj;
};

exports.implement = function(proto, mixin) {
    exports.mixin(proto, mixin);
};

});

ace.define("ace/lib/keys",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop"], function(acequire, exports, module) {
"use strict";

acequire("./fixoldbrowsers");

var oop = acequire("./oop");
var Keys = (function() {
    var ret = {
        MODIFIER_KEYS: {
            16: 'Shift', 17: 'Ctrl', 18: 'Alt', 224: 'Meta'
        },

        KEY_MODS: {
            "ctrl": 1, "alt": 2, "option" : 2, "shift": 4,
            "super": 8, "meta": 8, "command": 8, "cmd": 8
        },

        FUNCTION_KEYS : {
            8  : "Backspace",
            9  : "Tab",
            13 : "Return",
            19 : "Pause",
            27 : "Esc",
            32 : "Space",
            33 : "PageUp",
            34 : "PageDown",
            35 : "End",
            36 : "Home",
            37 : "Left",
            38 : "Up",
            39 : "Right",
            40 : "Down",
            44 : "Print",
            45 : "Insert",
            46 : "Delete",
            96 : "Numpad0",
            97 : "Numpad1",
            98 : "Numpad2",
            99 : "Numpad3",
            100: "Numpad4",
            101: "Numpad5",
            102: "Numpad6",
            103: "Numpad7",
            104: "Numpad8",
            105: "Numpad9",
            '-13': "NumpadEnter",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "Numlock",
            145: "Scrolllock"
        },

        PRINTABLE_KEYS: {
           32: ' ',  48: '0',  49: '1',  50: '2',  51: '3',  52: '4', 53:  '5',
           54: '6',  55: '7',  56: '8',  57: '9',  59: ';',  61: '=', 65:  'a',
           66: 'b',  67: 'c',  68: 'd',  69: 'e',  70: 'f',  71: 'g', 72:  'h',
           73: 'i',  74: 'j',  75: 'k',  76: 'l',  77: 'm',  78: 'n', 79:  'o',
           80: 'p',  81: 'q',  82: 'r',  83: 's',  84: 't',  85: 'u', 86:  'v',
           87: 'w',  88: 'x',  89: 'y',  90: 'z', 107: '+', 109: '-', 110: '.',
          186: ';', 187: '=', 188: ',', 189: '-', 190: '.', 191: '/', 192: '`',
          219: '[', 220: '\\',221: ']', 222: "'", 111: '/', 106: '*'
        }
    };
    var name, i;
    for (i in ret.FUNCTION_KEYS) {
        name = ret.FUNCTION_KEYS[i].toLowerCase();
        ret[name] = parseInt(i, 10);
    }
    for (i in ret.PRINTABLE_KEYS) {
        name = ret.PRINTABLE_KEYS[i].toLowerCase();
        ret[name] = parseInt(i, 10);
    }
    oop.mixin(ret, ret.MODIFIER_KEYS);
    oop.mixin(ret, ret.PRINTABLE_KEYS);
    oop.mixin(ret, ret.FUNCTION_KEYS);
    ret.enter = ret["return"];
    ret.escape = ret.esc;
    ret.del = ret["delete"];
    ret[173] = '-';
    
    (function() {
        var mods = ["cmd", "ctrl", "alt", "shift"];
        for (var i = Math.pow(2, mods.length); i--;) {            
            ret.KEY_MODS[i] = mods.filter(function(x) {
                return i & ret.KEY_MODS[x];
            }).join("-") + "-";
        }
    })();

    ret.KEY_MODS[0] = "";
    ret.KEY_MODS[-1] = "input-";

    return ret;
})();
oop.mixin(exports, Keys);

exports.keyCodeToString = function(keyCode) {
    var keyString = Keys[keyCode];
    if (typeof keyString != "string")
        keyString = String.fromCharCode(keyCode);
    return keyString.toLowerCase();
};

});

ace.define("ace/lib/useragent",["require","exports","module"], function(acequire, exports, module) {
"use strict";
exports.OS = {
    LINUX: "LINUX",
    MAC: "MAC",
    WINDOWS: "WINDOWS"
};
exports.getOS = function() {
    if (exports.isMac) {
        return exports.OS.MAC;
    } else if (exports.isLinux) {
        return exports.OS.LINUX;
    } else {
        return exports.OS.WINDOWS;
    }
};
if (typeof navigator != "object")
    return;

var os = (navigator.platform.match(/mac|win|linux/i) || ["other"])[0].toLowerCase();
var ua = navigator.userAgent;
exports.isWin = (os == "win");
exports.isMac = (os == "mac");
exports.isLinux = (os == "linux");
exports.isIE = 
    (navigator.appName == "Microsoft Internet Explorer" || navigator.appName.indexOf("MSAppHost") >= 0)
    ? parseFloat((ua.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1])
    : parseFloat((ua.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]); // for ie
    
exports.isOldIE = exports.isIE && exports.isIE < 9;
exports.isGecko = exports.isMozilla = (window.Controllers || window.controllers) && window.navigator.product === "Gecko";
exports.isOldGecko = exports.isGecko && parseInt((ua.match(/rv:(\d+)/)||[])[1], 10) < 4;
exports.isOpera = window.opera && Object.prototype.toString.call(window.opera) == "[object Opera]";
exports.isWebKit = parseFloat(ua.split("WebKit/")[1]) || undefined;

exports.isChrome = parseFloat(ua.split(" Chrome/")[1]) || undefined;

exports.isAIR = ua.indexOf("AdobeAIR") >= 0;

exports.isIPad = ua.indexOf("iPad") >= 0;

exports.isChromeOS = ua.indexOf(" CrOS ") >= 0;

exports.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

if (exports.isIOS) exports.isMac = true;

});

ace.define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var keys = acequire("./keys");
var useragent = acequire("./useragent");

var pressedKeys = null;
var ts = 0;

exports.addListener = function(elem, type, callback) {
    if (elem.addEventListener) {
        return elem.addEventListener(type, callback, false);
    }
    if (elem.attachEvent) {
        var wrapper = function() {
            callback.call(elem, window.event);
        };
        callback._wrapper = wrapper;
        elem.attachEvent("on" + type, wrapper);
    }
};

exports.removeListener = function(elem, type, callback) {
    if (elem.removeEventListener) {
        return elem.removeEventListener(type, callback, false);
    }
    if (elem.detachEvent) {
        elem.detachEvent("on" + type, callback._wrapper || callback);
    }
};
exports.stopEvent = function(e) {
    exports.stopPropagation(e);
    exports.preventDefault(e);
    return false;
};

exports.stopPropagation = function(e) {
    if (e.stopPropagation)
        e.stopPropagation();
    else
        e.cancelBubble = true;
};

exports.preventDefault = function(e) {
    if (e.preventDefault)
        e.preventDefault();
    else
        e.returnValue = false;
};
exports.getButton = function(e) {
    if (e.type == "dblclick")
        return 0;
    if (e.type == "contextmenu" || (useragent.isMac && (e.ctrlKey && !e.altKey && !e.shiftKey)))
        return 2;
    if (e.preventDefault) {
        return e.button;
    }
    else {
        return {1:0, 2:2, 4:1}[e.button];
    }
};

exports.capture = function(el, eventHandler, releaseCaptureHandler) {
    function onMouseUp(e) {
        eventHandler && eventHandler(e);
        releaseCaptureHandler && releaseCaptureHandler(e);

        exports.removeListener(document, "mousemove", eventHandler, true);
        exports.removeListener(document, "mouseup", onMouseUp, true);
        exports.removeListener(document, "dragstart", onMouseUp, true);
    }

    exports.addListener(document, "mousemove", eventHandler, true);
    exports.addListener(document, "mouseup", onMouseUp, true);
    exports.addListener(document, "dragstart", onMouseUp, true);
    
    return onMouseUp;
};

exports.addTouchMoveListener = function (el, callback) {
    var startx, starty;
    exports.addListener(el, "touchstart", function (e) {
        var touches = e.touches;
        var touchObj = touches[0];
        startx = touchObj.clientX;
        starty = touchObj.clientY;
    });
    exports.addListener(el, "touchmove", function (e) {
        var touches = e.touches;
        if (touches.length > 1) return;

        var touchObj = touches[0];

        e.wheelX = startx - touchObj.clientX;
        e.wheelY = starty - touchObj.clientY;

        startx = touchObj.clientX;
        starty = touchObj.clientY;

        callback(e);
    });
};

exports.addMouseWheelListener = function(el, callback) {
    if ("onmousewheel" in el) {
        exports.addListener(el, "mousewheel", function(e) {
            var factor = 8;
            if (e.wheelDeltaX !== undefined) {
                e.wheelX = -e.wheelDeltaX / factor;
                e.wheelY = -e.wheelDeltaY / factor;
            } else {
                e.wheelX = 0;
                e.wheelY = -e.wheelDelta / factor;
            }
            callback(e);
        });
    } else if ("onwheel" in el) {
        exports.addListener(el, "wheel",  function(e) {
            var factor = 0.35;
            switch (e.deltaMode) {
                case e.DOM_DELTA_PIXEL:
                    e.wheelX = e.deltaX * factor || 0;
                    e.wheelY = e.deltaY * factor || 0;
                    break;
                case e.DOM_DELTA_LINE:
                case e.DOM_DELTA_PAGE:
                    e.wheelX = (e.deltaX || 0) * 5;
                    e.wheelY = (e.deltaY || 0) * 5;
                    break;
            }
            
            callback(e);
        });
    } else {
        exports.addListener(el, "DOMMouseScroll", function(e) {
            if (e.axis && e.axis == e.HORIZONTAL_AXIS) {
                e.wheelX = (e.detail || 0) * 5;
                e.wheelY = 0;
            } else {
                e.wheelX = 0;
                e.wheelY = (e.detail || 0) * 5;
            }
            callback(e);
        });
    }
};

exports.addMultiMouseDownListener = function(elements, timeouts, eventHandler, callbackName) {
    var clicks = 0;
    var startX, startY, timer; 
    var eventNames = {
        2: "dblclick",
        3: "tripleclick",
        4: "quadclick"
    };

    function onMousedown(e) {
        if (exports.getButton(e) !== 0) {
            clicks = 0;
        } else if (e.detail > 1) {
            clicks++;
            if (clicks > 4)
                clicks = 1;
        } else {
            clicks = 1;
        }
        if (useragent.isIE) {
            var isNewClick = Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5;
            if (!timer || isNewClick)
                clicks = 1;
            if (timer)
                clearTimeout(timer);
            timer = setTimeout(function() {timer = null;}, timeouts[clicks - 1] || 600);

            if (clicks == 1) {
                startX = e.clientX;
                startY = e.clientY;
            }
        }
        
        e._clicks = clicks;

        eventHandler[callbackName]("mousedown", e);

        if (clicks > 4)
            clicks = 0;
        else if (clicks > 1)
            return eventHandler[callbackName](eventNames[clicks], e);
    }
    function onDblclick(e) {
        clicks = 2;
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(function() {timer = null;}, timeouts[clicks - 1] || 600);
        eventHandler[callbackName]("mousedown", e);
        eventHandler[callbackName](eventNames[clicks], e);
    }
    if (!Array.isArray(elements))
        elements = [elements];
    elements.forEach(function(el) {
        exports.addListener(el, "mousedown", onMousedown);
        if (useragent.isOldIE)
            exports.addListener(el, "dblclick", onDblclick);
    });
};

var getModifierHash = useragent.isMac && useragent.isOpera && !("KeyboardEvent" in window)
    ? function(e) {
        return 0 | (e.metaKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.ctrlKey ? 8 : 0);
    }
    : function(e) {
        return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
    };

exports.getModifierString = function(e) {
    return keys.KEY_MODS[getModifierHash(e)];
};

function normalizeCommandKeys(callback, e, keyCode) {
    var hashId = getModifierHash(e);

    if (!useragent.isMac && pressedKeys) {
        if (e.getModifierState && (e.getModifierState("OS") || e.getModifierState("Win")))
            hashId |= 8;
        if (pressedKeys.altGr) {
            if ((3 & hashId) != 3)
                pressedKeys.altGr = 0;
            else
                return;
        }
        if (keyCode === 18 || keyCode === 17) {
            var location = "location" in e ? e.location : e.keyLocation;
            if (keyCode === 17 && location === 1) {
                if (pressedKeys[keyCode] == 1)
                    ts = e.timeStamp;
            } else if (keyCode === 18 && hashId === 3 && location === 2) {
                var dt = e.timeStamp - ts;
                if (dt < 50)
                    pressedKeys.altGr = true;
            }
        }
    }
    
    if (keyCode in keys.MODIFIER_KEYS) {
        keyCode = -1;
    }
    if (hashId & 8 && (keyCode >= 91 && keyCode <= 93)) {
        keyCode = -1;
    }
    
    if (!hashId && keyCode === 13) {
        var location = "location" in e ? e.location : e.keyLocation;
        if (location === 3) {
            callback(e, hashId, -keyCode);
            if (e.defaultPrevented)
                return;
        }
    }
    
    if (useragent.isChromeOS && hashId & 8) {
        callback(e, hashId, keyCode);
        if (e.defaultPrevented)
            return;
        else
            hashId &= ~8;
    }
    if (!hashId && !(keyCode in keys.FUNCTION_KEYS) && !(keyCode in keys.PRINTABLE_KEYS)) {
        return false;
    }
    
    return callback(e, hashId, keyCode);
}


exports.addCommandKeyListener = function(el, callback) {
    var addListener = exports.addListener;
    if (useragent.isOldGecko || (useragent.isOpera && !("KeyboardEvent" in window))) {
        var lastKeyDownKeyCode = null;
        addListener(el, "keydown", function(e) {
            lastKeyDownKeyCode = e.keyCode;
        });
        addListener(el, "keypress", function(e) {
            return normalizeCommandKeys(callback, e, lastKeyDownKeyCode);
        });
    } else {
        var lastDefaultPrevented = null;

        addListener(el, "keydown", function(e) {
            pressedKeys[e.keyCode] = (pressedKeys[e.keyCode] || 0) + 1;
            var result = normalizeCommandKeys(callback, e, e.keyCode);
            lastDefaultPrevented = e.defaultPrevented;
            return result;
        });

        addListener(el, "keypress", function(e) {
            if (lastDefaultPrevented && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey)) {
                exports.stopEvent(e);
                lastDefaultPrevented = null;
            }
        });

        addListener(el, "keyup", function(e) {
            pressedKeys[e.keyCode] = null;
        });

        if (!pressedKeys) {
            resetPressedKeys();
            addListener(window, "focus", resetPressedKeys);
        }
    }
};
function resetPressedKeys() {
    pressedKeys = Object.create(null);
}

if (typeof window == "object" && window.postMessage && !useragent.isOldIE) {
    var postMessageId = 1;
    exports.nextTick = function(callback, win) {
        win = win || window;
        var messageName = "zero-timeout-message-" + postMessageId;
        exports.addListener(win, "message", function listener(e) {
            if (e.data == messageName) {
                exports.stopPropagation(e);
                exports.removeListener(win, "message", listener);
                callback();
            }
        });
        win.postMessage(messageName, "*");
    };
}


exports.nextFrame = typeof window == "object" && (window.requestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.msRequestAnimationFrame
    || window.oRequestAnimationFrame);

if (exports.nextFrame)
    exports.nextFrame = exports.nextFrame.bind(window);
else
    exports.nextFrame = function(callback) {
        setTimeout(callback, 17);
    };
});

ace.define("ace/lib/lang",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.last = function(a) {
    return a[a.length - 1];
};

exports.stringReverse = function(string) {
    return string.split("").reverse().join("");
};

exports.stringRepeat = function (string, count) {
    var result = '';
    while (count > 0) {
        if (count & 1)
            result += string;

        if (count >>= 1)
            string += string;
    }
    return result;
};

var trimBeginRegexp = /^\s\s*/;
var trimEndRegexp = /\s\s*$/;

exports.stringTrimLeft = function (string) {
    return string.replace(trimBeginRegexp, '');
};

exports.stringTrimRight = function (string) {
    return string.replace(trimEndRegexp, '');
};

exports.copyObject = function(obj) {
    var copy = {};
    for (var key in obj) {
        copy[key] = obj[key];
    }
    return copy;
};

exports.copyArray = function(array){
    var copy = [];
    for (var i=0, l=array.length; i<l; i++) {
        if (array[i] && typeof array[i] == "object")
            copy[i] = this.copyObject(array[i]);
        else 
            copy[i] = array[i];
    }
    return copy;
};

exports.deepCopy = function deepCopy(obj) {
    if (typeof obj !== "object" || !obj)
        return obj;
    var copy;
    if (Array.isArray(obj)) {
        copy = [];
        for (var key = 0; key < obj.length; key++) {
            copy[key] = deepCopy(obj[key]);
        }
        return copy;
    }
    if (Object.prototype.toString.call(obj) !== "[object Object]")
        return obj;
    
    copy = {};
    for (var key in obj)
        copy[key] = deepCopy(obj[key]);
    return copy;
};

exports.arrayToMap = function(arr) {
    var map = {};
    for (var i=0; i<arr.length; i++) {
        map[arr[i]] = 1;
    }
    return map;

};

exports.createMap = function(props) {
    var map = Object.create(null);
    for (var i in props) {
        map[i] = props[i];
    }
    return map;
};
exports.arrayRemove = function(array, value) {
  for (var i = 0; i <= array.length; i++) {
    if (value === array[i]) {
      array.splice(i, 1);
    }
  }
};

exports.escapeRegExp = function(str) {
    return str.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
};

exports.escapeHTML = function(str) {
    return str.replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
};

exports.getMatchOffsets = function(string, regExp) {
    var matches = [];

    string.replace(regExp, function(str) {
        matches.push({
            offset: arguments[arguments.length-2],
            length: str.length
        });
    });

    return matches;
};
exports.deferredCall = function(fcn) {
    var timer = null;
    var callback = function() {
        timer = null;
        fcn();
    };

    var deferred = function(timeout) {
        deferred.cancel();
        timer = setTimeout(callback, timeout || 0);
        return deferred;
    };

    deferred.schedule = deferred;

    deferred.call = function() {
        this.cancel();
        fcn();
        return deferred;
    };

    deferred.cancel = function() {
        clearTimeout(timer);
        timer = null;
        return deferred;
    };
    
    deferred.isPending = function() {
        return timer;
    };

    return deferred;
};


exports.delayedCall = function(fcn, defaultTimeout) {
    var timer = null;
    var callback = function() {
        timer = null;
        fcn();
    };

    var _self = function(timeout) {
        if (timer == null)
            timer = setTimeout(callback, timeout || defaultTimeout);
    };

    _self.delay = function(timeout) {
        timer && clearTimeout(timer);
        timer = setTimeout(callback, timeout || defaultTimeout);
    };
    _self.schedule = _self;

    _self.call = function() {
        this.cancel();
        fcn();
    };

    _self.cancel = function() {
        timer && clearTimeout(timer);
        timer = null;
    };

    _self.isPending = function() {
        return timer;
    };

    return _self;
};
});

ace.define("ace/keyboard/textinput_ios",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang","ace/lib/keys"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var KEYS = acequire("../lib/keys");
var MODS = KEYS.KEY_MODS;
var BROKEN_SETDATA = useragent.isChrome < 18;
var USE_IE_MIME_TYPE =  useragent.isIE;

var TextInput = function(parentNode, host) {
    var self = this;
    var text = dom.createElement("textarea");
    text.className = useragent.isIOS ? "ace_text-input ace_text-input-ios" : "ace_text-input";

    if (useragent.isTouchPad)
        text.setAttribute("x-palm-disable-auto-cap", true);

    text.setAttribute("wrap", "off");
    text.setAttribute("autocorrect", "off");
    text.setAttribute("autocapitalize", "off");
    text.setAttribute("spellcheck", false);

    text.style.opacity = "0";
    parentNode.insertBefore(text, parentNode.firstChild);

    var PLACEHOLDER = "\n aaaa a\n";

    var copied = false;
    var cut = false;
    var pasted = false;
    var inComposition = false;
    var tempStyle = '';
    var isSelectionEmpty = true;
    try { var isFocused = document.activeElement === text; } catch(e) {}

    event.addListener(text, "blur", function(e) {
        host.onBlur(e);
        isFocused = false;
    });
    event.addListener(text, "focus", function(e) {
        isFocused = true;
        host.onFocus(e);
        resetSelection();
    });
    this.focus = function() {
        if (tempStyle) return text.focus();
        text.style.position = "fixed";
        text.focus();
    };
    this.blur = function() {
        text.blur();
    };
    this.isFocused = function() {
        return isFocused;
    };
    var syncSelection = lang.delayedCall(function() {
        isFocused && resetSelection(isSelectionEmpty);
    });
    var syncValue = lang.delayedCall(function() {
         if (!inComposition) {
            text.value = PLACEHOLDER;
            isFocused && resetSelection();
         }
    });

    function resetSelection(isEmpty) {
        if (inComposition)
            return;
        inComposition = true;

        if (inputHandler) {
            selectionStart = 0;
            selectionEnd = isEmpty ? 0 : text.value.length - 1;
        } else {
            var selectionStart = 4;
            var selectionEnd = 5;
        }
        try {
            text.setSelectionRange(selectionStart, selectionEnd);
        } catch(e) {}

        inComposition = false;
    }

    function resetValue() {
        if (inComposition)
            return;
        text.value = PLACEHOLDER;
        if (useragent.isWebKit)
            syncValue.schedule();
    }

    useragent.isWebKit || host.addEventListener('changeSelection', function() {
        if (host.selection.isEmpty() != isSelectionEmpty) {
            isSelectionEmpty = !isSelectionEmpty;
            syncSelection.schedule();
        }
    });

    resetValue();
    if (isFocused)
        host.onFocus();


    var isAllSelected = function(text) {
        return text.selectionStart === 0 && text.selectionEnd === text.value.length;
    };

    var onSelect = function(e) {
        if (isAllSelected(text)) {
            host.selectAll();
            resetSelection();
        } else if (inputHandler) {
            resetSelection(host.selection.isEmpty());
        }
    };

    var inputHandler = null;
    this.setInputHandler = function(cb) {inputHandler = cb;};
    this.getInputHandler = function() {return inputHandler;};
    var afterContextMenu = false;

    var sendText = function(data) {
        if (text.selectionStart === 4 && text.selectionEnd === 5) {
          return;
        }
        if (inputHandler) {
            data = inputHandler(data);
            inputHandler = null;
        }
        if (pasted) {
            resetSelection();
            if (data)
                host.onPaste(data);
            pasted = false;
        } else if (data == PLACEHOLDER.substr(0) && text.selectionStart === 4) {
            if (afterContextMenu)
                host.execCommand("del", {source: "ace"});
            else // some versions of android do not fire keydown when pressing backspace
                host.execCommand("backspace", {source: "ace"});
        } else if (!copied) {
            if (data.substring(0, 9) == PLACEHOLDER && data.length > PLACEHOLDER.length)
                data = data.substr(9);
            else if (data.substr(0, 4) == PLACEHOLDER.substr(0, 4))
                data = data.substr(4, data.length - PLACEHOLDER.length + 1);
            else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);
            if (data == PLACEHOLDER.charAt(0)) {
            } else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);

            if (data)
                host.onTextInput(data);
        }
        if (copied) {
          copied = false;
        }
        if (afterContextMenu)
            afterContextMenu = false;
    };
    var onInput = function(e) {
        if (inComposition)
            return;
        var data = text.value;
        sendText(data);
        resetValue();
    };

    var handleClipboardData = function(e, data, forceIEMime) {
        var clipboardData = e.clipboardData || window.clipboardData;
        if (!clipboardData || BROKEN_SETDATA)
            return;
        var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
        try {
            if (data) {
                return clipboardData.setData(mime, data) !== false;
            } else {
                return clipboardData.getData(mime);
            }
        } catch(e) {
            if (!forceIEMime)
                return handleClipboardData(e, data, true);
        }
    };

    var doCopy = function(e, isCut) {
        var data = host.getCopyText();
        if (!data)
            return event.preventDefault(e);

        if (handleClipboardData(e, data)) {
            if (useragent.isIOS) {
                cut = isCut;
                text.value = "\n aa" + data + "a a\n";
                text.setSelectionRange(4, 4 + data.length);
                copied = {
                    value: data
                };
            }
            isCut ? host.onCut() : host.onCopy();
            if (!useragent.isIOS) event.preventDefault(e);
        } else {
            copied = true;
            text.value = data;
            text.select();
            setTimeout(function(){
                copied = false;
                resetValue();
                resetSelection();
                isCut ? host.onCut() : host.onCopy();
            });
        }
    };

    var onCut = function(e) {
        doCopy(e, true);
    };

    var onCopy = function(e) {
        doCopy(e, false);
    };

    var onPaste = function(e) {
        var data = handleClipboardData(e);
        if (typeof data == "string") {
            if (data)
                host.onPaste(data, e);
            if (useragent.isIE)
                setTimeout(resetSelection);
            event.preventDefault(e);
        }
        else {
            text.value = "";
            pasted = true;
        }
    };

    event.addCommandKeyListener(text, host.onCommandKey.bind(host));

    event.addListener(text, "select", onSelect);

    event.addListener(text, "input", onInput);

    event.addListener(text, "cut", onCut);
    event.addListener(text, "copy", onCopy);
    event.addListener(text, "paste", onPaste);
    var onCompositionStart = function(e) {
        if (inComposition || !host.onCompositionStart || host.$readOnly)
            return;
        inComposition = {};
        inComposition.canUndo = host.session.$undoManager;
        host.onCompositionStart();
        setTimeout(onCompositionUpdate, 0);
        host.on("mousedown", onCompositionEnd);
        if (inComposition.canUndo && !host.selection.isEmpty()) {
            host.insert("");
            host.session.markUndoGroup();
            host.selection.clearSelection();
        }
        host.session.markUndoGroup();
    };

    var onCompositionUpdate = function() {
        if (!inComposition || !host.onCompositionUpdate || host.$readOnly)
            return;
        var val = text.value.replace(/\x01/g, "");
        if (inComposition.lastValue === val) return;

        host.onCompositionUpdate(val);
        if (inComposition.lastValue)
            host.undo();
        if (inComposition.canUndo)
            inComposition.lastValue = val;
        if (inComposition.lastValue) {
            var r = host.selection.getRange();
            host.insert(inComposition.lastValue);
            host.session.markUndoGroup();
            inComposition.range = host.selection.getRange();
            host.selection.setRange(r);
            host.selection.clearSelection();
        }
    };

    var onCompositionEnd = function(e) {
        if (!host.onCompositionEnd || host.$readOnly) return;
        var c = inComposition;
        inComposition = false;
        var timer = setTimeout(function() {
            timer = null;
            var str = text.value.replace(/\x01/g, "");
            if (inComposition)
                return;
            else if (str == c.lastValue)
                resetValue();
            else if (!c.lastValue && str) {
                resetValue();
                sendText(str);
            }
        });
        inputHandler = function compositionInputHandler(str) {
            if (timer)
                clearTimeout(timer);
            str = str.replace(/\x01/g, "");
            if (str == c.lastValue)
                return "";
            if (c.lastValue && timer)
                host.undo();
            return str;
        };
        host.onCompositionEnd();
        host.removeListener("mousedown", onCompositionEnd);
        if (e.type == "compositionend" && c.range) {
            host.selection.setRange(c.range);
        }
        var needsOnInput =
            (!!useragent.isChrome && useragent.isChrome >= 53) ||
            (!!useragent.isWebKit && useragent.isWebKit >= 603);

        if (needsOnInput) {
          onInput();
        }
    };



    var syncComposition = lang.delayedCall(onCompositionUpdate, 50);

    event.addListener(text, "compositionstart", onCompositionStart);
    if (useragent.isGecko) {
        event.addListener(text, "text", function(){syncComposition.schedule();});
    } else {
        event.addListener(text, "keyup", function(){syncComposition.schedule();});
        event.addListener(text, "keydown", function(){syncComposition.schedule();});
    }
    event.addListener(text, "compositionend", onCompositionEnd);

    this.getElement = function() {
        return text;
    };

    this.setReadOnly = function(readOnly) {
       text.readOnly = readOnly;
    };

    this.onContextMenu = function(e) {
        afterContextMenu = true;
        resetSelection(host.selection.isEmpty());
        host._emit("nativecontextmenu", {target: host, domEvent: e});
        this.moveToMouse(e, true);
    };

    this.moveToMouse = function(e, bringToFront) {
        if (!tempStyle)
            tempStyle = text.style.cssText;
        text.style.cssText = (bringToFront ? "z-index:100000;" : "")
            + "height:" + text.style.height + ";"
            + (useragent.isIE ? "opacity:0.1;" : "");

        var rect = host.container.getBoundingClientRect();
        var style = dom.computedStyle(host.container);
        var top = rect.top + (parseInt(style.borderTopWidth) || 0);
        var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
        var maxTop = rect.bottom - top - text.clientHeight -2;
        var move = function(e) {
            text.style.left = e.clientX - left - 2 + "px";
            text.style.top = Math.min(e.clientY - top - 2, maxTop) + "px";
        };
        move(e);

        if (e.type != "mousedown")
            return;

        if (host.renderer.$keepTextAreaAtCursor)
            host.renderer.$keepTextAreaAtCursor = null;

        clearTimeout(closeTimeout);
        if (useragent.isWin)
            event.capture(host.container, move, onContextMenuClose);
    };

    this.onContextMenuClose = onContextMenuClose;
    var closeTimeout;
    function onContextMenuClose() {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(function () {
            if (tempStyle) {
                text.style.cssText = tempStyle;
                tempStyle = '';
            }
            if (host.renderer.$keepTextAreaAtCursor == null) {
                host.renderer.$keepTextAreaAtCursor = true;
                host.renderer.$moveTextAreaToCursor();
            }
        }, 0);
    }

    var onContextMenu = function(e) {
        host.textInput.onContextMenu(e);
        onContextMenuClose();
    };
    event.addListener(text, "mouseup", onContextMenu);
    event.addListener(text, "mousedown", function(e) {
        e.preventDefault();
        onContextMenuClose();
    });
    event.addListener(host.renderer.scroller, "contextmenu", onContextMenu);
    event.addListener(text, "contextmenu", onContextMenu);

    if (useragent.isIOS) {
        var typingResetTimeout = null;
        var typing = false;

        parentNode.addEventListener("keydown", function (e) {
            if (typingResetTimeout) clearTimeout(typingResetTimeout);
            typing = true;
        });

        parentNode.addEventListener("keyup", function (e) {
            typingResetTimeout = setTimeout(function () {
                typing = false;
            }, 100);
        });
        var detectArrowKeys = function(e) {
            if (document.activeElement !== text) return;
            if (typing) return;

            if (cut) {
                return setTimeout(function () {
                    cut = false;
                }, 100);
            }
            var selectionStart = text.selectionStart;
            var selectionEnd = text.selectionEnd;
            text.setSelectionRange(4, 5);
            if (selectionStart == selectionEnd) {
                switch (selectionStart) {
                    case 0: host.onCommandKey(null, 0, KEYS.up); break;
                    case 1: host.onCommandKey(null, 0, KEYS.home); break;
                    case 2: host.onCommandKey(null, MODS.option, KEYS.left); break;
                    case 4: host.onCommandKey(null, 0, KEYS.left); break;
                    case 5: host.onCommandKey(null, 0, KEYS.right); break;
                    case 7: host.onCommandKey(null, MODS.option, KEYS.right); break;
                    case 8: host.onCommandKey(null, 0, KEYS.end); break;
                    case 9: host.onCommandKey(null, 0, KEYS.down); break;
                }
            } else {
                switch (selectionEnd) {
                    case 6: host.onCommandKey(null, MODS.shift, KEYS.right); break;
                    case 7: host.onCommandKey(null, MODS.shift | MODS.option, KEYS.right); break;
                    case 8: host.onCommandKey(null, MODS.shift, KEYS.end); break;
                    case 9: host.onCommandKey(null, MODS.shift, KEYS.down); break;
                }
                switch (selectionStart) {
                    case 0: host.onCommandKey(null, MODS.shift, KEYS.up); break;
                    case 1: host.onCommandKey(null, MODS.shift, KEYS.home); break;
                    case 2: host.onCommandKey(null, MODS.shift | MODS.option, KEYS.left); break;
                    case 3: host.onCommandKey(null, MODS.shift, KEYS.left); break;
                }
            }
        };
        document.addEventListener("selectionchange", detectArrowKeys);
        host.on("destroy", function() {
            document.removeEventListener("selectionchange", detectArrowKeys);
        });
    }
};

exports.TextInput = TextInput;
});

ace.define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang","ace/keyboard/textinput_ios"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var BROKEN_SETDATA = useragent.isChrome < 18;
var USE_IE_MIME_TYPE =  useragent.isIE;

var TextInputIOS = acequire("./textinput_ios").TextInput;
var TextInput = function(parentNode, host) {
    if (useragent.isIOS)
        return TextInputIOS.call(this, parentNode, host);

    var text = dom.createElement("textarea");
    text.className = "ace_text-input";

    text.setAttribute("wrap", "off");
    text.setAttribute("autocorrect", "off");
    text.setAttribute("autocapitalize", "off");
    text.setAttribute("spellcheck", false);

    text.style.opacity = "0";
    parentNode.insertBefore(text, parentNode.firstChild);

    var PLACEHOLDER = "\u2028\u2028";

    var copied = false;
    var pasted = false;
    var inComposition = false;
    var tempStyle = '';
    var isSelectionEmpty = true;
    try { var isFocused = document.activeElement === text; } catch(e) {}
    
    event.addListener(text, "blur", function(e) {
        host.onBlur(e);
        isFocused = false;
    });
    event.addListener(text, "focus", function(e) {
        isFocused = true;
        host.onFocus(e);
        resetSelection();
    });
    this.focus = function() {
        if (tempStyle) return text.focus();
        var top = text.style.top;
        text.style.position = "fixed";
        text.style.top = "0px";
        text.focus();
        setTimeout(function() {
            text.style.position = "";
            if (text.style.top == "0px")
                text.style.top = top;
        }, 0);
    };
    this.blur = function() {
        text.blur();
    };
    this.isFocused = function() {
        return isFocused;
    };
    var syncSelection = lang.delayedCall(function() {
        isFocused && resetSelection(isSelectionEmpty);
    });
    var syncValue = lang.delayedCall(function() {
         if (!inComposition) {
            text.value = PLACEHOLDER;
            isFocused && resetSelection();
         }
    });

    function resetSelection(isEmpty) {
        if (inComposition)
            return;
        inComposition = true;
        
        if (inputHandler) {
            var selectionStart = 0;
            var selectionEnd = isEmpty ? 0 : text.value.length - 1;
        } else {
            var selectionStart = isEmpty ? 2 : 1;
            var selectionEnd = 2;
        }
        try {
            text.setSelectionRange(selectionStart, selectionEnd);
        } catch(e){}
        
        inComposition = false;
    }

    function resetValue() {
        if (inComposition)
            return;
        text.value = PLACEHOLDER;
        if (useragent.isWebKit)
            syncValue.schedule();
    }

    useragent.isWebKit || host.addEventListener('changeSelection', function() {
        if (host.selection.isEmpty() != isSelectionEmpty) {
            isSelectionEmpty = !isSelectionEmpty;
            syncSelection.schedule();
        }
    });

    resetValue();
    if (isFocused)
        host.onFocus();


    var isAllSelected = function(text) {
        return text.selectionStart === 0 && text.selectionEnd === text.value.length;
    };

    var onSelect = function(e) {
        if (copied) {
            copied = false;
        } else if (isAllSelected(text)) {
            host.selectAll();
            resetSelection();
        } else if (inputHandler) {
            resetSelection(host.selection.isEmpty());
        }
    };

    var inputHandler = null;
    this.setInputHandler = function(cb) {inputHandler = cb;};
    this.getInputHandler = function() {return inputHandler;};
    var afterContextMenu = false;
    
    var sendText = function(data) {
        if (inputHandler) {
            data = inputHandler(data);
            inputHandler = null;
        }
        if (pasted) {
            resetSelection();
            if (data)
                host.onPaste(data);
            pasted = false;
        } else if (data == PLACEHOLDER.charAt(0)) {
            if (afterContextMenu)
                host.execCommand("del", {source: "ace"});
            else // some versions of android do not fire keydown when pressing backspace
                host.execCommand("backspace", {source: "ace"});
        } else {
            if (data.substring(0, 2) == PLACEHOLDER)
                data = data.substr(2);
            else if (data.charAt(0) == PLACEHOLDER.charAt(0))
                data = data.substr(1);
            else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);
            if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);
            
            if (data)
                host.onTextInput(data);
        }
        if (afterContextMenu)
            afterContextMenu = false;
    };
    var onInput = function(e) {
        if (inComposition)
            return;
        var data = text.value;
        sendText(data);
        resetValue();
    };
    
    var handleClipboardData = function(e, data, forceIEMime) {
        var clipboardData = e.clipboardData || window.clipboardData;
        if (!clipboardData || BROKEN_SETDATA)
            return;
        var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
        try {
            if (data) {
                return clipboardData.setData(mime, data) !== false;
            } else {
                return clipboardData.getData(mime);
            }
        } catch(e) {
            if (!forceIEMime)
                return handleClipboardData(e, data, true);
        }
    };

    var doCopy = function(e, isCut) {
        var data = host.getCopyText();
        if (!data)
            return event.preventDefault(e);

        if (handleClipboardData(e, data)) {
            isCut ? host.onCut() : host.onCopy();
            event.preventDefault(e);
        } else {
            copied = true;
            text.value = data;
            text.select();
            setTimeout(function(){
                copied = false;
                resetValue();
                resetSelection();
                isCut ? host.onCut() : host.onCopy();
            });
        }
    };
    
    var onCut = function(e) {
        doCopy(e, true);
    };
    
    var onCopy = function(e) {
        doCopy(e, false);
    };
    
    var onPaste = function(e) {
        var data = handleClipboardData(e);
        if (typeof data == "string") {
            if (data)
                host.onPaste(data, e);
            if (useragent.isIE)
                setTimeout(resetSelection);
            event.preventDefault(e);
        }
        else {
            text.value = "";
            pasted = true;
        }
    };

    event.addCommandKeyListener(text, host.onCommandKey.bind(host));

    event.addListener(text, "select", onSelect);

    event.addListener(text, "input", onInput);

    event.addListener(text, "cut", onCut);
    event.addListener(text, "copy", onCopy);
    event.addListener(text, "paste", onPaste);
    if (!('oncut' in text) || !('oncopy' in text) || !('onpaste' in text)) {
        event.addListener(parentNode, "keydown", function(e) {
            if ((useragent.isMac && !e.metaKey) || !e.ctrlKey)
                return;

            switch (e.keyCode) {
                case 67:
                    onCopy(e);
                    break;
                case 86:
                    onPaste(e);
                    break;
                case 88:
                    onCut(e);
                    break;
            }
        });
    }
    var onCompositionStart = function(e) {
        if (inComposition || !host.onCompositionStart || host.$readOnly) 
            return;
        inComposition = {};
        inComposition.canUndo = host.session.$undoManager;
        host.onCompositionStart();
        setTimeout(onCompositionUpdate, 0);
        host.on("mousedown", onCompositionEnd);
        if (inComposition.canUndo && !host.selection.isEmpty()) {
            host.insert("");
            host.session.markUndoGroup();
            host.selection.clearSelection();
        }
        host.session.markUndoGroup();
    };

    var onCompositionUpdate = function() {
        if (!inComposition || !host.onCompositionUpdate || host.$readOnly)
            return;
        var val = text.value.replace(/\u2028/g, "");
        if (inComposition.lastValue === val) return;
        
        host.onCompositionUpdate(val);
        if (inComposition.lastValue)
            host.undo();
        if (inComposition.canUndo)
            inComposition.lastValue = val;
        if (inComposition.lastValue) {
            var r = host.selection.getRange();
            host.insert(inComposition.lastValue);
            host.session.markUndoGroup();
            inComposition.range = host.selection.getRange();
            host.selection.setRange(r);
            host.selection.clearSelection();
        }
    };

    var onCompositionEnd = function(e) {
        if (!host.onCompositionEnd || host.$readOnly) return;
        var c = inComposition;
        inComposition = false;
        var timer = setTimeout(function() {
            timer = null;
            var str = text.value.replace(/\u2028/g, "");
            if (inComposition)
                return;
            else if (str == c.lastValue)
                resetValue();
            else if (!c.lastValue && str) {
                resetValue();
                sendText(str);
            }
        });
        inputHandler = function compositionInputHandler(str) {
            if (timer)
                clearTimeout(timer);
            str = str.replace(/\u2028/g, "");
            if (str == c.lastValue)
                return "";
            if (c.lastValue && timer)
                host.undo();
            return str;
        };
        host.onCompositionEnd();
        host.removeListener("mousedown", onCompositionEnd);
        if (e.type == "compositionend" && c.range) {
            host.selection.setRange(c.range);
        }
        var needsOnInput =
            (!!useragent.isChrome && useragent.isChrome >= 53) ||
            (!!useragent.isWebKit && useragent.isWebKit >= 603);

        if (needsOnInput) {
          onInput();
        }
    };
    
    

    var syncComposition = lang.delayedCall(onCompositionUpdate, 50);

    event.addListener(text, "compositionstart", onCompositionStart);
    if (useragent.isGecko) {
        event.addListener(text, "text", function(){syncComposition.schedule();});
    } else {
        event.addListener(text, "keyup", function(){syncComposition.schedule();});
        event.addListener(text, "keydown", function(){syncComposition.schedule();});
    }
    event.addListener(text, "compositionend", onCompositionEnd);

    this.getElement = function() {
        return text;
    };

    this.setReadOnly = function(readOnly) {
       text.readOnly = readOnly;
    };

    this.onContextMenu = function(e) {
        afterContextMenu = true;
        resetSelection(host.selection.isEmpty());
        host._emit("nativecontextmenu", {target: host, domEvent: e});
        this.moveToMouse(e, true);
    };
    
    this.moveToMouse = function(e, bringToFront) {
        if (!tempStyle)
            tempStyle = text.style.cssText;
        text.style.cssText = (bringToFront ? "z-index:100000;" : "")
            + "height:" + text.style.height + ";"
            + (useragent.isIE ? "opacity:0.1;" : "");

        var rect = host.container.getBoundingClientRect();
        var style = dom.computedStyle(host.container);
        var top = rect.top + (parseInt(style.borderTopWidth) || 0);
        var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
        var maxTop = rect.bottom - top - text.clientHeight -2;
        var move = function(e) {
            text.style.left = e.clientX - left - 2 + "px";
            text.style.top = Math.min(e.clientY - top - 2, maxTop) + "px";
        }; 
        move(e);

        if (e.type != "mousedown")
            return;

        if (host.renderer.$keepTextAreaAtCursor)
            host.renderer.$keepTextAreaAtCursor = null;

        clearTimeout(closeTimeout);
        if (useragent.isWin)
            event.capture(host.container, move, onContextMenuClose);
    };

    this.onContextMenuClose = onContextMenuClose;
    var closeTimeout;
    function onContextMenuClose() {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(function () {
            if (tempStyle) {
                text.style.cssText = tempStyle;
                tempStyle = '';
            }
            if (host.renderer.$keepTextAreaAtCursor == null) {
                host.renderer.$keepTextAreaAtCursor = true;
                host.renderer.$moveTextAreaToCursor();
            }
        }, 0);
    }

    var onContextMenu = function(e) {
        host.textInput.onContextMenu(e);
        onContextMenuClose();
    };
    event.addListener(text, "mouseup", onContextMenu);
    event.addListener(text, "mousedown", function(e) {
        e.preventDefault();
        onContextMenuClose();
    });
    event.addListener(host.renderer.scroller, "contextmenu", onContextMenu);
    event.addListener(text, "contextmenu", onContextMenu);
};

exports.TextInput = TextInput;
});

ace.define("ace/mouse/default_handlers",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");

var DRAG_OFFSET = 0; // pixels
var SCROLL_COOLDOWN_T = 250; // milliseconds

function DefaultHandlers(mouseHandler) {
    mouseHandler.$clickSelection = null;

    var editor = mouseHandler.editor;
    editor.setDefaultHandler("mousedown", this.onMouseDown.bind(mouseHandler));
    editor.setDefaultHandler("dblclick", this.onDoubleClick.bind(mouseHandler));
    editor.setDefaultHandler("tripleclick", this.onTripleClick.bind(mouseHandler));
    editor.setDefaultHandler("quadclick", this.onQuadClick.bind(mouseHandler));
    editor.setDefaultHandler("mousewheel", this.onMouseWheel.bind(mouseHandler));
    editor.setDefaultHandler("touchmove", this.onTouchMove.bind(mouseHandler));

    var exports = ["select", "startSelect", "selectEnd", "selectAllEnd", "selectByWordsEnd",
        "selectByLinesEnd", "dragWait", "dragWaitEnd", "focusWait"];

    exports.forEach(function(x) {
        mouseHandler[x] = this[x];
    }, this);

    mouseHandler.selectByLines = this.extendSelectionBy.bind(mouseHandler, "getLineRange");
    mouseHandler.selectByWords = this.extendSelectionBy.bind(mouseHandler, "getWordRange");
}

(function() {

    this.onMouseDown = function(ev) {
        var inSelection = ev.inSelection();
        var pos = ev.getDocumentPosition();
        this.mousedownEvent = ev;
        var editor = this.editor;

        var button = ev.getButton();
        if (button !== 0) {
            var selectionRange = editor.getSelectionRange();
            var selectionEmpty = selectionRange.isEmpty();
            editor.$blockScrolling++;
            if (selectionEmpty || button == 1)
                editor.selection.moveToPosition(pos);
            editor.$blockScrolling--;
            if (button == 2) {
                editor.textInput.onContextMenu(ev.domEvent);
                if (!useragent.isMozilla)
                    ev.preventDefault();
            }
            return;
        }

        this.mousedownEvent.time = Date.now();
        if (inSelection && !editor.isFocused()) {
            editor.focus();
            if (this.$focusTimout && !this.$clickSelection && !editor.inMultiSelectMode) {
                this.setState("focusWait");
                this.captureMouse(ev);
                return;
            }
        }

        this.captureMouse(ev);
        this.startSelect(pos, ev.domEvent._clicks > 1);
        return ev.preventDefault();
    };

    this.startSelect = function(pos, waitForClickSelection) {
        pos = pos || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
        var editor = this.editor;
        editor.$blockScrolling++;
        if (this.mousedownEvent.getShiftKey())
            editor.selection.selectToPosition(pos);
        else if (!waitForClickSelection)
            editor.selection.moveToPosition(pos);
        if (!waitForClickSelection)
            this.select();
        if (editor.renderer.scroller.setCapture) {
            editor.renderer.scroller.setCapture();
        }
        editor.setStyle("ace_selecting");
        this.setState("select");
        editor.$blockScrolling--;
    };

    this.select = function() {
        var anchor, editor = this.editor;
        var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
        editor.$blockScrolling++;
        if (this.$clickSelection) {
            var cmp = this.$clickSelection.comparePoint(cursor);

            if (cmp == -1) {
                anchor = this.$clickSelection.end;
            } else if (cmp == 1) {
                anchor = this.$clickSelection.start;
            } else {
                var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                cursor = orientedRange.cursor;
                anchor = orientedRange.anchor;
            }
            editor.selection.setSelectionAnchor(anchor.row, anchor.column);
        }
        editor.selection.selectToPosition(cursor);
        editor.$blockScrolling--;
        editor.renderer.scrollCursorIntoView();
    };

    this.extendSelectionBy = function(unitName) {
        var anchor, editor = this.editor;
        var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
        var range = editor.selection[unitName](cursor.row, cursor.column);
        editor.$blockScrolling++;
        if (this.$clickSelection) {
            var cmpStart = this.$clickSelection.comparePoint(range.start);
            var cmpEnd = this.$clickSelection.comparePoint(range.end);

            if (cmpStart == -1 && cmpEnd <= 0) {
                anchor = this.$clickSelection.end;
                if (range.end.row != cursor.row || range.end.column != cursor.column)
                    cursor = range.start;
            } else if (cmpEnd == 1 && cmpStart >= 0) {
                anchor = this.$clickSelection.start;
                if (range.start.row != cursor.row || range.start.column != cursor.column)
                    cursor = range.end;
            } else if (cmpStart == -1 && cmpEnd == 1) {
                cursor = range.end;
                anchor = range.start;
            } else {
                var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                cursor = orientedRange.cursor;
                anchor = orientedRange.anchor;
            }
            editor.selection.setSelectionAnchor(anchor.row, anchor.column);
        }
        editor.selection.selectToPosition(cursor);
        editor.$blockScrolling--;
        editor.renderer.scrollCursorIntoView();
    };

    this.selectEnd =
    this.selectAllEnd =
    this.selectByWordsEnd =
    this.selectByLinesEnd = function() {
        this.$clickSelection = null;
        this.editor.unsetStyle("ace_selecting");
        if (this.editor.renderer.scroller.releaseCapture) {
            this.editor.renderer.scroller.releaseCapture();
        }
    };

    this.focusWait = function() {
        var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
        var time = Date.now();

        if (distance > DRAG_OFFSET || time - this.mousedownEvent.time > this.$focusTimout)
            this.startSelect(this.mousedownEvent.getDocumentPosition());
    };

    this.onDoubleClick = function(ev) {
        var pos = ev.getDocumentPosition();
        var editor = this.editor;
        var session = editor.session;

        var range = session.getBracketRange(pos);
        if (range) {
            if (range.isEmpty()) {
                range.start.column--;
                range.end.column++;
            }
            this.setState("select");
        } else {
            range = editor.selection.getWordRange(pos.row, pos.column);
            this.setState("selectByWords");
        }
        this.$clickSelection = range;
        this.select();
    };

    this.onTripleClick = function(ev) {
        var pos = ev.getDocumentPosition();
        var editor = this.editor;

        this.setState("selectByLines");
        var range = editor.getSelectionRange();
        if (range.isMultiLine() && range.contains(pos.row, pos.column)) {
            this.$clickSelection = editor.selection.getLineRange(range.start.row);
            this.$clickSelection.end = editor.selection.getLineRange(range.end.row).end;
        } else {
            this.$clickSelection = editor.selection.getLineRange(pos.row);
        }
        this.select();
    };

    this.onQuadClick = function(ev) {
        var editor = this.editor;

        editor.selectAll();
        this.$clickSelection = editor.getSelectionRange();
        this.setState("selectAll");
    };

    this.onMouseWheel = function(ev) {
        if (ev.getAccelKey())
            return;
        if (ev.getShiftKey() && ev.wheelY && !ev.wheelX) {
            ev.wheelX = ev.wheelY;
            ev.wheelY = 0;
        }
        
        var editor = this.editor;

        if (!this.$lastScroll)
            this.$lastScroll = { t: 0, vx: 0, vy: 0, allowed: 0 };

        var prevScroll = this.$lastScroll;
        var t = ev.domEvent.timeStamp;
        var dt = t - prevScroll.t;
        var vx = ev.wheelX / dt;
        var vy = ev.wheelY / dt;
        if (dt < SCROLL_COOLDOWN_T) {
            vx = (vx + prevScroll.vx) / 2;
            vy = (vy + prevScroll.vy) / 2;
        }

        var direction = Math.abs(vx / vy);

        var canScroll = false;
        if (direction >= 1 && editor.renderer.isScrollableBy(ev.wheelX * ev.speed, 0))
            canScroll = true;
        if (direction <= 1 && editor.renderer.isScrollableBy(0, ev.wheelY * ev.speed))
            canScroll = true;

        if (canScroll) {
            prevScroll.allowed = t;
        } else if (t - prevScroll.allowed < SCROLL_COOLDOWN_T) {
            var isSlower = Math.abs(vx) <= 1.1 * Math.abs(prevScroll.vx)
                && Math.abs(vy) <= 1.1 * Math.abs(prevScroll.vy);
            if (isSlower) {
                canScroll = true;
                prevScroll.allowed = t;
            }
            else {
                prevScroll.allowed = 0;
            }
        }

        prevScroll.t = t;
        prevScroll.vx = vx;
        prevScroll.vy = vy;

        if (canScroll) {
            editor.renderer.scrollBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
            return ev.stop();
        }
    };

    this.onTouchMove = function(ev) {
        this.editor._emit("mousewheel", ev);
    };

}).call(DefaultHandlers.prototype);

exports.DefaultHandlers = DefaultHandlers;

function calcDistance(ax, ay, bx, by) {
    return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
}

function calcRangeOrientation(range, cursor) {
    if (range.start.row == range.end.row)
        var cmp = 2 * cursor.column - range.start.column - range.end.column;
    else if (range.start.row == range.end.row - 1 && !range.start.column && !range.end.column)
        var cmp = cursor.column - 4;
    else
        var cmp = 2 * cursor.row - range.start.row - range.end.row;

    if (cmp < 0)
        return {cursor: range.start, anchor: range.end};
    else
        return {cursor: range.end, anchor: range.start};
}

});

ace.define("ace/tooltip",["require","exports","module","ace/lib/oop","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
function Tooltip (parentNode) {
    this.isOpen = false;
    this.$element = null;
    this.$parentNode = parentNode;
}

(function() {
    this.$init = function() {
        this.$element = dom.createElement("div");
        this.$element.className = "ace_tooltip";
        this.$element.style.display = "none";
        this.$parentNode.appendChild(this.$element);
        return this.$element;
    };
    this.getElement = function() {
        return this.$element || this.$init();
    };
    this.setText = function(text) {
        dom.setInnerText(this.getElement(), text);
    };
    this.setHtml = function(html) {
        this.getElement().innerHTML = html;
    };
    this.setPosition = function(x, y) {
        this.getElement().style.left = x + "px";
        this.getElement().style.top = y + "px";
    };
    this.setClassName = function(className) {
        dom.addCssClass(this.getElement(), className);
    };
    this.show = function(text, x, y) {
        if (text != null)
            this.setText(text);
        if (x != null && y != null)
            this.setPosition(x, y);
        if (!this.isOpen) {
            this.getElement().style.display = "block";
            this.isOpen = true;
        }
    };

    this.hide = function() {
        if (this.isOpen) {
            this.getElement().style.display = "none";
            this.isOpen = false;
        }
    };
    this.getHeight = function() {
        return this.getElement().offsetHeight;
    };
    this.getWidth = function() {
        return this.getElement().offsetWidth;
    };

    this.destroy = function() {
        this.isOpen = false;
        if (this.$element && this.$element.parentNode) {
            this.$element.parentNode.removeChild(this.$element);
        }
    };

}).call(Tooltip.prototype);

exports.Tooltip = Tooltip;
});

ace.define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event","ace/tooltip"], function(acequire, exports, module) {
"use strict";
var dom = acequire("../lib/dom");
var oop = acequire("../lib/oop");
var event = acequire("../lib/event");
var Tooltip = acequire("../tooltip").Tooltip;

function GutterHandler(mouseHandler) {
    var editor = mouseHandler.editor;
    var gutter = editor.renderer.$gutterLayer;
    var tooltip = new GutterTooltip(editor.container);

    mouseHandler.editor.setDefaultHandler("guttermousedown", function(e) {
        if (!editor.isFocused() || e.getButton() != 0)
            return;
        var gutterRegion = gutter.getRegion(e);

        if (gutterRegion == "foldWidgets")
            return;

        var row = e.getDocumentPosition().row;
        var selection = editor.session.selection;

        if (e.getShiftKey())
            selection.selectTo(row, 0);
        else {
            if (e.domEvent.detail == 2) {
                editor.selectAll();
                return e.preventDefault();
            }
            mouseHandler.$clickSelection = editor.selection.getLineRange(row);
        }
        mouseHandler.setState("selectByLines");
        mouseHandler.captureMouse(e);
        return e.preventDefault();
    });


    var tooltipTimeout, mouseEvent, tooltipAnnotation;

    function showTooltip() {
        var row = mouseEvent.getDocumentPosition().row;
        var annotation = gutter.$annotations[row];
        if (!annotation)
            return hideTooltip();

        var maxRow = editor.session.getLength();
        if (row == maxRow) {
            var screenRow = editor.renderer.pixelToScreenCoordinates(0, mouseEvent.y).row;
            var pos = mouseEvent.$pos;
            if (screenRow > editor.session.documentToScreenRow(pos.row, pos.column))
                return hideTooltip();
        }

        if (tooltipAnnotation == annotation)
            return;
        tooltipAnnotation = annotation.text.join("<br/>");

        tooltip.setHtml(tooltipAnnotation);
        tooltip.show();
        editor._signal("showGutterTooltip", tooltip);
        editor.on("mousewheel", hideTooltip);

        if (mouseHandler.$tooltipFollowsMouse) {
            moveTooltip(mouseEvent);
        } else {
            var gutterElement = mouseEvent.domEvent.target;
            var rect = gutterElement.getBoundingClientRect();
            var style = tooltip.getElement().style;
            style.left = rect.right + "px";
            style.top = rect.bottom + "px";
        }
    }

    function hideTooltip() {
        if (tooltipTimeout)
            tooltipTimeout = clearTimeout(tooltipTimeout);
        if (tooltipAnnotation) {
            tooltip.hide();
            tooltipAnnotation = null;
            editor._signal("hideGutterTooltip", tooltip);
            editor.removeEventListener("mousewheel", hideTooltip);
        }
    }

    function moveTooltip(e) {
        tooltip.setPosition(e.x, e.y);
    }

    mouseHandler.editor.setDefaultHandler("guttermousemove", function(e) {
        var target = e.domEvent.target || e.domEvent.srcElement;
        if (dom.hasCssClass(target, "ace_fold-widget"))
            return hideTooltip();

        if (tooltipAnnotation && mouseHandler.$tooltipFollowsMouse)
            moveTooltip(e);

        mouseEvent = e;
        if (tooltipTimeout)
            return;
        tooltipTimeout = setTimeout(function() {
            tooltipTimeout = null;
            if (mouseEvent && !mouseHandler.isMousePressed)
                showTooltip();
            else
                hideTooltip();
        }, 50);
    });

    event.addListener(editor.renderer.$gutter, "mouseout", function(e) {
        mouseEvent = null;
        if (!tooltipAnnotation || tooltipTimeout)
            return;

        tooltipTimeout = setTimeout(function() {
            tooltipTimeout = null;
            hideTooltip();
        }, 50);
    });
    
    editor.on("changeSession", hideTooltip);
}

function GutterTooltip(parentNode) {
    Tooltip.call(this, parentNode);
}

oop.inherits(GutterTooltip, Tooltip);

(function(){
    this.setPosition = function(x, y) {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        var width = this.getWidth();
        var height = this.getHeight();
        x += 15;
        y += 15;
        if (x + width > windowWidth) {
            x -= (x + width) - windowWidth;
        }
        if (y + height > windowHeight) {
            y -= 20 + height;
        }
        Tooltip.prototype.setPosition.call(this, x, y);
    };

}).call(GutterTooltip.prototype);



exports.GutterHandler = GutterHandler;

});

ace.define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var MouseEvent = exports.MouseEvent = function(domEvent, editor) {
    this.domEvent = domEvent;
    this.editor = editor;
    
    this.x = this.clientX = domEvent.clientX;
    this.y = this.clientY = domEvent.clientY;

    this.$pos = null;
    this.$inSelection = null;
    
    this.propagationStopped = false;
    this.defaultPrevented = false;
};

(function() {  
    
    this.stopPropagation = function() {
        event.stopPropagation(this.domEvent);
        this.propagationStopped = true;
    };
    
    this.preventDefault = function() {
        event.preventDefault(this.domEvent);
        this.defaultPrevented = true;
    };
    
    this.stop = function() {
        this.stopPropagation();
        this.preventDefault();
    };
    this.getDocumentPosition = function() {
        if (this.$pos)
            return this.$pos;
        
        this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY);
        return this.$pos;
    };
    this.inSelection = function() {
        if (this.$inSelection !== null)
            return this.$inSelection;
            
        var editor = this.editor;
        

        var selectionRange = editor.getSelectionRange();
        if (selectionRange.isEmpty())
            this.$inSelection = false;
        else {
            var pos = this.getDocumentPosition();
            this.$inSelection = selectionRange.contains(pos.row, pos.column);
        }

        return this.$inSelection;
    };
    this.getButton = function() {
        return event.getButton(this.domEvent);
    };
    this.getShiftKey = function() {
        return this.domEvent.shiftKey;
    };
    
    this.getAccelKey = useragent.isMac
        ? function() { return this.domEvent.metaKey; }
        : function() { return this.domEvent.ctrlKey; };
    
}).call(MouseEvent.prototype);

});

ace.define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");

var AUTOSCROLL_DELAY = 200;
var SCROLL_CURSOR_DELAY = 200;
var SCROLL_CURSOR_HYSTERESIS = 5;

function DragdropHandler(mouseHandler) {

    var editor = mouseHandler.editor;

    var blankImage = dom.createElement("img");
    blankImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    if (useragent.isOpera)
        blankImage.style.cssText = "width:1px;height:1px;position:fixed;top:0;left:0;z-index:2147483647;opacity:0;";

    var exports = ["dragWait", "dragWaitEnd", "startDrag", "dragReadyEnd", "onMouseDrag"];

     exports.forEach(function(x) {
         mouseHandler[x] = this[x];
    }, this);
    editor.addEventListener("mousedown", this.onMouseDown.bind(mouseHandler));


    var mouseTarget = editor.container;
    var dragSelectionMarker, x, y;
    var timerId, range;
    var dragCursor, counter = 0;
    var dragOperation;
    var isInternal;
    var autoScrollStartTime;
    var cursorMovedTime;
    var cursorPointOnCaretMoved;

    this.onDragStart = function(e) {
        if (this.cancelDrag || !mouseTarget.draggable) {
            var self = this;
            setTimeout(function(){
                self.startSelect();
                self.captureMouse(e);
            }, 0);
            return e.preventDefault();
        }
        range = editor.getSelectionRange();

        var dataTransfer = e.dataTransfer;
        dataTransfer.effectAllowed = editor.getReadOnly() ? "copy" : "copyMove";
        if (useragent.isOpera) {
            editor.container.appendChild(blankImage);
            blankImage.scrollTop = 0;
        }
        dataTransfer.setDragImage && dataTransfer.setDragImage(blankImage, 0, 0);
        if (useragent.isOpera) {
            editor.container.removeChild(blankImage);
        }
        dataTransfer.clearData();
        dataTransfer.setData("Text", editor.session.getTextRange());

        isInternal = true;
        this.setState("drag");
    };

    this.onDragEnd = function(e) {
        mouseTarget.draggable = false;
        isInternal = false;
        this.setState(null);
        if (!editor.getReadOnly()) {
            var dropEffect = e.dataTransfer.dropEffect;
            if (!dragOperation && dropEffect == "move")
                editor.session.remove(editor.getSelectionRange());
            editor.renderer.$cursorLayer.setBlinking(true);
        }
        this.editor.unsetStyle("ace_dragging");
        this.editor.renderer.setCursorStyle("");
    };

    this.onDragEnter = function(e) {
        if (editor.getReadOnly() || !canAccept(e.dataTransfer))
            return;
        x = e.clientX;
        y = e.clientY;
        if (!dragSelectionMarker)
            addDragMarker();
        counter++;
        e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
        return event.preventDefault(e);
    };

    this.onDragOver = function(e) {
        if (editor.getReadOnly() || !canAccept(e.dataTransfer))
            return;
        x = e.clientX;
        y = e.clientY;
        if (!dragSelectionMarker) {
            addDragMarker();
            counter++;
        }
        if (onMouseMoveTimer !== null)
            onMouseMoveTimer = null;

        e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
        return event.preventDefault(e);
    };

    this.onDragLeave = function(e) {
        counter--;
        if (counter <= 0 && dragSelectionMarker) {
            clearDragMarker();
            dragOperation = null;
            return event.preventDefault(e);
        }
    };

    this.onDrop = function(e) {
        if (!dragCursor)
            return;
        var dataTransfer = e.dataTransfer;
        if (isInternal) {
            switch (dragOperation) {
                case "move":
                    if (range.contains(dragCursor.row, dragCursor.column)) {
                        range = {
                            start: dragCursor,
                            end: dragCursor
                        };
                    } else {
                        range = editor.moveText(range, dragCursor);
                    }
                    break;
                case "copy":
                    range = editor.moveText(range, dragCursor, true);
                    break;
            }
        } else {
            var dropData = dataTransfer.getData('Text');
            range = {
                start: dragCursor,
                end: editor.session.insert(dragCursor, dropData)
            };
            editor.focus();
            dragOperation = null;
        }
        clearDragMarker();
        return event.preventDefault(e);
    };

    event.addListener(mouseTarget, "dragstart", this.onDragStart.bind(mouseHandler));
    event.addListener(mouseTarget, "dragend", this.onDragEnd.bind(mouseHandler));
    event.addListener(mouseTarget, "dragenter", this.onDragEnter.bind(mouseHandler));
    event.addListener(mouseTarget, "dragover", this.onDragOver.bind(mouseHandler));
    event.addListener(mouseTarget, "dragleave", this.onDragLeave.bind(mouseHandler));
    event.addListener(mouseTarget, "drop", this.onDrop.bind(mouseHandler));

    function scrollCursorIntoView(cursor, prevCursor) {
        var now = Date.now();
        var vMovement = !prevCursor || cursor.row != prevCursor.row;
        var hMovement = !prevCursor || cursor.column != prevCursor.column;
        if (!cursorMovedTime || vMovement || hMovement) {
            editor.$blockScrolling += 1;
            editor.moveCursorToPosition(cursor);
            editor.$blockScrolling -= 1;
            cursorMovedTime = now;
            cursorPointOnCaretMoved = {x: x, y: y};
        } else {
            var distance = calcDistance(cursorPointOnCaretMoved.x, cursorPointOnCaretMoved.y, x, y);
            if (distance > SCROLL_CURSOR_HYSTERESIS) {
                cursorMovedTime = null;
            } else if (now - cursorMovedTime >= SCROLL_CURSOR_DELAY) {
                editor.renderer.scrollCursorIntoView();
                cursorMovedTime = null;
            }
        }
    }

    function autoScroll(cursor, prevCursor) {
        var now = Date.now();
        var lineHeight = editor.renderer.layerConfig.lineHeight;
        var characterWidth = editor.renderer.layerConfig.characterWidth;
        var editorRect = editor.renderer.scroller.getBoundingClientRect();
        var offsets = {
           x: {
               left: x - editorRect.left,
               right: editorRect.right - x
           },
           y: {
               top: y - editorRect.top,
               bottom: editorRect.bottom - y
           }
        };
        var nearestXOffset = Math.min(offsets.x.left, offsets.x.right);
        var nearestYOffset = Math.min(offsets.y.top, offsets.y.bottom);
        var scrollCursor = {row: cursor.row, column: cursor.column};
        if (nearestXOffset / characterWidth <= 2) {
            scrollCursor.column += (offsets.x.left < offsets.x.right ? -3 : +2);
        }
        if (nearestYOffset / lineHeight <= 1) {
            scrollCursor.row += (offsets.y.top < offsets.y.bottom ? -1 : +1);
        }
        var vScroll = cursor.row != scrollCursor.row;
        var hScroll = cursor.column != scrollCursor.column;
        var vMovement = !prevCursor || cursor.row != prevCursor.row;
        if (vScroll || (hScroll && !vMovement)) {
            if (!autoScrollStartTime)
                autoScrollStartTime = now;
            else if (now - autoScrollStartTime >= AUTOSCROLL_DELAY)
                editor.renderer.scrollCursorIntoView(scrollCursor);
        } else {
            autoScrollStartTime = null;
        }
    }

    function onDragInterval() {
        var prevCursor = dragCursor;
        dragCursor = editor.renderer.screenToTextCoordinates(x, y);
        scrollCursorIntoView(dragCursor, prevCursor);
        autoScroll(dragCursor, prevCursor);
    }

    function addDragMarker() {
        range = editor.selection.toOrientedRange();
        dragSelectionMarker = editor.session.addMarker(range, "ace_selection", editor.getSelectionStyle());
        editor.clearSelection();
        if (editor.isFocused())
            editor.renderer.$cursorLayer.setBlinking(false);
        clearInterval(timerId);
        onDragInterval();
        timerId = setInterval(onDragInterval, 20);
        counter = 0;
        event.addListener(document, "mousemove", onMouseMove);
    }

    function clearDragMarker() {
        clearInterval(timerId);
        editor.session.removeMarker(dragSelectionMarker);
        dragSelectionMarker = null;
        editor.$blockScrolling += 1;
        editor.selection.fromOrientedRange(range);
        editor.$blockScrolling -= 1;
        if (editor.isFocused() && !isInternal)
            editor.renderer.$cursorLayer.setBlinking(!editor.getReadOnly());
        range = null;
        dragCursor = null;
        counter = 0;
        autoScrollStartTime = null;
        cursorMovedTime = null;
        event.removeListener(document, "mousemove", onMouseMove);
    }
    var onMouseMoveTimer = null;
    function onMouseMove() {
        if (onMouseMoveTimer == null) {
            onMouseMoveTimer = setTimeout(function() {
                if (onMouseMoveTimer != null && dragSelectionMarker)
                    clearDragMarker();
            }, 20);
        }
    }

    function canAccept(dataTransfer) {
        var types = dataTransfer.types;
        return !types || Array.prototype.some.call(types, function(type) {
            return type == 'text/plain' || type == 'Text';
        });
    }

    function getDropEffect(e) {
        var copyAllowed = ['copy', 'copymove', 'all', 'uninitialized'];
        var moveAllowed = ['move', 'copymove', 'linkmove', 'all', 'uninitialized'];

        var copyModifierState = useragent.isMac ? e.altKey : e.ctrlKey;
        var effectAllowed = "uninitialized";
        try {
            effectAllowed = e.dataTransfer.effectAllowed.toLowerCase();
        } catch (e) {}
        var dropEffect = "none";

        if (copyModifierState && copyAllowed.indexOf(effectAllowed) >= 0)
            dropEffect = "copy";
        else if (moveAllowed.indexOf(effectAllowed) >= 0)
            dropEffect = "move";
        else if (copyAllowed.indexOf(effectAllowed) >= 0)
            dropEffect = "copy";

        return dropEffect;
    }
}

(function() {

    this.dragWait = function() {
        var interval = Date.now() - this.mousedownEvent.time;
        if (interval > this.editor.getDragDelay())
            this.startDrag();
    };

    this.dragWaitEnd = function() {
        var target = this.editor.container;
        target.draggable = false;
        this.startSelect(this.mousedownEvent.getDocumentPosition());
        this.selectEnd();
    };

    this.dragReadyEnd = function(e) {
        this.editor.renderer.$cursorLayer.setBlinking(!this.editor.getReadOnly());
        this.editor.unsetStyle("ace_dragging");
        this.editor.renderer.setCursorStyle("");
        this.dragWaitEnd();
    };

    this.startDrag = function(){
        this.cancelDrag = false;
        var editor = this.editor;
        var target = editor.container;
        target.draggable = true;
        editor.renderer.$cursorLayer.setBlinking(false);
        editor.setStyle("ace_dragging");
        var cursorStyle = useragent.isWin ? "default" : "move";
        editor.renderer.setCursorStyle(cursorStyle);
        this.setState("dragReady");
    };

    this.onMouseDrag = function(e) {
        var target = this.editor.container;
        if (useragent.isIE && this.state == "dragReady") {
            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
            if (distance > 3)
                target.dragDrop();
        }
        if (this.state === "dragWait") {
            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
            if (distance > 0) {
                target.draggable = false;
                this.startSelect(this.mousedownEvent.getDocumentPosition());
            }
        }
    };

    this.onMouseDown = function(e) {
        if (!this.$dragEnabled)
            return;
        this.mousedownEvent = e;
        var editor = this.editor;

        var inSelection = e.inSelection();
        var button = e.getButton();
        var clickCount = e.domEvent.detail || 1;
        if (clickCount === 1 && button === 0 && inSelection) {
            if (e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey()))
                return;
            this.mousedownEvent.time = Date.now();
            var eventTarget = e.domEvent.target || e.domEvent.srcElement;
            if ("unselectable" in eventTarget)
                eventTarget.unselectable = "on";
            if (editor.getDragDelay()) {
                if (useragent.isWebKit) {
                    this.cancelDrag = true;
                    var mouseTarget = editor.container;
                    mouseTarget.draggable = true;
                }
                this.setState("dragWait");
            } else {
                this.startDrag();
            }
            this.captureMouse(e, this.onMouseDrag.bind(this));
            e.defaultPrevented = true;
        }
    };

}).call(DragdropHandler.prototype);


function calcDistance(ax, ay, bx, by) {
    return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
}

exports.DragdropHandler = DragdropHandler;

});

ace.define("ace/lib/net",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";
var dom = acequire("./dom");

exports.get = function (url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            callback(xhr.responseText);
        }
    };
    xhr.send(null);
};

exports.loadScript = function(path, callback) {
    var head = dom.getDocumentHead();
    var s = document.createElement('script');

    s.src = path;
    head.appendChild(s);

    s.onload = s.onreadystatechange = function(_, isAbort) {
        if (isAbort || !s.readyState || s.readyState == "loaded" || s.readyState == "complete") {
            s = s.onload = s.onreadystatechange = null;
            if (!isAbort)
                callback();
        }
    };
};
exports.qualifyURL = function(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
};

});

ace.define("ace/lib/event_emitter",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var EventEmitter = {};
var stopPropagation = function() { this.propagationStopped = true; };
var preventDefault = function() { this.defaultPrevented = true; };

EventEmitter._emit =
EventEmitter._dispatchEvent = function(eventName, e) {
    this._eventRegistry || (this._eventRegistry = {});
    this._defaultHandlers || (this._defaultHandlers = {});

    var listeners = this._eventRegistry[eventName] || [];
    var defaultHandler = this._defaultHandlers[eventName];
    if (!listeners.length && !defaultHandler)
        return;

    if (typeof e != "object" || !e)
        e = {};

    if (!e.type)
        e.type = eventName;
    if (!e.stopPropagation)
        e.stopPropagation = stopPropagation;
    if (!e.preventDefault)
        e.preventDefault = preventDefault;

    listeners = listeners.slice();
    for (var i=0; i<listeners.length; i++) {
        listeners[i](e, this);
        if (e.propagationStopped)
            break;
    }
    
    if (defaultHandler && !e.defaultPrevented)
        return defaultHandler(e, this);
};


EventEmitter._signal = function(eventName, e) {
    var listeners = (this._eventRegistry || {})[eventName];
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i=0; i<listeners.length; i++)
        listeners[i](e, this);
};

EventEmitter.once = function(eventName, callback) {
    var _self = this;
    callback && this.addEventListener(eventName, function newCallback() {
        _self.removeEventListener(eventName, newCallback);
        callback.apply(null, arguments);
    });
};


EventEmitter.setDefaultHandler = function(eventName, callback) {
    var handlers = this._defaultHandlers;
    if (!handlers)
        handlers = this._defaultHandlers = {_disabled_: {}};
    
    if (handlers[eventName]) {
        var old = handlers[eventName];
        var disabled = handlers._disabled_[eventName];
        if (!disabled)
            handlers._disabled_[eventName] = disabled = [];
        disabled.push(old);
        var i = disabled.indexOf(callback);
        if (i != -1) 
            disabled.splice(i, 1);
    }
    handlers[eventName] = callback;
};
EventEmitter.removeDefaultHandler = function(eventName, callback) {
    var handlers = this._defaultHandlers;
    if (!handlers)
        return;
    var disabled = handlers._disabled_[eventName];
    
    if (handlers[eventName] == callback) {
        var old = handlers[eventName];
        if (disabled)
            this.setDefaultHandler(eventName, disabled.pop());
    } else if (disabled) {
        var i = disabled.indexOf(callback);
        if (i != -1)
            disabled.splice(i, 1);
    }
};

EventEmitter.on =
EventEmitter.addEventListener = function(eventName, callback, capturing) {
    this._eventRegistry = this._eventRegistry || {};

    var listeners = this._eventRegistry[eventName];
    if (!listeners)
        listeners = this._eventRegistry[eventName] = [];

    if (listeners.indexOf(callback) == -1)
        listeners[capturing ? "unshift" : "push"](callback);
    return callback;
};

EventEmitter.off =
EventEmitter.removeListener =
EventEmitter.removeEventListener = function(eventName, callback) {
    this._eventRegistry = this._eventRegistry || {};

    var listeners = this._eventRegistry[eventName];
    if (!listeners)
        return;

    var index = listeners.indexOf(callback);
    if (index !== -1)
        listeners.splice(index, 1);
};

EventEmitter.removeAllListeners = function(eventName) {
    if (this._eventRegistry) this._eventRegistry[eventName] = [];
};

exports.EventEmitter = EventEmitter;

});

ace.define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
"no use strict";

var oop = acequire("./oop");
var EventEmitter = acequire("./event_emitter").EventEmitter;

var optionsProvider = {
    setOptions: function(optList) {
        Object.keys(optList).forEach(function(key) {
            this.setOption(key, optList[key]);
        }, this);
    },
    getOptions: function(optionNames) {
        var result = {};
        if (!optionNames) {
            optionNames = Object.keys(this.$options);
        } else if (!Array.isArray(optionNames)) {
            result = optionNames;
            optionNames = Object.keys(result);
        }
        optionNames.forEach(function(key) {
            result[key] = this.getOption(key);
        }, this);
        return result;
    },
    setOption: function(name, value) {
        if (this["$" + name] === value)
            return;
        var opt = this.$options[name];
        if (!opt) {
            return warn('misspelled option "' + name + '"');
        }
        if (opt.forwardTo)
            return this[opt.forwardTo] && this[opt.forwardTo].setOption(name, value);

        if (!opt.handlesSet)
            this["$" + name] = value;
        if (opt && opt.set)
            opt.set.call(this, value);
    },
    getOption: function(name) {
        var opt = this.$options[name];
        if (!opt) {
            return warn('misspelled option "' + name + '"');
        }
        if (opt.forwardTo)
            return this[opt.forwardTo] && this[opt.forwardTo].getOption(name);
        return opt && opt.get ? opt.get.call(this) : this["$" + name];
    }
};

function warn(message) {
    if (typeof console != "undefined" && console.warn)
        console.warn.apply(console, arguments);
}

function reportError(msg, data) {
    var e = new Error(msg);
    e.data = data;
    if (typeof console == "object" && console.error)
        console.error(e);
    setTimeout(function() { throw e; });
}

var AppConfig = function() {
    this.$defaultOptions = {};
};

(function() {
    oop.implement(this, EventEmitter);
    this.defineOptions = function(obj, path, options) {
        if (!obj.$options)
            this.$defaultOptions[path] = obj.$options = {};

        Object.keys(options).forEach(function(key) {
            var opt = options[key];
            if (typeof opt == "string")
                opt = {forwardTo: opt};

            opt.name || (opt.name = key);
            obj.$options[opt.name] = opt;
            if ("initialValue" in opt)
                obj["$" + opt.name] = opt.initialValue;
        });
        oop.implement(obj, optionsProvider);

        return this;
    };

    this.resetOptions = function(obj) {
        Object.keys(obj.$options).forEach(function(key) {
            var opt = obj.$options[key];
            if ("value" in opt)
                obj.setOption(key, opt.value);
        });
    };

    this.setDefaultValue = function(path, name, value) {
        var opts = this.$defaultOptions[path] || (this.$defaultOptions[path] = {});
        if (opts[name]) {
            if (opts.forwardTo)
                this.setDefaultValue(opts.forwardTo, name, value);
            else
                opts[name].value = value;
        }
    };

    this.setDefaultValues = function(path, optionHash) {
        Object.keys(optionHash).forEach(function(key) {
            this.setDefaultValue(path, key, optionHash[key]);
        }, this);
    };
    
    this.warn = warn;
    this.reportError = reportError;
    
}).call(AppConfig.prototype);

exports.AppConfig = AppConfig;

});

ace.define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/lib/net","ace/lib/app_config"], function(acequire, exports, module) {
"no use strict";

var lang = acequire("./lib/lang");
var oop = acequire("./lib/oop");
var net = acequire("./lib/net");
var AppConfig = acequire("./lib/app_config").AppConfig;

module.exports = exports = new AppConfig();

var global = (function() {
    return this || typeof window != "undefined" && window;
})();

var options = {
    packaged: false,
    workerPath: null,
    modePath: null,
    themePath: null,
    basePath: "",
    suffix: ".js",
    $moduleUrls: {}
};

exports.get = function(key) {
    if (!options.hasOwnProperty(key))
        throw new Error("Unknown config key: " + key);

    return options[key];
};

exports.set = function(key, value) {
    if (!options.hasOwnProperty(key))
        throw new Error("Unknown config key: " + key);

    options[key] = value;
};

exports.all = function() {
    return lang.copyObject(options);
};
exports.moduleUrl = function(name, component) {
    if (options.$moduleUrls[name])
        return options.$moduleUrls[name];

    var parts = name.split("/");
    component = component || parts[parts.length - 2] || "";
    var sep = component == "snippets" ? "/" : "-";
    var base = parts[parts.length - 1];
    if (component == "worker" && sep == "-") {
        var re = new RegExp("^" + component + "[\\-_]|[\\-_]" + component + "$", "g");
        base = base.replace(re, "");
    }

    if ((!base || base == component) && parts.length > 1)
        base = parts[parts.length - 2];
    var path = options[component + "Path"];
    if (path == null) {
        path = options.basePath;
    } else if (sep == "/") {
        component = sep = "";
    }
    if (path && path.slice(-1) != "/")
        path += "/";
    return path + component + sep + base + this.get("suffix");
};

exports.setModuleUrl = function(name, subst) {
    return options.$moduleUrls[name] = subst;
};

exports.$loading = {};
exports.loadModule = function(moduleName, onLoad) {
    var module, moduleType;
    if (Array.isArray(moduleName)) {
        moduleType = moduleName[0];
        moduleName = moduleName[1];
    }

    try {
        module = acequire(moduleName);
    } catch (e) {}
    if (module && !exports.$loading[moduleName])
        return onLoad && onLoad(module);

    if (!exports.$loading[moduleName])
        exports.$loading[moduleName] = [];

    exports.$loading[moduleName].push(onLoad);

    if (exports.$loading[moduleName].length > 1)
        return;

    var afterLoad = function() {
        acequire([moduleName], function(module) {
            exports._emit("load.module", {name: moduleName, module: module});
            var listeners = exports.$loading[moduleName];
            exports.$loading[moduleName] = null;
            listeners.forEach(function(onLoad) {
                onLoad && onLoad(module);
            });
        });
    };

    if (!exports.get("packaged"))
        return afterLoad();
    net.loadScript(exports.moduleUrl(moduleName, moduleType), afterLoad);
};
init(true);function init(packaged) {

    if (!global || !global.document)
        return;
    
    options.packaged = packaged || acequire.packaged || module.packaged || (global.define && __webpack_require__(130).packaged);

    var scriptOptions = {};
    var scriptUrl = "";
    var currentScript = (document.currentScript || document._currentScript ); // native or polyfill
    var currentDocument = currentScript && currentScript.ownerDocument || document;
    
    var scripts = currentDocument.getElementsByTagName("script");
    for (var i=0; i<scripts.length; i++) {
        var script = scripts[i];

        var src = script.src || script.getAttribute("src");
        if (!src)
            continue;

        var attributes = script.attributes;
        for (var j=0, l=attributes.length; j < l; j++) {
            var attr = attributes[j];
            if (attr.name.indexOf("data-ace-") === 0) {
                scriptOptions[deHyphenate(attr.name.replace(/^data-ace-/, ""))] = attr.value;
            }
        }

        var m = src.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);
        if (m)
            scriptUrl = m[1];
    }

    if (scriptUrl) {
        scriptOptions.base = scriptOptions.base || scriptUrl;
        scriptOptions.packaged = true;
    }

    scriptOptions.basePath = scriptOptions.base;
    scriptOptions.workerPath = scriptOptions.workerPath || scriptOptions.base;
    scriptOptions.modePath = scriptOptions.modePath || scriptOptions.base;
    scriptOptions.themePath = scriptOptions.themePath || scriptOptions.base;
    delete scriptOptions.base;

    for (var key in scriptOptions)
        if (typeof scriptOptions[key] !== "undefined")
            exports.set(key, scriptOptions[key]);
}

exports.init = init;

function deHyphenate(str) {
    return str.replace(/-(.)/g, function(m, m1) { return m1.toUpperCase(); });
}

});

ace.define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/config"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var DefaultHandlers = acequire("./default_handlers").DefaultHandlers;
var DefaultGutterHandler = acequire("./default_gutter_handler").GutterHandler;
var MouseEvent = acequire("./mouse_event").MouseEvent;
var DragdropHandler = acequire("./dragdrop_handler").DragdropHandler;
var config = acequire("../config");

var MouseHandler = function(editor) {
    var _self = this;
    this.editor = editor;

    new DefaultHandlers(this);
    new DefaultGutterHandler(this);
    new DragdropHandler(this);

    var focusEditor = function(e) {
        var windowBlurred = !document.hasFocus || !document.hasFocus()
            || !editor.isFocused() && document.activeElement == (editor.textInput && editor.textInput.getElement());
        if (windowBlurred)
            window.focus();
        editor.focus();
    };

    var mouseTarget = editor.renderer.getMouseEventTarget();
    event.addListener(mouseTarget, "click", this.onMouseEvent.bind(this, "click"));
    event.addListener(mouseTarget, "mousemove", this.onMouseMove.bind(this, "mousemove"));
    event.addMultiMouseDownListener([
        mouseTarget,
        editor.renderer.scrollBarV && editor.renderer.scrollBarV.inner,
        editor.renderer.scrollBarH && editor.renderer.scrollBarH.inner,
        editor.textInput && editor.textInput.getElement()
    ].filter(Boolean), [400, 300, 250], this, "onMouseEvent");
    event.addMouseWheelListener(editor.container, this.onMouseWheel.bind(this, "mousewheel"));
    event.addTouchMoveListener(editor.container, this.onTouchMove.bind(this, "touchmove"));

    var gutterEl = editor.renderer.$gutter;
    event.addListener(gutterEl, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"));
    event.addListener(gutterEl, "click", this.onMouseEvent.bind(this, "gutterclick"));
    event.addListener(gutterEl, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"));
    event.addListener(gutterEl, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"));

    event.addListener(mouseTarget, "mousedown", focusEditor);
    event.addListener(gutterEl, "mousedown", focusEditor);
    if (useragent.isIE && editor.renderer.scrollBarV) {
        event.addListener(editor.renderer.scrollBarV.element, "mousedown", focusEditor);
        event.addListener(editor.renderer.scrollBarH.element, "mousedown", focusEditor);
    }

    editor.on("mousemove", function(e){
        if (_self.state || _self.$dragDelay || !_self.$dragEnabled)
            return;

        var character = editor.renderer.screenToTextCoordinates(e.x, e.y);
        var range = editor.session.selection.getRange();
        var renderer = editor.renderer;

        if (!range.isEmpty() && range.insideStart(character.row, character.column)) {
            renderer.setCursorStyle("default");
        } else {
            renderer.setCursorStyle("");
        }
    });
};

(function() {
    this.onMouseEvent = function(name, e) {
        this.editor._emit(name, new MouseEvent(e, this.editor));
    };

    this.onMouseMove = function(name, e) {
        var listeners = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
        if (!listeners || !listeners.length)
            return;

        this.editor._emit(name, new MouseEvent(e, this.editor));
    };

    this.onMouseWheel = function(name, e) {
        var mouseEvent = new MouseEvent(e, this.editor);
        mouseEvent.speed = this.$scrollSpeed * 2;
        mouseEvent.wheelX = e.wheelX;
        mouseEvent.wheelY = e.wheelY;

        this.editor._emit(name, mouseEvent);
    };
    
    this.onTouchMove = function (name, e) {
        var mouseEvent = new MouseEvent(e, this.editor);
        mouseEvent.speed = 1;//this.$scrollSpeed * 2;
        mouseEvent.wheelX = e.wheelX;
        mouseEvent.wheelY = e.wheelY;
        this.editor._emit(name, mouseEvent);
    };

    this.setState = function(state) {
        this.state = state;
    };

    this.captureMouse = function(ev, mouseMoveHandler) {
        this.x = ev.x;
        this.y = ev.y;

        this.isMousePressed = true;
        var renderer = this.editor.renderer;
        if (renderer.$keepTextAreaAtCursor)
            renderer.$keepTextAreaAtCursor = null;

        var self = this;
        var onMouseMove = function(e) {
            if (!e) return;
            if (useragent.isWebKit && !e.which && self.releaseMouse)
                return self.releaseMouse();

            self.x = e.clientX;
            self.y = e.clientY;
            mouseMoveHandler && mouseMoveHandler(e);
            self.mouseEvent = new MouseEvent(e, self.editor);
            self.$mouseMoved = true;
        };

        var onCaptureEnd = function(e) {
            clearInterval(timerId);
            onCaptureInterval();
            self[self.state + "End"] && self[self.state + "End"](e);
            self.state = "";
            if (renderer.$keepTextAreaAtCursor == null) {
                renderer.$keepTextAreaAtCursor = true;
                renderer.$moveTextAreaToCursor();
            }
            self.isMousePressed = false;
            self.$onCaptureMouseMove = self.releaseMouse = null;
            e && self.onMouseEvent("mouseup", e);
        };

        var onCaptureInterval = function() {
            self[self.state] && self[self.state]();
            self.$mouseMoved = false;
        };

        if (useragent.isOldIE && ev.domEvent.type == "dblclick") {
            return setTimeout(function() {onCaptureEnd(ev);});
        }

        self.$onCaptureMouseMove = onMouseMove;
        self.releaseMouse = event.capture(this.editor.container, onMouseMove, onCaptureEnd);
        var timerId = setInterval(onCaptureInterval, 20);
    };
    this.releaseMouse = null;
    this.cancelContextMenu = function() {
        var stop = function(e) {
            if (e && e.domEvent && e.domEvent.type != "contextmenu")
                return;
            this.editor.off("nativecontextmenu", stop);
            if (e && e.domEvent)
                event.stopEvent(e.domEvent);
        }.bind(this);
        setTimeout(stop, 10);
        this.editor.on("nativecontextmenu", stop);
    };
}).call(MouseHandler.prototype);

config.defineOptions(MouseHandler.prototype, "mouseHandler", {
    scrollSpeed: {initialValue: 2},
    dragDelay: {initialValue: (useragent.isMac ? 150 : 0)},
    dragEnabled: {initialValue: true},
    focusTimout: {initialValue: 0},
    tooltipFollowsMouse: {initialValue: true}
});


exports.MouseHandler = MouseHandler;
});

ace.define("ace/mouse/fold_handler",["require","exports","module"], function(acequire, exports, module) {
"use strict";

function FoldHandler(editor) {

    editor.on("click", function(e) {
        var position = e.getDocumentPosition();
        var session = editor.session;
        var fold = session.getFoldAt(position.row, position.column, 1);
        if (fold) {
            if (e.getAccelKey())
                session.removeFold(fold);
            else
                session.expandFold(fold);

            e.stop();
        }
    });

    editor.on("gutterclick", function(e) {
        var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);

        if (gutterRegion == "foldWidgets") {
            var row = e.getDocumentPosition().row;
            var session = editor.session;
            if (session.foldWidgets && session.foldWidgets[row])
                editor.session.onFoldWidgetClick(row, e);
            if (!editor.isFocused())
                editor.focus();
            e.stop();
        }
    });

    editor.on("gutterdblclick", function(e) {
        var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);

        if (gutterRegion == "foldWidgets") {
            var row = e.getDocumentPosition().row;
            var session = editor.session;
            var data = session.getParentFoldRangeData(row, true);
            var range = data.range || data.firstRange;

            if (range) {
                row = range.start.row;
                var fold = session.getFoldAt(row, session.getLine(row).length, 1);

                if (fold) {
                    session.removeFold(fold);
                } else {
                    session.addFold("...", range);
                    editor.renderer.scrollCursorIntoView({row: range.start.row, column: 0});
                }
            }
            e.stop();
        }
    });
}

exports.FoldHandler = FoldHandler;

});

ace.define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"], function(acequire, exports, module) {
"use strict";

var keyUtil  = acequire("../lib/keys");
var event = acequire("../lib/event");

var KeyBinding = function(editor) {
    this.$editor = editor;
    this.$data = {editor: editor};
    this.$handlers = [];
    this.setDefaultHandler(editor.commands);
};

(function() {
    this.setDefaultHandler = function(kb) {
        this.removeKeyboardHandler(this.$defaultHandler);
        this.$defaultHandler = kb;
        this.addKeyboardHandler(kb, 0);
    };

    this.setKeyboardHandler = function(kb) {
        var h = this.$handlers;
        if (h[h.length - 1] == kb)
            return;

        while (h[h.length - 1] && h[h.length - 1] != this.$defaultHandler)
            this.removeKeyboardHandler(h[h.length - 1]);

        this.addKeyboardHandler(kb, 1);
    };

    this.addKeyboardHandler = function(kb, pos) {
        if (!kb)
            return;
        if (typeof kb == "function" && !kb.handleKeyboard)
            kb.handleKeyboard = kb;
        var i = this.$handlers.indexOf(kb);
        if (i != -1)
            this.$handlers.splice(i, 1);

        if (pos == undefined)
            this.$handlers.push(kb);
        else
            this.$handlers.splice(pos, 0, kb);

        if (i == -1 && kb.attach)
            kb.attach(this.$editor);
    };

    this.removeKeyboardHandler = function(kb) {
        var i = this.$handlers.indexOf(kb);
        if (i == -1)
            return false;
        this.$handlers.splice(i, 1);
        kb.detach && kb.detach(this.$editor);
        return true;
    };

    this.getKeyboardHandler = function() {
        return this.$handlers[this.$handlers.length - 1];
    };
    
    this.getStatusText = function() {
        var data = this.$data;
        var editor = data.editor;
        return this.$handlers.map(function(h) {
            return h.getStatusText && h.getStatusText(editor, data) || "";
        }).filter(Boolean).join(" ");
    };

    this.$callKeyboardHandlers = function(hashId, keyString, keyCode, e) {
        var toExecute;
        var success = false;
        var commands = this.$editor.commands;

        for (var i = this.$handlers.length; i--;) {
            toExecute = this.$handlers[i].handleKeyboard(
                this.$data, hashId, keyString, keyCode, e
            );
            if (!toExecute || !toExecute.command)
                continue;
            if (toExecute.command == "null") {
                success = true;
            } else {
                success = commands.exec(toExecute.command, this.$editor, toExecute.args, e);
            }
            if (success && e && hashId != -1 && 
                toExecute.passEvent != true && toExecute.command.passEvent != true
            ) {
                event.stopEvent(e);
            }
            if (success)
                break;
        }
        
        if (!success && hashId == -1) {
            toExecute = {command: "insertstring"};
            success = commands.exec("insertstring", this.$editor, keyString);
        }
        
        if (success && this.$editor._signal)
            this.$editor._signal("keyboardActivity", toExecute);
        
        return success;
    };

    this.onCommandKey = function(e, hashId, keyCode) {
        var keyString = keyUtil.keyCodeToString(keyCode);
        this.$callKeyboardHandlers(hashId, keyString, keyCode, e);
    };

    this.onTextInput = function(text) {
        this.$callKeyboardHandlers(-1, text);
    };

}).call(KeyBinding.prototype);

exports.KeyBinding = KeyBinding;
});

ace.define("ace/lib/bidiutil",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var ArabicAlefBetIntervalsBegine = ['\u0621', '\u0641'];
var ArabicAlefBetIntervalsEnd = ['\u063A', '\u064a'];
var dir = 0, hiLevel = 0;
var lastArabic = false, hasUBAT_AL = false,  hasUBAT_B = false,  hasUBAT_S = false, hasBlockSep = false, hasSegSep = false;

var impTab_LTR = [	[	0,		3,		0,		1,		0,		0,		0	],	[	0,		3,		0,		1,		2,		2,		0	],	[	0,		3,		0,		0x11,		2,		0,		1	],	[	0,		3,		5,		5,		4,		1,		0	],	[	0,		3,		0x15,		0x15,		4,		0,		1	],	[	0,		3,		5,		5,		4,		2,		0	]
];

var impTab_RTL = [	[	2,		0,		1,		1,		0,		1,		0	],	[	2,		0,		1,		1,		0,		2,		0	],	[	2,		0,		2,		1,		3,		2,		0	],	[	2,		0,		2,		0x21,		3,		1,		1	]
];

var LTR = 0, RTL = 1;

var L = 0;
var R = 1;
var EN = 2;
var AN = 3;
var ON = 4;
var B = 5;
var S = 6;
var AL = 7;
var WS = 8;
var CS = 9;
var ES = 10;
var ET = 11;
var NSM = 12;
var LRE = 13;
var RLE = 14;
var PDF = 15;
var LRO = 16;
var RLO = 17;
var BN = 18;

var UnicodeTBL00 = [
BN,BN,BN,BN,BN,BN,BN,BN,BN,S,B,S,WS,B,BN,BN,
BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,B,B,B,S,
WS,ON,ON,ET,ET,ET,ON,ON,ON,ON,ON,ES,CS,ES,CS,CS,
EN,EN,EN,EN,EN,EN,EN,EN,EN,EN,CS,ON,ON,ON,ON,ON,
ON,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,
L,L,L,L,L,L,L,L,L,L,L,ON,ON,ON,ON,ON,
ON,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,
L,L,L,L,L,L,L,L,L,L,L,ON,ON,ON,ON,BN,
BN,BN,BN,BN,BN,B,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,
BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,
CS,ON,ET,ET,ET,ET,ON,ON,ON,ON,L,ON,ON,BN,ON,ON,
ET,ET,EN,EN,ON,L,ON,ON,ON,EN,L,ON,ON,ON,ON,ON
];

var UnicodeTBL20 = [
WS,WS,WS,WS,WS,WS,WS,WS,WS,WS,WS,BN,BN,BN,L,R	,
ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,
ON,ON,ON,ON,ON,ON,ON,ON,WS,B,LRE,RLE,PDF,LRO,RLO,CS,
ET,ET,ET,ET,ET,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,
ON,ON,ON,ON,CS,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,
ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,WS
];

function _computeLevels(chars, levels, len, charTypes) {
	var impTab = dir ? impTab_RTL : impTab_LTR
		, prevState = null, newClass = null, newLevel = null, newState = 0
		, action = null, cond = null, condPos = -1, i = null, ix = null, classes = [];

	if (!charTypes) {
		for (i = 0, charTypes = []; i < len; i++) {
			charTypes[i] = _getCharacterType(chars[i]);
		}
	}
	hiLevel = dir;
	lastArabic = false;
	hasUBAT_AL = false;
	hasUBAT_B = false;
	hasUBAT_S = false;
	for (ix = 0; ix < len; ix++){
		prevState = newState;
		classes[ix] = newClass = _getCharClass(chars, charTypes, classes, ix);
		newState = impTab[prevState][newClass];
		action = newState & 0xF0;
		newState &= 0x0F;
		levels[ix] = newLevel = impTab[newState][5];
		if (action > 0){
			if (action == 0x10){
				for(i = condPos; i < ix; i++){
					levels[i] = 1;
				}
				condPos = -1;
			} else {
				condPos = -1;
			}
		}
		cond = impTab[newState][6];
		if (cond){
			if(condPos == -1){
				condPos = ix;
			}
		}else{
			if (condPos > -1){
				for(i = condPos; i < ix; i++){
					levels[i] = newLevel;
				}
				condPos = -1;
			}
		}
		if (charTypes[ix] == B){
			levels[ix] = 0;
		}
		hiLevel |= newLevel;
	}
	if (hasUBAT_S){
		for(i = 0; i < len; i++){
			if(charTypes[i] == S){
				levels[i] = dir;
				for(var j = i - 1; j >= 0; j--){
					if(charTypes[j] == WS){
						levels[j] = dir;
					}else{
						break;
					}
				}
			}
		}
	}
}

function _invertLevel(lev, levels, _array) {
	if (hiLevel < lev){
		return;
	}
	if (lev == 1 && dir == RTL && !hasUBAT_B){
		_array.reverse();
		return;
	}
	var len = _array.length, start = 0, end, lo, hi, tmp;
	while(start < len){
		if (levels[start] >= lev){
			end = start + 1;
		while(end < len && levels[end] >= lev){
			end++;
		}
		for(lo = start, hi = end - 1 ; lo < hi; lo++, hi--){
			tmp = _array[lo];
			_array[lo] = _array[hi];
			_array[hi] = tmp;
		}
		start = end;
	}
	start++;
	}
}

function _getCharClass(chars, types, classes, ix) {
	var cType = types[ix], wType, nType, len, i;
	switch(cType){
		case L:
		case R:
			lastArabic = false;
		case ON:
		case AN:
			return cType;
		case EN:
			return lastArabic ? AN : EN;
		case AL:
			lastArabic = true;
			hasUBAT_AL = true;
			return R;
		case WS:
			return ON;
		case CS:
			if (ix < 1 || (ix + 1) >= types.length ||
				((wType = classes[ix - 1]) != EN && wType != AN) ||
				((nType = types[ix + 1]) != EN && nType != AN)){
				return ON;
			}
			if (lastArabic){nType = AN;}
			return nType == wType ? nType : ON;
		case ES:
			wType = ix > 0 ? classes[ix - 1] : B;
			if (wType == EN && (ix + 1) < types.length && types[ix + 1] == EN){
				return EN;
			}
			return ON;
		case ET:
			if (ix > 0 && classes[ix - 1] == EN){
				return EN;
			}
			if (lastArabic){
				return ON;
			}
			i = ix + 1;
			len = types.length;
			while (i < len && types[i] == ET){
				i++;
			}
			if (i < len && types[i] == EN){
				return EN;
			}
			return ON;
		case NSM:
			len = types.length;
			i = ix + 1;
			while (i < len && types[i] == NSM){
				i++;
			}
			if (i < len){
				var c = chars[ix], rtlCandidate = (c >= 0x0591 && c <= 0x08FF) || c == 0xFB1E;

				wType = types[i];
				if (rtlCandidate && (wType == R || wType == AL)){
					return R;
				}
			}

			if (ix < 1 || (wType = types[ix - 1]) == B){
				return ON;
			}
			return classes[ix - 1];
		case B:
			lastArabic = false;
			hasUBAT_B = true;
			return dir;
		case S:
			hasUBAT_S = true;
			return ON;
		case LRE:
		case RLE:
		case LRO:
		case RLO:
		case PDF:
			lastArabic = false;
		case BN:
			return ON;
	}
}

function _getCharacterType( ch ) {
	var uc = ch.charCodeAt(0), hi = uc >> 8;

	if (hi == 0) {
		return ((uc > 0x00BF) ? L : UnicodeTBL00[uc]);
	} else if (hi == 5) {
		return (/[\u0591-\u05f4]/.test(ch) ? R : L);
	} else if (hi == 6) {
		if (/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(ch))
			return NSM;
		else if (/[\u0660-\u0669\u066b-\u066c]/.test(ch))
			return AN;
		else if (uc == 0x066A)
			return ET;
		else if (/[\u06f0-\u06f9]/.test(ch))
			return EN;
		else
			return AL;
	} else if (hi == 0x20 && uc <= 0x205F) {
		return UnicodeTBL20[uc & 0xFF];
	} else if (hi == 0xFE) {
		return (uc >= 0xFE70 ? AL : ON);
	}
	return ON;
}

function _isArabicDiacritics( ch ) {
	return (ch >= '\u064b' && ch <= '\u0655');
}
exports.L = L;
exports.R = R;
exports.EN = EN;
exports.ON_R = 3;
exports.AN = 4;
exports.R_H = 5;
exports.B = 6;

exports.DOT = "\xB7";
exports.doBidiReorder = function(text, textCharTypes, isRtl) {
	if (text.length < 2)
		return {};

	var chars = text.split(""), logicalFromVisual = new Array(chars.length),
		bidiLevels = new Array(chars.length), levels = [];

	dir = isRtl ? RTL : LTR;

	_computeLevels(chars, levels, chars.length, textCharTypes);

	for (var i = 0; i < logicalFromVisual.length; logicalFromVisual[i] = i, i++);

	_invertLevel(2, levels, logicalFromVisual);
	_invertLevel(1, levels, logicalFromVisual);

	for (var i = 0; i < logicalFromVisual.length - 1; i++) { //fix levels to reflect character width
		if (textCharTypes[i] === AN) {
			levels[i] = exports.AN;
		} else if (levels[i] === R && ((textCharTypes[i] > AL && textCharTypes[i] < LRE)
			|| textCharTypes[i] === ON || textCharTypes[i] === BN)) {
			levels[i] = exports.ON_R;
		} else if ((i > 0 && chars[i - 1] === '\u0644') && /\u0622|\u0623|\u0625|\u0627/.test(chars[i])) {
			levels[i - 1] = levels[i] = exports.R_H;
			i++;
		}
	}
	if (chars[chars.length - 1] === exports.DOT)
		levels[chars.length - 1] = exports.B;

	for (var i = 0; i < logicalFromVisual.length; i++) {
		bidiLevels[i] = levels[logicalFromVisual[i]];
	}

	return {'logicalFromVisual': logicalFromVisual, 'bidiLevels': bidiLevels};
};
exports.hasBidiCharacters = function(text, textCharTypes){
	var ret = false;
	for (var i = 0; i < text.length; i++){
		textCharTypes[i] = _getCharacterType(text.charAt(i));
		if (!ret && (textCharTypes[i] == R || textCharTypes[i] == AL))
			ret = true;
	}
	return ret;
};
exports.getVisualFromLogicalIdx = function(logIdx, rowMap) {
	for (var i = 0; i < rowMap.logicalFromVisual.length; i++) {
		if (rowMap.logicalFromVisual[i] == logIdx)
			return i;
	}
	return 0;
};

});

ace.define("ace/bidihandler",["require","exports","module","ace/lib/bidiutil","ace/lib/lang","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var bidiUtil = acequire("./lib/bidiutil");
var lang = acequire("./lib/lang");
var useragent = acequire("./lib/useragent");
var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
var BidiHandler = function(session) {
    this.session = session;
    this.bidiMap = {};
    this.currentRow = null;
    this.bidiUtil = bidiUtil;
    this.charWidths = [];
    this.EOL = "\xAC";
    this.showInvisibles = true;
    this.isRtlDir = false;
    this.line = "";
    this.wrapIndent = 0;
    this.isLastRow = false;
    this.EOF = "\xB6";
    this.seenBidi = false;
};

(function() {
    this.isBidiRow = function(screenRow, docRow, splitIndex) {
        if (!this.seenBidi)
            return false;
        if (screenRow !== this.currentRow) {
            this.currentRow = screenRow;
            this.updateRowLine(docRow, splitIndex);
            this.updateBidiMap();
        }
        return this.bidiMap.bidiLevels;
    };

    this.onChange = function(delta) {
        if (!this.seenBidi) {
            if (delta.action == "insert" && bidiRE.test(delta.lines.join("\n"))) {
                this.seenBidi = true;
                this.currentRow = null;
            }
        }
        else {
            this.currentRow = null;
        }
    };

    this.getDocumentRow = function() {
        var docRow = 0;
        var rowCache = this.session.$screenRowCache;
        if (rowCache.length) {
            var index = this.session.$getRowCacheIndex(rowCache, this.currentRow);
            if (index >= 0)
                docRow = this.session.$docRowCache[index];
        }

        return docRow;
    };

    this.getSplitIndex = function() {
        var splitIndex = 0;
        var rowCache = this.session.$screenRowCache;
        if (rowCache.length) {
            var currentIndex, prevIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow);
            while (this.currentRow - splitIndex > 0) {
                currentIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow - splitIndex - 1);
                if (currentIndex !== prevIndex)
                    break;

                prevIndex = currentIndex;
                splitIndex++;
            }
        }

        return splitIndex;
    };

    this.updateRowLine = function(docRow, splitIndex) {
        if (docRow === undefined)
            docRow = this.getDocumentRow();

        this.wrapIndent = 0;
        this.isLastRow = (docRow === this.session.getLength() - 1);
        this.line = this.session.getLine(docRow);
        if (this.session.$useWrapMode) {
            var splits = this.session.$wrapData[docRow];
            if (splits) {
                if (splitIndex === undefined)
                    splitIndex = this.getSplitIndex();

                if(splitIndex > 0 && splits.length) {
                    this.wrapIndent = splits.indent;
                    this.line = (splitIndex < splits.length) ?
                        this.line.substring(splits[splitIndex - 1], splits[splits.length - 1]) :
                            this.line.substring(splits[splits.length - 1]);
                } else {
                    this.line = this.line.substring(0, splits[splitIndex]);
                }
            }
        }
        var session = this.session, shift = 0, size;
        this.line = this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function(ch, i){
            if (ch === '\t' || session.isFullWidth(ch.charCodeAt(0))) {
                size = (ch === '\t') ? session.getScreenTabSize(i + shift) : 2;
                shift += size - 1;
                return lang.stringRepeat(bidiUtil.DOT, size);
            }
            return ch;
        });
    };

    this.updateBidiMap = function() {
        var textCharTypes = [], endOfLine = this.isLastRow ? this.EOF : this.EOL;
        var line = this.line + (this.showInvisibles ? endOfLine : bidiUtil.DOT);
        if (bidiUtil.hasBidiCharacters(line, textCharTypes)) {
            this.bidiMap = bidiUtil.doBidiReorder(line, textCharTypes, this.isRtlDir);
        } else {
            this.bidiMap = {};
        }
    };
    this.markAsDirty = function() {
        this.currentRow = null;
    };
    this.updateCharacterWidths = function(fontMetrics) {
        if (!this.seenBidi)
            return;
        if (this.characterWidth === fontMetrics.$characterSize.width)
            return;

        var characterWidth = this.characterWidth = fontMetrics.$characterSize.width;
        var bidiCharWidth = fontMetrics.$measureCharWidth("\u05d4");

        this.charWidths[bidiUtil.L] = this.charWidths[bidiUtil.EN] = this.charWidths[bidiUtil.ON_R] = characterWidth;
        this.charWidths[bidiUtil.R] = this.charWidths[bidiUtil.AN] = bidiCharWidth;
        this.charWidths[bidiUtil.R_H] = useragent.isChrome ? bidiCharWidth : bidiCharWidth * 0.45;
        this.charWidths[bidiUtil.B] = 0;

        this.currentRow = null;
    };

    this.getShowInvisibles = function() {
        return this.showInvisibles;
    };

    this.setShowInvisibles = function(showInvisibles) {
        this.showInvisibles = showInvisibles;
        this.currentRow = null;
    };

    this.setEolChar = function(eolChar) {
        this.EOL = eolChar;
    };

    this.setTextDir = function(isRtlDir) {
        this.isRtlDir = isRtlDir;
    };
    this.getPosLeft = function(col) {
        col -= this.wrapIndent;
        var visualIdx = bidiUtil.getVisualFromLogicalIdx(col > 0 ? col - 1 : 0, this.bidiMap),
            levels = this.bidiMap.bidiLevels, left = 0;

        if (col === 0 && levels[visualIdx] % 2 !== 0)
            visualIdx++;

        for (var i = 0; i < visualIdx; i++) {
            left += this.charWidths[levels[i]];
        }

        if (col !== 0 && levels[visualIdx] % 2 === 0)
            left += this.charWidths[levels[visualIdx]];

        if (this.wrapIndent)
            left += this.wrapIndent * this.charWidths[bidiUtil.L];

        return left;
    };
    this.getSelections = function(startCol, endCol) {
        var map = this.bidiMap, levels = map.bidiLevels, level, offset = this.wrapIndent * this.charWidths[bidiUtil.L], selections = [],
            selColMin = Math.min(startCol, endCol) - this.wrapIndent, selColMax = Math.max(startCol, endCol) - this.wrapIndent,
                isSelected = false, isSelectedPrev = false, selectionStart = 0;

        for (var logIdx, visIdx = 0; visIdx < levels.length; visIdx++) {
            logIdx = map.logicalFromVisual[visIdx];
            level = levels[visIdx];
            isSelected = (logIdx >= selColMin) && (logIdx < selColMax);
            if (isSelected && !isSelectedPrev) {
                selectionStart = offset;
            } else if (!isSelected && isSelectedPrev) {
                selections.push({left: selectionStart, width: offset - selectionStart});
            }
            offset += this.charWidths[level];
            isSelectedPrev = isSelected;
        }

        if (isSelected && (visIdx === levels.length)) {
            selections.push({left: selectionStart, width: offset - selectionStart});
        }

        return selections;
    };
    this.offsetToCol = function(posX) {
        var logicalIdx = 0, posX = Math.max(posX, 0),
            offset = 0, visualIdx = 0, levels = this.bidiMap.bidiLevels,
                charWidth = this.charWidths[levels[visualIdx]];

        if (this.wrapIndent) {
            posX -= this.wrapIndent * this.charWidths[bidiUtil.L];
        }

        while(posX > offset + charWidth/2) {
            offset += charWidth;
            if(visualIdx === levels.length - 1) {
                charWidth = 0;
                break;
            }
            charWidth = this.charWidths[levels[++visualIdx]];
        }

        if (visualIdx > 0 && (levels[visualIdx - 1] % 2 !== 0) && (levels[visualIdx] % 2 === 0)){
            if(posX < offset)
                visualIdx--;
            logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];

        } else if (visualIdx > 0 && (levels[visualIdx - 1] % 2 === 0) && (levels[visualIdx] % 2 !== 0)){
            logicalIdx = 1 + ((posX > offset) ? this.bidiMap.logicalFromVisual[visualIdx]
                    : this.bidiMap.logicalFromVisual[visualIdx - 1]);

        } else if ((this.isRtlDir && visualIdx === levels.length - 1 && charWidth === 0 && (levels[visualIdx - 1] % 2 === 0))
                || (!this.isRtlDir && visualIdx === 0 && (levels[visualIdx] % 2 !== 0))){
            logicalIdx = 1 + this.bidiMap.logicalFromVisual[visualIdx];
        } else {
            if (visualIdx > 0 && (levels[visualIdx - 1] % 2 !== 0) && charWidth !== 0)
                visualIdx--;
            logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
        }

        return (logicalIdx + this.wrapIndent);
    };

}).call(BidiHandler.prototype);

exports.BidiHandler = BidiHandler;
});

ace.define("ace/range",["require","exports","module"], function(acequire, exports, module) {
"use strict";
var comparePoints = function(p1, p2) {
    return p1.row - p2.row || p1.column - p2.column;
};
var Range = function(startRow, startColumn, endRow, endColumn) {
    this.start = {
        row: startRow,
        column: startColumn
    };

    this.end = {
        row: endRow,
        column: endColumn
    };
};

(function() {
    this.isEqual = function(range) {
        return this.start.row === range.start.row &&
            this.end.row === range.end.row &&
            this.start.column === range.start.column &&
            this.end.column === range.end.column;
    };
    this.toString = function() {
        return ("Range: [" + this.start.row + "/" + this.start.column +
            "] -> [" + this.end.row + "/" + this.end.column + "]");
    };

    this.contains = function(row, column) {
        return this.compare(row, column) == 0;
    };
    this.compareRange = function(range) {
        var cmp,
            end = range.end,
            start = range.start;

        cmp = this.compare(end.row, end.column);
        if (cmp == 1) {
            cmp = this.compare(start.row, start.column);
            if (cmp == 1) {
                return 2;
            } else if (cmp == 0) {
                return 1;
            } else {
                return 0;
            }
        } else if (cmp == -1) {
            return -2;
        } else {
            cmp = this.compare(start.row, start.column);
            if (cmp == -1) {
                return -1;
            } else if (cmp == 1) {
                return 42;
            } else {
                return 0;
            }
        }
    };
    this.comparePoint = function(p) {
        return this.compare(p.row, p.column);
    };
    this.containsRange = function(range) {
        return this.comparePoint(range.start) == 0 && this.comparePoint(range.end) == 0;
    };
    this.intersects = function(range) {
        var cmp = this.compareRange(range);
        return (cmp == -1 || cmp == 0 || cmp == 1);
    };
    this.isEnd = function(row, column) {
        return this.end.row == row && this.end.column == column;
    };
    this.isStart = function(row, column) {
        return this.start.row == row && this.start.column == column;
    };
    this.setStart = function(row, column) {
        if (typeof row == "object") {
            this.start.column = row.column;
            this.start.row = row.row;
        } else {
            this.start.row = row;
            this.start.column = column;
        }
    };
    this.setEnd = function(row, column) {
        if (typeof row == "object") {
            this.end.column = row.column;
            this.end.row = row.row;
        } else {
            this.end.row = row;
            this.end.column = column;
        }
    };
    this.inside = function(row, column) {
        if (this.compare(row, column) == 0) {
            if (this.isEnd(row, column) || this.isStart(row, column)) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    };
    this.insideStart = function(row, column) {
        if (this.compare(row, column) == 0) {
            if (this.isEnd(row, column)) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    };
    this.insideEnd = function(row, column) {
        if (this.compare(row, column) == 0) {
            if (this.isStart(row, column)) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    };
    this.compare = function(row, column) {
        if (!this.isMultiLine()) {
            if (row === this.start.row) {
                return column < this.start.column ? -1 : (column > this.end.column ? 1 : 0);
            }
        }

        if (row < this.start.row)
            return -1;

        if (row > this.end.row)
            return 1;

        if (this.start.row === row)
            return column >= this.start.column ? 0 : -1;

        if (this.end.row === row)
            return column <= this.end.column ? 0 : 1;

        return 0;
    };
    this.compareStart = function(row, column) {
        if (this.start.row == row && this.start.column == column) {
            return -1;
        } else {
            return this.compare(row, column);
        }
    };
    this.compareEnd = function(row, column) {
        if (this.end.row == row && this.end.column == column) {
            return 1;
        } else {
            return this.compare(row, column);
        }
    };
    this.compareInside = function(row, column) {
        if (this.end.row == row && this.end.column == column) {
            return 1;
        } else if (this.start.row == row && this.start.column == column) {
            return -1;
        } else {
            return this.compare(row, column);
        }
    };
    this.clipRows = function(firstRow, lastRow) {
        if (this.end.row > lastRow)
            var end = {row: lastRow + 1, column: 0};
        else if (this.end.row < firstRow)
            var end = {row: firstRow, column: 0};

        if (this.start.row > lastRow)
            var start = {row: lastRow + 1, column: 0};
        else if (this.start.row < firstRow)
            var start = {row: firstRow, column: 0};

        return Range.fromPoints(start || this.start, end || this.end);
    };
    this.extend = function(row, column) {
        var cmp = this.compare(row, column);

        if (cmp == 0)
            return this;
        else if (cmp == -1)
            var start = {row: row, column: column};
        else
            var end = {row: row, column: column};

        return Range.fromPoints(start || this.start, end || this.end);
    };

    this.isEmpty = function() {
        return (this.start.row === this.end.row && this.start.column === this.end.column);
    };
    this.isMultiLine = function() {
        return (this.start.row !== this.end.row);
    };
    this.clone = function() {
        return Range.fromPoints(this.start, this.end);
    };
    this.collapseRows = function() {
        if (this.end.column == 0)
            return new Range(this.start.row, 0, Math.max(this.start.row, this.end.row-1), 0);
        else
            return new Range(this.start.row, 0, this.end.row, 0);
    };
    this.toScreenRange = function(session) {
        var screenPosStart = session.documentToScreenPosition(this.start);
        var screenPosEnd = session.documentToScreenPosition(this.end);

        return new Range(
            screenPosStart.row, screenPosStart.column,
            screenPosEnd.row, screenPosEnd.column
        );
    };
    this.moveBy = function(row, column) {
        this.start.row += row;
        this.start.column += column;
        this.end.row += row;
        this.end.column += column;
    };

}).call(Range.prototype);
Range.fromPoints = function(start, end) {
    return new Range(start.row, start.column, end.row, end.column);
};
Range.comparePoints = comparePoints;

Range.comparePoints = function(p1, p2) {
    return p1.row - p2.row || p1.column - p2.column;
};


exports.Range = Range;
});

ace.define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var lang = acequire("./lib/lang");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var Range = acequire("./range").Range;
var Selection = function(session) {
    this.session = session;
    this.doc = session.getDocument();

    this.clearSelection();
    this.lead = this.selectionLead = this.doc.createAnchor(0, 0);
    this.anchor = this.selectionAnchor = this.doc.createAnchor(0, 0);

    var self = this;
    this.lead.on("change", function(e) {
        self._emit("changeCursor");
        if (!self.$isEmpty)
            self._emit("changeSelection");
        if (!self.$keepDesiredColumnOnChange && e.old.column != e.value.column)
            self.$desiredColumn = null;
    });

    this.selectionAnchor.on("change", function() {
        if (!self.$isEmpty)
            self._emit("changeSelection");
    });
};

(function() {

    oop.implement(this, EventEmitter);
    this.isEmpty = function() {
        return (this.$isEmpty || (
            this.anchor.row == this.lead.row &&
            this.anchor.column == this.lead.column
        ));
    };
    this.isMultiLine = function() {
        if (this.isEmpty()) {
            return false;
        }

        return this.getRange().isMultiLine();
    };
    this.getCursor = function() {
        return this.lead.getPosition();
    };
    this.setSelectionAnchor = function(row, column) {
        this.anchor.setPosition(row, column);

        if (this.$isEmpty) {
            this.$isEmpty = false;
            this._emit("changeSelection");
        }
    };
    this.getSelectionAnchor = function() {
        if (this.$isEmpty)
            return this.getSelectionLead();
        else
            return this.anchor.getPosition();
    };
    this.getSelectionLead = function() {
        return this.lead.getPosition();
    };
    this.shiftSelection = function(columns) {
        if (this.$isEmpty) {
            this.moveCursorTo(this.lead.row, this.lead.column + columns);
            return;
        }

        var anchor = this.getSelectionAnchor();
        var lead = this.getSelectionLead();

        var isBackwards = this.isBackwards();

        if (!isBackwards || anchor.column !== 0)
            this.setSelectionAnchor(anchor.row, anchor.column + columns);

        if (isBackwards || lead.column !== 0) {
            this.$moveSelection(function() {
                this.moveCursorTo(lead.row, lead.column + columns);
            });
        }
    };
    this.isBackwards = function() {
        var anchor = this.anchor;
        var lead = this.lead;
        return (anchor.row > lead.row || (anchor.row == lead.row && anchor.column > lead.column));
    };
    this.getRange = function() {
        var anchor = this.anchor;
        var lead = this.lead;

        if (this.isEmpty())
            return Range.fromPoints(lead, lead);

        if (this.isBackwards()) {
            return Range.fromPoints(lead, anchor);
        }
        else {
            return Range.fromPoints(anchor, lead);
        }
    };
    this.clearSelection = function() {
        if (!this.$isEmpty) {
            this.$isEmpty = true;
            this._emit("changeSelection");
        }
    };
    this.selectAll = function() {
        var lastRow = this.doc.getLength() - 1;
        this.setSelectionAnchor(0, 0);
        this.moveCursorTo(lastRow, this.doc.getLine(lastRow).length);
    };
    this.setRange =
    this.setSelectionRange = function(range, reverse) {
        if (reverse) {
            this.setSelectionAnchor(range.end.row, range.end.column);
            this.selectTo(range.start.row, range.start.column);
        } else {
            this.setSelectionAnchor(range.start.row, range.start.column);
            this.selectTo(range.end.row, range.end.column);
        }
        if (this.getRange().isEmpty())
            this.$isEmpty = true;
        this.$desiredColumn = null;
    };

    this.$moveSelection = function(mover) {
        var lead = this.lead;
        if (this.$isEmpty)
            this.setSelectionAnchor(lead.row, lead.column);

        mover.call(this);
    };
    this.selectTo = function(row, column) {
        this.$moveSelection(function() {
            this.moveCursorTo(row, column);
        });
    };
    this.selectToPosition = function(pos) {
        this.$moveSelection(function() {
            this.moveCursorToPosition(pos);
        });
    };
    this.moveTo = function(row, column) {
        this.clearSelection();
        this.moveCursorTo(row, column);
    };
    this.moveToPosition = function(pos) {
        this.clearSelection();
        this.moveCursorToPosition(pos);
    };
    this.selectUp = function() {
        this.$moveSelection(this.moveCursorUp);
    };
    this.selectDown = function() {
        this.$moveSelection(this.moveCursorDown);
    };
    this.selectRight = function() {
        this.$moveSelection(this.moveCursorRight);
    };
    this.selectLeft = function() {
        this.$moveSelection(this.moveCursorLeft);
    };
    this.selectLineStart = function() {
        this.$moveSelection(this.moveCursorLineStart);
    };
    this.selectLineEnd = function() {
        this.$moveSelection(this.moveCursorLineEnd);
    };
    this.selectFileEnd = function() {
        this.$moveSelection(this.moveCursorFileEnd);
    };
    this.selectFileStart = function() {
        this.$moveSelection(this.moveCursorFileStart);
    };
    this.selectWordRight = function() {
        this.$moveSelection(this.moveCursorWordRight);
    };
    this.selectWordLeft = function() {
        this.$moveSelection(this.moveCursorWordLeft);
    };
    this.getWordRange = function(row, column) {
        if (typeof column == "undefined") {
            var cursor = row || this.lead;
            row = cursor.row;
            column = cursor.column;
        }
        return this.session.getWordRange(row, column);
    };
    this.selectWord = function() {
        this.setSelectionRange(this.getWordRange());
    };
    this.selectAWord = function() {
        var cursor = this.getCursor();
        var range = this.session.getAWordRange(cursor.row, cursor.column);
        this.setSelectionRange(range);
    };

    this.getLineRange = function(row, excludeLastChar) {
        var rowStart = typeof row == "number" ? row : this.lead.row;
        var rowEnd;

        var foldLine = this.session.getFoldLine(rowStart);
        if (foldLine) {
            rowStart = foldLine.start.row;
            rowEnd = foldLine.end.row;
        } else {
            rowEnd = rowStart;
        }
        if (excludeLastChar === true)
            return new Range(rowStart, 0, rowEnd, this.session.getLine(rowEnd).length);
        else
            return new Range(rowStart, 0, rowEnd + 1, 0);
    };
    this.selectLine = function() {
        this.setSelectionRange(this.getLineRange());
    };
    this.moveCursorUp = function() {
        this.moveCursorBy(-1, 0);
    };
    this.moveCursorDown = function() {
        this.moveCursorBy(1, 0);
    };
    this.wouldMoveIntoSoftTab = function(cursor, tabSize, direction) {
        var start = cursor.column;
        var end = cursor.column + tabSize;

        if (direction < 0) {
            start = cursor.column - tabSize;
            end = cursor.column;
        }
        return this.session.isTabStop(cursor) && this.doc.getLine(cursor.row).slice(start, end).split(" ").length-1 == tabSize;
    };
    this.moveCursorLeft = function() {
        var cursor = this.lead.getPosition(),
            fold;

        if (fold = this.session.getFoldAt(cursor.row, cursor.column, -1)) {
            this.moveCursorTo(fold.start.row, fold.start.column);
        } else if (cursor.column === 0) {
            if (cursor.row > 0) {
                this.moveCursorTo(cursor.row - 1, this.doc.getLine(cursor.row - 1).length);
            }
        }
        else {
            var tabSize = this.session.getTabSize();
            if (this.wouldMoveIntoSoftTab(cursor, tabSize, -1) && !this.session.getNavigateWithinSoftTabs()) {
                this.moveCursorBy(0, -tabSize);
            } else {
                this.moveCursorBy(0, -1);
            }
        }
    };
    this.moveCursorRight = function() {
        var cursor = this.lead.getPosition(),
            fold;
        if (fold = this.session.getFoldAt(cursor.row, cursor.column, 1)) {
            this.moveCursorTo(fold.end.row, fold.end.column);
        }
        else if (this.lead.column == this.doc.getLine(this.lead.row).length) {
            if (this.lead.row < this.doc.getLength() - 1) {
                this.moveCursorTo(this.lead.row + 1, 0);
            }
        }
        else {
            var tabSize = this.session.getTabSize();
            var cursor = this.lead;
            if (this.wouldMoveIntoSoftTab(cursor, tabSize, 1) && !this.session.getNavigateWithinSoftTabs()) {
                this.moveCursorBy(0, tabSize);
            } else {
                this.moveCursorBy(0, 1);
            }
        }
    };
    this.moveCursorLineStart = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var screenRow = this.session.documentToScreenRow(row, column);
        var firstColumnPosition = this.session.screenToDocumentPosition(screenRow, 0);
        var beforeCursor = this.session.getDisplayLine(
            row, null, firstColumnPosition.row,
            firstColumnPosition.column
        );

        var leadingSpace = beforeCursor.match(/^\s*/);
        if (leadingSpace[0].length != column && !this.session.$useEmacsStyleLineStart)
            firstColumnPosition.column += leadingSpace[0].length;
        this.moveCursorToPosition(firstColumnPosition);
    };
    this.moveCursorLineEnd = function() {
        var lead = this.lead;
        var lineEnd = this.session.getDocumentLastRowColumnPosition(lead.row, lead.column);
        if (this.lead.column == lineEnd.column) {
            var line = this.session.getLine(lineEnd.row);
            if (lineEnd.column == line.length) {
                var textEnd = line.search(/\s+$/);
                if (textEnd > 0)
                    lineEnd.column = textEnd;
            }
        }

        this.moveCursorTo(lineEnd.row, lineEnd.column);
    };
    this.moveCursorFileEnd = function() {
        var row = this.doc.getLength() - 1;
        var column = this.doc.getLine(row).length;
        this.moveCursorTo(row, column);
    };
    this.moveCursorFileStart = function() {
        this.moveCursorTo(0, 0);
    };
    this.moveCursorLongWordRight = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var line = this.doc.getLine(row);
        var rightOfCursor = line.substring(column);

        var match;
        this.session.nonTokenRe.lastIndex = 0;
        this.session.tokenRe.lastIndex = 0;
        var fold = this.session.getFoldAt(row, column, 1);
        if (fold) {
            this.moveCursorTo(fold.end.row, fold.end.column);
            return;
        }
        if (match = this.session.nonTokenRe.exec(rightOfCursor)) {
            column += this.session.nonTokenRe.lastIndex;
            this.session.nonTokenRe.lastIndex = 0;
            rightOfCursor = line.substring(column);
        }
        if (column >= line.length) {
            this.moveCursorTo(row, line.length);
            this.moveCursorRight();
            if (row < this.doc.getLength() - 1)
                this.moveCursorWordRight();
            return;
        }
        if (match = this.session.tokenRe.exec(rightOfCursor)) {
            column += this.session.tokenRe.lastIndex;
            this.session.tokenRe.lastIndex = 0;
        }

        this.moveCursorTo(row, column);
    };
    this.moveCursorLongWordLeft = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var fold;
        if (fold = this.session.getFoldAt(row, column, -1)) {
            this.moveCursorTo(fold.start.row, fold.start.column);
            return;
        }

        var str = this.session.getFoldStringAt(row, column, -1);
        if (str == null) {
            str = this.doc.getLine(row).substring(0, column);
        }

        var leftOfCursor = lang.stringReverse(str);
        var match;
        this.session.nonTokenRe.lastIndex = 0;
        this.session.tokenRe.lastIndex = 0;
        if (match = this.session.nonTokenRe.exec(leftOfCursor)) {
            column -= this.session.nonTokenRe.lastIndex;
            leftOfCursor = leftOfCursor.slice(this.session.nonTokenRe.lastIndex);
            this.session.nonTokenRe.lastIndex = 0;
        }
        if (column <= 0) {
            this.moveCursorTo(row, 0);
            this.moveCursorLeft();
            if (row > 0)
                this.moveCursorWordLeft();
            return;
        }
        if (match = this.session.tokenRe.exec(leftOfCursor)) {
            column -= this.session.tokenRe.lastIndex;
            this.session.tokenRe.lastIndex = 0;
        }

        this.moveCursorTo(row, column);
    };

    this.$shortWordEndIndex = function(rightOfCursor) {
        var match, index = 0, ch;
        var whitespaceRe = /\s/;
        var tokenRe = this.session.tokenRe;

        tokenRe.lastIndex = 0;
        if (match = this.session.tokenRe.exec(rightOfCursor)) {
            index = this.session.tokenRe.lastIndex;
        } else {
            while ((ch = rightOfCursor[index]) && whitespaceRe.test(ch))
                index ++;

            if (index < 1) {
                tokenRe.lastIndex = 0;
                 while ((ch = rightOfCursor[index]) && !tokenRe.test(ch)) {
                    tokenRe.lastIndex = 0;
                    index ++;
                    if (whitespaceRe.test(ch)) {
                        if (index > 2) {
                            index--;
                            break;
                        } else {
                            while ((ch = rightOfCursor[index]) && whitespaceRe.test(ch))
                                index ++;
                            if (index > 2)
                                break;
                        }
                    }
                }
            }
        }
        tokenRe.lastIndex = 0;

        return index;
    };

    this.moveCursorShortWordRight = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var line = this.doc.getLine(row);
        var rightOfCursor = line.substring(column);

        var fold = this.session.getFoldAt(row, column, 1);
        if (fold)
            return this.moveCursorTo(fold.end.row, fold.end.column);

        if (column == line.length) {
            var l = this.doc.getLength();
            do {
                row++;
                rightOfCursor = this.doc.getLine(row);
            } while (row < l && /^\s*$/.test(rightOfCursor));

            if (!/^\s+/.test(rightOfCursor))
                rightOfCursor = "";
            column = 0;
        }

        var index = this.$shortWordEndIndex(rightOfCursor);

        this.moveCursorTo(row, column + index);
    };

    this.moveCursorShortWordLeft = function() {
        var row = this.lead.row;
        var column = this.lead.column;

        var fold;
        if (fold = this.session.getFoldAt(row, column, -1))
            return this.moveCursorTo(fold.start.row, fold.start.column);

        var line = this.session.getLine(row).substring(0, column);
        if (column === 0) {
            do {
                row--;
                line = this.doc.getLine(row);
            } while (row > 0 && /^\s*$/.test(line));

            column = line.length;
            if (!/\s+$/.test(line))
                line = "";
        }

        var leftOfCursor = lang.stringReverse(line);
        var index = this.$shortWordEndIndex(leftOfCursor);

        return this.moveCursorTo(row, column - index);
    };

    this.moveCursorWordRight = function() {
        if (this.session.$selectLongWords)
            this.moveCursorLongWordRight();
        else
            this.moveCursorShortWordRight();
    };

    this.moveCursorWordLeft = function() {
        if (this.session.$selectLongWords)
            this.moveCursorLongWordLeft();
        else
            this.moveCursorShortWordLeft();
    };
    this.moveCursorBy = function(rows, chars) {
        var screenPos = this.session.documentToScreenPosition(
            this.lead.row,
            this.lead.column
        );

        var offsetX;

        if (chars === 0) {
            if (rows !== 0) {
                if (this.session.$bidiHandler.isBidiRow(screenPos.row, this.lead.row)) {
                    offsetX = this.session.$bidiHandler.getPosLeft(screenPos.column);
                    screenPos.column = Math.round(offsetX / this.session.$bidiHandler.charWidths[0]);
                } else {
                    offsetX = screenPos.column * this.session.$bidiHandler.charWidths[0];
                }
            }

            if (this.$desiredColumn)
                screenPos.column = this.$desiredColumn;
            else
                this.$desiredColumn = screenPos.column;
        }

        var docPos = this.session.screenToDocumentPosition(screenPos.row + rows, screenPos.column, offsetX);
        
        if (rows !== 0 && chars === 0 && docPos.row === this.lead.row && docPos.column === this.lead.column) {
            if (this.session.lineWidgets && this.session.lineWidgets[docPos.row]) {
                if (docPos.row > 0 || rows > 0)
                    docPos.row++;
            }
        }
        this.moveCursorTo(docPos.row, docPos.column + chars, chars === 0);
    };
    this.moveCursorToPosition = function(position) {
        this.moveCursorTo(position.row, position.column);
    };
    this.moveCursorTo = function(row, column, keepDesiredColumn) {
        var fold = this.session.getFoldAt(row, column, 1);
        if (fold) {
            row = fold.start.row;
            column = fold.start.column;
        }

        this.$keepDesiredColumnOnChange = true;
        var line = this.session.getLine(row);
        if (/[\uDC00-\uDFFF]/.test(line.charAt(column)) && line.charAt(column - 1)) {
            if (this.lead.row == row && this.lead.column == column + 1)
                column = column - 1;
            else
                column = column + 1;
        }
        this.lead.setPosition(row, column);
        this.$keepDesiredColumnOnChange = false;

        if (!keepDesiredColumn)
            this.$desiredColumn = null;
    };
    this.moveCursorToScreen = function(row, column, keepDesiredColumn) {
        var pos = this.session.screenToDocumentPosition(row, column);
        this.moveCursorTo(pos.row, pos.column, keepDesiredColumn);
    };
    this.detach = function() {
        this.lead.detach();
        this.anchor.detach();
        this.session = this.doc = null;
    };

    this.fromOrientedRange = function(range) {
        this.setSelectionRange(range, range.cursor == range.start);
        this.$desiredColumn = range.desiredColumn || this.$desiredColumn;
    };

    this.toOrientedRange = function(range) {
        var r = this.getRange();
        if (range) {
            range.start.column = r.start.column;
            range.start.row = r.start.row;
            range.end.column = r.end.column;
            range.end.row = r.end.row;
        } else {
            range = r;
        }

        range.cursor = this.isBackwards() ? range.start : range.end;
        range.desiredColumn = this.$desiredColumn;
        return range;
    };
    this.getRangeOfMovements = function(func) {
        var start = this.getCursor();
        try {
            func(this);
            var end = this.getCursor();
            return Range.fromPoints(start,end);
        } catch(e) {
            return Range.fromPoints(start,start);
        } finally {
            this.moveCursorToPosition(start);
        }
    };

    this.toJSON = function() {
        if (this.rangeCount) {
            var data = this.ranges.map(function(r) {
                var r1 = r.clone();
                r1.isBackwards = r.cursor == r.start;
                return r1;
            });
        } else {
            var data = this.getRange();
            data.isBackwards = this.isBackwards();
        }
        return data;
    };

    this.fromJSON = function(data) {
        if (data.start == undefined) {
            if (this.rangeList) {
                this.toSingleRange(data[0]);
                for (var i = data.length; i--; ) {
                    var r = Range.fromPoints(data[i].start, data[i].end);
                    if (data[i].isBackwards)
                        r.cursor = r.start;
                    this.addRange(r, true);
                }
                return;
            } else
                data = data[0];
        }
        if (this.rangeList)
            this.toSingleRange(data);
        this.setSelectionRange(data, data.isBackwards);
    };

    this.isEqual = function(data) {
        if ((data.length || this.rangeCount) && data.length != this.rangeCount)
            return false;
        if (!data.length || !this.ranges)
            return this.getRange().isEqual(data);

        for (var i = this.ranges.length; i--; ) {
            if (!this.ranges[i].isEqual(data[i]))
                return false;
        }
        return true;
    };

}).call(Selection.prototype);

exports.Selection = Selection;
});

ace.define("ace/tokenizer",["require","exports","module","ace/config"], function(acequire, exports, module) {
"use strict";

var config = acequire("./config");
var MAX_TOKEN_COUNT = 2000;
var Tokenizer = function(rules) {
    this.states = rules;

    this.regExps = {};
    this.matchMappings = {};
    for (var key in this.states) {
        var state = this.states[key];
        var ruleRegExps = [];
        var matchTotal = 0;
        var mapping = this.matchMappings[key] = {defaultToken: "text"};
        var flag = "g";

        var splitterRurles = [];
        for (var i = 0; i < state.length; i++) {
            var rule = state[i];
            if (rule.defaultToken)
                mapping.defaultToken = rule.defaultToken;
            if (rule.caseInsensitive)
                flag = "gi";
            if (rule.regex == null)
                continue;

            if (rule.regex instanceof RegExp)
                rule.regex = rule.regex.toString().slice(1, -1);
            var adjustedregex = rule.regex;
            var matchcount = new RegExp("(?:(" + adjustedregex + ")|(.))").exec("a").length - 2;
            if (Array.isArray(rule.token)) {
                if (rule.token.length == 1 || matchcount == 1) {
                    rule.token = rule.token[0];
                } else if (matchcount - 1 != rule.token.length) {
                    this.reportError("number of classes and regexp groups doesn't match", { 
                        rule: rule,
                        groupCount: matchcount - 1
                    });
                    rule.token = rule.token[0];
                } else {
                    rule.tokenArray = rule.token;
                    rule.token = null;
                    rule.onMatch = this.$arrayTokens;
                }
            } else if (typeof rule.token == "function" && !rule.onMatch) {
                if (matchcount > 1)
                    rule.onMatch = this.$applyToken;
                else
                    rule.onMatch = rule.token;
            }

            if (matchcount > 1) {
                if (/\\\d/.test(rule.regex)) {
                    adjustedregex = rule.regex.replace(/\\([0-9]+)/g, function(match, digit) {
                        return "\\" + (parseInt(digit, 10) + matchTotal + 1);
                    });
                } else {
                    matchcount = 1;
                    adjustedregex = this.removeCapturingGroups(rule.regex);
                }
                if (!rule.splitRegex && typeof rule.token != "string")
                    splitterRurles.push(rule); // flag will be known only at the very end
            }

            mapping[matchTotal] = i;
            matchTotal += matchcount;

            ruleRegExps.push(adjustedregex);
            if (!rule.onMatch)
                rule.onMatch = null;
        }
        
        if (!ruleRegExps.length) {
            mapping[0] = 0;
            ruleRegExps.push("$");
        }
        
        splitterRurles.forEach(function(rule) {
            rule.splitRegex = this.createSplitterRegexp(rule.regex, flag);
        }, this);

        this.regExps[key] = new RegExp("(" + ruleRegExps.join(")|(") + ")|($)", flag);
    }
};

(function() {
    this.$setMaxTokenCount = function(m) {
        MAX_TOKEN_COUNT = m | 0;
    };
    
    this.$applyToken = function(str) {
        var values = this.splitRegex.exec(str).slice(1);
        var types = this.token.apply(this, values);
        if (typeof types === "string")
            return [{type: types, value: str}];

        var tokens = [];
        for (var i = 0, l = types.length; i < l; i++) {
            if (values[i])
                tokens[tokens.length] = {
                    type: types[i],
                    value: values[i]
                };
        }
        return tokens;
    };

    this.$arrayTokens = function(str) {
        if (!str)
            return [];
        var values = this.splitRegex.exec(str);
        if (!values)
            return "text";
        var tokens = [];
        var types = this.tokenArray;
        for (var i = 0, l = types.length; i < l; i++) {
            if (values[i + 1])
                tokens[tokens.length] = {
                    type: types[i],
                    value: values[i + 1]
                };
        }
        return tokens;
    };

    this.removeCapturingGroups = function(src) {
        var r = src.replace(
            /\[(?:\\.|[^\]])*?\]|\\.|\(\?[:=!]|(\()/g,
            function(x, y) {return y ? "(?:" : x;}
        );
        return r;
    };

    this.createSplitterRegexp = function(src, flag) {
        if (src.indexOf("(?=") != -1) {
            var stack = 0;
            var inChClass = false;
            var lastCapture = {};
            src.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(
                m, esc, parenOpen, parenClose, square, index
            ) {
                if (inChClass) {
                    inChClass = square != "]";
                } else if (square) {
                    inChClass = true;
                } else if (parenClose) {
                    if (stack == lastCapture.stack) {
                        lastCapture.end = index+1;
                        lastCapture.stack = -1;
                    }
                    stack--;
                } else if (parenOpen) {
                    stack++;
                    if (parenOpen.length != 1) {
                        lastCapture.stack = stack;
                        lastCapture.start = index;
                    }
                }
                return m;
            });

            if (lastCapture.end != null && /^\)*$/.test(src.substr(lastCapture.end)))
                src = src.substring(0, lastCapture.start) + src.substr(lastCapture.end);
        }
        if (src.charAt(0) != "^") src = "^" + src;
        if (src.charAt(src.length - 1) != "$") src += "$";
        
        return new RegExp(src, (flag||"").replace("g", ""));
    };
    this.getLineTokens = function(line, startState) {
        if (startState && typeof startState != "string") {
            var stack = startState.slice(0);
            startState = stack[0];
            if (startState === "#tmp") {
                stack.shift();
                startState = stack.shift();
            }
        } else
            var stack = [];

        var currentState = startState || "start";
        var state = this.states[currentState];
        if (!state) {
            currentState = "start";
            state = this.states[currentState];
        }
        var mapping = this.matchMappings[currentState];
        var re = this.regExps[currentState];
        re.lastIndex = 0;

        var match, tokens = [];
        var lastIndex = 0;
        var matchAttempts = 0;

        var token = {type: null, value: ""};

        while (match = re.exec(line)) {
            var type = mapping.defaultToken;
            var rule = null;
            var value = match[0];
            var index = re.lastIndex;

            if (index - value.length > lastIndex) {
                var skipped = line.substring(lastIndex, index - value.length);
                if (token.type == type) {
                    token.value += skipped;
                } else {
                    if (token.type)
                        tokens.push(token);
                    token = {type: type, value: skipped};
                }
            }

            for (var i = 0; i < match.length-2; i++) {
                if (match[i + 1] === undefined)
                    continue;

                rule = state[mapping[i]];

                if (rule.onMatch)
                    type = rule.onMatch(value, currentState, stack, line);
                else
                    type = rule.token;

                if (rule.next) {
                    if (typeof rule.next == "string") {
                        currentState = rule.next;
                    } else {
                        currentState = rule.next(currentState, stack);
                    }
                    
                    state = this.states[currentState];
                    if (!state) {
                        this.reportError("state doesn't exist", currentState);
                        currentState = "start";
                        state = this.states[currentState];
                    }
                    mapping = this.matchMappings[currentState];
                    lastIndex = index;
                    re = this.regExps[currentState];
                    re.lastIndex = index;
                }
                if (rule.consumeLineEnd)
                    lastIndex = index;
                break;
            }

            if (value) {
                if (typeof type === "string") {
                    if ((!rule || rule.merge !== false) && token.type === type) {
                        token.value += value;
                    } else {
                        if (token.type)
                            tokens.push(token);
                        token = {type: type, value: value};
                    }
                } else if (type) {
                    if (token.type)
                        tokens.push(token);
                    token = {type: null, value: ""};
                    for (var i = 0; i < type.length; i++)
                        tokens.push(type[i]);
                }
            }

            if (lastIndex == line.length)
                break;

            lastIndex = index;

            if (matchAttempts++ > MAX_TOKEN_COUNT) {
                if (matchAttempts > 2 * line.length) {
                    this.reportError("infinite loop with in ace tokenizer", {
                        startState: startState,
                        line: line
                    });
                }
                while (lastIndex < line.length) {
                    if (token.type)
                        tokens.push(token);
                    token = {
                        value: line.substring(lastIndex, lastIndex += 2000),
                        type: "overflow"
                    };
                }
                currentState = "start";
                stack = [];
                break;
            }
        }

        if (token.type)
            tokens.push(token);
        
        if (stack.length > 1) {
            if (stack[0] !== currentState)
                stack.unshift("#tmp", currentState);
        }
        return {
            tokens : tokens,
            state : stack.length ? stack : currentState
        };
    };
    
    this.reportError = config.reportError;
    
}).call(Tokenizer.prototype);

exports.Tokenizer = Tokenizer;
});

ace.define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/lang"], function(acequire, exports, module) {
"use strict";

var lang = acequire("../lib/lang");

var TextHighlightRules = function() {

    this.$rules = {
        "start" : [{
            token : "empty_line",
            regex : '^$'
        }, {
            defaultToken : "text"
        }]
    };
};

(function() {

    this.addRules = function(rules, prefix) {
        if (!prefix) {
            for (var key in rules)
                this.$rules[key] = rules[key];
            return;
        }
        for (var key in rules) {
            var state = rules[key];
            for (var i = 0; i < state.length; i++) {
                var rule = state[i];
                if (rule.next || rule.onMatch) {
                    if (typeof rule.next == "string") {
                        if (rule.next.indexOf(prefix) !== 0)
                            rule.next = prefix + rule.next;
                    }
                    if (rule.nextState && rule.nextState.indexOf(prefix) !== 0)
                        rule.nextState = prefix + rule.nextState;
                }
            }
            this.$rules[prefix + key] = state;
        }
    };

    this.getRules = function() {
        return this.$rules;
    };

    this.embedRules = function (HighlightRules, prefix, escapeRules, states, append) {
        var embedRules = typeof HighlightRules == "function"
            ? new HighlightRules().getRules()
            : HighlightRules;
        if (states) {
            for (var i = 0; i < states.length; i++)
                states[i] = prefix + states[i];
        } else {
            states = [];
            for (var key in embedRules)
                states.push(prefix + key);
        }

        this.addRules(embedRules, prefix);

        if (escapeRules) {
            var addRules = Array.prototype[append ? "push" : "unshift"];
            for (var i = 0; i < states.length; i++)
                addRules.apply(this.$rules[states[i]], lang.deepCopy(escapeRules));
        }

        if (!this.$embeds)
            this.$embeds = [];
        this.$embeds.push(prefix);
    };

    this.getEmbeds = function() {
        return this.$embeds;
    };

    var pushState = function(currentState, stack) {
        if (currentState != "start" || stack.length)
            stack.unshift(this.nextState, currentState);
        return this.nextState;
    };
    var popState = function(currentState, stack) {
        stack.shift();
        return stack.shift() || "start";
    };

    this.normalizeRules = function() {
        var id = 0;
        var rules = this.$rules;
        function processState(key) {
            var state = rules[key];
            state.processed = true;
            for (var i = 0; i < state.length; i++) {
                var rule = state[i];
                var toInsert = null;
                if (Array.isArray(rule)) {
                    toInsert = rule;
                    rule = {};
                }
                if (!rule.regex && rule.start) {
                    rule.regex = rule.start;
                    if (!rule.next)
                        rule.next = [];
                    rule.next.push({
                        defaultToken: rule.token
                    }, {
                        token: rule.token + ".end",
                        regex: rule.end || rule.start,
                        next: "pop"
                    });
                    rule.token = rule.token + ".start";
                    rule.push = true;
                }
                var next = rule.next || rule.push;
                if (next && Array.isArray(next)) {
                    var stateName = rule.stateName;
                    if (!stateName)  {
                        stateName = rule.token;
                        if (typeof stateName != "string")
                            stateName = stateName[0] || "";
                        if (rules[stateName])
                            stateName += id++;
                    }
                    rules[stateName] = next;
                    rule.next = stateName;
                    processState(stateName);
                } else if (next == "pop") {
                    rule.next = popState;
                }

                if (rule.push) {
                    rule.nextState = rule.next || rule.push;
                    rule.next = pushState;
                    delete rule.push;
                }

                if (rule.rules) {
                    for (var r in rule.rules) {
                        if (rules[r]) {
                            if (rules[r].push)
                                rules[r].push.apply(rules[r], rule.rules[r]);
                        } else {
                            rules[r] = rule.rules[r];
                        }
                    }
                }
                var includeName = typeof rule == "string" ? rule : rule.include;
                if (includeName) {
                    if (Array.isArray(includeName))
                        toInsert = includeName.map(function(x) { return rules[x]; });
                    else
                        toInsert = rules[includeName];
                }

                if (toInsert) {
                    var args = [i, 1].concat(toInsert);
                    if (rule.noEscape)
                        args = args.filter(function(x) {return !x.next;});
                    state.splice.apply(state, args);
                    i--;
                }
                
                if (rule.keywordMap) {
                    rule.token = this.createKeywordMapper(
                        rule.keywordMap, rule.defaultToken || "text", rule.caseInsensitive
                    );
                    delete rule.defaultToken;
                }
            }
        }
        Object.keys(rules).forEach(processState, this);
    };

    this.createKeywordMapper = function(map, defaultToken, ignoreCase, splitChar) {
        var keywords = Object.create(null);
        Object.keys(map).forEach(function(className) {
            var a = map[className];
            if (ignoreCase)
                a = a.toLowerCase();
            var list = a.split(splitChar || "|");
            for (var i = list.length; i--; )
                keywords[list[i]] = className;
        });
        if (Object.getPrototypeOf(keywords)) {
            keywords.__proto__ = null;
        }
        this.$keywordList = Object.keys(keywords);
        map = null;
        return ignoreCase
            ? function(value) {return keywords[value.toLowerCase()] || defaultToken; }
            : function(value) {return keywords[value] || defaultToken; };
    };

    this.getKeywords = function() {
        return this.$keywords;
    };

}).call(TextHighlightRules.prototype);

exports.TextHighlightRules = TextHighlightRules;
});

ace.define("ace/mode/behaviour",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var Behaviour = function() {
   this.$behaviours = {};
};

(function () {

    this.add = function (name, action, callback) {
        switch (undefined) {
          case this.$behaviours:
              this.$behaviours = {};
          case this.$behaviours[name]:
              this.$behaviours[name] = {};
        }
        this.$behaviours[name][action] = callback;
    };
    
    this.addBehaviours = function (behaviours) {
        for (var key in behaviours) {
            for (var action in behaviours[key]) {
                this.add(key, action, behaviours[key][action]);
            }
        }
    };
    
    this.remove = function (name) {
        if (this.$behaviours && this.$behaviours[name]) {
            delete this.$behaviours[name];
        }
    };
    
    this.inherit = function (mode, filter) {
        if (typeof mode === "function") {
            var behaviours = new mode().getBehaviours(filter);
        } else {
            var behaviours = mode.getBehaviours(filter);
        }
        this.addBehaviours(behaviours);
    };
    
    this.getBehaviours = function (filter) {
        if (!filter) {
            return this.$behaviours;
        } else {
            var ret = {};
            for (var i = 0; i < filter.length; i++) {
                if (this.$behaviours[filter[i]]) {
                    ret[filter[i]] = this.$behaviours[filter[i]];
                }
            }
            return ret;
        }
    };

}).call(Behaviour.prototype);

exports.Behaviour = Behaviour;
});

ace.define("ace/token_iterator",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("./range").Range;
var TokenIterator = function(session, initialRow, initialColumn) {
    this.$session = session;
    this.$row = initialRow;
    this.$rowTokens = session.getTokens(initialRow);

    var token = session.getTokenAt(initialRow, initialColumn);
    this.$tokenIndex = token ? token.index : -1;
};

(function() { 
    this.stepBackward = function() {
        this.$tokenIndex -= 1;
        
        while (this.$tokenIndex < 0) {
            this.$row -= 1;
            if (this.$row < 0) {
                this.$row = 0;
                return null;
            }
                
            this.$rowTokens = this.$session.getTokens(this.$row);
            this.$tokenIndex = this.$rowTokens.length - 1;
        }
            
        return this.$rowTokens[this.$tokenIndex];
    };   
    this.stepForward = function() {
        this.$tokenIndex += 1;
        var rowCount;
        while (this.$tokenIndex >= this.$rowTokens.length) {
            this.$row += 1;
            if (!rowCount)
                rowCount = this.$session.getLength();
            if (this.$row >= rowCount) {
                this.$row = rowCount - 1;
                return null;
            }

            this.$rowTokens = this.$session.getTokens(this.$row);
            this.$tokenIndex = 0;
        }
            
        return this.$rowTokens[this.$tokenIndex];
    };      
    this.getCurrentToken = function () {
        return this.$rowTokens[this.$tokenIndex];
    };      
    this.getCurrentTokenRow = function () {
        return this.$row;
    };     
    this.getCurrentTokenColumn = function() {
        var rowTokens = this.$rowTokens;
        var tokenIndex = this.$tokenIndex;
        var column = rowTokens[tokenIndex].start;
        if (column !== undefined)
            return column;
            
        column = 0;
        while (tokenIndex > 0) {
            tokenIndex -= 1;
            column += rowTokens[tokenIndex].value.length;
        }
        
        return column;  
    };
    this.getCurrentTokenPosition = function() {
        return {row: this.$row, column: this.getCurrentTokenColumn()};
    };
    this.getCurrentTokenRange = function() {
        var token = this.$rowTokens[this.$tokenIndex];
        var column = this.getCurrentTokenColumn();
        return new Range(this.$row, column, this.$row, column + token.value.length);
    };

}).call(TokenIterator.prototype);

exports.TokenIterator = TokenIterator;
});

ace.define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Behaviour = acequire("../behaviour").Behaviour;
var TokenIterator = acequire("../../token_iterator").TokenIterator;
var lang = acequire("../../lib/lang");

var SAFE_INSERT_IN_TOKENS =
    ["text", "paren.rparen", "punctuation.operator"];
var SAFE_INSERT_BEFORE_TOKENS =
    ["text", "paren.rparen", "punctuation.operator", "comment"];

var context;
var contextCache = {};
var defaultQuotes = {'"' : '"', "'" : "'"};

var initContext = function(editor) {
    var id = -1;
    if (editor.multiSelect) {
        id = editor.selection.index;
        if (contextCache.rangeCount != editor.multiSelect.rangeCount)
            contextCache = {rangeCount: editor.multiSelect.rangeCount};
    }
    if (contextCache[id])
        return context = contextCache[id];
    context = contextCache[id] = {
        autoInsertedBrackets: 0,
        autoInsertedRow: -1,
        autoInsertedLineEnd: "",
        maybeInsertedBrackets: 0,
        maybeInsertedRow: -1,
        maybeInsertedLineStart: "",
        maybeInsertedLineEnd: ""
    };
};

var getWrapped = function(selection, selected, opening, closing) {
    var rowDiff = selection.end.row - selection.start.row;
    return {
        text: opening + selected + closing,
        selection: [
                0,
                selection.start.column + 1,
                rowDiff,
                selection.end.column + (rowDiff ? 0 : 1)
            ]
    };
};

var CstyleBehaviour = function(options) {
    this.add("braces", "insertion", function(state, action, editor, session, text) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (text == '{') {
            initContext(editor);
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && selected !== "{" && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, '{', '}');
            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                if (/[\]\}\)]/.test(line[cursor.column]) || editor.inMultiSelectMode || options && options.braces) {
                    CstyleBehaviour.recordAutoInsert(editor, session, "}");
                    return {
                        text: '{}',
                        selection: [1, 1]
                    };
                } else {
                    CstyleBehaviour.recordMaybeInsert(editor, session, "{");
                    return {
                        text: '{',
                        selection: [1, 1]
                    };
                }
            }
        } else if (text == '}') {
            initContext(editor);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar == '}') {
                var matching = session.$findOpeningBracket('}', {column: cursor.column + 1, row: cursor.row});
                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                    CstyleBehaviour.popAutoInsertedClosing();
                    return {
                        text: '',
                        selection: [1, 1]
                    };
                }
            }
        } else if (text == "\n" || text == "\r\n") {
            initContext(editor);
            var closing = "";
            if (CstyleBehaviour.isMaybeInsertedClosing(cursor, line)) {
                closing = lang.stringRepeat("}", context.maybeInsertedBrackets);
                CstyleBehaviour.clearMaybeInsertedClosing();
            }
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar === '}') {
                var openBracePos = session.findMatchingBracket({row: cursor.row, column: cursor.column+1}, '}');
                if (!openBracePos)
                     return null;
                var next_indent = this.$getIndent(session.getLine(openBracePos.row));
            } else if (closing) {
                var next_indent = this.$getIndent(line);
            } else {
                CstyleBehaviour.clearMaybeInsertedClosing();
                return;
            }
            var indent = next_indent + session.getTabString();

            return {
                text: '\n' + indent + '\n' + next_indent + closing,
                selection: [1, indent.length, 1, indent.length]
            };
        } else {
            CstyleBehaviour.clearMaybeInsertedClosing();
        }
    });

    this.add("braces", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && selected == '{') {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.end.column, range.end.column + 1);
            if (rightChar == '}') {
                range.end.column++;
                return range;
            } else {
                context.maybeInsertedBrackets--;
            }
        }
    });

    this.add("parens", "insertion", function(state, action, editor, session, text) {
        if (text == '(') {
            initContext(editor);
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, '(', ')');
            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                CstyleBehaviour.recordAutoInsert(editor, session, ")");
                return {
                    text: '()',
                    selection: [1, 1]
                };
            }
        } else if (text == ')') {
            initContext(editor);
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar == ')') {
                var matching = session.$findOpeningBracket(')', {column: cursor.column + 1, row: cursor.row});
                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                    CstyleBehaviour.popAutoInsertedClosing();
                    return {
                        text: '',
                        selection: [1, 1]
                    };
                }
            }
        }
    });

    this.add("parens", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && selected == '(') {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
            if (rightChar == ')') {
                range.end.column++;
                return range;
            }
        }
    });

    this.add("brackets", "insertion", function(state, action, editor, session, text) {
        if (text == '[') {
            initContext(editor);
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, '[', ']');
            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                CstyleBehaviour.recordAutoInsert(editor, session, "]");
                return {
                    text: '[]',
                    selection: [1, 1]
                };
            }
        } else if (text == ']') {
            initContext(editor);
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar == ']') {
                var matching = session.$findOpeningBracket(']', {column: cursor.column + 1, row: cursor.row});
                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                    CstyleBehaviour.popAutoInsertedClosing();
                    return {
                        text: '',
                        selection: [1, 1]
                    };
                }
            }
        }
    });

    this.add("brackets", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && selected == '[') {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
            if (rightChar == ']') {
                range.end.column++;
                return range;
            }
        }
    });

    this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
        var quotes = session.$mode.$quotes || defaultQuotes;
        if (text.length == 1 && quotes[text]) {
            if (this.lineCommentStart && this.lineCommentStart.indexOf(text) != -1)
                return;
            initContext(editor);
            var quote = text;
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && (selected.length != 1 || !quotes[selected]) && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, quote, quote);
            } else if (!selected) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var leftChar = line.substring(cursor.column-1, cursor.column);
                var rightChar = line.substring(cursor.column, cursor.column + 1);

                var token = session.getTokenAt(cursor.row, cursor.column);
                var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
                if (leftChar == "\\" && token && /escape/.test(token.type))
                    return null;

                var stringBefore = token && /string|escape/.test(token.type);
                var stringAfter = !rightToken || /string|escape/.test(rightToken.type);

                var pair;
                if (rightChar == quote) {
                    pair = stringBefore !== stringAfter;
                    if (pair && /string\.end/.test(rightToken.type))
                        pair = false;
                } else {
                    if (stringBefore && !stringAfter)
                        return null; // wrap string with different quote
                    if (stringBefore && stringAfter)
                        return null; // do not pair quotes inside strings
                    var wordRe = session.$mode.tokenRe;
                    wordRe.lastIndex = 0;
                    var isWordBefore = wordRe.test(leftChar);
                    wordRe.lastIndex = 0;
                    var isWordAfter = wordRe.test(leftChar);
                    if (isWordBefore || isWordAfter)
                        return null; // before or after alphanumeric
                    if (rightChar && !/[\s;,.})\]\\]/.test(rightChar))
                        return null; // there is rightChar and it isn't closing
                    pair = true;
                }
                return {
                    text: pair ? quote + quote : "",
                    selection: [1,1]
                };
            }
        }
    });

    this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
            if (rightChar == selected) {
                range.end.column++;
                return range;
            }
        }
    });

};


CstyleBehaviour.isSaneInsertion = function(editor, session) {
    var cursor = editor.getCursorPosition();
    var iterator = new TokenIterator(session, cursor.row, cursor.column);
    if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
        var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
        if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS))
            return false;
    }
    iterator.stepForward();
    return iterator.getCurrentTokenRow() !== cursor.row ||
        this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
};

CstyleBehaviour.$matchTokenType = function(token, types) {
    return types.indexOf(token.type || token) > -1;
};

CstyleBehaviour.recordAutoInsert = function(editor, session, bracket) {
    var cursor = editor.getCursorPosition();
    var line = session.doc.getLine(cursor.row);
    if (!this.isAutoInsertedClosing(cursor, line, context.autoInsertedLineEnd[0]))
        context.autoInsertedBrackets = 0;
    context.autoInsertedRow = cursor.row;
    context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
    context.autoInsertedBrackets++;
};

CstyleBehaviour.recordMaybeInsert = function(editor, session, bracket) {
    var cursor = editor.getCursorPosition();
    var line = session.doc.getLine(cursor.row);
    if (!this.isMaybeInsertedClosing(cursor, line))
        context.maybeInsertedBrackets = 0;
    context.maybeInsertedRow = cursor.row;
    context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
    context.maybeInsertedLineEnd = line.substr(cursor.column);
    context.maybeInsertedBrackets++;
};

CstyleBehaviour.isAutoInsertedClosing = function(cursor, line, bracket) {
    return context.autoInsertedBrackets > 0 &&
        cursor.row === context.autoInsertedRow &&
        bracket === context.autoInsertedLineEnd[0] &&
        line.substr(cursor.column) === context.autoInsertedLineEnd;
};

CstyleBehaviour.isMaybeInsertedClosing = function(cursor, line) {
    return context.maybeInsertedBrackets > 0 &&
        cursor.row === context.maybeInsertedRow &&
        line.substr(cursor.column) === context.maybeInsertedLineEnd &&
        line.substr(0, cursor.column) == context.maybeInsertedLineStart;
};

CstyleBehaviour.popAutoInsertedClosing = function() {
    context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
    context.autoInsertedBrackets--;
};

CstyleBehaviour.clearMaybeInsertedClosing = function() {
    if (context) {
        context.maybeInsertedBrackets = 0;
        context.maybeInsertedRow = -1;
    }
};



oop.inherits(CstyleBehaviour, Behaviour);

exports.CstyleBehaviour = CstyleBehaviour;
});

ace.define("ace/unicode",["require","exports","module"], function(acequire, exports, module) {
"use strict";
exports.packages = {};

addUnicodePackage({
    L:  "0041-005A0061-007A00AA00B500BA00C0-00D600D8-00F600F8-02C102C6-02D102E0-02E402EC02EE0370-037403760377037A-037D03860388-038A038C038E-03A103A3-03F503F7-0481048A-05250531-055605590561-058705D0-05EA05F0-05F20621-064A066E066F0671-06D306D506E506E606EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA07F407F507FA0800-0815081A082408280904-0939093D09500958-0961097109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E460E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EC60EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10A0-10C510D0-10FA10FC1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317D717DC1820-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541AA71B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C7D1CE9-1CEC1CEE-1CF11D00-1DBF1E00-1F151F18-1F1D1F20-1F451F48-1F4D1F50-1F571F591F5B1F5D1F5F-1F7D1F80-1FB41FB6-1FBC1FBE1FC2-1FC41FC6-1FCC1FD0-1FD31FD6-1FDB1FE0-1FEC1FF2-1FF41FF6-1FFC2071207F2090-209421022107210A-211321152119-211D212421262128212A-212D212F-2139213C-213F2145-2149214E218321842C00-2C2E2C30-2C5E2C60-2CE42CEB-2CEE2D00-2D252D30-2D652D6F2D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE2E2F300530063031-3035303B303C3041-3096309D-309F30A1-30FA30FC-30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A48CA4D0-A4FDA500-A60CA610-A61FA62AA62BA640-A65FA662-A66EA67F-A697A6A0-A6E5A717-A71FA722-A788A78BA78CA7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2A9CFAA00-AA28AA40-AA42AA44-AA4BAA60-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADB-AADDABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB00-FB06FB13-FB17FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF21-FF3AFF41-FF5AFF66-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
    Ll: "0061-007A00AA00B500BA00DF-00F600F8-00FF01010103010501070109010B010D010F01110113011501170119011B011D011F01210123012501270129012B012D012F01310133013501370138013A013C013E014001420144014601480149014B014D014F01510153015501570159015B015D015F01610163016501670169016B016D016F0171017301750177017A017C017E-0180018301850188018C018D019201950199-019B019E01A101A301A501A801AA01AB01AD01B001B401B601B901BA01BD-01BF01C601C901CC01CE01D001D201D401D601D801DA01DC01DD01DF01E101E301E501E701E901EB01ED01EF01F001F301F501F901FB01FD01FF02010203020502070209020B020D020F02110213021502170219021B021D021F02210223022502270229022B022D022F02310233-0239023C023F0240024202470249024B024D024F-02930295-02AF037103730377037B-037D039003AC-03CE03D003D103D5-03D703D903DB03DD03DF03E103E303E503E703E903EB03ED03EF-03F303F503F803FB03FC0430-045F04610463046504670469046B046D046F04710473047504770479047B047D047F0481048B048D048F04910493049504970499049B049D049F04A104A304A504A704A904AB04AD04AF04B104B304B504B704B904BB04BD04BF04C204C404C604C804CA04CC04CE04CF04D104D304D504D704D904DB04DD04DF04E104E304E504E704E904EB04ED04EF04F104F304F504F704F904FB04FD04FF05010503050505070509050B050D050F05110513051505170519051B051D051F0521052305250561-05871D00-1D2B1D62-1D771D79-1D9A1E011E031E051E071E091E0B1E0D1E0F1E111E131E151E171E191E1B1E1D1E1F1E211E231E251E271E291E2B1E2D1E2F1E311E331E351E371E391E3B1E3D1E3F1E411E431E451E471E491E4B1E4D1E4F1E511E531E551E571E591E5B1E5D1E5F1E611E631E651E671E691E6B1E6D1E6F1E711E731E751E771E791E7B1E7D1E7F1E811E831E851E871E891E8B1E8D1E8F1E911E931E95-1E9D1E9F1EA11EA31EA51EA71EA91EAB1EAD1EAF1EB11EB31EB51EB71EB91EBB1EBD1EBF1EC11EC31EC51EC71EC91ECB1ECD1ECF1ED11ED31ED51ED71ED91EDB1EDD1EDF1EE11EE31EE51EE71EE91EEB1EED1EEF1EF11EF31EF51EF71EF91EFB1EFD1EFF-1F071F10-1F151F20-1F271F30-1F371F40-1F451F50-1F571F60-1F671F70-1F7D1F80-1F871F90-1F971FA0-1FA71FB0-1FB41FB61FB71FBE1FC2-1FC41FC61FC71FD0-1FD31FD61FD71FE0-1FE71FF2-1FF41FF61FF7210A210E210F2113212F21342139213C213D2146-2149214E21842C30-2C5E2C612C652C662C682C6A2C6C2C712C732C742C76-2C7C2C812C832C852C872C892C8B2C8D2C8F2C912C932C952C972C992C9B2C9D2C9F2CA12CA32CA52CA72CA92CAB2CAD2CAF2CB12CB32CB52CB72CB92CBB2CBD2CBF2CC12CC32CC52CC72CC92CCB2CCD2CCF2CD12CD32CD52CD72CD92CDB2CDD2CDF2CE12CE32CE42CEC2CEE2D00-2D25A641A643A645A647A649A64BA64DA64FA651A653A655A657A659A65BA65DA65FA663A665A667A669A66BA66DA681A683A685A687A689A68BA68DA68FA691A693A695A697A723A725A727A729A72BA72DA72F-A731A733A735A737A739A73BA73DA73FA741A743A745A747A749A74BA74DA74FA751A753A755A757A759A75BA75DA75FA761A763A765A767A769A76BA76DA76FA771-A778A77AA77CA77FA781A783A785A787A78CFB00-FB06FB13-FB17FF41-FF5A",
    Lu: "0041-005A00C0-00D600D8-00DE01000102010401060108010A010C010E01100112011401160118011A011C011E01200122012401260128012A012C012E01300132013401360139013B013D013F0141014301450147014A014C014E01500152015401560158015A015C015E01600162016401660168016A016C016E017001720174017601780179017B017D018101820184018601870189-018B018E-0191019301940196-0198019C019D019F01A001A201A401A601A701A901AC01AE01AF01B1-01B301B501B701B801BC01C401C701CA01CD01CF01D101D301D501D701D901DB01DE01E001E201E401E601E801EA01EC01EE01F101F401F6-01F801FA01FC01FE02000202020402060208020A020C020E02100212021402160218021A021C021E02200222022402260228022A022C022E02300232023A023B023D023E02410243-02460248024A024C024E03700372037603860388-038A038C038E038F0391-03A103A3-03AB03CF03D2-03D403D803DA03DC03DE03E003E203E403E603E803EA03EC03EE03F403F703F903FA03FD-042F04600462046404660468046A046C046E04700472047404760478047A047C047E0480048A048C048E04900492049404960498049A049C049E04A004A204A404A604A804AA04AC04AE04B004B204B404B604B804BA04BC04BE04C004C104C304C504C704C904CB04CD04D004D204D404D604D804DA04DC04DE04E004E204E404E604E804EA04EC04EE04F004F204F404F604F804FA04FC04FE05000502050405060508050A050C050E05100512051405160518051A051C051E0520052205240531-055610A0-10C51E001E021E041E061E081E0A1E0C1E0E1E101E121E141E161E181E1A1E1C1E1E1E201E221E241E261E281E2A1E2C1E2E1E301E321E341E361E381E3A1E3C1E3E1E401E421E441E461E481E4A1E4C1E4E1E501E521E541E561E581E5A1E5C1E5E1E601E621E641E661E681E6A1E6C1E6E1E701E721E741E761E781E7A1E7C1E7E1E801E821E841E861E881E8A1E8C1E8E1E901E921E941E9E1EA01EA21EA41EA61EA81EAA1EAC1EAE1EB01EB21EB41EB61EB81EBA1EBC1EBE1EC01EC21EC41EC61EC81ECA1ECC1ECE1ED01ED21ED41ED61ED81EDA1EDC1EDE1EE01EE21EE41EE61EE81EEA1EEC1EEE1EF01EF21EF41EF61EF81EFA1EFC1EFE1F08-1F0F1F18-1F1D1F28-1F2F1F38-1F3F1F48-1F4D1F591F5B1F5D1F5F1F68-1F6F1FB8-1FBB1FC8-1FCB1FD8-1FDB1FE8-1FEC1FF8-1FFB21022107210B-210D2110-211221152119-211D212421262128212A-212D2130-2133213E213F214521832C00-2C2E2C602C62-2C642C672C692C6B2C6D-2C702C722C752C7E-2C802C822C842C862C882C8A2C8C2C8E2C902C922C942C962C982C9A2C9C2C9E2CA02CA22CA42CA62CA82CAA2CAC2CAE2CB02CB22CB42CB62CB82CBA2CBC2CBE2CC02CC22CC42CC62CC82CCA2CCC2CCE2CD02CD22CD42CD62CD82CDA2CDC2CDE2CE02CE22CEB2CEDA640A642A644A646A648A64AA64CA64EA650A652A654A656A658A65AA65CA65EA662A664A666A668A66AA66CA680A682A684A686A688A68AA68CA68EA690A692A694A696A722A724A726A728A72AA72CA72EA732A734A736A738A73AA73CA73EA740A742A744A746A748A74AA74CA74EA750A752A754A756A758A75AA75CA75EA760A762A764A766A768A76AA76CA76EA779A77BA77DA77EA780A782A784A786A78BFF21-FF3A",
    Lt: "01C501C801CB01F21F88-1F8F1F98-1F9F1FA8-1FAF1FBC1FCC1FFC",
    Lm: "02B0-02C102C6-02D102E0-02E402EC02EE0374037A0559064006E506E607F407F507FA081A0824082809710E460EC610FC17D718431AA71C78-1C7D1D2C-1D611D781D9B-1DBF2071207F2090-20942C7D2D6F2E2F30053031-3035303B309D309E30FC-30FEA015A4F8-A4FDA60CA67FA717-A71FA770A788A9CFAA70AADDFF70FF9EFF9F",
    Lo: "01BB01C0-01C3029405D0-05EA05F0-05F20621-063F0641-064A066E066F0671-06D306D506EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA0800-08150904-0939093D09500958-096109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E450E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10D0-10FA1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317DC1820-18421844-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C771CE9-1CEC1CEE-1CF12135-21382D30-2D652D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE3006303C3041-3096309F30A1-30FA30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A014A016-A48CA4D0-A4F7A500-A60BA610-A61FA62AA62BA66EA6A0-A6E5A7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2AA00-AA28AA40-AA42AA44-AA4BAA60-AA6FAA71-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADBAADCABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF66-FF6FFF71-FF9DFFA0-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
    M:  "0300-036F0483-04890591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DE-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0903093C093E-094E0951-0955096209630981-098309BC09BE-09C409C709C809CB-09CD09D709E209E30A01-0A030A3C0A3E-0A420A470A480A4B-0A4D0A510A700A710A750A81-0A830ABC0ABE-0AC50AC7-0AC90ACB-0ACD0AE20AE30B01-0B030B3C0B3E-0B440B470B480B4B-0B4D0B560B570B620B630B820BBE-0BC20BC6-0BC80BCA-0BCD0BD70C01-0C030C3E-0C440C46-0C480C4A-0C4D0C550C560C620C630C820C830CBC0CBE-0CC40CC6-0CC80CCA-0CCD0CD50CD60CE20CE30D020D030D3E-0D440D46-0D480D4A-0D4D0D570D620D630D820D830DCA0DCF-0DD40DD60DD8-0DDF0DF20DF30E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F3E0F3F0F71-0F840F860F870F90-0F970F99-0FBC0FC6102B-103E1056-1059105E-10601062-10641067-106D1071-10741082-108D108F109A-109D135F1712-17141732-1734175217531772177317B6-17D317DD180B-180D18A91920-192B1930-193B19B0-19C019C819C91A17-1A1B1A55-1A5E1A60-1A7C1A7F1B00-1B041B34-1B441B6B-1B731B80-1B821BA1-1BAA1C24-1C371CD0-1CD21CD4-1CE81CED1CF21DC0-1DE61DFD-1DFF20D0-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66F-A672A67CA67DA6F0A6F1A802A806A80BA823-A827A880A881A8B4-A8C4A8E0-A8F1A926-A92DA947-A953A980-A983A9B3-A9C0AA29-AA36AA43AA4CAA4DAA7BAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE3-ABEAABECABEDFB1EFE00-FE0FFE20-FE26",
    Mn: "0300-036F0483-04870591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DF-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0902093C0941-0948094D0951-095509620963098109BC09C1-09C409CD09E209E30A010A020A3C0A410A420A470A480A4B-0A4D0A510A700A710A750A810A820ABC0AC1-0AC50AC70AC80ACD0AE20AE30B010B3C0B3F0B41-0B440B4D0B560B620B630B820BC00BCD0C3E-0C400C46-0C480C4A-0C4D0C550C560C620C630CBC0CBF0CC60CCC0CCD0CE20CE30D41-0D440D4D0D620D630DCA0DD2-0DD40DD60E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F71-0F7E0F80-0F840F860F870F90-0F970F99-0FBC0FC6102D-10301032-10371039103A103D103E10581059105E-10601071-1074108210851086108D109D135F1712-17141732-1734175217531772177317B7-17BD17C617C9-17D317DD180B-180D18A91920-19221927192819321939-193B1A171A181A561A58-1A5E1A601A621A65-1A6C1A73-1A7C1A7F1B00-1B031B341B36-1B3A1B3C1B421B6B-1B731B801B811BA2-1BA51BA81BA91C2C-1C331C361C371CD0-1CD21CD4-1CE01CE2-1CE81CED1DC0-1DE61DFD-1DFF20D0-20DC20E120E5-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66FA67CA67DA6F0A6F1A802A806A80BA825A826A8C4A8E0-A8F1A926-A92DA947-A951A980-A982A9B3A9B6-A9B9A9BCAA29-AA2EAA31AA32AA35AA36AA43AA4CAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE5ABE8ABEDFB1EFE00-FE0FFE20-FE26",
    Mc: "0903093E-09400949-094C094E0982098309BE-09C009C709C809CB09CC09D70A030A3E-0A400A830ABE-0AC00AC90ACB0ACC0B020B030B3E0B400B470B480B4B0B4C0B570BBE0BBF0BC10BC20BC6-0BC80BCA-0BCC0BD70C01-0C030C41-0C440C820C830CBE0CC0-0CC40CC70CC80CCA0CCB0CD50CD60D020D030D3E-0D400D46-0D480D4A-0D4C0D570D820D830DCF-0DD10DD8-0DDF0DF20DF30F3E0F3F0F7F102B102C10311038103B103C105610571062-10641067-106D108310841087-108C108F109A-109C17B617BE-17C517C717C81923-19261929-192B193019311933-193819B0-19C019C819C91A19-1A1B1A551A571A611A631A641A6D-1A721B041B351B3B1B3D-1B411B431B441B821BA11BA61BA71BAA1C24-1C2B1C341C351CE11CF2A823A824A827A880A881A8B4-A8C3A952A953A983A9B4A9B5A9BAA9BBA9BD-A9C0AA2FAA30AA33AA34AA4DAA7BABE3ABE4ABE6ABE7ABE9ABEAABEC",
    Me: "0488048906DE20DD-20E020E2-20E4A670-A672",
    N:  "0030-003900B200B300B900BC-00BE0660-066906F0-06F907C0-07C90966-096F09E6-09EF09F4-09F90A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BF20C66-0C6F0C78-0C7E0CE6-0CEF0D66-0D750E50-0E590ED0-0ED90F20-0F331040-10491090-10991369-137C16EE-16F017E0-17E917F0-17F91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C5920702074-20792080-20892150-21822185-21892460-249B24EA-24FF2776-27932CFD30073021-30293038-303A3192-31953220-32293251-325F3280-328932B1-32BFA620-A629A6E6-A6EFA830-A835A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
    Nd: "0030-00390660-066906F0-06F907C0-07C90966-096F09E6-09EF0A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BEF0C66-0C6F0CE6-0CEF0D66-0D6F0E50-0E590ED0-0ED90F20-0F291040-10491090-109917E0-17E91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C59A620-A629A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
    Nl: "16EE-16F02160-21822185-218830073021-30293038-303AA6E6-A6EF",
    No: "00B200B300B900BC-00BE09F4-09F90BF0-0BF20C78-0C7E0D70-0D750F2A-0F331369-137C17F0-17F920702074-20792080-20892150-215F21892460-249B24EA-24FF2776-27932CFD3192-31953220-32293251-325F3280-328932B1-32BFA830-A835",
    P:  "0021-00230025-002A002C-002F003A003B003F0040005B-005D005F007B007D00A100AB00B700BB00BF037E0387055A-055F0589058A05BE05C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F3A-0F3D0F850FD0-0FD4104A-104F10FB1361-13681400166D166E169B169C16EB-16ED1735173617D4-17D617D8-17DA1800-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD32010-20272030-20432045-20512053-205E207D207E208D208E2329232A2768-277527C527C627E6-27EF2983-299829D8-29DB29FC29FD2CF9-2CFC2CFE2CFF2E00-2E2E2E302E313001-30033008-30113014-301F3030303D30A030FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFD3EFD3FFE10-FE19FE30-FE52FE54-FE61FE63FE68FE6AFE6BFF01-FF03FF05-FF0AFF0C-FF0FFF1AFF1BFF1FFF20FF3B-FF3DFF3FFF5BFF5DFF5F-FF65",
    Pd: "002D058A05BE140018062010-20152E172E1A301C303030A0FE31FE32FE58FE63FF0D",
    Ps: "0028005B007B0F3A0F3C169B201A201E2045207D208D23292768276A276C276E27702772277427C527E627E827EA27EC27EE2983298529872989298B298D298F299129932995299729D829DA29FC2E222E242E262E283008300A300C300E3010301430163018301A301DFD3EFE17FE35FE37FE39FE3BFE3DFE3FFE41FE43FE47FE59FE5BFE5DFF08FF3BFF5BFF5FFF62",
    Pe: "0029005D007D0F3B0F3D169C2046207E208E232A2769276B276D276F27712773277527C627E727E927EB27ED27EF298429862988298A298C298E2990299229942996299829D929DB29FD2E232E252E272E293009300B300D300F3011301530173019301B301E301FFD3FFE18FE36FE38FE3AFE3CFE3EFE40FE42FE44FE48FE5AFE5CFE5EFF09FF3DFF5DFF60FF63",
    Pi: "00AB2018201B201C201F20392E022E042E092E0C2E1C2E20",
    Pf: "00BB2019201D203A2E032E052E0A2E0D2E1D2E21",
    Pc: "005F203F20402054FE33FE34FE4D-FE4FFF3F",
    Po: "0021-00230025-0027002A002C002E002F003A003B003F0040005C00A100B700BF037E0387055A-055F058905C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F850FD0-0FD4104A-104F10FB1361-1368166D166E16EB-16ED1735173617D4-17D617D8-17DA1800-18051807-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD3201620172020-20272030-2038203B-203E2041-20432047-205120532055-205E2CF9-2CFC2CFE2CFF2E002E012E06-2E082E0B2E0E-2E162E182E192E1B2E1E2E1F2E2A-2E2E2E302E313001-3003303D30FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFE10-FE16FE19FE30FE45FE46FE49-FE4CFE50-FE52FE54-FE57FE5F-FE61FE68FE6AFE6BFF01-FF03FF05-FF07FF0AFF0CFF0EFF0FFF1AFF1BFF1FFF20FF3CFF61FF64FF65",
    S:  "0024002B003C-003E005E0060007C007E00A2-00A900AC00AE-00B100B400B600B800D700F702C2-02C502D2-02DF02E5-02EB02ED02EF-02FF03750384038503F604820606-0608060B060E060F06E906FD06FE07F609F209F309FA09FB0AF10B700BF3-0BFA0C7F0CF10CF20D790E3F0F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-139917DB194019E0-19FF1B61-1B6A1B74-1B7C1FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE20442052207A-207C208A-208C20A0-20B8210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B2140-2144214A-214D214F2190-2328232B-23E82400-24262440-244A249C-24E92500-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE27C0-27C427C7-27CA27CC27D0-27E527F0-29822999-29D729DC-29FB29FE-2B4C2B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F309B309C319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A700-A716A720A721A789A78AA828-A82BA836-A839AA77-AA79FB29FDFCFDFDFE62FE64-FE66FE69FF04FF0BFF1C-FF1EFF3EFF40FF5CFF5EFFE0-FFE6FFE8-FFEEFFFCFFFD",
    Sm: "002B003C-003E007C007E00AC00B100D700F703F60606-060820442052207A-207C208A-208C2140-2144214B2190-2194219A219B21A021A321A621AE21CE21CF21D221D421F4-22FF2308-230B23202321237C239B-23B323DC-23E125B725C125F8-25FF266F27C0-27C427C7-27CA27CC27D0-27E527F0-27FF2900-29822999-29D729DC-29FB29FE-2AFF2B30-2B442B47-2B4CFB29FE62FE64-FE66FF0BFF1C-FF1EFF5CFF5EFFE2FFE9-FFEC",
    Sc: "002400A2-00A5060B09F209F309FB0AF10BF90E3F17DB20A0-20B8A838FDFCFE69FF04FFE0FFE1FFE5FFE6",
    Sk: "005E006000A800AF00B400B802C2-02C502D2-02DF02E5-02EB02ED02EF-02FF0375038403851FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE309B309CA700-A716A720A721A789A78AFF3EFF40FFE3",
    So: "00A600A700A900AE00B000B60482060E060F06E906FD06FE07F609FA0B700BF3-0BF80BFA0C7F0CF10CF20D790F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-1399194019E0-19FF1B61-1B6A1B74-1B7C210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B214A214C214D214F2195-2199219C-219F21A121A221A421A521A7-21AD21AF-21CD21D021D121D321D5-21F32300-2307230C-231F2322-2328232B-237B237D-239A23B4-23DB23E2-23E82400-24262440-244A249C-24E92500-25B625B8-25C025C2-25F72600-266E2670-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE2800-28FF2B00-2B2F2B452B462B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A828-A82BA836A837A839AA77-AA79FDFDFFE4FFE8FFEDFFEEFFFCFFFD",
    Z:  "002000A01680180E2000-200A20282029202F205F3000",
    Zs: "002000A01680180E2000-200A202F205F3000",
    Zl: "2028",
    Zp: "2029",
    C:  "0000-001F007F-009F00AD03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-0605061C061D0620065F06DD070E070F074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17B417B517DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF200B-200F202A-202E2060-206F20722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-F8FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFD-FF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFFBFFFEFFFF",
    Cc: "0000-001F007F-009F",
    Cf: "00AD0600-060306DD070F17B417B5200B-200F202A-202E2060-2064206A-206FFEFFFFF9-FFFB",
    Co: "E000-F8FF",
    Cs: "D800-DFFF",
    Cn: "03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-05FF06040605061C061D0620065F070E074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF2065-206920722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-D7FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFDFEFEFF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFF8FFFEFFFF"
});

function addUnicodePackage (pack) {
    var codePoint = /\w{4}/g;
    for (var name in pack)
        exports.packages[name] = pack[name].replace(codePoint, "\\u$&");
}

});

ace.define("ace/mode/text",["require","exports","module","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour/cstyle","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"], function(acequire, exports, module) {
"use strict";

var Tokenizer = acequire("../tokenizer").Tokenizer;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
var unicode = acequire("../unicode");
var lang = acequire("../lib/lang");
var TokenIterator = acequire("../token_iterator").TokenIterator;
var Range = acequire("../range").Range;

var Mode = function() {
    this.HighlightRules = TextHighlightRules;
};

(function() {
    this.$defaultBehaviour = new CstyleBehaviour();

    this.tokenRe = new RegExp("^["
        + unicode.packages.L
        + unicode.packages.Mn + unicode.packages.Mc
        + unicode.packages.Nd
        + unicode.packages.Pc + "\\$_]+", "g"
    );

    this.nonTokenRe = new RegExp("^(?:[^"
        + unicode.packages.L
        + unicode.packages.Mn + unicode.packages.Mc
        + unicode.packages.Nd
        + unicode.packages.Pc + "\\$_]|\\s])+", "g"
    );

    this.getTokenizer = function() {
        if (!this.$tokenizer) {
            this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig);
            this.$tokenizer = new Tokenizer(this.$highlightRules.getRules());
        }
        return this.$tokenizer;
    };

    this.lineCommentStart = "";
    this.blockComment = "";

    this.toggleCommentLines = function(state, session, startRow, endRow) {
        var doc = session.doc;

        var ignoreBlankLines = true;
        var shouldRemove = true;
        var minIndent = Infinity;
        var tabSize = session.getTabSize();
        var insertAtTabStop = false;

        if (!this.lineCommentStart) {
            if (!this.blockComment)
                return false;
            var lineCommentStart = this.blockComment.start;
            var lineCommentEnd = this.blockComment.end;
            var regexpStart = new RegExp("^(\\s*)(?:" + lang.escapeRegExp(lineCommentStart) + ")");
            var regexpEnd = new RegExp("(?:" + lang.escapeRegExp(lineCommentEnd) + ")\\s*$");

            var comment = function(line, i) {
                if (testRemove(line, i))
                    return;
                if (!ignoreBlankLines || /\S/.test(line)) {
                    doc.insertInLine({row: i, column: line.length}, lineCommentEnd);
                    doc.insertInLine({row: i, column: minIndent}, lineCommentStart);
                }
            };

            var uncomment = function(line, i) {
                var m;
                if (m = line.match(regexpEnd))
                    doc.removeInLine(i, line.length - m[0].length, line.length);
                if (m = line.match(regexpStart))
                    doc.removeInLine(i, m[1].length, m[0].length);
            };

            var testRemove = function(line, row) {
                if (regexpStart.test(line))
                    return true;
                var tokens = session.getTokens(row);
                for (var i = 0; i < tokens.length; i++) {
                    if (tokens[i].type === "comment")
                        return true;
                }
            };
        } else {
            if (Array.isArray(this.lineCommentStart)) {
                var regexpStart = this.lineCommentStart.map(lang.escapeRegExp).join("|");
                var lineCommentStart = this.lineCommentStart[0];
            } else {
                var regexpStart = lang.escapeRegExp(this.lineCommentStart);
                var lineCommentStart = this.lineCommentStart;
            }
            regexpStart = new RegExp("^(\\s*)(?:" + regexpStart + ") ?");
            
            insertAtTabStop = session.getUseSoftTabs();

            var uncomment = function(line, i) {
                var m = line.match(regexpStart);
                if (!m) return;
                var start = m[1].length, end = m[0].length;
                if (!shouldInsertSpace(line, start, end) && m[0][end - 1] == " ")
                    end--;
                doc.removeInLine(i, start, end);
            };
            var commentWithSpace = lineCommentStart + " ";
            var comment = function(line, i) {
                if (!ignoreBlankLines || /\S/.test(line)) {
                    if (shouldInsertSpace(line, minIndent, minIndent))
                        doc.insertInLine({row: i, column: minIndent}, commentWithSpace);
                    else
                        doc.insertInLine({row: i, column: minIndent}, lineCommentStart);
                }
            };
            var testRemove = function(line, i) {
                return regexpStart.test(line);
            };
            
            var shouldInsertSpace = function(line, before, after) {
                var spaces = 0;
                while (before-- && line.charAt(before) == " ")
                    spaces++;
                if (spaces % tabSize != 0)
                    return false;
                var spaces = 0;
                while (line.charAt(after++) == " ")
                    spaces++;
                if (tabSize > 2)
                    return spaces % tabSize != tabSize - 1;
                else
                    return spaces % tabSize == 0;
                return true;
            };
        }

        function iter(fun) {
            for (var i = startRow; i <= endRow; i++)
                fun(doc.getLine(i), i);
        }


        var minEmptyLength = Infinity;
        iter(function(line, i) {
            var indent = line.search(/\S/);
            if (indent !== -1) {
                if (indent < minIndent)
                    minIndent = indent;
                if (shouldRemove && !testRemove(line, i))
                    shouldRemove = false;
            } else if (minEmptyLength > line.length) {
                minEmptyLength = line.length;
            }
        });

        if (minIndent == Infinity) {
            minIndent = minEmptyLength;
            ignoreBlankLines = false;
            shouldRemove = false;
        }

        if (insertAtTabStop && minIndent % tabSize != 0)
            minIndent = Math.floor(minIndent / tabSize) * tabSize;

        iter(shouldRemove ? uncomment : comment);
    };

    this.toggleBlockComment = function(state, session, range, cursor) {
        var comment = this.blockComment;
        if (!comment)
            return;
        if (!comment.start && comment[0])
            comment = comment[0];

        var iterator = new TokenIterator(session, cursor.row, cursor.column);
        var token = iterator.getCurrentToken();

        var sel = session.selection;
        var initialRange = session.selection.toOrientedRange();
        var startRow, colDiff;

        if (token && /comment/.test(token.type)) {
            var startRange, endRange;
            while (token && /comment/.test(token.type)) {
                var i = token.value.indexOf(comment.start);
                if (i != -1) {
                    var row = iterator.getCurrentTokenRow();
                    var column = iterator.getCurrentTokenColumn() + i;
                    startRange = new Range(row, column, row, column + comment.start.length);
                    break;
                }
                token = iterator.stepBackward();
            }

            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();
            while (token && /comment/.test(token.type)) {
                var i = token.value.indexOf(comment.end);
                if (i != -1) {
                    var row = iterator.getCurrentTokenRow();
                    var column = iterator.getCurrentTokenColumn() + i;
                    endRange = new Range(row, column, row, column + comment.end.length);
                    break;
                }
                token = iterator.stepForward();
            }
            if (endRange)
                session.remove(endRange);
            if (startRange) {
                session.remove(startRange);
                startRow = startRange.start.row;
                colDiff = -comment.start.length;
            }
        } else {
            colDiff = comment.start.length;
            startRow = range.start.row;
            session.insert(range.end, comment.end);
            session.insert(range.start, comment.start);
        }
        if (initialRange.start.row == startRow)
            initialRange.start.column += colDiff;
        if (initialRange.end.row == startRow)
            initialRange.end.column += colDiff;
        session.selection.fromOrientedRange(initialRange);
    };

    this.getNextLineIndent = function(state, line, tab) {
        return this.$getIndent(line);
    };

    this.checkOutdent = function(state, line, input) {
        return false;
    };

    this.autoOutdent = function(state, doc, row) {
    };

    this.$getIndent = function(line) {
        return line.match(/^\s*/)[0];
    };

    this.createWorker = function(session) {
        return null;
    };

    this.createModeDelegates = function (mapping) {
        this.$embeds = [];
        this.$modes = {};
        for (var i in mapping) {
            if (mapping[i]) {
                this.$embeds.push(i);
                this.$modes[i] = new mapping[i]();
            }
        }

        var delegations = ["toggleBlockComment", "toggleCommentLines", "getNextLineIndent", 
            "checkOutdent", "autoOutdent", "transformAction", "getCompletions"];

        for (var i = 0; i < delegations.length; i++) {
            (function(scope) {
              var functionName = delegations[i];
              var defaultHandler = scope[functionName];
              scope[delegations[i]] = function() {
                  return this.$delegator(functionName, arguments, defaultHandler);
              };
            }(this));
        }
    };

    this.$delegator = function(method, args, defaultHandler) {
        var state = args[0];
        if (typeof state != "string")
            state = state[0];
        for (var i = 0; i < this.$embeds.length; i++) {
            if (!this.$modes[this.$embeds[i]]) continue;

            var split = state.split(this.$embeds[i]);
            if (!split[0] && split[1]) {
                args[0] = split[1];
                var mode = this.$modes[this.$embeds[i]];
                return mode[method].apply(mode, args);
            }
        }
        var ret = defaultHandler.apply(this, args);
        return defaultHandler ? ret : undefined;
    };

    this.transformAction = function(state, action, editor, session, param) {
        if (this.$behaviour) {
            var behaviours = this.$behaviour.getBehaviours();
            for (var key in behaviours) {
                if (behaviours[key][action]) {
                    var ret = behaviours[key][action].apply(this, arguments);
                    if (ret) {
                        return ret;
                    }
                }
            }
        }
    };
    
    this.getKeywords = function(append) {
        if (!this.completionKeywords) {
            var rules = this.$tokenizer.rules;
            var completionKeywords = [];
            for (var rule in rules) {
                var ruleItr = rules[rule];
                for (var r = 0, l = ruleItr.length; r < l; r++) {
                    if (typeof ruleItr[r].token === "string") {
                        if (/keyword|support|storage/.test(ruleItr[r].token))
                            completionKeywords.push(ruleItr[r].regex);
                    }
                    else if (typeof ruleItr[r].token === "object") {
                        for (var a = 0, aLength = ruleItr[r].token.length; a < aLength; a++) {    
                            if (/keyword|support|storage/.test(ruleItr[r].token[a])) {
                                var rule = ruleItr[r].regex.match(/\(.+?\)/g)[a];
                                completionKeywords.push(rule.substr(1, rule.length - 2));
                            }
                        }
                    }
                }
            }
            this.completionKeywords = completionKeywords;
        }
        if (!append)
            return this.$keywordList;
        return completionKeywords.concat(this.$keywordList || []);
    };
    
    this.$createKeywordList = function() {
        if (!this.$highlightRules)
            this.getTokenizer();
        return this.$keywordList = this.$highlightRules.$keywordList || [];
    };

    this.getCompletions = function(state, session, pos, prefix) {
        var keywords = this.$keywordList || this.$createKeywordList();
        return keywords.map(function(word) {
            return {
                name: word,
                value: word,
                score: 0,
                meta: "keyword"
            };
        });
    };

    this.$id = "ace/mode/text";
}).call(Mode.prototype);

exports.Mode = Mode;
});

ace.define("ace/apply_delta",["require","exports","module"], function(acequire, exports, module) {
"use strict";

function throwDeltaError(delta, errorText){
    console.log("Invalid Delta:", delta);
    throw "Invalid Delta: " + errorText;
}

function positionInDocument(docLines, position) {
    return position.row    >= 0 && position.row    <  docLines.length &&
           position.column >= 0 && position.column <= docLines[position.row].length;
}

function validateDelta(docLines, delta) {
    if (delta.action != "insert" && delta.action != "remove")
        throwDeltaError(delta, "delta.action must be 'insert' or 'remove'");
    if (!(delta.lines instanceof Array))
        throwDeltaError(delta, "delta.lines must be an Array");
    if (!delta.start || !delta.end)
       throwDeltaError(delta, "delta.start/end must be an present");
    var start = delta.start;
    if (!positionInDocument(docLines, delta.start))
        throwDeltaError(delta, "delta.start must be contained in document");
    var end = delta.end;
    if (delta.action == "remove" && !positionInDocument(docLines, end))
        throwDeltaError(delta, "delta.end must contained in document for 'remove' actions");
    var numRangeRows = end.row - start.row;
    var numRangeLastLineChars = (end.column - (numRangeRows == 0 ? start.column : 0));
    if (numRangeRows != delta.lines.length - 1 || delta.lines[numRangeRows].length != numRangeLastLineChars)
        throwDeltaError(delta, "delta.range must match delta lines");
}

exports.applyDelta = function(docLines, delta, doNotValidate) {
    
    var row = delta.start.row;
    var startColumn = delta.start.column;
    var line = docLines[row] || "";
    switch (delta.action) {
        case "insert":
            var lines = delta.lines;
            if (lines.length === 1) {
                docLines[row] = line.substring(0, startColumn) + delta.lines[0] + line.substring(startColumn);
            } else {
                var args = [row, 1].concat(delta.lines);
                docLines.splice.apply(docLines, args);
                docLines[row] = line.substring(0, startColumn) + docLines[row];
                docLines[row + delta.lines.length - 1] += line.substring(startColumn);
            }
            break;
        case "remove":
            var endColumn = delta.end.column;
            var endRow = delta.end.row;
            if (row === endRow) {
                docLines[row] = line.substring(0, startColumn) + line.substring(endColumn);
            } else {
                docLines.splice(
                    row, endRow - row + 1,
                    line.substring(0, startColumn) + docLines[endRow].substring(endColumn)
                );
            }
            break;
    }
};
});

ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;

var Anchor = exports.Anchor = function(doc, row, column) {
    this.$onChange = this.onChange.bind(this);
    this.attach(doc);
    
    if (typeof column == "undefined")
        this.setPosition(row.row, row.column);
    else
        this.setPosition(row, column);
};

(function() {

    oop.implement(this, EventEmitter);
    this.getPosition = function() {
        return this.$clipPositionToDocument(this.row, this.column);
    };
    this.getDocument = function() {
        return this.document;
    };
    this.$insertRight = false;
    this.onChange = function(delta) {
        if (delta.start.row == delta.end.row && delta.start.row != this.row)
            return;

        if (delta.start.row > this.row)
            return;
            
        var point = $getTransformedPoint(delta, {row: this.row, column: this.column}, this.$insertRight);
        this.setPosition(point.row, point.column, true);
    };
    
    function $pointsInOrder(point1, point2, equalPointsInOrder) {
        var bColIsAfter = equalPointsInOrder ? point1.column <= point2.column : point1.column < point2.column;
        return (point1.row < point2.row) || (point1.row == point2.row && bColIsAfter);
    }
            
    function $getTransformedPoint(delta, point, moveIfEqual) {
        var deltaIsInsert = delta.action == "insert";
        var deltaRowShift = (deltaIsInsert ? 1 : -1) * (delta.end.row    - delta.start.row);
        var deltaColShift = (deltaIsInsert ? 1 : -1) * (delta.end.column - delta.start.column);
        var deltaStart = delta.start;
        var deltaEnd = deltaIsInsert ? deltaStart : delta.end; // Collapse insert range.
        if ($pointsInOrder(point, deltaStart, moveIfEqual)) {
            return {
                row: point.row,
                column: point.column
            };
        }
        if ($pointsInOrder(deltaEnd, point, !moveIfEqual)) {
            return {
                row: point.row + deltaRowShift,
                column: point.column + (point.row == deltaEnd.row ? deltaColShift : 0)
            };
        }
        
        return {
            row: deltaStart.row,
            column: deltaStart.column
        };
    }
    this.setPosition = function(row, column, noClip) {
        var pos;
        if (noClip) {
            pos = {
                row: row,
                column: column
            };
        } else {
            pos = this.$clipPositionToDocument(row, column);
        }

        if (this.row == pos.row && this.column == pos.column)
            return;

        var old = {
            row: this.row,
            column: this.column
        };

        this.row = pos.row;
        this.column = pos.column;
        this._signal("change", {
            old: old,
            value: pos
        });
    };
    this.detach = function() {
        this.document.removeEventListener("change", this.$onChange);
    };
    this.attach = function(doc) {
        this.document = doc || this.document;
        this.document.on("change", this.$onChange);
    };
    this.$clipPositionToDocument = function(row, column) {
        var pos = {};

        if (row >= this.document.getLength()) {
            pos.row = Math.max(0, this.document.getLength() - 1);
            pos.column = this.document.getLine(pos.row).length;
        }
        else if (row < 0) {
            pos.row = 0;
            pos.column = 0;
        }
        else {
            pos.row = row;
            pos.column = Math.min(this.document.getLine(pos.row).length, Math.max(0, column));
        }

        if (column < 0)
            pos.column = 0;

        return pos;
    };

}).call(Anchor.prototype);

});

ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var applyDelta = acequire("./apply_delta").applyDelta;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var Range = acequire("./range").Range;
var Anchor = acequire("./anchor").Anchor;

var Document = function(textOrLines) {
    this.$lines = [""];
    if (textOrLines.length === 0) {
        this.$lines = [""];
    } else if (Array.isArray(textOrLines)) {
        this.insertMergedLines({row: 0, column: 0}, textOrLines);
    } else {
        this.insert({row: 0, column:0}, textOrLines);
    }
};

(function() {

    oop.implement(this, EventEmitter);
    this.setValue = function(text) {
        var len = this.getLength() - 1;
        this.remove(new Range(0, 0, len, this.getLine(len).length));
        this.insert({row: 0, column: 0}, text);
    };
    this.getValue = function() {
        return this.getAllLines().join(this.getNewLineCharacter());
    };
    this.createAnchor = function(row, column) {
        return new Anchor(this, row, column);
    };
    if ("aaa".split(/a/).length === 0) {
        this.$split = function(text) {
            return text.replace(/\r\n|\r/g, "\n").split("\n");
        };
    } else {
        this.$split = function(text) {
            return text.split(/\r\n|\r|\n/);
        };
    }


    this.$detectNewLine = function(text) {
        var match = text.match(/^.*?(\r\n|\r|\n)/m);
        this.$autoNewLine = match ? match[1] : "\n";
        this._signal("changeNewLineMode");
    };
    this.getNewLineCharacter = function() {
        switch (this.$newLineMode) {
          case "windows":
            return "\r\n";
          case "unix":
            return "\n";
          default:
            return this.$autoNewLine || "\n";
        }
    };

    this.$autoNewLine = "";
    this.$newLineMode = "auto";
    this.setNewLineMode = function(newLineMode) {
        if (this.$newLineMode === newLineMode)
            return;

        this.$newLineMode = newLineMode;
        this._signal("changeNewLineMode");
    };
    this.getNewLineMode = function() {
        return this.$newLineMode;
    };
    this.isNewLine = function(text) {
        return (text == "\r\n" || text == "\r" || text == "\n");
    };
    this.getLine = function(row) {
        return this.$lines[row] || "";
    };
    this.getLines = function(firstRow, lastRow) {
        return this.$lines.slice(firstRow, lastRow + 1);
    };
    this.getAllLines = function() {
        return this.getLines(0, this.getLength());
    };
    this.getLength = function() {
        return this.$lines.length;
    };
    this.getTextRange = function(range) {
        return this.getLinesForRange(range).join(this.getNewLineCharacter());
    };
    this.getLinesForRange = function(range) {
        var lines;
        if (range.start.row === range.end.row) {
            lines = [this.getLine(range.start.row).substring(range.start.column, range.end.column)];
        } else {
            lines = this.getLines(range.start.row, range.end.row);
            lines[0] = (lines[0] || "").substring(range.start.column);
            var l = lines.length - 1;
            if (range.end.row - range.start.row == l)
                lines[l] = lines[l].substring(0, range.end.column);
        }
        return lines;
    };
    this.insertLines = function(row, lines) {
        console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead.");
        return this.insertFullLines(row, lines);
    };
    this.removeLines = function(firstRow, lastRow) {
        console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead.");
        return this.removeFullLines(firstRow, lastRow);
    };
    this.insertNewLine = function(position) {
        console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.");
        return this.insertMergedLines(position, ["", ""]);
    };
    this.insert = function(position, text) {
        if (this.getLength() <= 1)
            this.$detectNewLine(text);
        
        return this.insertMergedLines(position, this.$split(text));
    };
    this.insertInLine = function(position, text) {
        var start = this.clippedPos(position.row, position.column);
        var end = this.pos(position.row, position.column + text.length);
        
        this.applyDelta({
            start: start,
            end: end,
            action: "insert",
            lines: [text]
        }, true);
        
        return this.clonePos(end);
    };
    
    this.clippedPos = function(row, column) {
        var length = this.getLength();
        if (row === undefined) {
            row = length;
        } else if (row < 0) {
            row = 0;
        } else if (row >= length) {
            row = length - 1;
            column = undefined;
        }
        var line = this.getLine(row);
        if (column == undefined)
            column = line.length;
        column = Math.min(Math.max(column, 0), line.length);
        return {row: row, column: column};
    };
    
    this.clonePos = function(pos) {
        return {row: pos.row, column: pos.column};
    };
    
    this.pos = function(row, column) {
        return {row: row, column: column};
    };
    
    this.$clipPosition = function(position) {
        var length = this.getLength();
        if (position.row >= length) {
            position.row = Math.max(0, length - 1);
            position.column = this.getLine(length - 1).length;
        } else {
            position.row = Math.max(0, position.row);
            position.column = Math.min(Math.max(position.column, 0), this.getLine(position.row).length);
        }
        return position;
    };
    this.insertFullLines = function(row, lines) {
        row = Math.min(Math.max(row, 0), this.getLength());
        var column = 0;
        if (row < this.getLength()) {
            lines = lines.concat([""]);
            column = 0;
        } else {
            lines = [""].concat(lines);
            row--;
            column = this.$lines[row].length;
        }
        this.insertMergedLines({row: row, column: column}, lines);
    };    
    this.insertMergedLines = function(position, lines) {
        var start = this.clippedPos(position.row, position.column);
        var end = {
            row: start.row + lines.length - 1,
            column: (lines.length == 1 ? start.column : 0) + lines[lines.length - 1].length
        };
        
        this.applyDelta({
            start: start,
            end: end,
            action: "insert",
            lines: lines
        });
        
        return this.clonePos(end);
    };
    this.remove = function(range) {
        var start = this.clippedPos(range.start.row, range.start.column);
        var end = this.clippedPos(range.end.row, range.end.column);
        this.applyDelta({
            start: start,
            end: end,
            action: "remove",
            lines: this.getLinesForRange({start: start, end: end})
        });
        return this.clonePos(start);
    };
    this.removeInLine = function(row, startColumn, endColumn) {
        var start = this.clippedPos(row, startColumn);
        var end = this.clippedPos(row, endColumn);
        
        this.applyDelta({
            start: start,
            end: end,
            action: "remove",
            lines: this.getLinesForRange({start: start, end: end})
        }, true);
        
        return this.clonePos(start);
    };
    this.removeFullLines = function(firstRow, lastRow) {
        firstRow = Math.min(Math.max(0, firstRow), this.getLength() - 1);
        lastRow  = Math.min(Math.max(0, lastRow ), this.getLength() - 1);
        var deleteFirstNewLine = lastRow == this.getLength() - 1 && firstRow > 0;
        var deleteLastNewLine  = lastRow  < this.getLength() - 1;
        var startRow = ( deleteFirstNewLine ? firstRow - 1                  : firstRow                    );
        var startCol = ( deleteFirstNewLine ? this.getLine(startRow).length : 0                           );
        var endRow   = ( deleteLastNewLine  ? lastRow + 1                   : lastRow                     );
        var endCol   = ( deleteLastNewLine  ? 0                             : this.getLine(endRow).length ); 
        var range = new Range(startRow, startCol, endRow, endCol);
        var deletedLines = this.$lines.slice(firstRow, lastRow + 1);
        
        this.applyDelta({
            start: range.start,
            end: range.end,
            action: "remove",
            lines: this.getLinesForRange(range)
        });
        return deletedLines;
    };
    this.removeNewLine = function(row) {
        if (row < this.getLength() - 1 && row >= 0) {
            this.applyDelta({
                start: this.pos(row, this.getLine(row).length),
                end: this.pos(row + 1, 0),
                action: "remove",
                lines: ["", ""]
            });
        }
    };
    this.replace = function(range, text) {
        if (!(range instanceof Range))
            range = Range.fromPoints(range.start, range.end);
        if (text.length === 0 && range.isEmpty())
            return range.start;
        if (text == this.getTextRange(range))
            return range.end;

        this.remove(range);
        var end;
        if (text) {
            end = this.insert(range.start, text);
        }
        else {
            end = range.start;
        }
        
        return end;
    };
    this.applyDeltas = function(deltas) {
        for (var i=0; i<deltas.length; i++) {
            this.applyDelta(deltas[i]);
        }
    };
    this.revertDeltas = function(deltas) {
        for (var i=deltas.length-1; i>=0; i--) {
            this.revertDelta(deltas[i]);
        }
    };
    this.applyDelta = function(delta, doNotValidate) {
        var isInsert = delta.action == "insert";
        if (isInsert ? delta.lines.length <= 1 && !delta.lines[0]
            : !Range.comparePoints(delta.start, delta.end)) {
            return;
        }
        
        if (isInsert && delta.lines.length > 20000)
            this.$splitAndapplyLargeDelta(delta, 20000);
        applyDelta(this.$lines, delta, doNotValidate);
        this._signal("change", delta);
    };
    
    this.$splitAndapplyLargeDelta = function(delta, MAX) {
        var lines = delta.lines;
        var l = lines.length;
        var row = delta.start.row; 
        var column = delta.start.column;
        var from = 0, to = 0;
        do {
            from = to;
            to += MAX - 1;
            var chunk = lines.slice(from, to);
            if (to > l) {
                delta.lines = chunk;
                delta.start.row = row + from;
                delta.start.column = column;
                break;
            }
            chunk.push("");
            this.applyDelta({
                start: this.pos(row + from, column),
                end: this.pos(row + to, column = 0),
                action: delta.action,
                lines: chunk
            }, true);
        } while(true);
    };
    this.revertDelta = function(delta) {
        this.applyDelta({
            start: this.clonePos(delta.start),
            end: this.clonePos(delta.end),
            action: (delta.action == "insert" ? "remove" : "insert"),
            lines: delta.lines.slice()
        });
    };
    this.indexToPosition = function(index, startRow) {
        var lines = this.$lines || this.getAllLines();
        var newlineLength = this.getNewLineCharacter().length;
        for (var i = startRow || 0, l = lines.length; i < l; i++) {
            index -= lines[i].length + newlineLength;
            if (index < 0)
                return {row: i, column: index + lines[i].length + newlineLength};
        }
        return {row: l-1, column: lines[l-1].length};
    };
    this.positionToIndex = function(pos, startRow) {
        var lines = this.$lines || this.getAllLines();
        var newlineLength = this.getNewLineCharacter().length;
        var index = 0;
        var row = Math.min(pos.row, lines.length);
        for (var i = startRow || 0; i < row; ++i)
            index += lines[i].length + newlineLength;

        return index + pos.column;
    };

}).call(Document.prototype);

exports.Document = Document;
});

ace.define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;

var BackgroundTokenizer = function(tokenizer, editor) {
    this.running = false;
    this.lines = [];
    this.states = [];
    this.currentLine = 0;
    this.tokenizer = tokenizer;

    var self = this;

    this.$worker = function() {
        if (!self.running) { return; }

        var workerStart = new Date();
        var currentLine = self.currentLine;
        var endLine = -1;
        var doc = self.doc;

        var startLine = currentLine;
        while (self.lines[currentLine])
            currentLine++;
        
        var len = doc.getLength();
        var processedLines = 0;
        self.running = false;
        while (currentLine < len) {
            self.$tokenizeRow(currentLine);
            endLine = currentLine;
            do {
                currentLine++;
            } while (self.lines[currentLine]);
            processedLines ++;
            if ((processedLines % 5 === 0) && (new Date() - workerStart) > 20) {                
                self.running = setTimeout(self.$worker, 20);
                break;
            }
        }
        self.currentLine = currentLine;
        
        if (endLine == -1)
            endLine = currentLine;

        if (startLine <= endLine)
            self.fireUpdateEvent(startLine, endLine);
    };
};

(function(){

    oop.implement(this, EventEmitter);
    this.setTokenizer = function(tokenizer) {
        this.tokenizer = tokenizer;
        this.lines = [];
        this.states = [];

        this.start(0);
    };
    this.setDocument = function(doc) {
        this.doc = doc;
        this.lines = [];
        this.states = [];

        this.stop();
    };
    this.fireUpdateEvent = function(firstRow, lastRow) {
        var data = {
            first: firstRow,
            last: lastRow
        };
        this._signal("update", {data: data});
    };
    this.start = function(startRow) {
        this.currentLine = Math.min(startRow || 0, this.currentLine, this.doc.getLength());
        this.lines.splice(this.currentLine, this.lines.length);
        this.states.splice(this.currentLine, this.states.length);

        this.stop();
        this.running = setTimeout(this.$worker, 700);
    };
    
    this.scheduleStart = function() {
        if (!this.running)
            this.running = setTimeout(this.$worker, 700);
    };

    this.$updateOnChange = function(delta) {
        var startRow = delta.start.row;
        var len = delta.end.row - startRow;

        if (len === 0) {
            this.lines[startRow] = null;
        } else if (delta.action == "remove") {
            this.lines.splice(startRow, len + 1, null);
            this.states.splice(startRow, len + 1, null);
        } else {
            var args = Array(len + 1);
            args.unshift(startRow, 1);
            this.lines.splice.apply(this.lines, args);
            this.states.splice.apply(this.states, args);
        }

        this.currentLine = Math.min(startRow, this.currentLine, this.doc.getLength());

        this.stop();
    };
    this.stop = function() {
        if (this.running)
            clearTimeout(this.running);
        this.running = false;
    };
    this.getTokens = function(row) {
        return this.lines[row] || this.$tokenizeRow(row);
    };
    this.getState = function(row) {
        if (this.currentLine == row)
            this.$tokenizeRow(row);
        return this.states[row] || "start";
    };

    this.$tokenizeRow = function(row) {
        var line = this.doc.getLine(row);
        var state = this.states[row - 1];

        var data = this.tokenizer.getLineTokens(line, state, row);

        if (this.states[row] + "" !== data.state + "") {
            this.states[row] = data.state;
            this.lines[row + 1] = null;
            if (this.currentLine > row + 1)
                this.currentLine = row + 1;
        } else if (this.currentLine == row) {
            this.currentLine = row + 1;
        }

        return this.lines[row] = data.tokens;
    };

}).call(BackgroundTokenizer.prototype);

exports.BackgroundTokenizer = BackgroundTokenizer;
});

ace.define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"], function(acequire, exports, module) {
"use strict";

var lang = acequire("./lib/lang");
var oop = acequire("./lib/oop");
var Range = acequire("./range").Range;

var SearchHighlight = function(regExp, clazz, type) {
    this.setRegexp(regExp);
    this.clazz = clazz;
    this.type = type || "text";
};

(function() {
    this.MAX_RANGES = 500;
    
    this.setRegexp = function(regExp) {
        if (this.regExp+"" == regExp+"")
            return;
        this.regExp = regExp;
        this.cache = [];
    };

    this.update = function(html, markerLayer, session, config) {
        if (!this.regExp)
            return;
        var start = config.firstRow, end = config.lastRow;

        for (var i = start; i <= end; i++) {
            var ranges = this.cache[i];
            if (ranges == null) {
                ranges = lang.getMatchOffsets(session.getLine(i), this.regExp);
                if (ranges.length > this.MAX_RANGES)
                    ranges = ranges.slice(0, this.MAX_RANGES);
                ranges = ranges.map(function(match) {
                    return new Range(i, match.offset, i, match.offset + match.length);
                });
                this.cache[i] = ranges.length ? ranges : "";
            }

            for (var j = ranges.length; j --; ) {
                markerLayer.drawSingleLineMarker(
                    html, ranges[j].toScreenRange(session), this.clazz, config);
            }
        }
    };

}).call(SearchHighlight.prototype);

exports.SearchHighlight = SearchHighlight;
});

ace.define("ace/edit_session/fold_line",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
function FoldLine(foldData, folds) {
    this.foldData = foldData;
    if (Array.isArray(folds)) {
        this.folds = folds;
    } else {
        folds = this.folds = [ folds ];
    }

    var last = folds[folds.length - 1];
    this.range = new Range(folds[0].start.row, folds[0].start.column,
                           last.end.row, last.end.column);
    this.start = this.range.start;
    this.end   = this.range.end;

    this.folds.forEach(function(fold) {
        fold.setFoldLine(this);
    }, this);
}

(function() {
    this.shiftRow = function(shift) {
        this.start.row += shift;
        this.end.row += shift;
        this.folds.forEach(function(fold) {
            fold.start.row += shift;
            fold.end.row += shift;
        });
    };

    this.addFold = function(fold) {
        if (fold.sameRow) {
            if (fold.start.row < this.startRow || fold.endRow > this.endRow) {
                throw new Error("Can't add a fold to this FoldLine as it has no connection");
            }
            this.folds.push(fold);
            this.folds.sort(function(a, b) {
                return -a.range.compareEnd(b.start.row, b.start.column);
            });
            if (this.range.compareEnd(fold.start.row, fold.start.column) > 0) {
                this.end.row = fold.end.row;
                this.end.column =  fold.end.column;
            } else if (this.range.compareStart(fold.end.row, fold.end.column) < 0) {
                this.start.row = fold.start.row;
                this.start.column = fold.start.column;
            }
        } else if (fold.start.row == this.end.row) {
            this.folds.push(fold);
            this.end.row = fold.end.row;
            this.end.column = fold.end.column;
        } else if (fold.end.row == this.start.row) {
            this.folds.unshift(fold);
            this.start.row = fold.start.row;
            this.start.column = fold.start.column;
        } else {
            throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
        }
        fold.foldLine = this;
    };

    this.containsRow = function(row) {
        return row >= this.start.row && row <= this.end.row;
    };

    this.walk = function(callback, endRow, endColumn) {
        var lastEnd = 0,
            folds = this.folds,
            fold,
            cmp, stop, isNewRow = true;

        if (endRow == null) {
            endRow = this.end.row;
            endColumn = this.end.column;
        }

        for (var i = 0; i < folds.length; i++) {
            fold = folds[i];

            cmp = fold.range.compareStart(endRow, endColumn);
            if (cmp == -1) {
                callback(null, endRow, endColumn, lastEnd, isNewRow);
                return;
            }

            stop = callback(null, fold.start.row, fold.start.column, lastEnd, isNewRow);
            stop = !stop && callback(fold.placeholder, fold.start.row, fold.start.column, lastEnd);
            if (stop || cmp === 0) {
                return;
            }
            isNewRow = !fold.sameRow;
            lastEnd = fold.end.column;
        }
        callback(null, endRow, endColumn, lastEnd, isNewRow);
    };

    this.getNextFoldTo = function(row, column) {
        var fold, cmp;
        for (var i = 0; i < this.folds.length; i++) {
            fold = this.folds[i];
            cmp = fold.range.compareEnd(row, column);
            if (cmp == -1) {
                return {
                    fold: fold,
                    kind: "after"
                };
            } else if (cmp === 0) {
                return {
                    fold: fold,
                    kind: "inside"
                };
            }
        }
        return null;
    };

    this.addRemoveChars = function(row, column, len) {
        var ret = this.getNextFoldTo(row, column),
            fold, folds;
        if (ret) {
            fold = ret.fold;
            if (ret.kind == "inside"
                && fold.start.column != column
                && fold.start.row != row)
            {
                window.console && window.console.log(row, column, fold);
            } else if (fold.start.row == row) {
                folds = this.folds;
                var i = folds.indexOf(fold);
                if (i === 0) {
                    this.start.column += len;
                }
                for (i; i < folds.length; i++) {
                    fold = folds[i];
                    fold.start.column += len;
                    if (!fold.sameRow) {
                        return;
                    }
                    fold.end.column += len;
                }
                this.end.column += len;
            }
        }
    };

    this.split = function(row, column) {
        var pos = this.getNextFoldTo(row, column);
        
        if (!pos || pos.kind == "inside")
            return null;
            
        var fold = pos.fold;
        var folds = this.folds;
        var foldData = this.foldData;
        
        var i = folds.indexOf(fold);
        var foldBefore = folds[i - 1];
        this.end.row = foldBefore.end.row;
        this.end.column = foldBefore.end.column;
        folds = folds.splice(i, folds.length - i);

        var newFoldLine = new FoldLine(foldData, folds);
        foldData.splice(foldData.indexOf(this) + 1, 0, newFoldLine);
        return newFoldLine;
    };

    this.merge = function(foldLineNext) {
        var folds = foldLineNext.folds;
        for (var i = 0; i < folds.length; i++) {
            this.addFold(folds[i]);
        }
        var foldData = this.foldData;
        foldData.splice(foldData.indexOf(foldLineNext), 1);
    };

    this.toString = function() {
        var ret = [this.range.toString() + ": [" ];

        this.folds.forEach(function(fold) {
            ret.push("  " + fold.toString());
        });
        ret.push("]");
        return ret.join("\n");
    };

    this.idxToPosition = function(idx) {
        var lastFoldEndColumn = 0;

        for (var i = 0; i < this.folds.length; i++) {
            var fold = this.folds[i];

            idx -= fold.start.column - lastFoldEndColumn;
            if (idx < 0) {
                return {
                    row: fold.start.row,
                    column: fold.start.column + idx
                };
            }

            idx -= fold.placeholder.length;
            if (idx < 0) {
                return fold.start;
            }

            lastFoldEndColumn = fold.end.column;
        }

        return {
            row: this.end.row,
            column: this.end.column + idx
        };
    };
}).call(FoldLine.prototype);

exports.FoldLine = FoldLine;
});

ace.define("ace/range_list",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";
var Range = acequire("./range").Range;
var comparePoints = Range.comparePoints;

var RangeList = function() {
    this.ranges = [];
};

(function() {
    this.comparePoints = comparePoints;

    this.pointIndex = function(pos, excludeEdges, startIndex) {
        var list = this.ranges;

        for (var i = startIndex || 0; i < list.length; i++) {
            var range = list[i];
            var cmpEnd = comparePoints(pos, range.end);
            if (cmpEnd > 0)
                continue;
            var cmpStart = comparePoints(pos, range.start);
            if (cmpEnd === 0)
                return excludeEdges && cmpStart !== 0 ? -i-2 : i;
            if (cmpStart > 0 || (cmpStart === 0 && !excludeEdges))
                return i;

            return -i-1;
        }
        return -i - 1;
    };

    this.add = function(range) {
        var excludeEdges = !range.isEmpty();
        var startIndex = this.pointIndex(range.start, excludeEdges);
        if (startIndex < 0)
            startIndex = -startIndex - 1;

        var endIndex = this.pointIndex(range.end, excludeEdges, startIndex);

        if (endIndex < 0)
            endIndex = -endIndex - 1;
        else
            endIndex++;
        return this.ranges.splice(startIndex, endIndex - startIndex, range);
    };

    this.addList = function(list) {
        var removed = [];
        for (var i = list.length; i--; ) {
            removed.push.apply(removed, this.add(list[i]));
        }
        return removed;
    };

    this.substractPoint = function(pos) {
        var i = this.pointIndex(pos);

        if (i >= 0)
            return this.ranges.splice(i, 1);
    };
    this.merge = function() {
        var removed = [];
        var list = this.ranges;
        
        list = list.sort(function(a, b) {
            return comparePoints(a.start, b.start);
        });
        
        var next = list[0], range;
        for (var i = 1; i < list.length; i++) {
            range = next;
            next = list[i];
            var cmp = comparePoints(range.end, next.start);
            if (cmp < 0)
                continue;

            if (cmp == 0 && !range.isEmpty() && !next.isEmpty())
                continue;

            if (comparePoints(range.end, next.end) < 0) {
                range.end.row = next.end.row;
                range.end.column = next.end.column;
            }

            list.splice(i, 1);
            removed.push(next);
            next = range;
            i--;
        }
        
        this.ranges = list;

        return removed;
    };

    this.contains = function(row, column) {
        return this.pointIndex({row: row, column: column}) >= 0;
    };

    this.containsPoint = function(pos) {
        return this.pointIndex(pos) >= 0;
    };

    this.rangeAtPoint = function(pos) {
        var i = this.pointIndex(pos);
        if (i >= 0)
            return this.ranges[i];
    };


    this.clipRows = function(startRow, endRow) {
        var list = this.ranges;
        if (list[0].start.row > endRow || list[list.length - 1].start.row < startRow)
            return [];

        var startIndex = this.pointIndex({row: startRow, column: 0});
        if (startIndex < 0)
            startIndex = -startIndex - 1;
        var endIndex = this.pointIndex({row: endRow, column: 0}, startIndex);
        if (endIndex < 0)
            endIndex = -endIndex - 1;

        var clipped = [];
        for (var i = startIndex; i < endIndex; i++) {
            clipped.push(list[i]);
        }
        return clipped;
    };

    this.removeAll = function() {
        return this.ranges.splice(0, this.ranges.length);
    };

    this.attach = function(session) {
        if (this.session)
            this.detach();

        this.session = session;
        this.onChange = this.$onChange.bind(this);

        this.session.on('change', this.onChange);
    };

    this.detach = function() {
        if (!this.session)
            return;
        this.session.removeListener('change', this.onChange);
        this.session = null;
    };

    this.$onChange = function(delta) {
        if (delta.action == "insert"){
            var start = delta.start;
            var end = delta.end;
        } else {
            var end = delta.start;
            var start = delta.end;
        }
        var startRow = start.row;
        var endRow = end.row;
        var lineDif = endRow - startRow;

        var colDiff = -start.column + end.column;
        var ranges = this.ranges;

        for (var i = 0, n = ranges.length; i < n; i++) {
            var r = ranges[i];
            if (r.end.row < startRow)
                continue;
            if (r.start.row > startRow)
                break;

            if (r.start.row == startRow && r.start.column >= start.column ) {
                if (r.start.column == start.column && this.$insertRight) {
                } else {
                    r.start.column += colDiff;
                    r.start.row += lineDif;
                }
            }
            if (r.end.row == startRow && r.end.column >= start.column) {
                if (r.end.column == start.column && this.$insertRight) {
                    continue;
                }
                if (r.end.column == start.column && colDiff > 0 && i < n - 1) {                
                    if (r.end.column > r.start.column && r.end.column == ranges[i+1].start.column)
                        r.end.column -= colDiff;
                }
                r.end.column += colDiff;
                r.end.row += lineDif;
            }
        }

        if (lineDif != 0 && i < n) {
            for (; i < n; i++) {
                var r = ranges[i];
                r.start.row += lineDif;
                r.end.row += lineDif;
            }
        }
    };

}).call(RangeList.prototype);

exports.RangeList = RangeList;
});

ace.define("ace/edit_session/fold",["require","exports","module","ace/range","ace/range_list","ace/lib/oop"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
var RangeList = acequire("../range_list").RangeList;
var oop = acequire("../lib/oop");
var Fold = exports.Fold = function(range, placeholder) {
    this.foldLine = null;
    this.placeholder = placeholder;
    this.range = range;
    this.start = range.start;
    this.end = range.end;

    this.sameRow = range.start.row == range.end.row;
    this.subFolds = this.ranges = [];
};

oop.inherits(Fold, RangeList);

(function() {

    this.toString = function() {
        return '"' + this.placeholder + '" ' + this.range.toString();
    };

    this.setFoldLine = function(foldLine) {
        this.foldLine = foldLine;
        this.subFolds.forEach(function(fold) {
            fold.setFoldLine(foldLine);
        });
    };

    this.clone = function() {
        var range = this.range.clone();
        var fold = new Fold(range, this.placeholder);
        this.subFolds.forEach(function(subFold) {
            fold.subFolds.push(subFold.clone());
        });
        fold.collapseChildren = this.collapseChildren;
        return fold;
    };

    this.addSubFold = function(fold) {
        if (this.range.isEqual(fold))
            return;

        if (!this.range.containsRange(fold))
            throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);
        consumeRange(fold, this.start);

        var row = fold.start.row, column = fold.start.column;
        for (var i = 0, cmp = -1; i < this.subFolds.length; i++) {
            cmp = this.subFolds[i].range.compare(row, column);
            if (cmp != 1)
                break;
        }
        var afterStart = this.subFolds[i];

        if (cmp == 0)
            return afterStart.addSubFold(fold);
        var row = fold.range.end.row, column = fold.range.end.column;
        for (var j = i, cmp = -1; j < this.subFolds.length; j++) {
            cmp = this.subFolds[j].range.compare(row, column);
            if (cmp != 1)
                break;
        }
        var afterEnd = this.subFolds[j];

        if (cmp == 0)
            throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);

        var consumedFolds = this.subFolds.splice(i, j - i, fold);
        fold.setFoldLine(this.foldLine);

        return fold;
    };
    
    this.restoreRange = function(range) {
        return restoreRange(range, this.start);
    };

}).call(Fold.prototype);

function consumePoint(point, anchor) {
    point.row -= anchor.row;
    if (point.row == 0)
        point.column -= anchor.column;
}
function consumeRange(range, anchor) {
    consumePoint(range.start, anchor);
    consumePoint(range.end, anchor);
}
function restorePoint(point, anchor) {
    if (point.row == 0)
        point.column += anchor.column;
    point.row += anchor.row;
}
function restoreRange(range, anchor) {
    restorePoint(range.start, anchor);
    restorePoint(range.end, anchor);
}

});

ace.define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
var FoldLine = acequire("./fold_line").FoldLine;
var Fold = acequire("./fold").Fold;
var TokenIterator = acequire("../token_iterator").TokenIterator;

function Folding() {
    this.getFoldAt = function(row, column, side) {
        var foldLine = this.getFoldLine(row);
        if (!foldLine)
            return null;

        var folds = foldLine.folds;
        for (var i = 0; i < folds.length; i++) {
            var fold = folds[i];
            if (fold.range.contains(row, column)) {
                if (side == 1 && fold.range.isEnd(row, column)) {
                    continue;
                } else if (side == -1 && fold.range.isStart(row, column)) {
                    continue;
                }
                return fold;
            }
        }
    };
    this.getFoldsInRange = function(range) {
        var start = range.start;
        var end = range.end;
        var foldLines = this.$foldData;
        var foundFolds = [];

        start.column += 1;
        end.column -= 1;

        for (var i = 0; i < foldLines.length; i++) {
            var cmp = foldLines[i].range.compareRange(range);
            if (cmp == 2) {
                continue;
            }
            else if (cmp == -2) {
                break;
            }

            var folds = foldLines[i].folds;
            for (var j = 0; j < folds.length; j++) {
                var fold = folds[j];
                cmp = fold.range.compareRange(range);
                if (cmp == -2) {
                    break;
                } else if (cmp == 2) {
                    continue;
                } else
                if (cmp == 42) {
                    break;
                }
                foundFolds.push(fold);
            }
        }
        start.column -= 1;
        end.column += 1;

        return foundFolds;
    };

    this.getFoldsInRangeList = function(ranges) {
        if (Array.isArray(ranges)) {
            var folds = [];
            ranges.forEach(function(range) {
                folds = folds.concat(this.getFoldsInRange(range));
            }, this);
        } else {
            var folds = this.getFoldsInRange(ranges);
        }
        return folds;
    };
    this.getAllFolds = function() {
        var folds = [];
        var foldLines = this.$foldData;
        
        for (var i = 0; i < foldLines.length; i++)
            for (var j = 0; j < foldLines[i].folds.length; j++)
                folds.push(foldLines[i].folds[j]);

        return folds;
    };
    this.getFoldStringAt = function(row, column, trim, foldLine) {
        foldLine = foldLine || this.getFoldLine(row);
        if (!foldLine)
            return null;

        var lastFold = {
            end: { column: 0 }
        };
        var str, fold;
        for (var i = 0; i < foldLine.folds.length; i++) {
            fold = foldLine.folds[i];
            var cmp = fold.range.compareEnd(row, column);
            if (cmp == -1) {
                str = this
                    .getLine(fold.start.row)
                    .substring(lastFold.end.column, fold.start.column);
                break;
            }
            else if (cmp === 0) {
                return null;
            }
            lastFold = fold;
        }
        if (!str)
            str = this.getLine(fold.start.row).substring(lastFold.end.column);

        if (trim == -1)
            return str.substring(0, column - lastFold.end.column);
        else if (trim == 1)
            return str.substring(column - lastFold.end.column);
        else
            return str;
    };

    this.getFoldLine = function(docRow, startFoldLine) {
        var foldData = this.$foldData;
        var i = 0;
        if (startFoldLine)
            i = foldData.indexOf(startFoldLine);
        if (i == -1)
            i = 0;
        for (i; i < foldData.length; i++) {
            var foldLine = foldData[i];
            if (foldLine.start.row <= docRow && foldLine.end.row >= docRow) {
                return foldLine;
            } else if (foldLine.end.row > docRow) {
                return null;
            }
        }
        return null;
    };
    this.getNextFoldLine = function(docRow, startFoldLine) {
        var foldData = this.$foldData;
        var i = 0;
        if (startFoldLine)
            i = foldData.indexOf(startFoldLine);
        if (i == -1)
            i = 0;
        for (i; i < foldData.length; i++) {
            var foldLine = foldData[i];
            if (foldLine.end.row >= docRow) {
                return foldLine;
            }
        }
        return null;
    };

    this.getFoldedRowCount = function(first, last) {
        var foldData = this.$foldData, rowCount = last-first+1;
        for (var i = 0; i < foldData.length; i++) {
            var foldLine = foldData[i],
                end = foldLine.end.row,
                start = foldLine.start.row;
            if (end >= last) {
                if (start < last) {
                    if (start >= first)
                        rowCount -= last-start;
                    else
                        rowCount = 0; // in one fold
                }
                break;
            } else if (end >= first){
                if (start >= first) // fold inside range
                    rowCount -=  end-start;
                else
                    rowCount -=  end-first+1;
            }
        }
        return rowCount;
    };

    this.$addFoldLine = function(foldLine) {
        this.$foldData.push(foldLine);
        this.$foldData.sort(function(a, b) {
            return a.start.row - b.start.row;
        });
        return foldLine;
    };
    this.addFold = function(placeholder, range) {
        var foldData = this.$foldData;
        var added = false;
        var fold;
        
        if (placeholder instanceof Fold)
            fold = placeholder;
        else {
            fold = new Fold(range, placeholder);
            fold.collapseChildren = range.collapseChildren;
        }
        this.$clipRangeToDocument(fold.range);

        var startRow = fold.start.row;
        var startColumn = fold.start.column;
        var endRow = fold.end.row;
        var endColumn = fold.end.column;
        if (!(startRow < endRow || 
            startRow == endRow && startColumn <= endColumn - 2))
            throw new Error("The range has to be at least 2 characters width");

        var startFold = this.getFoldAt(startRow, startColumn, 1);
        var endFold = this.getFoldAt(endRow, endColumn, -1);
        if (startFold && endFold == startFold)
            return startFold.addSubFold(fold);

        if (startFold && !startFold.range.isStart(startRow, startColumn))
            this.removeFold(startFold);
        
        if (endFold && !endFold.range.isEnd(endRow, endColumn))
            this.removeFold(endFold);
        var folds = this.getFoldsInRange(fold.range);
        if (folds.length > 0) {
            this.removeFolds(folds);
            folds.forEach(function(subFold) {
                fold.addSubFold(subFold);
            });
        }

        for (var i = 0; i < foldData.length; i++) {
            var foldLine = foldData[i];
            if (endRow == foldLine.start.row) {
                foldLine.addFold(fold);
                added = true;
                break;
            } else if (startRow == foldLine.end.row) {
                foldLine.addFold(fold);
                added = true;
                if (!fold.sameRow) {
                    var foldLineNext = foldData[i + 1];
                    if (foldLineNext && foldLineNext.start.row == endRow) {
                        foldLine.merge(foldLineNext);
                        break;
                    }
                }
                break;
            } else if (endRow <= foldLine.start.row) {
                break;
            }
        }

        if (!added)
            foldLine = this.$addFoldLine(new FoldLine(this.$foldData, fold));

        if (this.$useWrapMode)
            this.$updateWrapData(foldLine.start.row, foldLine.start.row);
        else
            this.$updateRowLengthCache(foldLine.start.row, foldLine.start.row);
        this.$modified = true;
        this._signal("changeFold", { data: fold, action: "add" });

        return fold;
    };

    this.addFolds = function(folds) {
        folds.forEach(function(fold) {
            this.addFold(fold);
        }, this);
    };

    this.removeFold = function(fold) {
        var foldLine = fold.foldLine;
        var startRow = foldLine.start.row;
        var endRow = foldLine.end.row;

        var foldLines = this.$foldData;
        var folds = foldLine.folds;
        if (folds.length == 1) {
            foldLines.splice(foldLines.indexOf(foldLine), 1);
        } else
        if (foldLine.range.isEnd(fold.end.row, fold.end.column)) {
            folds.pop();
            foldLine.end.row = folds[folds.length - 1].end.row;
            foldLine.end.column = folds[folds.length - 1].end.column;
        } else
        if (foldLine.range.isStart(fold.start.row, fold.start.column)) {
            folds.shift();
            foldLine.start.row = folds[0].start.row;
            foldLine.start.column = folds[0].start.column;
        } else
        if (fold.sameRow) {
            folds.splice(folds.indexOf(fold), 1);
        } else
        {
            var newFoldLine = foldLine.split(fold.start.row, fold.start.column);
            folds = newFoldLine.folds;
            folds.shift();
            newFoldLine.start.row = folds[0].start.row;
            newFoldLine.start.column = folds[0].start.column;
        }

        if (!this.$updating) {
            if (this.$useWrapMode)
                this.$updateWrapData(startRow, endRow);
            else
                this.$updateRowLengthCache(startRow, endRow);
        }
        this.$modified = true;
        this._signal("changeFold", { data: fold, action: "remove" });
    };

    this.removeFolds = function(folds) {
        var cloneFolds = [];
        for (var i = 0; i < folds.length; i++) {
            cloneFolds.push(folds[i]);
        }

        cloneFolds.forEach(function(fold) {
            this.removeFold(fold);
        }, this);
        this.$modified = true;
    };

    this.expandFold = function(fold) {
        this.removeFold(fold);
        fold.subFolds.forEach(function(subFold) {
            fold.restoreRange(subFold);
            this.addFold(subFold);
        }, this);
        if (fold.collapseChildren > 0) {
            this.foldAll(fold.start.row+1, fold.end.row, fold.collapseChildren-1);
        }
        fold.subFolds = [];
    };

    this.expandFolds = function(folds) {
        folds.forEach(function(fold) {
            this.expandFold(fold);
        }, this);
    };

    this.unfold = function(location, expandInner) {
        var range, folds;
        if (location == null) {
            range = new Range(0, 0, this.getLength(), 0);
            expandInner = true;
        } else if (typeof location == "number")
            range = new Range(location, 0, location, this.getLine(location).length);
        else if ("row" in location)
            range = Range.fromPoints(location, location);
        else
            range = location;
        
        folds = this.getFoldsInRangeList(range);
        if (expandInner) {
            this.removeFolds(folds);
        } else {
            var subFolds = folds;
            while (subFolds.length) {
                this.expandFolds(subFolds);
                subFolds = this.getFoldsInRangeList(range);
            }
        }
        if (folds.length)
            return folds;
    };
    this.isRowFolded = function(docRow, startFoldRow) {
        return !!this.getFoldLine(docRow, startFoldRow);
    };

    this.getRowFoldEnd = function(docRow, startFoldRow) {
        var foldLine = this.getFoldLine(docRow, startFoldRow);
        return foldLine ? foldLine.end.row : docRow;
    };

    this.getRowFoldStart = function(docRow, startFoldRow) {
        var foldLine = this.getFoldLine(docRow, startFoldRow);
        return foldLine ? foldLine.start.row : docRow;
    };

    this.getFoldDisplayLine = function(foldLine, endRow, endColumn, startRow, startColumn) {
        if (startRow == null)
            startRow = foldLine.start.row;
        if (startColumn == null)
            startColumn = 0;
        if (endRow == null)
            endRow = foldLine.end.row;
        if (endColumn == null)
            endColumn = this.getLine(endRow).length;
        var doc = this.doc;
        var textLine = "";

        foldLine.walk(function(placeholder, row, column, lastColumn) {
            if (row < startRow)
                return;
            if (row == startRow) {
                if (column < startColumn)
                    return;
                lastColumn = Math.max(startColumn, lastColumn);
            }

            if (placeholder != null) {
                textLine += placeholder;
            } else {
                textLine += doc.getLine(row).substring(lastColumn, column);
            }
        }, endRow, endColumn);
        return textLine;
    };

    this.getDisplayLine = function(row, endColumn, startRow, startColumn) {
        var foldLine = this.getFoldLine(row);

        if (!foldLine) {
            var line;
            line = this.doc.getLine(row);
            return line.substring(startColumn || 0, endColumn || line.length);
        } else {
            return this.getFoldDisplayLine(
                foldLine, row, endColumn, startRow, startColumn);
        }
    };

    this.$cloneFoldData = function() {
        var fd = [];
        fd = this.$foldData.map(function(foldLine) {
            var folds = foldLine.folds.map(function(fold) {
                return fold.clone();
            });
            return new FoldLine(fd, folds);
        });

        return fd;
    };

    this.toggleFold = function(tryToUnfold) {
        var selection = this.selection;
        var range = selection.getRange();
        var fold;
        var bracketPos;

        if (range.isEmpty()) {
            var cursor = range.start;
            fold = this.getFoldAt(cursor.row, cursor.column);

            if (fold) {
                this.expandFold(fold);
                return;
            } else if (bracketPos = this.findMatchingBracket(cursor)) {
                if (range.comparePoint(bracketPos) == 1) {
                    range.end = bracketPos;
                } else {
                    range.start = bracketPos;
                    range.start.column++;
                    range.end.column--;
                }
            } else if (bracketPos = this.findMatchingBracket({row: cursor.row, column: cursor.column + 1})) {
                if (range.comparePoint(bracketPos) == 1)
                    range.end = bracketPos;
                else
                    range.start = bracketPos;

                range.start.column++;
            } else {
                range = this.getCommentFoldRange(cursor.row, cursor.column) || range;
            }
        } else {
            var folds = this.getFoldsInRange(range);
            if (tryToUnfold && folds.length) {
                this.expandFolds(folds);
                return;
            } else if (folds.length == 1 ) {
                fold = folds[0];
            }
        }

        if (!fold)
            fold = this.getFoldAt(range.start.row, range.start.column);

        if (fold && fold.range.toString() == range.toString()) {
            this.expandFold(fold);
            return;
        }

        var placeholder = "...";
        if (!range.isMultiLine()) {
            placeholder = this.getTextRange(range);
            if (placeholder.length < 4)
                return;
            placeholder = placeholder.trim().substring(0, 2) + "..";
        }

        this.addFold(placeholder, range);
    };

    this.getCommentFoldRange = function(row, column, dir) {
        var iterator = new TokenIterator(this, row, column);
        var token = iterator.getCurrentToken();
        var type = token.type;
        if (token && /^comment|string/.test(type)) {
            type = type.match(/comment|string/)[0];
            if (type == "comment")
                type += "|doc-start";
            var re = new RegExp(type);
            var range = new Range();
            if (dir != 1) {
                do {
                    token = iterator.stepBackward();
                } while (token && re.test(token.type));
                iterator.stepForward();
            }
            
            range.start.row = iterator.getCurrentTokenRow();
            range.start.column = iterator.getCurrentTokenColumn() + 2;

            iterator = new TokenIterator(this, row, column);
            
            if (dir != -1) {
                var lastRow = -1;
                do {
                    token = iterator.stepForward();
                    if (lastRow == -1) {
                        var state = this.getState(iterator.$row);
                        if (!re.test(state))
                            lastRow = iterator.$row;
                    } else if (iterator.$row > lastRow) {
                        break;
                    }
                } while (token && re.test(token.type));
                token = iterator.stepBackward();
            } else
                token = iterator.getCurrentToken();

            range.end.row = iterator.getCurrentTokenRow();
            range.end.column = iterator.getCurrentTokenColumn() + token.value.length - 2;
            return range;
        }
    };

    this.foldAll = function(startRow, endRow, depth) {
        if (depth == undefined)
            depth = 100000; // JSON.stringify doesn't hanle Infinity
        var foldWidgets = this.foldWidgets;
        if (!foldWidgets)
            return; // mode doesn't support folding
        endRow = endRow || this.getLength();
        startRow = startRow || 0;
        for (var row = startRow; row < endRow; row++) {
            if (foldWidgets[row] == null)
                foldWidgets[row] = this.getFoldWidget(row);
            if (foldWidgets[row] != "start")
                continue;

            var range = this.getFoldWidgetRange(row);
            if (range && range.isMultiLine()
                && range.end.row <= endRow
                && range.start.row >= startRow
            ) {
                row = range.end.row;
                try {
                    var fold = this.addFold("...", range);
                    if (fold)
                        fold.collapseChildren = depth;
                } catch(e) {}
            }
        }
    };
    this.$foldStyles = {
        "manual": 1,
        "markbegin": 1,
        "markbeginend": 1
    };
    this.$foldStyle = "markbegin";
    this.setFoldStyle = function(style) {
        if (!this.$foldStyles[style])
            throw new Error("invalid fold style: " + style + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
        
        if (this.$foldStyle == style)
            return;

        this.$foldStyle = style;
        
        if (style == "manual")
            this.unfold();
        var mode = this.$foldMode;
        this.$setFolding(null);
        this.$setFolding(mode);
    };

    this.$setFolding = function(foldMode) {
        if (this.$foldMode == foldMode)
            return;
            
        this.$foldMode = foldMode;
        
        this.off('change', this.$updateFoldWidgets);
        this.off('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
        this._signal("changeAnnotation");
        
        if (!foldMode || this.$foldStyle == "manual") {
            this.foldWidgets = null;
            return;
        }
        
        this.foldWidgets = [];
        this.getFoldWidget = foldMode.getFoldWidget.bind(foldMode, this, this.$foldStyle);
        this.getFoldWidgetRange = foldMode.getFoldWidgetRange.bind(foldMode, this, this.$foldStyle);
        
        this.$updateFoldWidgets = this.updateFoldWidgets.bind(this);
        this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this);
        this.on('change', this.$updateFoldWidgets);
        this.on('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
    };

    this.getParentFoldRangeData = function (row, ignoreCurrent) {
        var fw = this.foldWidgets;
        if (!fw || (ignoreCurrent && fw[row]))
            return {};

        var i = row - 1, firstRange;
        while (i >= 0) {
            var c = fw[i];
            if (c == null)
                c = fw[i] = this.getFoldWidget(i);

            if (c == "start") {
                var range = this.getFoldWidgetRange(i);
                if (!firstRange)
                    firstRange = range;
                if (range && range.end.row >= row)
                    break;
            }
            i--;
        }

        return {
            range: i !== -1 && range,
            firstRange: firstRange
        };
    };

    this.onFoldWidgetClick = function(row, e) {
        e = e.domEvent;
        var options = {
            children: e.shiftKey,
            all: e.ctrlKey || e.metaKey,
            siblings: e.altKey
        };
        
        var range = this.$toggleFoldWidget(row, options);
        if (!range) {
            var el = (e.target || e.srcElement);
            if (el && /ace_fold-widget/.test(el.className))
                el.className += " ace_invalid";
        }
    };
    
    this.$toggleFoldWidget = function(row, options) {
        if (!this.getFoldWidget)
            return;
        var type = this.getFoldWidget(row);
        var line = this.getLine(row);

        var dir = type === "end" ? -1 : 1;
        var fold = this.getFoldAt(row, dir === -1 ? 0 : line.length, dir);

        if (fold) {
            if (options.children || options.all)
                this.removeFold(fold);
            else
                this.expandFold(fold);
            return fold;
        }

        var range = this.getFoldWidgetRange(row, true);
        if (range && !range.isMultiLine()) {
            fold = this.getFoldAt(range.start.row, range.start.column, 1);
            if (fold && range.isEqual(fold.range)) {
                this.removeFold(fold);
                return fold;
            }
        }
        
        if (options.siblings) {
            var data = this.getParentFoldRangeData(row);
            if (data.range) {
                var startRow = data.range.start.row + 1;
                var endRow = data.range.end.row;
            }
            this.foldAll(startRow, endRow, options.all ? 10000 : 0);
        } else if (options.children) {
            endRow = range ? range.end.row : this.getLength();
            this.foldAll(row + 1, endRow, options.all ? 10000 : 0);
        } else if (range) {
            if (options.all) 
                range.collapseChildren = 10000;
            this.addFold("...", range);
        }
        
        return range;
    };
    
    
    
    this.toggleFoldWidget = function(toggleParent) {
        var row = this.selection.getCursor().row;
        row = this.getRowFoldStart(row);
        var range = this.$toggleFoldWidget(row, {});
        
        if (range)
            return;
        var data = this.getParentFoldRangeData(row, true);
        range = data.range || data.firstRange;
        
        if (range) {
            row = range.start.row;
            var fold = this.getFoldAt(row, this.getLine(row).length, 1);

            if (fold) {
                this.removeFold(fold);
            } else {
                this.addFold("...", range);
            }
        }
    };

    this.updateFoldWidgets = function(delta) {
        var firstRow = delta.start.row;
        var len = delta.end.row - firstRow;

        if (len === 0) {
            this.foldWidgets[firstRow] = null;
        } else if (delta.action == 'remove') {
            this.foldWidgets.splice(firstRow, len + 1, null);
        } else {
            var args = Array(len + 1);
            args.unshift(firstRow, 1);
            this.foldWidgets.splice.apply(this.foldWidgets, args);
        }
    };
    this.tokenizerUpdateFoldWidgets = function(e) {
        var rows = e.data;
        if (rows.first != rows.last) {
            if (this.foldWidgets.length > rows.first)
                this.foldWidgets.splice(rows.first, this.foldWidgets.length);
        }
    };
}

exports.Folding = Folding;

});

ace.define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"], function(acequire, exports, module) {
"use strict";

var TokenIterator = acequire("../token_iterator").TokenIterator;
var Range = acequire("../range").Range;


function BracketMatch() {

    this.findMatchingBracket = function(position, chr) {
        if (position.column == 0) return null;

        var charBeforeCursor = chr || this.getLine(position.row).charAt(position.column-1);
        if (charBeforeCursor == "") return null;

        var match = charBeforeCursor.match(/([\(\[\{])|([\)\]\}])/);
        if (!match)
            return null;

        if (match[1])
            return this.$findClosingBracket(match[1], position);
        else
            return this.$findOpeningBracket(match[2], position);
    };
    
    this.getBracketRange = function(pos) {
        var line = this.getLine(pos.row);
        var before = true, range;

        var chr = line.charAt(pos.column-1);
        var match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
        if (!match) {
            chr = line.charAt(pos.column);
            pos = {row: pos.row, column: pos.column + 1};
            match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
            before = false;
        }
        if (!match)
            return null;

        if (match[1]) {
            var bracketPos = this.$findClosingBracket(match[1], pos);
            if (!bracketPos)
                return null;
            range = Range.fromPoints(pos, bracketPos);
            if (!before) {
                range.end.column++;
                range.start.column--;
            }
            range.cursor = range.end;
        } else {
            var bracketPos = this.$findOpeningBracket(match[2], pos);
            if (!bracketPos)
                return null;
            range = Range.fromPoints(bracketPos, pos);
            if (!before) {
                range.start.column++;
                range.end.column--;
            }
            range.cursor = range.start;
        }
        
        return range;
    };

    this.$brackets = {
        ")": "(",
        "(": ")",
        "]": "[",
        "[": "]",
        "{": "}",
        "}": "{"
    };

    this.$findOpeningBracket = function(bracket, position, typeRe) {
        var openBracket = this.$brackets[bracket];
        var depth = 1;

        var iterator = new TokenIterator(this, position.row, position.column);
        var token = iterator.getCurrentToken();
        if (!token)
            token = iterator.stepForward();
        if (!token)
            return;
        
         if (!typeRe){
            typeRe = new RegExp(
                "(\\.?" +
                token.type.replace(".", "\\.").replace("rparen", ".paren")
                    .replace(/\b(?:end)\b/, "(?:start|begin|end)")
                + ")+"
            );
        }
        var valueIndex = position.column - iterator.getCurrentTokenColumn() - 2;
        var value = token.value;
        
        while (true) {
        
            while (valueIndex >= 0) {
                var chr = value.charAt(valueIndex);
                if (chr == openBracket) {
                    depth -= 1;
                    if (depth == 0) {
                        return {row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()};
                    }
                }
                else if (chr == bracket) {
                    depth += 1;
                }
                valueIndex -= 1;
            }
            do {
                token = iterator.stepBackward();
            } while (token && !typeRe.test(token.type));

            if (token == null)
                break;
                
            value = token.value;
            valueIndex = value.length - 1;
        }
        
        return null;
    };

    this.$findClosingBracket = function(bracket, position, typeRe) {
        var closingBracket = this.$brackets[bracket];
        var depth = 1;

        var iterator = new TokenIterator(this, position.row, position.column);
        var token = iterator.getCurrentToken();
        if (!token)
            token = iterator.stepForward();
        if (!token)
            return;

        if (!typeRe){
            typeRe = new RegExp(
                "(\\.?" +
                token.type.replace(".", "\\.").replace("lparen", ".paren")
                    .replace(/\b(?:start|begin)\b/, "(?:start|begin|end)")
                + ")+"
            );
        }
        var valueIndex = position.column - iterator.getCurrentTokenColumn();

        while (true) {

            var value = token.value;
            var valueLength = value.length;
            while (valueIndex < valueLength) {
                var chr = value.charAt(valueIndex);
                if (chr == closingBracket) {
                    depth -= 1;
                    if (depth == 0) {
                        return {row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()};
                    }
                }
                else if (chr == bracket) {
                    depth += 1;
                }
                valueIndex += 1;
            }
            do {
                token = iterator.stepForward();
            } while (token && !typeRe.test(token.type));

            if (token == null)
                break;

            valueIndex = 0;
        }
        
        return null;
    };
}
exports.BracketMatch = BracketMatch;

});

ace.define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/bidihandler","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/document","ace/background_tokenizer","ace/search_highlight","ace/edit_session/folding","ace/edit_session/bracket_match"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var lang = acequire("./lib/lang");
var BidiHandler = acequire("./bidihandler").BidiHandler;
var config = acequire("./config");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var Selection = acequire("./selection").Selection;
var TextMode = acequire("./mode/text").Mode;
var Range = acequire("./range").Range;
var Document = acequire("./document").Document;
var BackgroundTokenizer = acequire("./background_tokenizer").BackgroundTokenizer;
var SearchHighlight = acequire("./search_highlight").SearchHighlight;

var EditSession = function(text, mode) {
    this.$breakpoints = [];
    this.$decorations = [];
    this.$frontMarkers = {};
    this.$backMarkers = {};
    this.$markerId = 1;
    this.$undoSelect = true;

    this.$foldData = [];
    this.id = "session" + (++EditSession.$uid);
    this.$foldData.toString = function() {
        return this.join("\n");
    };
    this.on("changeFold", this.onChangeFold.bind(this));
    this.$onChange = this.onChange.bind(this);

    if (typeof text != "object" || !text.getLine)
        text = new Document(text);

    this.$bidiHandler = new BidiHandler(this);
    this.setDocument(text);
    this.selection = new Selection(this);

    config.resetOptions(this);
    this.setMode(mode);
    config._signal("session", this);
};


EditSession.$uid = 0;

(function() {

    oop.implement(this, EventEmitter);
    this.setDocument = function(doc) {
        if (this.doc)
            this.doc.removeListener("change", this.$onChange);

        this.doc = doc;
        doc.on("change", this.$onChange);

        if (this.bgTokenizer)
            this.bgTokenizer.setDocument(this.getDocument());

        this.resetCaches();
    };
    this.getDocument = function() {
        return this.doc;
    };
    this.$resetRowCache = function(docRow) {
        if (!docRow) {
            this.$docRowCache = [];
            this.$screenRowCache = [];
            return;
        }
        var l = this.$docRowCache.length;
        var i = this.$getRowCacheIndex(this.$docRowCache, docRow) + 1;
        if (l > i) {
            this.$docRowCache.splice(i, l);
            this.$screenRowCache.splice(i, l);
        }
    };

    this.$getRowCacheIndex = function(cacheArray, val) {
        var low = 0;
        var hi = cacheArray.length - 1;

        while (low <= hi) {
            var mid = (low + hi) >> 1;
            var c = cacheArray[mid];

            if (val > c)
                low = mid + 1;
            else if (val < c)
                hi = mid - 1;
            else
                return mid;
        }

        return low -1;
    };

    this.resetCaches = function() {
        this.$modified = true;
        this.$wrapData = [];
        this.$rowLengthCache = [];
        this.$resetRowCache(0);
        if (this.bgTokenizer)
            this.bgTokenizer.start(0);
    };

    this.onChangeFold = function(e) {
        var fold = e.data;
        this.$resetRowCache(fold.start.row);
    };

    this.onChange = function(delta) {
        this.$modified = true;
        this.$bidiHandler.onChange(delta);
        this.$resetRowCache(delta.start.row);

        var removedFolds = this.$updateInternalDataOnChange(delta);
        if (!this.$fromUndo && this.$undoManager && !delta.ignore) {
            this.$deltasDoc.push(delta);
            if (removedFolds && removedFolds.length != 0) {
                this.$deltasFold.push({
                    action: "removeFolds",
                    folds:  removedFolds
                });
            }

            this.$informUndoManager.schedule();
        }

        this.bgTokenizer && this.bgTokenizer.$updateOnChange(delta);
        this._signal("change", delta);
    };
    this.setValue = function(text) {
        this.doc.setValue(text);
        this.selection.moveTo(0, 0);

        this.$resetRowCache(0);
        this.$deltas = [];
        this.$deltasDoc = [];
        this.$deltasFold = [];
        this.setUndoManager(this.$undoManager);
        this.getUndoManager().reset();
    };
    this.getValue =
    this.toString = function() {
        return this.doc.getValue();
    };
    this.getSelection = function() {
        return this.selection;
    };
    this.getState = function(row) {
        return this.bgTokenizer.getState(row);
    };
    this.getTokens = function(row) {
        return this.bgTokenizer.getTokens(row);
    };
    this.getTokenAt = function(row, column) {
        var tokens = this.bgTokenizer.getTokens(row);
        var token, c = 0;
        if (column == null) {
            var i = tokens.length - 1;
            c = this.getLine(row).length;
        } else {
            for (var i = 0; i < tokens.length; i++) {
                c += tokens[i].value.length;
                if (c >= column)
                    break;
            }
        }
        token = tokens[i];
        if (!token)
            return null;
        token.index = i;
        token.start = c - token.value.length;
        return token;
    };
    this.setUndoManager = function(undoManager) {
        this.$undoManager = undoManager;
        this.$deltas = [];
        this.$deltasDoc = [];
        this.$deltasFold = [];

        if (this.$informUndoManager)
            this.$informUndoManager.cancel();

        if (undoManager) {
            var self = this;

            this.$syncInformUndoManager = function() {
                self.$informUndoManager.cancel();

                if (self.$deltasFold.length) {
                    self.$deltas.push({
                        group: "fold",
                        deltas: self.$deltasFold
                    });
                    self.$deltasFold = [];
                }

                if (self.$deltasDoc.length) {
                    self.$deltas.push({
                        group: "doc",
                        deltas: self.$deltasDoc
                    });
                    self.$deltasDoc = [];
                }

                if (self.$deltas.length > 0) {
                    undoManager.execute({
                        action: "aceupdate",
                        args: [self.$deltas, self],
                        merge: self.mergeUndoDeltas
                    });
                }
                self.mergeUndoDeltas = false;
                self.$deltas = [];
            };
            this.$informUndoManager = lang.delayedCall(this.$syncInformUndoManager);
        }
    };
    this.markUndoGroup = function() {
        if (this.$syncInformUndoManager)
            this.$syncInformUndoManager();
    };
    
    this.$defaultUndoManager = {
        undo: function() {},
        redo: function() {},
        reset: function() {}
    };
    this.getUndoManager = function() {
        return this.$undoManager || this.$defaultUndoManager;
    };
    this.getTabString = function() {
        if (this.getUseSoftTabs()) {
            return lang.stringRepeat(" ", this.getTabSize());
        } else {
            return "\t";
        }
    };
    this.setUseSoftTabs = function(val) {
        this.setOption("useSoftTabs", val);
    };
    this.getUseSoftTabs = function() {
        return this.$useSoftTabs && !this.$mode.$indentWithTabs;
    };
    this.setTabSize = function(tabSize) {
        this.setOption("tabSize", tabSize);
    };
    this.getTabSize = function() {
        return this.$tabSize;
    };
    this.isTabStop = function(position) {
        return this.$useSoftTabs && (position.column % this.$tabSize === 0);
    };
    this.setNavigateWithinSoftTabs = function (navigateWithinSoftTabs) {
        this.setOption("navigateWithinSoftTabs", navigateWithinSoftTabs);
    };
    this.getNavigateWithinSoftTabs = function() {
        return this.$navigateWithinSoftTabs;
    };

    this.$overwrite = false;
    this.setOverwrite = function(overwrite) {
        this.setOption("overwrite", overwrite);
    };
    this.getOverwrite = function() {
        return this.$overwrite;
    };
    this.toggleOverwrite = function() {
        this.setOverwrite(!this.$overwrite);
    };
    this.addGutterDecoration = function(row, className) {
        if (!this.$decorations[row])
            this.$decorations[row] = "";
        this.$decorations[row] += " " + className;
        this._signal("changeBreakpoint", {});
    };
    this.removeGutterDecoration = function(row, className) {
        this.$decorations[row] = (this.$decorations[row] || "").replace(" " + className, "");
        this._signal("changeBreakpoint", {});
    };
    this.getBreakpoints = function() {
        return this.$breakpoints;
    };
    this.setBreakpoints = function(rows) {
        this.$breakpoints = [];
        for (var i=0; i<rows.length; i++) {
            this.$breakpoints[rows[i]] = "ace_breakpoint";
        }
        this._signal("changeBreakpoint", {});
    };
    this.clearBreakpoints = function() {
        this.$breakpoints = [];
        this._signal("changeBreakpoint", {});
    };
    this.setBreakpoint = function(row, className) {
        if (className === undefined)
            className = "ace_breakpoint";
        if (className)
            this.$breakpoints[row] = className;
        else
            delete this.$breakpoints[row];
        this._signal("changeBreakpoint", {});
    };
    this.clearBreakpoint = function(row) {
        delete this.$breakpoints[row];
        this._signal("changeBreakpoint", {});
    };
    this.addMarker = function(range, clazz, type, inFront) {
        var id = this.$markerId++;

        var marker = {
            range : range,
            type : type || "line",
            renderer: typeof type == "function" ? type : null,
            clazz : clazz,
            inFront: !!inFront,
            id: id
        };

        if (inFront) {
            this.$frontMarkers[id] = marker;
            this._signal("changeFrontMarker");
        } else {
            this.$backMarkers[id] = marker;
            this._signal("changeBackMarker");
        }

        return id;
    };
    this.addDynamicMarker = function(marker, inFront) {
        if (!marker.update)
            return;
        var id = this.$markerId++;
        marker.id = id;
        marker.inFront = !!inFront;

        if (inFront) {
            this.$frontMarkers[id] = marker;
            this._signal("changeFrontMarker");
        } else {
            this.$backMarkers[id] = marker;
            this._signal("changeBackMarker");
        }

        return marker;
    };
    this.removeMarker = function(markerId) {
        var marker = this.$frontMarkers[markerId] || this.$backMarkers[markerId];
        if (!marker)
            return;

        var markers = marker.inFront ? this.$frontMarkers : this.$backMarkers;
        if (marker) {
            delete (markers[markerId]);
            this._signal(marker.inFront ? "changeFrontMarker" : "changeBackMarker");
        }
    };
    this.getMarkers = function(inFront) {
        return inFront ? this.$frontMarkers : this.$backMarkers;
    };

    this.highlight = function(re) {
        if (!this.$searchHighlight) {
            var highlight = new SearchHighlight(null, "ace_selected-word", "text");
            this.$searchHighlight = this.addDynamicMarker(highlight);
        }
        this.$searchHighlight.setRegexp(re);
    };
    this.highlightLines = function(startRow, endRow, clazz, inFront) {
        if (typeof endRow != "number") {
            clazz = endRow;
            endRow = startRow;
        }
        if (!clazz)
            clazz = "ace_step";

        var range = new Range(startRow, 0, endRow, Infinity);
        range.id = this.addMarker(range, clazz, "fullLine", inFront);
        return range;
    };
    this.setAnnotations = function(annotations) {
        this.$annotations = annotations;
        this._signal("changeAnnotation", {});
    };
    this.getAnnotations = function() {
        return this.$annotations || [];
    };
    this.clearAnnotations = function() {
        this.setAnnotations([]);
    };
    this.$detectNewLine = function(text) {
        var match = text.match(/^.*?(\r?\n)/m);
        if (match) {
            this.$autoNewLine = match[1];
        } else {
            this.$autoNewLine = "\n";
        }
    };
    this.getWordRange = function(row, column) {
        var line = this.getLine(row);

        var inToken = false;
        if (column > 0)
            inToken = !!line.charAt(column - 1).match(this.tokenRe);

        if (!inToken)
            inToken = !!line.charAt(column).match(this.tokenRe);

        if (inToken)
            var re = this.tokenRe;
        else if (/^\s+$/.test(line.slice(column-1, column+1)))
            var re = /\s/;
        else
            var re = this.nonTokenRe;

        var start = column;
        if (start > 0) {
            do {
                start--;
            }
            while (start >= 0 && line.charAt(start).match(re));
            start++;
        }

        var end = column;
        while (end < line.length && line.charAt(end).match(re)) {
            end++;
        }

        return new Range(row, start, row, end);
    };
    this.getAWordRange = function(row, column) {
        var wordRange = this.getWordRange(row, column);
        var line = this.getLine(wordRange.end.row);

        while (line.charAt(wordRange.end.column).match(/[ \t]/)) {
            wordRange.end.column += 1;
        }
        return wordRange;
    };
    this.setNewLineMode = function(newLineMode) {
        this.doc.setNewLineMode(newLineMode);
    };
    this.getNewLineMode = function() {
        return this.doc.getNewLineMode();
    };
    this.setUseWorker = function(useWorker) { this.setOption("useWorker", useWorker); };
    this.getUseWorker = function() { return this.$useWorker; };
    this.onReloadTokenizer = function(e) {
        var rows = e.data;
        this.bgTokenizer.start(rows.first);
        this._signal("tokenizerUpdate", e);
    };

    this.$modes = {};
    this.$mode = null;
    this.$modeId = null;
    this.setMode = function(mode, cb) {
        if (mode && typeof mode === "object") {
            if (mode.getTokenizer)
                return this.$onChangeMode(mode);
            var options = mode;
            var path = options.path;
        } else {
            path = mode || "ace/mode/text";
        }
        if (!this.$modes["ace/mode/text"])
            this.$modes["ace/mode/text"] = new TextMode();

        if (this.$modes[path] && !options) {
            this.$onChangeMode(this.$modes[path]);
            cb && cb();
            return;
        }
        this.$modeId = path;
        config.loadModule(["mode", path], function(m) {
            if (this.$modeId !== path)
                return cb && cb();
            if (this.$modes[path] && !options) {
                this.$onChangeMode(this.$modes[path]);
            } else if (m && m.Mode) {
                m = new m.Mode(options);
                if (!options) {
                    this.$modes[path] = m;
                    m.$id = path;
                }
                this.$onChangeMode(m);
            }
            cb && cb();
        }.bind(this));
        if (!this.$mode)
            this.$onChangeMode(this.$modes["ace/mode/text"], true);
    };

    this.$onChangeMode = function(mode, $isPlaceholder) {
        if (!$isPlaceholder)
            this.$modeId = mode.$id;
        if (this.$mode === mode) 
            return;

        this.$mode = mode;

        this.$stopWorker();

        if (this.$useWorker)
            this.$startWorker();

        var tokenizer = mode.getTokenizer();

        if(tokenizer.addEventListener !== undefined) {
            var onReloadTokenizer = this.onReloadTokenizer.bind(this);
            tokenizer.addEventListener("update", onReloadTokenizer);
        }

        if (!this.bgTokenizer) {
            this.bgTokenizer = new BackgroundTokenizer(tokenizer);
            var _self = this;
            this.bgTokenizer.addEventListener("update", function(e) {
                _self._signal("tokenizerUpdate", e);
            });
        } else {
            this.bgTokenizer.setTokenizer(tokenizer);
        }

        this.bgTokenizer.setDocument(this.getDocument());

        this.tokenRe = mode.tokenRe;
        this.nonTokenRe = mode.nonTokenRe;

        
        if (!$isPlaceholder) {
            if (mode.attachToSession)
                mode.attachToSession(this);
            this.$options.wrapMethod.set.call(this, this.$wrapMethod);
            this.$setFolding(mode.foldingRules);
            this.bgTokenizer.start(0);
            this._emit("changeMode");
        }
    };

    this.$stopWorker = function() {
        if (this.$worker) {
            this.$worker.terminate();
            this.$worker = null;
        }
    };

    this.$startWorker = function() {
        try {
            this.$worker = this.$mode.createWorker(this);
        } catch (e) {
            config.warn("Could not load worker", e);
            this.$worker = null;
        }
    };
    this.getMode = function() {
        return this.$mode;
    };

    this.$scrollTop = 0;
    this.setScrollTop = function(scrollTop) {
        if (this.$scrollTop === scrollTop || isNaN(scrollTop))
            return;

        this.$scrollTop = scrollTop;
        this._signal("changeScrollTop", scrollTop);
    };
    this.getScrollTop = function() {
        return this.$scrollTop;
    };

    this.$scrollLeft = 0;
    this.setScrollLeft = function(scrollLeft) {
        if (this.$scrollLeft === scrollLeft || isNaN(scrollLeft))
            return;

        this.$scrollLeft = scrollLeft;
        this._signal("changeScrollLeft", scrollLeft);
    };
    this.getScrollLeft = function() {
        return this.$scrollLeft;
    };
    this.getScreenWidth = function() {
        this.$computeWidth();
        if (this.lineWidgets) 
            return Math.max(this.getLineWidgetMaxWidth(), this.screenWidth);
        return this.screenWidth;
    };
    
    this.getLineWidgetMaxWidth = function() {
        if (this.lineWidgetsWidth != null) return this.lineWidgetsWidth;
        var width = 0;
        this.lineWidgets.forEach(function(w) {
            if (w && w.screenWidth > width)
                width = w.screenWidth;
        });
        return this.lineWidgetWidth = width;
    };

    this.$computeWidth = function(force) {
        if (this.$modified || force) {
            this.$modified = false;

            if (this.$useWrapMode)
                return this.screenWidth = this.$wrapLimit;

            var lines = this.doc.getAllLines();
            var cache = this.$rowLengthCache;
            var longestScreenLine = 0;
            var foldIndex = 0;
            var foldLine = this.$foldData[foldIndex];
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            var len = lines.length;

            for (var i = 0; i < len; i++) {
                if (i > foldStart) {
                    i = foldLine.end.row + 1;
                    if (i >= len)
                        break;
                    foldLine = this.$foldData[foldIndex++];
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }

                if (cache[i] == null)
                    cache[i] = this.$getStringScreenWidth(lines[i])[0];

                if (cache[i] > longestScreenLine)
                    longestScreenLine = cache[i];
            }
            this.screenWidth = longestScreenLine;
        }
    };
    this.getLine = function(row) {
        return this.doc.getLine(row);
    };
    this.getLines = function(firstRow, lastRow) {
        return this.doc.getLines(firstRow, lastRow);
    };
    this.getLength = function() {
        return this.doc.getLength();
    };
    this.getTextRange = function(range) {
        return this.doc.getTextRange(range || this.selection.getRange());
    };
    this.insert = function(position, text) {
        return this.doc.insert(position, text);
    };
    this.remove = function(range) {
        return this.doc.remove(range);
    };
    this.removeFullLines = function(firstRow, lastRow){
        return this.doc.removeFullLines(firstRow, lastRow);
    };
    this.undoChanges = function(deltas, dontSelect) {
        if (!deltas.length)
            return;

        this.$fromUndo = true;
        var lastUndoRange = null;
        for (var i = deltas.length - 1; i != -1; i--) {
            var delta = deltas[i];
            if (delta.group == "doc") {
                this.doc.revertDeltas(delta.deltas);
                lastUndoRange =
                    this.$getUndoSelection(delta.deltas, true, lastUndoRange);
            } else {
                delta.deltas.forEach(function(foldDelta) {
                    this.addFolds(foldDelta.folds);
                }, this);
            }
        }
        this.$fromUndo = false;
        lastUndoRange &&
            this.$undoSelect &&
            !dontSelect &&
            this.selection.setSelectionRange(lastUndoRange);
        return lastUndoRange;
    };
    this.redoChanges = function(deltas, dontSelect) {
        if (!deltas.length)
            return;

        this.$fromUndo = true;
        var lastUndoRange = null;
        for (var i = 0; i < deltas.length; i++) {
            var delta = deltas[i];
            if (delta.group == "doc") {
                this.doc.applyDeltas(delta.deltas);
                lastUndoRange =
                    this.$getUndoSelection(delta.deltas, false, lastUndoRange);
            }
        }
        this.$fromUndo = false;
        lastUndoRange &&
            this.$undoSelect &&
            !dontSelect &&
            this.selection.setSelectionRange(lastUndoRange);
        return lastUndoRange;
    };
    this.setUndoSelect = function(enable) {
        this.$undoSelect = enable;
    };

    this.$getUndoSelection = function(deltas, isUndo, lastUndoRange) {
        function isInsert(delta) {
            return isUndo ? delta.action !== "insert" : delta.action === "insert";
        }

        var delta = deltas[0];
        var range, point;
        var lastDeltaIsInsert = false;
        if (isInsert(delta)) {
            range = Range.fromPoints(delta.start, delta.end);
            lastDeltaIsInsert = true;
        } else {
            range = Range.fromPoints(delta.start, delta.start);
            lastDeltaIsInsert = false;
        }

        for (var i = 1; i < deltas.length; i++) {
            delta = deltas[i];
            if (isInsert(delta)) {
                point = delta.start;
                if (range.compare(point.row, point.column) == -1) {
                    range.setStart(point);
                }
                point = delta.end;
                if (range.compare(point.row, point.column) == 1) {
                    range.setEnd(point);
                }
                lastDeltaIsInsert = true;
            } else {
                point = delta.start;
                if (range.compare(point.row, point.column) == -1) {
                    range = Range.fromPoints(delta.start, delta.start);
                }
                lastDeltaIsInsert = false;
            }
        }
        if (lastUndoRange != null) {
            if (Range.comparePoints(lastUndoRange.start, range.start) === 0) {
                lastUndoRange.start.column += range.end.column - range.start.column;
                lastUndoRange.end.column += range.end.column - range.start.column;
            }

            var cmp = lastUndoRange.compareRange(range);
            if (cmp == 1) {
                range.setStart(lastUndoRange.start);
            } else if (cmp == -1) {
                range.setEnd(lastUndoRange.end);
            }
        }

        return range;
    };
    this.replace = function(range, text) {
        return this.doc.replace(range, text);
    };
    this.moveText = function(fromRange, toPosition, copy) {
        var text = this.getTextRange(fromRange);
        var folds = this.getFoldsInRange(fromRange);

        var toRange = Range.fromPoints(toPosition, toPosition);
        if (!copy) {
            this.remove(fromRange);
            var rowDiff = fromRange.start.row - fromRange.end.row;
            var collDiff = rowDiff ? -fromRange.end.column : fromRange.start.column - fromRange.end.column;
            if (collDiff) {
                if (toRange.start.row == fromRange.end.row && toRange.start.column > fromRange.end.column)
                    toRange.start.column += collDiff;
                if (toRange.end.row == fromRange.end.row && toRange.end.column > fromRange.end.column)
                    toRange.end.column += collDiff;
            }
            if (rowDiff && toRange.start.row >= fromRange.end.row) {
                toRange.start.row += rowDiff;
                toRange.end.row += rowDiff;
            }
        }

        toRange.end = this.insert(toRange.start, text);
        if (folds.length) {
            var oldStart = fromRange.start;
            var newStart = toRange.start;
            var rowDiff = newStart.row - oldStart.row;
            var collDiff = newStart.column - oldStart.column;
            this.addFolds(folds.map(function(x) {
                x = x.clone();
                if (x.start.row == oldStart.row)
                    x.start.column += collDiff;
                if (x.end.row == oldStart.row)
                    x.end.column += collDiff;
                x.start.row += rowDiff;
                x.end.row += rowDiff;
                return x;
            }));
        }

        return toRange;
    };
    this.indentRows = function(startRow, endRow, indentString) {
        indentString = indentString.replace(/\t/g, this.getTabString());
        for (var row=startRow; row<=endRow; row++)
            this.doc.insertInLine({row: row, column: 0}, indentString);
    };
    this.outdentRows = function (range) {
        var rowRange = range.collapseRows();
        var deleteRange = new Range(0, 0, 0, 0);
        var size = this.getTabSize();

        for (var i = rowRange.start.row; i <= rowRange.end.row; ++i) {
            var line = this.getLine(i);

            deleteRange.start.row = i;
            deleteRange.end.row = i;
            for (var j = 0; j < size; ++j)
                if (line.charAt(j) != ' ')
                    break;
            if (j < size && line.charAt(j) == '\t') {
                deleteRange.start.column = j;
                deleteRange.end.column = j + 1;
            } else {
                deleteRange.start.column = 0;
                deleteRange.end.column = j;
            }
            this.remove(deleteRange);
        }
    };

    this.$moveLines = function(firstRow, lastRow, dir) {
        firstRow = this.getRowFoldStart(firstRow);
        lastRow = this.getRowFoldEnd(lastRow);
        if (dir < 0) {
            var row = this.getRowFoldStart(firstRow + dir);
            if (row < 0) return 0;
            var diff = row-firstRow;
        } else if (dir > 0) {
            var row = this.getRowFoldEnd(lastRow + dir);
            if (row > this.doc.getLength()-1) return 0;
            var diff = row-lastRow;
        } else {
            firstRow = this.$clipRowToDocument(firstRow);
            lastRow = this.$clipRowToDocument(lastRow);
            var diff = lastRow - firstRow + 1;
        }

        var range = new Range(firstRow, 0, lastRow, Number.MAX_VALUE);
        var folds = this.getFoldsInRange(range).map(function(x){
            x = x.clone();
            x.start.row += diff;
            x.end.row += diff;
            return x;
        });
        
        var lines = dir == 0
            ? this.doc.getLines(firstRow, lastRow)
            : this.doc.removeFullLines(firstRow, lastRow);
        this.doc.insertFullLines(firstRow+diff, lines);
        folds.length && this.addFolds(folds);
        return diff;
    };
    this.moveLinesUp = function(firstRow, lastRow) {
        return this.$moveLines(firstRow, lastRow, -1);
    };
    this.moveLinesDown = function(firstRow, lastRow) {
        return this.$moveLines(firstRow, lastRow, 1);
    };
    this.duplicateLines = function(firstRow, lastRow) {
        return this.$moveLines(firstRow, lastRow, 0);
    };


    this.$clipRowToDocument = function(row) {
        return Math.max(0, Math.min(row, this.doc.getLength()-1));
    };

    this.$clipColumnToRow = function(row, column) {
        if (column < 0)
            return 0;
        return Math.min(this.doc.getLine(row).length, column);
    };


    this.$clipPositionToDocument = function(row, column) {
        column = Math.max(0, column);

        if (row < 0) {
            row = 0;
            column = 0;
        } else {
            var len = this.doc.getLength();
            if (row >= len) {
                row = len - 1;
                column = this.doc.getLine(len-1).length;
            } else {
                column = Math.min(this.doc.getLine(row).length, column);
            }
        }

        return {
            row: row,
            column: column
        };
    };

    this.$clipRangeToDocument = function(range) {
        if (range.start.row < 0) {
            range.start.row = 0;
            range.start.column = 0;
        } else {
            range.start.column = this.$clipColumnToRow(
                range.start.row,
                range.start.column
            );
        }

        var len = this.doc.getLength() - 1;
        if (range.end.row > len) {
            range.end.row = len;
            range.end.column = this.doc.getLine(len).length;
        } else {
            range.end.column = this.$clipColumnToRow(
                range.end.row,
                range.end.column
            );
        }
        return range;
    };
    this.$wrapLimit = 80;
    this.$useWrapMode = false;
    this.$wrapLimitRange = {
        min : null,
        max : null
    };
    this.setUseWrapMode = function(useWrapMode) {
        if (useWrapMode != this.$useWrapMode) {
            this.$useWrapMode = useWrapMode;
            this.$modified = true;
            this.$resetRowCache(0);
            if (useWrapMode) {
                var len = this.getLength();
                this.$wrapData = Array(len);
                this.$updateWrapData(0, len - 1);
            }

            this._signal("changeWrapMode");
        }
    };
    this.getUseWrapMode = function() {
        return this.$useWrapMode;
    };
    this.setWrapLimitRange = function(min, max) {
        if (this.$wrapLimitRange.min !== min || this.$wrapLimitRange.max !== max) {
            this.$wrapLimitRange = { min: min, max: max };
            this.$modified = true;
            this.$bidiHandler.markAsDirty();
            if (this.$useWrapMode)
                this._signal("changeWrapMode");
        }
    };
    this.adjustWrapLimit = function(desiredLimit, $printMargin) {
        var limits = this.$wrapLimitRange;
        if (limits.max < 0)
            limits = {min: $printMargin, max: $printMargin};
        var wrapLimit = this.$constrainWrapLimit(desiredLimit, limits.min, limits.max);
        if (wrapLimit != this.$wrapLimit && wrapLimit > 1) {
            this.$wrapLimit = wrapLimit;
            this.$modified = true;
            if (this.$useWrapMode) {
                this.$updateWrapData(0, this.getLength() - 1);
                this.$resetRowCache(0);
                this._signal("changeWrapLimit");
            }
            return true;
        }
        return false;
    };

    this.$constrainWrapLimit = function(wrapLimit, min, max) {
        if (min)
            wrapLimit = Math.max(min, wrapLimit);

        if (max)
            wrapLimit = Math.min(max, wrapLimit);

        return wrapLimit;
    };
    this.getWrapLimit = function() {
        return this.$wrapLimit;
    };
    this.setWrapLimit = function (limit) {
        this.setWrapLimitRange(limit, limit);
    };
    this.getWrapLimitRange = function() {
        return {
            min : this.$wrapLimitRange.min,
            max : this.$wrapLimitRange.max
        };
    };

    this.$updateInternalDataOnChange = function(delta) {
        var useWrapMode = this.$useWrapMode;
        var action = delta.action;
        var start = delta.start;
        var end = delta.end;
        var firstRow = start.row;
        var lastRow = end.row;
        var len = lastRow - firstRow;
        var removedFolds = null;
        
        this.$updating = true;
        if (len != 0) {
            if (action === "remove") {
                this[useWrapMode ? "$wrapData" : "$rowLengthCache"].splice(firstRow, len);

                var foldLines = this.$foldData;
                removedFolds = this.getFoldsInRange(delta);
                this.removeFolds(removedFolds);

                var foldLine = this.getFoldLine(end.row);
                var idx = 0;
                if (foldLine) {
                    foldLine.addRemoveChars(end.row, end.column, start.column - end.column);
                    foldLine.shiftRow(-len);

                    var foldLineBefore = this.getFoldLine(firstRow);
                    if (foldLineBefore && foldLineBefore !== foldLine) {
                        foldLineBefore.merge(foldLine);
                        foldLine = foldLineBefore;
                    }
                    idx = foldLines.indexOf(foldLine) + 1;
                }

                for (idx; idx < foldLines.length; idx++) {
                    var foldLine = foldLines[idx];
                    if (foldLine.start.row >= end.row) {
                        foldLine.shiftRow(-len);
                    }
                }

                lastRow = firstRow;
            } else {
                var args = Array(len);
                args.unshift(firstRow, 0);
                var arr = useWrapMode ? this.$wrapData : this.$rowLengthCache;
                arr.splice.apply(arr, args);
                var foldLines = this.$foldData;
                var foldLine = this.getFoldLine(firstRow);
                var idx = 0;
                if (foldLine) {
                    var cmp = foldLine.range.compareInside(start.row, start.column);
                    if (cmp == 0) {
                        foldLine = foldLine.split(start.row, start.column);
                        if (foldLine) {
                            foldLine.shiftRow(len);
                            foldLine.addRemoveChars(lastRow, 0, end.column - start.column);
                        }
                    } else
                    if (cmp == -1) {
                        foldLine.addRemoveChars(firstRow, 0, end.column - start.column);
                        foldLine.shiftRow(len);
                    }
                    idx = foldLines.indexOf(foldLine) + 1;
                }

                for (idx; idx < foldLines.length; idx++) {
                    var foldLine = foldLines[idx];
                    if (foldLine.start.row >= firstRow) {
                        foldLine.shiftRow(len);
                    }
                }
            }
        } else {
            len = Math.abs(delta.start.column - delta.end.column);
            if (action === "remove") {
                removedFolds = this.getFoldsInRange(delta);
                this.removeFolds(removedFolds);

                len = -len;
            }
            var foldLine = this.getFoldLine(firstRow);
            if (foldLine) {
                foldLine.addRemoveChars(firstRow, start.column, len);
            }
        }

        if (useWrapMode && this.$wrapData.length != this.doc.getLength()) {
            console.error("doc.getLength() and $wrapData.length have to be the same!");
        }
        this.$updating = false;

        if (useWrapMode)
            this.$updateWrapData(firstRow, lastRow);
        else
            this.$updateRowLengthCache(firstRow, lastRow);

        return removedFolds;
    };

    this.$updateRowLengthCache = function(firstRow, lastRow, b) {
        this.$rowLengthCache[firstRow] = null;
        this.$rowLengthCache[lastRow] = null;
    };

    this.$updateWrapData = function(firstRow, lastRow) {
        var lines = this.doc.getAllLines();
        var tabSize = this.getTabSize();
        var wrapData = this.$wrapData;
        var wrapLimit = this.$wrapLimit;
        var tokens;
        var foldLine;

        var row = firstRow;
        lastRow = Math.min(lastRow, lines.length - 1);
        while (row <= lastRow) {
            foldLine = this.getFoldLine(row, foldLine);
            if (!foldLine) {
                tokens = this.$getDisplayTokens(lines[row]);
                wrapData[row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                row ++;
            } else {
                tokens = [];
                foldLine.walk(function(placeholder, row, column, lastColumn) {
                        var walkTokens;
                        if (placeholder != null) {
                            walkTokens = this.$getDisplayTokens(
                                            placeholder, tokens.length);
                            walkTokens[0] = PLACEHOLDER_START;
                            for (var i = 1; i < walkTokens.length; i++) {
                                walkTokens[i] = PLACEHOLDER_BODY;
                            }
                        } else {
                            walkTokens = this.$getDisplayTokens(
                                lines[row].substring(lastColumn, column),
                                tokens.length);
                        }
                        tokens = tokens.concat(walkTokens);
                    }.bind(this),
                    foldLine.end.row,
                    lines[foldLine.end.row].length + 1
                );

                wrapData[foldLine.start.row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                row = foldLine.end.row + 1;
            }
        }
    };
    var CHAR = 1,
        CHAR_EXT = 2,
        PLACEHOLDER_START = 3,
        PLACEHOLDER_BODY =  4,
        PUNCTUATION = 9,
        SPACE = 10,
        TAB = 11,
        TAB_SPACE = 12;


    this.$computeWrapSplits = function(tokens, wrapLimit, tabSize) {
        if (tokens.length == 0) {
            return [];
        }

        var splits = [];
        var displayLength = tokens.length;
        var lastSplit = 0, lastDocSplit = 0;

        var isCode = this.$wrapAsCode;

        var indentedSoftWrap = this.$indentedSoftWrap;
        var maxIndent = wrapLimit <= Math.max(2 * tabSize, 8)
            || indentedSoftWrap === false ? 0 : Math.floor(wrapLimit / 2);

        function getWrapIndent() {
            var indentation = 0;
            if (maxIndent === 0)
                return indentation;
            if (indentedSoftWrap) {
                for (var i = 0; i < tokens.length; i++) {
                    var token = tokens[i];
                    if (token == SPACE)
                        indentation += 1;
                    else if (token == TAB)
                        indentation += tabSize;
                    else if (token == TAB_SPACE)
                        continue;
                    else
                        break;
                }
            }
            if (isCode && indentedSoftWrap !== false)
                indentation += tabSize;
            return Math.min(indentation, maxIndent);
        }
        function addSplit(screenPos) {
            var displayed = tokens.slice(lastSplit, screenPos);
            var len = displayed.length;
            displayed.join("")
                .replace(/12/g, function() {
                    len -= 1;
                })
                .replace(/2/g, function() {
                    len -= 1;
                });

            if (!splits.length) {
                indent = getWrapIndent();
                splits.indent = indent;
            }
            lastDocSplit += len;
            splits.push(lastDocSplit);
            lastSplit = screenPos;
        }
        var indent = 0;
        while (displayLength - lastSplit > wrapLimit - indent) {
            var split = lastSplit + wrapLimit - indent;
            if (tokens[split - 1] >= SPACE && tokens[split] >= SPACE) {
                addSplit(split);
                continue;
            }
            if (tokens[split] == PLACEHOLDER_START || tokens[split] == PLACEHOLDER_BODY) {
                for (split; split != lastSplit - 1; split--) {
                    if (tokens[split] == PLACEHOLDER_START) {
                        break;
                    }
                }
                if (split > lastSplit) {
                    addSplit(split);
                    continue;
                }
                split = lastSplit + wrapLimit;
                for (split; split < tokens.length; split++) {
                    if (tokens[split] != PLACEHOLDER_BODY) {
                        break;
                    }
                }
                if (split == tokens.length) {
                    break;  // Breaks the while-loop.
                }
                addSplit(split);
                continue;
            }
            var minSplit = Math.max(split - (wrapLimit -(wrapLimit>>2)), lastSplit - 1);
            while (split > minSplit && tokens[split] < PLACEHOLDER_START) {
                split --;
            }
            if (isCode) {
                while (split > minSplit && tokens[split] < PLACEHOLDER_START) {
                    split --;
                }
                while (split > minSplit && tokens[split] == PUNCTUATION) {
                    split --;
                }
            } else {
                while (split > minSplit && tokens[split] < SPACE) {
                    split --;
                }
            }
            if (split > minSplit) {
                addSplit(++split);
                continue;
            }
            split = lastSplit + wrapLimit;
            if (tokens[split] == CHAR_EXT)
                split--;
            addSplit(split - indent);
        }
        return splits;
    };
    this.$getDisplayTokens = function(str, offset) {
        var arr = [];
        var tabSize;
        offset = offset || 0;

        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            if (c == 9) {
                tabSize = this.getScreenTabSize(arr.length + offset);
                arr.push(TAB);
                for (var n = 1; n < tabSize; n++) {
                    arr.push(TAB_SPACE);
                }
            }
            else if (c == 32) {
                arr.push(SPACE);
            } else if((c > 39 && c < 48) || (c > 57 && c < 64)) {
                arr.push(PUNCTUATION);
            }
            else if (c >= 0x1100 && isFullWidth(c)) {
                arr.push(CHAR, CHAR_EXT);
            } else {
                arr.push(CHAR);
            }
        }
        return arr;
    };
    this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
        if (maxScreenColumn == 0)
            return [0, 0];
        if (maxScreenColumn == null)
            maxScreenColumn = Infinity;
        screenColumn = screenColumn || 0;

        var c, column;
        for (column = 0; column < str.length; column++) {
            c = str.charCodeAt(column);
            if (c == 9) {
                screenColumn += this.getScreenTabSize(screenColumn);
            }
            else if (c >= 0x1100 && isFullWidth(c)) {
                screenColumn += 2;
            } else {
                screenColumn += 1;
            }
            if (screenColumn > maxScreenColumn) {
                break;
            }
        }

        return [screenColumn, column];
    };

    this.lineWidgets = null;
    this.getRowLength = function(row) {
        if (this.lineWidgets)
            var h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
        else 
            h = 0;
        if (!this.$useWrapMode || !this.$wrapData[row]) {
            return 1 + h;
        } else {
            return this.$wrapData[row].length + 1 + h;
        }
    };
    this.getRowLineCount = function(row) {
        if (!this.$useWrapMode || !this.$wrapData[row]) {
            return 1;
        } else {
            return this.$wrapData[row].length + 1;
        }
    };

    this.getRowWrapIndent = function(screenRow) {
        if (this.$useWrapMode) {
            var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
            var splits = this.$wrapData[pos.row];
            return splits.length && splits[0] < pos.column ? splits.indent : 0;
        } else {
            return 0;
        }
    };
    this.getScreenLastRowColumn = function(screenRow) {
        var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
        return this.documentToScreenColumn(pos.row, pos.column);
    };
    this.getDocumentLastRowColumn = function(docRow, docColumn) {
        var screenRow = this.documentToScreenRow(docRow, docColumn);
        return this.getScreenLastRowColumn(screenRow);
    };
    this.getDocumentLastRowColumnPosition = function(docRow, docColumn) {
        var screenRow = this.documentToScreenRow(docRow, docColumn);
        return this.screenToDocumentPosition(screenRow, Number.MAX_VALUE / 10);
    };
    this.getRowSplitData = function(row) {
        if (!this.$useWrapMode) {
            return undefined;
        } else {
            return this.$wrapData[row];
        }
    };
    this.getScreenTabSize = function(screenColumn) {
        return this.$tabSize - screenColumn % this.$tabSize;
    };


    this.screenToDocumentRow = function(screenRow, screenColumn) {
        return this.screenToDocumentPosition(screenRow, screenColumn).row;
    };


    this.screenToDocumentColumn = function(screenRow, screenColumn) {
        return this.screenToDocumentPosition(screenRow, screenColumn).column;
    };
    this.screenToDocumentPosition = function(screenRow, screenColumn, offsetX) {
        if (screenRow < 0)
            return {row: 0, column: 0};

        var line;
        var docRow = 0;
        var docColumn = 0;
        var column;
        var row = 0;
        var rowLength = 0;

        var rowCache = this.$screenRowCache;
        var i = this.$getRowCacheIndex(rowCache, screenRow);
        var l = rowCache.length;
        if (l && i >= 0) {
            var row = rowCache[i];
            var docRow = this.$docRowCache[i];
            var doCache = screenRow > rowCache[l - 1];
        } else {
            var doCache = !l;
        }

        var maxRow = this.getLength() - 1;
        var foldLine = this.getNextFoldLine(docRow);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (row <= screenRow) {
            rowLength = this.getRowLength(docRow);
            if (row + rowLength > screenRow || docRow >= maxRow) {
                break;
            } else {
                row += rowLength;
                docRow++;
                if (docRow > foldStart) {
                    docRow = foldLine.end.row+1;
                    foldLine = this.getNextFoldLine(docRow, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
            }

            if (doCache) {
                this.$docRowCache.push(docRow);
                this.$screenRowCache.push(row);
            }
        }

        if (foldLine && foldLine.start.row <= docRow) {
            line = this.getFoldDisplayLine(foldLine);
            docRow = foldLine.start.row;
        } else if (row + rowLength <= screenRow || docRow > maxRow) {
            return {
                row: maxRow,
                column: this.getLine(maxRow).length
            };
        } else {
            line = this.getLine(docRow);
            foldLine = null;
        }
        var wrapIndent = 0, splitIndex = Math.floor(screenRow - row);
        if (this.$useWrapMode) {
            var splits = this.$wrapData[docRow];
            if (splits) {
                column = splits[splitIndex];
                if(splitIndex > 0 && splits.length) {
                    wrapIndent = splits.indent;
                    docColumn = splits[splitIndex - 1] || splits[splits.length - 1];
                    line = line.substring(docColumn);
                }
            }
        }

        if (offsetX !== undefined && this.$bidiHandler.isBidiRow(row + splitIndex, docRow, splitIndex))
            screenColumn = this.$bidiHandler.offsetToCol(offsetX);

        docColumn += this.$getStringScreenWidth(line, screenColumn - wrapIndent)[1];
        if (this.$useWrapMode && docColumn >= column)
            docColumn = column - 1;

        if (foldLine)
            return foldLine.idxToPosition(docColumn);

        return {row: docRow, column: docColumn};
    };
    this.documentToScreenPosition = function(docRow, docColumn) {
        if (typeof docColumn === "undefined")
            var pos = this.$clipPositionToDocument(docRow.row, docRow.column);
        else
            pos = this.$clipPositionToDocument(docRow, docColumn);

        docRow = pos.row;
        docColumn = pos.column;

        var screenRow = 0;
        var foldStartRow = null;
        var fold = null;
        fold = this.getFoldAt(docRow, docColumn, 1);
        if (fold) {
            docRow = fold.start.row;
            docColumn = fold.start.column;
        }

        var rowEnd, row = 0;


        var rowCache = this.$docRowCache;
        var i = this.$getRowCacheIndex(rowCache, docRow);
        var l = rowCache.length;
        if (l && i >= 0) {
            var row = rowCache[i];
            var screenRow = this.$screenRowCache[i];
            var doCache = docRow > rowCache[l - 1];
        } else {
            var doCache = !l;
        }

        var foldLine = this.getNextFoldLine(row);
        var foldStart = foldLine ?foldLine.start.row :Infinity;

        while (row < docRow) {
            if (row >= foldStart) {
                rowEnd = foldLine.end.row + 1;
                if (rowEnd > docRow)
                    break;
                foldLine = this.getNextFoldLine(rowEnd, foldLine);
                foldStart = foldLine ?foldLine.start.row :Infinity;
            }
            else {
                rowEnd = row + 1;
            }

            screenRow += this.getRowLength(row);
            row = rowEnd;

            if (doCache) {
                this.$docRowCache.push(row);
                this.$screenRowCache.push(screenRow);
            }
        }
        var textLine = "";
        if (foldLine && row >= foldStart) {
            textLine = this.getFoldDisplayLine(foldLine, docRow, docColumn);
            foldStartRow = foldLine.start.row;
        } else {
            textLine = this.getLine(docRow).substring(0, docColumn);
            foldStartRow = docRow;
        }
        var wrapIndent = 0;
        if (this.$useWrapMode) {
            var wrapRow = this.$wrapData[foldStartRow];
            if (wrapRow) {
                var screenRowOffset = 0;
                while (textLine.length >= wrapRow[screenRowOffset]) {
                    screenRow ++;
                    screenRowOffset++;
                }
                textLine = textLine.substring(
                    wrapRow[screenRowOffset - 1] || 0, textLine.length
                );
                wrapIndent = screenRowOffset > 0 ? wrapRow.indent : 0;
            }
        }

        return {
            row: screenRow,
            column: wrapIndent + this.$getStringScreenWidth(textLine)[0]
        };
    };
    this.documentToScreenColumn = function(row, docColumn) {
        return this.documentToScreenPosition(row, docColumn).column;
    };
    this.documentToScreenRow = function(docRow, docColumn) {
        return this.documentToScreenPosition(docRow, docColumn).row;
    };
    this.getScreenLength = function() {
        var screenRows = 0;
        var fold = null;
        if (!this.$useWrapMode) {
            screenRows = this.getLength();
            var foldData = this.$foldData;
            for (var i = 0; i < foldData.length; i++) {
                fold = foldData[i];
                screenRows -= fold.end.row - fold.start.row;
            }
        } else {
            var lastRow = this.$wrapData.length;
            var row = 0, i = 0;
            var fold = this.$foldData[i++];
            var foldStart = fold ? fold.start.row :Infinity;

            while (row < lastRow) {
                var splits = this.$wrapData[row];
                screenRows += splits ? splits.length + 1 : 1;
                row ++;
                if (row > foldStart) {
                    row = fold.end.row+1;
                    fold = this.$foldData[i++];
                    foldStart = fold ?fold.start.row :Infinity;
                }
            }
        }
        if (this.lineWidgets)
            screenRows += this.$getWidgetScreenLength();

        return screenRows;
    };
    this.$setFontMetrics = function(fm) {
        if (!this.$enableVarChar) return;
        this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
            if (maxScreenColumn === 0)
                return [0, 0];
            if (!maxScreenColumn)
                maxScreenColumn = Infinity;
            screenColumn = screenColumn || 0;
            
            var c, column;
            for (column = 0; column < str.length; column++) {
                c = str.charAt(column);
                if (c === "\t") {
                    screenColumn += this.getScreenTabSize(screenColumn);
                } else {
                    screenColumn += fm.getCharacterWidth(c);
                }
                if (screenColumn > maxScreenColumn) {
                    break;
                }
            }
            
            return [screenColumn, column];
        };
    };
    
    this.destroy = function() {
        if (this.bgTokenizer) {
            this.bgTokenizer.setDocument(null);
            this.bgTokenizer = null;
        }
        this.$stopWorker();
    };

    this.isFullWidth = isFullWidth;
    function isFullWidth(c) {
        if (c < 0x1100)
            return false;
        return c >= 0x1100 && c <= 0x115F ||
               c >= 0x11A3 && c <= 0x11A7 ||
               c >= 0x11FA && c <= 0x11FF ||
               c >= 0x2329 && c <= 0x232A ||
               c >= 0x2E80 && c <= 0x2E99 ||
               c >= 0x2E9B && c <= 0x2EF3 ||
               c >= 0x2F00 && c <= 0x2FD5 ||
               c >= 0x2FF0 && c <= 0x2FFB ||
               c >= 0x3000 && c <= 0x303E ||
               c >= 0x3041 && c <= 0x3096 ||
               c >= 0x3099 && c <= 0x30FF ||
               c >= 0x3105 && c <= 0x312D ||
               c >= 0x3131 && c <= 0x318E ||
               c >= 0x3190 && c <= 0x31BA ||
               c >= 0x31C0 && c <= 0x31E3 ||
               c >= 0x31F0 && c <= 0x321E ||
               c >= 0x3220 && c <= 0x3247 ||
               c >= 0x3250 && c <= 0x32FE ||
               c >= 0x3300 && c <= 0x4DBF ||
               c >= 0x4E00 && c <= 0xA48C ||
               c >= 0xA490 && c <= 0xA4C6 ||
               c >= 0xA960 && c <= 0xA97C ||
               c >= 0xAC00 && c <= 0xD7A3 ||
               c >= 0xD7B0 && c <= 0xD7C6 ||
               c >= 0xD7CB && c <= 0xD7FB ||
               c >= 0xF900 && c <= 0xFAFF ||
               c >= 0xFE10 && c <= 0xFE19 ||
               c >= 0xFE30 && c <= 0xFE52 ||
               c >= 0xFE54 && c <= 0xFE66 ||
               c >= 0xFE68 && c <= 0xFE6B ||
               c >= 0xFF01 && c <= 0xFF60 ||
               c >= 0xFFE0 && c <= 0xFFE6;
    }

}).call(EditSession.prototype);

acequire("./edit_session/folding").Folding.call(EditSession.prototype);
acequire("./edit_session/bracket_match").BracketMatch.call(EditSession.prototype);


config.defineOptions(EditSession.prototype, "session", {
    wrap: {
        set: function(value) {
            if (!value || value == "off")
                value = false;
            else if (value == "free")
                value = true;
            else if (value == "printMargin")
                value = -1;
            else if (typeof value == "string")
                value = parseInt(value, 10) || false;

            if (this.$wrap == value)
                return;
            this.$wrap = value;
            if (!value) {
                this.setUseWrapMode(false);
            } else {
                var col = typeof value == "number" ? value : null;
                this.setWrapLimitRange(col, col);
                this.setUseWrapMode(true);
            }
        },
        get: function() {
            if (this.getUseWrapMode()) {
                if (this.$wrap == -1)
                    return "printMargin";
                if (!this.getWrapLimitRange().min)
                    return "free";
                return this.$wrap;
            }
            return "off";
        },
        handlesSet: true
    },    
    wrapMethod: {
        set: function(val) {
            val = val == "auto"
                ? this.$mode.type != "text"
                : val != "text";
            if (val != this.$wrapAsCode) {
                this.$wrapAsCode = val;
                if (this.$useWrapMode) {
                    this.$modified = true;
                    this.$resetRowCache(0);
                    this.$updateWrapData(0, this.getLength() - 1);
                }
            }
        },
        initialValue: "auto"
    },
    indentedSoftWrap: { initialValue: true },
    firstLineNumber: {
        set: function() {this._signal("changeBreakpoint");},
        initialValue: 1
    },
    useWorker: {
        set: function(useWorker) {
            this.$useWorker = useWorker;

            this.$stopWorker();
            if (useWorker)
                this.$startWorker();
        },
        initialValue: true
    },
    useSoftTabs: {initialValue: true},
    tabSize: {
        set: function(tabSize) {
            if (isNaN(tabSize) || this.$tabSize === tabSize) return;

            this.$modified = true;
            this.$rowLengthCache = [];
            this.$tabSize = tabSize;
            this._signal("changeTabSize");
        },
        initialValue: 4,
        handlesSet: true
    },
    navigateWithinSoftTabs: {initialValue: false},
    overwrite: {
        set: function(val) {this._signal("changeOverwrite");},
        initialValue: false
    },
    newLineMode: {
        set: function(val) {this.doc.setNewLineMode(val);},
        get: function() {return this.doc.getNewLineMode();},
        handlesSet: true
    },
    mode: {
        set: function(val) { this.setMode(val); },
        get: function() { return this.$modeId; }
    }
});

exports.EditSession = EditSession;
});

ace.define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"], function(acequire, exports, module) {
"use strict";

var lang = acequire("./lib/lang");
var oop = acequire("./lib/oop");
var Range = acequire("./range").Range;

var Search = function() {
    this.$options = {};
};

(function() {
    this.set = function(options) {
        oop.mixin(this.$options, options);
        return this;
    };
    this.getOptions = function() {
        return lang.copyObject(this.$options);
    };
    this.setOptions = function(options) {
        this.$options = options;
    };
    this.find = function(session) {
        var options = this.$options;
        var iterator = this.$matchIterator(session, options);
        if (!iterator)
            return false;

        var firstRange = null;
        iterator.forEach(function(sr, sc, er, ec) {
            firstRange = new Range(sr, sc, er, ec);
            if (sc == ec && options.start && options.start.start
                && options.skipCurrent != false && firstRange.isEqual(options.start)
            ) {
                firstRange = null;
                return false;
            }

            return true;
        });

        return firstRange;
    };
    this.findAll = function(session) {
        var options = this.$options;
        if (!options.needle)
            return [];
        this.$assembleRegExp(options);

        var range = options.range;
        var lines = range
            ? session.getLines(range.start.row, range.end.row)
            : session.doc.getAllLines();

        var ranges = [];
        var re = options.re;
        if (options.$isMultiLine) {
            var len = re.length;
            var maxRow = lines.length - len;
            var prevRange;
            outer: for (var row = re.offset || 0; row <= maxRow; row++) {
                for (var j = 0; j < len; j++)
                    if (lines[row + j].search(re[j]) == -1)
                        continue outer;
                
                var startLine = lines[row];
                var line = lines[row + len - 1];
                var startIndex = startLine.length - startLine.match(re[0])[0].length;
                var endIndex = line.match(re[len - 1])[0].length;
                
                if (prevRange && prevRange.end.row === row &&
                    prevRange.end.column > startIndex
                ) {
                    continue;
                }
                ranges.push(prevRange = new Range(
                    row, startIndex, row + len - 1, endIndex
                ));
                if (len > 2)
                    row = row + len - 2;
            }
        } else {
            for (var i = 0; i < lines.length; i++) {
                var matches = lang.getMatchOffsets(lines[i], re);
                for (var j = 0; j < matches.length; j++) {
                    var match = matches[j];
                    ranges.push(new Range(i, match.offset, i, match.offset + match.length));
                }
            }
        }

        if (range) {
            var startColumn = range.start.column;
            var endColumn = range.start.column;
            var i = 0, j = ranges.length - 1;
            while (i < j && ranges[i].start.column < startColumn && ranges[i].start.row == range.start.row)
                i++;

            while (i < j && ranges[j].end.column > endColumn && ranges[j].end.row == range.end.row)
                j--;
            
            ranges = ranges.slice(i, j + 1);
            for (i = 0, j = ranges.length; i < j; i++) {
                ranges[i].start.row += range.start.row;
                ranges[i].end.row += range.start.row;
            }
        }

        return ranges;
    };
    this.replace = function(input, replacement) {
        var options = this.$options;

        var re = this.$assembleRegExp(options);
        if (options.$isMultiLine)
            return replacement;

        if (!re)
            return;

        var match = re.exec(input);
        if (!match || match[0].length != input.length)
            return null;
        
        replacement = input.replace(re, replacement);
        if (options.preserveCase) {
            replacement = replacement.split("");
            for (var i = Math.min(input.length, input.length); i--; ) {
                var ch = input[i];
                if (ch && ch.toLowerCase() != ch)
                    replacement[i] = replacement[i].toUpperCase();
                else
                    replacement[i] = replacement[i].toLowerCase();
            }
            replacement = replacement.join("");
        }
        
        return replacement;
    };

    this.$assembleRegExp = function(options, $disableFakeMultiline) {
        if (options.needle instanceof RegExp)
            return options.re = options.needle;

        var needle = options.needle;

        if (!options.needle)
            return options.re = false;

        if (!options.regExp)
            needle = lang.escapeRegExp(needle);

        if (options.wholeWord)
            needle = addWordBoundary(needle, options);

        var modifier = options.caseSensitive ? "gm" : "gmi";

        options.$isMultiLine = !$disableFakeMultiline && /[\n\r]/.test(needle);
        if (options.$isMultiLine)
            return options.re = this.$assembleMultilineRegExp(needle, modifier);

        try {
            var re = new RegExp(needle, modifier);
        } catch(e) {
            re = false;
        }
        return options.re = re;
    };

    this.$assembleMultilineRegExp = function(needle, modifier) {
        var parts = needle.replace(/\r\n|\r|\n/g, "$\n^").split("\n");
        var re = [];
        for (var i = 0; i < parts.length; i++) try {
            re.push(new RegExp(parts[i], modifier));
        } catch(e) {
            return false;
        }
        return re;
    };

    this.$matchIterator = function(session, options) {
        var re = this.$assembleRegExp(options);
        if (!re)
            return false;
        var backwards = options.backwards == true;
        var skipCurrent = options.skipCurrent != false;

        var range = options.range;
        var start = options.start;
        if (!start)
            start = range ? range[backwards ? "end" : "start"] : session.selection.getRange();
         
        if (start.start)
            start = start[skipCurrent != backwards ? "end" : "start"];

        var firstRow = range ? range.start.row : 0;
        var lastRow = range ? range.end.row : session.getLength() - 1;

        if (backwards) {
            var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback))
                    return;
                for (row--; row >= firstRow; row--)
                    if (forEachInLine(row, Number.MAX_VALUE, callback))
                        return;
                if (options.wrap == false)
                    return;
                for (row = lastRow, firstRow = start.row; row >= firstRow; row--)
                    if (forEachInLine(row, Number.MAX_VALUE, callback))
                        return;
            };
        }
        else {
            var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback))
                    return;
                for (row = row + 1; row <= lastRow; row++)
                    if (forEachInLine(row, 0, callback))
                        return;
                if (options.wrap == false)
                    return;
                for (row = firstRow, lastRow = start.row; row <= lastRow; row++)
                    if (forEachInLine(row, 0, callback))
                        return;
            };
        }
        
        if (options.$isMultiLine) {
            var len = re.length;
            var forEachInLine = function(row, offset, callback) {
                var startRow = backwards ? row - len + 1 : row;
                if (startRow < 0) return;
                var line = session.getLine(startRow);
                var startIndex = line.search(re[0]);
                if (!backwards && startIndex < offset || startIndex === -1) return;
                for (var i = 1; i < len; i++) {
                    line = session.getLine(startRow + i);
                    if (line.search(re[i]) == -1)
                        return;
                }
                var endIndex = line.match(re[len - 1])[0].length;
                if (backwards && endIndex > offset) return;
                if (callback(startRow, startIndex, startRow + len - 1, endIndex))
                    return true;
            };
        }
        else if (backwards) {
            var forEachInLine = function(row, endIndex, callback) {
                var line = session.getLine(row);
                var matches = [];
                var m, last = 0;
                re.lastIndex = 0;
                while((m = re.exec(line))) {
                    var length = m[0].length;
                    last = m.index;
                    if (!length) {
                        if (last >= line.length) break;
                        re.lastIndex = last += 1;
                    }
                    if (m.index + length > endIndex)
                        break;
                    matches.push(m.index, length);
                }
                for (var i = matches.length - 1; i >= 0; i -= 2) {
                    var column = matches[i - 1];
                    var length = matches[i];
                    if (callback(row, column, row, column + length))
                        return true;
                }
            };
        }
        else {
            var forEachInLine = function(row, startIndex, callback) {
                var line = session.getLine(row);
                var m;
                var last = startIndex;
                re.lastIndex = startIndex;
                while((m = re.exec(line))) {
                    var length = m[0].length;
                    last = m.index;
                    if (callback(row, last, row,last + length))
                        return true;
                    if (!length) {
                        re.lastIndex = last += 1;
                        if (last >= line.length) return false;
                    }
                }
            };
        }
        return {forEach: forEach};
    };

}).call(Search.prototype);

function addWordBoundary(needle, options) {
    function wordBoundary(c) {
        if (/\w/.test(c) || options.regExp) return "\\b";
        return "";
    }
    return wordBoundary(needle[0]) + needle
        + wordBoundary(needle[needle.length - 1]);
}

exports.Search = Search;
});

ace.define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var keyUtil = acequire("../lib/keys");
var useragent = acequire("../lib/useragent");
var KEY_MODS = keyUtil.KEY_MODS;

function HashHandler(config, platform) {
    this.platform = platform || (useragent.isMac ? "mac" : "win");
    this.commands = {};
    this.commandKeyBinding = {};
    this.addCommands(config);
    this.$singleCommand = true;
}

function MultiHashHandler(config, platform) {
    HashHandler.call(this, config, platform);
    this.$singleCommand = false;
}

MultiHashHandler.prototype = HashHandler.prototype;

(function() {
    

    this.addCommand = function(command) {
        if (this.commands[command.name])
            this.removeCommand(command);

        this.commands[command.name] = command;

        if (command.bindKey)
            this._buildKeyHash(command);
    };

    this.removeCommand = function(command, keepCommand) {
        var name = command && (typeof command === 'string' ? command : command.name);
        command = this.commands[name];
        if (!keepCommand)
            delete this.commands[name];
        var ckb = this.commandKeyBinding;
        for (var keyId in ckb) {
            var cmdGroup = ckb[keyId];
            if (cmdGroup == command) {
                delete ckb[keyId];
            } else if (Array.isArray(cmdGroup)) {
                var i = cmdGroup.indexOf(command);
                if (i != -1) {
                    cmdGroup.splice(i, 1);
                    if (cmdGroup.length == 1)
                        ckb[keyId] = cmdGroup[0];
                }
            }
        }
    };

    this.bindKey = function(key, command, position) {
        if (typeof key == "object" && key) {
            if (position == undefined)
                position = key.position;
            key = key[this.platform];
        }
        if (!key)
            return;
        if (typeof command == "function")
            return this.addCommand({exec: command, bindKey: key, name: command.name || key});
        
        key.split("|").forEach(function(keyPart) {
            var chain = "";
            if (keyPart.indexOf(" ") != -1) {
                var parts = keyPart.split(/\s+/);
                keyPart = parts.pop();
                parts.forEach(function(keyPart) {
                    var binding = this.parseKeys(keyPart);
                    var id = KEY_MODS[binding.hashId] + binding.key;
                    chain += (chain ? " " : "") + id;
                    this._addCommandToBinding(chain, "chainKeys");
                }, this);
                chain += " ";
            }
            var binding = this.parseKeys(keyPart);
            var id = KEY_MODS[binding.hashId] + binding.key;
            this._addCommandToBinding(chain + id, command, position);
        }, this);
    };
    
    function getPosition(command) {
        return typeof command == "object" && command.bindKey
            && command.bindKey.position
            || (command.isDefault ? -100 : 0);
    }
    this._addCommandToBinding = function(keyId, command, position) {
        var ckb = this.commandKeyBinding, i;
        if (!command) {
            delete ckb[keyId];
        } else if (!ckb[keyId] || this.$singleCommand) {
            ckb[keyId] = command;
        } else {
            if (!Array.isArray(ckb[keyId])) {
                ckb[keyId] = [ckb[keyId]];
            } else if ((i = ckb[keyId].indexOf(command)) != -1) {
                ckb[keyId].splice(i, 1);
            }

            if (typeof position != "number") {
                position = getPosition(command);
            }

            var commands = ckb[keyId];
            for (i = 0; i < commands.length; i++) {
                var other = commands[i];
                var otherPos = getPosition(other);
                if (otherPos > position)
                    break;
            }
            commands.splice(i, 0, command);
        }
    };

    this.addCommands = function(commands) {
        commands && Object.keys(commands).forEach(function(name) {
            var command = commands[name];
            if (!command)
                return;
            
            if (typeof command === "string")
                return this.bindKey(command, name);

            if (typeof command === "function")
                command = { exec: command };

            if (typeof command !== "object")
                return;

            if (!command.name)
                command.name = name;

            this.addCommand(command);
        }, this);
    };

    this.removeCommands = function(commands) {
        Object.keys(commands).forEach(function(name) {
            this.removeCommand(commands[name]);
        }, this);
    };

    this.bindKeys = function(keyList) {
        Object.keys(keyList).forEach(function(key) {
            this.bindKey(key, keyList[key]);
        }, this);
    };

    this._buildKeyHash = function(command) {
        this.bindKey(command.bindKey, command);
    };
    this.parseKeys = function(keys) {
        var parts = keys.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(x){return x;});
        var key = parts.pop();

        var keyCode = keyUtil[key];
        if (keyUtil.FUNCTION_KEYS[keyCode])
            key = keyUtil.FUNCTION_KEYS[keyCode].toLowerCase();
        else if (!parts.length)
            return {key: key, hashId: -1};
        else if (parts.length == 1 && parts[0] == "shift")
            return {key: key.toUpperCase(), hashId: -1};

        var hashId = 0;
        for (var i = parts.length; i--;) {
            var modifier = keyUtil.KEY_MODS[parts[i]];
            if (modifier == null) {
                if (typeof console != "undefined")
                    console.error("invalid modifier " + parts[i] + " in " + keys);
                return false;
            }
            hashId |= modifier;
        }
        return {key: key, hashId: hashId};
    };

    this.findKeyCommand = function findKeyCommand(hashId, keyString) {
        var key = KEY_MODS[hashId] + keyString;
        return this.commandKeyBinding[key];
    };

    this.handleKeyboard = function(data, hashId, keyString, keyCode) {
        if (keyCode < 0) return;
        var key = KEY_MODS[hashId] + keyString;
        var command = this.commandKeyBinding[key];
        if (data.$keyChain) {
            data.$keyChain += " " + key;
            command = this.commandKeyBinding[data.$keyChain] || command;
        }
        
        if (command) {
            if (command == "chainKeys" || command[command.length - 1] == "chainKeys") {
                data.$keyChain = data.$keyChain || key;
                return {command: "null"};
            }
        }
        
        if (data.$keyChain) {
            if ((!hashId || hashId == 4) && keyString.length == 1)
                data.$keyChain = data.$keyChain.slice(0, -key.length - 1); // wait for input
            else if (hashId == -1 || keyCode > 0)
                data.$keyChain = ""; // reset keyChain
        }
        return {command: command};
    };
    
    this.getStatusText = function(editor, data) {
        return data.$keyChain || "";
    };

}).call(HashHandler.prototype);

exports.HashHandler = HashHandler;
exports.MultiHashHandler = MultiHashHandler;
});

ace.define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var MultiHashHandler = acequire("../keyboard/hash_handler").MultiHashHandler;
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var CommandManager = function(platform, commands) {
    MultiHashHandler.call(this, commands, platform);
    this.byName = this.commands;
    this.setDefaultHandler("exec", function(e) {
        return e.command.exec(e.editor, e.args || {});
    });
};

oop.inherits(CommandManager, MultiHashHandler);

(function() {

    oop.implement(this, EventEmitter);

    this.exec = function(command, editor, args) {
        if (Array.isArray(command)) {
            for (var i = command.length; i--; ) {
                if (this.exec(command[i], editor, args)) return true;
            }
            return false;
        }

        if (typeof command === "string")
            command = this.commands[command];

        if (!command)
            return false;

        if (editor && editor.$readOnly && !command.readOnly)
            return false;

        if (command.isAvailable && !command.isAvailable(editor))
            return false;

        var e = {editor: editor, command: command, args: args};
        e.returnValue = this._emit("exec", e);
        this._signal("afterExec", e);

        return e.returnValue === false ? false : true;
    };

    this.toggleRecording = function(editor) {
        if (this.$inReplay)
            return;

        editor && editor._emit("changeStatus");
        if (this.recording) {
            this.macro.pop();
            this.removeEventListener("exec", this.$addCommandToMacro);

            if (!this.macro.length)
                this.macro = this.oldMacro;

            return this.recording = false;
        }
        if (!this.$addCommandToMacro) {
            this.$addCommandToMacro = function(e) {
                this.macro.push([e.command, e.args]);
            }.bind(this);
        }

        this.oldMacro = this.macro;
        this.macro = [];
        this.on("exec", this.$addCommandToMacro);
        return this.recording = true;
    };

    this.replay = function(editor) {
        if (this.$inReplay || !this.macro)
            return;

        if (this.recording)
            return this.toggleRecording(editor);

        try {
            this.$inReplay = true;
            this.macro.forEach(function(x) {
                if (typeof x == "string")
                    this.exec(x, editor);
                else
                    this.exec(x[0], editor, x[1]);
            }, this);
        } finally {
            this.$inReplay = false;
        }
    };

    this.trimMacro = function(m) {
        return m.map(function(x){
            if (typeof x[0] != "string")
                x[0] = x[0].name;
            if (!x[1])
                x = x[0];
            return x;
        });
    };

}).call(CommandManager.prototype);

exports.CommandManager = CommandManager;

});

ace.define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"], function(acequire, exports, module) {
"use strict";

var lang = acequire("../lib/lang");
var config = acequire("../config");
var Range = acequire("../range").Range;

function bindKey(win, mac) {
    return {win: win, mac: mac};
}
exports.commands = [{
    name: "showSettingsMenu",
    bindKey: bindKey("Ctrl-,", "Command-,"),
    exec: function(editor) {
        config.loadModule("ace/ext/settings_menu", function(module) {
            module.init(editor);
            editor.showSettingsMenu();
        });
    },
    readOnly: true
}, {
    name: "goToNextError",
    bindKey: bindKey("Alt-E", "F4"),
    exec: function(editor) {
        config.loadModule("ace/ext/error_marker", function(module) {
            module.showErrorMarker(editor, 1);
        });
    },
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "goToPreviousError",
    bindKey: bindKey("Alt-Shift-E", "Shift-F4"),
    exec: function(editor) {
        config.loadModule("ace/ext/error_marker", function(module) {
            module.showErrorMarker(editor, -1);
        });
    },
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "selectall",
    bindKey: bindKey("Ctrl-A", "Command-A"),
    exec: function(editor) { editor.selectAll(); },
    readOnly: true
}, {
    name: "centerselection",
    bindKey: bindKey(null, "Ctrl-L"),
    exec: function(editor) { editor.centerSelection(); },
    readOnly: true
}, {
    name: "gotoline",
    bindKey: bindKey("Ctrl-L", "Command-L"),
    exec: function(editor) {
        var line = parseInt(prompt("Enter line number:"), 10);
        if (!isNaN(line)) {
            editor.gotoLine(line);
        }
    },
    readOnly: true
}, {
    name: "fold",
    bindKey: bindKey("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
    exec: function(editor) { editor.session.toggleFold(false); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "unfold",
    bindKey: bindKey("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
    exec: function(editor) { editor.session.toggleFold(true); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "toggleFoldWidget",
    bindKey: bindKey("F2", "F2"),
    exec: function(editor) { editor.session.toggleFoldWidget(); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "toggleParentFoldWidget",
    bindKey: bindKey("Alt-F2", "Alt-F2"),
    exec: function(editor) { editor.session.toggleFoldWidget(true); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "foldall",
    bindKey: bindKey(null, "Ctrl-Command-Option-0"),
    exec: function(editor) { editor.session.foldAll(); },
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "foldOther",
    bindKey: bindKey("Alt-0", "Command-Option-0"),
    exec: function(editor) { 
        editor.session.foldAll();
        editor.session.unfold(editor.selection.getAllRanges());
    },
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "unfoldall",
    bindKey: bindKey("Alt-Shift-0", "Command-Option-Shift-0"),
    exec: function(editor) { editor.session.unfold(); },
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "findnext",
    bindKey: bindKey("Ctrl-K", "Command-G"),
    exec: function(editor) { editor.findNext(); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "findprevious",
    bindKey: bindKey("Ctrl-Shift-K", "Command-Shift-G"),
    exec: function(editor) { editor.findPrevious(); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "selectOrFindNext",
    bindKey: bindKey("Alt-K", "Ctrl-G"),
    exec: function(editor) {
        if (editor.selection.isEmpty())
            editor.selection.selectWord();
        else
            editor.findNext(); 
    },
    readOnly: true
}, {
    name: "selectOrFindPrevious",
    bindKey: bindKey("Alt-Shift-K", "Ctrl-Shift-G"),
    exec: function(editor) { 
        if (editor.selection.isEmpty())
            editor.selection.selectWord();
        else
            editor.findPrevious();
    },
    readOnly: true
}, {
    name: "find",
    bindKey: bindKey("Ctrl-F", "Command-F"),
    exec: function(editor) {
        config.loadModule("ace/ext/searchbox", function(e) {e.Search(editor);});
    },
    readOnly: true
}, {
    name: "overwrite",
    bindKey: "Insert",
    exec: function(editor) { editor.toggleOverwrite(); },
    readOnly: true
}, {
    name: "selecttostart",
    bindKey: bindKey("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
    exec: function(editor) { editor.getSelection().selectFileStart(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "gotostart",
    bindKey: bindKey("Ctrl-Home", "Command-Home|Command-Up"),
    exec: function(editor) { editor.navigateFileStart(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "selectup",
    bindKey: bindKey("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
    exec: function(editor) { editor.getSelection().selectUp(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "golineup",
    bindKey: bindKey("Up", "Up|Ctrl-P"),
    exec: function(editor, args) { editor.navigateUp(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selecttoend",
    bindKey: bindKey("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
    exec: function(editor) { editor.getSelection().selectFileEnd(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "gotoend",
    bindKey: bindKey("Ctrl-End", "Command-End|Command-Down"),
    exec: function(editor) { editor.navigateFileEnd(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "selectdown",
    bindKey: bindKey("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
    exec: function(editor) { editor.getSelection().selectDown(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "golinedown",
    bindKey: bindKey("Down", "Down|Ctrl-N"),
    exec: function(editor, args) { editor.navigateDown(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectwordleft",
    bindKey: bindKey("Ctrl-Shift-Left", "Option-Shift-Left"),
    exec: function(editor) { editor.getSelection().selectWordLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotowordleft",
    bindKey: bindKey("Ctrl-Left", "Option-Left"),
    exec: function(editor) { editor.navigateWordLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selecttolinestart",
    bindKey: bindKey("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
    exec: function(editor) { editor.getSelection().selectLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotolinestart",
    bindKey: bindKey("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
    exec: function(editor) { editor.navigateLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectleft",
    bindKey: bindKey("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
    exec: function(editor) { editor.getSelection().selectLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotoleft",
    bindKey: bindKey("Left", "Left|Ctrl-B"),
    exec: function(editor, args) { editor.navigateLeft(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectwordright",
    bindKey: bindKey("Ctrl-Shift-Right", "Option-Shift-Right"),
    exec: function(editor) { editor.getSelection().selectWordRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotowordright",
    bindKey: bindKey("Ctrl-Right", "Option-Right"),
    exec: function(editor) { editor.navigateWordRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selecttolineend",
    bindKey: bindKey("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
    exec: function(editor) { editor.getSelection().selectLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotolineend",
    bindKey: bindKey("Alt-Right|End", "Command-Right|End|Ctrl-E"),
    exec: function(editor) { editor.navigateLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectright",
    bindKey: bindKey("Shift-Right", "Shift-Right"),
    exec: function(editor) { editor.getSelection().selectRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotoright",
    bindKey: bindKey("Right", "Right|Ctrl-F"),
    exec: function(editor, args) { editor.navigateRight(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectpagedown",
    bindKey: "Shift-PageDown",
    exec: function(editor) { editor.selectPageDown(); },
    readOnly: true
}, {
    name: "pagedown",
    bindKey: bindKey(null, "Option-PageDown"),
    exec: function(editor) { editor.scrollPageDown(); },
    readOnly: true
}, {
    name: "gotopagedown",
    bindKey: bindKey("PageDown", "PageDown|Ctrl-V"),
    exec: function(editor) { editor.gotoPageDown(); },
    readOnly: true
}, {
    name: "selectpageup",
    bindKey: "Shift-PageUp",
    exec: function(editor) { editor.selectPageUp(); },
    readOnly: true
}, {
    name: "pageup",
    bindKey: bindKey(null, "Option-PageUp"),
    exec: function(editor) { editor.scrollPageUp(); },
    readOnly: true
}, {
    name: "gotopageup",
    bindKey: "PageUp",
    exec: function(editor) { editor.gotoPageUp(); },
    readOnly: true
}, {
    name: "scrollup",
    bindKey: bindKey("Ctrl-Up", null),
    exec: function(e) { e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight); },
    readOnly: true
}, {
    name: "scrolldown",
    bindKey: bindKey("Ctrl-Down", null),
    exec: function(e) { e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight); },
    readOnly: true
}, {
    name: "selectlinestart",
    bindKey: "Shift-Home",
    exec: function(editor) { editor.getSelection().selectLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectlineend",
    bindKey: "Shift-End",
    exec: function(editor) { editor.getSelection().selectLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "togglerecording",
    bindKey: bindKey("Ctrl-Alt-E", "Command-Option-E"),
    exec: function(editor) { editor.commands.toggleRecording(editor); },
    readOnly: true
}, {
    name: "replaymacro",
    bindKey: bindKey("Ctrl-Shift-E", "Command-Shift-E"),
    exec: function(editor) { editor.commands.replay(editor); },
    readOnly: true
}, {
    name: "jumptomatching",
    bindKey: bindKey("Ctrl-P", "Ctrl-P"),
    exec: function(editor) { editor.jumpToMatching(); },
    multiSelectAction: "forEach",
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "selecttomatching",
    bindKey: bindKey("Ctrl-Shift-P", "Ctrl-Shift-P"),
    exec: function(editor) { editor.jumpToMatching(true); },
    multiSelectAction: "forEach",
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "expandToMatching",
    bindKey: bindKey("Ctrl-Shift-M", "Ctrl-Shift-M"),
    exec: function(editor) { editor.jumpToMatching(true, true); },
    multiSelectAction: "forEach",
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "passKeysToBrowser",
    bindKey: bindKey(null, null),
    exec: function() {},
    passEvent: true,
    readOnly: true
}, {
    name: "copy",
    exec: function(editor) {
    },
    readOnly: true
},
{
    name: "cut",
    exec: function(editor) {
        var range = editor.getSelectionRange();
        editor._emit("cut", range);

        if (!editor.selection.isEmpty()) {
            editor.session.remove(range);
            editor.clearSelection();
        }
    },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "paste",
    exec: function(editor, args) {
        editor.$handlePaste(args);
    },
    scrollIntoView: "cursor"
}, {
    name: "removeline",
    bindKey: bindKey("Ctrl-D", "Command-D"),
    exec: function(editor) { editor.removeLines(); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEachLine"
}, {
    name: "duplicateSelection",
    bindKey: bindKey("Ctrl-Shift-D", "Command-Shift-D"),
    exec: function(editor) { editor.duplicateSelection(); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "sortlines",
    bindKey: bindKey("Ctrl-Alt-S", "Command-Alt-S"),
    exec: function(editor) { editor.sortLines(); },
    scrollIntoView: "selection",
    multiSelectAction: "forEachLine"
}, {
    name: "togglecomment",
    bindKey: bindKey("Ctrl-/", "Command-/"),
    exec: function(editor) { editor.toggleCommentLines(); },
    multiSelectAction: "forEachLine",
    scrollIntoView: "selectionPart"
}, {
    name: "toggleBlockComment",
    bindKey: bindKey("Ctrl-Shift-/", "Command-Shift-/"),
    exec: function(editor) { editor.toggleBlockComment(); },
    multiSelectAction: "forEach",
    scrollIntoView: "selectionPart"
}, {
    name: "modifyNumberUp",
    bindKey: bindKey("Ctrl-Shift-Up", "Alt-Shift-Up"),
    exec: function(editor) { editor.modifyNumber(1); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "modifyNumberDown",
    bindKey: bindKey("Ctrl-Shift-Down", "Alt-Shift-Down"),
    exec: function(editor) { editor.modifyNumber(-1); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "replace",
    bindKey: bindKey("Ctrl-H", "Command-Option-F"),
    exec: function(editor) {
        config.loadModule("ace/ext/searchbox", function(e) {e.Search(editor, true);});
    }
}, {
    name: "undo",
    bindKey: bindKey("Ctrl-Z", "Command-Z"),
    exec: function(editor) { editor.undo(); }
}, {
    name: "redo",
    bindKey: bindKey("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
    exec: function(editor) { editor.redo(); }
}, {
    name: "copylinesup",
    bindKey: bindKey("Alt-Shift-Up", "Command-Option-Up"),
    exec: function(editor) { editor.copyLinesUp(); },
    scrollIntoView: "cursor"
}, {
    name: "movelinesup",
    bindKey: bindKey("Alt-Up", "Option-Up"),
    exec: function(editor) { editor.moveLinesUp(); },
    scrollIntoView: "cursor"
}, {
    name: "copylinesdown",
    bindKey: bindKey("Alt-Shift-Down", "Command-Option-Down"),
    exec: function(editor) { editor.copyLinesDown(); },
    scrollIntoView: "cursor"
}, {
    name: "movelinesdown",
    bindKey: bindKey("Alt-Down", "Option-Down"),
    exec: function(editor) { editor.moveLinesDown(); },
    scrollIntoView: "cursor"
}, {
    name: "del",
    bindKey: bindKey("Delete", "Delete|Ctrl-D|Shift-Delete"),
    exec: function(editor) { editor.remove("right"); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "backspace",
    bindKey: bindKey(
        "Shift-Backspace|Backspace",
        "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"
    ),
    exec: function(editor) { editor.remove("left"); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "cut_or_delete",
    bindKey: bindKey("Shift-Delete", null),
    exec: function(editor) { 
        if (editor.selection.isEmpty()) {
            editor.remove("left");
        } else {
            return false;
        }
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolinestart",
    bindKey: bindKey("Alt-Backspace", "Command-Backspace"),
    exec: function(editor) { editor.removeToLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolineend",
    bindKey: bindKey("Alt-Delete", "Ctrl-K|Command-Delete"),
    exec: function(editor) { editor.removeToLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolinestarthard",
    bindKey: bindKey("Ctrl-Shift-Backspace", null),
    exec: function(editor) {
        var range = editor.selection.getRange();
        range.start.column = 0;
        editor.session.remove(range);
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolineendhard",
    bindKey: bindKey("Ctrl-Shift-Delete", null),
    exec: function(editor) {
        var range = editor.selection.getRange();
        range.end.column = Number.MAX_VALUE;
        editor.session.remove(range);
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removewordleft",
    bindKey: bindKey("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
    exec: function(editor) { editor.removeWordLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removewordright",
    bindKey: bindKey("Ctrl-Delete", "Alt-Delete"),
    exec: function(editor) { editor.removeWordRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "outdent",
    bindKey: bindKey("Shift-Tab", "Shift-Tab"),
    exec: function(editor) { editor.blockOutdent(); },
    multiSelectAction: "forEach",
    scrollIntoView: "selectionPart"
}, {
    name: "indent",
    bindKey: bindKey("Tab", "Tab"),
    exec: function(editor) { editor.indent(); },
    multiSelectAction: "forEach",
    scrollIntoView: "selectionPart"
}, {
    name: "blockoutdent",
    bindKey: bindKey("Ctrl-[", "Ctrl-["),
    exec: function(editor) { editor.blockOutdent(); },
    multiSelectAction: "forEachLine",
    scrollIntoView: "selectionPart"
}, {
    name: "blockindent",
    bindKey: bindKey("Ctrl-]", "Ctrl-]"),
    exec: function(editor) { editor.blockIndent(); },
    multiSelectAction: "forEachLine",
    scrollIntoView: "selectionPart"
}, {
    name: "insertstring",
    exec: function(editor, str) { editor.insert(str); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "inserttext",
    exec: function(editor, args) {
        editor.insert(lang.stringRepeat(args.text  || "", args.times || 1));
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "splitline",
    bindKey: bindKey(null, "Ctrl-O"),
    exec: function(editor) { editor.splitLine(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "transposeletters",
    bindKey: bindKey("Alt-Shift-X", "Ctrl-T"),
    exec: function(editor) { editor.transposeLetters(); },
    multiSelectAction: function(editor) {editor.transposeSelections(1); },
    scrollIntoView: "cursor"
}, {
    name: "touppercase",
    bindKey: bindKey("Ctrl-U", "Ctrl-U"),
    exec: function(editor) { editor.toUpperCase(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "tolowercase",
    bindKey: bindKey("Ctrl-Shift-U", "Ctrl-Shift-U"),
    exec: function(editor) { editor.toLowerCase(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "expandtoline",
    bindKey: bindKey("Ctrl-Shift-L", "Command-Shift-L"),
    exec: function(editor) {
        var range = editor.selection.getRange();

        range.start.column = range.end.column = 0;
        range.end.row++;
        editor.selection.setRange(range, false);
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "joinlines",
    bindKey: bindKey(null, null),
    exec: function(editor) {
        var isBackwards = editor.selection.isBackwards();
        var selectionStart = isBackwards ? editor.selection.getSelectionLead() : editor.selection.getSelectionAnchor();
        var selectionEnd = isBackwards ? editor.selection.getSelectionAnchor() : editor.selection.getSelectionLead();
        var firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length;
        var selectedText = editor.session.doc.getTextRange(editor.selection.getRange());
        var selectedCount = selectedText.replace(/\n\s*/, " ").length;
        var insertLine = editor.session.doc.getLine(selectionStart.row);

        for (var i = selectionStart.row + 1; i <= selectionEnd.row + 1; i++) {
            var curLine = lang.stringTrimLeft(lang.stringTrimRight(editor.session.doc.getLine(i)));
            if (curLine.length !== 0) {
                curLine = " " + curLine;
            }
            insertLine += curLine;
        }

        if (selectionEnd.row + 1 < (editor.session.doc.getLength() - 1)) {
            insertLine += editor.session.doc.getNewLineCharacter();
        }

        editor.clearSelection();
        editor.session.doc.replace(new Range(selectionStart.row, 0, selectionEnd.row + 2, 0), insertLine);

        if (selectedCount > 0) {
            editor.selection.moveCursorTo(selectionStart.row, selectionStart.column);
            editor.selection.selectTo(selectionStart.row, selectionStart.column + selectedCount);
        } else {
            firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length > firstLineEndCol ? (firstLineEndCol + 1) : firstLineEndCol;
            editor.selection.moveCursorTo(selectionStart.row, firstLineEndCol);
        }
    },
    multiSelectAction: "forEach",
    readOnly: true
}, {
    name: "invertSelection",
    bindKey: bindKey(null, null),
    exec: function(editor) {
        var endRow = editor.session.doc.getLength() - 1;
        var endCol = editor.session.doc.getLine(endRow).length;
        var ranges = editor.selection.rangeList.ranges;
        var newRanges = [];
        if (ranges.length < 1) {
            ranges = [editor.selection.getRange()];
        }

        for (var i = 0; i < ranges.length; i++) {
            if (i == (ranges.length - 1)) {
                if (!(ranges[i].end.row === endRow && ranges[i].end.column === endCol)) {
                    newRanges.push(new Range(ranges[i].end.row, ranges[i].end.column, endRow, endCol));
                }
            }

            if (i === 0) {
                if (!(ranges[i].start.row === 0 && ranges[i].start.column === 0)) {
                    newRanges.push(new Range(0, 0, ranges[i].start.row, ranges[i].start.column));
                }
            } else {
                newRanges.push(new Range(ranges[i-1].end.row, ranges[i-1].end.column, ranges[i].start.row, ranges[i].start.column));
            }
        }

        editor.exitMultiSelectMode();
        editor.clearSelection();

        for(var i = 0; i < newRanges.length; i++) {
            editor.selection.addRange(newRanges[i], false);
        }
    },
    readOnly: true,
    scrollIntoView: "none"
}];

});

ace.define("ace/editor",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator"], function(acequire, exports, module) {
"use strict";

acequire("./lib/fixoldbrowsers");

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var lang = acequire("./lib/lang");
var useragent = acequire("./lib/useragent");
var TextInput = acequire("./keyboard/textinput").TextInput;
var MouseHandler = acequire("./mouse/mouse_handler").MouseHandler;
var FoldHandler = acequire("./mouse/fold_handler").FoldHandler;
var KeyBinding = acequire("./keyboard/keybinding").KeyBinding;
var EditSession = acequire("./edit_session").EditSession;
var Search = acequire("./search").Search;
var Range = acequire("./range").Range;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var CommandManager = acequire("./commands/command_manager").CommandManager;
var defaultCommands = acequire("./commands/default_commands").commands;
var config = acequire("./config");
var TokenIterator = acequire("./token_iterator").TokenIterator;
var Editor = function(renderer, session) {
    var container = renderer.getContainerElement();
    this.container = container;
    this.renderer = renderer;
    this.id = "editor" + (++Editor.$uid);

    this.commands = new CommandManager(useragent.isMac ? "mac" : "win", defaultCommands);
    if (typeof document == "object") {
        this.textInput  = new TextInput(renderer.getTextAreaContainer(), this);
        this.renderer.textarea = this.textInput.getElement();
        this.$mouseHandler = new MouseHandler(this);
        new FoldHandler(this);
    }

    this.keyBinding = new KeyBinding(this);

    this.$blockScrolling = 0;
    this.$search = new Search().set({
        wrap: true
    });

    this.$historyTracker = this.$historyTracker.bind(this);
    this.commands.on("exec", this.$historyTracker);

    this.$initOperationListeners();
    
    this._$emitInputEvent = lang.delayedCall(function() {
        this._signal("input", {});
        if (this.session && this.session.bgTokenizer)
            this.session.bgTokenizer.scheduleStart();
    }.bind(this));
    
    this.on("change", function(_, _self) {
        _self._$emitInputEvent.schedule(31);
    });

    this.setSession(session || new EditSession(""));
    config.resetOptions(this);
    config._signal("editor", this);
};

Editor.$uid = 0;

(function(){

    oop.implement(this, EventEmitter);

    this.$initOperationListeners = function() {
        function last(a) {return a[a.length - 1];}

        this.selections = [];
        this.commands.on("exec", this.startOperation.bind(this), true);
        this.commands.on("afterExec", this.endOperation.bind(this), true);

        this.$opResetTimer = lang.delayedCall(this.endOperation.bind(this));

        this.on("change", function() {
            this.curOp || this.startOperation();
            this.curOp.docChanged = true;
        }.bind(this), true);

        this.on("changeSelection", function() {
            this.curOp || this.startOperation();
            this.curOp.selectionChanged = true;
        }.bind(this), true);
    };

    this.curOp = null;
    this.prevOp = {};
    this.startOperation = function(commadEvent) {
        if (this.curOp) {
            if (!commadEvent || this.curOp.command)
                return;
            this.prevOp = this.curOp;
        }
        if (!commadEvent) {
            this.previousCommand = null;
            commadEvent = {};
        }

        this.$opResetTimer.schedule();
        this.curOp = {
            command: commadEvent.command || {},
            args: commadEvent.args,
            scrollTop: this.renderer.scrollTop
        };
        if (this.curOp.command.name && this.curOp.command.scrollIntoView !== undefined)
            this.$blockScrolling++;
    };

    this.endOperation = function(e) {
        if (this.curOp) {
            if (e && e.returnValue === false)
                return this.curOp = null;
            this._signal("beforeEndOperation");
            var command = this.curOp.command;
            if (command.name && this.$blockScrolling > 0)
                this.$blockScrolling--;
            var scrollIntoView = command && command.scrollIntoView;
            if (scrollIntoView) {
                switch (scrollIntoView) {
                    case "center-animate":
                        scrollIntoView = "animate";
                    case "center":
                        this.renderer.scrollCursorIntoView(null, 0.5);
                        break;
                    case "animate":
                    case "cursor":
                        this.renderer.scrollCursorIntoView();
                        break;
                    case "selectionPart":
                        var range = this.selection.getRange();
                        var config = this.renderer.layerConfig;
                        if (range.start.row >= config.lastRow || range.end.row <= config.firstRow) {
                            this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
                        }
                        break;
                    default:
                        break;
                }
                if (scrollIntoView == "animate")
                    this.renderer.animateScrolling(this.curOp.scrollTop);
            }
            
            this.prevOp = this.curOp;
            this.curOp = null;
        }
    };
    this.$mergeableCommands = ["backspace", "del", "insertstring"];
    this.$historyTracker = function(e) {
        if (!this.$mergeUndoDeltas)
            return;

        var prev = this.prevOp;
        var mergeableCommands = this.$mergeableCommands;
        var shouldMerge = prev.command && (e.command.name == prev.command.name);
        if (e.command.name == "insertstring") {
            var text = e.args;
            if (this.mergeNextCommand === undefined)
                this.mergeNextCommand = true;

            shouldMerge = shouldMerge
                && this.mergeNextCommand // previous command allows to coalesce with
                && (!/\s/.test(text) || /\s/.test(prev.args)); // previous insertion was of same type

            this.mergeNextCommand = true;
        } else {
            shouldMerge = shouldMerge
                && mergeableCommands.indexOf(e.command.name) !== -1; // the command is mergeable
        }

        if (
            this.$mergeUndoDeltas != "always"
            && Date.now() - this.sequenceStartTime > 2000
        ) {
            shouldMerge = false; // the sequence is too long
        }

        if (shouldMerge)
            this.session.mergeUndoDeltas = true;
        else if (mergeableCommands.indexOf(e.command.name) !== -1)
            this.sequenceStartTime = Date.now();
    };
    this.setKeyboardHandler = function(keyboardHandler, cb) {
        if (keyboardHandler && typeof keyboardHandler === "string") {
            this.$keybindingId = keyboardHandler;
            var _self = this;
            config.loadModule(["keybinding", keyboardHandler], function(module) {
                if (_self.$keybindingId == keyboardHandler)
                    _self.keyBinding.setKeyboardHandler(module && module.handler);
                cb && cb();
            });
        } else {
            this.$keybindingId = null;
            this.keyBinding.setKeyboardHandler(keyboardHandler);
            cb && cb();
        }
    };
    this.getKeyboardHandler = function() {
        return this.keyBinding.getKeyboardHandler();
    };
    this.setSession = function(session) {
        if (this.session == session)
            return;
        if (this.curOp) this.endOperation();
        this.curOp = {};

        var oldSession = this.session;
        if (oldSession) {
            this.session.off("change", this.$onDocumentChange);
            this.session.off("changeMode", this.$onChangeMode);
            this.session.off("tokenizerUpdate", this.$onTokenizerUpdate);
            this.session.off("changeTabSize", this.$onChangeTabSize);
            this.session.off("changeWrapLimit", this.$onChangeWrapLimit);
            this.session.off("changeWrapMode", this.$onChangeWrapMode);
            this.session.off("changeFold", this.$onChangeFold);
            this.session.off("changeFrontMarker", this.$onChangeFrontMarker);
            this.session.off("changeBackMarker", this.$onChangeBackMarker);
            this.session.off("changeBreakpoint", this.$onChangeBreakpoint);
            this.session.off("changeAnnotation", this.$onChangeAnnotation);
            this.session.off("changeOverwrite", this.$onCursorChange);
            this.session.off("changeScrollTop", this.$onScrollTopChange);
            this.session.off("changeScrollLeft", this.$onScrollLeftChange);

            var selection = this.session.getSelection();
            selection.off("changeCursor", this.$onCursorChange);
            selection.off("changeSelection", this.$onSelectionChange);
        }

        this.session = session;
        if (session) {
            this.$onDocumentChange = this.onDocumentChange.bind(this);
            session.on("change", this.$onDocumentChange);
            this.renderer.setSession(session);
    
            this.$onChangeMode = this.onChangeMode.bind(this);
            session.on("changeMode", this.$onChangeMode);
    
            this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this);
            session.on("tokenizerUpdate", this.$onTokenizerUpdate);
    
            this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer);
            session.on("changeTabSize", this.$onChangeTabSize);
    
            this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this);
            session.on("changeWrapLimit", this.$onChangeWrapLimit);
    
            this.$onChangeWrapMode = this.onChangeWrapMode.bind(this);
            session.on("changeWrapMode", this.$onChangeWrapMode);
    
            this.$onChangeFold = this.onChangeFold.bind(this);
            session.on("changeFold", this.$onChangeFold);
    
            this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this);
            this.session.on("changeFrontMarker", this.$onChangeFrontMarker);
    
            this.$onChangeBackMarker = this.onChangeBackMarker.bind(this);
            this.session.on("changeBackMarker", this.$onChangeBackMarker);
    
            this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this);
            this.session.on("changeBreakpoint", this.$onChangeBreakpoint);
    
            this.$onChangeAnnotation = this.onChangeAnnotation.bind(this);
            this.session.on("changeAnnotation", this.$onChangeAnnotation);
    
            this.$onCursorChange = this.onCursorChange.bind(this);
            this.session.on("changeOverwrite", this.$onCursorChange);
    
            this.$onScrollTopChange = this.onScrollTopChange.bind(this);
            this.session.on("changeScrollTop", this.$onScrollTopChange);
    
            this.$onScrollLeftChange = this.onScrollLeftChange.bind(this);
            this.session.on("changeScrollLeft", this.$onScrollLeftChange);
    
            this.selection = session.getSelection();
            this.selection.on("changeCursor", this.$onCursorChange);
    
            this.$onSelectionChange = this.onSelectionChange.bind(this);
            this.selection.on("changeSelection", this.$onSelectionChange);
    
            this.onChangeMode();
    
            this.$blockScrolling += 1;
            this.onCursorChange();
            this.$blockScrolling -= 1;
    
            this.onScrollTopChange();
            this.onScrollLeftChange();
            this.onSelectionChange();
            this.onChangeFrontMarker();
            this.onChangeBackMarker();
            this.onChangeBreakpoint();
            this.onChangeAnnotation();
            this.session.getUseWrapMode() && this.renderer.adjustWrapLimit();
            this.renderer.updateFull();
        } else {
            this.selection = null;
            this.renderer.setSession(session);
        }

        this._signal("changeSession", {
            session: session,
            oldSession: oldSession
        });
        
        this.curOp = null;
        
        oldSession && oldSession._signal("changeEditor", {oldEditor: this});
        session && session._signal("changeEditor", {editor: this});

        if (session && session.bgTokenizer)
            session.bgTokenizer.scheduleStart();
    };
    this.getSession = function() {
        return this.session;
    };
    this.setValue = function(val, cursorPos) {
        this.session.doc.setValue(val);

        if (!cursorPos)
            this.selectAll();
        else if (cursorPos == 1)
            this.navigateFileEnd();
        else if (cursorPos == -1)
            this.navigateFileStart();

        return val;
    };
    this.getValue = function() {
        return this.session.getValue();
    };
    this.getSelection = function() {
        return this.selection;
    };
    this.resize = function(force) {
        this.renderer.onResize(force);
    };
    this.setTheme = function(theme, cb) {
        this.renderer.setTheme(theme, cb);
    };
    this.getTheme = function() {
        return this.renderer.getTheme();
    };
    this.setStyle = function(style) {
        this.renderer.setStyle(style);
    };
    this.unsetStyle = function(style) {
        this.renderer.unsetStyle(style);
    };
    this.getFontSize = function () {
        return this.getOption("fontSize") ||
           dom.computedStyle(this.container, "fontSize");
    };
    this.setFontSize = function(size) {
        this.setOption("fontSize", size);
    };

    this.$highlightBrackets = function() {
        if (this.session.$bracketHighlight) {
            this.session.removeMarker(this.session.$bracketHighlight);
            this.session.$bracketHighlight = null;
        }

        if (this.$highlightPending) {
            return;
        }
        var self = this;
        this.$highlightPending = true;
        setTimeout(function() {
            self.$highlightPending = false;
            var session = self.session;
            if (!session || !session.bgTokenizer) return;
            var pos = session.findMatchingBracket(self.getCursorPosition());
            if (pos) {
                var range = new Range(pos.row, pos.column, pos.row, pos.column + 1);
            } else if (session.$mode.getMatching) {
                var range = session.$mode.getMatching(self.session);
            }
            if (range)
                session.$bracketHighlight = session.addMarker(range, "ace_bracket", "text");
        }, 50);
    };
    this.$highlightTags = function() {
        if (this.$highlightTagPending)
            return;
        var self = this;
        this.$highlightTagPending = true;
        setTimeout(function() {
            self.$highlightTagPending = false;
            
            var session = self.session;
            if (!session || !session.bgTokenizer) return;
            
            var pos = self.getCursorPosition();
            var iterator = new TokenIterator(self.session, pos.row, pos.column);
            var token = iterator.getCurrentToken();
            
            if (!token || !/\b(?:tag-open|tag-name)/.test(token.type)) {
                session.removeMarker(session.$tagHighlight);
                session.$tagHighlight = null;
                return;
            }
            
            if (token.type.indexOf("tag-open") != -1) {
                token = iterator.stepForward();
                if (!token)
                    return;
            }
            
            var tag = token.value;
            var depth = 0;
            var prevToken = iterator.stepBackward();
            
            if (prevToken.value == '<'){
                do {
                    prevToken = token;
                    token = iterator.stepForward();
                    
                    if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
                        if (prevToken.value === '<'){
                            depth++;
                        } else if (prevToken.value === '</'){
                            depth--;
                        }
                    }
                    
                } while (token && depth >= 0);
            } else {
                do {
                    token = prevToken;
                    prevToken = iterator.stepBackward();
                    
                    if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
                        if (prevToken.value === '<') {
                            depth++;
                        } else if (prevToken.value === '</') {
                            depth--;
                        }
                    }
                } while (prevToken && depth <= 0);
                iterator.stepForward();
            }
            
            if (!token) {
                session.removeMarker(session.$tagHighlight);
                session.$tagHighlight = null;
                return;
            }
            
            var row = iterator.getCurrentTokenRow();
            var column = iterator.getCurrentTokenColumn();
            var range = new Range(row, column, row, column+token.value.length);
            var sbm = session.$backMarkers[session.$tagHighlight];
            if (session.$tagHighlight && sbm != undefined && range.compareRange(sbm.range) !== 0) {
                session.removeMarker(session.$tagHighlight);
                session.$tagHighlight = null;
            }
            
            if (range && !session.$tagHighlight)
                session.$tagHighlight = session.addMarker(range, "ace_bracket", "text");
        }, 50);
    };
    this.focus = function() {
        var _self = this;
        setTimeout(function() {
            _self.textInput.focus();
        });
        this.textInput.focus();
    };
    this.isFocused = function() {
        return this.textInput.isFocused();
    };
    this.blur = function() {
        this.textInput.blur();
    };
    this.onFocus = function(e) {
        if (this.$isFocused)
            return;
        this.$isFocused = true;
        this.renderer.showCursor();
        this.renderer.visualizeFocus();
        this._emit("focus", e);
    };
    this.onBlur = function(e) {
        if (!this.$isFocused)
            return;
        this.$isFocused = false;
        this.renderer.hideCursor();
        this.renderer.visualizeBlur();
        this._emit("blur", e);
    };

    this.$cursorChange = function() {
        this.renderer.updateCursor();
    };
    this.onDocumentChange = function(delta) {
        var wrap = this.session.$useWrapMode;
        var lastRow = (delta.start.row == delta.end.row ? delta.end.row : Infinity);
        this.renderer.updateLines(delta.start.row, lastRow, wrap);

        this._signal("change", delta);
        this.$cursorChange();
        this.$updateHighlightActiveLine();
    };

    this.onTokenizerUpdate = function(e) {
        var rows = e.data;
        this.renderer.updateLines(rows.first, rows.last);
    };


    this.onScrollTopChange = function() {
        this.renderer.scrollToY(this.session.getScrollTop());
    };

    this.onScrollLeftChange = function() {
        this.renderer.scrollToX(this.session.getScrollLeft());
    };
    this.onCursorChange = function() {
        this.$cursorChange();

        if (!this.$blockScrolling) {
            config.warn("Automatically scrolling cursor into view after selection change",
                "this will be disabled in the next version",
                "set editor.$blockScrolling = Infinity to disable this message"
            );
            this.renderer.scrollCursorIntoView();
        }

        this.$highlightBrackets();
        this.$highlightTags();
        this.$updateHighlightActiveLine();
        this._signal("changeSelection");
    };

    this.$updateHighlightActiveLine = function() {
        var session = this.getSession();

        var highlight;
        if (this.$highlightActiveLine) {
            if ((this.$selectionStyle != "line" || !this.selection.isMultiLine()))
                highlight = this.getCursorPosition();
            if (this.renderer.$maxLines && this.session.getLength() === 1 && !(this.renderer.$minLines > 1))
                highlight = false;
        }

        if (session.$highlightLineMarker && !highlight) {
            session.removeMarker(session.$highlightLineMarker.id);
            session.$highlightLineMarker = null;
        } else if (!session.$highlightLineMarker && highlight) {
            var range = new Range(highlight.row, highlight.column, highlight.row, Infinity);
            range.id = session.addMarker(range, "ace_active-line", "screenLine");
            session.$highlightLineMarker = range;
        } else if (highlight) {
            session.$highlightLineMarker.start.row = highlight.row;
            session.$highlightLineMarker.end.row = highlight.row;
            session.$highlightLineMarker.start.column = highlight.column;
            session._signal("changeBackMarker");
        }
    };

    this.onSelectionChange = function(e) {
        var session = this.session;

        if (session.$selectionMarker) {
            session.removeMarker(session.$selectionMarker);
        }
        session.$selectionMarker = null;

        if (!this.selection.isEmpty()) {
            var range = this.selection.getRange();
            var style = this.getSelectionStyle();
            session.$selectionMarker = session.addMarker(range, "ace_selection", style);
        } else {
            this.$updateHighlightActiveLine();
        }

        var re = this.$highlightSelectedWord && this.$getSelectionHighLightRegexp();
        this.session.highlight(re);

        this._signal("changeSelection");
    };

    this.$getSelectionHighLightRegexp = function() {
        var session = this.session;

        var selection = this.getSelectionRange();
        if (selection.isEmpty() || selection.isMultiLine())
            return;

        var startOuter = selection.start.column - 1;
        var endOuter = selection.end.column + 1;
        var line = session.getLine(selection.start.row);
        var lineCols = line.length;
        var needle = line.substring(Math.max(startOuter, 0),
                                    Math.min(endOuter, lineCols));
        if ((startOuter >= 0 && /^[\w\d]/.test(needle)) ||
            (endOuter <= lineCols && /[\w\d]$/.test(needle)))
            return;

        needle = line.substring(selection.start.column, selection.end.column);
        if (!/^[\w\d]+$/.test(needle))
            return;

        var re = this.$search.$assembleRegExp({
            wholeWord: true,
            caseSensitive: true,
            needle: needle
        });

        return re;
    };


    this.onChangeFrontMarker = function() {
        this.renderer.updateFrontMarkers();
    };

    this.onChangeBackMarker = function() {
        this.renderer.updateBackMarkers();
    };


    this.onChangeBreakpoint = function() {
        this.renderer.updateBreakpoints();
    };

    this.onChangeAnnotation = function() {
        this.renderer.setAnnotations(this.session.getAnnotations());
    };


    this.onChangeMode = function(e) {
        this.renderer.updateText();
        this._emit("changeMode", e);
    };


    this.onChangeWrapLimit = function() {
        this.renderer.updateFull();
    };

    this.onChangeWrapMode = function() {
        this.renderer.onResize(true);
    };


    this.onChangeFold = function() {
        this.$updateHighlightActiveLine();
        this.renderer.updateFull();
    };
    this.getSelectedText = function() {
        return this.session.getTextRange(this.getSelectionRange());
    };
    this.getCopyText = function() {
        var text = this.getSelectedText();
        this._signal("copy", text);
        return text;
    };
    this.onCopy = function() {
        this.commands.exec("copy", this);
    };
    this.onCut = function() {
        this.commands.exec("cut", this);
    };
    this.onPaste = function(text, event) {
        var e = {text: text, event: event};
        this.commands.exec("paste", this, e);
    };
    
    this.$handlePaste = function(e) {
        if (typeof e == "string") 
            e = {text: e};
        this._signal("paste", e);
        var text = e.text;
        if (!this.inMultiSelectMode || this.inVirtualSelectionMode) {
            this.insert(text);
        } else {
            var lines = text.split(/\r\n|\r|\n/);
            var ranges = this.selection.rangeList.ranges;
    
            if (lines.length > ranges.length || lines.length < 2 || !lines[1])
                return this.commands.exec("insertstring", this, text);
    
            for (var i = ranges.length; i--;) {
                var range = ranges[i];
                if (!range.isEmpty())
                    this.session.remove(range);
    
                this.session.insert(range.start, lines[i]);
            }
        }
    };

    this.execCommand = function(command, args) {
        return this.commands.exec(command, this, args);
    };
    this.insert = function(text, pasted) {
        var session = this.session;
        var mode = session.getMode();
        var cursor = this.getCursorPosition();

        if (this.getBehavioursEnabled() && !pasted) {
            var transform = mode.transformAction(session.getState(cursor.row), 'insertion', this, session, text);
            if (transform) {
                if (text !== transform.text) {
                    this.session.mergeUndoDeltas = false;
                    this.$mergeNextCommand = false;
                }
                text = transform.text;

            }
        }
        
        if (text == "\t")
            text = this.session.getTabString();
        if (!this.selection.isEmpty()) {
            var range = this.getSelectionRange();
            cursor = this.session.remove(range);
            this.clearSelection();
        }
        else if (this.session.getOverwrite() && text.indexOf("\n") == -1) {
            var range = new Range.fromPoints(cursor, cursor);
            range.end.column += text.length;
            this.session.remove(range);
        }

        if (text == "\n" || text == "\r\n") {
            var line = session.getLine(cursor.row);
            if (cursor.column > line.search(/\S|$/)) {
                var d = line.substr(cursor.column).search(/\S|$/);
                session.doc.removeInLine(cursor.row, cursor.column, cursor.column + d);
            }
        }
        this.clearSelection();

        var start = cursor.column;
        var lineState = session.getState(cursor.row);
        var line = session.getLine(cursor.row);
        var shouldOutdent = mode.checkOutdent(lineState, line, text);
        var end = session.insert(cursor, text);

        if (transform && transform.selection) {
            if (transform.selection.length == 2) { // Transform relative to the current column
                this.selection.setSelectionRange(
                    new Range(cursor.row, start + transform.selection[0],
                              cursor.row, start + transform.selection[1]));
            } else { // Transform relative to the current row.
                this.selection.setSelectionRange(
                    new Range(cursor.row + transform.selection[0],
                              transform.selection[1],
                              cursor.row + transform.selection[2],
                              transform.selection[3]));
            }
        }

        if (session.getDocument().isNewLine(text)) {
            var lineIndent = mode.getNextLineIndent(lineState, line.slice(0, cursor.column), session.getTabString());

            session.insert({row: cursor.row+1, column: 0}, lineIndent);
        }
        if (shouldOutdent)
            mode.autoOutdent(lineState, session, cursor.row);
    };

    this.onTextInput = function(text) {
        this.keyBinding.onTextInput(text);
    };

    this.onCommandKey = function(e, hashId, keyCode) {
        this.keyBinding.onCommandKey(e, hashId, keyCode);
    };
    this.setOverwrite = function(overwrite) {
        this.session.setOverwrite(overwrite);
    };
    this.getOverwrite = function() {
        return this.session.getOverwrite();
    };
    this.toggleOverwrite = function() {
        this.session.toggleOverwrite();
    };
    this.setScrollSpeed = function(speed) {
        this.setOption("scrollSpeed", speed);
    };
    this.getScrollSpeed = function() {
        return this.getOption("scrollSpeed");
    };
    this.setDragDelay = function(dragDelay) {
        this.setOption("dragDelay", dragDelay);
    };
    this.getDragDelay = function() {
        return this.getOption("dragDelay");
    };
    this.setSelectionStyle = function(val) {
        this.setOption("selectionStyle", val);
    };
    this.getSelectionStyle = function() {
        return this.getOption("selectionStyle");
    };
    this.setHighlightActiveLine = function(shouldHighlight) {
        this.setOption("highlightActiveLine", shouldHighlight);
    };
    this.getHighlightActiveLine = function() {
        return this.getOption("highlightActiveLine");
    };
    this.setHighlightGutterLine = function(shouldHighlight) {
        this.setOption("highlightGutterLine", shouldHighlight);
    };

    this.getHighlightGutterLine = function() {
        return this.getOption("highlightGutterLine");
    };
    this.setHighlightSelectedWord = function(shouldHighlight) {
        this.setOption("highlightSelectedWord", shouldHighlight);
    };
    this.getHighlightSelectedWord = function() {
        return this.$highlightSelectedWord;
    };

    this.setAnimatedScroll = function(shouldAnimate){
        this.renderer.setAnimatedScroll(shouldAnimate);
    };

    this.getAnimatedScroll = function(){
        return this.renderer.getAnimatedScroll();
    };
    this.setShowInvisibles = function(showInvisibles) {
        this.renderer.setShowInvisibles(showInvisibles);
    };
    this.getShowInvisibles = function() {
        return this.renderer.getShowInvisibles();
    };

    this.setDisplayIndentGuides = function(display) {
        this.renderer.setDisplayIndentGuides(display);
    };

    this.getDisplayIndentGuides = function() {
        return this.renderer.getDisplayIndentGuides();
    };
    this.setShowPrintMargin = function(showPrintMargin) {
        this.renderer.setShowPrintMargin(showPrintMargin);
    };
    this.getShowPrintMargin = function() {
        return this.renderer.getShowPrintMargin();
    };
    this.setPrintMarginColumn = function(showPrintMargin) {
        this.renderer.setPrintMarginColumn(showPrintMargin);
    };
    this.getPrintMarginColumn = function() {
        return this.renderer.getPrintMarginColumn();
    };
    this.setReadOnly = function(readOnly) {
        this.setOption("readOnly", readOnly);
    };
    this.getReadOnly = function() {
        return this.getOption("readOnly");
    };
    this.setBehavioursEnabled = function (enabled) {
        this.setOption("behavioursEnabled", enabled);
    };
    this.getBehavioursEnabled = function () {
        return this.getOption("behavioursEnabled");
    };
    this.setWrapBehavioursEnabled = function (enabled) {
        this.setOption("wrapBehavioursEnabled", enabled);
    };
    this.getWrapBehavioursEnabled = function () {
        return this.getOption("wrapBehavioursEnabled");
    };
    this.setShowFoldWidgets = function(show) {
        this.setOption("showFoldWidgets", show);

    };
    this.getShowFoldWidgets = function() {
        return this.getOption("showFoldWidgets");
    };

    this.setFadeFoldWidgets = function(fade) {
        this.setOption("fadeFoldWidgets", fade);
    };

    this.getFadeFoldWidgets = function() {
        return this.getOption("fadeFoldWidgets");
    };
    this.remove = function(dir) {
        if (this.selection.isEmpty()){
            if (dir == "left")
                this.selection.selectLeft();
            else
                this.selection.selectRight();
        }

        var range = this.getSelectionRange();
        if (this.getBehavioursEnabled()) {
            var session = this.session;
            var state = session.getState(range.start.row);
            var new_range = session.getMode().transformAction(state, 'deletion', this, session, range);

            if (range.end.column === 0) {
                var text = session.getTextRange(range);
                if (text[text.length - 1] == "\n") {
                    var line = session.getLine(range.end.row);
                    if (/^\s+$/.test(line)) {
                        range.end.column = line.length;
                    }
                }
            }
            if (new_range)
                range = new_range;
        }

        this.session.remove(range);
        this.clearSelection();
    };
    this.removeWordRight = function() {
        if (this.selection.isEmpty())
            this.selection.selectWordRight();

        this.session.remove(this.getSelectionRange());
        this.clearSelection();
    };
    this.removeWordLeft = function() {
        if (this.selection.isEmpty())
            this.selection.selectWordLeft();

        this.session.remove(this.getSelectionRange());
        this.clearSelection();
    };
    this.removeToLineStart = function() {
        if (this.selection.isEmpty())
            this.selection.selectLineStart();

        this.session.remove(this.getSelectionRange());
        this.clearSelection();
    };
    this.removeToLineEnd = function() {
        if (this.selection.isEmpty())
            this.selection.selectLineEnd();

        var range = this.getSelectionRange();
        if (range.start.column == range.end.column && range.start.row == range.end.row) {
            range.end.column = 0;
            range.end.row++;
        }

        this.session.remove(range);
        this.clearSelection();
    };
    this.splitLine = function() {
        if (!this.selection.isEmpty()) {
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        }

        var cursor = this.getCursorPosition();
        this.insert("\n");
        this.moveCursorToPosition(cursor);
    };
    this.transposeLetters = function() {
        if (!this.selection.isEmpty()) {
            return;
        }

        var cursor = this.getCursorPosition();
        var column = cursor.column;
        if (column === 0)
            return;

        var line = this.session.getLine(cursor.row);
        var swap, range;
        if (column < line.length) {
            swap = line.charAt(column) + line.charAt(column-1);
            range = new Range(cursor.row, column-1, cursor.row, column+1);
        }
        else {
            swap = line.charAt(column-1) + line.charAt(column-2);
            range = new Range(cursor.row, column-2, cursor.row, column);
        }
        this.session.replace(range, swap);
        this.session.selection.moveToPosition(range.end);
    };
    this.toLowerCase = function() {
        var originalRange = this.getSelectionRange();
        if (this.selection.isEmpty()) {
            this.selection.selectWord();
        }

        var range = this.getSelectionRange();
        var text = this.session.getTextRange(range);
        this.session.replace(range, text.toLowerCase());
        this.selection.setSelectionRange(originalRange);
    };
    this.toUpperCase = function() {
        var originalRange = this.getSelectionRange();
        if (this.selection.isEmpty()) {
            this.selection.selectWord();
        }

        var range = this.getSelectionRange();
        var text = this.session.getTextRange(range);
        this.session.replace(range, text.toUpperCase());
        this.selection.setSelectionRange(originalRange);
    };
    this.indent = function() {
        var session = this.session;
        var range = this.getSelectionRange();

        if (range.start.row < range.end.row) {
            var rows = this.$getSelectedRows();
            session.indentRows(rows.first, rows.last, "\t");
            return;
        } else if (range.start.column < range.end.column) {
            var text = session.getTextRange(range);
            if (!/^\s+$/.test(text)) {
                var rows = this.$getSelectedRows();
                session.indentRows(rows.first, rows.last, "\t");
                return;
            }
        }
        
        var line = session.getLine(range.start.row);
        var position = range.start;
        var size = session.getTabSize();
        var column = session.documentToScreenColumn(position.row, position.column);

        if (this.session.getUseSoftTabs()) {
            var count = (size - column % size);
            var indentString = lang.stringRepeat(" ", count);
        } else {
            var count = column % size;
            while (line[range.start.column - 1] == " " && count) {
                range.start.column--;
                count--;
            }
            this.selection.setSelectionRange(range);
            indentString = "\t";
        }
        return this.insert(indentString);
    };
    this.blockIndent = function() {
        var rows = this.$getSelectedRows();
        this.session.indentRows(rows.first, rows.last, "\t");
    };
    this.blockOutdent = function() {
        var selection = this.session.getSelection();
        this.session.outdentRows(selection.getRange());
    };
    this.sortLines = function() {
        var rows = this.$getSelectedRows();
        var session = this.session;

        var lines = [];
        for (var i = rows.first; i <= rows.last; i++)
            lines.push(session.getLine(i));

        lines.sort(function(a, b) {
            if (a.toLowerCase() < b.toLowerCase()) return -1;
            if (a.toLowerCase() > b.toLowerCase()) return 1;
            return 0;
        });

        var deleteRange = new Range(0, 0, 0, 0);
        for (var i = rows.first; i <= rows.last; i++) {
            var line = session.getLine(i);
            deleteRange.start.row = i;
            deleteRange.end.row = i;
            deleteRange.end.column = line.length;
            session.replace(deleteRange, lines[i-rows.first]);
        }
    };
    this.toggleCommentLines = function() {
        var state = this.session.getState(this.getCursorPosition().row);
        var rows = this.$getSelectedRows();
        this.session.getMode().toggleCommentLines(state, this.session, rows.first, rows.last);
    };

    this.toggleBlockComment = function() {
        var cursor = this.getCursorPosition();
        var state = this.session.getState(cursor.row);
        var range = this.getSelectionRange();
        this.session.getMode().toggleBlockComment(state, this.session, range, cursor);
    };
    this.getNumberAt = function(row, column) {
        var _numberRx = /[\-]?[0-9]+(?:\.[0-9]+)?/g;
        _numberRx.lastIndex = 0;

        var s = this.session.getLine(row);
        while (_numberRx.lastIndex < column) {
            var m = _numberRx.exec(s);
            if(m.index <= column && m.index+m[0].length >= column){
                var number = {
                    value: m[0],
                    start: m.index,
                    end: m.index+m[0].length
                };
                return number;
            }
        }
        return null;
    };
    this.modifyNumber = function(amount) {
        var row = this.selection.getCursor().row;
        var column = this.selection.getCursor().column;
        var charRange = new Range(row, column-1, row, column);

        var c = this.session.getTextRange(charRange);
        if (!isNaN(parseFloat(c)) && isFinite(c)) {
            var nr = this.getNumberAt(row, column);
            if (nr) {
                var fp = nr.value.indexOf(".") >= 0 ? nr.start + nr.value.indexOf(".") + 1 : nr.end;
                var decimals = nr.start + nr.value.length - fp;

                var t = parseFloat(nr.value);
                t *= Math.pow(10, decimals);


                if(fp !== nr.end && column < fp){
                    amount *= Math.pow(10, nr.end - column - 1);
                } else {
                    amount *= Math.pow(10, nr.end - column);
                }

                t += amount;
                t /= Math.pow(10, decimals);
                var nnr = t.toFixed(decimals);
                var replaceRange = new Range(row, nr.start, row, nr.end);
                this.session.replace(replaceRange, nnr);
                this.moveCursorTo(row, Math.max(nr.start +1, column + nnr.length - nr.value.length));

            }
        }
    };
    this.removeLines = function() {
        var rows = this.$getSelectedRows();
        this.session.removeFullLines(rows.first, rows.last);
        this.clearSelection();
    };

    this.duplicateSelection = function() {
        var sel = this.selection;
        var doc = this.session;
        var range = sel.getRange();
        var reverse = sel.isBackwards();
        if (range.isEmpty()) {
            var row = range.start.row;
            doc.duplicateLines(row, row);
        } else {
            var point = reverse ? range.start : range.end;
            var endPoint = doc.insert(point, doc.getTextRange(range), false);
            range.start = point;
            range.end = endPoint;

            sel.setSelectionRange(range, reverse);
        }
    };
    this.moveLinesDown = function() {
        this.$moveLines(1, false);
    };
    this.moveLinesUp = function() {
        this.$moveLines(-1, false);
    };
    this.moveText = function(range, toPosition, copy) {
        return this.session.moveText(range, toPosition, copy);
    };
    this.copyLinesUp = function() {
        this.$moveLines(-1, true);
    };
    this.copyLinesDown = function() {
        this.$moveLines(1, true);
    };
    this.$moveLines = function(dir, copy) {
        var rows, moved;
        var selection = this.selection;
        if (!selection.inMultiSelectMode || this.inVirtualSelectionMode) {
            var range = selection.toOrientedRange();
            rows = this.$getSelectedRows(range);
            moved = this.session.$moveLines(rows.first, rows.last, copy ? 0 : dir);
            if (copy && dir == -1) moved = 0;
            range.moveBy(moved, 0);
            selection.fromOrientedRange(range);
        } else {
            var ranges = selection.rangeList.ranges;
            selection.rangeList.detach(this.session);
            this.inVirtualSelectionMode = true;
            
            var diff = 0;
            var totalDiff = 0;
            var l = ranges.length;
            for (var i = 0; i < l; i++) {
                var rangeIndex = i;
                ranges[i].moveBy(diff, 0);
                rows = this.$getSelectedRows(ranges[i]);
                var first = rows.first;
                var last = rows.last;
                while (++i < l) {
                    if (totalDiff) ranges[i].moveBy(totalDiff, 0);
                    var subRows = this.$getSelectedRows(ranges[i]);
                    if (copy && subRows.first != last)
                        break;
                    else if (!copy && subRows.first > last + 1)
                        break;
                    last = subRows.last;
                }
                i--;
                diff = this.session.$moveLines(first, last, copy ? 0 : dir);
                if (copy && dir == -1) rangeIndex = i + 1;
                while (rangeIndex <= i) {
                    ranges[rangeIndex].moveBy(diff, 0);
                    rangeIndex++;
                }
                if (!copy) diff = 0;
                totalDiff += diff;
            }
            
            selection.fromOrientedRange(selection.ranges[0]);
            selection.rangeList.attach(this.session);
            this.inVirtualSelectionMode = false;
        }
    };
    this.$getSelectedRows = function(range) {
        range = (range || this.getSelectionRange()).collapseRows();

        return {
            first: this.session.getRowFoldStart(range.start.row),
            last: this.session.getRowFoldEnd(range.end.row)
        };
    };

    this.onCompositionStart = function(text) {
        this.renderer.showComposition(this.getCursorPosition());
    };

    this.onCompositionUpdate = function(text) {
        this.renderer.setCompositionText(text);
    };

    this.onCompositionEnd = function() {
        this.renderer.hideComposition();
    };
    this.getFirstVisibleRow = function() {
        return this.renderer.getFirstVisibleRow();
    };
    this.getLastVisibleRow = function() {
        return this.renderer.getLastVisibleRow();
    };
    this.isRowVisible = function(row) {
        return (row >= this.getFirstVisibleRow() && row <= this.getLastVisibleRow());
    };
    this.isRowFullyVisible = function(row) {
        return (row >= this.renderer.getFirstFullyVisibleRow() && row <= this.renderer.getLastFullyVisibleRow());
    };
    this.$getVisibleRowCount = function() {
        return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
    };

    this.$moveByPage = function(dir, select) {
        var renderer = this.renderer;
        var config = this.renderer.layerConfig;
        var rows = dir * Math.floor(config.height / config.lineHeight);

        this.$blockScrolling++;
        if (select === true) {
            this.selection.$moveSelection(function(){
                this.moveCursorBy(rows, 0);
            });
        } else if (select === false) {
            this.selection.moveCursorBy(rows, 0);
            this.selection.clearSelection();
        }
        this.$blockScrolling--;

        var scrollTop = renderer.scrollTop;

        renderer.scrollBy(0, rows * config.lineHeight);
        if (select != null)
            renderer.scrollCursorIntoView(null, 0.5);

        renderer.animateScrolling(scrollTop);
    };
    this.selectPageDown = function() {
        this.$moveByPage(1, true);
    };
    this.selectPageUp = function() {
        this.$moveByPage(-1, true);
    };
    this.gotoPageDown = function() {
       this.$moveByPage(1, false);
    };
    this.gotoPageUp = function() {
        this.$moveByPage(-1, false);
    };
    this.scrollPageDown = function() {
        this.$moveByPage(1);
    };
    this.scrollPageUp = function() {
        this.$moveByPage(-1);
    };
    this.scrollToRow = function(row) {
        this.renderer.scrollToRow(row);
    };
    this.scrollToLine = function(line, center, animate, callback) {
        this.renderer.scrollToLine(line, center, animate, callback);
    };
    this.centerSelection = function() {
        var range = this.getSelectionRange();
        var pos = {
            row: Math.floor(range.start.row + (range.end.row - range.start.row) / 2),
            column: Math.floor(range.start.column + (range.end.column - range.start.column) / 2)
        };
        this.renderer.alignCursor(pos, 0.5);
    };
    this.getCursorPosition = function() {
        return this.selection.getCursor();
    };
    this.getCursorPositionScreen = function() {
        return this.session.documentToScreenPosition(this.getCursorPosition());
    };
    this.getSelectionRange = function() {
        return this.selection.getRange();
    };
    this.selectAll = function() {
        this.$blockScrolling += 1;
        this.selection.selectAll();
        this.$blockScrolling -= 1;
    };
    this.clearSelection = function() {
        this.selection.clearSelection();
    };
    this.moveCursorTo = function(row, column) {
        this.selection.moveCursorTo(row, column);
    };
    this.moveCursorToPosition = function(pos) {
        this.selection.moveCursorToPosition(pos);
    };
    this.jumpToMatching = function(select, expand) {
        var cursor = this.getCursorPosition();
        var iterator = new TokenIterator(this.session, cursor.row, cursor.column);
        var prevToken = iterator.getCurrentToken();
        var token = prevToken || iterator.stepForward();

        if (!token) return;
        var matchType;
        var found = false;
        var depth = {};
        var i = cursor.column - token.start;
        var bracketType;
        var brackets = {
            ")": "(",
            "(": "(",
            "]": "[",
            "[": "[",
            "{": "{",
            "}": "{"
        };
        
        do {
            if (token.value.match(/[{}()\[\]]/g)) {
                for (; i < token.value.length && !found; i++) {
                    if (!brackets[token.value[i]]) {
                        continue;
                    }

                    bracketType = brackets[token.value[i]] + '.' + token.type.replace("rparen", "lparen");

                    if (isNaN(depth[bracketType])) {
                        depth[bracketType] = 0;
                    }

                    switch (token.value[i]) {
                        case '(':
                        case '[':
                        case '{':
                            depth[bracketType]++;
                            break;
                        case ')':
                        case ']':
                        case '}':
                            depth[bracketType]--;

                            if (depth[bracketType] === -1) {
                                matchType = 'bracket';
                                found = true;
                            }
                        break;
                    }
                }
            }
            else if (token && token.type.indexOf('tag-name') !== -1) {
                if (isNaN(depth[token.value])) {
                    depth[token.value] = 0;
                }
                
                if (prevToken.value === '<') {
                    depth[token.value]++;
                }
                else if (prevToken.value === '</') {
                    depth[token.value]--;
                }
                
                if (depth[token.value] === -1) {
                    matchType = 'tag';
                    found = true;
                }
            }

            if (!found) {
                prevToken = token;
                token = iterator.stepForward();
                i = 0;
            }
        } while (token && !found);
        if (!matchType)
            return;

        var range, pos;
        if (matchType === 'bracket') {
            range = this.session.getBracketRange(cursor);
            if (!range) {
                range = new Range(
                    iterator.getCurrentTokenRow(),
                    iterator.getCurrentTokenColumn() + i - 1,
                    iterator.getCurrentTokenRow(),
                    iterator.getCurrentTokenColumn() + i - 1
                );
                pos = range.start;
                if (expand || pos.row === cursor.row && Math.abs(pos.column - cursor.column) < 2)
                    range = this.session.getBracketRange(pos);
            }
        }
        else if (matchType === 'tag') {
            if (token && token.type.indexOf('tag-name') !== -1) 
                var tag = token.value;
            else
                return;

            range = new Range(
                iterator.getCurrentTokenRow(),
                iterator.getCurrentTokenColumn() - 2,
                iterator.getCurrentTokenRow(),
                iterator.getCurrentTokenColumn() - 2
            );
            if (range.compare(cursor.row, cursor.column) === 0) {
                found = false;
                do {
                    token = prevToken;
                    prevToken = iterator.stepBackward();
                    
                    if (prevToken) {
                        if (prevToken.type.indexOf('tag-close') !== -1) {
                            range.setEnd(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1);
                        }

                        if (token.value === tag && token.type.indexOf('tag-name') !== -1) {
                            if (prevToken.value === '<') {
                                depth[tag]++;
                            }
                            else if (prevToken.value === '</') {
                                depth[tag]--;
                            }
                            
                            if (depth[tag] === 0)
                                found = true;
                        }
                    }
                } while (prevToken && !found);
            }
            if (token && token.type.indexOf('tag-name')) {
                pos = range.start;
                if (pos.row == cursor.row && Math.abs(pos.column - cursor.column) < 2)
                    pos = range.end;
            }
        }

        pos = range && range.cursor || pos;
        if (pos) {
            if (select) {
                if (range && expand) {
                    this.selection.setRange(range);
                } else if (range && range.isEqual(this.getSelectionRange())) {
                    this.clearSelection();
                } else {
                    this.selection.selectTo(pos.row, pos.column);
                }
            } else {
                this.selection.moveTo(pos.row, pos.column);
            }
        }
    };
    this.gotoLine = function(lineNumber, column, animate) {
        this.selection.clearSelection();
        this.session.unfold({row: lineNumber - 1, column: column || 0});

        this.$blockScrolling += 1;
        this.exitMultiSelectMode && this.exitMultiSelectMode();
        this.moveCursorTo(lineNumber - 1, column || 0);
        this.$blockScrolling -= 1;

        if (!this.isRowFullyVisible(lineNumber - 1))
            this.scrollToLine(lineNumber - 1, true, animate);
    };
    this.navigateTo = function(row, column) {
        this.selection.moveTo(row, column);
    };
    this.navigateUp = function(times) {
        if (this.selection.isMultiLine() && !this.selection.isBackwards()) {
            var selectionStart = this.selection.anchor.getPosition();
            return this.moveCursorToPosition(selectionStart);
        }
        this.selection.clearSelection();
        this.selection.moveCursorBy(-times || -1, 0);
    };
    this.navigateDown = function(times) {
        if (this.selection.isMultiLine() && this.selection.isBackwards()) {
            var selectionEnd = this.selection.anchor.getPosition();
            return this.moveCursorToPosition(selectionEnd);
        }
        this.selection.clearSelection();
        this.selection.moveCursorBy(times || 1, 0);
    };
    this.navigateLeft = function(times) {
        if (!this.selection.isEmpty()) {
            var selectionStart = this.getSelectionRange().start;
            this.moveCursorToPosition(selectionStart);
        }
        else {
            times = times || 1;
            while (times--) {
                this.selection.moveCursorLeft();
            }
        }
        this.clearSelection();
    };
    this.navigateRight = function(times) {
        if (!this.selection.isEmpty()) {
            var selectionEnd = this.getSelectionRange().end;
            this.moveCursorToPosition(selectionEnd);
        }
        else {
            times = times || 1;
            while (times--) {
                this.selection.moveCursorRight();
            }
        }
        this.clearSelection();
    };
    this.navigateLineStart = function() {
        this.selection.moveCursorLineStart();
        this.clearSelection();
    };
    this.navigateLineEnd = function() {
        this.selection.moveCursorLineEnd();
        this.clearSelection();
    };
    this.navigateFileEnd = function() {
        this.selection.moveCursorFileEnd();
        this.clearSelection();
    };
    this.navigateFileStart = function() {
        this.selection.moveCursorFileStart();
        this.clearSelection();
    };
    this.navigateWordRight = function() {
        this.selection.moveCursorWordRight();
        this.clearSelection();
    };
    this.navigateWordLeft = function() {
        this.selection.moveCursorWordLeft();
        this.clearSelection();
    };
    this.replace = function(replacement, options) {
        if (options)
            this.$search.set(options);

        var range = this.$search.find(this.session);
        var replaced = 0;
        if (!range)
            return replaced;

        if (this.$tryReplace(range, replacement)) {
            replaced = 1;
        }
        if (range !== null) {
            this.selection.setSelectionRange(range);
            this.renderer.scrollSelectionIntoView(range.start, range.end);
        }

        return replaced;
    };
    this.replaceAll = function(replacement, options) {
        if (options) {
            this.$search.set(options);
        }

        var ranges = this.$search.findAll(this.session);
        var replaced = 0;
        if (!ranges.length)
            return replaced;

        this.$blockScrolling += 1;

        var selection = this.getSelectionRange();
        this.selection.moveTo(0, 0);

        for (var i = ranges.length - 1; i >= 0; --i) {
            if(this.$tryReplace(ranges[i], replacement)) {
                replaced++;
            }
        }

        this.selection.setSelectionRange(selection);
        this.$blockScrolling -= 1;

        return replaced;
    };

    this.$tryReplace = function(range, replacement) {
        var input = this.session.getTextRange(range);
        replacement = this.$search.replace(input, replacement);
        if (replacement !== null) {
            range.end = this.session.replace(range, replacement);
            return range;
        } else {
            return null;
        }
    };
    this.getLastSearchOptions = function() {
        return this.$search.getOptions();
    };
    this.find = function(needle, options, animate) {
        if (!options)
            options = {};

        if (typeof needle == "string" || needle instanceof RegExp)
            options.needle = needle;
        else if (typeof needle == "object")
            oop.mixin(options, needle);

        var range = this.selection.getRange();
        if (options.needle == null) {
            needle = this.session.getTextRange(range)
                || this.$search.$options.needle;
            if (!needle) {
                range = this.session.getWordRange(range.start.row, range.start.column);
                needle = this.session.getTextRange(range);
            }
            this.$search.set({needle: needle});
        }

        this.$search.set(options);
        if (!options.start)
            this.$search.set({start: range});

        var newRange = this.$search.find(this.session);
        if (options.preventScroll)
            return newRange;
        if (newRange) {
            this.revealRange(newRange, animate);
            return newRange;
        }
        if (options.backwards)
            range.start = range.end;
        else
            range.end = range.start;
        this.selection.setRange(range);
    };
    this.findNext = function(options, animate) {
        this.find({skipCurrent: true, backwards: false}, options, animate);
    };
    this.findPrevious = function(options, animate) {
        this.find(options, {skipCurrent: true, backwards: true}, animate);
    };

    this.revealRange = function(range, animate) {
        this.$blockScrolling += 1;
        this.session.unfold(range);
        this.selection.setSelectionRange(range);
        this.$blockScrolling -= 1;

        var scrollTop = this.renderer.scrollTop;
        this.renderer.scrollSelectionIntoView(range.start, range.end, 0.5);
        if (animate !== false)
            this.renderer.animateScrolling(scrollTop);
    };
    this.undo = function() {
        this.$blockScrolling++;
        this.session.getUndoManager().undo();
        this.$blockScrolling--;
        this.renderer.scrollCursorIntoView(null, 0.5);
    };
    this.redo = function() {
        this.$blockScrolling++;
        this.session.getUndoManager().redo();
        this.$blockScrolling--;
        this.renderer.scrollCursorIntoView(null, 0.5);
    };
    this.destroy = function() {
        this.renderer.destroy();
        this._signal("destroy", this);
        if (this.session) {
            this.session.destroy();
        }
    };
    this.setAutoScrollEditorIntoView = function(enable) {
        if (!enable)
            return;
        var rect;
        var self = this;
        var shouldScroll = false;
        if (!this.$scrollAnchor)
            this.$scrollAnchor = document.createElement("div");
        var scrollAnchor = this.$scrollAnchor;
        scrollAnchor.style.cssText = "position:absolute";
        this.container.insertBefore(scrollAnchor, this.container.firstChild);
        var onChangeSelection = this.on("changeSelection", function() {
            shouldScroll = true;
        });
        var onBeforeRender = this.renderer.on("beforeRender", function() {
            if (shouldScroll)
                rect = self.renderer.container.getBoundingClientRect();
        });
        var onAfterRender = this.renderer.on("afterRender", function() {
            if (shouldScroll && rect && (self.isFocused()
                || self.searchBox && self.searchBox.isFocused())
            ) {
                var renderer = self.renderer;
                var pos = renderer.$cursorLayer.$pixelPos;
                var config = renderer.layerConfig;
                var top = pos.top - config.offset;
                if (pos.top >= 0 && top + rect.top < 0) {
                    shouldScroll = true;
                } else if (pos.top < config.height &&
                    pos.top + rect.top + config.lineHeight > window.innerHeight) {
                    shouldScroll = false;
                } else {
                    shouldScroll = null;
                }
                if (shouldScroll != null) {
                    scrollAnchor.style.top = top + "px";
                    scrollAnchor.style.left = pos.left + "px";
                    scrollAnchor.style.height = config.lineHeight + "px";
                    scrollAnchor.scrollIntoView(shouldScroll);
                }
                shouldScroll = rect = null;
            }
        });
        this.setAutoScrollEditorIntoView = function(enable) {
            if (enable)
                return;
            delete this.setAutoScrollEditorIntoView;
            this.off("changeSelection", onChangeSelection);
            this.renderer.off("afterRender", onAfterRender);
            this.renderer.off("beforeRender", onBeforeRender);
        };
    };


    this.$resetCursorStyle = function() {
        var style = this.$cursorStyle || "ace";
        var cursorLayer = this.renderer.$cursorLayer;
        if (!cursorLayer)
            return;
        cursorLayer.setSmoothBlinking(/smooth/.test(style));
        cursorLayer.isBlinking = !this.$readOnly && style != "wide";
        dom.setCssClass(cursorLayer.element, "ace_slim-cursors", /slim/.test(style));
    };

}).call(Editor.prototype);



config.defineOptions(Editor.prototype, "editor", {
    selectionStyle: {
        set: function(style) {
            this.onSelectionChange();
            this._signal("changeSelectionStyle", {data: style});
        },
        initialValue: "line"
    },
    highlightActiveLine: {
        set: function() {this.$updateHighlightActiveLine();},
        initialValue: true
    },
    highlightSelectedWord: {
        set: function(shouldHighlight) {this.$onSelectionChange();},
        initialValue: true
    },
    readOnly: {
        set: function(readOnly) {
            this.$resetCursorStyle(); 
        },
        initialValue: false
    },
    cursorStyle: {
        set: function(val) { this.$resetCursorStyle(); },
        values: ["ace", "slim", "smooth", "wide"],
        initialValue: "ace"
    },
    mergeUndoDeltas: {
        values: [false, true, "always"],
        initialValue: true
    },
    behavioursEnabled: {initialValue: true},
    wrapBehavioursEnabled: {initialValue: true},
    autoScrollEditorIntoView: {
        set: function(val) {this.setAutoScrollEditorIntoView(val);}
    },
    keyboardHandler: {
        set: function(val) { this.setKeyboardHandler(val); },
        get: function() { return this.keybindingId; },
        handlesSet: true
    },

    hScrollBarAlwaysVisible: "renderer",
    vScrollBarAlwaysVisible: "renderer",
    highlightGutterLine: "renderer",
    animatedScroll: "renderer",
    showInvisibles: "renderer",
    showPrintMargin: "renderer",
    printMarginColumn: "renderer",
    printMargin: "renderer",
    fadeFoldWidgets: "renderer",
    showFoldWidgets: "renderer",
    showLineNumbers: "renderer",
    showGutter: "renderer",
    displayIndentGuides: "renderer",
    fontSize: "renderer",
    fontFamily: "renderer",
    maxLines: "renderer",
    minLines: "renderer",
    scrollPastEnd: "renderer",
    fixedWidthGutter: "renderer",
    theme: "renderer",

    scrollSpeed: "$mouseHandler",
    dragDelay: "$mouseHandler",
    dragEnabled: "$mouseHandler",
    focusTimout: "$mouseHandler",
    tooltipFollowsMouse: "$mouseHandler",

    firstLineNumber: "session",
    overwrite: "session",
    newLineMode: "session",
    useWorker: "session",
    useSoftTabs: "session",
    tabSize: "session",
    wrap: "session",
    indentedSoftWrap: "session",
    foldStyle: "session",
    mode: "session"
});

exports.Editor = Editor;
});

ace.define("ace/undomanager",["require","exports","module"], function(acequire, exports, module) {
"use strict";
var UndoManager = function() {
    this.reset();
};

(function() {
    this.execute = function(options) {
        var deltaSets = options.args[0];
        this.$doc  = options.args[1];
        if (options.merge && this.hasUndo()){
            this.dirtyCounter--;
            deltaSets = this.$undoStack.pop().concat(deltaSets);
        }
        this.$undoStack.push(deltaSets);
        this.$redoStack = [];
        if (this.dirtyCounter < 0) {
            this.dirtyCounter = NaN;
        }
        this.dirtyCounter++;
    };
    this.undo = function(dontSelect) {
        var deltaSets = this.$undoStack.pop();
        var undoSelectionRange = null;
        if (deltaSets) {
            undoSelectionRange = this.$doc.undoChanges(deltaSets, dontSelect);
            this.$redoStack.push(deltaSets);
            this.dirtyCounter--;
        }

        return undoSelectionRange;
    };
    this.redo = function(dontSelect) {
        var deltaSets = this.$redoStack.pop();
        var redoSelectionRange = null;
        if (deltaSets) {
            redoSelectionRange =
                this.$doc.redoChanges(this.$deserializeDeltas(deltaSets), dontSelect);
            this.$undoStack.push(deltaSets);
            this.dirtyCounter++;
        }
        return redoSelectionRange;
    };
    this.reset = function() {
        this.$undoStack = [];
        this.$redoStack = [];
        this.dirtyCounter = 0;
    };
    this.hasUndo = function() {
        return this.$undoStack.length > 0;
    };
    this.hasRedo = function() {
        return this.$redoStack.length > 0;
    };
    this.markClean = function() {
        this.dirtyCounter = 0;
    };
    this.isClean = function() {
        return this.dirtyCounter === 0;
    };
    this.$serializeDeltas = function(deltaSets) {
        return cloneDeltaSetsObj(deltaSets, $serializeDelta);
    };
    this.$deserializeDeltas = function(deltaSets) {
        return cloneDeltaSetsObj(deltaSets, $deserializeDelta);
    };
    
    function $serializeDelta(delta){
        return {
            action: delta.action,
            start: delta.start,
            end: delta.end,
            lines: delta.lines.length == 1 ? null : delta.lines,
            text: delta.lines.length == 1 ? delta.lines[0] : null
        };
    }
        
    function $deserializeDelta(delta) {
        return {
            action: delta.action,
            start: delta.start,
            end: delta.end,
            lines: delta.lines || [delta.text]
        };
    }
    
    function cloneDeltaSetsObj(deltaSets_old, fnGetModifiedDelta) {
        var deltaSets_new = new Array(deltaSets_old.length);
        for (var i = 0; i < deltaSets_old.length; i++) {
            var deltaSet_old = deltaSets_old[i];
            var deltaSet_new = { group: deltaSet_old.group, deltas: new Array(deltaSet_old.length)};
            
            for (var j = 0; j < deltaSet_old.deltas.length; j++) {
                var delta_old = deltaSet_old.deltas[j];
                deltaSet_new.deltas[j] = fnGetModifiedDelta(delta_old);
            }
            
            deltaSets_new[i] = deltaSet_new;
        }
        return deltaSets_new;
    }
    
}).call(UndoManager.prototype);

exports.UndoManager = UndoManager;
});

ace.define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var Gutter = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_gutter-layer";
    parentEl.appendChild(this.element);
    this.setShowFoldWidgets(this.$showFoldWidgets);
    
    this.gutterWidth = 0;

    this.$annotations = [];
    this.$updateAnnotations = this.$updateAnnotations.bind(this);

    this.$cells = [];
};

(function() {

    oop.implement(this, EventEmitter);

    this.setSession = function(session) {
        if (this.session)
            this.session.removeEventListener("change", this.$updateAnnotations);
        this.session = session;
        if (session)
            session.on("change", this.$updateAnnotations);
    };

    this.addGutterDecoration = function(row, className){
        if (window.console)
            console.warn && console.warn("deprecated use session.addGutterDecoration");
        this.session.addGutterDecoration(row, className);
    };

    this.removeGutterDecoration = function(row, className){
        if (window.console)
            console.warn && console.warn("deprecated use session.removeGutterDecoration");
        this.session.removeGutterDecoration(row, className);
    };

    this.setAnnotations = function(annotations) {
        this.$annotations = [];
        for (var i = 0; i < annotations.length; i++) {
            var annotation = annotations[i];
            var row = annotation.row;
            var rowInfo = this.$annotations[row];
            if (!rowInfo)
                rowInfo = this.$annotations[row] = {text: []};
           
            var annoText = annotation.text;
            annoText = annoText ? lang.escapeHTML(annoText) : annotation.html || "";

            if (rowInfo.text.indexOf(annoText) === -1)
                rowInfo.text.push(annoText);

            var type = annotation.type;
            if (type == "error")
                rowInfo.className = " ace_error";
            else if (type == "warning" && rowInfo.className != " ace_error")
                rowInfo.className = " ace_warning";
            else if (type == "info" && (!rowInfo.className))
                rowInfo.className = " ace_info";
        }
    };

    this.$updateAnnotations = function (delta) {
        if (!this.$annotations.length)
            return;
        var firstRow = delta.start.row;
        var len = delta.end.row - firstRow;
        if (len === 0) {
        } else if (delta.action == 'remove') {
            this.$annotations.splice(firstRow, len + 1, null);
        } else {
            var args = new Array(len + 1);
            args.unshift(firstRow, 1);
            this.$annotations.splice.apply(this.$annotations, args);
        }
    };

    this.update = function(config) {
        var session = this.session;
        var firstRow = config.firstRow;
        var lastRow = Math.min(config.lastRow + config.gutterOffset,  // needed to compensate for hor scollbar
            session.getLength() - 1);
        var fold = session.getNextFoldLine(firstRow);
        var foldStart = fold ? fold.start.row : Infinity;
        var foldWidgets = this.$showFoldWidgets && session.foldWidgets;
        var breakpoints = session.$breakpoints;
        var decorations = session.$decorations;
        var firstLineNumber = session.$firstLineNumber;
        var lastLineNumber = 0;
        
        var gutterRenderer = session.gutterRenderer || this.$renderer;

        var cell = null;
        var index = -1;
        var row = firstRow;
        while (true) {
            if (row > foldStart) {
                row = fold.end.row + 1;
                fold = session.getNextFoldLine(row, fold);
                foldStart = fold ? fold.start.row : Infinity;
            }
            if (row > lastRow) {
                while (this.$cells.length > index + 1) {
                    cell = this.$cells.pop();
                    this.element.removeChild(cell.element);
                }
                break;
            }

            cell = this.$cells[++index];
            if (!cell) {
                cell = {element: null, textNode: null, foldWidget: null};
                cell.element = dom.createElement("div");
                cell.textNode = document.createTextNode('');
                cell.element.appendChild(cell.textNode);
                this.element.appendChild(cell.element);
                this.$cells[index] = cell;
            }

            var className = "ace_gutter-cell ";
            if (breakpoints[row])
                className += breakpoints[row];
            if (decorations[row])
                className += decorations[row];
            if (this.$annotations[row])
                className += this.$annotations[row].className;
            if (cell.element.className != className)
                cell.element.className = className;

            var height = session.getRowLength(row) * config.lineHeight + "px";
            if (height != cell.element.style.height)
                cell.element.style.height = height;

            if (foldWidgets) {
                var c = foldWidgets[row];
                if (c == null)
                    c = foldWidgets[row] = session.getFoldWidget(row);
            }

            if (c) {
                if (!cell.foldWidget) {
                    cell.foldWidget = dom.createElement("span");
                    cell.element.appendChild(cell.foldWidget);
                }
                var className = "ace_fold-widget ace_" + c;
                if (c == "start" && row == foldStart && row < fold.end.row)
                    className += " ace_closed";
                else
                    className += " ace_open";
                if (cell.foldWidget.className != className)
                    cell.foldWidget.className = className;

                var height = config.lineHeight + "px";
                if (cell.foldWidget.style.height != height)
                    cell.foldWidget.style.height = height;
            } else {
                if (cell.foldWidget) {
                    cell.element.removeChild(cell.foldWidget);
                    cell.foldWidget = null;
                }
            }
            
            var text = lastLineNumber = gutterRenderer
                ? gutterRenderer.getText(session, row)
                : row + firstLineNumber;
            if (text !== cell.textNode.data)
                cell.textNode.data = text;

            row++;
        }

        this.element.style.height = config.minHeight + "px";

        if (this.$fixedWidth || session.$useWrapMode)
            lastLineNumber = session.getLength() + firstLineNumber;

        var gutterWidth = gutterRenderer 
            ? gutterRenderer.getWidth(session, lastLineNumber, config)
            : lastLineNumber.toString().length * config.characterWidth;
        
        var padding = this.$padding || this.$computePadding();
        gutterWidth += padding.left + padding.right;
        if (gutterWidth !== this.gutterWidth && !isNaN(gutterWidth)) {
            this.gutterWidth = gutterWidth;
            this.element.style.width = Math.ceil(this.gutterWidth) + "px";
            this._emit("changeGutterWidth", gutterWidth);
        }
    };

    this.$fixedWidth = false;
    
    this.$showLineNumbers = true;
    this.$renderer = "";
    this.setShowLineNumbers = function(show) {
        this.$renderer = !show && {
            getWidth: function() {return "";},
            getText: function() {return "";}
        };
    };
    
    this.getShowLineNumbers = function() {
        return this.$showLineNumbers;
    };
    
    this.$showFoldWidgets = true;
    this.setShowFoldWidgets = function(show) {
        if (show)
            dom.addCssClass(this.element, "ace_folding-enabled");
        else
            dom.removeCssClass(this.element, "ace_folding-enabled");

        this.$showFoldWidgets = show;
        this.$padding = null;
    };
    
    this.getShowFoldWidgets = function() {
        return this.$showFoldWidgets;
    };

    this.$computePadding = function() {
        if (!this.element.firstChild)
            return {left: 0, right: 0};
        var style = dom.computedStyle(this.element.firstChild);
        this.$padding = {};
        this.$padding.left = parseInt(style.paddingLeft) + 1 || 0;
        this.$padding.right = parseInt(style.paddingRight) || 0;
        return this.$padding;
    };

    this.getRegion = function(point) {
        var padding = this.$padding || this.$computePadding();
        var rect = this.element.getBoundingClientRect();
        if (point.x < padding.left + rect.left)
            return "markers";
        if (this.$showFoldWidgets && point.x > rect.right - padding.right)
            return "foldWidgets";
    };

}).call(Gutter.prototype);

exports.Gutter = Gutter;

});

ace.define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
var dom = acequire("../lib/dom");

var Marker = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_marker-layer";
    parentEl.appendChild(this.element);
};

(function() {

    this.$padding = 0;

    this.setPadding = function(padding) {
        this.$padding = padding;
    };
    this.setSession = function(session) {
        this.session = session;
    };
    
    this.setMarkers = function(markers) {
        this.markers = markers;
    };

    this.update = function(config) {
        if (!config) return;

        this.config = config;


        var html = [];
        for (var key in this.markers) {
            var marker = this.markers[key];

            if (!marker.range) {
                marker.update(html, this, this.session, config);
                continue;
            }

            var range = marker.range.clipRows(config.firstRow, config.lastRow);
            if (range.isEmpty()) continue;

            range = range.toScreenRange(this.session);
            if (marker.renderer) {
                var top = this.$getTop(range.start.row, config);
                var left = this.$padding + (this.session.$bidiHandler.isBidiRow(range.start.row)
                    ? this.session.$bidiHandler.getPosLeft(range.start.column)
                    : range.start.column * config.characterWidth);
                marker.renderer(html, range, left, top, config);
            } else if (marker.type == "fullLine") {
                this.drawFullLineMarker(html, range, marker.clazz, config);
            } else if (marker.type == "screenLine") {
                this.drawScreenLineMarker(html, range, marker.clazz, config);
            } else if (range.isMultiLine()) {
                if (marker.type == "text")
                    this.drawTextMarker(html, range, marker.clazz, config);
                else
                    this.drawMultiLineMarker(html, range, marker.clazz, config);
            } else {
                if (this.session.$bidiHandler.isBidiRow(range.start.row)) {
                    this.drawBidiSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
                } else {
                    this.drawSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
                }
            }
        }
        this.element.innerHTML = html.join("");
    };

    this.$getTop = function(row, layerConfig) {
        return (row - layerConfig.firstRowScreen) * layerConfig.lineHeight;
    };

    function getBorderClass(tl, tr, br, bl) {
        return (tl ? 1 : 0) | (tr ? 2 : 0) | (br ? 4 : 0) | (bl ? 8 : 0);
    }
    this.drawTextMarker = function(stringBuilder, range, clazz, layerConfig, extraStyle) {
        var session = this.session;
        var start = range.start.row;
        var end = range.end.row;
        var row = start;
        var prev = 0; 
        var curr = 0;
        var next = session.getScreenLastRowColumn(row);
        var clazzModified = null;
        var lineRange = new Range(row, range.start.column, row, curr);
        for (; row <= end; row++) {
            lineRange.start.row = lineRange.end.row = row;
            lineRange.start.column = row == start ? range.start.column : session.getRowWrapIndent(row);
            lineRange.end.column = next;
            prev = curr;
            curr = next;
            next = row + 1 < end ? session.getScreenLastRowColumn(row + 1) : row == end ? 0 : range.end.column;
            clazzModified = clazz + (row == start  ? " ace_start" : "") + " ace_br"
                + getBorderClass(row == start || row == start + 1 && range.start.column, prev < curr, curr > next, row == end);

            if (this.session.$bidiHandler.isBidiRow(row)) {
                this.drawBidiSingleLineMarker(stringBuilder, lineRange, clazzModified,
                    layerConfig, row == end ? 0 : 1, extraStyle);
            } else {
                this.drawSingleLineMarker(stringBuilder, lineRange, clazzModified,
                    layerConfig, row == end ? 0 : 1, extraStyle);
            }
        }
    };
    this.drawMultiLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
        var padding = this.$padding;
        var height, top, left;
        extraStyle = extraStyle || "";
       if (this.session.$bidiHandler.isBidiRow(range.start.row)) {
           var range1 = range.clone();
           range1.end.row = range1.start.row;
           range1.end.column = this.session.getLine(range1.start.row).length;
           this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br1 ace_start", config, null, extraStyle);
        } else {
           height = config.lineHeight;
           top = this.$getTop(range.start.row, config);
           left = padding + range.start.column * config.characterWidth;
           stringBuilder.push(
               "<div class='", clazz, " ace_br1 ace_start' style='",
               "height:", height, "px;",
               "right:0;",
               "top:", top, "px;",
               "left:", left, "px;", extraStyle, "'></div>"
           );
        }
        if (this.session.$bidiHandler.isBidiRow(range.end.row)) {
           var range1 = range.clone();
           range1.start.row = range1.end.row;
           range1.start.column = 0;
           this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br12", config, null, extraStyle);
        } else {
           var width = range.end.column * config.characterWidth;
           height = config.lineHeight;
           top = this.$getTop(range.end.row, config);
           stringBuilder.push(
               "<div class='", clazz, " ace_br12' style='",
               "height:", height, "px;",
               "width:", width, "px;",
               "top:", top, "px;",
               "left:", padding, "px;", extraStyle, "'></div>"
           );
        }
        height = (range.end.row - range.start.row - 1) * config.lineHeight;
        if (height <= 0)
            return;
        top = this.$getTop(range.start.row + 1, config);
        
        var radiusClass = (range.start.column ? 1 : 0) | (range.end.column ? 0 : 8);

        stringBuilder.push(
            "<div class='", clazz, (radiusClass ? " ace_br" + radiusClass : ""), "' style='",
            "height:", height, "px;",
            "right:0;",
            "top:", top, "px;",
            "left:", padding, "px;", extraStyle, "'></div>"
        );
    };
    this.drawSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
        var height = config.lineHeight;
        var width = (range.end.column + (extraLength || 0) - range.start.column) * config.characterWidth;

        var top = this.$getTop(range.start.row, config);
        var left = this.$padding + range.start.column * config.characterWidth;

        stringBuilder.push(
            "<div class='", clazz, "' style='",
            "height:", height, "px;",
            "width:", width, "px;",
            "top:", top, "px;",
            "left:", left, "px;", extraStyle || "", "'></div>"
        );
    };
    this.drawBidiSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
        var height = config.lineHeight, top = this.$getTop(range.start.row, config), padding = this.$padding;
        var selections = this.session.$bidiHandler.getSelections(range.start.column, range.end.column);

        selections.forEach(function(selection) {
            stringBuilder.push(
                "<div class='", clazz, "' style='",
                "height:", height, "px;",
                "width:", selection.width + (extraLength || 0), "px;",
                "top:", top, "px;",
                "left:", padding + selection.left, "px;", extraStyle || "", "'></div>"
            );
        });
    };

    this.drawFullLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
        var top = this.$getTop(range.start.row, config);
        var height = config.lineHeight;
        if (range.start.row != range.end.row)
            height += this.$getTop(range.end.row, config) - top;

        stringBuilder.push(
            "<div class='", clazz, "' style='",
            "height:", height, "px;",
            "top:", top, "px;",
            "left:0;right:0;", extraStyle || "", "'></div>"
        );
    };
    
    this.drawScreenLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
        var top = this.$getTop(range.start.row, config);
        var height = config.lineHeight;

        stringBuilder.push(
            "<div class='", clazz, "' style='",
            "height:", height, "px;",
            "top:", top, "px;",
            "left:0;right:0;", extraStyle || "", "'></div>"
        );
    };

}).call(Marker.prototype);

exports.Marker = Marker;

});

ace.define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var useragent = acequire("../lib/useragent");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var Text = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_text-layer";
    parentEl.appendChild(this.element);
    this.$updateEolChar = this.$updateEolChar.bind(this);
};

(function() {

    oop.implement(this, EventEmitter);

    this.EOF_CHAR = "\xB6";
    this.EOL_CHAR_LF = "\xAC";
    this.EOL_CHAR_CRLF = "\xa4";
    this.EOL_CHAR = this.EOL_CHAR_LF;
    this.TAB_CHAR = "\u2014"; //"\u21E5";
    this.SPACE_CHAR = "\xB7";
    this.$padding = 0;

    this.$updateEolChar = function() {
        var EOL_CHAR = this.session.doc.getNewLineCharacter() == "\n"
           ? this.EOL_CHAR_LF
           : this.EOL_CHAR_CRLF;
        if (this.EOL_CHAR != EOL_CHAR) {
            this.EOL_CHAR = EOL_CHAR;
            return true;
        }
    };

    this.setPadding = function(padding) {
        this.$padding = padding;
        this.element.style.padding = "0 " + padding + "px";
    };

    this.getLineHeight = function() {
        return this.$fontMetrics.$characterSize.height || 0;
    };

    this.getCharacterWidth = function() {
        return this.$fontMetrics.$characterSize.width || 0;
    };
    
    this.$setFontMetrics = function(measure) {
        this.$fontMetrics = measure;
        this.$fontMetrics.on("changeCharacterSize", function(e) {
            this._signal("changeCharacterSize", e);
        }.bind(this));
        this.$pollSizeChanges();
    };

    this.checkForSizeChanges = function() {
        this.$fontMetrics.checkForSizeChanges();
    };
    this.$pollSizeChanges = function() {
        return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
    };
    this.setSession = function(session) {
        this.session = session;
        if (session)
            this.$computeTabString();
    };

    this.showInvisibles = false;
    this.setShowInvisibles = function(showInvisibles) {
        if (this.showInvisibles == showInvisibles)
            return false;

        this.showInvisibles = showInvisibles;
        this.$computeTabString();
        return true;
    };

    this.displayIndentGuides = true;
    this.setDisplayIndentGuides = function(display) {
        if (this.displayIndentGuides == display)
            return false;

        this.displayIndentGuides = display;
        this.$computeTabString();
        return true;
    };

    this.$tabStrings = [];
    this.onChangeTabSize =
    this.$computeTabString = function() {
        var tabSize = this.session.getTabSize();
        this.tabSize = tabSize;
        var tabStr = this.$tabStrings = [0];
        for (var i = 1; i < tabSize + 1; i++) {
            if (this.showInvisibles) {
                tabStr.push("<span class='ace_invisible ace_invisible_tab'>"
                    + lang.stringRepeat(this.TAB_CHAR, i)
                    + "</span>");
            } else {
                tabStr.push(lang.stringRepeat(" ", i));
            }
        }
        if (this.displayIndentGuides) {
            this.$indentGuideRe =  /\s\S| \t|\t |\s$/;
            var className = "ace_indent-guide";
            var spaceClass = "";
            var tabClass = "";
            if (this.showInvisibles) {
                className += " ace_invisible";
                spaceClass = " ace_invisible_space";
                tabClass = " ace_invisible_tab";
                var spaceContent = lang.stringRepeat(this.SPACE_CHAR, this.tabSize);
                var tabContent = lang.stringRepeat(this.TAB_CHAR, this.tabSize);
            } else{
                var spaceContent = lang.stringRepeat(" ", this.tabSize);
                var tabContent = spaceContent;
            }

            this.$tabStrings[" "] = "<span class='" + className + spaceClass + "'>" + spaceContent + "</span>";
            this.$tabStrings["\t"] = "<span class='" + className + tabClass + "'>" + tabContent + "</span>";
        }
    };

    this.updateLines = function(config, firstRow, lastRow) {
        if (this.config.lastRow != config.lastRow ||
            this.config.firstRow != config.firstRow) {
            this.scrollLines(config);
        }
        this.config = config;

        var first = Math.max(firstRow, config.firstRow);
        var last = Math.min(lastRow, config.lastRow);

        var lineElements = this.element.childNodes;
        var lineElementsIdx = 0;

        for (var row = config.firstRow; row < first; row++) {
            var foldLine = this.session.getFoldLine(row);
            if (foldLine) {
                if (foldLine.containsRow(first)) {
                    first = foldLine.start.row;
                    break;
                } else {
                    row = foldLine.end.row;
                }
            }
            lineElementsIdx ++;
        }

        var row = first;
        var foldLine = this.session.getNextFoldLine(row);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (true) {
            if (row > foldStart) {
                row = foldLine.end.row+1;
                foldLine = this.session.getNextFoldLine(row, foldLine);
                foldStart = foldLine ? foldLine.start.row :Infinity;
            }
            if (row > last)
                break;

            var lineElement = lineElements[lineElementsIdx++];
            if (lineElement) {
                var html = [];
                this.$renderLine(
                    html, row, !this.$useLineGroups(), row == foldStart ? foldLine : false
                );
                lineElement.style.height = config.lineHeight * this.session.getRowLength(row) + "px";
                lineElement.innerHTML = html.join("");
            }
            row++;
        }
    };

    this.scrollLines = function(config) {
        var oldConfig = this.config;
        this.config = config;

        if (!oldConfig || oldConfig.lastRow < config.firstRow)
            return this.update(config);

        if (config.lastRow < oldConfig.firstRow)
            return this.update(config);

        var el = this.element;
        if (oldConfig.firstRow < config.firstRow)
            for (var row=this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row>0; row--)
                el.removeChild(el.firstChild);

        if (oldConfig.lastRow > config.lastRow)
            for (var row=this.session.getFoldedRowCount(config.lastRow + 1, oldConfig.lastRow); row>0; row--)
                el.removeChild(el.lastChild);

        if (config.firstRow < oldConfig.firstRow) {
            var fragment = this.$renderLinesFragment(config, config.firstRow, oldConfig.firstRow - 1);
            if (el.firstChild)
                el.insertBefore(fragment, el.firstChild);
            else
                el.appendChild(fragment);
        }

        if (config.lastRow > oldConfig.lastRow) {
            var fragment = this.$renderLinesFragment(config, oldConfig.lastRow + 1, config.lastRow);
            el.appendChild(fragment);
        }
    };

    this.$renderLinesFragment = function(config, firstRow, lastRow) {
        var fragment = this.element.ownerDocument.createDocumentFragment();
        var row = firstRow;
        var foldLine = this.session.getNextFoldLine(row);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (true) {
            if (row > foldStart) {
                row = foldLine.end.row+1;
                foldLine = this.session.getNextFoldLine(row, foldLine);
                foldStart = foldLine ? foldLine.start.row : Infinity;
            }
            if (row > lastRow)
                break;

            var container = dom.createElement("div");

            var html = [];
            this.$renderLine(html, row, false, row == foldStart ? foldLine : false);
            container.innerHTML = html.join("");
            if (this.$useLineGroups()) {
                container.className = 'ace_line_group';
                fragment.appendChild(container);
                container.style.height = config.lineHeight * this.session.getRowLength(row) + "px";

            } else {
                while(container.firstChild)
                    fragment.appendChild(container.firstChild);
            }

            row++;
        }
        return fragment;
    };

    this.update = function(config) {
        this.config = config;

        var html = [];
        var firstRow = config.firstRow, lastRow = config.lastRow;

        var row = firstRow;
        var foldLine = this.session.getNextFoldLine(row);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (true) {
            if (row > foldStart) {
                row = foldLine.end.row+1;
                foldLine = this.session.getNextFoldLine(row, foldLine);
                foldStart = foldLine ? foldLine.start.row :Infinity;
            }
            if (row > lastRow)
                break;

            if (this.$useLineGroups())
                html.push("<div class='ace_line_group' style='height:", config.lineHeight*this.session.getRowLength(row), "px'>");

            this.$renderLine(html, row, false, row == foldStart ? foldLine : false);

            if (this.$useLineGroups())
                html.push("</div>"); // end the line group

            row++;
        }
        this.element.innerHTML = html.join("");
    };

    this.$textToken = {
        "text": true,
        "rparen": true,
        "lparen": true
    };

    this.$renderToken = function(stringBuilder, screenColumn, token, value) {
        var self = this;
        var replaceReg = /\t|&|<|>|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\u3000\uFEFF\uFFF9-\uFFFC])|[\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        var replaceFunc = function(c, a, b, tabIdx, idx4) {
            if (a) {
                return self.showInvisibles
                    ? "<span class='ace_invisible ace_invisible_space'>" + lang.stringRepeat(self.SPACE_CHAR, c.length) + "</span>"
                    : c;
            } else if (c == "&") {
                return "&#38;";
            } else if (c == "<") {
                return "&#60;";
            } else if (c == ">") {
                return "&#62;";
            } else if (c == "\t") {
                var tabSize = self.session.getScreenTabSize(screenColumn + tabIdx);
                screenColumn += tabSize - 1;
                return self.$tabStrings[tabSize];
            } else if (c == "\u3000") {
                var classToUse = self.showInvisibles ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk";
                var space = self.showInvisibles ? self.SPACE_CHAR : "";
                screenColumn += 1;
                return "<span class='" + classToUse + "' style='width:" +
                    (self.config.characterWidth * 2) +
                    "px'>" + space + "</span>";
            } else if (b) {
                return "<span class='ace_invisible ace_invisible_space ace_invalid'>" + self.SPACE_CHAR + "</span>";
            } else {
                screenColumn += 1;
                return "<span class='ace_cjk' style='width:" +
                    (self.config.characterWidth * 2) +
                    "px'>" + c + "</span>";
            }
        };

        var output = value.replace(replaceReg, replaceFunc);

        if (!this.$textToken[token.type]) {
            var classes = "ace_" + token.type.replace(/\./g, " ace_");
            var style = "";
            if (token.type == "fold")
                style = " style='width:" + (token.value.length * this.config.characterWidth) + "px;' ";
            stringBuilder.push("<span class='", classes, "'", style, ">", output, "</span>");
        }
        else {
            stringBuilder.push(output);
        }
        return screenColumn + value.length;
    };

    this.renderIndentGuide = function(stringBuilder, value, max) {
        var cols = value.search(this.$indentGuideRe);
        if (cols <= 0 || cols >= max)
            return value;
        if (value[0] == " ") {
            cols -= cols % this.tabSize;
            stringBuilder.push(lang.stringRepeat(this.$tabStrings[" "], cols/this.tabSize));
            return value.substr(cols);
        } else if (value[0] == "\t") {
            stringBuilder.push(lang.stringRepeat(this.$tabStrings["\t"], cols));
            return value.substr(cols);
        }
        return value;
    };

    this.$renderWrappedLine = function(stringBuilder, tokens, splits, onlyContents) {
        var chars = 0;
        var split = 0;
        var splitChars = splits[0];
        var screenColumn = 0;

        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            var value = token.value;
            if (i == 0 && this.displayIndentGuides) {
                chars = value.length;
                value = this.renderIndentGuide(stringBuilder, value, splitChars);
                if (!value)
                    continue;
                chars -= value.length;
            }

            if (chars + value.length < splitChars) {
                screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
                chars += value.length;
            } else {
                while (chars + value.length >= splitChars) {
                    screenColumn = this.$renderToken(
                        stringBuilder, screenColumn,
                        token, value.substring(0, splitChars - chars)
                    );
                    value = value.substring(splitChars - chars);
                    chars = splitChars;

                    if (!onlyContents) {
                        stringBuilder.push("</div>",
                            "<div class='ace_line' style='height:",
                            this.config.lineHeight, "px'>"
                        );
                    }

                    stringBuilder.push(lang.stringRepeat("\xa0", splits.indent));

                    split ++;
                    screenColumn = 0;
                    splitChars = splits[split] || Number.MAX_VALUE;
                }
                if (value.length != 0) {
                    chars += value.length;
                    screenColumn = this.$renderToken(
                        stringBuilder, screenColumn, token, value
                    );
                }
            }
        }
    };

    this.$renderSimpleLine = function(stringBuilder, tokens) {
        var screenColumn = 0;
        var token = tokens[0];
        var value = token.value;
        if (this.displayIndentGuides)
            value = this.renderIndentGuide(stringBuilder, value);
        if (value)
            screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
        for (var i = 1; i < tokens.length; i++) {
            token = tokens[i];
            value = token.value;
            screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
        }
    };
    this.$renderLine = function(stringBuilder, row, onlyContents, foldLine) {
        if (!foldLine && foldLine != false)
            foldLine = this.session.getFoldLine(row);

        if (foldLine)
            var tokens = this.$getFoldLineTokens(row, foldLine);
        else
            var tokens = this.session.getTokens(row);


        if (!onlyContents) {
            stringBuilder.push(
                "<div class='ace_line' style='height:", 
                    this.config.lineHeight * (
                        this.$useLineGroups() ? 1 :this.session.getRowLength(row)
                    ), "px'>"
            );
        }

        if (tokens.length) {
            var splits = this.session.getRowSplitData(row);
            if (splits && splits.length)
                this.$renderWrappedLine(stringBuilder, tokens, splits, onlyContents);
            else
                this.$renderSimpleLine(stringBuilder, tokens);
        }

        if (this.showInvisibles) {
            if (foldLine)
                row = foldLine.end.row;

            stringBuilder.push(
                "<span class='ace_invisible ace_invisible_eol'>",
                row == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR,
                "</span>"
            );
        }
        if (!onlyContents)
            stringBuilder.push("</div>");
    };

    this.$getFoldLineTokens = function(row, foldLine) {
        var session = this.session;
        var renderTokens = [];

        function addTokens(tokens, from, to) {
            var idx = 0, col = 0;
            while ((col + tokens[idx].value.length) < from) {
                col += tokens[idx].value.length;
                idx++;

                if (idx == tokens.length)
                    return;
            }
            if (col != from) {
                var value = tokens[idx].value.substring(from - col);
                if (value.length > (to - from))
                    value = value.substring(0, to - from);

                renderTokens.push({
                    type: tokens[idx].type,
                    value: value
                });

                col = from + value.length;
                idx += 1;
            }

            while (col < to && idx < tokens.length) {
                var value = tokens[idx].value;
                if (value.length + col > to) {
                    renderTokens.push({
                        type: tokens[idx].type,
                        value: value.substring(0, to - col)
                    });
                } else
                    renderTokens.push(tokens[idx]);
                col += value.length;
                idx += 1;
            }
        }

        var tokens = session.getTokens(row);
        foldLine.walk(function(placeholder, row, column, lastColumn, isNewRow) {
            if (placeholder != null) {
                renderTokens.push({
                    type: "fold",
                    value: placeholder
                });
            } else {
                if (isNewRow)
                    tokens = session.getTokens(row);

                if (tokens.length)
                    addTokens(tokens, lastColumn, column);
            }
        }, foldLine.end.row, this.session.getLine(foldLine.end.row).length);

        return renderTokens;
    };

    this.$useLineGroups = function() {
        return this.session.getUseWrapMode();
    };

    this.destroy = function() {
        clearInterval(this.$pollSizeChangesTimer);
        if (this.$measureNode)
            this.$measureNode.parentNode.removeChild(this.$measureNode);
        delete this.$measureNode;
    };

}).call(Text.prototype);

exports.Text = Text;

});

ace.define("ace/layer/cursor",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var isIE8;

var Cursor = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_cursor-layer";
    parentEl.appendChild(this.element);
    
    if (isIE8 === undefined)
        isIE8 = !("opacity" in this.element.style);

    this.isVisible = false;
    this.isBlinking = true;
    this.blinkInterval = 1000;
    this.smoothBlinking = false;

    this.cursors = [];
    this.cursor = this.addCursor();
    dom.addCssClass(this.element, "ace_hidden-cursors");
    this.$updateCursors = (isIE8
        ? this.$updateVisibility
        : this.$updateOpacity).bind(this);
};

(function() {
    
    this.$updateVisibility = function(val) {
        var cursors = this.cursors;
        for (var i = cursors.length; i--; )
            cursors[i].style.visibility = val ? "" : "hidden";
    };
    this.$updateOpacity = function(val) {
        var cursors = this.cursors;
        for (var i = cursors.length; i--; )
            cursors[i].style.opacity = val ? "" : "0";
    };
    

    this.$padding = 0;
    this.setPadding = function(padding) {
        this.$padding = padding;
    };

    this.setSession = function(session) {
        this.session = session;
    };

    this.setBlinking = function(blinking) {
        if (blinking != this.isBlinking){
            this.isBlinking = blinking;
            this.restartTimer();
        }
    };

    this.setBlinkInterval = function(blinkInterval) {
        if (blinkInterval != this.blinkInterval){
            this.blinkInterval = blinkInterval;
            this.restartTimer();
        }
    };

    this.setSmoothBlinking = function(smoothBlinking) {
        if (smoothBlinking != this.smoothBlinking && !isIE8) {
            this.smoothBlinking = smoothBlinking;
            dom.setCssClass(this.element, "ace_smooth-blinking", smoothBlinking);
            this.$updateCursors(true);
            this.$updateCursors = (this.$updateOpacity).bind(this);
            this.restartTimer();
        }
    };

    this.addCursor = function() {
        var el = dom.createElement("div");
        el.className = "ace_cursor";
        this.element.appendChild(el);
        this.cursors.push(el);
        return el;
    };

    this.removeCursor = function() {
        if (this.cursors.length > 1) {
            var el = this.cursors.pop();
            el.parentNode.removeChild(el);
            return el;
        }
    };

    this.hideCursor = function() {
        this.isVisible = false;
        dom.addCssClass(this.element, "ace_hidden-cursors");
        this.restartTimer();
    };

    this.showCursor = function() {
        this.isVisible = true;
        dom.removeCssClass(this.element, "ace_hidden-cursors");
        this.restartTimer();
    };

    this.restartTimer = function() {
        var update = this.$updateCursors;
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
        if (this.smoothBlinking) {
            dom.removeCssClass(this.element, "ace_smooth-blinking");
        }
        
        update(true);

        if (!this.isBlinking || !this.blinkInterval || !this.isVisible)
            return;

        if (this.smoothBlinking) {
            setTimeout(function(){
                dom.addCssClass(this.element, "ace_smooth-blinking");
            }.bind(this));
        }
        
        var blink = function(){
            this.timeoutId = setTimeout(function() {
                update(false);
            }, 0.6 * this.blinkInterval);
        }.bind(this);

        this.intervalId = setInterval(function() {
            update(true);
            blink();
        }, this.blinkInterval);

        blink();
    };

    this.getPixelPosition = function(position, onScreen) {
        if (!this.config || !this.session)
            return {left : 0, top : 0};

        if (!position)
            position = this.session.selection.getCursor();
        var pos = this.session.documentToScreenPosition(position);
        var cursorLeft = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, position.row)
            ? this.session.$bidiHandler.getPosLeft(pos.column)
            : pos.column * this.config.characterWidth);

        var cursorTop = (pos.row - (onScreen ? this.config.firstRowScreen : 0)) *
            this.config.lineHeight;

        return {left : cursorLeft, top : cursorTop};
    };

    this.update = function(config) {
        this.config = config;

        var selections = this.session.$selectionMarkers;
        var i = 0, cursorIndex = 0;

        if (selections === undefined || selections.length === 0){
            selections = [{cursor: null}];
        }

        for (var i = 0, n = selections.length; i < n; i++) {
            var pixelPos = this.getPixelPosition(selections[i].cursor, true);
            if ((pixelPos.top > config.height + config.offset ||
                 pixelPos.top < 0) && i > 1) {
                continue;
            }

            var style = (this.cursors[cursorIndex++] || this.addCursor()).style;
            
            if (!this.drawCursor) {
                style.left = pixelPos.left + "px";
                style.top = pixelPos.top + "px";
                style.width = config.characterWidth + "px";
                style.height = config.lineHeight + "px";
            } else {
                this.drawCursor(style, pixelPos, config, selections[i], this.session);
            }
        }
        while (this.cursors.length > cursorIndex)
            this.removeCursor();

        var overwrite = this.session.getOverwrite();
        this.$setOverwrite(overwrite);
        this.$pixelPos = pixelPos;
        this.restartTimer();
    };
    
    this.drawCursor = null;

    this.$setOverwrite = function(overwrite) {
        if (overwrite != this.overwrite) {
            this.overwrite = overwrite;
            if (overwrite)
                dom.addCssClass(this.element, "ace_overwrite-cursors");
            else
                dom.removeCssClass(this.element, "ace_overwrite-cursors");
        }
    };

    this.destroy = function() {
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
    };

}).call(Cursor.prototype);

exports.Cursor = Cursor;

});

ace.define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var event = acequire("./lib/event");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var MAX_SCROLL_H = 0x8000;
var ScrollBar = function(parent) {
    this.element = dom.createElement("div");
    this.element.className = "ace_scrollbar ace_scrollbar" + this.classSuffix;

    this.inner = dom.createElement("div");
    this.inner.className = "ace_scrollbar-inner";
    this.element.appendChild(this.inner);

    parent.appendChild(this.element);

    this.setVisible(false);
    this.skipEvent = false;

    event.addListener(this.element, "scroll", this.onScroll.bind(this));
    event.addListener(this.element, "mousedown", event.preventDefault);
};

(function() {
    oop.implement(this, EventEmitter);

    this.setVisible = function(isVisible) {
        this.element.style.display = isVisible ? "" : "none";
        this.isVisible = isVisible;
        this.coeff = 1;
    };
}).call(ScrollBar.prototype);
var VScrollBar = function(parent, renderer) {
    ScrollBar.call(this, parent);
    this.scrollTop = 0;
    this.scrollHeight = 0;
    renderer.$scrollbarWidth = 
    this.width = dom.scrollbarWidth(parent.ownerDocument);
    this.inner.style.width =
    this.element.style.width = (this.width || 15) + 5 + "px";
    this.$minWidth = 0;
};

oop.inherits(VScrollBar, ScrollBar);

(function() {

    this.classSuffix = '-v';
    this.onScroll = function() {
        if (!this.skipEvent) {
            this.scrollTop = this.element.scrollTop;
            if (this.coeff != 1) {
                var h = this.element.clientHeight / this.scrollHeight;
                this.scrollTop = this.scrollTop * (1 - h) / (this.coeff - h);
            }
            this._emit("scroll", {data: this.scrollTop});
        }
        this.skipEvent = false;
    };
    this.getWidth = function() {
        return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
    };
    this.setHeight = function(height) {
        this.element.style.height = height + "px";
    };
    this.setInnerHeight =
    this.setScrollHeight = function(height) {
        this.scrollHeight = height;
        if (height > MAX_SCROLL_H) {
            this.coeff = MAX_SCROLL_H / height;
            height = MAX_SCROLL_H;
        } else if (this.coeff != 1) {
            this.coeff = 1;
        }
        this.inner.style.height = height + "px";
    };
    this.setScrollTop = function(scrollTop) {
        if (this.scrollTop != scrollTop) {
            this.skipEvent = true;
            this.scrollTop = scrollTop;
            this.element.scrollTop = scrollTop * this.coeff;
        }
    };

}).call(VScrollBar.prototype);
var HScrollBar = function(parent, renderer) {
    ScrollBar.call(this, parent);
    this.scrollLeft = 0;
    this.height = renderer.$scrollbarWidth;
    this.inner.style.height =
    this.element.style.height = (this.height || 15) + 5 + "px";
};

oop.inherits(HScrollBar, ScrollBar);

(function() {

    this.classSuffix = '-h';
    this.onScroll = function() {
        if (!this.skipEvent) {
            this.scrollLeft = this.element.scrollLeft;
            this._emit("scroll", {data: this.scrollLeft});
        }
        this.skipEvent = false;
    };
    this.getHeight = function() {
        return this.isVisible ? this.height : 0;
    };
    this.setWidth = function(width) {
        this.element.style.width = width + "px";
    };
    this.setInnerWidth = function(width) {
        this.inner.style.width = width + "px";
    };
    this.setScrollWidth = function(width) {
        this.inner.style.width = width + "px";
    };
    this.setScrollLeft = function(scrollLeft) {
        if (this.scrollLeft != scrollLeft) {
            this.skipEvent = true;
            this.scrollLeft = this.element.scrollLeft = scrollLeft;
        }
    };

}).call(HScrollBar.prototype);


exports.ScrollBar = VScrollBar; // backward compatibility
exports.ScrollBarV = VScrollBar; // backward compatibility
exports.ScrollBarH = HScrollBar; // backward compatibility

exports.VScrollBar = VScrollBar;
exports.HScrollBar = HScrollBar;
});

ace.define("ace/renderloop",["require","exports","module","ace/lib/event"], function(acequire, exports, module) {
"use strict";

var event = acequire("./lib/event");


var RenderLoop = function(onRender, win) {
    this.onRender = onRender;
    this.pending = false;
    this.changes = 0;
    this.window = win || window;
};

(function() {


    this.schedule = function(change) {
        this.changes = this.changes | change;
        if (!this.pending && this.changes) {
            this.pending = true;
            var _self = this;
            event.nextFrame(function() {
                _self.pending = false;
                var changes;
                while (changes = _self.changes) {
                    _self.changes = 0;
                    _self.onRender(changes);
                }
            }, this.window);
        }
    };

}).call(RenderLoop.prototype);

exports.RenderLoop = RenderLoop;
});

ace.define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"], function(acequire, exports, module) {

var oop = acequire("../lib/oop");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var useragent = acequire("../lib/useragent");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var CHAR_COUNT = 0;

var FontMetrics = exports.FontMetrics = function(parentEl) {
    this.el = dom.createElement("div");
    this.$setMeasureNodeStyles(this.el.style, true);
    
    this.$main = dom.createElement("div");
    this.$setMeasureNodeStyles(this.$main.style);
    
    this.$measureNode = dom.createElement("div");
    this.$setMeasureNodeStyles(this.$measureNode.style);
    
    
    this.el.appendChild(this.$main);
    this.el.appendChild(this.$measureNode);
    parentEl.appendChild(this.el);
    
    if (!CHAR_COUNT)
        this.$testFractionalRect();
    this.$measureNode.innerHTML = lang.stringRepeat("X", CHAR_COUNT);
    
    this.$characterSize = {width: 0, height: 0};
    this.checkForSizeChanges();
};

(function() {

    oop.implement(this, EventEmitter);
        
    this.$characterSize = {width: 0, height: 0};
    
    this.$testFractionalRect = function() {
        var el = dom.createElement("div");
        this.$setMeasureNodeStyles(el.style);
        el.style.width = "0.2px";
        document.documentElement.appendChild(el);
        var w = el.getBoundingClientRect().width;
        if (w > 0 && w < 1)
            CHAR_COUNT = 50;
        else
            CHAR_COUNT = 100;
        el.parentNode.removeChild(el);
    };
    
    this.$setMeasureNodeStyles = function(style, isRoot) {
        style.width = style.height = "auto";
        style.left = style.top = "0px";
        style.visibility = "hidden";
        style.position = "absolute";
        style.whiteSpace = "pre";

        if (useragent.isIE < 8) {
            style["font-family"] = "inherit";
        } else {
            style.font = "inherit";
        }
        style.overflow = isRoot ? "hidden" : "visible";
    };

    this.checkForSizeChanges = function() {
        var size = this.$measureSizes();
        if (size && (this.$characterSize.width !== size.width || this.$characterSize.height !== size.height)) {
            this.$measureNode.style.fontWeight = "bold";
            var boldSize = this.$measureSizes();
            this.$measureNode.style.fontWeight = "";
            this.$characterSize = size;
            this.charSizes = Object.create(null);
            this.allowBoldFonts = boldSize && boldSize.width === size.width && boldSize.height === size.height;
            this._emit("changeCharacterSize", {data: size});
        }
    };

    this.$pollSizeChanges = function() {
        if (this.$pollSizeChangesTimer)
            return this.$pollSizeChangesTimer;
        var self = this;
        return this.$pollSizeChangesTimer = setInterval(function() {
            self.checkForSizeChanges();
        }, 500);
    };
    
    this.setPolling = function(val) {
        if (val) {
            this.$pollSizeChanges();
        } else if (this.$pollSizeChangesTimer) {
            clearInterval(this.$pollSizeChangesTimer);
            this.$pollSizeChangesTimer = 0;
        }
    };

    this.$measureSizes = function() {
        if (CHAR_COUNT === 50) {
            var rect = null;
            try { 
               rect = this.$measureNode.getBoundingClientRect();
            } catch(e) {
               rect = {width: 0, height:0 };
            }
            var size = {
                height: rect.height,
                width: rect.width / CHAR_COUNT
            };
        } else {
            var size = {
                height: this.$measureNode.clientHeight,
                width: this.$measureNode.clientWidth / CHAR_COUNT
            };
        }
        if (size.width === 0 || size.height === 0)
            return null;
        return size;
    };

    this.$measureCharWidth = function(ch) {
        this.$main.innerHTML = lang.stringRepeat(ch, CHAR_COUNT);
        var rect = this.$main.getBoundingClientRect();
        return rect.width / CHAR_COUNT;
    };
    
    this.getCharacterWidth = function(ch) {
        var w = this.charSizes[ch];
        if (w === undefined) {
            w = this.charSizes[ch] = this.$measureCharWidth(ch) / this.$characterSize.width;
        }
        return w;
    };

    this.destroy = function() {
        clearInterval(this.$pollSizeChangesTimer);
        if (this.el && this.el.parentNode)
            this.el.parentNode.removeChild(this.el);
    };

}).call(FontMetrics.prototype);

});

ace.define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/config","ace/lib/useragent","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var config = acequire("./config");
var useragent = acequire("./lib/useragent");
var GutterLayer = acequire("./layer/gutter").Gutter;
var MarkerLayer = acequire("./layer/marker").Marker;
var TextLayer = acequire("./layer/text").Text;
var CursorLayer = acequire("./layer/cursor").Cursor;
var HScrollBar = acequire("./scrollbar").HScrollBar;
var VScrollBar = acequire("./scrollbar").VScrollBar;
var RenderLoop = acequire("./renderloop").RenderLoop;
var FontMetrics = acequire("./layer/font_metrics").FontMetrics;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var editorCss = ".ace_editor {\
position: relative;\
overflow: hidden;\
font: 12px/normal 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;\
direction: ltr;\
text-align: left;\
-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\
}\
.ace_scroller {\
position: absolute;\
overflow: hidden;\
top: 0;\
bottom: 0;\
background-color: inherit;\
-ms-user-select: none;\
-moz-user-select: none;\
-webkit-user-select: none;\
user-select: none;\
cursor: text;\
}\
.ace_content {\
position: absolute;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
min-width: 100%;\
}\
.ace_dragging .ace_scroller:before{\
position: absolute;\
top: 0;\
left: 0;\
right: 0;\
bottom: 0;\
content: '';\
background: rgba(250, 250, 250, 0.01);\
z-index: 1000;\
}\
.ace_dragging.ace_dark .ace_scroller:before{\
background: rgba(0, 0, 0, 0.01);\
}\
.ace_selecting, .ace_selecting * {\
cursor: text !important;\
}\
.ace_gutter {\
position: absolute;\
overflow : hidden;\
width: auto;\
top: 0;\
bottom: 0;\
left: 0;\
cursor: default;\
z-index: 4;\
-ms-user-select: none;\
-moz-user-select: none;\
-webkit-user-select: none;\
user-select: none;\
}\
.ace_gutter-active-line {\
position: absolute;\
left: 0;\
right: 0;\
}\
.ace_scroller.ace_scroll-left {\
box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\
}\
.ace_gutter-cell {\
padding-left: 19px;\
padding-right: 6px;\
background-repeat: no-repeat;\
}\
.ace_gutter-cell.ace_error {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==\");\
background-repeat: no-repeat;\
background-position: 2px center;\
}\
.ace_gutter-cell.ace_warning {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==\");\
background-position: 2px center;\
}\
.ace_gutter-cell.ace_info {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=\");\
background-position: 2px center;\
}\
.ace_dark .ace_gutter-cell.ace_info {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC\");\
}\
.ace_scrollbar {\
position: absolute;\
right: 0;\
bottom: 0;\
z-index: 6;\
}\
.ace_scrollbar-inner {\
position: absolute;\
cursor: text;\
left: 0;\
top: 0;\
}\
.ace_scrollbar-v{\
overflow-x: hidden;\
overflow-y: scroll;\
top: 0;\
}\
.ace_scrollbar-h {\
overflow-x: scroll;\
overflow-y: hidden;\
left: 0;\
}\
.ace_print-margin {\
position: absolute;\
height: 100%;\
}\
.ace_text-input {\
position: absolute;\
z-index: 0;\
width: 0.5em;\
height: 1em;\
opacity: 0;\
background: transparent;\
-moz-appearance: none;\
appearance: none;\
border: none;\
resize: none;\
outline: none;\
overflow: hidden;\
font: inherit;\
padding: 0 1px;\
margin: 0 -1px;\
text-indent: -1em;\
-ms-user-select: text;\
-moz-user-select: text;\
-webkit-user-select: text;\
user-select: text;\
white-space: pre!important;\
}\
.ace_text-input.ace_composition {\
background: inherit;\
color: inherit;\
z-index: 1000;\
opacity: 1;\
text-indent: 0;\
}\
.ace_layer {\
z-index: 1;\
position: absolute;\
overflow: hidden;\
word-wrap: normal;\
white-space: pre;\
height: 100%;\
width: 100%;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
pointer-events: none;\
}\
.ace_gutter-layer {\
position: relative;\
width: auto;\
text-align: right;\
pointer-events: auto;\
}\
.ace_text-layer {\
font: inherit !important;\
}\
.ace_cjk {\
display: inline-block;\
text-align: center;\
}\
.ace_cursor-layer {\
z-index: 4;\
}\
.ace_cursor {\
z-index: 4;\
position: absolute;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
border-left: 2px solid;\
transform: translatez(0);\
}\
.ace_multiselect .ace_cursor {\
border-left-width: 1px;\
}\
.ace_slim-cursors .ace_cursor {\
border-left-width: 1px;\
}\
.ace_overwrite-cursors .ace_cursor {\
border-left-width: 0;\
border-bottom: 1px solid;\
}\
.ace_hidden-cursors .ace_cursor {\
opacity: 0.2;\
}\
.ace_smooth-blinking .ace_cursor {\
-webkit-transition: opacity 0.18s;\
transition: opacity 0.18s;\
}\
.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\
position: absolute;\
z-index: 3;\
}\
.ace_marker-layer .ace_selection {\
position: absolute;\
z-index: 5;\
}\
.ace_marker-layer .ace_bracket {\
position: absolute;\
z-index: 6;\
}\
.ace_marker-layer .ace_active-line {\
position: absolute;\
z-index: 2;\
}\
.ace_marker-layer .ace_selected-word {\
position: absolute;\
z-index: 4;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
}\
.ace_line .ace_fold {\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
display: inline-block;\
height: 11px;\
margin-top: -2px;\
vertical-align: middle;\
background-image:\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=\");\
background-repeat: no-repeat, repeat-x;\
background-position: center center, top left;\
color: transparent;\
border: 1px solid black;\
border-radius: 2px;\
cursor: pointer;\
pointer-events: auto;\
}\
.ace_dark .ace_fold {\
}\
.ace_fold:hover{\
background-image:\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC\");\
}\
.ace_tooltip {\
background-color: #FFF;\
background-image: -webkit-linear-gradient(top, transparent, rgba(0, 0, 0, 0.1));\
background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));\
border: 1px solid gray;\
border-radius: 1px;\
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\
color: black;\
max-width: 100%;\
padding: 3px 4px;\
position: fixed;\
z-index: 999999;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
cursor: default;\
white-space: pre;\
word-wrap: break-word;\
line-height: normal;\
font-style: normal;\
font-weight: normal;\
letter-spacing: normal;\
pointer-events: none;\
}\
.ace_folding-enabled > .ace_gutter-cell {\
padding-right: 13px;\
}\
.ace_fold-widget {\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
margin: 0 -12px 0 1px;\
display: none;\
width: 11px;\
vertical-align: top;\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==\");\
background-repeat: no-repeat;\
background-position: center;\
border-radius: 3px;\
border: 1px solid transparent;\
cursor: pointer;\
}\
.ace_folding-enabled .ace_fold-widget {\
display: inline-block;   \
}\
.ace_fold-widget.ace_end {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==\");\
}\
.ace_fold-widget.ace_closed {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==\");\
}\
.ace_fold-widget:hover {\
border: 1px solid rgba(0, 0, 0, 0.3);\
background-color: rgba(255, 255, 255, 0.2);\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\
}\
.ace_fold-widget:active {\
border: 1px solid rgba(0, 0, 0, 0.4);\
background-color: rgba(0, 0, 0, 0.05);\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\
}\
.ace_dark .ace_fold-widget {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC\");\
}\
.ace_dark .ace_fold-widget.ace_end {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==\");\
}\
.ace_dark .ace_fold-widget.ace_closed {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==\");\
}\
.ace_dark .ace_fold-widget:hover {\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
background-color: rgba(255, 255, 255, 0.1);\
}\
.ace_dark .ace_fold-widget:active {\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
}\
.ace_fold-widget.ace_invalid {\
background-color: #FFB4B4;\
border-color: #DE5555;\
}\
.ace_fade-fold-widgets .ace_fold-widget {\
-webkit-transition: opacity 0.4s ease 0.05s;\
transition: opacity 0.4s ease 0.05s;\
opacity: 0;\
}\
.ace_fade-fold-widgets:hover .ace_fold-widget {\
-webkit-transition: opacity 0.05s ease 0.05s;\
transition: opacity 0.05s ease 0.05s;\
opacity:1;\
}\
.ace_underline {\
text-decoration: underline;\
}\
.ace_bold {\
font-weight: bold;\
}\
.ace_nobold .ace_bold {\
font-weight: normal;\
}\
.ace_italic {\
font-style: italic;\
}\
.ace_error-marker {\
background-color: rgba(255, 0, 0,0.2);\
position: absolute;\
z-index: 9;\
}\
.ace_highlight-marker {\
background-color: rgba(255, 255, 0,0.2);\
position: absolute;\
z-index: 8;\
}\
.ace_br1 {border-top-left-radius    : 3px;}\
.ace_br2 {border-top-right-radius   : 3px;}\
.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\
.ace_br4 {border-bottom-right-radius: 3px;}\
.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\
.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\
.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\
.ace_br8 {border-bottom-left-radius : 3px;}\
.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\
.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\
.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\
.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\
.ace_text-input-ios {\
position: absolute !important;\
top: -100000px !important;\
left: -100000px !important;\
}\
";

dom.importCssString(editorCss, "ace_editor.css");

var VirtualRenderer = function(container, theme) {
    var _self = this;

    this.container = container || dom.createElement("div");
    this.$keepTextAreaAtCursor = !useragent.isOldIE;

    dom.addCssClass(this.container, "ace_editor");

    this.setTheme(theme);

    this.$gutter = dom.createElement("div");
    this.$gutter.className = "ace_gutter";
    this.container.appendChild(this.$gutter);
    this.$gutter.setAttribute("aria-hidden", true);

    this.scroller = dom.createElement("div");
    this.scroller.className = "ace_scroller";
    this.container.appendChild(this.scroller);

    this.content = dom.createElement("div");
    this.content.className = "ace_content";
    this.scroller.appendChild(this.content);

    this.$gutterLayer = new GutterLayer(this.$gutter);
    this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this));

    this.$markerBack = new MarkerLayer(this.content);

    var textLayer = this.$textLayer = new TextLayer(this.content);
    this.canvas = textLayer.element;

    this.$markerFront = new MarkerLayer(this.content);

    this.$cursorLayer = new CursorLayer(this.content);
    this.$horizScroll = false;
    this.$vScroll = false;

    this.scrollBar = 
    this.scrollBarV = new VScrollBar(this.container, this);
    this.scrollBarH = new HScrollBar(this.container, this);
    this.scrollBarV.addEventListener("scroll", function(e) {
        if (!_self.$scrollAnimation)
            _self.session.setScrollTop(e.data - _self.scrollMargin.top);
    });
    this.scrollBarH.addEventListener("scroll", function(e) {
        if (!_self.$scrollAnimation)
            _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
    });

    this.scrollTop = 0;
    this.scrollLeft = 0;

    this.cursorPos = {
        row : 0,
        column : 0
    };

    this.$fontMetrics = new FontMetrics(this.container);
    this.$textLayer.$setFontMetrics(this.$fontMetrics);
    this.$textLayer.addEventListener("changeCharacterSize", function(e) {
        _self.updateCharacterSize();
        _self.onResize(true, _self.gutterWidth, _self.$size.width, _self.$size.height);
        _self._signal("changeCharacterSize", e);
    });

    this.$size = {
        width: 0,
        height: 0,
        scrollerHeight: 0,
        scrollerWidth: 0,
        $dirty: true
    };

    this.layerConfig = {
        width : 1,
        padding : 0,
        firstRow : 0,
        firstRowScreen: 0,
        lastRow : 0,
        lineHeight : 0,
        characterWidth : 0,
        minHeight : 1,
        maxHeight : 1,
        offset : 0,
        height : 1,
        gutterOffset: 1
    };
    
    this.scrollMargin = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        v: 0,
        h: 0
    };

    this.$loop = new RenderLoop(
        this.$renderChanges.bind(this),
        this.container.ownerDocument.defaultView
    );
    this.$loop.schedule(this.CHANGE_FULL);

    this.updateCharacterSize();
    this.setPadding(4);
    config.resetOptions(this);
    config._emit("renderer", this);
};

(function() {

    this.CHANGE_CURSOR = 1;
    this.CHANGE_MARKER = 2;
    this.CHANGE_GUTTER = 4;
    this.CHANGE_SCROLL = 8;
    this.CHANGE_LINES = 16;
    this.CHANGE_TEXT = 32;
    this.CHANGE_SIZE = 64;
    this.CHANGE_MARKER_BACK = 128;
    this.CHANGE_MARKER_FRONT = 256;
    this.CHANGE_FULL = 512;
    this.CHANGE_H_SCROLL = 1024;

    oop.implement(this, EventEmitter);

    this.updateCharacterSize = function() {
        if (this.$textLayer.allowBoldFonts != this.$allowBoldFonts) {
            this.$allowBoldFonts = this.$textLayer.allowBoldFonts;
            this.setStyle("ace_nobold", !this.$allowBoldFonts);
        }

        this.layerConfig.characterWidth =
        this.characterWidth = this.$textLayer.getCharacterWidth();
        this.layerConfig.lineHeight =
        this.lineHeight = this.$textLayer.getLineHeight();
        this.$updatePrintMargin();
    };
    this.setSession = function(session) {
        if (this.session)
            this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode);
            
        this.session = session;
        if (session && this.scrollMargin.top && session.getScrollTop() <= 0)
            session.setScrollTop(-this.scrollMargin.top);

        this.$cursorLayer.setSession(session);
        this.$markerBack.setSession(session);
        this.$markerFront.setSession(session);
        this.$gutterLayer.setSession(session);
        this.$textLayer.setSession(session);
        if (!session)
            return;
        
        this.$loop.schedule(this.CHANGE_FULL);
        this.session.$setFontMetrics(this.$fontMetrics);
        this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null;
        
        this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this);
        this.onChangeNewLineMode();
        this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode);
    };
    this.updateLines = function(firstRow, lastRow, force) {
        if (lastRow === undefined)
            lastRow = Infinity;

        if (!this.$changedLines) {
            this.$changedLines = {
                firstRow: firstRow,
                lastRow: lastRow
            };
        }
        else {
            if (this.$changedLines.firstRow > firstRow)
                this.$changedLines.firstRow = firstRow;

            if (this.$changedLines.lastRow < lastRow)
                this.$changedLines.lastRow = lastRow;
        }
        if (this.$changedLines.lastRow < this.layerConfig.firstRow) {
            if (force)
                this.$changedLines.lastRow = this.layerConfig.lastRow;
            else
                return;
        }
        if (this.$changedLines.firstRow > this.layerConfig.lastRow)
            return;
        this.$loop.schedule(this.CHANGE_LINES);
    };

    this.onChangeNewLineMode = function() {
        this.$loop.schedule(this.CHANGE_TEXT);
        this.$textLayer.$updateEolChar();
        this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);
    };
    
    this.onChangeTabSize = function() {
        this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER);
        this.$textLayer.onChangeTabSize();
    };
    this.updateText = function() {
        this.$loop.schedule(this.CHANGE_TEXT);
    };
    this.updateFull = function(force) {
        if (force)
            this.$renderChanges(this.CHANGE_FULL, true);
        else
            this.$loop.schedule(this.CHANGE_FULL);
    };
    this.updateFontSize = function() {
        this.$textLayer.checkForSizeChanges();
    };

    this.$changes = 0;
    this.$updateSizeAsync = function() {
        if (this.$loop.pending)
            this.$size.$dirty = true;
        else
            this.onResize();
    };
    this.onResize = function(force, gutterWidth, width, height) {
        if (this.resizing > 2)
            return;
        else if (this.resizing > 0)
            this.resizing++;
        else
            this.resizing = force ? 1 : 0;
        var el = this.container;
        if (!height)
            height = el.clientHeight || el.scrollHeight;
        if (!width)
            width = el.clientWidth || el.scrollWidth;
        var changes = this.$updateCachedSize(force, gutterWidth, width, height);

        
        if (!this.$size.scrollerHeight || (!width && !height))
            return this.resizing = 0;

        if (force)
            this.$gutterLayer.$padding = null;

        if (force)
            this.$renderChanges(changes | this.$changes, true);
        else
            this.$loop.schedule(changes | this.$changes);

        if (this.resizing)
            this.resizing = 0;
        this.scrollBarV.scrollLeft = this.scrollBarV.scrollTop = null;
    };
    
    this.$updateCachedSize = function(force, gutterWidth, width, height) {
        height -= (this.$extraHeight || 0);
        var changes = 0;
        var size = this.$size;
        var oldSize = {
            width: size.width,
            height: size.height,
            scrollerHeight: size.scrollerHeight,
            scrollerWidth: size.scrollerWidth
        };
        if (height && (force || size.height != height)) {
            size.height = height;
            changes |= this.CHANGE_SIZE;

            size.scrollerHeight = size.height;
            if (this.$horizScroll)
                size.scrollerHeight -= this.scrollBarH.getHeight();
            this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px";

            changes = changes | this.CHANGE_SCROLL;
        }

        if (width && (force || size.width != width)) {
            changes |= this.CHANGE_SIZE;
            size.width = width;
            
            if (gutterWidth == null)
                gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
            
            this.gutterWidth = gutterWidth;
            
            this.scrollBarH.element.style.left = 
            this.scroller.style.left = gutterWidth + "px";
            size.scrollerWidth = Math.max(0, width - gutterWidth - this.scrollBarV.getWidth());           
            
            this.scrollBarH.element.style.right = 
            this.scroller.style.right = this.scrollBarV.getWidth() + "px";
            this.scroller.style.bottom = this.scrollBarH.getHeight() + "px";

            if (this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || force)
                changes |= this.CHANGE_FULL;
        }
        
        size.$dirty = !width || !height;

        if (changes)
            this._signal("resize", oldSize);

        return changes;
    };

    this.onGutterResize = function() {
        var gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
        if (gutterWidth != this.gutterWidth)
            this.$changes |= this.$updateCachedSize(true, gutterWidth, this.$size.width, this.$size.height);

        if (this.session.getUseWrapMode() && this.adjustWrapLimit()) {
            this.$loop.schedule(this.CHANGE_FULL);
        } else if (this.$size.$dirty) {
            this.$loop.schedule(this.CHANGE_FULL);
        } else {
            this.$computeLayerConfig();
            this.$loop.schedule(this.CHANGE_MARKER);
        }
    };
    this.adjustWrapLimit = function() {
        var availableWidth = this.$size.scrollerWidth - this.$padding * 2;
        var limit = Math.floor(availableWidth / this.characterWidth);
        return this.session.adjustWrapLimit(limit, this.$showPrintMargin && this.$printMarginColumn);
    };
    this.setAnimatedScroll = function(shouldAnimate){
        this.setOption("animatedScroll", shouldAnimate);
    };
    this.getAnimatedScroll = function() {
        return this.$animatedScroll;
    };
    this.setShowInvisibles = function(showInvisibles) {
        this.setOption("showInvisibles", showInvisibles);
        this.session.$bidiHandler.setShowInvisibles(showInvisibles);
    };
    this.getShowInvisibles = function() {
        return this.getOption("showInvisibles");
    };
    this.getDisplayIndentGuides = function() {
        return this.getOption("displayIndentGuides");
    };

    this.setDisplayIndentGuides = function(display) {
        this.setOption("displayIndentGuides", display);
    };
    this.setShowPrintMargin = function(showPrintMargin) {
        this.setOption("showPrintMargin", showPrintMargin);
    };
    this.getShowPrintMargin = function() {
        return this.getOption("showPrintMargin");
    };
    this.setPrintMarginColumn = function(showPrintMargin) {
        this.setOption("printMarginColumn", showPrintMargin);
    };
    this.getPrintMarginColumn = function() {
        return this.getOption("printMarginColumn");
    };
    this.getShowGutter = function(){
        return this.getOption("showGutter");
    };
    this.setShowGutter = function(show){
        return this.setOption("showGutter", show);
    };

    this.getFadeFoldWidgets = function(){
        return this.getOption("fadeFoldWidgets");
    };

    this.setFadeFoldWidgets = function(show) {
        this.setOption("fadeFoldWidgets", show);
    };

    this.setHighlightGutterLine = function(shouldHighlight) {
        this.setOption("highlightGutterLine", shouldHighlight);
    };

    this.getHighlightGutterLine = function() {
        return this.getOption("highlightGutterLine");
    };

    this.$updateGutterLineHighlight = function() {
        var pos = this.$cursorLayer.$pixelPos;
        var height = this.layerConfig.lineHeight;
        if (this.session.getUseWrapMode()) {
            var cursor = this.session.selection.getCursor();
            cursor.column = 0;
            pos = this.$cursorLayer.getPixelPosition(cursor, true);
            height *= this.session.getRowLength(cursor.row);
        }
        this.$gutterLineHighlight.style.top = pos.top - this.layerConfig.offset + "px";
        this.$gutterLineHighlight.style.height = height + "px";
    };

    this.$updatePrintMargin = function() {
        if (!this.$showPrintMargin && !this.$printMarginEl)
            return;

        if (!this.$printMarginEl) {
            var containerEl = dom.createElement("div");
            containerEl.className = "ace_layer ace_print-margin-layer";
            this.$printMarginEl = dom.createElement("div");
            this.$printMarginEl.className = "ace_print-margin";
            containerEl.appendChild(this.$printMarginEl);
            this.content.insertBefore(containerEl, this.content.firstChild);
        }

        var style = this.$printMarginEl.style;
        style.left = ((this.characterWidth * this.$printMarginColumn) + this.$padding) + "px";
        style.visibility = this.$showPrintMargin ? "visible" : "hidden";
        
        if (this.session && this.session.$wrap == -1)
            this.adjustWrapLimit();
    };
    this.getContainerElement = function() {
        return this.container;
    };
    this.getMouseEventTarget = function() {
        return this.scroller;
    };
    this.getTextAreaContainer = function() {
        return this.container;
    };
    this.$moveTextAreaToCursor = function() {
        if (!this.$keepTextAreaAtCursor)
            return;
        var config = this.layerConfig;
        var posTop = this.$cursorLayer.$pixelPos.top;
        var posLeft = this.$cursorLayer.$pixelPos.left;
        posTop -= config.offset;

        var style = this.textarea.style;
        var h = this.lineHeight;
        if (posTop < 0 || posTop > config.height - h) {
            style.top = style.left = "0";
            return;
        }

        var w = this.characterWidth;
        if (this.$composition) {
            var val = this.textarea.value.replace(/^\x01+/, "");
            w *= (this.session.$getStringScreenWidth(val)[0]+2);
            h += 2;
        }
        posLeft -= this.scrollLeft;
        if (posLeft > this.$size.scrollerWidth - w)
            posLeft = this.$size.scrollerWidth - w;

        posLeft += this.gutterWidth;
        style.height = h + "px";
        style.width = w + "px";
        style.left = Math.min(posLeft, this.$size.scrollerWidth - w) + "px";
        style.top = Math.min(posTop, this.$size.height - h) + "px";
    };
    this.getFirstVisibleRow = function() {
        return this.layerConfig.firstRow;
    };
    this.getFirstFullyVisibleRow = function() {
        return this.layerConfig.firstRow + (this.layerConfig.offset === 0 ? 0 : 1);
    };
    this.getLastFullyVisibleRow = function() {
        var config = this.layerConfig;
        var lastRow = config.lastRow;
        var top = this.session.documentToScreenRow(lastRow, 0) * config.lineHeight;
        if (top - this.session.getScrollTop() > config.height - config.lineHeight)
            return lastRow - 1;
        return lastRow;
    };
    this.getLastVisibleRow = function() {
        return this.layerConfig.lastRow;
    };

    this.$padding = null;
    this.setPadding = function(padding) {
        this.$padding = padding;
        this.$textLayer.setPadding(padding);
        this.$cursorLayer.setPadding(padding);
        this.$markerFront.setPadding(padding);
        this.$markerBack.setPadding(padding);
        this.$loop.schedule(this.CHANGE_FULL);
        this.$updatePrintMargin();
    };
    
    this.setScrollMargin = function(top, bottom, left, right) {
        var sm = this.scrollMargin;
        sm.top = top|0;
        sm.bottom = bottom|0;
        sm.right = right|0;
        sm.left = left|0;
        sm.v = sm.top + sm.bottom;
        sm.h = sm.left + sm.right;
        if (sm.top && this.scrollTop <= 0 && this.session)
            this.session.setScrollTop(-sm.top);
        this.updateFull();
    };
    this.getHScrollBarAlwaysVisible = function() {
        return this.$hScrollBarAlwaysVisible;
    };
    this.setHScrollBarAlwaysVisible = function(alwaysVisible) {
        this.setOption("hScrollBarAlwaysVisible", alwaysVisible);
    };
    this.getVScrollBarAlwaysVisible = function() {
        return this.$vScrollBarAlwaysVisible;
    };
    this.setVScrollBarAlwaysVisible = function(alwaysVisible) {
        this.setOption("vScrollBarAlwaysVisible", alwaysVisible);
    };

    this.$updateScrollBarV = function() {
        var scrollHeight = this.layerConfig.maxHeight;
        var scrollerHeight = this.$size.scrollerHeight;
        if (!this.$maxLines && this.$scrollPastEnd) {
            scrollHeight -= (scrollerHeight - this.lineHeight) * this.$scrollPastEnd;
            if (this.scrollTop > scrollHeight - scrollerHeight) {
                scrollHeight = this.scrollTop + scrollerHeight;
                this.scrollBarV.scrollTop = null;
            }
        }
        this.scrollBarV.setScrollHeight(scrollHeight + this.scrollMargin.v);
        this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
    };
    this.$updateScrollBarH = function() {
        this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h);
        this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
    };
    
    this.$frozen = false;
    this.freeze = function() {
        this.$frozen = true;
    };
    
    this.unfreeze = function() {
        this.$frozen = false;
    };

    this.$renderChanges = function(changes, force) {
        if (this.$changes) {
            changes |= this.$changes;
            this.$changes = 0;
        }
        if ((!this.session || !this.container.offsetWidth || this.$frozen) || (!changes && !force)) {
            this.$changes |= changes;
            return; 
        } 
        if (this.$size.$dirty) {
            this.$changes |= changes;
            return this.onResize(true);
        }
        if (!this.lineHeight) {
            this.$textLayer.checkForSizeChanges();
        }
        
        this._signal("beforeRender");

        if (this.session && this.session.$bidiHandler)
            this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);

        var config = this.layerConfig;
        if (changes & this.CHANGE_FULL ||
            changes & this.CHANGE_SIZE ||
            changes & this.CHANGE_TEXT ||
            changes & this.CHANGE_LINES ||
            changes & this.CHANGE_SCROLL ||
            changes & this.CHANGE_H_SCROLL
        ) {
            changes |= this.$computeLayerConfig();
            if (config.firstRow != this.layerConfig.firstRow && config.firstRowScreen == this.layerConfig.firstRowScreen) {
                var st = this.scrollTop + (config.firstRow - this.layerConfig.firstRow) * this.lineHeight;
                if (st > 0) {
                    this.scrollTop = st;
                    changes = changes | this.CHANGE_SCROLL;
                    changes |= this.$computeLayerConfig();
                }
            }
            config = this.layerConfig;
            this.$updateScrollBarV();
            if (changes & this.CHANGE_H_SCROLL)
                this.$updateScrollBarH();
            this.$gutterLayer.element.style.marginTop = (-config.offset) + "px";
            this.content.style.marginTop = (-config.offset) + "px";
            this.content.style.width = config.width + 2 * this.$padding + "px";
            this.content.style.height = config.minHeight + "px";
        }
        if (changes & this.CHANGE_H_SCROLL) {
            this.content.style.marginLeft = -this.scrollLeft + "px";
            this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller" : "ace_scroller ace_scroll-left";
        }
        if (changes & this.CHANGE_FULL) {
            this.$textLayer.update(config);
            if (this.$showGutter)
                this.$gutterLayer.update(config);
            this.$markerBack.update(config);
            this.$markerFront.update(config);
            this.$cursorLayer.update(config);
            this.$moveTextAreaToCursor();
            this.$highlightGutterLine && this.$updateGutterLineHighlight();
            this._signal("afterRender");
            return;
        }
        if (changes & this.CHANGE_SCROLL) {
            if (changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES)
                this.$textLayer.update(config);
            else
                this.$textLayer.scrollLines(config);

            if (this.$showGutter)
                this.$gutterLayer.update(config);
            this.$markerBack.update(config);
            this.$markerFront.update(config);
            this.$cursorLayer.update(config);
            this.$highlightGutterLine && this.$updateGutterLineHighlight();
            this.$moveTextAreaToCursor();
            this._signal("afterRender");
            return;
        }

        if (changes & this.CHANGE_TEXT) {
            this.$textLayer.update(config);
            if (this.$showGutter)
                this.$gutterLayer.update(config);
        }
        else if (changes & this.CHANGE_LINES) {
            if (this.$updateLines() || (changes & this.CHANGE_GUTTER) && this.$showGutter)
                this.$gutterLayer.update(config);
        }
        else if (changes & this.CHANGE_TEXT || changes & this.CHANGE_GUTTER) {
            if (this.$showGutter)
                this.$gutterLayer.update(config);
        }

        if (changes & this.CHANGE_CURSOR) {
            this.$cursorLayer.update(config);
            this.$moveTextAreaToCursor();
            this.$highlightGutterLine && this.$updateGutterLineHighlight();
        }

        if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT)) {
            this.$markerFront.update(config);
        }

        if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK)) {
            this.$markerBack.update(config);
        }

        this._signal("afterRender");
    };

    
    this.$autosize = function() {
        var height = this.session.getScreenLength() * this.lineHeight;
        var maxHeight = this.$maxLines * this.lineHeight;
        var desiredHeight = Math.min(maxHeight,
            Math.max((this.$minLines || 1) * this.lineHeight, height)
        ) + this.scrollMargin.v + (this.$extraHeight || 0);
        if (this.$horizScroll)
            desiredHeight += this.scrollBarH.getHeight();
        if (this.$maxPixelHeight && desiredHeight > this.$maxPixelHeight)
            desiredHeight = this.$maxPixelHeight;
        var vScroll = height > maxHeight;
        
        if (desiredHeight != this.desiredHeight ||
            this.$size.height != this.desiredHeight || vScroll != this.$vScroll) {
            if (vScroll != this.$vScroll) {
                this.$vScroll = vScroll;
                this.scrollBarV.setVisible(vScroll);
            }
            
            var w = this.container.clientWidth;
            this.container.style.height = desiredHeight + "px";
            this.$updateCachedSize(true, this.$gutterWidth, w, desiredHeight);
            this.desiredHeight = desiredHeight;
            
            this._signal("autosize");
        }
    };
    
    this.$computeLayerConfig = function() {
        var session = this.session;
        var size = this.$size;
        
        var hideScrollbars = size.height <= 2 * this.lineHeight;
        var screenLines = this.session.getScreenLength();
        var maxHeight = screenLines * this.lineHeight;

        var longestLine = this.$getLongestLine();
        
        var horizScroll = !hideScrollbars && (this.$hScrollBarAlwaysVisible ||
            size.scrollerWidth - longestLine - 2 * this.$padding < 0);

        var hScrollChanged = this.$horizScroll !== horizScroll;
        if (hScrollChanged) {
            this.$horizScroll = horizScroll;
            this.scrollBarH.setVisible(horizScroll);
        }
        var vScrollBefore = this.$vScroll; // autosize can change vscroll value in which case we need to update longestLine
        if (this.$maxLines && this.lineHeight > 1)
            this.$autosize();

        var offset = this.scrollTop % this.lineHeight;
        var minHeight = size.scrollerHeight + this.lineHeight;
        
        var scrollPastEnd = !this.$maxLines && this.$scrollPastEnd
            ? (size.scrollerHeight - this.lineHeight) * this.$scrollPastEnd
            : 0;
        maxHeight += scrollPastEnd;
        
        var sm = this.scrollMargin;
        this.session.setScrollTop(Math.max(-sm.top,
            Math.min(this.scrollTop, maxHeight - size.scrollerHeight + sm.bottom)));

        this.session.setScrollLeft(Math.max(-sm.left, Math.min(this.scrollLeft, 
            longestLine + 2 * this.$padding - size.scrollerWidth + sm.right)));
        
        var vScroll = !hideScrollbars && (this.$vScrollBarAlwaysVisible ||
            size.scrollerHeight - maxHeight + scrollPastEnd < 0 || this.scrollTop > sm.top);
        var vScrollChanged = vScrollBefore !== vScroll;
        if (vScrollChanged) {
            this.$vScroll = vScroll;
            this.scrollBarV.setVisible(vScroll);
        }

        var lineCount = Math.ceil(minHeight / this.lineHeight) - 1;
        var firstRow = Math.max(0, Math.round((this.scrollTop - offset) / this.lineHeight));
        var lastRow = firstRow + lineCount;
        var firstRowScreen, firstRowHeight;
        var lineHeight = this.lineHeight;
        firstRow = session.screenToDocumentRow(firstRow, 0);
        var foldLine = session.getFoldLine(firstRow);
        if (foldLine) {
            firstRow = foldLine.start.row;
        }

        firstRowScreen = session.documentToScreenRow(firstRow, 0);
        firstRowHeight = session.getRowLength(firstRow) * lineHeight;

        lastRow = Math.min(session.screenToDocumentRow(lastRow, 0), session.getLength() - 1);
        minHeight = size.scrollerHeight + session.getRowLength(lastRow) * lineHeight +
                                                firstRowHeight;

        offset = this.scrollTop - firstRowScreen * lineHeight;

        var changes = 0;
        if (this.layerConfig.width != longestLine) 
            changes = this.CHANGE_H_SCROLL;
        if (hScrollChanged || vScrollChanged) {
            changes = this.$updateCachedSize(true, this.gutterWidth, size.width, size.height);
            this._signal("scrollbarVisibilityChanged");
            if (vScrollChanged)
                longestLine = this.$getLongestLine();
        }
        
        this.layerConfig = {
            width : longestLine,
            padding : this.$padding,
            firstRow : firstRow,
            firstRowScreen: firstRowScreen,
            lastRow : lastRow,
            lineHeight : lineHeight,
            characterWidth : this.characterWidth,
            minHeight : minHeight,
            maxHeight : maxHeight,
            offset : offset,
            gutterOffset : lineHeight ? Math.max(0, Math.ceil((offset + size.height - size.scrollerHeight) / lineHeight)) : 0,
            height : this.$size.scrollerHeight
        };

        return changes;
    };

    this.$updateLines = function() {
        if (!this.$changedLines) return;
        var firstRow = this.$changedLines.firstRow;
        var lastRow = this.$changedLines.lastRow;
        this.$changedLines = null;

        var layerConfig = this.layerConfig;

        if (firstRow > layerConfig.lastRow + 1) { return; }
        if (lastRow < layerConfig.firstRow) { return; }
        if (lastRow === Infinity) {
            if (this.$showGutter)
                this.$gutterLayer.update(layerConfig);
            this.$textLayer.update(layerConfig);
            return;
        }
        this.$textLayer.updateLines(layerConfig, firstRow, lastRow);
        return true;
    };

    this.$getLongestLine = function() {
        var charCount = this.session.getScreenWidth();
        if (this.showInvisibles && !this.session.$useWrapMode)
            charCount += 1;

        return Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(charCount * this.characterWidth));
    };
    this.updateFrontMarkers = function() {
        this.$markerFront.setMarkers(this.session.getMarkers(true));
        this.$loop.schedule(this.CHANGE_MARKER_FRONT);
    };
    this.updateBackMarkers = function() {
        this.$markerBack.setMarkers(this.session.getMarkers());
        this.$loop.schedule(this.CHANGE_MARKER_BACK);
    };
    this.addGutterDecoration = function(row, className){
        this.$gutterLayer.addGutterDecoration(row, className);
    };
    this.removeGutterDecoration = function(row, className){
        this.$gutterLayer.removeGutterDecoration(row, className);
    };
    this.updateBreakpoints = function(rows) {
        this.$loop.schedule(this.CHANGE_GUTTER);
    };
    this.setAnnotations = function(annotations) {
        this.$gutterLayer.setAnnotations(annotations);
        this.$loop.schedule(this.CHANGE_GUTTER);
    };
    this.updateCursor = function() {
        this.$loop.schedule(this.CHANGE_CURSOR);
    };
    this.hideCursor = function() {
        this.$cursorLayer.hideCursor();
    };
    this.showCursor = function() {
        this.$cursorLayer.showCursor();
    };

    this.scrollSelectionIntoView = function(anchor, lead, offset) {
        this.scrollCursorIntoView(anchor, offset);
        this.scrollCursorIntoView(lead, offset);
    };
    this.scrollCursorIntoView = function(cursor, offset, $viewMargin) {
        if (this.$size.scrollerHeight === 0)
            return;

        var pos = this.$cursorLayer.getPixelPosition(cursor);

        var left = pos.left;
        var top = pos.top;
        
        var topMargin = $viewMargin && $viewMargin.top || 0;
        var bottomMargin = $viewMargin && $viewMargin.bottom || 0;
        
        var scrollTop = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop;
        
        if (scrollTop + topMargin > top) {
            if (offset && scrollTop + topMargin > top + this.lineHeight)
                top -= offset * this.$size.scrollerHeight;
            if (top === 0)
                top = -this.scrollMargin.top;
            this.session.setScrollTop(top);
        } else if (scrollTop + this.$size.scrollerHeight - bottomMargin < top + this.lineHeight) {
            if (offset && scrollTop + this.$size.scrollerHeight - bottomMargin < top -  this.lineHeight)
                top += offset * this.$size.scrollerHeight;
            this.session.setScrollTop(top + this.lineHeight - this.$size.scrollerHeight);
        }

        var scrollLeft = this.scrollLeft;

        if (scrollLeft > left) {
            if (left < this.$padding + 2 * this.layerConfig.characterWidth)
                left = -this.scrollMargin.left;
            this.session.setScrollLeft(left);
        } else if (scrollLeft + this.$size.scrollerWidth < left + this.characterWidth) {
            this.session.setScrollLeft(Math.round(left + this.characterWidth - this.$size.scrollerWidth));
        } else if (scrollLeft <= this.$padding && left - scrollLeft < this.characterWidth) {
            this.session.setScrollLeft(0);
        }
    };
    this.getScrollTop = function() {
        return this.session.getScrollTop();
    };
    this.getScrollLeft = function() {
        return this.session.getScrollLeft();
    };
    this.getScrollTopRow = function() {
        return this.scrollTop / this.lineHeight;
    };
    this.getScrollBottomRow = function() {
        return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
    };
    this.scrollToRow = function(row) {
        this.session.setScrollTop(row * this.lineHeight);
    };

    this.alignCursor = function(cursor, alignment) {
        if (typeof cursor == "number")
            cursor = {row: cursor, column: 0};

        var pos = this.$cursorLayer.getPixelPosition(cursor);
        var h = this.$size.scrollerHeight - this.lineHeight;
        var offset = pos.top - h * (alignment || 0);

        this.session.setScrollTop(offset);
        return offset;
    };

    this.STEPS = 8;
    this.$calcSteps = function(fromValue, toValue){
        var i = 0;
        var l = this.STEPS;
        var steps = [];

        var func  = function(t, x_min, dx) {
            return dx * (Math.pow(t - 1, 3) + 1) + x_min;
        };

        for (i = 0; i < l; ++i)
            steps.push(func(i / this.STEPS, fromValue, toValue - fromValue));

        return steps;
    };
    this.scrollToLine = function(line, center, animate, callback) {
        var pos = this.$cursorLayer.getPixelPosition({row: line, column: 0});
        var offset = pos.top;
        if (center)
            offset -= this.$size.scrollerHeight / 2;

        var initialScroll = this.scrollTop;
        this.session.setScrollTop(offset);
        if (animate !== false)
            this.animateScrolling(initialScroll, callback);
    };

    this.animateScrolling = function(fromValue, callback) {
        var toValue = this.scrollTop;
        if (!this.$animatedScroll)
            return;
        var _self = this;
        
        if (fromValue == toValue)
            return;
        
        if (this.$scrollAnimation) {
            var oldSteps = this.$scrollAnimation.steps;
            if (oldSteps.length) {
                fromValue = oldSteps[0];
                if (fromValue == toValue)
                    return;
            }
        }
        
        var steps = _self.$calcSteps(fromValue, toValue);
        this.$scrollAnimation = {from: fromValue, to: toValue, steps: steps};

        clearInterval(this.$timer);

        _self.session.setScrollTop(steps.shift());
        _self.session.$scrollTop = toValue;
        this.$timer = setInterval(function() {
            if (steps.length) {
                _self.session.setScrollTop(steps.shift());
                _self.session.$scrollTop = toValue;
            } else if (toValue != null) {
                _self.session.$scrollTop = -1;
                _self.session.setScrollTop(toValue);
                toValue = null;
            } else {
                _self.$timer = clearInterval(_self.$timer);
                _self.$scrollAnimation = null;
                callback && callback();
            }
        }, 10);
    };
    this.scrollToY = function(scrollTop) {
        if (this.scrollTop !== scrollTop) {
            this.$loop.schedule(this.CHANGE_SCROLL);
            this.scrollTop = scrollTop;
        }
    };
    this.scrollToX = function(scrollLeft) {
        if (this.scrollLeft !== scrollLeft)
            this.scrollLeft = scrollLeft;
        this.$loop.schedule(this.CHANGE_H_SCROLL);
    };
    this.scrollTo = function(x, y) {
        this.session.setScrollTop(y);
        this.session.setScrollLeft(y);
    };
    this.scrollBy = function(deltaX, deltaY) {
        deltaY && this.session.setScrollTop(this.session.getScrollTop() + deltaY);
        deltaX && this.session.setScrollLeft(this.session.getScrollLeft() + deltaX);
    };
    this.isScrollableBy = function(deltaX, deltaY) {
        if (deltaY < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top)
           return true;
        if (deltaY > 0 && this.session.getScrollTop() + this.$size.scrollerHeight
            - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom)
           return true;
        if (deltaX < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left)
            return true;
        if (deltaX > 0 && this.session.getScrollLeft() + this.$size.scrollerWidth
            - this.layerConfig.width < -1 + this.scrollMargin.right)
           return true;
    };

    this.pixelToScreenCoordinates = function(x, y) {
        var canvasPos = this.scroller.getBoundingClientRect();

        var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
        var offset = offsetX / this.characterWidth;
        var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
        var col = Math.round(offset);

        return {row: row, column: col, side: offset - col > 0 ? 1 : -1, offsetX:  offsetX};
    };

    this.screenToTextCoordinates = function(x, y) {
        var canvasPos = this.scroller.getBoundingClientRect();
        var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;

        var col = Math.round(offsetX / this.characterWidth);

        var row = (y + this.scrollTop - canvasPos.top) / this.lineHeight;

        return this.session.screenToDocumentPosition(row, Math.max(col, 0), offsetX);
    };
    this.textToScreenCoordinates = function(row, column) {
        var canvasPos = this.scroller.getBoundingClientRect();
        var pos = this.session.documentToScreenPosition(row, column);

        var x = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, row)
             ? this.session.$bidiHandler.getPosLeft(pos.column)
             : Math.round(pos.column * this.characterWidth));

        var y = pos.row * this.lineHeight;

        return {
            pageX: canvasPos.left + x - this.scrollLeft,
            pageY: canvasPos.top + y - this.scrollTop
        };
    };
    this.visualizeFocus = function() {
        dom.addCssClass(this.container, "ace_focus");
    };
    this.visualizeBlur = function() {
        dom.removeCssClass(this.container, "ace_focus");
    };
    this.showComposition = function(position) {
        if (!this.$composition)
            this.$composition = {
                keepTextAreaAtCursor: this.$keepTextAreaAtCursor,
                cssText: this.textarea.style.cssText
            };

        this.$keepTextAreaAtCursor = true;
        dom.addCssClass(this.textarea, "ace_composition");
        this.textarea.style.cssText = "";
        this.$moveTextAreaToCursor();
    };
    this.setCompositionText = function(text) {
        this.$moveTextAreaToCursor();
    };
    this.hideComposition = function() {
        if (!this.$composition)
            return;

        dom.removeCssClass(this.textarea, "ace_composition");
        this.$keepTextAreaAtCursor = this.$composition.keepTextAreaAtCursor;
        this.textarea.style.cssText = this.$composition.cssText;
        this.$composition = null;
    };
    this.setTheme = function(theme, cb) {
        var _self = this;
        this.$themeId = theme;
        _self._dispatchEvent('themeChange',{theme:theme});

        if (!theme || typeof theme == "string") {
            var moduleName = theme || this.$options.theme.initialValue;
            config.loadModule(["theme", moduleName], afterLoad);
        } else {
            afterLoad(theme);
        }

        function afterLoad(module) {
            if (_self.$themeId != theme)
                return cb && cb();
            if (!module || !module.cssClass)
                throw new Error("couldn't load module " + theme + " or it didn't call define");
            dom.importCssString(
                module.cssText,
                module.cssClass,
                _self.container.ownerDocument
            );

            if (_self.theme)
                dom.removeCssClass(_self.container, _self.theme.cssClass);

            var padding = "padding" in module ? module.padding 
                : "padding" in (_self.theme || {}) ? 4 : _self.$padding;
            if (_self.$padding && padding != _self.$padding)
                _self.setPadding(padding);
            _self.$theme = module.cssClass;

            _self.theme = module;
            dom.addCssClass(_self.container, module.cssClass);
            dom.setCssClass(_self.container, "ace_dark", module.isDark);
            if (_self.$size) {
                _self.$size.width = 0;
                _self.$updateSizeAsync();
            }

            _self._dispatchEvent('themeLoaded', {theme:module});
            cb && cb();
        }
    };
    this.getTheme = function() {
        return this.$themeId;
    };
    this.setStyle = function(style, include) {
        dom.setCssClass(this.container, style, include !== false);
    };
    this.unsetStyle = function(style) {
        dom.removeCssClass(this.container, style);
    };
    
    this.setCursorStyle = function(style) {
        if (this.scroller.style.cursor != style)
            this.scroller.style.cursor = style;
    };
    this.setMouseCursor = function(cursorStyle) {
        this.scroller.style.cursor = cursorStyle;
    };
    this.destroy = function() {
        this.$textLayer.destroy();
        this.$cursorLayer.destroy();
    };

}).call(VirtualRenderer.prototype);


config.defineOptions(VirtualRenderer.prototype, "renderer", {
    animatedScroll: {initialValue: false},
    showInvisibles: {
        set: function(value) {
            if (this.$textLayer.setShowInvisibles(value))
                this.$loop.schedule(this.CHANGE_TEXT);
        },
        initialValue: false
    },
    showPrintMargin: {
        set: function() { this.$updatePrintMargin(); },
        initialValue: true
    },
    printMarginColumn: {
        set: function() { this.$updatePrintMargin(); },
        initialValue: 80
    },
    printMargin: {
        set: function(val) {
            if (typeof val == "number")
                this.$printMarginColumn = val;
            this.$showPrintMargin = !!val;
            this.$updatePrintMargin();
        },
        get: function() {
            return this.$showPrintMargin && this.$printMarginColumn; 
        }
    },
    showGutter: {
        set: function(show){
            this.$gutter.style.display = show ? "block" : "none";
            this.$loop.schedule(this.CHANGE_FULL);
            this.onGutterResize();
        },
        initialValue: true
    },
    fadeFoldWidgets: {
        set: function(show) {
            dom.setCssClass(this.$gutter, "ace_fade-fold-widgets", show);
        },
        initialValue: false
    },
    showFoldWidgets: {
        set: function(show) {this.$gutterLayer.setShowFoldWidgets(show);},
        initialValue: true
    },
    showLineNumbers: {
        set: function(show) {
            this.$gutterLayer.setShowLineNumbers(show);
            this.$loop.schedule(this.CHANGE_GUTTER);
        },
        initialValue: true
    },
    displayIndentGuides: {
        set: function(show) {
            if (this.$textLayer.setDisplayIndentGuides(show))
                this.$loop.schedule(this.CHANGE_TEXT);
        },
        initialValue: true
    },
    highlightGutterLine: {
        set: function(shouldHighlight) {
            if (!this.$gutterLineHighlight) {
                this.$gutterLineHighlight = dom.createElement("div");
                this.$gutterLineHighlight.className = "ace_gutter-active-line";
                this.$gutter.appendChild(this.$gutterLineHighlight);
                return;
            }

            this.$gutterLineHighlight.style.display = shouldHighlight ? "" : "none";
            if (this.$cursorLayer.$pixelPos)
                this.$updateGutterLineHighlight();
        },
        initialValue: false,
        value: true
    },
    hScrollBarAlwaysVisible: {
        set: function(val) {
            if (!this.$hScrollBarAlwaysVisible || !this.$horizScroll)
                this.$loop.schedule(this.CHANGE_SCROLL);
        },
        initialValue: false
    },
    vScrollBarAlwaysVisible: {
        set: function(val) {
            if (!this.$vScrollBarAlwaysVisible || !this.$vScroll)
                this.$loop.schedule(this.CHANGE_SCROLL);
        },
        initialValue: false
    },
    fontSize:  {
        set: function(size) {
            if (typeof size == "number")
                size = size + "px";
            this.container.style.fontSize = size;
            this.updateFontSize();
        },
        initialValue: 12
    },
    fontFamily: {
        set: function(name) {
            this.container.style.fontFamily = name;
            this.updateFontSize();
        }
    },
    maxLines: {
        set: function(val) {
            this.updateFull();
        }
    },
    minLines: {
        set: function(val) {
            this.updateFull();
        }
    },
    maxPixelHeight: {
        set: function(val) {
            this.updateFull();
        },
        initialValue: 0
    },
    scrollPastEnd: {
        set: function(val) {
            val = +val || 0;
            if (this.$scrollPastEnd == val)
                return;
            this.$scrollPastEnd = val;
            this.$loop.schedule(this.CHANGE_SCROLL);
        },
        initialValue: 0,
        handlesSet: true
    },
    fixedWidthGutter: {
        set: function(val) {
            this.$gutterLayer.$fixedWidth = !!val;
            this.$loop.schedule(this.CHANGE_GUTTER);
        }
    },
    theme: {
        set: function(val) { this.setTheme(val); },
        get: function() { return this.$themeId || this.theme; },
        initialValue: "./theme/textmate",
        handlesSet: true
    }
});

exports.VirtualRenderer = VirtualRenderer;
});

ace.define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var net = acequire("../lib/net");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
var config = acequire("../config");

function $workerBlob(workerUrl, mod) {
    var script = mod.src;"importScripts('" + net.qualifyURL(workerUrl) + "');";
    try {
        return new Blob([script], {"type": "application/javascript"});
    } catch (e) { // Backwards-compatibility
        var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
        var blobBuilder = new BlobBuilder();
        blobBuilder.append(script);
        return blobBuilder.getBlob("application/javascript");
    }
}

function createWorker(workerUrl, mod) {
    var blob = $workerBlob(workerUrl, mod);
    var URL = window.URL || window.webkitURL;
    var blobURL = URL.createObjectURL(blob);
    return new Worker(blobURL);
}

var WorkerClient = function(topLevelNamespaces, mod, classname, workerUrl, importScripts) {
    this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.onMessage = this.onMessage.bind(this);
    if (acequire.nameToUrl && !acequire.toUrl)
        acequire.toUrl = acequire.nameToUrl;
    
    if (config.get("packaged") || !acequire.toUrl) {
        workerUrl = workerUrl || config.moduleUrl(mod.id, "worker");
    } else {
        var normalizePath = this.$normalizePath;
        workerUrl = workerUrl || normalizePath(acequire.toUrl("ace/worker/worker.js", null, "_"));

        var tlns = {};
        topLevelNamespaces.forEach(function(ns) {
            tlns[ns] = normalizePath(acequire.toUrl(ns, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
        });
    }

    this.$worker = createWorker(workerUrl, mod);
    if (importScripts) {
        this.send("importScripts", importScripts);
    }
    this.$worker.postMessage({
        init : true,
        tlns : tlns,
        module : mod.id,
        classname : classname
    });

    this.callbackId = 1;
    this.callbacks = {};

    this.$worker.onmessage = this.onMessage;
};

(function(){

    oop.implement(this, EventEmitter);

    this.onMessage = function(e) {
        var msg = e.data;
        switch (msg.type) {
            case "event":
                this._signal(msg.name, {data: msg.data});
                break;
            case "call":
                var callback = this.callbacks[msg.id];
                if (callback) {
                    callback(msg.data);
                    delete this.callbacks[msg.id];
                }
                break;
            case "error":
                this.reportError(msg.data);
                break;
            case "log":
                window.console && console.log && console.log.apply(console, msg.data);
                break;
        }
    };
    
    this.reportError = function(err) {
        window.console && console.error && console.error(err);
    };

    this.$normalizePath = function(path) {
        return net.qualifyURL(path);
    };

    this.terminate = function() {
        this._signal("terminate", {});
        this.deltaQueue = null;
        this.$worker.terminate();
        this.$worker = null;
        if (this.$doc)
            this.$doc.off("change", this.changeListener);
        this.$doc = null;
    };

    this.send = function(cmd, args) {
        this.$worker.postMessage({command: cmd, args: args});
    };

    this.call = function(cmd, args, callback) {
        if (callback) {
            var id = this.callbackId++;
            this.callbacks[id] = callback;
            args.push(id);
        }
        this.send(cmd, args);
    };

    this.emit = function(event, data) {
        try {
            this.$worker.postMessage({event: event, data: {data: data.data}});
        }
        catch(ex) {
            console.error(ex.stack);
        }
    };

    this.attachToDocument = function(doc) {
        if (this.$doc)
            this.terminate();

        this.$doc = doc;
        this.call("setValue", [doc.getValue()]);
        doc.on("change", this.changeListener);
    };

    this.changeListener = function(delta) {
        if (!this.deltaQueue) {
            this.deltaQueue = [];
            setTimeout(this.$sendDeltaQueue, 0);
        }
        if (delta.action == "insert")
            this.deltaQueue.push(delta.start, delta.lines);
        else
            this.deltaQueue.push(delta.start, delta.end);
    };

    this.$sendDeltaQueue = function() {
        var q = this.deltaQueue;
        if (!q) return;
        this.deltaQueue = null;
        if (q.length > 50 && q.length > this.$doc.getLength() >> 1) {
            this.call("setValue", [this.$doc.getValue()]);
        } else
            this.emit("change", {data: q});
    };

}).call(WorkerClient.prototype);


var UIWorkerClient = function(topLevelNamespaces, mod, classname) {
    this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.callbackId = 1;
    this.callbacks = {};
    this.messageBuffer = [];

    var main = null;
    var emitSync = false;
    var sender = Object.create(EventEmitter);
    var _self = this;

    this.$worker = {};
    this.$worker.terminate = function() {};
    this.$worker.postMessage = function(e) {
        _self.messageBuffer.push(e);
        if (main) {
            if (emitSync)
                setTimeout(processNext);
            else
                processNext();
        }
    };
    this.setEmitSync = function(val) { emitSync = val; };

    var processNext = function() {
        var msg = _self.messageBuffer.shift();
        if (msg.command)
            main[msg.command].apply(main, msg.args);
        else if (msg.event)
            sender._signal(msg.event, msg.data);
    };

    sender.postMessage = function(msg) {
        _self.onMessage({data: msg});
    };
    sender.callback = function(data, callbackId) {
        this.postMessage({type: "call", id: callbackId, data: data});
    };
    sender.emit = function(name, data) {
        this.postMessage({type: "event", name: name, data: data});
    };

    config.loadModule(["worker", mod], function(Main) {
        main = new Main[classname](sender);
        while (_self.messageBuffer.length)
            processNext();
    });
};

UIWorkerClient.prototype = WorkerClient.prototype;

exports.UIWorkerClient = UIWorkerClient;
exports.WorkerClient = WorkerClient;
exports.createWorker = createWorker;


});

ace.define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"], function(acequire, exports, module) {
"use strict";

var Range = acequire("./range").Range;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var oop = acequire("./lib/oop");

var PlaceHolder = function(session, length, pos, others, mainClass, othersClass) {
    var _self = this;
    this.length = length;
    this.session = session;
    this.doc = session.getDocument();
    this.mainClass = mainClass;
    this.othersClass = othersClass;
    this.$onUpdate = this.onUpdate.bind(this);
    this.doc.on("change", this.$onUpdate);
    this.$others = others;
    
    this.$onCursorChange = function() {
        setTimeout(function() {
            _self.onCursorChange();
        });
    };
    
    this.$pos = pos;
    var undoStack = session.getUndoManager().$undoStack || session.getUndoManager().$undostack || {length: -1};
    this.$undoStackDepth = undoStack.length;
    this.setup();

    session.selection.on("changeCursor", this.$onCursorChange);
};

(function() {

    oop.implement(this, EventEmitter);
    this.setup = function() {
        var _self = this;
        var doc = this.doc;
        var session = this.session;
        
        this.selectionBefore = session.selection.toJSON();
        if (session.selection.inMultiSelectMode)
            session.selection.toSingleRange();

        this.pos = doc.createAnchor(this.$pos.row, this.$pos.column);
        var pos = this.pos;
        pos.$insertRight = true;
        pos.detach();
        pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + this.length), this.mainClass, null, false);
        this.others = [];
        this.$others.forEach(function(other) {
            var anchor = doc.createAnchor(other.row, other.column);
            anchor.$insertRight = true;
            anchor.detach();
            _self.others.push(anchor);
        });
        session.setUndoSelect(false);
    };
    this.showOtherMarkers = function() {
        if (this.othersActive) return;
        var session = this.session;
        var _self = this;
        this.othersActive = true;
        this.others.forEach(function(anchor) {
            anchor.markerId = session.addMarker(new Range(anchor.row, anchor.column, anchor.row, anchor.column+_self.length), _self.othersClass, null, false);
        });
    };
    this.hideOtherMarkers = function() {
        if (!this.othersActive) return;
        this.othersActive = false;
        for (var i = 0; i < this.others.length; i++) {
            this.session.removeMarker(this.others[i].markerId);
        }
    };
    this.onUpdate = function(delta) {
        if (this.$updating)
            return this.updateAnchors(delta);
            
        var range = delta;
        if (range.start.row !== range.end.row) return;
        if (range.start.row !== this.pos.row) return;
        this.$updating = true;
        var lengthDiff = delta.action === "insert" ? range.end.column - range.start.column : range.start.column - range.end.column;
        var inMainRange = range.start.column >= this.pos.column && range.start.column <= this.pos.column + this.length + 1;
        var distanceFromStart = range.start.column - this.pos.column;
        
        this.updateAnchors(delta);
        
        if (inMainRange)
            this.length += lengthDiff;

        if (inMainRange && !this.session.$fromUndo) {
            if (delta.action === 'insert') {
                for (var i = this.others.length - 1; i >= 0; i--) {
                    var otherPos = this.others[i];
                    var newPos = {row: otherPos.row, column: otherPos.column + distanceFromStart};
                    this.doc.insertMergedLines(newPos, delta.lines);
                }
            } else if (delta.action === 'remove') {
                for (var i = this.others.length - 1; i >= 0; i--) {
                    var otherPos = this.others[i];
                    var newPos = {row: otherPos.row, column: otherPos.column + distanceFromStart};
                    this.doc.remove(new Range(newPos.row, newPos.column, newPos.row, newPos.column - lengthDiff));
                }
            }
        }
        
        this.$updating = false;
        this.updateMarkers();
    };
    
    this.updateAnchors = function(delta) {
        this.pos.onChange(delta);
        for (var i = this.others.length; i--;)
            this.others[i].onChange(delta);
        this.updateMarkers();
    };
    
    this.updateMarkers = function() {
        if (this.$updating)
            return;
        var _self = this;
        var session = this.session;
        var updateMarker = function(pos, className) {
            session.removeMarker(pos.markerId);
            pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column+_self.length), className, null, false);
        };
        updateMarker(this.pos, this.mainClass);
        for (var i = this.others.length; i--;)
            updateMarker(this.others[i], this.othersClass);
    };

    this.onCursorChange = function(event) {
        if (this.$updating || !this.session) return;
        var pos = this.session.selection.getCursor();
        if (pos.row === this.pos.row && pos.column >= this.pos.column && pos.column <= this.pos.column + this.length) {
            this.showOtherMarkers();
            this._emit("cursorEnter", event);
        } else {
            this.hideOtherMarkers();
            this._emit("cursorLeave", event);
        }
    };    
    this.detach = function() {
        this.session.removeMarker(this.pos && this.pos.markerId);
        this.hideOtherMarkers();
        this.doc.removeEventListener("change", this.$onUpdate);
        this.session.selection.removeEventListener("changeCursor", this.$onCursorChange);
        this.session.setUndoSelect(true);
        this.session = null;
    };
    this.cancel = function() {
        if (this.$undoStackDepth === -1)
            return;
        var undoManager = this.session.getUndoManager();
        var undosRequired = (undoManager.$undoStack || undoManager.$undostack).length - this.$undoStackDepth;
        for (var i = 0; i < undosRequired; i++) {
            undoManager.undo(true);
        }
        if (this.selectionBefore)
            this.session.selection.fromJSON(this.selectionBefore);
    };
}).call(PlaceHolder.prototype);


exports.PlaceHolder = PlaceHolder;
});

ace.define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
function isSamePoint(p1, p2) {
    return p1.row == p2.row && p1.column == p2.column;
}

function onMouseDown(e) {
    var ev = e.domEvent;
    var alt = ev.altKey;
    var shift = ev.shiftKey;
    var ctrl = ev.ctrlKey;
    var accel = e.getAccelKey();
    var button = e.getButton();
    
    if (ctrl && useragent.isMac)
        button = ev.button;

    if (e.editor.inMultiSelectMode && button == 2) {
        e.editor.textInput.onContextMenu(e.domEvent);
        return;
    }
    
    if (!ctrl && !alt && !accel) {
        if (button === 0 && e.editor.inMultiSelectMode)
            e.editor.exitMultiSelectMode();
        return;
    }
    
    if (button !== 0)
        return;

    var editor = e.editor;
    var selection = editor.selection;
    var isMultiSelect = editor.inMultiSelectMode;
    var pos = e.getDocumentPosition();
    var cursor = selection.getCursor();
    var inSelection = e.inSelection() || (selection.isEmpty() && isSamePoint(pos, cursor));

    var mouseX = e.x, mouseY = e.y;
    var onMouseSelection = function(e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
    };
    
    var session = editor.session;
    var screenAnchor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
    var screenCursor = screenAnchor;
    
    var selectionMode;
    if (editor.$mouseHandler.$enableJumpToDef) {
        if (ctrl && alt || accel && alt)
            selectionMode = shift ? "block" : "add";
        else if (alt && editor.$blockSelectEnabled)
            selectionMode = "block";
    } else {
        if (accel && !alt) {
            selectionMode = "add";
            if (!isMultiSelect && shift)
                return;
        } else if (alt && editor.$blockSelectEnabled) {
            selectionMode = "block";
        }
    }
    
    if (selectionMode && useragent.isMac && ev.ctrlKey) {
        editor.$mouseHandler.cancelContextMenu();
    }

    if (selectionMode == "add") {
        if (!isMultiSelect && inSelection)
            return; // dragging

        if (!isMultiSelect) {
            var range = selection.toOrientedRange();
            editor.addSelectionMarker(range);
        }

        var oldRange = selection.rangeList.rangeAtPoint(pos);
        
        
        editor.$blockScrolling++;
        editor.inVirtualSelectionMode = true;
        
        if (shift) {
            oldRange = null;
            range = selection.ranges[0] || range;
            editor.removeSelectionMarker(range);
        }
        editor.once("mouseup", function() {
            var tmpSel = selection.toOrientedRange();

            if (oldRange && tmpSel.isEmpty() && isSamePoint(oldRange.cursor, tmpSel.cursor))
                selection.substractPoint(tmpSel.cursor);
            else {
                if (shift) {
                    selection.substractPoint(range.cursor);
                } else if (range) {
                    editor.removeSelectionMarker(range);
                    selection.addRange(range);
                }
                selection.addRange(tmpSel);
            }
            editor.$blockScrolling--;
            editor.inVirtualSelectionMode = false;
        });

    } else if (selectionMode == "block") {
        e.stop();
        editor.inVirtualSelectionMode = true;        
        var initialRange;
        var rectSel = [];
        var blockSelect = function() {
            var newCursor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
            var cursor = session.screenToDocumentPosition(newCursor.row, newCursor.column, newCursor.offsetX);

            if (isSamePoint(screenCursor, newCursor) && isSamePoint(cursor, selection.lead))
                return;
            screenCursor = newCursor;
            
            editor.$blockScrolling++;
            editor.selection.moveToPosition(cursor);
            editor.renderer.scrollCursorIntoView();

            editor.removeSelectionMarkers(rectSel);
            rectSel = selection.rectangularRangeBlock(screenCursor, screenAnchor);
            if (editor.$mouseHandler.$clickSelection && rectSel.length == 1 && rectSel[0].isEmpty())
                rectSel[0] = editor.$mouseHandler.$clickSelection.clone();
            rectSel.forEach(editor.addSelectionMarker, editor);
            editor.updateSelectionMarkers();
            editor.$blockScrolling--;
        };
        editor.$blockScrolling++;
        if (isMultiSelect && !accel) {
            selection.toSingleRange();
        } else if (!isMultiSelect && accel) {
            initialRange = selection.toOrientedRange();
            editor.addSelectionMarker(initialRange);
        }
        
        if (shift)
            screenAnchor = session.documentToScreenPosition(selection.lead);            
        else
            selection.moveToPosition(pos);
        editor.$blockScrolling--;
        
        screenCursor = {row: -1, column: -1};

        var onMouseSelectionEnd = function(e) {
            clearInterval(timerId);
            editor.removeSelectionMarkers(rectSel);
            if (!rectSel.length)
                rectSel = [selection.toOrientedRange()];
            editor.$blockScrolling++;
            if (initialRange) {
                editor.removeSelectionMarker(initialRange);
                selection.toSingleRange(initialRange);
            }
            for (var i = 0; i < rectSel.length; i++)
                selection.addRange(rectSel[i]);
            editor.inVirtualSelectionMode = false;
            editor.$mouseHandler.$clickSelection = null;
            editor.$blockScrolling--;
        };

        var onSelectionInterval = blockSelect;

        event.capture(editor.container, onMouseSelection, onMouseSelectionEnd);
        var timerId = setInterval(function() {onSelectionInterval();}, 20);

        return e.preventDefault();
    }
}


exports.onMouseDown = onMouseDown;

});

ace.define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"], function(acequire, exports, module) {
exports.defaultCommands = [{
    name: "addCursorAbove",
    exec: function(editor) { editor.selectMoreLines(-1); },
    bindKey: {win: "Ctrl-Alt-Up", mac: "Ctrl-Alt-Up"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "addCursorBelow",
    exec: function(editor) { editor.selectMoreLines(1); },
    bindKey: {win: "Ctrl-Alt-Down", mac: "Ctrl-Alt-Down"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "addCursorAboveSkipCurrent",
    exec: function(editor) { editor.selectMoreLines(-1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Up", mac: "Ctrl-Alt-Shift-Up"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "addCursorBelowSkipCurrent",
    exec: function(editor) { editor.selectMoreLines(1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Down", mac: "Ctrl-Alt-Shift-Down"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectMoreBefore",
    exec: function(editor) { editor.selectMore(-1); },
    bindKey: {win: "Ctrl-Alt-Left", mac: "Ctrl-Alt-Left"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectMoreAfter",
    exec: function(editor) { editor.selectMore(1); },
    bindKey: {win: "Ctrl-Alt-Right", mac: "Ctrl-Alt-Right"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectNextBefore",
    exec: function(editor) { editor.selectMore(-1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Left", mac: "Ctrl-Alt-Shift-Left"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectNextAfter",
    exec: function(editor) { editor.selectMore(1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Right", mac: "Ctrl-Alt-Shift-Right"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "splitIntoLines",
    exec: function(editor) { editor.multiSelect.splitIntoLines(); },
    bindKey: {win: "Ctrl-Alt-L", mac: "Ctrl-Alt-L"},
    readOnly: true
}, {
    name: "alignCursors",
    exec: function(editor) { editor.alignCursors(); },
    bindKey: {win: "Ctrl-Alt-A", mac: "Ctrl-Alt-A"},
    scrollIntoView: "cursor"
}, {
    name: "findAll",
    exec: function(editor) { editor.findAll(); },
    bindKey: {win: "Ctrl-Alt-K", mac: "Ctrl-Alt-G"},
    scrollIntoView: "cursor",
    readOnly: true
}];
exports.multiSelectCommands = [{
    name: "singleSelection",
    bindKey: "esc",
    exec: function(editor) { editor.exitMultiSelectMode(); },
    scrollIntoView: "cursor",
    readOnly: true,
    isAvailable: function(editor) {return editor && editor.inMultiSelectMode;}
}];

var HashHandler = acequire("../keyboard/hash_handler").HashHandler;
exports.keyboardHandler = new HashHandler(exports.multiSelectCommands);

});

ace.define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"], function(acequire, exports, module) {

var RangeList = acequire("./range_list").RangeList;
var Range = acequire("./range").Range;
var Selection = acequire("./selection").Selection;
var onMouseDown = acequire("./mouse/multi_select_handler").onMouseDown;
var event = acequire("./lib/event");
var lang = acequire("./lib/lang");
var commands = acequire("./commands/multi_select_commands");
exports.commands = commands.defaultCommands.concat(commands.multiSelectCommands);
var Search = acequire("./search").Search;
var search = new Search();

function find(session, needle, dir) {
    search.$options.wrap = true;
    search.$options.needle = needle;
    search.$options.backwards = dir == -1;
    return search.find(session);
}
var EditSession = acequire("./edit_session").EditSession;
(function() {
    this.getSelectionMarkers = function() {
        return this.$selectionMarkers;
    };
}).call(EditSession.prototype);
(function() {
    this.ranges = null;
    this.rangeList = null;
    this.addRange = function(range, $blockChangeEvents) {
        if (!range)
            return;

        if (!this.inMultiSelectMode && this.rangeCount === 0) {
            var oldRange = this.toOrientedRange();
            this.rangeList.add(oldRange);
            this.rangeList.add(range);
            if (this.rangeList.ranges.length != 2) {
                this.rangeList.removeAll();
                return $blockChangeEvents || this.fromOrientedRange(range);
            }
            this.rangeList.removeAll();
            this.rangeList.add(oldRange);
            this.$onAddRange(oldRange);
        }

        if (!range.cursor)
            range.cursor = range.end;

        var removed = this.rangeList.add(range);

        this.$onAddRange(range);

        if (removed.length)
            this.$onRemoveRange(removed);

        if (this.rangeCount > 1 && !this.inMultiSelectMode) {
            this._signal("multiSelect");
            this.inMultiSelectMode = true;
            this.session.$undoSelect = false;
            this.rangeList.attach(this.session);
        }

        return $blockChangeEvents || this.fromOrientedRange(range);
    };

    this.toSingleRange = function(range) {
        range = range || this.ranges[0];
        var removed = this.rangeList.removeAll();
        if (removed.length)
            this.$onRemoveRange(removed);

        range && this.fromOrientedRange(range);
    };
    this.substractPoint = function(pos) {
        var removed = this.rangeList.substractPoint(pos);
        if (removed) {
            this.$onRemoveRange(removed);
            return removed[0];
        }
    };
    this.mergeOverlappingRanges = function() {
        var removed = this.rangeList.merge();
        if (removed.length)
            this.$onRemoveRange(removed);
        else if(this.ranges[0])
            this.fromOrientedRange(this.ranges[0]);
    };

    this.$onAddRange = function(range) {
        this.rangeCount = this.rangeList.ranges.length;
        this.ranges.unshift(range);
        this._signal("addRange", {range: range});
    };

    this.$onRemoveRange = function(removed) {
        this.rangeCount = this.rangeList.ranges.length;
        if (this.rangeCount == 1 && this.inMultiSelectMode) {
            var lastRange = this.rangeList.ranges.pop();
            removed.push(lastRange);
            this.rangeCount = 0;
        }

        for (var i = removed.length; i--; ) {
            var index = this.ranges.indexOf(removed[i]);
            this.ranges.splice(index, 1);
        }

        this._signal("removeRange", {ranges: removed});

        if (this.rangeCount === 0 && this.inMultiSelectMode) {
            this.inMultiSelectMode = false;
            this._signal("singleSelect");
            this.session.$undoSelect = true;
            this.rangeList.detach(this.session);
        }

        lastRange = lastRange || this.ranges[0];
        if (lastRange && !lastRange.isEqual(this.getRange()))
            this.fromOrientedRange(lastRange);
    };
    this.$initRangeList = function() {
        if (this.rangeList)
            return;

        this.rangeList = new RangeList();
        this.ranges = [];
        this.rangeCount = 0;
    };
    this.getAllRanges = function() {
        return this.rangeCount ? this.rangeList.ranges.concat() : [this.getRange()];
    };

    this.splitIntoLines = function () {
        if (this.rangeCount > 1) {
            var ranges = this.rangeList.ranges;
            var lastRange = ranges[ranges.length - 1];
            var range = Range.fromPoints(ranges[0].start, lastRange.end);

            this.toSingleRange();
            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
        } else {
            var range = this.getRange();
            var isBackwards = this.isBackwards();
            var startRow = range.start.row;
            var endRow = range.end.row;
            if (startRow == endRow) {
                if (isBackwards)
                    var start = range.end, end = range.start;
                else
                    var start = range.start, end = range.end;
                
                this.addRange(Range.fromPoints(end, end));
                this.addRange(Range.fromPoints(start, start));
                return;
            }

            var rectSel = [];
            var r = this.getLineRange(startRow, true);
            r.start.column = range.start.column;
            rectSel.push(r);

            for (var i = startRow + 1; i < endRow; i++)
                rectSel.push(this.getLineRange(i, true));

            r = this.getLineRange(endRow, true);
            r.end.column = range.end.column;
            rectSel.push(r);

            rectSel.forEach(this.addRange, this);
        }
    };
    this.toggleBlockSelection = function () {
        if (this.rangeCount > 1) {
            var ranges = this.rangeList.ranges;
            var lastRange = ranges[ranges.length - 1];
            var range = Range.fromPoints(ranges[0].start, lastRange.end);

            this.toSingleRange();
            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
        } else {
            var cursor = this.session.documentToScreenPosition(this.selectionLead);
            var anchor = this.session.documentToScreenPosition(this.selectionAnchor);

            var rectSel = this.rectangularRangeBlock(cursor, anchor);
            rectSel.forEach(this.addRange, this);
        }
    };
    this.rectangularRangeBlock = function(screenCursor, screenAnchor, includeEmptyLines) {
        var rectSel = [];

        var xBackwards = screenCursor.column < screenAnchor.column;
        if (xBackwards) {
            var startColumn = screenCursor.column;
            var endColumn = screenAnchor.column;
            var startOffsetX = screenCursor.offsetX;
            var endOffsetX = screenAnchor.offsetX;
        } else {
            var startColumn = screenAnchor.column;
            var endColumn = screenCursor.column;
            var startOffsetX = screenAnchor.offsetX;
            var endOffsetX = screenCursor.offsetX;
        }

        var yBackwards = screenCursor.row < screenAnchor.row;
        if (yBackwards) {
            var startRow = screenCursor.row;
            var endRow = screenAnchor.row;
        } else {
            var startRow = screenAnchor.row;
            var endRow = screenCursor.row;
        }

        if (startColumn < 0)
            startColumn = 0;
        if (startRow < 0)
            startRow = 0;

        if (startRow == endRow)
            includeEmptyLines = true;

        for (var row = startRow; row <= endRow; row++) {
            var range = Range.fromPoints(
                this.session.screenToDocumentPosition(row, startColumn, startOffsetX),
                this.session.screenToDocumentPosition(row, endColumn, endOffsetX)
            );
            if (range.isEmpty()) {
                if (docEnd && isSamePoint(range.end, docEnd))
                    break;
                var docEnd = range.end;
            }
            range.cursor = xBackwards ? range.start : range.end;
            rectSel.push(range);
        }

        if (yBackwards)
            rectSel.reverse();

        if (!includeEmptyLines) {
            var end = rectSel.length - 1;
            while (rectSel[end].isEmpty() && end > 0)
                end--;
            if (end > 0) {
                var start = 0;
                while (rectSel[start].isEmpty())
                    start++;
            }
            for (var i = end; i >= start; i--) {
                if (rectSel[i].isEmpty())
                    rectSel.splice(i, 1);
            }
        }

        return rectSel;
    };
}).call(Selection.prototype);
var Editor = acequire("./editor").Editor;
(function() {
    this.updateSelectionMarkers = function() {
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };
    this.addSelectionMarker = function(orientedRange) {
        if (!orientedRange.cursor)
            orientedRange.cursor = orientedRange.end;

        var style = this.getSelectionStyle();
        orientedRange.marker = this.session.addMarker(orientedRange, "ace_selection", style);

        this.session.$selectionMarkers.push(orientedRange);
        this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
        return orientedRange;
    };
    this.removeSelectionMarker = function(range) {
        if (!range.marker)
            return;
        this.session.removeMarker(range.marker);
        var index = this.session.$selectionMarkers.indexOf(range);
        if (index != -1)
            this.session.$selectionMarkers.splice(index, 1);
        this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
    };

    this.removeSelectionMarkers = function(ranges) {
        var markerList = this.session.$selectionMarkers;
        for (var i = ranges.length; i--; ) {
            var range = ranges[i];
            if (!range.marker)
                continue;
            this.session.removeMarker(range.marker);
            var index = markerList.indexOf(range);
            if (index != -1)
                markerList.splice(index, 1);
        }
        this.session.selectionMarkerCount = markerList.length;
    };

    this.$onAddRange = function(e) {
        this.addSelectionMarker(e.range);
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };

    this.$onRemoveRange = function(e) {
        this.removeSelectionMarkers(e.ranges);
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };

    this.$onMultiSelect = function(e) {
        if (this.inMultiSelectMode)
            return;
        this.inMultiSelectMode = true;

        this.setStyle("ace_multiselect");
        this.keyBinding.addKeyboardHandler(commands.keyboardHandler);
        this.commands.setDefaultHandler("exec", this.$onMultiSelectExec);

        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };

    this.$onSingleSelect = function(e) {
        if (this.session.multiSelect.inVirtualMode)
            return;
        this.inMultiSelectMode = false;

        this.unsetStyle("ace_multiselect");
        this.keyBinding.removeKeyboardHandler(commands.keyboardHandler);

        this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec);
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
        this._emit("changeSelection");
    };

    this.$onMultiSelectExec = function(e) {
        var command = e.command;
        var editor = e.editor;
        if (!editor.multiSelect)
            return;
        if (!command.multiSelectAction) {
            var result = command.exec(editor, e.args || {});
            editor.multiSelect.addRange(editor.multiSelect.toOrientedRange());
            editor.multiSelect.mergeOverlappingRanges();
        } else if (command.multiSelectAction == "forEach") {
            result = editor.forEachSelection(command, e.args);
        } else if (command.multiSelectAction == "forEachLine") {
            result = editor.forEachSelection(command, e.args, true);
        } else if (command.multiSelectAction == "single") {
            editor.exitMultiSelectMode();
            result = command.exec(editor, e.args || {});
        } else {
            result = command.multiSelectAction(editor, e.args || {});
        }
        return result;
    }; 
    this.forEachSelection = function(cmd, args, options) {
        if (this.inVirtualSelectionMode)
            return;
        var keepOrder = options && options.keepOrder;
        var $byLines = options == true || options && options.$byLines;
        var session = this.session;
        var selection = this.selection;
        var rangeList = selection.rangeList;
        var ranges = (keepOrder ? selection : rangeList).ranges;
        var result;
        
        if (!ranges.length)
            return cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
        
        var reg = selection._eventRegistry;
        selection._eventRegistry = {};

        var tmpSel = new Selection(session);
        this.inVirtualSelectionMode = true;
        for (var i = ranges.length; i--;) {
            if ($byLines) {
                while (i > 0 && ranges[i].start.row == ranges[i - 1].end.row)
                    i--;
            }
            tmpSel.fromOrientedRange(ranges[i]);
            tmpSel.index = i;
            this.selection = session.selection = tmpSel;
            var cmdResult = cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
            if (!result && cmdResult !== undefined)
                result = cmdResult;
            tmpSel.toOrientedRange(ranges[i]);
        }
        tmpSel.detach();

        this.selection = session.selection = selection;
        this.inVirtualSelectionMode = false;
        selection._eventRegistry = reg;
        selection.mergeOverlappingRanges();
        
        var anim = this.renderer.$scrollAnimation;
        this.onCursorChange();
        this.onSelectionChange();
        if (anim && anim.from == anim.to)
            this.renderer.animateScrolling(anim.from);
        
        return result;
    };
    this.exitMultiSelectMode = function() {
        if (!this.inMultiSelectMode || this.inVirtualSelectionMode)
            return;
        this.multiSelect.toSingleRange();
    };

    this.getSelectedText = function() {
        var text = "";
        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
            var ranges = this.multiSelect.rangeList.ranges;
            var buf = [];
            for (var i = 0; i < ranges.length; i++) {
                buf.push(this.session.getTextRange(ranges[i]));
            }
            var nl = this.session.getDocument().getNewLineCharacter();
            text = buf.join(nl);
            if (text.length == (buf.length - 1) * nl.length)
                text = "";
        } else if (!this.selection.isEmpty()) {
            text = this.session.getTextRange(this.getSelectionRange());
        }
        return text;
    };
    
    this.$checkMultiselectChange = function(e, anchor) {
        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
            var range = this.multiSelect.ranges[0];
            if (this.multiSelect.isEmpty() && anchor == this.multiSelect.anchor)
                return;
            var pos = anchor == this.multiSelect.anchor
                ? range.cursor == range.start ? range.end : range.start
                : range.cursor;
            if (pos.row != anchor.row 
                || this.session.$clipPositionToDocument(pos.row, pos.column).column != anchor.column)
                this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange());
        }
    };
    this.findAll = function(needle, options, additive) {
        options = options || {};
        options.needle = needle || options.needle;
        if (options.needle == undefined) {
            var range = this.selection.isEmpty()
                ? this.selection.getWordRange()
                : this.selection.getRange();
            options.needle = this.session.getTextRange(range);
        }    
        this.$search.set(options);
        
        var ranges = this.$search.findAll(this.session);
        if (!ranges.length)
            return 0;

        this.$blockScrolling += 1;
        var selection = this.multiSelect;

        if (!additive)
            selection.toSingleRange(ranges[0]);

        for (var i = ranges.length; i--; )
            selection.addRange(ranges[i], true);
        if (range && selection.rangeList.rangeAtPoint(range.start))
            selection.addRange(range, true);
        
        this.$blockScrolling -= 1;

        return ranges.length;
    };
    this.selectMoreLines = function(dir, skip) {
        var range = this.selection.toOrientedRange();
        var isBackwards = range.cursor == range.end;

        var screenLead = this.session.documentToScreenPosition(range.cursor);
        if (this.selection.$desiredColumn)
            screenLead.column = this.selection.$desiredColumn;

        var lead = this.session.screenToDocumentPosition(screenLead.row + dir, screenLead.column);

        if (!range.isEmpty()) {
            var screenAnchor = this.session.documentToScreenPosition(isBackwards ? range.end : range.start);
            var anchor = this.session.screenToDocumentPosition(screenAnchor.row + dir, screenAnchor.column);
        } else {
            var anchor = lead;
        }

        if (isBackwards) {
            var newRange = Range.fromPoints(lead, anchor);
            newRange.cursor = newRange.start;
        } else {
            var newRange = Range.fromPoints(anchor, lead);
            newRange.cursor = newRange.end;
        }

        newRange.desiredColumn = screenLead.column;
        if (!this.selection.inMultiSelectMode) {
            this.selection.addRange(range);
        } else {
            if (skip)
                var toRemove = range.cursor;
        }

        this.selection.addRange(newRange);
        if (toRemove)
            this.selection.substractPoint(toRemove);
    };
    this.transposeSelections = function(dir) {
        var session = this.session;
        var sel = session.multiSelect;
        var all = sel.ranges;

        for (var i = all.length; i--; ) {
            var range = all[i];
            if (range.isEmpty()) {
                var tmp = session.getWordRange(range.start.row, range.start.column);
                range.start.row = tmp.start.row;
                range.start.column = tmp.start.column;
                range.end.row = tmp.end.row;
                range.end.column = tmp.end.column;
            }
        }
        sel.mergeOverlappingRanges();

        var words = [];
        for (var i = all.length; i--; ) {
            var range = all[i];
            words.unshift(session.getTextRange(range));
        }

        if (dir < 0)
            words.unshift(words.pop());
        else
            words.push(words.shift());

        for (var i = all.length; i--; ) {
            var range = all[i];
            var tmp = range.clone();
            session.replace(range, words[i]);
            range.start.row = tmp.start.row;
            range.start.column = tmp.start.column;
        }
    };
    this.selectMore = function(dir, skip, stopAtFirst) {
        var session = this.session;
        var sel = session.multiSelect;

        var range = sel.toOrientedRange();
        if (range.isEmpty()) {
            range = session.getWordRange(range.start.row, range.start.column);
            range.cursor = dir == -1 ? range.start : range.end;
            this.multiSelect.addRange(range);
            if (stopAtFirst)
                return;
        }
        var needle = session.getTextRange(range);

        var newRange = find(session, needle, dir);
        if (newRange) {
            newRange.cursor = dir == -1 ? newRange.start : newRange.end;
            this.$blockScrolling += 1;
            this.session.unfold(newRange);
            this.multiSelect.addRange(newRange);
            this.$blockScrolling -= 1;
            this.renderer.scrollCursorIntoView(null, 0.5);
        }
        if (skip)
            this.multiSelect.substractPoint(range.cursor);
    };
    this.alignCursors = function() {
        var session = this.session;
        var sel = session.multiSelect;
        var ranges = sel.ranges;
        var row = -1;
        var sameRowRanges = ranges.filter(function(r) {
            if (r.cursor.row == row)
                return true;
            row = r.cursor.row;
        });
        
        if (!ranges.length || sameRowRanges.length == ranges.length - 1) {
            var range = this.selection.getRange();
            var fr = range.start.row, lr = range.end.row;
            var guessRange = fr == lr;
            if (guessRange) {
                var max = this.session.getLength();
                var line;
                do {
                    line = this.session.getLine(lr);
                } while (/[=:]/.test(line) && ++lr < max);
                do {
                    line = this.session.getLine(fr);
                } while (/[=:]/.test(line) && --fr > 0);
                
                if (fr < 0) fr = 0;
                if (lr >= max) lr = max - 1;
            }
            var lines = this.session.removeFullLines(fr, lr);
            lines = this.$reAlignText(lines, guessRange);
            this.session.insert({row: fr, column: 0}, lines.join("\n") + "\n");
            if (!guessRange) {
                range.start.column = 0;
                range.end.column = lines[lines.length - 1].length;
            }
            this.selection.setRange(range);
        } else {
            sameRowRanges.forEach(function(r) {
                sel.substractPoint(r.cursor);
            });

            var maxCol = 0;
            var minSpace = Infinity;
            var spaceOffsets = ranges.map(function(r) {
                var p = r.cursor;
                var line = session.getLine(p.row);
                var spaceOffset = line.substr(p.column).search(/\S/g);
                if (spaceOffset == -1)
                    spaceOffset = 0;

                if (p.column > maxCol)
                    maxCol = p.column;
                if (spaceOffset < minSpace)
                    minSpace = spaceOffset;
                return spaceOffset;
            });
            ranges.forEach(function(r, i) {
                var p = r.cursor;
                var l = maxCol - p.column;
                var d = spaceOffsets[i] - minSpace;
                if (l > d)
                    session.insert(p, lang.stringRepeat(" ", l - d));
                else
                    session.remove(new Range(p.row, p.column, p.row, p.column - l + d));

                r.start.column = r.end.column = maxCol;
                r.start.row = r.end.row = p.row;
                r.cursor = r.end;
            });
            sel.fromOrientedRange(ranges[0]);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        }
    };

    this.$reAlignText = function(lines, forceLeft) {
        var isLeftAligned = true, isRightAligned = true;
        var startW, textW, endW;

        return lines.map(function(line) {
            var m = line.match(/(\s*)(.*?)(\s*)([=:].*)/);
            if (!m)
                return [line];

            if (startW == null) {
                startW = m[1].length;
                textW = m[2].length;
                endW = m[3].length;
                return m;
            }

            if (startW + textW + endW != m[1].length + m[2].length + m[3].length)
                isRightAligned = false;
            if (startW != m[1].length)
                isLeftAligned = false;

            if (startW > m[1].length)
                startW = m[1].length;
            if (textW < m[2].length)
                textW = m[2].length;
            if (endW > m[3].length)
                endW = m[3].length;

            return m;
        }).map(forceLeft ? alignLeft :
            isLeftAligned ? isRightAligned ? alignRight : alignLeft : unAlign);

        function spaces(n) {
            return lang.stringRepeat(" ", n);
        }

        function alignLeft(m) {
            return !m[2] ? m[0] : spaces(startW) + m[2]
                + spaces(textW - m[2].length + endW)
                + m[4].replace(/^([=:])\s+/, "$1 ");
        }
        function alignRight(m) {
            return !m[2] ? m[0] : spaces(startW + textW - m[2].length) + m[2]
                + spaces(endW, " ")
                + m[4].replace(/^([=:])\s+/, "$1 ");
        }
        function unAlign(m) {
            return !m[2] ? m[0] : spaces(startW) + m[2]
                + spaces(endW)
                + m[4].replace(/^([=:])\s+/, "$1 ");
        }
    };
}).call(Editor.prototype);


function isSamePoint(p1, p2) {
    return p1.row == p2.row && p1.column == p2.column;
}
exports.onSessionChange = function(e) {
    var session = e.session;
    if (session && !session.multiSelect) {
        session.$selectionMarkers = [];
        session.selection.$initRangeList();
        session.multiSelect = session.selection;
    }
    this.multiSelect = session && session.multiSelect;

    var oldSession = e.oldSession;
    if (oldSession) {
        oldSession.multiSelect.off("addRange", this.$onAddRange);
        oldSession.multiSelect.off("removeRange", this.$onRemoveRange);
        oldSession.multiSelect.off("multiSelect", this.$onMultiSelect);
        oldSession.multiSelect.off("singleSelect", this.$onSingleSelect);
        oldSession.multiSelect.lead.off("change", this.$checkMultiselectChange);
        oldSession.multiSelect.anchor.off("change", this.$checkMultiselectChange);
    }

    if (session) {
        session.multiSelect.on("addRange", this.$onAddRange);
        session.multiSelect.on("removeRange", this.$onRemoveRange);
        session.multiSelect.on("multiSelect", this.$onMultiSelect);
        session.multiSelect.on("singleSelect", this.$onSingleSelect);
        session.multiSelect.lead.on("change", this.$checkMultiselectChange);
        session.multiSelect.anchor.on("change", this.$checkMultiselectChange);
    }

    if (session && this.inMultiSelectMode != session.selection.inMultiSelectMode) {
        if (session.selection.inMultiSelectMode)
            this.$onMultiSelect();
        else
            this.$onSingleSelect();
    }
};
function MultiSelect(editor) {
    if (editor.$multiselectOnSessionChange)
        return;
    editor.$onAddRange = editor.$onAddRange.bind(editor);
    editor.$onRemoveRange = editor.$onRemoveRange.bind(editor);
    editor.$onMultiSelect = editor.$onMultiSelect.bind(editor);
    editor.$onSingleSelect = editor.$onSingleSelect.bind(editor);
    editor.$multiselectOnSessionChange = exports.onSessionChange.bind(editor);
    editor.$checkMultiselectChange = editor.$checkMultiselectChange.bind(editor);

    editor.$multiselectOnSessionChange(editor);
    editor.on("changeSession", editor.$multiselectOnSessionChange);

    editor.on("mousedown", onMouseDown);
    editor.commands.addCommands(commands.defaultCommands);

    addAltCursorListeners(editor);
}

function addAltCursorListeners(editor){
    var el = editor.textInput.getElement();
    var altCursor = false;
    event.addListener(el, "keydown", function(e) {
        var altDown = e.keyCode == 18 && !(e.ctrlKey || e.shiftKey || e.metaKey);
        if (editor.$blockSelectEnabled && altDown) {
            if (!altCursor) {
                editor.renderer.setMouseCursor("crosshair");
                altCursor = true;
            }
        } else if (altCursor) {
            reset();
        }
    });

    event.addListener(el, "keyup", reset);
    event.addListener(el, "blur", reset);
    function reset(e) {
        if (altCursor) {
            editor.renderer.setMouseCursor("");
            altCursor = false;
        }
    }
}

exports.MultiSelect = MultiSelect;


acequire("./config").defineOptions(Editor.prototype, "editor", {
    enableMultiselect: {
        set: function(val) {
            MultiSelect(this);
            if (val) {
                this.on("changeSession", this.$multiselectOnSessionChange);
                this.on("mousedown", onMouseDown);
            } else {
                this.off("changeSession", this.$multiselectOnSessionChange);
                this.off("mousedown", onMouseDown);
            }
        },
        value: true
    },
    enableBlockSelect: {
        set: function(val) {
            this.$blockSelectEnabled = val;
        },
        value: true
    }
});



});

ace.define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../../range").Range;

var FoldMode = exports.FoldMode = function() {};

(function() {

    this.foldingStartMarker = null;
    this.foldingStopMarker = null;
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
        if (this.foldingStartMarker.test(line))
            return "start";
        if (foldStyle == "markbeginend"
                && this.foldingStopMarker
                && this.foldingStopMarker.test(line))
            return "end";
        return "";
    };

    this.getFoldWidgetRange = function(session, foldStyle, row) {
        return null;
    };

    this.indentationBlock = function(session, row, column) {
        var re = /\S/;
        var line = session.getLine(row);
        var startLevel = line.search(re);
        if (startLevel == -1)
            return;

        var startColumn = column || line.length;
        var maxRow = session.getLength();
        var startRow = row;
        var endRow = row;

        while (++row < maxRow) {
            var level = session.getLine(row).search(re);

            if (level == -1)
                continue;

            if (level <= startLevel)
                break;

            endRow = row;
        }

        if (endRow > startRow) {
            var endColumn = session.getLine(endRow).length;
            return new Range(startRow, startColumn, endRow, endColumn);
        }
    };

    this.openingBracketBlock = function(session, bracket, row, column, typeRe) {
        var start = {row: row, column: column + 1};
        var end = session.$findClosingBracket(bracket, start, typeRe);
        if (!end)
            return;

        var fw = session.foldWidgets[end.row];
        if (fw == null)
            fw = session.getFoldWidget(end.row);

        if (fw == "start" && end.row > start.row) {
            end.row --;
            end.column = session.getLine(end.row).length;
        }
        return Range.fromPoints(start, end);
    };

    this.closingBracketBlock = function(session, bracket, row, column, typeRe) {
        var end = {row: row, column: column};
        var start = session.$findOpeningBracket(bracket, end);

        if (!start)
            return;

        start.column++;
        end.column--;

        return  Range.fromPoints(start, end);
    };
}).call(FoldMode.prototype);

});

ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

exports.isDark = false;
exports.cssClass = "ace-tm";
exports.cssText = ".ace-tm .ace_gutter {\
background: #f0f0f0;\
color: #333;\
}\
.ace-tm .ace_print-margin {\
width: 1px;\
background: #e8e8e8;\
}\
.ace-tm .ace_fold {\
background-color: #6B72E6;\
}\
.ace-tm {\
background-color: #FFFFFF;\
color: black;\
}\
.ace-tm .ace_cursor {\
color: black;\
}\
.ace-tm .ace_invisible {\
color: rgb(191, 191, 191);\
}\
.ace-tm .ace_storage,\
.ace-tm .ace_keyword {\
color: blue;\
}\
.ace-tm .ace_constant {\
color: rgb(197, 6, 11);\
}\
.ace-tm .ace_constant.ace_buildin {\
color: rgb(88, 72, 246);\
}\
.ace-tm .ace_constant.ace_language {\
color: rgb(88, 92, 246);\
}\
.ace-tm .ace_constant.ace_library {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_invalid {\
background-color: rgba(255, 0, 0, 0.1);\
color: red;\
}\
.ace-tm .ace_support.ace_function {\
color: rgb(60, 76, 114);\
}\
.ace-tm .ace_support.ace_constant {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_support.ace_type,\
.ace-tm .ace_support.ace_class {\
color: rgb(109, 121, 222);\
}\
.ace-tm .ace_keyword.ace_operator {\
color: rgb(104, 118, 135);\
}\
.ace-tm .ace_string {\
color: rgb(3, 106, 7);\
}\
.ace-tm .ace_comment {\
color: rgb(76, 136, 107);\
}\
.ace-tm .ace_comment.ace_doc {\
color: rgb(0, 102, 255);\
}\
.ace-tm .ace_comment.ace_doc.ace_tag {\
color: rgb(128, 159, 191);\
}\
.ace-tm .ace_constant.ace_numeric {\
color: rgb(0, 0, 205);\
}\
.ace-tm .ace_variable {\
color: rgb(49, 132, 149);\
}\
.ace-tm .ace_xml-pe {\
color: rgb(104, 104, 91);\
}\
.ace-tm .ace_entity.ace_name.ace_function {\
color: #0000A2;\
}\
.ace-tm .ace_heading {\
color: rgb(12, 7, 255);\
}\
.ace-tm .ace_list {\
color:rgb(185, 6, 144);\
}\
.ace-tm .ace_meta.ace_tag {\
color:rgb(0, 22, 142);\
}\
.ace-tm .ace_string.ace_regex {\
color: rgb(255, 0, 0)\
}\
.ace-tm .ace_marker-layer .ace_selection {\
background: rgb(181, 213, 255);\
}\
.ace-tm.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px white;\
}\
.ace-tm .ace_marker-layer .ace_step {\
background: rgb(252, 255, 0);\
}\
.ace-tm .ace_marker-layer .ace_stack {\
background: rgb(164, 229, 101);\
}\
.ace-tm .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgb(192, 192, 192);\
}\
.ace-tm .ace_marker-layer .ace_active-line {\
background: rgba(0, 0, 0, 0.07);\
}\
.ace-tm .ace_gutter-active-line {\
background-color : #dcdcdc;\
}\
.ace-tm .ace_marker-layer .ace_selected-word {\
background: rgb(250, 250, 255);\
border: 1px solid rgb(200, 200, 250);\
}\
.ace-tm .ace_indent-guide {\
background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
}\
";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});

ace.define("ace/line_widgets",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/range"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var Range = acequire("./range").Range;


function LineWidgets(session) {
    this.session = session;
    this.session.widgetManager = this;
    this.session.getRowLength = this.getRowLength;
    this.session.$getWidgetScreenLength = this.$getWidgetScreenLength;
    this.updateOnChange = this.updateOnChange.bind(this);
    this.renderWidgets = this.renderWidgets.bind(this);
    this.measureWidgets = this.measureWidgets.bind(this);
    this.session._changedWidgets = [];
    this.$onChangeEditor = this.$onChangeEditor.bind(this);
    
    this.session.on("change", this.updateOnChange);
    this.session.on("changeFold", this.updateOnFold);
    this.session.on("changeEditor", this.$onChangeEditor);
}

(function() {
    this.getRowLength = function(row) {
        var h;
        if (this.lineWidgets)
            h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
        else 
            h = 0;
        if (!this.$useWrapMode || !this.$wrapData[row]) {
            return 1 + h;
        } else {
            return this.$wrapData[row].length + 1 + h;
        }
    };

    this.$getWidgetScreenLength = function() {
        var screenRows = 0;
        this.lineWidgets.forEach(function(w){
            if (w && w.rowCount && !w.hidden)
                screenRows += w.rowCount;
        });
        return screenRows;
    };    
    
    this.$onChangeEditor = function(e) {
        this.attach(e.editor);
    };
    
    this.attach = function(editor) {
        if (editor  && editor.widgetManager && editor.widgetManager != this)
            editor.widgetManager.detach();

        if (this.editor == editor)
            return;

        this.detach();
        this.editor = editor;
        
        if (editor) {
            editor.widgetManager = this;
            editor.renderer.on("beforeRender", this.measureWidgets);
            editor.renderer.on("afterRender", this.renderWidgets);
        }
    };
    this.detach = function(e) {
        var editor = this.editor;
        if (!editor)
            return;
        
        this.editor = null;
        editor.widgetManager = null;
        
        editor.renderer.off("beforeRender", this.measureWidgets);
        editor.renderer.off("afterRender", this.renderWidgets);
        var lineWidgets = this.session.lineWidgets;
        lineWidgets && lineWidgets.forEach(function(w) {
            if (w && w.el && w.el.parentNode) {
                w._inDocument = false;
                w.el.parentNode.removeChild(w.el);
            }
        });
    };

    this.updateOnFold = function(e, session) {
        var lineWidgets = session.lineWidgets;
        if (!lineWidgets || !e.action)
            return;
        var fold = e.data;
        var start = fold.start.row;
        var end = fold.end.row;
        var hide = e.action == "add";
        for (var i = start + 1; i < end; i++) {
            if (lineWidgets[i])
                lineWidgets[i].hidden = hide;
        }
        if (lineWidgets[end]) {
            if (hide) {
                if (!lineWidgets[start])
                    lineWidgets[start] = lineWidgets[end];
                else
                    lineWidgets[end].hidden = hide;
            } else {
                if (lineWidgets[start] == lineWidgets[end])
                    lineWidgets[start] = undefined;
                lineWidgets[end].hidden = hide;
            }
        }
    };
    
    this.updateOnChange = function(delta) {
        var lineWidgets = this.session.lineWidgets;
        if (!lineWidgets) return;
        
        var startRow = delta.start.row;
        var len = delta.end.row - startRow;

        if (len === 0) {
        } else if (delta.action == 'remove') {
            var removed = lineWidgets.splice(startRow + 1, len);
            removed.forEach(function(w) {
                w && this.removeLineWidget(w);
            }, this);
            this.$updateRows();
        } else {
            var args = new Array(len);
            args.unshift(startRow, 0);
            lineWidgets.splice.apply(lineWidgets, args);
            this.$updateRows();
        }
    };
    
    this.$updateRows = function() {
        var lineWidgets = this.session.lineWidgets;
        if (!lineWidgets) return;
        var noWidgets = true;
        lineWidgets.forEach(function(w, i) {
            if (w) {
                noWidgets = false;
                w.row = i;
                while (w.$oldWidget) {
                    w.$oldWidget.row = i;
                    w = w.$oldWidget;
                }
            }
        });
        if (noWidgets)
            this.session.lineWidgets = null;
    };

    this.addLineWidget = function(w) {
        if (!this.session.lineWidgets)
            this.session.lineWidgets = new Array(this.session.getLength());
        
        var old = this.session.lineWidgets[w.row];
        if (old) {
            w.$oldWidget = old;
            if (old.el && old.el.parentNode) {
                old.el.parentNode.removeChild(old.el);
                old._inDocument = false;
            }
        }
            
        this.session.lineWidgets[w.row] = w;
        
        w.session = this.session;
        
        var renderer = this.editor.renderer;
        if (w.html && !w.el) {
            w.el = dom.createElement("div");
            w.el.innerHTML = w.html;
        }
        if (w.el) {
            dom.addCssClass(w.el, "ace_lineWidgetContainer");
            w.el.style.position = "absolute";
            w.el.style.zIndex = 5;
            renderer.container.appendChild(w.el);
            w._inDocument = true;
        }
        
        if (!w.coverGutter) {
            w.el.style.zIndex = 3;
        }
        if (w.pixelHeight == null) {
            w.pixelHeight = w.el.offsetHeight;
        }
        if (w.rowCount == null) {
            w.rowCount = w.pixelHeight / renderer.layerConfig.lineHeight;
        }
        
        var fold = this.session.getFoldAt(w.row, 0);
        w.$fold = fold;
        if (fold) {
            var lineWidgets = this.session.lineWidgets;
            if (w.row == fold.end.row && !lineWidgets[fold.start.row])
                lineWidgets[fold.start.row] = w;
            else
                w.hidden = true;
        }
            
        this.session._emit("changeFold", {data:{start:{row: w.row}}});
        
        this.$updateRows();
        this.renderWidgets(null, renderer);
        this.onWidgetChanged(w);
        return w;
    };
    
    this.removeLineWidget = function(w) {
        w._inDocument = false;
        w.session = null;
        if (w.el && w.el.parentNode)
            w.el.parentNode.removeChild(w.el);
        if (w.editor && w.editor.destroy) try {
            w.editor.destroy();
        } catch(e){}
        if (this.session.lineWidgets) {
            var w1 = this.session.lineWidgets[w.row];
            if (w1 == w) {
                this.session.lineWidgets[w.row] = w.$oldWidget;
                if (w.$oldWidget)
                    this.onWidgetChanged(w.$oldWidget);
            } else {
                while (w1) {
                    if (w1.$oldWidget == w) {
                        w1.$oldWidget = w.$oldWidget;
                        break;
                    }
                    w1 = w1.$oldWidget;
                }
            }
        }
        this.session._emit("changeFold", {data:{start:{row: w.row}}});
        this.$updateRows();
    };
    
    this.getWidgetsAtRow = function(row) {
        var lineWidgets = this.session.lineWidgets;
        var w = lineWidgets && lineWidgets[row];
        var list = [];
        while (w) {
            list.push(w);
            w = w.$oldWidget;
        }
        return list;
    };
    
    this.onWidgetChanged = function(w) {
        this.session._changedWidgets.push(w);
        this.editor && this.editor.renderer.updateFull();
    };
    
    this.measureWidgets = function(e, renderer) {
        var changedWidgets = this.session._changedWidgets;
        var config = renderer.layerConfig;
        
        if (!changedWidgets || !changedWidgets.length) return;
        var min = Infinity;
        for (var i = 0; i < changedWidgets.length; i++) {
            var w = changedWidgets[i];
            if (!w || !w.el) continue;
            if (w.session != this.session) continue;
            if (!w._inDocument) {
                if (this.session.lineWidgets[w.row] != w)
                    continue;
                w._inDocument = true;
                renderer.container.appendChild(w.el);
            }
            
            w.h = w.el.offsetHeight;
            
            if (!w.fixedWidth) {
                w.w = w.el.offsetWidth;
                w.screenWidth = Math.ceil(w.w / config.characterWidth);
            }
            
            var rowCount = w.h / config.lineHeight;
            if (w.coverLine) {
                rowCount -= this.session.getRowLineCount(w.row);
                if (rowCount < 0)
                    rowCount = 0;
            }
            if (w.rowCount != rowCount) {
                w.rowCount = rowCount;
                if (w.row < min)
                    min = w.row;
            }
        }
        if (min != Infinity) {
            this.session._emit("changeFold", {data:{start:{row: min}}});
            this.session.lineWidgetWidth = null;
        }
        this.session._changedWidgets = [];
    };
    
    this.renderWidgets = function(e, renderer) {
        var config = renderer.layerConfig;
        var lineWidgets = this.session.lineWidgets;
        if (!lineWidgets)
            return;
        var first = Math.min(this.firstRow, config.firstRow);
        var last = Math.max(this.lastRow, config.lastRow, lineWidgets.length);
        
        while (first > 0 && !lineWidgets[first])
            first--;
        
        this.firstRow = config.firstRow;
        this.lastRow = config.lastRow;

        renderer.$cursorLayer.config = config;
        for (var i = first; i <= last; i++) {
            var w = lineWidgets[i];
            if (!w || !w.el) continue;
            if (w.hidden) {
                w.el.style.top = -100 - (w.pixelHeight || 0) + "px";
                continue;
            }
            if (!w._inDocument) {
                w._inDocument = true;
                renderer.container.appendChild(w.el);
            }
            var top = renderer.$cursorLayer.getPixelPosition({row: i, column:0}, true).top;
            if (!w.coverLine)
                top += config.lineHeight * this.session.getRowLineCount(w.row);
            w.el.style.top = top - config.offset + "px";
            
            var left = w.coverGutter ? 0 : renderer.gutterWidth;
            if (!w.fixedWidth)
                left -= renderer.scrollLeft;
            w.el.style.left = left + "px";
            
            if (w.fullWidth && w.screenWidth) {
                w.el.style.minWidth = config.width + 2 * config.padding + "px";
            }
            
            if (w.fixedWidth) {
                w.el.style.right = renderer.scrollBar.getWidth() + "px";
            } else {
                w.el.style.right = "";
            }
        }
    };
    
}).call(LineWidgets.prototype);


exports.LineWidgets = LineWidgets;

});

ace.define("ace/ext/error_marker",["require","exports","module","ace/line_widgets","ace/lib/dom","ace/range"], function(acequire, exports, module) {
"use strict";
var LineWidgets = acequire("../line_widgets").LineWidgets;
var dom = acequire("../lib/dom");
var Range = acequire("../range").Range;

function binarySearch(array, needle, comparator) {
    var first = 0;
    var last = array.length - 1;

    while (first <= last) {
        var mid = (first + last) >> 1;
        var c = comparator(needle, array[mid]);
        if (c > 0)
            first = mid + 1;
        else if (c < 0)
            last = mid - 1;
        else
            return mid;
    }
    return -(first + 1);
}

function findAnnotations(session, row, dir) {
    var annotations = session.getAnnotations().sort(Range.comparePoints);
    if (!annotations.length)
        return;
    
    var i = binarySearch(annotations, {row: row, column: -1}, Range.comparePoints);
    if (i < 0)
        i = -i - 1;
    
    if (i >= annotations.length)
        i = dir > 0 ? 0 : annotations.length - 1;
    else if (i === 0 && dir < 0)
        i = annotations.length - 1;
    
    var annotation = annotations[i];
    if (!annotation || !dir)
        return;

    if (annotation.row === row) {
        do {
            annotation = annotations[i += dir];
        } while (annotation && annotation.row === row);
        if (!annotation)
            return annotations.slice();
    }
    
    
    var matched = [];
    row = annotation.row;
    do {
        matched[dir < 0 ? "unshift" : "push"](annotation);
        annotation = annotations[i += dir];
    } while (annotation && annotation.row == row);
    return matched.length && matched;
}

exports.showErrorMarker = function(editor, dir) {
    var session = editor.session;
    if (!session.widgetManager) {
        session.widgetManager = new LineWidgets(session);
        session.widgetManager.attach(editor);
    }
    
    var pos = editor.getCursorPosition();
    var row = pos.row;
    var oldWidget = session.widgetManager.getWidgetsAtRow(row).filter(function(w) {
        return w.type == "errorMarker";
    })[0];
    if (oldWidget) {
        oldWidget.destroy();
    } else {
        row -= dir;
    }
    var annotations = findAnnotations(session, row, dir);
    var gutterAnno;
    if (annotations) {
        var annotation = annotations[0];
        pos.column = (annotation.pos && typeof annotation.column != "number"
            ? annotation.pos.sc
            : annotation.column) || 0;
        pos.row = annotation.row;
        gutterAnno = editor.renderer.$gutterLayer.$annotations[pos.row];
    } else if (oldWidget) {
        return;
    } else {
        gutterAnno = {
            text: ["Looks good!"],
            className: "ace_ok"
        };
    }
    editor.session.unfold(pos.row);
    editor.selection.moveToPosition(pos);
    
    var w = {
        row: pos.row, 
        fixedWidth: true,
        coverGutter: true,
        el: dom.createElement("div"),
        type: "errorMarker"
    };
    var el = w.el.appendChild(dom.createElement("div"));
    var arrow = w.el.appendChild(dom.createElement("div"));
    arrow.className = "error_widget_arrow " + gutterAnno.className;
    
    var left = editor.renderer.$cursorLayer
        .getPixelPosition(pos).left;
    arrow.style.left = left + editor.renderer.gutterWidth - 5 + "px";
    
    w.el.className = "error_widget_wrapper";
    el.className = "error_widget " + gutterAnno.className;
    el.innerHTML = gutterAnno.text.join("<br>");
    
    el.appendChild(dom.createElement("div"));
    
    var kb = function(_, hashId, keyString) {
        if (hashId === 0 && (keyString === "esc" || keyString === "return")) {
            w.destroy();
            return {command: "null"};
        }
    };
    
    w.destroy = function() {
        if (editor.$mouseHandler.isMousePressed)
            return;
        editor.keyBinding.removeKeyboardHandler(kb);
        session.widgetManager.removeLineWidget(w);
        editor.off("changeSelection", w.destroy);
        editor.off("changeSession", w.destroy);
        editor.off("mouseup", w.destroy);
        editor.off("change", w.destroy);
    };
    
    editor.keyBinding.addKeyboardHandler(kb);
    editor.on("changeSelection", w.destroy);
    editor.on("changeSession", w.destroy);
    editor.on("mouseup", w.destroy);
    editor.on("change", w.destroy);
    
    editor.session.widgetManager.addLineWidget(w);
    
    w.el.onmousedown = editor.focus.bind(editor);
    
    editor.renderer.scrollCursorIntoView(null, 0.5, {bottom: w.el.offsetHeight});
};


dom.importCssString("\
    .error_widget_wrapper {\
        background: inherit;\
        color: inherit;\
        border:none\
    }\
    .error_widget {\
        border-top: solid 2px;\
        border-bottom: solid 2px;\
        margin: 5px 0;\
        padding: 10px 40px;\
        white-space: pre-wrap;\
    }\
    .error_widget.ace_error, .error_widget_arrow.ace_error{\
        border-color: #ff5a5a\
    }\
    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\
        border-color: #F1D817\
    }\
    .error_widget.ace_info, .error_widget_arrow.ace_info{\
        border-color: #5a5a5a\
    }\
    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\
        border-color: #5aaa5a\
    }\
    .error_widget_arrow {\
        position: absolute;\
        border: solid 5px;\
        border-top-color: transparent!important;\
        border-right-color: transparent!important;\
        border-left-color: transparent!important;\
        top: -5px;\
    }\
", "");

});

ace.define("ace/ace",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/dom","ace/lib/event","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config"], function(acequire, exports, module) {
"use strict";

acequire("./lib/fixoldbrowsers");

var dom = acequire("./lib/dom");
var event = acequire("./lib/event");

var Editor = acequire("./editor").Editor;
var EditSession = acequire("./edit_session").EditSession;
var UndoManager = acequire("./undomanager").UndoManager;
var Renderer = acequire("./virtual_renderer").VirtualRenderer;
acequire("./worker/worker_client");
acequire("./keyboard/hash_handler");
acequire("./placeholder");
acequire("./multi_select");
acequire("./mode/folding/fold_mode");
acequire("./theme/textmate");
acequire("./ext/error_marker");

exports.config = acequire("./config");
exports.acequire = acequire;

if (true)
    exports.define = __webpack_require__(130);
exports.edit = function(el) {
    if (typeof el == "string") {
        var _id = el;
        el = document.getElementById(_id);
        if (!el)
            throw new Error("ace.edit can't find div #" + _id);
    }

    if (el && el.env && el.env.editor instanceof Editor)
        return el.env.editor;

    var value = "";
    if (el && /input|textarea/i.test(el.tagName)) {
        var oldNode = el;
        value = oldNode.value;
        el = dom.createElement("pre");
        oldNode.parentNode.replaceChild(el, oldNode);
    } else if (el) {
        value = dom.getInnerText(el);
        el.innerHTML = "";
    }

    var doc = exports.createEditSession(value);

    var editor = new Editor(new Renderer(el));
    editor.setSession(doc);

    var env = {
        document: doc,
        editor: editor,
        onResize: editor.resize.bind(editor, null)
    };
    if (oldNode) env.textarea = oldNode;
    event.addListener(window, "resize", env.onResize);
    editor.on("destroy", function() {
        event.removeListener(window, "resize", env.onResize);
        env.editor.container.env = null; // prevent memory leak on old ie
    });
    editor.container.env = editor.env = env;
    return editor;
};
exports.createEditSession = function(text, mode) {
    var doc = new EditSession(text, mode);
    doc.setUndoManager(new UndoManager());
    return doc;
};
exports.EditSession = EditSession;
exports.UndoManager = UndoManager;
exports.version = "1.2.9";
});
            (function() {
                ace.acequire(["ace/ace"], function(a) {
                    if (a) {
                        a.config.init(true);
                        a.define = ace.define;
                    }
                    if (!window.ace)
                        window.ace = a;
                    for (var key in a) if (a.hasOwnProperty(key))
                        window.ace[key] = a[key];
                });
            })();
        
module.exports = window.ace.acequire("ace/ace");

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34), __webpack_require__(75)(module)))

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var editorOptions = ['minLines', 'maxLines', 'readOnly', 'highlightActiveLine', 'tabSize', 'enableBasicAutocompletion', 'enableLiveAutocompletion', 'enableSnippets'];

var editorEvents = ['onChange', 'onFocus', 'onInput', 'onBlur', 'onCopy', 'onPaste', 'onSelectionChange', 'onCursorChange', 'onScroll', 'handleOptions', 'updateRef'];
var debounce = function debounce(fn, delay) {
  var timer = null;
  return function () {
    var context = this,
        args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
exports.editorOptions = editorOptions;
exports.editorEvents = editorEvents;
exports.debounce = debounce;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _brace = __webpack_require__(129);

var _brace2 = _interopRequireDefault(_brace);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(131);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(262);

var _lodash4 = _interopRequireDefault(_lodash3);

var _editorOptions = __webpack_require__(132);

__webpack_require__(263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ace$acequire = _brace2.default.acequire('ace/range'),
    Range = _ace$acequire.Range;

var _ace$acequire2 = _brace2.default.acequire('ace/split'),
    Split = _ace$acequire2.Split;

var SplitComponent = function (_Component) {
  _inherits(SplitComponent, _Component);

  function SplitComponent(props) {
    _classCallCheck(this, SplitComponent);

    var _this = _possibleConstructorReturn(this, (SplitComponent.__proto__ || Object.getPrototypeOf(SplitComponent)).call(this, props));

    _editorOptions.editorEvents.forEach(function (method) {
      _this[method] = _this[method].bind(_this);
    });
    _this.debounce = _editorOptions.debounce;
    return _this;
  }

  _createClass(SplitComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          onBeforeLoad = _props.onBeforeLoad,
          mode = _props.mode,
          focus = _props.focus,
          theme = _props.theme,
          fontSize = _props.fontSize,
          value = _props.value,
          defaultValue = _props.defaultValue,
          cursorStart = _props.cursorStart,
          showGutter = _props.showGutter,
          wrapEnabled = _props.wrapEnabled,
          showPrintMargin = _props.showPrintMargin,
          _props$scrollMargin = _props.scrollMargin,
          scrollMargin = _props$scrollMargin === undefined ? [0, 0, 0, 0] : _props$scrollMargin,
          keyboardHandler = _props.keyboardHandler,
          onLoad = _props.onLoad,
          commands = _props.commands,
          annotations = _props.annotations,
          markers = _props.markers,
          splits = _props.splits;


      this.editor = _brace2.default.edit(this.refEditor);

      if (onBeforeLoad) {
        onBeforeLoad(_brace2.default);
      }

      var editorProps = Object.keys(this.props.editorProps);

      var split = new Split(this.editor.container, 'ace/theme/' + theme, splits);
      this.editor.env.split = split;

      this.splitEditor = split.getEditor(0);
      this.split = split;
      // in a split scenario we don't want a print margin for the entire application
      this.editor.setShowPrintMargin(false);
      this.editor.renderer.setShowGutter(false);
      // get a list of possible options to avoid 'misspelled option errors'
      var availableOptions = this.splitEditor.$options;
      if (this.props.debounceChangePeriod) {
        this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
      }
      split.forEach(function (editor, index) {
        for (var i = 0; i < editorProps.length; i++) {
          editor[editorProps[i]] = _this2.props.editorProps[editorProps[i]];
        }
        var defaultValueForEditor = (0, _lodash4.default)(defaultValue, index);
        var valueForEditor = (0, _lodash4.default)(value, index, '');
        editor.session.setUndoManager(new _brace.UndoManager());
        editor.setTheme('ace/theme/' + theme);
        editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
        editor.getSession().setMode('ace/mode/' + mode);
        editor.setFontSize(fontSize);
        editor.renderer.setShowGutter(showGutter);
        editor.getSession().setUseWrapMode(wrapEnabled);
        editor.setShowPrintMargin(showPrintMargin);
        editor.on('focus', _this2.onFocus);
        editor.on('blur', _this2.onBlur);
        editor.on('input', _this2.onInput);
        editor.on('copy', _this2.onCopy);
        editor.on('paste', _this2.onPaste);
        editor.on('change', _this2.onChange);
        editor.getSession().selection.on('changeSelection', _this2.onSelectionChange);
        editor.getSession().selection.on('changeCursor', _this2.onCursorChange);
        editor.session.on('changeScrollTop', _this2.onScroll);
        editor.setValue(defaultValueForEditor === undefined ? valueForEditor : defaultValueForEditor, cursorStart);
        var newAnnotations = (0, _lodash4.default)(annotations, index, []);
        var newMarkers = (0, _lodash4.default)(markers, index, []);
        editor.getSession().setAnnotations(newAnnotations);
        if (newMarkers && newMarkers.length > 0) {
          _this2.handleMarkers(newMarkers, editor);
        }

        for (var _i = 0; _i < _editorOptions.editorOptions.length; _i++) {
          var option = _editorOptions.editorOptions[_i];
          if (availableOptions.hasOwnProperty(option)) {
            editor.setOption(option, _this2.props[option]);
          } else if (_this2.props[option]) {
            console.warn('ReaceAce: editor option ' + option + ' was activated but not found. Did you need to import a related tool or did you possibly mispell the option?');
          }
        }
        _this2.handleOptions(_this2.props, editor);

        if (Array.isArray(commands)) {
          commands.forEach(function (command) {
            if (typeof command.exec == 'string') {
              editor.commands.bindKey(command.bindKey, command.exec);
            } else {
              editor.commands.addCommand(command);
            }
          });
        }

        if (keyboardHandler) {
          editor.setKeyboardHandler('ace/keyboard/' + keyboardHandler);
        }
      });

      if (className) {
        this.refEditor.className += ' ' + className;
      }

      if (focus) {
        this.splitEditor.focus();
      }

      var sp = this.editor.env.split;
      sp.setOrientation(this.props.orientation === 'below' ? sp.BELOW : sp.BESIDE);
      sp.resize(true);
      if (onLoad) {
        onLoad(sp);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var oldProps = this.props;

      var split = this.editor.env.split;

      if (nextProps.splits !== oldProps.splits) {
        split.setSplits(nextProps.splits);
      }

      if (nextProps.orientation !== oldProps.orientation) {
        split.setOrientation(nextProps.orientation === 'below' ? split.BELOW : split.BESIDE);
      }

      split.forEach(function (editor, index) {

        if (nextProps.mode !== oldProps.mode) {
          editor.getSession().setMode('ace/mode/' + nextProps.mode);
        }
        if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
          if (nextProps.keyboardHandler) {
            editor.setKeyboardHandler('ace/keyboard/' + nextProps.keyboardHandler);
          } else {
            editor.setKeyboardHandler(null);
          }
        }
        if (nextProps.fontSize !== oldProps.fontSize) {
          editor.setFontSize(nextProps.fontSize);
        }
        if (nextProps.wrapEnabled !== oldProps.wrapEnabled) {
          editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
        }
        if (nextProps.showPrintMargin !== oldProps.showPrintMargin) {
          editor.setShowPrintMargin(nextProps.showPrintMargin);
        }
        if (nextProps.showGutter !== oldProps.showGutter) {
          editor.renderer.setShowGutter(nextProps.showGutter);
        }

        for (var i = 0; i < _editorOptions.editorOptions.length; i++) {
          var option = _editorOptions.editorOptions[i];
          if (nextProps[option] !== oldProps[option]) {
            editor.setOption(option, nextProps[option]);
          }
        }
        if (!(0, _lodash2.default)(nextProps.setOptions, oldProps.setOptions)) {
          _this3.handleOptions(nextProps, editor);
        }
        var nextValue = (0, _lodash4.default)(nextProps.value, index, '');
        if (editor.getValue() !== nextValue) {
          // editor.setValue is a synchronous function call, change event is emitted before setValue return.
          _this3.silent = true;
          var pos = editor.session.selection.toJSON();
          editor.setValue(nextValue, nextProps.cursorStart);
          editor.session.selection.fromJSON(pos);
          _this3.silent = false;
        }
        var newAnnotations = (0, _lodash4.default)(nextProps.annotations, index, []);
        var oldAnnotations = (0, _lodash4.default)(oldProps.annotations, index, []);
        if (!(0, _lodash2.default)(newAnnotations, oldAnnotations)) {
          editor.getSession().setAnnotations(newAnnotations);
        }

        var newMarkers = (0, _lodash4.default)(nextProps.markers, index, []);
        var oldMarkers = (0, _lodash4.default)(oldProps.markers, index, []);
        if (!(0, _lodash2.default)(newMarkers, oldMarkers) && Array.isArray(newMarkers)) {
          _this3.handleMarkers(newMarkers, editor);
        }
      });

      if (nextProps.className !== oldProps.className) {
        var appliedClasses = this.refEditor.className;
        var appliedClassesArray = appliedClasses.trim().split(' ');
        var oldClassesArray = oldProps.className.trim().split(' ');
        oldClassesArray.forEach(function (oldClass) {
          var index = appliedClassesArray.indexOf(oldClass);
          appliedClassesArray.splice(index, 1);
        });
        this.refEditor.className = ' ' + nextProps.className + ' ' + appliedClassesArray.join(' ');
      }

      if (nextProps.theme !== oldProps.theme) {
        split.setTheme('ace/theme/' + nextProps.theme);
      }

      if (nextProps.focus && !oldProps.focus) {
        this.splitEditor.focus();
      }
      if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) {
        this.editor.resize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.editor.destroy();
      this.editor = null;
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      if (this.props.onChange && !this.silent) {
        var value = [];
        this.editor.env.split.forEach(function (editor) {
          value.push(editor.getValue());
        });
        this.props.onChange(value, event);
      }
    }
  }, {
    key: 'onSelectionChange',
    value: function onSelectionChange(event) {
      if (this.props.onSelectionChange) {
        var value = [];
        this.editor.env.split.forEach(function (editor) {
          value.push(editor.getSelection());
        });
        this.props.onSelectionChange(value, event);
      }
    }
  }, {
    key: 'onCursorChange',
    value: function onCursorChange(event) {
      if (this.props.onCursorChange) {
        var value = [];
        this.editor.env.split.forEach(function (editor) {
          value.push(editor.getSelection());
        });
        this.props.onCursorChange(value, event);
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus(event) {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    }
  }, {
    key: 'onInput',
    value: function onInput(event) {
      if (this.props.onInput) {
        this.props.onInput(event);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(event) {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: 'onCopy',
    value: function onCopy(text) {
      if (this.props.onCopy) {
        this.props.onCopy(text);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(text) {
      if (this.props.onPaste) {
        this.props.onPaste(text);
      }
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      if (this.props.onScroll) {
        this.props.onScroll(this.editor);
      }
    }
  }, {
    key: 'handleOptions',
    value: function handleOptions(props, editor) {
      var setOptions = Object.keys(props.setOptions);
      for (var y = 0; y < setOptions.length; y++) {
        editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
      }
    }
  }, {
    key: 'handleMarkers',
    value: function handleMarkers(markers, editor) {
      // remove foreground markers
      var currentMarkers = editor.getSession().getMarkers(true);
      for (var i in currentMarkers) {
        if (currentMarkers.hasOwnProperty(i)) {
          editor.getSession().removeMarker(currentMarkers[i].id);
        }
      }
      // remove background markers
      currentMarkers = editor.getSession().getMarkers(false);
      for (var _i2 in currentMarkers) {
        if (currentMarkers.hasOwnProperty(_i2)) {
          editor.getSession().removeMarker(currentMarkers[_i2].id);
        }
      }
      // add new markers
      markers.forEach(function (_ref) {
        var startRow = _ref.startRow,
            startCol = _ref.startCol,
            endRow = _ref.endRow,
            endCol = _ref.endCol,
            className = _ref.className,
            type = _ref.type,
            _ref$inFront = _ref.inFront,
            inFront = _ref$inFront === undefined ? false : _ref$inFront;

        var range = new Range(startRow, startCol, endRow, endCol);
        editor.getSession().addMarker(range, className, type, inFront);
      });
    }
  }, {
    key: 'updateRef',
    value: function updateRef(item) {
      this.refEditor = item;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          width = _props2.width,
          height = _props2.height,
          style = _props2.style;

      var divStyle = _extends({ width: width, height: height }, style);
      return _react2.default.createElement('div', { ref: this.updateRef,
        id: name,
        style: divStyle
      });
    }
  }]);

  return SplitComponent;
}(_react.Component);

exports.default = SplitComponent;


SplitComponent.propTypes = {
  mode: _propTypes2.default.string,
  splits: _propTypes2.default.number,
  orientation: _propTypes2.default.string,
  focus: _propTypes2.default.bool,
  theme: _propTypes2.default.string,
  name: _propTypes2.default.string,
  className: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  showGutter: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onCopy: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onInput: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  value: _propTypes2.default.arrayOf(_propTypes2.default.string),
  defaultValue: _propTypes2.default.arrayOf(_propTypes2.default.string),
  debounceChangePeriod: _propTypes2.default.number,
  onLoad: _propTypes2.default.func,
  onSelectionChange: _propTypes2.default.func,
  onCursorChange: _propTypes2.default.func,
  onBeforeLoad: _propTypes2.default.func,
  minLines: _propTypes2.default.number,
  maxLines: _propTypes2.default.number,
  readOnly: _propTypes2.default.bool,
  highlightActiveLine: _propTypes2.default.bool,
  tabSize: _propTypes2.default.number,
  showPrintMargin: _propTypes2.default.bool,
  cursorStart: _propTypes2.default.number,
  editorProps: _propTypes2.default.object,
  setOptions: _propTypes2.default.object,
  style: _propTypes2.default.object,
  scrollMargin: _propTypes2.default.array,
  annotations: _propTypes2.default.array,
  markers: _propTypes2.default.array,
  keyboardHandler: _propTypes2.default.string,
  wrapEnabled: _propTypes2.default.bool,
  enableBasicAutocompletion: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
  enableLiveAutocompletion: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
  commands: _propTypes2.default.array
};

SplitComponent.defaultProps = {
  name: 'brace-editor',
  focus: false,
  orientation: 'beside',
  splits: 2,
  mode: '',
  theme: '',
  height: '500px',
  width: '500px',
  value: [],
  fontSize: 12,
  showGutter: true,
  onChange: null,
  onPaste: null,
  onLoad: null,
  onScroll: null,
  minLines: null,
  maxLines: null,
  readOnly: false,
  highlightActiveLine: true,
  showPrintMargin: true,
  tabSize: 4,
  cursorStart: 1,
  editorProps: {},
  style: {},
  scrollMargin: [0, 0, 0, 0],
  setOptions: {},
  wrapEnabled: false,
  enableBasicAutocompletion: false,
  enableLiveAutocompletion: false
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content_imgSlide_img=function(_React$Component){(0,_inherits3.default)(Content_imgSlide_img,_React$Component);function Content_imgSlide_img(){(0,_classCallCheck3.default)(this,Content_imgSlide_img);return(0,_possibleConstructorReturn3.default)(this,(Content_imgSlide_img.__proto__||(0,_getPrototypeOf2.default)(Content_imgSlide_img)).apply(this,arguments));}(0,_createClass3.default)(Content_imgSlide_img,[{key:'render',value:function render(){var _props=this.props,title=_props.title,imgSrc=_props.imgSrc,fontSize=_props.fontSize,showTitle=_props.showTitle;return _react2.default.createElement('div',{style:{padding:'0px',position:'relative',width:'230px'}},_react2.default.createElement('div',{style:{position:'relative',zIndex:1}},_react2.default.createElement('img',{alt:'',src:imgSrc,style:{width:'230px',height:'150px',verticalAlign:'middle'}})),showTitle=='1'?_react2.default.createElement('div',{style:{position:'absolute',bottom:0,zIndex:2,background:'#000',height:'30px',lineHeight:'20px',width:'100%',textAlign:'center',opacity:0.5}}):'',showTitle=='1'?_react2.default.createElement('div',{style:{position:'absolute',zIndex:3,bottom:0,color:'#fff',height:'35px',lineHeight:'35px',textAlign:'center',width:'100%',fontSize:fontSize+'px'}},title):'');}}]);return Content_imgSlide_img;}(_react2.default.Component);exports.default=Content_imgSlide_img;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addEventListener;

var _EventObject = __webpack_require__(353);

var _EventObject2 = _interopRequireDefault(_EventObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addEventListener(target, eventType, callback) {
  function wrapCallback(e) {
    var ne = new _EventObject2["default"](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    target.addEventListener(eventType, wrapCallback, false);
    return {
      remove: function remove() {
        target.removeEventListener(eventType, wrapCallback, false);
      }
    };
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjustForViewport__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getElFuturePos__ = __webpack_require__(363);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */







// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_2__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

/* harmony default export */ __webpack_exports__["a"] = (doAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(361);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(46);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(46);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(369)();
}


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LazyRenderBox, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.hiddenClassName || nextProps.visible;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          hiddenClassName = _props.hiddenClassName,
          visible = _props.visible,
          props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

      if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(props.children) > 1) {
        if (!visible && hiddenClassName) {
          props.className += ' ' + hiddenClassName;
        }
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', props);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(props.children);
    }
  }]);

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPopupClassNameFromAlign;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2) {
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = __webpack_require__(67);

var _color2 = _interopRequireDefault(_color);

var _Board = __webpack_require__(379);

var _Board2 = _interopRequireDefault(_Board);

var _Preview = __webpack_require__(380);

var _Preview2 = _interopRequireDefault(_Preview);

var _Ribbon = __webpack_require__(381);

var _Ribbon2 = _interopRequireDefault(_Ribbon);

var _Alpha = __webpack_require__(382);

var _Alpha2 = _interopRequireDefault(_Alpha);

var _Params = __webpack_require__(383);

var _Params2 = _interopRequireDefault(_Params);

var _classnames = __webpack_require__(41);

var _classnames2 = _interopRequireDefault(_classnames);

var _validationColor = __webpack_require__(385);

var _validationColor2 = _interopRequireDefault(_validationColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function noop() {}

var Panel = function (_React$Component) {
  _inherits(Panel, _React$Component);

  function Panel(props) {
    _classCallCheck(this, Panel);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var alpha = typeof props.alpha === 'undefined' ? props.defaultAlpha : Math.min(props.alpha, props.defaultAlpha);

    var color = new _color2["default"](props.color || props.defaultColor);

    _this.state = {
      color: color,
      alpha: alpha
    };
    return _this;
  }

  Panel.prototype.componentDidMount = function componentDidMount() {
    this.props.onMount(this.ref);
  };

  Panel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.color) {
      var color = new _color2["default"](nextProps.color);
      this.setState({
        color: color
      });
    }
    if (nextProps.alpha !== undefined) {
      this.setState({
        alpha: nextProps.alpha
      });
    }
  };

  /**
   * 响应 alpha 的变更
   * @param  {Number} alpha Range 0~100
   */


  /**
   * color change
   * @param  {Object}  color      tinycolor instance
   * @param  {Boolean} syncParams Sync to <Params />
   */


  Panel.prototype.render = function render() {
    var _cx,
        _this2 = this;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        enableAlpha = _props.enableAlpha;
    var _state = this.state,
        color = _state.color,
        alpha = _state.alpha;


    var wrapClasses = (0, _classnames2["default"])((_cx = {}, _defineProperty(_cx, prefixCls + '-wrap', true), _defineProperty(_cx, prefixCls + '-wrap-has-alpha', enableAlpha), _cx));

    return _react2["default"].createElement(
      'div',
      {
        ref: function ref(_ref) {
          return _this2.ref = _ref;
        },
        className: [prefixCls, this.props.className].join(' '),
        style: this.props.style,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        tabIndex: '0'
      },
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-inner' },
        _react2["default"].createElement(_Board2["default"], { rootPrefixCls: prefixCls, color: color, onChange: this.handleChange }),
        _react2["default"].createElement(
          'div',
          { className: wrapClasses },
          _react2["default"].createElement(
            'div',
            { className: prefixCls + '-wrap-ribbon' },
            _react2["default"].createElement(_Ribbon2["default"], { rootPrefixCls: prefixCls, color: color, onChange: this.handleChange })
          ),
          enableAlpha && _react2["default"].createElement(
            'div',
            { className: prefixCls + '-wrap-alpha' },
            _react2["default"].createElement(_Alpha2["default"], {
              rootPrefixCls: prefixCls,
              alpha: alpha,
              color: color,
              onChange: this.handleAlphaChange
            })
          ),
          _react2["default"].createElement(
            'div',
            { className: prefixCls + '-wrap-preview' },
            _react2["default"].createElement(_Preview2["default"], {
              rootPrefixCls: prefixCls,
              alpha: alpha,
              onChange: this.handleChange,
              onInputClick: this.onSystemColorPickerOpen,
              color: color
            })
          )
        ),
        _react2["default"].createElement(
          'div',
          { className: prefixCls + '-wrap', style: { height: 40, marginTop: 6 } },
          _react2["default"].createElement(_Params2["default"], {
            rootPrefixCls: prefixCls,
            color: color,
            alpha: alpha,
            onAlphaChange: this.handleAlphaChange,
            onChange: this.handleChange,
            mode: this.props.mode,
            enableAlpha: this.props.enableAlpha
          })
        )
      )
    );
  };

  return Panel;
}(_react2["default"].Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSystemColorPickerOpen = function (e) {
    // only work with broswer which support color input
    if (e.target.type === 'color') {
      _this3.systemColorPickerOpen = true;
    }
  };

  this.onFocus = function () {
    if (_this3._blurTimer) {
      clearTimeout(_this3._blurTimer);
      _this3._blurTimer = null;
    } else {
      _this3.props.onFocus();
    }
  };

  this.onBlur = function () {
    if (_this3._blurTimer) {
      clearTimeout(_this3._blurTimer);
    }
    _this3._blurTimer = setTimeout(function () {
      // if is system color picker open, then stop run blur
      if (_this3.systemColorPickerOpen) {
        _this3.systemColorPickerOpen = false;
        return;
      }

      _this3.props.onBlur();
    }, 100);
  };

  this.handleAlphaChange = function (alpha) {
    var color = _this3.state.color;

    color.alpha = alpha;

    _this3.setState({
      alpha: alpha,
      color: color
    });
    _this3.props.onChange({
      color: color.toHexString(),
      alpha: alpha
    });
  };

  this.handleChange = function (color) {
    var alpha = _this3.state.alpha;

    color.alpha = alpha;

    _this3.setState({ color: color });
    _this3.props.onChange({
      color: color.toHexString(),
      alpha: color.alpha
    });
  };
};

exports["default"] = Panel;


Panel.propTypes = {
  alpha: _propTypes2["default"].number,
  className: _propTypes2["default"].string,
  color: _validationColor2["default"], // Hex string
  defaultAlpha: _propTypes2["default"].number,
  defaultColor: _validationColor2["default"], // Hex string
  enableAlpha: _propTypes2["default"].bool,
  mode: _propTypes2["default"].oneOf(['RGB', 'HSL', 'HSB']),
  onBlur: _propTypes2["default"].func,
  onChange: _propTypes2["default"].func,
  onFocus: _propTypes2["default"].func,
  onMount: _propTypes2["default"].func,
  prefixCls: _propTypes2["default"].string,
  style: _propTypes2["default"].object
};

Panel.defaultProps = {
  className: '',
  defaultAlpha: 100,
  defaultColor: '#ff0000',
  enableAlpha: true,
  mode: 'RGB',
  onBlur: noop,
  onChange: noop,
  onFocus: noop,
  onMount: noop,
  prefixCls: 'rc-color-picker-panel',
  style: {}
};
module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sentinel__ = __webpack_require__(147);













var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TabPane, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          id = _props.id,
          className = _props.className,
          destroyInactiveTabPane = _props.destroyInactiveTabPane,
          active = _props.active,
          forceRender = _props.forceRender,
          rootPrefixCls = _props.rootPrefixCls,
          style = _props.style,
          children = _props.children,
          placeholder = _props.placeholder,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);

      this._isActived = this._isActived || active;
      var prefixCls = rootPrefixCls + '-tabpane';
      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-inactive', !active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-active', active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, className), _classnames));
      var isRender = destroyInactiveTabPane ? active : this._isActived;
      var shouldRender = isRender || forceRender;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__Sentinel__["a" /* SentinelConsumer */],
        null,
        function (_ref) {
          var sentinelStart = _ref.sentinelStart,
              sentinelEnd = _ref.sentinelEnd,
              setPanelSentinelStart = _ref.setPanelSentinelStart,
              setPanelSentinelEnd = _ref.setPanelSentinelEnd;

          // Create sentinel
          var panelSentinelStart = void 0;
          var panelSentinelEnd = void 0;
          if (active && shouldRender) {
            panelSentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
              setRef: setPanelSentinelStart,
              prevElement: sentinelStart
            });
            panelSentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
              setRef: setPanelSentinelEnd,
              nextElement: sentinelEnd
            });
          }

          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              style: style,
              role: 'tabpanel',
              'aria-hidden': active ? 'false' : 'true',
              className: cls,
              id: id
            }, Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getDataAttr */])(restProps)),
            panelSentinelStart,
            shouldRender ? children : placeholder,
            panelSentinelEnd
          );
        }
      );
    }
  }]);

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabPane);


TabPane.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

TabPane.defaultProps = {
  placeholder: null
};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SentinelProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentinelConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_create_react_context__);




/* eslint-disable jsx-a11y/no-noninteractive-tabindex */





var SentinelContext = __WEBPACK_IMPORTED_MODULE_7_create_react_context___default()({});
var SentinelProvider = SentinelContext.Provider;
var SentinelConsumer = SentinelContext.Consumer;

var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', position: 'absolute' };

var Sentinel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Sentinel, _React$Component);

  function Sentinel() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sentinel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Sentinel.__proto__ || Object.getPrototypeOf(Sentinel)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (_ref2) {
      var target = _ref2.target,
          which = _ref2.which,
          shiftKey = _ref2.shiftKey;
      var _this$props = _this.props,
          nextElement = _this$props.nextElement,
          prevElement = _this$props.prevElement;

      if (which !== __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB || document.activeElement !== target) return;

      // Tab next
      if (!shiftKey && nextElement) {
        nextElement.focus();
      }

      // Tab prev
      if (shiftKey && prevElement) {
        prevElement.focus();
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Sentinel, [{
    key: 'render',
    value: function render() {
      var setRef = this.props.setRef;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', {
        tabIndex: 0,
        ref: setRef,
        style: sentinelStyle,
        onKeyDown: this.onKeyDown,
        role: 'presentation'
      });
    }
  }]);

  return Sentinel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Sentinel.propTypes = {
  setRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  prevElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  nextElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["c"] = (Sentinel);

/***/ }),
/* 148 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(422);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(149);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 152 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(83),
    isObject = __webpack_require__(155);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(454),
    mapCacheDelete = __webpack_require__(461),
    mapCacheGet = __webpack_require__(463),
    mapCacheHas = __webpack_require__(464),
    mapCacheSet = __webpack_require__(465);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(466),
    arraySome = __webpack_require__(469),
    cacheHas = __webpack_require__(470);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(38),
    stubFalse = __webpack_require__(487);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)(module)))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(489),
    baseUnary = __webpack_require__(490),
    nodeUtil = __webpack_require__(491);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_162__;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(535);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 165 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(169);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(112);var _Homepage=__webpack_require__(69);var _Homepage2=_interopRequireDefault(_Homepage);var _PortalSetting=__webpack_require__(120);var _PortalSetting2=_interopRequireDefault(_PortalSetting);var _ElementIndie=__webpack_require__(647);var _ElementIndie2=_interopRequireDefault(_ElementIndie);var _Synergy=__webpack_require__(648);var _Synergy2=_interopRequireDefault(_Synergy);var _SynergyPortalSetting=__webpack_require__(650);var _SynergyPortalSetting2=_interopRequireDefault(_SynergyPortalSetting);var _reactRouter=__webpack_require__(111);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//协同区组件
//门户设置
//门户样式
var PortalCom=function PortalCom(props){return React.createElement(_Homepage2.default,props);};//协同区门户设置组件
//元素组件
//门户相关
var getLocaleLabel=_ecCom.WeaLocaleProvider.getLocaleLabel.bind(undefined,'portal');var PortalRoute=React.createElement(_reactRouter.Route,{path:'portal',onEnter:getLocaleLabel},React.createElement(_reactRouter.Route,{path:'portal-:hpid-:subCompanyId',component:_Homepage2.default}));module.exports={Route:PortalRoute,store:{},Homepage:_Homepage2.default,PortalSetting:_PortalSetting2.default,ElementIndie:_ElementIndie2.default,Synergy:_Synergy2.default,SynergyPortalSetting:_SynergyPortalSetting2.default,PortalCom:PortalCom};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(175), __esModule: true };

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74);
__webpack_require__(97);
module.exports = __webpack_require__(98).f('iterator');


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var defined = __webpack_require__(44);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(95);
var descriptor = __webpack_require__(42);
var setToStringTag = __webpack_require__(96);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(39)(IteratorPrototype, __webpack_require__(30)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var anObject = __webpack_require__(35);
var getKeys = __webpack_require__(43);

module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(23).document;
module.exports = document && document.documentElement;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(181);
var step = __webpack_require__(182);
var Iterators = __webpack_require__(53);
var toIObject = __webpack_require__(36);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(113)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(184), __esModule: true };

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
module.exports = __webpack_require__(18).Symbol;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(23);
var has = __webpack_require__(33);
var DESCRIPTORS = __webpack_require__(28);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(114);
var META = __webpack_require__(186).KEY;
var $fails = __webpack_require__(29);
var shared = __webpack_require__(60);
var setToStringTag = __webpack_require__(96);
var uid = __webpack_require__(51);
var wks = __webpack_require__(30);
var wksExt = __webpack_require__(98);
var wksDefine = __webpack_require__(99);
var enumKeys = __webpack_require__(187);
var isArray = __webpack_require__(188);
var anObject = __webpack_require__(35);
var isObject = __webpack_require__(32);
var toIObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(56);
var createDesc = __webpack_require__(42);
var _create = __webpack_require__(95);
var gOPNExt = __webpack_require__(189);
var $GOPD = __webpack_require__(117);
var $DP = __webpack_require__(31);
var $keys = __webpack_require__(43);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(116).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(52).f = $propertyIsEnumerable;
  __webpack_require__(62).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(50)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(39)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(51)('meta');
var isObject = __webpack_require__(32);
var has = __webpack_require__(33);
var setDesc = __webpack_require__(31).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(29)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(43);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(52);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(58);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(36);
var gOPN = __webpack_require__(116).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {



/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99)('asyncIterator');


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99)('observable');


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(194);
module.exports = __webpack_require__(18).Object.getPrototypeOf;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(45);
var $getPrototypeOf = __webpack_require__(115);

__webpack_require__(118)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(196);
var $Object = __webpack_require__(18).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(31).f });


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(198), __esModule: true };

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(199);
module.exports = __webpack_require__(18).Object.setPrototypeOf;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(25);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(200).set });


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(32);
var anObject = __webpack_require__(35);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(55)(Function.call, __webpack_require__(117).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(202), __esModule: true };

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(203);
var $Object = __webpack_require__(18).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(95) });


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SubMenu=_antd.Menu.SubMenu;var MenuItemGroup=_antd.Menu.ItemGroup;var PortalMenu1=function(_React$Component){(0,_inherits3.default)(PortalMenu1,_React$Component);function PortalMenu1(props){(0,_classCallCheck3.default)(this,PortalMenu1);var _this=(0,_possibleConstructorReturn3.default)(this,(PortalMenu1.__proto__||(0,_getPrototypeOf2.default)(PortalMenu1)).call(this,props));_this.state={key:props.hpid+'-'+props.subCompanyId};_this.handleList=_this.handleList.bind(_this);_this.handleClick=_this.handleClick.bind(_this);return _this;}(0,_createClass3.default)(PortalMenu1,[{key:'handleClick',value:function handleClick(_ref){var item=_ref.item,key=_ref.key,keyPath=_ref.keyPath;var handleRefresh=this.props.handleRefresh;if(key){this.setState({key:key});var arr=key.split("-");handleRefresh({hpid:arr[0],subCompanyId:arr[1]});}}},{key:'handleList',value:function handleList(list){var _this2=this;var html=list.map(function(menu){var hpid=menu.hpid,subCompanyId=menu.subCompanyId,name=menu.name,children=menu.children;if(children&&children.length){return _react2.default.createElement(SubMenu,{key:hpid+'-'+subCompanyId,title:name},_this2.handleList(children));}else{return _react2.default.createElement(_antd.Menu.Item,{key:hpid+'-'+subCompanyId},name);}});return html;}},{key:'render',value:function render(){var portalmenu=this.props.portalmenu;var pList=portalmenu.pList;return _react2.default.createElement('div',{className:'portal-portalmenu'},_react2.default.createElement(_antd.Menu,{theme:'dark',selectedKeys:[this.state.key],mode:'horizontal',onClick:this.handleClick},this.handleList(pList)));}}]);return PortalMenu1;}(_react2.default.Component);var PortalMenu=function(_React$Component2){(0,_inherits3.default)(PortalMenu,_React$Component2);function PortalMenu(props){(0,_classCallCheck3.default)(this,PortalMenu);var _this3=(0,_possibleConstructorReturn3.default)(this,(PortalMenu.__proto__||(0,_getPrototypeOf2.default)(PortalMenu)).call(this,props));var num=props.portalmenu.pList.length;var isshow=false;if(120*num>document.body.clientWidth-100){isshow=true;}_this3.state={hpid:props.hpid,isshow:isshow};_this3.handleList=_this3.handleList.bind(_this3);_this3.handleClick=_this3.handleClick.bind(_this3);_this3.handleIconClick=_this3.handleIconClick.bind(_this3);_this3.handleMouseLeave=_this3.handleMouseLeave.bind(_this3);_this3.doScroll=_this3.doScroll.bind(_this3);return _this3;}(0,_createClass3.default)(PortalMenu,[{key:'handleClick',value:function handleClick(hpid,subCompanyId,e){e.stopPropagation();this.setState({hpid:hpid});this.props.handleRefresh({hpid:hpid,subCompanyId:subCompanyId});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.state.hpid!==nextState.hpid;}},{key:'handleIconClick',value:function handleIconClick(hpid,e){e.stopPropagation();$(".portal-portalmenu-menu[data-pid="+hpid+"]").css({display:'inline-block'});}},{key:'handleMouseLeave',value:function handleMouseLeave(pid,hpid,e){if(pid=='0')return;e.stopPropagation();$(".portal-portalmenu-menu[data-hpid="+hpid+"]").css({display:'none'});}},{key:'handleList',value:function handleList(list){var _this4=this;var _pid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'0';var _hpid=this.state.hpid;var html=list.map(function(menu,i){var pid=menu.pid,hpid=menu.hpid,subCompanyId=menu.subCompanyId,name=menu.name,children=menu.children;var style=_pid=='0'?{left:i*120,top:0}:{left:i*120,top:42,display:'none'};var icon='';var sub='';if(children&&children.length){icon=_react2.default.createElement('i',{onClick:_this4.handleIconClick.bind(_this4,hpid),className:'icon-coms-organization-down portal-menu-sub-icon'});sub=_this4.handleList(children,hpid);}return _react2.default.createElement('div',{id:'portalmenu_'+hpid,'data-pid':pid,'data-hpid':hpid,onMouseLeave:_this4.handleMouseLeave.bind(_this4,_pid,hpid),onClick:_this4.handleClick.bind(_this4,hpid,subCompanyId),className:'portal-portalmenu-menu '+(_hpid==hpid?'portal-portalmenu-selected':''),style:style},name,icon,sub);});return html;}},{key:'doScroll',value:function doScroll(type){var pList=this.props.portalmenu.pList;var width=type==='prev'?-120:120;$("#portalMenuContainer").scrollTo({top:'0px',left:$("#portalMenuContainer").get(0).scrollLeft+width+'px'},500);if(type==='prev'){$("#menuNext").css({color:'#FFFFFF',cursor:'pointer'});if($("#portalMenuContainer").get(0).scrollLeft<=120){$("#menuPrev").css({color:'#acacac',cursor:'default'});}}else{$("#menuPrev").css({color:'#FFFFFF',cursor:'pointer'});if($("#portalMenuContainer").get(0).scrollLeft>=pList.length*120+40-document.body.clientWidth+100){$("#menuNext").css({color:'#acacac',cursor:'default'});}}}},{key:'render',value:function render(){var portalmenu=this.props.portalmenu;var isshow=this.state.isshow;var pList=portalmenu.pList;var html=this.handleList(pList);if(isshow){html=_react2.default.createElement('div',{id:'portalMenuContainer',style:{width:document.body.clientWidth-140+'px'},className:'portal-portalmenu-container'},_react2.default.createElement('div',{style:{width:pList.length*120+'px',height:'40px',position:'relative'}},html));}return _react2.default.createElement('div',{className:'portal-portalmenu'},isshow?_react2.default.createElement('div',{id:'menuPrev',className:'portal-portalmenu-nav menu-prev'},_react2.default.createElement(_antd.Icon,{type:'caret-left',onClick:this.doScroll.bind(this,'prev')})):'',html,isshow?_react2.default.createElement('div',{id:'menuNext',className:'portal-portalmenu-nav menu-next'},_react2.default.createElement(_antd.Icon,{type:'caret-right',onClick:this.doScroll.bind(this,'next')})):'');}}]);return PortalMenu;}(_react2.default.Component);module.exports=PortalMenu;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _CustomLayoutFlags=__webpack_require__(206);var _CustomLayoutFlags2=_interopRequireDefault(_CustomLayoutFlags);var _elements=__webpack_require__(100);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LayoutFlags=function(_React$Component){(0,_inherits3.default)(LayoutFlags,_React$Component);function LayoutFlags(){(0,_classCallCheck3.default)(this,LayoutFlags);return(0,_possibleConstructorReturn3.default)(this,(LayoutFlags.__proto__||(0,_getPrototypeOf2.default)(LayoutFlags)).apply(this,arguments));}(0,_createClass3.default)(LayoutFlags,[{key:'render',value:function render(){//定义布局id全局变量
if(this.props.layoutHtml!==undefined){return _react2.default.createElement(_CustomLayoutFlags2.default,this.props);}else{return _react2.default.createElement(CommonLayoutFlags,this.props);}}}]);return LayoutFlags;}(_react2.default.Component);//引入元素组件
var getLabel=_ecCom.WeaLocaleProvider.getLabel;var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);LayoutFlags=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(LayoutFlags);exports.default=LayoutFlags;var CommonLayoutFlags=function(_React$Component3){(0,_inherits3.default)(CommonLayoutFlags,_React$Component3);function CommonLayoutFlags(){(0,_classCallCheck3.default)(this,CommonLayoutFlags);return(0,_possibleConstructorReturn3.default)(this,(CommonLayoutFlags.__proto__||(0,_getPrototypeOf2.default)(CommonLayoutFlags)).apply(this,arguments));}(0,_createClass3.default)(CommonLayoutFlags,[{key:'render',value:function render(){var eHtml=_react2.default.createElement('div',null);var _props=this.props,config=_props.config,layoutid=_props.layoutid,layoutFlags=_props.layoutFlags,layoutHtml=_props.layoutHtml;switch(layoutid){case"1"://一栏布局
case"2"://两栏布局
case"3"://三栏布局
var lfhtml=_react2.default.createElement('td',null);if(layoutFlags&&layoutFlags.length){lfhtml=layoutFlags.map(function(layoutFlag,i){return _react2.default.createElement('td',{width:layoutFlag.areasize,className:'valign'},_react2.default.createElement(GroupDiv,{key:layoutFlag.areaflag,config:(0,_extends3.default)({},config,{layoutid:layoutid}),layoutFlag:layoutFlag}));});}eHtml=_react2.default.createElement('table',{id:'Container'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,lfhtml)));break;case"4"://其他布局1
eHtml=_react2.default.createElement(SYSOtherRowOne,{config:(0,_extends3.default)({},config,{layoutid:layoutid}),layoutFlags:layoutFlags});break;case"5"://其他布局2
eHtml=_react2.default.createElement(SYSOtherRowTwo,{config:(0,_extends3.default)({},config,{layoutid:layoutid}),layoutFlags:layoutFlags});break;default:break;}return _react2.default.createElement('div',null,eHtml);}}]);return CommonLayoutFlags;}(_react2.default.Component);//其他布局1
var SYSOtherRowOne=function(_React$Component4){(0,_inherits3.default)(SYSOtherRowOne,_React$Component4);function SYSOtherRowOne(){(0,_classCallCheck3.default)(this,SYSOtherRowOne);return(0,_possibleConstructorReturn3.default)(this,(SYSOtherRowOne.__proto__||(0,_getPrototypeOf2.default)(SYSOtherRowOne)).apply(this,arguments));}(0,_createClass3.default)(SYSOtherRowOne,[{key:'render',value:function render(){var layoutFlag=new Object();var _props2=this.props,config=_props2.config,layoutFlags=_props2.layoutFlags;layoutFlags.map(function(item){return layoutFlag['flag'+item.areaflag]=item;});var aflag=layoutFlag.flagA;var bflag=layoutFlag.flagB;var cflag=layoutFlag.flagC;var dflag=layoutFlag.flagD;return _react2.default.createElement('table',{id:'Container'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:aflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign',border:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{colspan:'2',className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:aflag.areaflag,layoutFlag:aflag})))),_react2.default.createElement('table',{width:'100%',className:'valign',border:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:cflag.areasize,className:'valign',border:'0'},_react2.default.createElement(GroupDiv,{config:config,key:cflag.areaflag,layoutFlag:cflag})),_react2.default.createElement('td',{width:dflag.areasize,className:'valign',border:'0'},_react2.default.createElement(GroupDiv,{config:config,key:dflag.areaflag,layoutFlag:dflag}))))),_react2.default.createElement('td',{width:bflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign',border:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:bflag.areaflag,layoutFlag:bflag})))))));}}]);return SYSOtherRowOne;}(_react2.default.Component);//其他布局2
var SYSOtherRowTwo=function(_React$Component5){(0,_inherits3.default)(SYSOtherRowTwo,_React$Component5);function SYSOtherRowTwo(){(0,_classCallCheck3.default)(this,SYSOtherRowTwo);return(0,_possibleConstructorReturn3.default)(this,(SYSOtherRowTwo.__proto__||(0,_getPrototypeOf2.default)(SYSOtherRowTwo)).apply(this,arguments));}(0,_createClass3.default)(SYSOtherRowTwo,[{key:'render',value:function render(){var layoutFlag=new Object();var _props3=this.props,config=_props3.config,layoutFlags=_props3.layoutFlags;layoutFlags.map(function(item){return layoutFlag['flag'+item.areaflag]=item;});var aflag=layoutFlag.flagA;var bflag=layoutFlag.flagB;var cflag=layoutFlag.flagC;var dflag=layoutFlag.flagD;return _react2.default.createElement('table',{id:'Container'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:dflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:aflag.areasize,className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:aflag.areaflag,layoutFlag:aflag})),_react2.default.createElement('td',{width:bflag.areasize,className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:bflag.areaflag,layoutFlag:bflag})))),_react2.default.createElement('table',{width:'100%',className:'valign'},_react2.default.createElement('tr',{className:'valign'},_react2.default.createElement('td',{colspan:2,className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:dflag.areaflag,layoutFlag:dflag}))))),_react2.default.createElement('td',{width:cflag.areasize,className:'valign'},_react2.default.createElement('table',{width:'100%',className:'valign'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'valign'},_react2.default.createElement(GroupDiv,{config:config,key:cflag.areaflag,layoutFlag:cflag})))))));}}]);return SYSOtherRowTwo;}(_react2.default.Component);//group Div组件
var GroupDiv=function(_React$Component6){(0,_inherits3.default)(GroupDiv,_React$Component6);function GroupDiv(){(0,_classCallCheck3.default)(this,GroupDiv);return(0,_possibleConstructorReturn3.default)(this,(GroupDiv.__proto__||(0,_getPrototypeOf2.default)(GroupDiv)).apply(this,arguments));}(0,_createClass3.default)(GroupDiv,[{key:'render',value:function render(){var layoutFlag=this.props.layoutFlag;var _config=this.props.config;return _react2.default.createElement('div',{className:'group','data-areaflag':layoutFlag.areaflag},layoutFlag.areaElements.map(function(config){return _react2.default.createElement(_elements.Element,{key:"element-"+config.item.eid,config:(0,_extends3.default)({},config,_config)});}));}}]);return GroupDiv;}(_react2.default.Component);

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(20);var _reactDom2=_interopRequireDefault(_reactDom);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _elements=__webpack_require__(100);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//引入元素组件
var CustomLayoutFlags=function(_React$Component){(0,_inherits3.default)(CustomLayoutFlags,_React$Component);function CustomLayoutFlags(){(0,_classCallCheck3.default)(this,CustomLayoutFlags);return(0,_possibleConstructorReturn3.default)(this,(CustomLayoutFlags.__proto__||(0,_getPrototypeOf2.default)(CustomLayoutFlags)).apply(this,arguments));}(0,_createClass3.default)(CustomLayoutFlags,[{key:'renderCustomLayout',//加载自定义布局门户
value:function renderCustomLayout(){var _props=this.props,layoutid=_props.layoutid,layoutFlags=_props.layoutFlags,layoutHtml=_props.layoutHtml;var _config=this.props.config;if(layoutHtml){layoutFlags.map(function(layoutFlag,i){var lhtml=layoutFlag.areaElements.map(function(config){return _react2.default.createElement(_elements.Element,{key:"element-"+config.item.eid,config:(0,_extends3.default)({},config,{layoutid:layoutid},_config)});});var groupdom=$(".homepage[data-issetting="+_config.isSetting+"]").find(".group[areaflag='"+layoutFlag.areaflag+"']")[0]||$(".homepage[data-issetting="+_config.isSetting+"]").find(".group[data-areaflag='"+layoutFlag.areaflag+"']")[0];if(groupdom){var renderdom=groupdom.parentNode;_reactDom2.default.render(_react2.default.createElement('div',{className:'group','data-areaflag':layoutFlag.areaflag},lhtml),renderdom);}});}}},{key:'componentDidMount',value:function componentDidMount(){this.renderCustomLayout();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var prelayoutid=prevProps.layoutid;var _props2=this.props,layoutid=_props2.layoutid,config=_props2.config,layoutFlags=_props2.layoutFlags;if(prevProps.hpid!==this.props.hpid||prelayoutid!==layoutid||config.isRender||!(0,_lodash.isEqual)(prevProps.layoutFlags,layoutFlags)){this.renderCustomLayout();}}},{key:'render',value:function render(){var eHtml=_react2.default.createElement('div',null);var layoutHtml=this.props.layoutHtml;if(layoutHtml){eHtml=_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:layoutHtml}});}return _react2.default.createElement('div',null,eHtml);}}]);return CustomLayoutFlags;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomLayoutFlags=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomLayoutFlags);exports.default=CustomLayoutFlags;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(208);__webpack_require__(209);__webpack_require__(210);__webpack_require__(211);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
jQuery.curCSS=function(elem,name){var ret='0px';var style=elem.style;if(window.getComputedStyle){var computed=window.getComputedStyle(elem,null);if(computed){//getPropertyValue兼容ie9获取filter:Alpha(opacity=50)
ret=computed.getPropertyValue(name)||computed[name];//如果是动态创建的元素，则使用style方法获取样式
if(ret===""&&!jQuery.contains(elem.ownerDocument,elem)){ret=jQuery.style(elem,name);}}}return ret;};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * jCarouselLite - jQuery plugin to navigate images/any content in a carousel style widget.
 * @requires jQuery v1.2 or above
 *
 * http://gmarwaha.com/jquery/jcarousellite/
 *
 * Copyright (c) 2007 Ganeshji Marwaha (gmarwaha.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Version: 1.0.1
 * Note: Requires jquery 1.2 or above from version 1.0.1
 *//**
btnPrev : ��һ�Ű�ť
btnNext : ��һ�Ű�ť
btnGo : ��ǩ���ƣ�Ҳ�����á�1,2,3,4����������
mouseWheel : �Ƿ�֧����껬�ֹ���������ֵ��false / true��Ĭ��Ϊfalse �򿪴�����ҪjQuery UI���֧��
auto : �����Զ����ŵ��ٶȣ�Ĭ���Զ������ǹرյģ���ʽ auto: 800 (Ϊ�����ٶ�)
speed : ����Ч���ٶ�
easing : ����Ч���Ż���������ô���� ��Ҫ�ⲿ���֧��
vertical : ���������������Ϊtrue�����ʾ��ֱ������Ĭ��Ϊfalse
circular : �Ƿ��ظ����ţ��������Ϊfalse�������һ����һ�Ű�ť�͵㲻���ˣ�����һ����һ�Ű�ť�͵㲻��
visible : ����Ĭ����ʾ����li��Ĭ����3��
start : Ч���ӵڼ�����ʼ��Ĭ��Ϊ0
scroll : һ�λ�������li��Ĭ����2
beforeStart : ����ǽӿڣ�ÿ�λ���Ч��ִ��֮ǰִ�е��Զ��庯��
afterEnd : ����ǽӿڣ�ÿ�λ���Ч��ִ��֮��ִ�е��Զ��庯��
 *//**
 * Creates a carousel-style navigation widget for images/any-content from a simple HTML markup.
 *
 * The HTML markup that is used to build the carousel can be as simple as...
 *
 *  <div class="carousel">
 *      <ul>
 *          <li><img src="image/1.jpg" alt="1"></li>
 *          <li><img src="image/2.jpg" alt="2"></li>
 *          <li><img src="image/3.jpg" alt="3"></li>
 *      </ul>
 *  </div>
 *
 * As you can see, this snippet is nothing but a simple div containing an unordered list of images.
 * You don't need any special "class" attribute, or a special "css" file for this plugin.
 * I am using a class attribute just for the sake of explanation here.
 *
 * To navigate the elements of the carousel, you need some kind of navigation buttons.
 * For example, you will need a "previous" button to go backward, and a "next" button to go forward.
 * This need not be part of the carousel "div" itself. It can be any element in your page.
 * Lets assume that the following elements in your document can be used as next, and prev buttons...
 *
 * <button class="prev">&lt;&lt;</button>
 * <button class="next">&gt;&gt;</button>
 *
 * Now, all you need to do is call the carousel component on the div element that represents it, and pass in the
 * navigation buttons as options.
 *
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev"
 * });
 *
 * That's it, you would have now converted your raw div, into a magnificient carousel.
 *
 * There are quite a few other options that you can use to customize it though.
 * Each will be explained with an example below.
 *
 * @param an options object - You can specify all the options shown below as an options object param.
 *
 * @option btnPrev, btnNext : string - no defaults
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev"
 * });
 * @desc Creates a basic carousel. Clicking "btnPrev" navigates backwards and "btnNext" navigates forward.
 *
 * @option btnGo - array - no defaults
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      btnGo: [".0", ".1", ".2"]
 * });
 * @desc If you don't want next and previous buttons for navigation, instead you prefer custom navigation based on
 * the item number within the carousel, you can use this option. Just supply an array of selectors for each element
 * in the carousel. The index of the array represents the index of the element. What i mean is, if the
 * first element in the array is ".0", it means that when the element represented by ".0" is clicked, the carousel
 * will slide to the first element and so on and so forth. This feature is very powerful. For example, i made a tabbed
 * interface out of it by making my navigation elements styled like tabs in css. As the carousel is capable of holding
 * any content, not just images, you can have a very simple tabbed navigation in minutes without using any other plugin.
 * The best part is that, the tab will "slide" based on the provided effect. :-)
 *
 * @option mouseWheel : boolean - default is false
 * @example
 * $(".carousel").jCarouselLite({
 *      mouseWheel: true
 * });
 * @desc The carousel can also be navigated using the mouse wheel interface of a scroll mouse instead of using buttons.
 * To get this feature working, you have to do 2 things. First, you have to include the mouse-wheel plugin from brandon.
 * Second, you will have to set the option "mouseWheel" to true. That's it, now you will be able to navigate your carousel
 * using the mouse wheel. Using buttons and mouseWheel or not mutually exclusive. You can still have buttons for navigation
 * as well. They complement each other. To use both together, just supply the options required for both as shown below.
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      mouseWheel: true
 * });
 *
 * @option auto : number - default is null, meaning autoscroll is disabled by default
 * @example
 * $(".carousel").jCarouselLite({
 *      auto: 800,
 *      speed: 500
 * });
 * @desc You can make your carousel auto-navigate itself by specfying a millisecond value in this option.
 * The value you specify is the amount of time between 2 slides. The default is null, and that disables auto scrolling.
 * Specify this value and magically your carousel will start auto scrolling.
 *
 * @option speed : number - 200 is default
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      speed: 800
 * });
 * @desc Specifying a speed will slow-down or speed-up the sliding speed of your carousel. Try it out with
 * different speeds like 800, 600, 1500 etc. Providing 0, will remove the slide effect.
 *
 * @option easing : string - no easing effects by default.
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      easing: "bounceout"
 * });
 * @desc You can specify any easing effect. Note: You need easing plugin for that. Once specified,
 * the carousel will slide based on the provided easing effect.
 *
 * @option vertical : boolean - default is false
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      vertical: true
 * });
 * @desc Determines the direction of the carousel. true, means the carousel will display vertically. The next and
 * prev buttons will slide the items vertically as well. The default is false, which means that the carousel will
 * display horizontally. The next and prev items will slide the items from left-right in this case.
 *
 * @option circular : boolean - default is true
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      circular: false
 * });
 * @desc Setting it to true enables circular navigation. This means, if you click "next" after you reach the last
 * element, you will automatically slide to the first element and vice versa. If you set circular to false, then
 * if you click on the "next" button after you reach the last element, you will stay in the last element itself
 * and similarly for "previous" button and first element.
 *
 * @option visible : number - default is 3
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      visible: 4
 * });
 * @desc This specifies the number of items visible at all times within the carousel. The default is 3.
 * You are even free to experiment with real numbers. Eg: "3.5" will have 3 items fully visible and the
 * last item half visible. This gives you the effect of showing the user that there are more images to the right.
 *
 * @option start : number - default is 0
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      start: 2
 * });
 * @desc You can specify from which item the carousel should start. Remember, the first item in the carousel
 * has a start of 0, and so on.
 *
 * @option scrool : number - default is 1
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      scroll: 2
 * });
 * @desc The number of items that should scroll/slide when you click the next/prev navigation buttons. By
 * default, only one item is scrolled, but you may set it to any number. Eg: setting it to "2" will scroll
 * 2 items when you click the next or previous buttons.
 *
 * @option beforeStart, afterEnd : function - callbacks
 * @example
 * $(".carousel").jCarouselLite({
 *      btnNext: ".next",
 *      btnPrev: ".prev",
 *      beforeStart: function(a) {
 *          alert("Before animation starts:" + a);
 *      },
 *      afterEnd: function(a) {
 *          alert("After animation ends:" + a);
 *      }
 * });
 * @desc If you wanted to do some logic in your page before the slide starts and after the slide ends, you can
 * register these 2 callbacks. The functions will be passed an argument that represents an array of elements that
 * are visible at the time of callback.
 *
 *
 * @cat Plugins/Image Gallery
 * @author Ganeshji Marwaha/ganeshread@gmail.com
 */(function($){// Compliant with jquery.noConflict()
jQuery.fx.prototype.cur=function(force){if(this.elem[this.prop]!=null&&this.elem.style[this.prop]==null)return this.elem[this.prop];var r=parseFloat(jQuery.css(this.elem,this.prop,force));return r?r:parseFloat(jQuery.curCSS(this.elem,this.prop))||0;//&& r > -10000 cacel the limit
};$.fn.jCarouselLite=function(o){o=$.extend({btnPrev:null,btnNext:null,btnGo:null,mouseWheel:false,auto:null,speed:200,easing:null,vertical:false,circular:true,visible:3,start:0,scroll:1,beforeStart:null,afterEnd:null},o||{});return this.each(function(){// Returns the element collection. Chainable.
var running=false,animCss=o.vertical?"top":"left",sizeCss=o.vertical?"height":"width";var div=$(this),ul=$("ul",div),tLi=$("li",ul),tl=tLi.size(),v=o.visible;if(o.circular){ul.prepend(tLi.slice(tl-v-1+1).clone()).append(tLi.slice(0,v).clone());o.start+=v;}var li=$("li",ul),itemLength=li.size(),curr=o.start;div.css("visibility","visible");li.css({overflow:"hidden",float:o.vertical?"none":"left"});ul.css({margin:"0",padding:"0",position:"relative","list-style-type":"none","z-index":"1"});div.css({overflow:"hidden",position:"relative","z-index":"2",left:"0px"});var liSize=o.vertical?height(li):width(li);// Full li size(incl margin)-Used for animation
var ulSize=liSize*itemLength;// size of full ul(total length, not just for the visible items)
var divSize=liSize*v;// size of entire div(total length for just the visible items)
li.css({width:li.width(),height:li.height()});ul.css(sizeCss,ulSize+"px").css(animCss,-(curr*liSize));div.css(sizeCss,divSize+"px");// Width of the DIV. length of visible images
if(o.btnPrev)$(o.btnPrev).click(function(){return go(curr-o.scroll);});if(o.btnNext)$(o.btnNext).click(function(){return go(curr+o.scroll);});if(o.btnGo)$.each(o.btnGo,function(i,val){$(val).click(function(){return go(o.circular?o.visible+i:i);});});if(o.mouseWheel&&div.mousewheel)div.mousewheel(function(e,d){return d>0?go(curr-o.scroll):go(curr+o.scroll);});if(o.auto)setInterval(function(){go(curr+o.scroll);},o.auto+o.speed);function vis(){return li.slice(curr).slice(0,v);};function go(to){if(!running){if(o.beforeStart)o.beforeStart.call(this,vis());if(o.circular){// If circular we are in first or last, then goto the other end
if(to<=o.start-v-1){// If first, then goto last
ul.css(animCss,-((itemLength-v*2)*liSize)+"px");// If "scroll" > 1, then the "to" might not be equal to the condition; it can be lesser depending on the number of elements.
curr=to==o.start-v-1?itemLength-v*2-1:itemLength-v*2-o.scroll;}else if(to>=itemLength-v+1){// If last, then goto first
ul.css(animCss,-(v*liSize)+"px");// If "scroll" > 1, then the "to" might not be equal to the condition; it can be greater depending on the number of elements.
curr=to==itemLength-v+1?v+1:v+o.scroll;}else curr=to;}else{// If non-circular and to points to first or last, we just return.
if(to<0||to>itemLength-v)return;else curr=to;}// If neither overrides it, the curr will still be "to" and we can proceed.
running=true;ul.animate(animCss=="left"?{left:-(curr*liSize)}:{top:-(curr*liSize)},o.speed,o.easing,function(){if(o.afterEnd)o.afterEnd.call(this,vis());running=false;});// Disable buttons when the carousel reaches the last/first, and enable when not
if(!o.circular){$(o.btnPrev+","+o.btnNext).removeClass("disabled");$(curr-o.scroll<0&&o.btnPrev||curr+o.scroll>itemLength-v&&o.btnNext||[]).addClass("disabled");}}return false;};});};function css(el,prop){return parseInt($.css(el[0],prop))||0;};function width(el){return el.length&&el[0].offsetWidth+css(el,'marginLeft')+css(el,'marginRight');};function height(el){return el.length&&el[0].offsetHeight+css(el,'marginTop')+css(el,'marginBottom');};})(jQuery);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * jQuery Cycle Plugin (with Transition Definitions)
 * Examples and documentation at: http://jquery.malsup.com/cycle/
 * Copyright (c) 2007-2010 M. Alsup
 * Version: 2.88 (08-JUN-2010)
 * Dual licensed under the MIT and GPL licenses.
 * http://jquery.malsup.com/license.html
 * Requires: jQuery v1.2.6 or later
 */var slideTimeout={};;(function($){var ver='2.88';// if $.support is not defined (pre jQuery 1.3) add what I need
if($.support==undefined){$.support={opacity:!$.browser.msie};}function debug(s){if($.fn.cycle.debug)log(s);}function log(){if(window.console&&window.console.log)window.console.log('[cycle] '+Array.prototype.join.call(arguments,' '));};// the options arg can be...
//   a number  - indicates an immediate transition should occur to the given slide index
//   a string  - 'pause', 'resume', 'toggle', 'next', 'prev', 'stop', 'destroy' or the name of a transition effect (ie, 'fade', 'zoom', etc)
//   an object - properties to control the slideshow
//
// the arg2 arg can be...
//   the name of an fx (only used in conjunction with a numeric value for 'options')
//   the value true (only used in first arg == 'resume') and indicates
//	 that the resume should occur immediately (not wait for next timeout)
$.fn.cycle=function(options,arg2){var o={s:this.selector,c:this.context};// in 1.3+ we can fix mistakes with the ready state
if(this.length===0&&options!='stop'){if(!$.isReady&&o.s){log('DOM not ready, queuing slideshow');$(function(){$(o.s,o.c).cycle(options,arg2);});return this;}// is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
log('terminating; zero elements found by selector'+($.isReady?'':' (DOM not ready)'));return this;}// iterate the matched nodeset
return this.each(function(){var opts=handleArguments(this,options,arg2);if(opts===false)return;opts.updateActivePagerLink=opts.updateActivePagerLink||$.fn.cycle.updateActivePagerLink;// stop existing slideshow for this container (if there is one)
if(slideTimeout[opts.pager.split(" ")[0].substring(1)])clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=this.cyclePause=0;var $cont=$(this);var $slides=opts.slideExpr?$(opts.slideExpr,this):$cont.children();var els=$slides.get();if(els.length<2){log('terminating; too few slides: '+els.length);return;}var opts2=buildOptions($cont,$slides,els,opts,o);if(opts2===false)return;var startTime=opts2.continuous?10:getTimeout(els[opts2.currSlide],els[opts2.nextSlide],opts2,!opts2.rev);// if it's an auto slideshow, kick it off
if(startTime){startTime+=opts2.delay||0;if(startTime<10)startTime=10;debug('first timeout: '+startTime);slideTimeout[opts.pager.split(" ")[0].substring(1)]=setTimeout(function(){go(els,opts2,0,!opts2.rev&&!opts.backwards);},startTime);}});};// process the args that were passed to the plugin fn
function handleArguments(cont,options,arg2){if(cont.cycleStop==undefined)cont.cycleStop=0;if(options===undefined||options===null)options={};if(options.constructor==String){switch(options){case'destroy':case'stop':var opts=$(cont).data('cycle.opts');if(!opts)return false;cont.cycleStop++;// callbacks look for change
if(slideTimeout[opts.pager.split(" ")[0].substring(1)])clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;$(cont).removeData('cycle.opts');if(options=='destroy')destroy(opts);return false;case'toggle':cont.cyclePause=cont.cyclePause===1?0:1;checkInstantResume(cont.cyclePause,arg2,cont);return false;case'pause':cont.cyclePause=1;return false;case'resume':cont.cyclePause=0;checkInstantResume(false,arg2,cont);return false;case'prev':case'next':var opts=$(cont).data('cycle.opts');if(!opts){log('options not found, "prev/next" ignored');return false;}$.fn.cycle[options](opts);return false;default:options={fx:options};};return options;}else if(options.constructor==Number){// go to the requested slide
var num=options;options=$(cont).data('cycle.opts');if(!options){log('options not found, can not advance slide');return false;}if(num<0||num>=options.elements.length){log('invalid slide index: '+num);return false;}options.nextSlide=num;if(slideTimeout[opts.pager.split(" ")[0].substring(1)]){clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}if(typeof arg2=='string')options.oneTimeFx=arg2;go(options.elements,options,1,num>=options.currSlide);return false;}return options;function checkInstantResume(isPaused,arg2,cont){if(!isPaused&&arg2===true){// resume now!
var options=$(cont).data('cycle.opts');if(!options){log('options not found, can not resume');return false;}if(slideTimeout[opts.pager.split(" ")[0].substring(1)]){clearTimeout(slideTimeout[opts.pager.split(" ")[0].substring(1)]);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}go(options.elements,options,1,!opts.rev&&!opts.backwards);}}};function removeFilter(el,opts){if(!$.support.opacity&&opts.cleartype&&el.style.filter){try{el.style.removeAttribute('filter');}catch(smother){}// handle old opera versions
}};// unbind event handlers
function destroy(opts){if(opts.next)$(opts.next).unbind(opts.prevNextEvent);if(opts.prev)$(opts.prev).unbind(opts.prevNextEvent);if(opts.pager||opts.pagerAnchorBuilder)$.each(opts.pagerAnchors||[],function(){this.unbind().remove();});opts.pagerAnchors=null;if(opts.destroy)// callback
opts.destroy(opts);};// one-time initialization
function buildOptions($cont,$slides,els,options,o){// support metadata plugin (v1.0 and v2.0)
var opts=$.extend({},$.fn.cycle.defaults,options||{},$.metadata?$cont.metadata():$.meta?$cont.data():{});if(opts.autostop)opts.countdown=opts.autostopCount||els.length;var cont=$cont[0];$cont.data('cycle.opts',opts);opts.$cont=$cont;opts.stopCount=cont.cycleStop;opts.elements=els;opts.before=opts.before?[opts.before]:[];opts.after=opts.after?[opts.after]:[];opts.after.unshift(function(){opts.busy=0;});// push some after callbacks
if(!$.support.opacity&&opts.cleartype)opts.after.push(function(){removeFilter(this,opts);});if(opts.continuous)opts.after.push(function(){go(els,opts,0,!opts.rev&&!opts.backwards);});saveOriginalOpts(opts);// clearType corrections
if(!$.support.opacity&&opts.cleartype&&!opts.cleartypeNoBg)clearTypeFix($slides);// container requires non-static position so that slides can be position within
if($cont.css('position')=='static')$cont.css('position','relative');if(opts.width)$cont.width(opts.width);if(opts.height&&opts.height!='auto')$cont.height(opts.height);if(opts.startingSlide)opts.startingSlide=parseInt(opts.startingSlide);else if(opts.backwards)opts.startingSlide=els.length-1;// if random, mix up the slide array
if(opts.random){opts.randomMap=[];for(var i=0;i<els.length;i++){opts.randomMap.push(i);}opts.randomMap.sort(function(a,b){return Math.random()-0.5;});opts.randomIndex=1;opts.startingSlide=opts.randomMap[1];}else if(opts.startingSlide>=els.length)opts.startingSlide=0;// catch bogus input
opts.currSlide=opts.startingSlide||0;var first=opts.startingSlide;// set position and zIndex on all the slides
$slides.css({position:'absolute',top:0,left:0}).hide().each(function(i){var z;if(opts.backwards)z=first?i<=first?els.length+(i-first):first-i:els.length-i;else z=first?i>=first?els.length-(i-first):first-i:els.length-i;$(this).css('z-index',z);});// make sure first slide is visible
$(els[first]).css('opacity',1).show();// opacity bit needed to handle restart use case
removeFilter(els[first],opts);// stretch slides
if(opts.fit&&opts.width)$slides.width(opts.width);if(opts.fit&&opts.height&&opts.height!='auto')$slides.height(opts.height);// stretch container
var reshape=opts.containerResize&&!$cont.innerHeight();if(reshape){// do this only if container has no size http://tinyurl.com/da2oa9
var maxw=0,maxh=0;for(var j=0;j<els.length;j++){var $e=$(els[j]),e=$e[0],w=$e.outerWidth(),h=$e.outerHeight();if(!w)w=e.offsetWidth||e.width||$e.attr('width');if(!h)h=e.offsetHeight||e.height||$e.attr('height');maxw=w>maxw?w:maxw;maxh=h>maxh?h:maxh;}if(maxw>0&&maxh>0)$cont.css({width:maxw+'px',height:maxh+'px'});}if(opts.pause)$cont.hover(function(){this.cyclePause++;},function(){this.cyclePause--;});if(supportMultiTransitions(opts)===false)return false;// apparently a lot of people use image slideshows without height/width attributes on the images.
// Cycle 2.50+ requires the sizing info for every slide; this block tries to deal with that.
var requeue=false;options.requeueAttempts=options.requeueAttempts||0;$slides.each(function(){// try to get height/width of each slide
var $el=$(this);this.cycleH=opts.fit&&opts.height?opts.height:$el.height()||this.offsetHeight||this.height||$el.attr('height')||0;this.cycleW=opts.fit&&opts.width?opts.width:$el.width()||this.offsetWidth||this.width||$el.attr('width')||0;if($el.is('img')){// sigh..  sniffing, hacking, shrugging...  this crappy hack tries to account for what browsers do when
// an image is being downloaded and the markup did not include sizing info (height/width attributes);
// there seems to be some "default" sizes used in this situation
var loadingIE=$.browser.msie&&this.cycleW==28&&this.cycleH==30&&!this.complete;var loadingFF=$.browser.mozilla&&this.cycleW==34&&this.cycleH==19&&!this.complete;var loadingOp=$.browser.opera&&(this.cycleW==42&&this.cycleH==19||this.cycleW==37&&this.cycleH==17)&&!this.complete;var loadingOther=this.cycleH==0&&this.cycleW==0&&!this.complete;// don't requeue for images that are still loading but have a valid size
if(loadingIE||loadingFF||loadingOp||loadingOther){if(o.s&&opts.requeueOnImageNotLoaded&&++options.requeueAttempts<100){// track retry count so we don't loop forever
log(options.requeueAttempts,' - img slide not loaded, requeuing slideshow: ',this.src,this.cycleW,this.cycleH);setTimeout(function(){$(o.s,o.c).cycle(options);},opts.requeueTimeout);requeue=true;return false;// break each loop
}else{log('could not determine size of image: '+this.src,this.cycleW,this.cycleH);}}}return true;});if(requeue)return false;opts.cssBefore=opts.cssBefore||{};opts.animIn=opts.animIn||{};opts.animOut=opts.animOut||{};$slides.not(':eq('+first+')').css(opts.cssBefore);if(opts.cssFirst)$($slides[first]).css(opts.cssFirst);if(opts.timeout){opts.timeout=parseInt(opts.timeout);// ensure that timeout and speed settings are sane
if(opts.speed.constructor==String)opts.speed=$.fx.speeds[opts.speed]||parseInt(opts.speed);if(!opts.sync)opts.speed=opts.speed/2;var buffer=opts.fx=='shuffle'?500:250;while(opts.timeout-opts.speed<buffer){// sanitize timeout
opts.timeout+=opts.speed;}}if(opts.easing)opts.easeIn=opts.easeOut=opts.easing;if(!opts.speedIn)opts.speedIn=opts.speed;if(!opts.speedOut)opts.speedOut=opts.speed;opts.slideCount=els.length;opts.currSlide=opts.lastSlide=first;if(opts.random){if(++opts.randomIndex==els.length)opts.randomIndex=0;opts.nextSlide=opts.randomMap[opts.randomIndex];}else if(opts.backwards)opts.nextSlide=opts.startingSlide==0?els.length-1:opts.startingSlide-1;else opts.nextSlide=opts.startingSlide>=els.length-1?0:opts.startingSlide+1;// run transition init fn
if(!opts.multiFx){var init=$.fn.cycle.transitions[opts.fx];if($.isFunction(init))init($cont,$slides,opts);else if(opts.fx!='custom'&&!opts.multiFx){log('unknown transition: '+opts.fx,'; slideshow terminating');return false;}}// fire artificial events
var e0=$slides[first];if(opts.before.length)opts.before[0].apply(e0,[e0,e0,opts,true]);if(opts.after.length>1)opts.after[1].apply(e0,[e0,e0,opts,true]);if(opts.next)$(opts.next).bind(opts.prevNextEvent,function(){return advance(opts,opts.rev?-1:1);});if(opts.prev)$(opts.prev).bind(opts.prevNextEvent,function(){return advance(opts,opts.rev?1:-1);});if(opts.pager||opts.pagerAnchorBuilder)buildPager(els,opts);exposeAddSlide(opts,els);return opts;};// save off original opts so we can restore after clearing state
function saveOriginalOpts(opts){opts.original={before:[],after:[]};opts.original.cssBefore=$.extend({},opts.cssBefore);opts.original.cssAfter=$.extend({},opts.cssAfter);opts.original.animIn=$.extend({},opts.animIn);opts.original.animOut=$.extend({},opts.animOut);$.each(opts.before,function(){opts.original.before.push(this);});$.each(opts.after,function(){opts.original.after.push(this);});};function supportMultiTransitions(opts){var i,tx,txs=$.fn.cycle.transitions;// look for multiple effects
if(opts.fx.indexOf(',')>0){opts.multiFx=true;opts.fxs=opts.fx.replace(/\s*/g,'').split(',');// discard any bogus effect names
for(i=0;i<opts.fxs.length;i++){var fx=opts.fxs[i];tx=txs[fx];if(!tx||!txs.hasOwnProperty(fx)||!$.isFunction(tx)){log('discarding unknown transition: ',fx);opts.fxs.splice(i,1);i--;}}// if we have an empty list then we threw everything away!
if(!opts.fxs.length){log('No valid transitions named; slideshow terminating.');return false;}}else if(opts.fx=='all'){// auto-gen the list of transitions
opts.multiFx=true;opts.fxs=[];for(p in txs){tx=txs[p];if(txs.hasOwnProperty(p)&&$.isFunction(tx))opts.fxs.push(p);}}if(opts.multiFx&&opts.randomizeEffects){// munge the fxs array to make effect selection random
var r1=Math.floor(Math.random()*20)+30;for(i=0;i<r1;i++){var r2=Math.floor(Math.random()*opts.fxs.length);opts.fxs.push(opts.fxs.splice(r2,1)[0]);}debug('randomized fx sequence: ',opts.fxs);}return true;};// provide a mechanism for adding slides after the slideshow has started
function exposeAddSlide(opts,els){opts.addSlide=function(newSlide,prepend){var $s=$(newSlide),s=$s[0];if(!opts.autostopCount)opts.countdown++;els[prepend?'unshift':'push'](s);if(opts.els)opts.els[prepend?'unshift':'push'](s);// shuffle needs this
opts.slideCount=els.length;$s.css('position','absolute');$s[prepend?'prependTo':'appendTo'](opts.$cont);if(prepend){opts.currSlide++;opts.nextSlide++;}if(!$.support.opacity&&opts.cleartype&&!opts.cleartypeNoBg)clearTypeFix($s);if(opts.fit&&opts.width)$s.width(opts.width);if(opts.fit&&opts.height&&opts.height!='auto')$slides.height(opts.height);s.cycleH=opts.fit&&opts.height?opts.height:$s.height();s.cycleW=opts.fit&&opts.width?opts.width:$s.width();$s.css(opts.cssBefore);if(opts.pager||opts.pagerAnchorBuilder)$.fn.cycle.createPagerAnchor(els.length-1,s,$(opts.pager),els,opts);if($.isFunction(opts.onAddSlide))opts.onAddSlide($s);else $s.hide();// default behavior
};}// reset internal state; we do this on every pass in order to support multiple effects
$.fn.cycle.resetState=function(opts,fx){fx=fx||opts.fx;opts.before=[];opts.after=[];opts.cssBefore=$.extend({},opts.original.cssBefore);opts.cssAfter=$.extend({},opts.original.cssAfter);opts.animIn=$.extend({},opts.original.animIn);opts.animOut=$.extend({},opts.original.animOut);opts.fxFn=null;$.each(opts.original.before,function(){opts.before.push(this);});$.each(opts.original.after,function(){opts.after.push(this);});// re-init
var init=$.fn.cycle.transitions[fx];if($.isFunction(init))init(opts.$cont,$(opts.elements),opts);};// this is the main engine fn, it handles the timeouts, callbacks and slide index mgmt
function go(els,opts,manual,fwd){// opts.busy is true if we're in the middle of an animation
if(manual&&opts.busy&&opts.manualTrump){// let manual transitions requests trump active ones
debug('manualTrump in go(), stopping active transition');$(els).stop(true,true);opts.busy=false;}// don't begin another timeout-based transition if there is one active
if(opts.busy){debug('transition active, ignoring new tx request');return;}var p=opts.$cont[0],curr=els[opts.currSlide],next=els[opts.nextSlide];// stop cycling if we have an outstanding stop request
if(p.cycleStop!=opts.stopCount||slideTimeout[opts.pager.split(" ")[0].substring(1)]===0&&!manual)return;// check to see if we should stop cycling based on autostop options
if(!manual&&!p.cyclePause&&!opts.bounce&&(opts.autostop&&--opts.countdown<=0||opts.nowrap&&!opts.random&&opts.nextSlide<opts.currSlide)){if(opts.end)opts.end(opts);return;}// if slideshow is paused, only transition on a manual trigger
var changed=false;if((manual||!p.cyclePause)&&opts.nextSlide!=opts.currSlide){changed=true;var fx=opts.fx;// keep trying to get the slide size if we don't have it yet
curr.cycleH=curr.cycleH||$(curr).height();curr.cycleW=curr.cycleW||$(curr).width();next.cycleH=next.cycleH||$(next).height();next.cycleW=next.cycleW||$(next).width();// support multiple transition types
if(opts.multiFx){if(opts.lastFx==undefined||++opts.lastFx>=opts.fxs.length)opts.lastFx=0;fx=opts.fxs[opts.lastFx];opts.currFx=fx;}// one-time fx overrides apply to:  $('div').cycle(3,'zoom');
if(opts.oneTimeFx){fx=opts.oneTimeFx;opts.oneTimeFx=null;}$.fn.cycle.resetState(opts,fx);// run the before callbacks
if(opts.before.length)$.each(opts.before,function(i,o){if(p.cycleStop!=opts.stopCount)return;o.apply(next,[curr,next,opts,fwd]);});// stage the after callacks
var after=function after(){$.each(opts.after,function(i,o){if(p.cycleStop!=opts.stopCount)return;o.apply(next,[curr,next,opts,fwd]);});};debug('tx firing; currSlide: '+opts.currSlide+'; nextSlide: '+opts.nextSlide);// get ready to perform the transition
opts.busy=1;if(opts.fxFn)// fx function provided?
opts.fxFn(curr,next,opts,after,fwd,manual&&opts.fastOnEvent);else if($.isFunction($.fn.cycle[opts.fx]))// fx plugin ?
$.fn.cycle[opts.fx](curr,next,opts,after,fwd,manual&&opts.fastOnEvent);else $.fn.cycle.custom(curr,next,opts,after,fwd,manual&&opts.fastOnEvent);}if(changed||opts.nextSlide==opts.currSlide){// calculate the next slide
opts.lastSlide=opts.currSlide;if(opts.random){opts.currSlide=opts.nextSlide;if(++opts.randomIndex==els.length)opts.randomIndex=0;opts.nextSlide=opts.randomMap[opts.randomIndex];if(opts.nextSlide==opts.currSlide)opts.nextSlide=opts.currSlide==opts.slideCount-1?0:opts.currSlide+1;}else if(opts.backwards){var roll=opts.nextSlide-1<0;if(roll&&opts.bounce){opts.backwards=!opts.backwards;opts.nextSlide=1;opts.currSlide=0;}else{opts.nextSlide=roll?els.length-1:opts.nextSlide-1;opts.currSlide=roll?0:opts.nextSlide+1;}}else{// sequence
var roll=opts.nextSlide+1==els.length;if(roll&&opts.bounce){opts.backwards=!opts.backwards;opts.nextSlide=els.length-2;opts.currSlide=els.length-1;}else{opts.nextSlide=roll?0:opts.nextSlide+1;opts.currSlide=roll?els.length-1:opts.nextSlide-1;}}}if(changed&&opts.pager)opts.updateActivePagerLink(opts.pager,opts.currSlide,opts.activePagerClass);// stage the next transition
var ms=0;if(opts.timeout&&!opts.continuous)ms=getTimeout(els[opts.currSlide],els[opts.nextSlide],opts,fwd);else if(opts.continuous&&p.cyclePause)// continuous shows work off an after callback, not this timer logic
ms=10;if(ms>0)slideTimeout[opts.pager.split(" ")[0].substring(1)]=setTimeout(function(){go(els,opts,0,!opts.rev&&!opts.backwards);},ms);};// invoked after transition
$.fn.cycle.updateActivePagerLink=function(pager,currSlide,clsName){$(pager).each(function(){$(this).children().removeClass(clsName).eq(currSlide).addClass(clsName);});};// calculate timeout value for current transition
function getTimeout(curr,next,opts,fwd){if(opts.timeoutFn){// call user provided calc fn
var t=opts.timeoutFn.call(curr,curr,next,opts,fwd);while(t-opts.speed<250){// sanitize timeout
t+=opts.speed;}debug('calculated timeout: '+t+'; speed: '+opts.speed);if(t!==false)return t;}return opts.timeout;};// expose next/prev function, caller must pass in state
$.fn.cycle.next=function(opts){advance(opts,opts.rev?-1:1);};$.fn.cycle.prev=function(opts){advance(opts,opts.rev?1:-1);};// advance slide forward or back
function advance(opts,val){var els=opts.elements;var p=opts.$cont[0],timeout=slideTimeout[opts.pager.split(" ")[0].substring(1)];if(timeout){clearTimeout(timeout);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}if(opts.random&&val<0){// move back to the previously display slide
opts.randomIndex--;if(--opts.randomIndex==-2)opts.randomIndex=els.length-2;else if(opts.randomIndex==-1)opts.randomIndex=els.length-1;opts.nextSlide=opts.randomMap[opts.randomIndex];}else if(opts.random){opts.nextSlide=opts.randomMap[opts.randomIndex];}else{opts.nextSlide=opts.currSlide+val;if(opts.nextSlide<0){if(opts.nowrap)return false;opts.nextSlide=els.length-1;}else if(opts.nextSlide>=els.length){if(opts.nowrap)return false;opts.nextSlide=0;}}var cb=opts.onPrevNextEvent||opts.prevNextClick;// prevNextClick is deprecated
if($.isFunction(cb))cb(val>0,opts.nextSlide,els[opts.nextSlide]);go(els,opts,1,val>=0);return false;};function buildPager(els,opts){var $p=$(opts.pager);$.each(els,function(i,o){$.fn.cycle.createPagerAnchor(i,o,$p,els,opts);});opts.updateActivePagerLink(opts.pager,opts.startingSlide,opts.activePagerClass);};$.fn.cycle.createPagerAnchor=function(i,el,$p,els,opts){var a;if($.isFunction(opts.pagerAnchorBuilder)){a=opts.pagerAnchorBuilder(i,el);debug('pagerAnchorBuilder('+i+', el) returned: '+a);}else a='<a href="#">'+(i+1)+'</a>';if(!a)return;var $a=$(a);// don't reparent if anchor is in the dom
if($a.parents('body').length===0){var arr=[];if($p.length>1){$p.each(function(){var $clone=$a.clone(true);$(this).append($clone);arr.push($clone[0]);});$a=$(arr);}else{$a.appendTo($p);}}opts.pagerAnchors=opts.pagerAnchors||[];opts.pagerAnchors.push($a);$a.bind(opts.pagerEvent,function(e){e.preventDefault();opts.nextSlide=i;var p=opts.$cont[0],timeout=slideTimeout[opts.pager.split(" ")[0].substring(1)];if(timeout){clearTimeout(timeout);slideTimeout[opts.pager.split(" ")[0].substring(1)]=0;}var cb=opts.onPagerEvent||opts.pagerClick;// pagerClick is deprecated
if($.isFunction(cb))cb(opts.nextSlide,els[opts.nextSlide]);go(els,opts,1,opts.currSlide<i);// trigger the trans
//		return false; // <== allow bubble
});if(!/^click/.test(opts.pagerEvent)&&!opts.allowPagerClickBubble)$a.bind('click.cycle',function(){return false;});// suppress click
if(opts.pauseOnPagerHover)$a.hover(function(){opts.$cont[0].cyclePause++;},function(){opts.$cont[0].cyclePause--;});};// helper fn to calculate the number of slides between the current and the next
$.fn.cycle.hopsFromLast=function(opts,fwd){var hops,l=opts.lastSlide,c=opts.currSlide;if(fwd)hops=c>l?c-l:opts.slideCount-l;else hops=c<l?l-c:l+opts.slideCount-c;return hops;};// fix clearType problems in ie6 by setting an explicit bg color
// (otherwise text slides look horrible during a fade transition)
function clearTypeFix($slides){debug('applying clearType background-color hack');function hex(s){s=parseInt(s).toString(16);return s.length<2?'0'+s:s;};function getBg(e){for(;e&&e.nodeName.toLowerCase()!='html';e=e.parentNode){var v=$.css(e,'background-color');if(v.indexOf('rgb')>=0){var rgb=v.match(/\d+/g);return'#'+hex(rgb[0])+hex(rgb[1])+hex(rgb[2]);}if(v&&v!='transparent')return v;}return'#ffffff';//return 'transparent';
};//$slides.each(function() { $(this).css('background-color', getBg(this)); });
};// reset common props before the next transition
$.fn.cycle.commonReset=function(curr,next,opts,w,h,rev){$(opts.elements).not(curr).hide();opts.cssBefore.opacity=1;opts.cssBefore.display='block';if(w!==false&&next.cycleW>0)opts.cssBefore.width=next.cycleW;if(h!==false&&next.cycleH>0)opts.cssBefore.height=next.cycleH;opts.cssAfter=opts.cssAfter||{};opts.cssAfter.display='none';$(curr).css('zIndex',opts.slideCount+(rev===true?1:0));$(next).css('zIndex',opts.slideCount+(rev===true?0:1));};// the actual fn for effecting a transition
$.fn.cycle.custom=function(curr,next,opts,cb,fwd,speedOverride){var $l=$(curr),$n=$(next);var speedIn=opts.speedIn,speedOut=opts.speedOut,easeIn=opts.easeIn,easeOut=opts.easeOut;$n.css(opts.cssBefore);if(speedOverride){if(typeof speedOverride=='number')speedIn=speedOut=speedOverride;else speedIn=speedOut=1;easeIn=easeOut=null;}var fn=function fn(){$n.animate(opts.animIn,speedIn,easeIn,cb);};$l.animate(opts.animOut,speedOut,easeOut,function(){if(opts.cssAfter)$l.css(opts.cssAfter);if(!opts.sync)fn();});if(opts.sync)fn();};// transition definitions - only fade is defined here, transition pack defines the rest
$.fn.cycle.transitions={fade:function fade($cont,$slides,opts){$slides.not(':eq('+opts.currSlide+')').css('opacity',0);opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.cssBefore.opacity=0;});opts.animIn={opacity:1};opts.animOut={opacity:0};opts.cssBefore={top:0,left:0};}};$.fn.cycle.ver=function(){return ver;};// override these globally if you like (they are all optional)
$.fn.cycle.defaults={fx:'fade',// name of transition effect (or comma separated names, ex: 'fade,scrollUp,shuffle')
timeout:4000,// milliseconds between slide transitions (0 to disable auto advance)
timeoutFn:null,// callback for determining per-slide timeout value:  function(currSlideElement, nextSlideElement, options, forwardFlag)
continuous:0,// true to start next transition immediately after current one completes
speed:1000,// speed of the transition (any valid fx speed value)
speedIn:null,// speed of the 'in' transition
speedOut:null,// speed of the 'out' transition
next:null,// selector for element to use as event trigger for next slide
prev:null,// selector for element to use as event trigger for previous slide
//	prevNextClick: null,  // @deprecated; please use onPrevNextEvent instead
onPrevNextEvent:null,// callback fn for prev/next events: function(isNext, zeroBasedSlideIndex, slideElement)
prevNextEvent:'click.cycle',// event which drives the manual transition to the previous or next slide
pager:null,// selector for element to use as pager container
//pagerClick   null,  // @deprecated; please use onPagerEvent instead
onPagerEvent:null,// callback fn for pager events: function(zeroBasedSlideIndex, slideElement)
pagerEvent:'click.cycle',// name of event which drives the pager navigation
allowPagerClickBubble:false,// allows or prevents click event on pager anchors from bubbling
pagerAnchorBuilder:null,// callback fn for building anchor links:  function(index, DOMelement)
before:null,// transition callback (scope set to element to be shown):	 function(currSlideElement, nextSlideElement, options, forwardFlag)
after:null,// transition callback (scope set to element that was shown):  function(currSlideElement, nextSlideElement, options, forwardFlag)
end:null,// callback invoked when the slideshow terminates (use with autostop or nowrap options): function(options)
easing:null,// easing method for both in and out transitions
easeIn:null,// easing for "in" transition
easeOut:null,// easing for "out" transition
shuffle:null,// coords for shuffle animation, ex: { top:15, left: 200 }
animIn:null,// properties that define how the slide animates in
animOut:null,// properties that define how the slide animates out
cssBefore:null,// properties that define the initial state of the slide before transitioning in
cssAfter:null,// properties that defined the state of the slide after transitioning out
fxFn:null,// function used to control the transition: function(currSlideElement, nextSlideElement, options, afterCalback, forwardFlag)
height:'auto',// container height
startingSlide:0,// zero-based index of the first slide to be displayed
sync:1,// true if in/out transitions should occur simultaneously
random:0,// true for random, false for sequence (not applicable to shuffle fx)
fit:0,// force slides to fit container
containerResize:1,// resize container to fit largest slide
pause:0,// true to enable "pause on hover"
pauseOnPagerHover:0,// true to pause when hovering over pager link
autostop:0,// true to end slideshow after X transitions (where X == slide count)
autostopCount:0,// number of transitions (optionally used with autostop to define X)
delay:0,// additional delay (in ms) for first transition (hint: can be negative)
slideExpr:null,// expression for selecting slides (if something other than all children is required)
cleartype:!$.support.opacity,// true if clearType corrections should be applied (for IE)
cleartypeNoBg:false,// set to true to disable extra cleartype fixing (leave false to force background color setting on slides)
nowrap:0,// true to prevent slideshow from wrapping
fastOnEvent:0,// force fast transitions when triggered manually (via pager or prev/next); value == time in ms
randomizeEffects:1,// valid when multiple effects are used; true to make the effect sequence random
rev:0,// causes animations to transition in reverse
manualTrump:true,// causes manual transition to stop an active transition instead of being ignored
requeueOnImageNotLoaded:true,// requeue the slideshow if any image slides are not yet loaded
requeueTimeout:250,// ms delay for requeue
activePagerClass:'activeSlide',// class name used for the active pager link
updateActivePagerLink:null,// callback fn invoked to update the active pager link (adds/removes activePagerClass style)
backwards:false// true to start slideshow at last slide and move backwards through the stack
};})(jQuery);/*!
 * jQuery Cycle Plugin Transition Definitions
 * This script is a plugin for the jQuery Cycle Plugin
 * Examples and documentation at: http://malsup.com/jquery/cycle/
 * Copyright (c) 2007-2010 M. Alsup
 * Version:	 2.72
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */(function($){//
// These functions define one-time slide initialization for the named
// transitions. To save file size feel free to remove any of these that you
// don't need.
//
$.fn.cycle.transitions.none=function($cont,$slides,opts){opts.fxFn=function(curr,next,opts,after){$(next).show();$(curr).hide();after();};};// scrollUp/Down/Left/Right
$.fn.cycle.transitions.scrollUp=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var h=$cont.height();opts.cssBefore={top:h,left:0};opts.cssFirst={top:0};opts.animIn={top:0};opts.animOut={top:-h};};$.fn.cycle.transitions.scrollDown=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var h=$cont.height();opts.cssFirst={top:0};opts.cssBefore={top:-h,left:0};opts.animIn={top:0};opts.animOut={top:h};};$.fn.cycle.transitions.scrollLeft=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var w=$cont.width();opts.cssFirst={left:0};opts.cssBefore={left:w,top:0};opts.animIn={left:0};opts.animOut={left:0-w};};$.fn.cycle.transitions.scrollRight=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push($.fn.cycle.commonReset);var w=$cont.width();opts.cssFirst={left:0};opts.cssBefore={left:-w,top:0};opts.animIn={left:0};opts.animOut={left:w};};$.fn.cycle.transitions.scrollHorz=function($cont,$slides,opts){$cont.css('overflow','hidden').width();opts.before.push(function(curr,next,opts,fwd){$.fn.cycle.commonReset(curr,next,opts);opts.cssBefore.left=fwd?next.cycleW-1:1-next.cycleW;opts.animOut.left=fwd?-curr.cycleW:curr.cycleW;});opts.cssFirst={left:0};opts.cssBefore={top:0};opts.animIn={left:0};opts.animOut={top:0};};$.fn.cycle.transitions.scrollVert=function($cont,$slides,opts){$cont.css('overflow','hidden');opts.before.push(function(curr,next,opts,fwd){$.fn.cycle.commonReset(curr,next,opts);opts.cssBefore.top=fwd?1-next.cycleH:next.cycleH-1;opts.animOut.top=fwd?curr.cycleH:-curr.cycleH;});opts.cssFirst={top:0};opts.cssBefore={left:0};opts.animIn={top:0};opts.animOut={left:0};};// slideX/slideY
$.fn.cycle.transitions.slideX=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$(opts.elements).not(curr).hide();$.fn.cycle.commonReset(curr,next,opts,false,true);opts.animIn.width=next.cycleW;});opts.cssBefore={left:0,top:0,width:0};opts.animIn={width:'show'};opts.animOut={width:0};};$.fn.cycle.transitions.slideY=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$(opts.elements).not(curr).hide();$.fn.cycle.commonReset(curr,next,opts,true,false);opts.animIn.height=next.cycleH;});opts.cssBefore={left:0,top:0,height:0};opts.animIn={height:'show'};opts.animOut={height:0};};// shuffle
$.fn.cycle.transitions.shuffle=function($cont,$slides,opts){var i,w=$cont.css('overflow','visible').width();$slides.css({left:0,top:0});opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,true,true);});// only adjust speed once!
if(!opts.speedAdjusted){opts.speed=opts.speed/2;// shuffle has 2 transitions
opts.speedAdjusted=true;}opts.random=0;opts.shuffle=opts.shuffle||{left:-w,top:15};opts.els=[];for(i=0;i<$slides.length;i++){opts.els.push($slides[i]);}for(i=0;i<opts.currSlide;i++){opts.els.push(opts.els.shift());}// custom transition fn (hat tip to Benjamin Sterling for this bit of sweetness!)
opts.fxFn=function(curr,next,opts,cb,fwd){var $el=fwd?$(curr):$(next);$(next).css(opts.cssBefore);var count=opts.slideCount;$el.animate(opts.shuffle,opts.speedIn,opts.easeIn,function(){var hops=$.fn.cycle.hopsFromLast(opts,fwd);for(var k=0;k<hops;k++){fwd?opts.els.push(opts.els.shift()):opts.els.unshift(opts.els.pop());}if(fwd){for(var i=0,len=opts.els.length;i<len;i++){$(opts.els[i]).css('z-index',len-i+count);}}else{var z=$(curr).css('z-index');$el.css('z-index',parseInt(z)+1+count);}$el.animate({left:0,top:0},opts.speedOut,opts.easeOut,function(){$(fwd?this:curr).hide();if(cb)cb();});});};opts.cssBefore={display:'block',opacity:1,top:0,left:0};};// turnUp/Down/Left/Right
$.fn.cycle.transitions.turnUp=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false);opts.cssBefore.top=next.cycleH;opts.animIn.height=next.cycleH;});opts.cssFirst={top:0};opts.cssBefore={left:0,height:0};opts.animIn={top:0};opts.animOut={height:0};};$.fn.cycle.transitions.turnDown=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false);opts.animIn.height=next.cycleH;opts.animOut.top=curr.cycleH;});opts.cssFirst={top:0};opts.cssBefore={left:0,top:0,height:0};opts.animOut={height:0};};$.fn.cycle.transitions.turnLeft=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true);opts.cssBefore.left=next.cycleW;opts.animIn.width=next.cycleW;});opts.cssBefore={top:0,width:0};opts.animIn={left:0};opts.animOut={width:0};};$.fn.cycle.transitions.turnRight=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true);opts.animIn.width=next.cycleW;opts.animOut.left=curr.cycleW;});opts.cssBefore={top:0,left:0,width:0};opts.animIn={left:0};opts.animOut={width:0};};// zoom
$.fn.cycle.transitions.zoom=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,false,true);opts.cssBefore.top=next.cycleH/2;opts.cssBefore.left=next.cycleW/2;opts.animIn={top:0,left:0,width:next.cycleW,height:next.cycleH};opts.animOut={width:0,height:0,top:curr.cycleH/2,left:curr.cycleW/2};});opts.cssFirst={top:0,left:0};opts.cssBefore={width:0,height:0};};// fadeZoom
$.fn.cycle.transitions.fadeZoom=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,false);opts.cssBefore.left=next.cycleW/2;opts.cssBefore.top=next.cycleH/2;opts.animIn={top:0,left:0,width:next.cycleW,height:next.cycleH};});opts.cssBefore={width:0,height:0};opts.animOut={opacity:0};};// blindX
$.fn.cycle.transitions.blindX=function($cont,$slides,opts){var w=$cont.css('overflow','hidden').width();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.animIn.width=next.cycleW;opts.animOut.left=curr.cycleW;});opts.cssBefore={left:w,top:0};opts.animIn={left:0};opts.animOut={left:w};};// blindY
$.fn.cycle.transitions.blindY=function($cont,$slides,opts){var h=$cont.css('overflow','hidden').height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.animIn.height=next.cycleH;opts.animOut.top=curr.cycleH;});opts.cssBefore={top:h,left:0};opts.animIn={top:0};opts.animOut={top:h};};// blindZ
$.fn.cycle.transitions.blindZ=function($cont,$slides,opts){var h=$cont.css('overflow','hidden').height();var w=$cont.width();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);opts.animIn.height=next.cycleH;opts.animOut.top=curr.cycleH;});opts.cssBefore={top:h,left:w};opts.animIn={top:0,left:0};opts.animOut={top:h,left:w};};// growX - grow horizontally from centered 0 width
$.fn.cycle.transitions.growX=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true);opts.cssBefore.left=this.cycleW/2;opts.animIn={left:0,width:this.cycleW};opts.animOut={left:0};});opts.cssBefore={width:0,top:0};};// growY - grow vertically from centered 0 height
$.fn.cycle.transitions.growY=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false);opts.cssBefore.top=this.cycleH/2;opts.animIn={top:0,height:this.cycleH};opts.animOut={top:0};});opts.cssBefore={height:0,left:0};};// curtainX - squeeze in both edges horizontally
$.fn.cycle.transitions.curtainX=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,false,true,true);opts.cssBefore.left=next.cycleW/2;opts.animIn={left:0,width:this.cycleW};opts.animOut={left:curr.cycleW/2,width:0};});opts.cssBefore={top:0,width:0};};// curtainY - squeeze in both edges vertically
$.fn.cycle.transitions.curtainY=function($cont,$slides,opts){opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,false,true);opts.cssBefore.top=next.cycleH/2;opts.animIn={top:0,height:next.cycleH};opts.animOut={top:curr.cycleH/2,height:0};});opts.cssBefore={left:0,height:0};};// cover - curr slide covered by next slide
$.fn.cycle.transitions.cover=function($cont,$slides,opts){var d=opts.direction||'left';var w=$cont.css('overflow','hidden').width();var h=$cont.height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts);if(d=='right')opts.cssBefore.left=-w;else if(d=='up')opts.cssBefore.top=h;else if(d=='down')opts.cssBefore.top=-h;else opts.cssBefore.left=w;});opts.animIn={left:0,top:0};opts.animOut={opacity:1};opts.cssBefore={top:0,left:0};};// uncover - curr slide moves off next slide
$.fn.cycle.transitions.uncover=function($cont,$slides,opts){var d=opts.direction||'left';var w=$cont.css('overflow','hidden').width();var h=$cont.height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,true,true);if(d=='right')opts.animOut.left=w;else if(d=='up')opts.animOut.top=-h;else if(d=='down')opts.animOut.top=h;else opts.animOut.left=-w;});opts.animIn={left:0,top:0};opts.animOut={opacity:1};opts.cssBefore={top:0,left:0};};// toss - move top slide and fade away
$.fn.cycle.transitions.toss=function($cont,$slides,opts){var w=$cont.css('overflow','visible').width();var h=$cont.height();opts.before.push(function(curr,next,opts){$.fn.cycle.commonReset(curr,next,opts,true,true,true);// provide default toss settings if animOut not provided
if(!opts.animOut.left&&!opts.animOut.top)opts.animOut={left:w*2,top:-h/2,opacity:0};else opts.animOut.opacity=0;});opts.cssBefore={left:0,top:0};opts.animIn={left:0};};// wipe - clip animation
$.fn.cycle.transitions.wipe=function($cont,$slides,opts){var w=$cont.css('overflow','hidden').width();var h=$cont.height();opts.cssBefore=opts.cssBefore||{};var clip;if(opts.clip){if(/l2r/.test(opts.clip))clip='rect(0px 0px '+h+'px 0px)';else if(/r2l/.test(opts.clip))clip='rect(0px '+w+'px '+h+'px '+w+'px)';else if(/t2b/.test(opts.clip))clip='rect(0px '+w+'px 0px 0px)';else if(/b2t/.test(opts.clip))clip='rect('+h+'px '+w+'px '+h+'px 0px)';else if(/zoom/.test(opts.clip)){var top=parseInt(h/2);var left=parseInt(w/2);clip='rect('+top+'px '+left+'px '+top+'px '+left+'px)';}}opts.cssBefore.clip=opts.cssBefore.clip||clip||'rect(0px 0px 0px 0px)';var d=opts.cssBefore.clip.match(/(\d+)/g);var t=parseInt(d[0]),r=parseInt(d[1]),b=parseInt(d[2]),l=parseInt(d[3]);opts.before.push(function(curr,next,opts){if(curr==next)return;var $curr=$(curr),$next=$(next);$.fn.cycle.commonReset(curr,next,opts,true,true,false);opts.cssAfter.display='block';var step=1,count=parseInt(opts.speedIn/13)-1;(function f(){var tt=t?t-parseInt(step*(t/count)):0;var ll=l?l-parseInt(step*(l/count)):0;var bb=b<h?b+parseInt(step*((h-b)/count||1)):h;var rr=r<w?r+parseInt(step*((w-r)/count||1)):w;$next.css({clip:'rect('+tt+'px '+rr+'px '+bb+'px '+ll+'px)'});step++<=count?setTimeout(f,13):$curr.css('display','none');})();});opts.cssBefore={display:'block',opacity:1,top:0,left:0};opts.animIn={left:0};opts.animOut={left:0};};})(jQuery);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * fancyBox - jQuery Plugin
 * version: 2.1.5 (Fri, 14 Jun 2013)
 * @requires jQuery v1.6 or later
 *
 * Examples at http://fancyapps.com/fancybox/
 * License: www.fancyapps.com/fancybox/#license
 *
 * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
 *
 */(function(window,document,$,undefined){"use strict";var H=$("html"),W=$(window),D=$(document),F=$.fancybox=function(){F.open.apply(this,arguments);},IE=navigator.userAgent.match(/msie/i),didUpdate=null,isTouch=document.createTouch!==undefined,isQuery=function isQuery(obj){return obj&&obj.hasOwnProperty&&obj instanceof $;},isString=function isString(str){return str&&$.type(str)==="string";},isPercentage=function isPercentage(str){return isString(str)&&str.indexOf('%')>0;},isScrollable=function isScrollable(el){return el&&!(el.style.overflow&&el.style.overflow==='hidden')&&(el.clientWidth&&el.scrollWidth>el.clientWidth||el.clientHeight&&el.scrollHeight>el.clientHeight);},getScalar=function getScalar(orig,dim){var value=parseInt(orig,10)||0;if(dim&&isPercentage(orig)){value=F.getViewport()[dim]/100*value;}return Math.ceil(value);},getValue=function getValue(value,dim){return getScalar(value,dim)+'px';};$.extend(F,{// The current version of fancyBox
version:'2.1.5',defaults:{padding:15,margin:20,width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,// Set to 2 for retina display support
autoSize:true,autoHeight:false,autoWidth:false,autoResize:true,autoCenter:!isTouch,fitToView:true,aspectRatio:false,topRatio:0.5,leftRatio:0.5,scrolling:'auto',// 'auto', 'yes' or 'no'
wrapCSS:'',arrows:true,closeBtn:true,closeClick:false,nextClick:false,mouseWheel:true,autoPlay:false,playSpeed:3000,preload:3,modal:false,loop:true,ajax:{dataType:'html',headers:{'X-fancyBox':true}},iframe:{scrolling:'auto',preload:true},swf:{wmode:'transparent',allowfullscreen:'true',allowscriptaccess:'always'},keys:{next:{13:'left',// enter
34:'up',// page down
39:'left',// right arrow
40:'up'// down arrow
},prev:{8:'right',// backspace
33:'down',// page up
37:'right',// left arrow
38:'down'// up arrow
},close:[27],// escape key
play:[32],// space - start/stop slideshow
toggle:[70]// letter "f" - toggle fullscreen
},direction:{next:'left',prev:'right'},scrollOutside:true,// Override some properties
index:0,type:null,href:null,content:null,title:null,ref:null,// HTML templates
tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+(IE?' allowtransparency="true"':'')+'></iframe>',error:'<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},// Properties for each animation type
// Opening fancyBox
openEffect:'fade',// 'elastic', 'fade' or 'none'
openSpeed:250,openEasing:'swing',openOpacity:true,openMethod:'zoomIn',// Closing fancyBox
closeEffect:'fade',// 'elastic', 'fade' or 'none'
closeSpeed:250,closeEasing:'swing',closeOpacity:true,closeMethod:'zoomOut',// Changing next gallery item
nextEffect:'elastic',// 'elastic', 'fade' or 'none'
nextSpeed:250,nextEasing:'swing',nextMethod:'changeIn',// Changing previous gallery item
prevEffect:'elastic',// 'elastic', 'fade' or 'none'
prevSpeed:250,prevEasing:'swing',prevMethod:'changeOut',// Enable default helpers
helpers:{overlay:true,title:true},// Callbacks
onCancel:$.noop,// If canceling
beforeLoad:$.noop,// Before loading
afterLoad:$.noop,// After loading
beforeShow:$.noop,// Before changing in current item
afterShow:$.noop,// After opening
beforeChange:$.noop,// Before changing gallery item
beforeClose:$.noop,// Before closing
afterClose:$.noop// After closing
},//Current state
group:{},// Selected group
opts:{},// Group options
previous:null,// Previous element
coming:null,// Element being loaded
current:null,// Currently loaded element
isActive:false,// Is activated
isOpen:false,// Is currently open
isOpened:false,// Have been fully opened at least once
wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:false},// Loaders
ajaxLoad:null,imgPreload:null,// Some collections
transitions:{},helpers:{},/*
		 *	Static methods
		 */open:function open(group,opts){if(!group){return;}if(!$.isPlainObject(opts)){opts={};}// Close if already active
if(false===F.close(true)){return;}// Normalize group
if(!$.isArray(group)){group=isQuery(group)?$(group).get():[group];}// Recheck if the type of each element is `object` and set content type (image, ajax, etc)
$.each(group,function(i,element){var obj={},href,title,ref,content,type,rez,hrefParts,selector;if($.type(element)==="object"){// Check if is DOM element
if(element.nodeType){element=$(element);}if(isQuery(element)){obj={href:element.data('fancybox-href')||element.attr('href'),title:element.data('fancybox-title')||element.attr('title'),ref:element.data('fancybox-ref')||element.attr('ref'),isDom:true,element:element};if($.metadata){$.extend(true,obj,element.metadata());}}else{obj=element;}}href=opts.href||obj.href||(isString(element)?element:null);title=opts.title!==undefined?opts.title:obj.title||'';ref=opts.ref!==undefined?opts.ref:obj.ref||'';content=opts.content||obj.content;type=content?'html':opts.type||obj.type;if(!type&&obj.isDom){type=element.data('fancybox-type');if(!type){rez=element.attr('class').match(/fancybox\.(\w+)/);type=rez?rez[1]:null;}}if(isString(href)){// Try to guess the content type
if(!type){if(F.isImage(href)){type='image';}else if(F.isSWF(href)){type='swf';}else if(href.charAt(0)==='#'){type='inline';}else if(isString(element)){type='html';content=element;}}// Split url into two pieces with source url and content selector, e.g,
// "/mypage.html #my_id" will load "/mypage.html" and display element having id "my_id"
if(type==='ajax'){hrefParts=href.split(/\s+/,2);href=hrefParts.shift();selector=hrefParts.shift();}}if(!content){if(type==='inline'){if(href){content=$(isString(href)?href.replace(/.*(?=#[^\s]+$)/,''):href);//strip for ie7
}else if(obj.isDom){content=element;}}else if(type==='html'){content=href;}else if(!type&&!href&&obj.isDom){type='inline';content=element;}}$.extend(obj,{href:href,type:type,content:content,title:title,selector:selector,ref:ref});group[i]=obj;});// Extend the defaults
F.opts=$.extend(true,{},F.defaults,opts);// All options are merged recursive except keys
if(opts.keys!==undefined){F.opts.keys=opts.keys?$.extend({},F.defaults.keys,opts.keys):false;}F.group=group;return F._start(F.opts.index);},// Cancel image loading or abort ajax request
cancel:function cancel(){var coming=F.coming;if(!coming||false===F.trigger('onCancel')){return;}F.hideLoading();if(F.ajaxLoad){F.ajaxLoad.abort();}F.ajaxLoad=null;if(F.imgPreload){F.imgPreload.onload=F.imgPreload.onerror=null;}if(coming.wrap){coming.wrap.stop(true,true).trigger('onReset').remove();}F.coming=null;// If the first item has been canceled, then clear everything
if(!F.current){F._afterZoomOut(coming);}},// Start closing animation if is open; remove immediately if opening/closing
close:function close(event){F.cancel();if(false===F.trigger('beforeClose')){return;}F.unbindEvents();if(!F.isActive){return;}if(!F.isOpen||event===true){$('.fancybox-wrap').stop(true).trigger('onReset').remove();F._afterZoomOut();}else{F.isOpen=F.isOpened=false;F.isClosing=true;$('.fancybox-item, .fancybox-nav').remove();F.wrap.stop(true,true).removeClass('fancybox-opened');F.transitions[F.current.closeMethod]();}},// Manage slideshow:
//   $.fancybox.play(); - toggle slideshow
//   $.fancybox.play( true ); - start
//   $.fancybox.play( false ); - stop
play:function play(action){var clear=function clear(){clearTimeout(F.player.timer);},set=function set(){clear();if(F.current&&F.player.isActive){F.player.timer=setTimeout(F.next,F.current.playSpeed);}},stop=function stop(){clear();D.unbind('.player');F.player.isActive=false;F.trigger('onPlayEnd');},start=function start(){if(F.current&&(F.current.loop||F.current.index<F.group.length-1)){F.player.isActive=true;D.bind({'onCancel.player beforeClose.player':stop,'onUpdate.player':set,'beforeLoad.player':clear});set();F.trigger('onPlayStart');}};if(action===true||!F.player.isActive&&action!==false){start();}else{stop();}},// Navigate to next gallery item
next:function next(direction){var current=F.current;if(current){if(!isString(direction)){direction=current.direction.next;}F.jumpto(current.index+1,direction,'next');}},// Navigate to previous gallery item
prev:function prev(direction){var current=F.current;if(current){if(!isString(direction)){direction=current.direction.prev;}F.jumpto(current.index-1,direction,'prev');}},// Navigate to gallery item by index
jumpto:function jumpto(index,direction,router){var current=F.current;if(!current){return;}index=getScalar(index);F.direction=direction||current.direction[index>=current.index?'next':'prev'];F.router=router||'jumpto';if(current.loop){if(index<0){index=current.group.length+index%current.group.length;}index=index%current.group.length;}if(current.group[index]!==undefined){F.cancel();F._start(index);}},// Center inside viewport and toggle position type to fixed or absolute if needed
reposition:function reposition(e,onlyAbsolute){var current=F.current,wrap=current?current.wrap:null,pos;if(wrap){pos=F._getPosition(onlyAbsolute);if(e&&e.type==='scroll'){delete pos.position;wrap.stop(true,true).animate(pos,200);}else{wrap.css(pos);current.pos=$.extend({},current.dim,pos);}}},update:function update(e){var type=e&&e.type,anyway=!type||type==='orientationchange';if(anyway){clearTimeout(didUpdate);didUpdate=null;}if(!F.isOpen||didUpdate){return;}didUpdate=setTimeout(function(){var current=F.current;if(!current||F.isClosing){return;}F.wrap.removeClass('fancybox-tmp');if(anyway||type==='load'||type==='resize'&&current.autoResize){F._setDimension();}if(!(type==='scroll'&&current.canShrink)){F.reposition(e);}F.trigger('onUpdate');didUpdate=null;},anyway&&!isTouch?0:300);},// Shrink content to fit inside viewport or restore if resized
toggle:function toggle(action){if(F.isOpen){F.current.fitToView=$.type(action)==="boolean"?action:!F.current.fitToView;// Help browser to restore document dimensions
if(isTouch){F.wrap.removeAttr('style').addClass('fancybox-tmp');F.trigger('onUpdate');}F.update();}},hideLoading:function hideLoading(){D.unbind('.loading');$('#fancybox-loading').remove();},showLoading:function showLoading(){var el,viewport;F.hideLoading();el=$('<div id="fancybox-loading"><div></div></div>').click(F.cancel).appendTo('body');// If user will press the escape-button, the request will be canceled
D.bind('keydown.loading',function(e){if((e.which||e.keyCode)===27){e.preventDefault();F.cancel();}});if(!F.defaults.fixed){viewport=F.getViewport();el.css({position:'absolute',top:viewport.h*0.5+viewport.y,left:viewport.w*0.5+viewport.x});}},getViewport:function getViewport(){var locked=F.current&&F.current.locked||false,rez={x:W.scrollLeft(),y:W.scrollTop()};if(locked){rez.w=locked[0].clientWidth;rez.h=locked[0].clientHeight;}else{// See http://bugs.jquery.com/ticket/6724
rez.w=isTouch&&window.innerWidth?window.innerWidth:W.width();rez.h=isTouch&&window.innerHeight?window.innerHeight:W.height();}return rez;},// Unbind the keyboard / clicking actions
unbindEvents:function unbindEvents(){if(F.wrap&&isQuery(F.wrap)){F.wrap.unbind('.fb');}D.unbind('.fb');W.unbind('.fb');},bindEvents:function bindEvents(){var current=F.current,keys;if(!current){return;}// Changing document height on iOS devices triggers a 'resize' event,
// that can change document height... repeating infinitely
W.bind('orientationchange.fb'+(isTouch?'':' resize.fb')+(current.autoCenter&&!current.locked?' scroll.fb':''),F.update);keys=current.keys;if(keys){D.bind('keydown.fb',function(e){var code=e.which||e.keyCode,target=e.target||e.srcElement;// Skip esc key if loading, because showLoading will cancel preloading
if(code===27&&F.coming){return false;}// Ignore key combinations and key events within form elements
if(!e.ctrlKey&&!e.altKey&&!e.shiftKey&&!e.metaKey&&!(target&&(target.type||$(target).is('[contenteditable]')))){$.each(keys,function(i,val){if(current.group.length>1&&val[code]!==undefined){F[i](val[code]);e.preventDefault();return false;}if($.inArray(code,val)>-1){F[i]();e.preventDefault();return false;}});}});}if($.fn.mousewheel&&current.mouseWheel){F.wrap.bind('mousewheel.fb',function(e,delta,deltaX,deltaY){var target=e.target||null,parent=$(target),canScroll=false;while(parent.length){if(canScroll||parent.is('.fancybox-skin')||parent.is('.fancybox-wrap')){break;}canScroll=isScrollable(parent[0]);parent=$(parent).parent();}if(delta!==0&&!canScroll){if(F.group.length>1&&!current.canShrink){if(deltaY>0||deltaX>0){F.prev(deltaY>0?'down':'left');}else if(deltaY<0||deltaX<0){F.next(deltaY<0?'up':'right');}e.preventDefault();}}});}},trigger:function trigger(event,o){var ret,obj=o||F.coming||F.current;if(!obj){return;}if($.isFunction(obj[event])){ret=obj[event].apply(obj,Array.prototype.slice.call(arguments,1));}if(ret===false){return false;}if(obj.helpers){$.each(obj.helpers,function(helper,opts){if(opts&&F.helpers[helper]&&$.isFunction(F.helpers[helper][event])){F.helpers[helper][event]($.extend(true,{},F.helpers[helper].defaults,opts),obj);}});}D.trigger(event);},isImage:function isImage(str){return isString(str)&&str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);},isSWF:function isSWF(str){return isString(str)&&str.match(/\.(swf)((\?|#).*)?$/i);},_start:function _start(index){var coming={},obj,href,type,margin,padding;index=getScalar(index);obj=F.group[index]||null;if(!obj){return false;}coming=$.extend(true,{},F.opts,obj);// Convert margin and padding properties to array - top, right, bottom, left
margin=coming.margin;padding=coming.padding;if($.type(margin)==='number'){coming.margin=[margin,margin,margin,margin];}if($.type(padding)==='number'){coming.padding=[padding,padding,padding,padding];}// 'modal' propery is just a shortcut
if(coming.modal){$.extend(true,coming,{closeBtn:false,closeClick:false,nextClick:false,arrows:false,mouseWheel:false,keys:null,helpers:{overlay:{closeClick:false}}});}// 'autoSize' property is a shortcut, too
if(coming.autoSize){coming.autoWidth=coming.autoHeight=true;}if(coming.width==='auto'){coming.autoWidth=true;}if(coming.height==='auto'){coming.autoHeight=true;}/*
			 * Add reference to the group, so it`s possible to access from callbacks, example:
			 * afterLoad : function() {
			 *     this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
			 * }
			 */coming.group=F.group;coming.index=index;// Give a chance for callback or helpers to update coming item (type, title, etc)
F.coming=coming;if(false===F.trigger('beforeLoad')){F.coming=null;return;}type=coming.type;href=coming.href;if(!type){F.coming=null;//If we can not determine content type then drop silently or display next/prev item if looping through gallery
if(F.current&&F.router&&F.router!=='jumpto'){F.current.index=index;return F[F.router](F.direction);}return false;}F.isActive=true;if(type==='image'||type==='swf'){coming.autoHeight=coming.autoWidth=false;coming.scrolling='visible';}if(type==='image'){coming.aspectRatio=true;}if(type==='iframe'&&isTouch){coming.scrolling='scroll';}// Build the neccessary markup
coming.wrap=$(coming.tpl.wrap).addClass('fancybox-'+(isTouch?'mobile':'desktop')+' fancybox-type-'+type+' fancybox-tmp '+coming.wrapCSS).appendTo(coming.parent||'body');$.extend(coming,{skin:$('.fancybox-skin',coming.wrap),outer:$('.fancybox-outer',coming.wrap),inner:$('.fancybox-inner',coming.wrap)});$.each(["Top","Right","Bottom","Left"],function(i,v){coming.skin.css('padding'+v,getValue(coming.padding[i]));});F.trigger('onReady');// Check before try to load; 'inline' and 'html' types need content, others - href
if(type==='inline'||type==='html'){if(!coming.content||!coming.content.length){return F._error('content');}}else if(!href){return F._error('href');}if(type==='image'){F._loadImage();}else if(type==='ajax'){F._loadAjax();}else if(type==='iframe'){F._loadIframe();}else{F._afterLoad();}},_error:function _error(type){$.extend(F.coming,{type:'html',autoWidth:true,autoHeight:true,minWidth:0,minHeight:0,scrolling:'no',hasError:type,content:F.coming.tpl.error});F._afterLoad();},_loadImage:function _loadImage(){// Reset preload image so it is later possible to check "complete" property
var img=F.imgPreload=new Image();img.onload=function(){this.onload=this.onerror=null;F.coming.width=this.width/F.opts.pixelRatio;F.coming.height=this.height/F.opts.pixelRatio;F._afterLoad();};img.onerror=function(){this.onload=this.onerror=null;F._error('image');};img.src=F.coming.href;if(img.complete!==true){F.showLoading();}},_loadAjax:function _loadAjax(){var coming=F.coming;F.showLoading();F.ajaxLoad=$.ajax($.extend({},coming.ajax,{url:coming.href,error:function error(jqXHR,textStatus){if(F.coming&&textStatus!=='abort'){F._error('ajax',jqXHR);}else{F.hideLoading();}},success:function success(data,textStatus){if(textStatus==='success'){coming.content=data;F._afterLoad();}}}));},_loadIframe:function _loadIframe(){var coming=F.coming,iframe=$(coming.tpl.iframe.replace(/\{rnd\}/g,new Date().getTime())).attr('scrolling',isTouch?'auto':coming.iframe.scrolling).attr('src',coming.href);// This helps IE
$(coming.wrap).bind('onReset',function(){try{$(this).find('iframe').hide().attr('src','//about:blank').end().empty();}catch(e){}});if(coming.iframe.preload){F.showLoading();iframe.one('load',function(){$(this).data('ready',1);// iOS will lose scrolling if we resize
if(!isTouch){$(this).bind('load.fb',F.update);}// Without this trick:
//   - iframe won't scroll on iOS devices
//   - IE7 sometimes displays empty iframe
$(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();F._afterLoad();});}coming.content=iframe.appendTo(coming.inner);if(!coming.iframe.preload){F._afterLoad();}},_preloadImages:function _preloadImages(){var group=F.group,current=F.current,len=group.length,cnt=current.preload?Math.min(current.preload,len-1):0,item,i;for(i=1;i<=cnt;i+=1){item=group[(current.index+i)%len];if(item.type==='image'&&item.href){new Image().src=item.href;}}},_afterLoad:function _afterLoad(){var coming=F.coming,previous=F.current,placeholder='fancybox-placeholder',current,content,type,scrolling,href,embed;F.hideLoading();if(!coming||F.isActive===false){return;}if(false===F.trigger('afterLoad',coming,previous)){coming.wrap.stop(true).trigger('onReset').remove();F.coming=null;return;}if(previous){F.trigger('beforeChange',previous);previous.wrap.stop(true).removeClass('fancybox-opened').find('.fancybox-item, .fancybox-nav').remove();}F.unbindEvents();current=coming;content=coming.content;type=coming.type;scrolling=coming.scrolling;$.extend(F,{wrap:current.wrap,skin:current.skin,outer:current.outer,inner:current.inner,current:current,previous:previous});href=current.href;switch(type){case'inline':case'ajax':case'html':if(current.selector){content=$('<div>').html(content).find(current.selector);}else if(isQuery(content)){if(!content.data(placeholder)){content.data(placeholder,$('<div class="'+placeholder+'"></div>').insertAfter(content).hide());}content=content.show().detach();current.wrap.bind('onReset',function(){if($(this).find(content).length){content.hide().replaceAll(content.data(placeholder)).data(placeholder,false);}});}break;case'image':content=current.tpl.image.replace('{href}',href);break;case'swf':content='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+href+'"></param>';embed='';$.each(current.swf,function(name,val){content+='<param name="'+name+'" value="'+val+'"></param>';embed+=' '+name+'="'+val+'"';});content+='<embed src="'+href+'" type="application/x-shockwave-flash" width="100%" height="100%"'+embed+'></embed></object>';break;}if(!(isQuery(content)&&content.parent().is(current.inner))){current.inner.append(content);}// Give a chance for helpers or callbacks to update elements
F.trigger('beforeShow');// Set scrolling before calculating dimensions
current.inner.css('overflow',scrolling==='yes'?'scroll':scrolling==='no'?'hidden':scrolling);// Set initial dimensions and start position
F._setDimension();F.reposition();F.isOpen=false;F.coming=null;F.bindEvents();if(!F.isOpened){$('.fancybox-wrap').not(current.wrap).stop(true).trigger('onReset').remove();}else if(previous.prevMethod){F.transitions[previous.prevMethod]();}F.transitions[F.isOpened?current.nextMethod:current.openMethod]();F._preloadImages();},_setDimension:function _setDimension(){var viewport=F.getViewport(),steps=0,canShrink=false,canExpand=false,wrap=F.wrap,skin=F.skin,inner=F.inner,current=F.current,width=current.width,height=current.height,minWidth=current.minWidth,minHeight=current.minHeight,maxWidth=current.maxWidth,maxHeight=current.maxHeight,scrolling=current.scrolling,scrollOut=current.scrollOutside?current.scrollbarWidth:0,margin=current.margin,wMargin=getScalar(margin[1]+margin[3]),hMargin=getScalar(margin[0]+margin[2]),wPadding,hPadding,wSpace,hSpace,origWidth,origHeight,origMaxWidth,origMaxHeight,ratio,width_,height_,maxWidth_,maxHeight_,iframe,body;// Reset dimensions so we could re-check actual size
wrap.add(skin).add(inner).width('auto').height('auto').removeClass('fancybox-tmp');wPadding=getScalar(skin.outerWidth(true)-skin.width());hPadding=getScalar(skin.outerHeight(true)-skin.height());// Any space between content and viewport (margin, padding, border, title)
wSpace=wMargin+wPadding;hSpace=hMargin+hPadding;origWidth=isPercentage(width)?(viewport.w-wSpace)*getScalar(width)/100:width;origHeight=isPercentage(height)?(viewport.h-hSpace)*getScalar(height)/100:height;if(current.type==='iframe'){iframe=current.content;if(current.autoHeight&&iframe.data('ready')===1){try{if(iframe[0].contentWindow.document.location){inner.width(origWidth).height(9999);body=iframe.contents().find('body');if(scrollOut){body.css('overflow-x','hidden');}origHeight=body.outerHeight(true);}}catch(e){}}}else if(current.autoWidth||current.autoHeight){inner.addClass('fancybox-tmp');// Set width or height in case we need to calculate only one dimension
if(!current.autoWidth){inner.width(origWidth);}if(!current.autoHeight){inner.height(origHeight);}if(current.autoWidth){origWidth=inner.width();}if(current.autoHeight){origHeight=inner.height();}inner.removeClass('fancybox-tmp');}width=getScalar(origWidth);height=getScalar(origHeight);ratio=origWidth/origHeight;// Calculations for the content
minWidth=getScalar(isPercentage(minWidth)?getScalar(minWidth,'w')-wSpace:minWidth);maxWidth=getScalar(isPercentage(maxWidth)?getScalar(maxWidth,'w')-wSpace:maxWidth);minHeight=getScalar(isPercentage(minHeight)?getScalar(minHeight,'h')-hSpace:minHeight);maxHeight=getScalar(isPercentage(maxHeight)?getScalar(maxHeight,'h')-hSpace:maxHeight);// These will be used to determine if wrap can fit in the viewport
origMaxWidth=maxWidth;origMaxHeight=maxHeight;if(current.fitToView){maxWidth=Math.min(viewport.w-wSpace,maxWidth);maxHeight=Math.min(viewport.h-hSpace,maxHeight);}maxWidth_=viewport.w-wMargin;maxHeight_=viewport.h-hMargin;if(current.aspectRatio){if(width>maxWidth){width=maxWidth;height=getScalar(width/ratio);}if(height>maxHeight){height=maxHeight;width=getScalar(height*ratio);}if(width<minWidth){width=minWidth;height=getScalar(width/ratio);}if(height<minHeight){height=minHeight;width=getScalar(height*ratio);}}else{width=Math.max(minWidth,Math.min(width,maxWidth));if(current.autoHeight&&current.type!=='iframe'){inner.width(width);height=inner.height();}height=Math.max(minHeight,Math.min(height,maxHeight));}// Try to fit inside viewport (including the title)
if(current.fitToView){inner.width(width).height(height);wrap.width(width+wPadding);// Real wrap dimensions
width_=wrap.width();height_=wrap.height();if(current.aspectRatio){while((width_>maxWidth_||height_>maxHeight_)&&width>minWidth&&height>minHeight){if(steps++>19){break;}height=Math.max(minHeight,Math.min(maxHeight,height-10));width=getScalar(height*ratio);if(width<minWidth){width=minWidth;height=getScalar(width/ratio);}if(width>maxWidth){width=maxWidth;height=getScalar(width/ratio);}inner.width(width).height(height);wrap.width(width+wPadding);width_=wrap.width();height_=wrap.height();}}else{width=Math.max(minWidth,Math.min(width,width-(width_-maxWidth_)));height=Math.max(minHeight,Math.min(height,height-(height_-maxHeight_)));}}if(scrollOut&&scrolling==='auto'&&height<origHeight&&width+wPadding+scrollOut<maxWidth_){width+=scrollOut;}inner.width(width).height(height);wrap.width(width+wPadding);width_=wrap.width();height_=wrap.height();canShrink=(width_>maxWidth_||height_>maxHeight_)&&width>minWidth&&height>minHeight;canExpand=current.aspectRatio?width<origMaxWidth&&height<origMaxHeight&&width<origWidth&&height<origHeight:(width<origMaxWidth||height<origMaxHeight)&&(width<origWidth||height<origHeight);$.extend(current,{dim:{width:getValue(width_),height:getValue(height_)},origWidth:origWidth,origHeight:origHeight,canShrink:canShrink,canExpand:canExpand,wPadding:wPadding,hPadding:hPadding,wrapSpace:height_-skin.outerHeight(true),skinSpace:skin.height()-height});if(!iframe&&current.autoHeight&&height>minHeight&&height<maxHeight&&!canExpand){inner.height('auto');}},_getPosition:function _getPosition(onlyAbsolute){var current=F.current,viewport=F.getViewport(),margin=current.margin,width=F.wrap.width()+margin[1]+margin[3],height=F.wrap.height()+margin[0]+margin[2],rez={position:'absolute',top:margin[0],left:margin[3]};if(current.autoCenter&&current.fixed&&!onlyAbsolute&&height<=viewport.h&&width<=viewport.w){rez.position='fixed';}else if(!current.locked){rez.top+=viewport.y;rez.left+=viewport.x;}rez.top=getValue(Math.max(rez.top,rez.top+(viewport.h-height)*current.topRatio));rez.left=getValue(Math.max(rez.left,rez.left+(viewport.w-width)*current.leftRatio));return rez;},_afterZoomIn:function _afterZoomIn(){var current=F.current;if(!current){return;}F.isOpen=F.isOpened=true;F.wrap.css('overflow','visible').addClass('fancybox-opened');F.update();// Assign a click event
if(current.closeClick||current.nextClick&&F.group.length>1){F.inner.css('cursor','pointer').bind('click.fb',function(e){if(!$(e.target).is('a')&&!$(e.target).parent().is('a')){e.preventDefault();F[current.closeClick?'close':'next']();}});}// Create a close button
if(current.closeBtn){$(current.tpl.closeBtn).appendTo(F.skin).bind('click.fb',function(e){e.preventDefault();F.close();});}// Create navigation arrows
if(current.arrows&&F.group.length>1){if(current.loop||current.index>0){$(current.tpl.prev).appendTo(F.outer).bind('click.fb',F.prev);}if(current.loop||current.index<F.group.length-1){$(current.tpl.next).appendTo(F.outer).bind('click.fb',F.next);}}F.trigger('afterShow');// Stop the slideshow if this is the last item
if(!current.loop&&current.index===current.group.length-1){F.play(false);}else if(F.opts.autoPlay&&!F.player.isActive){F.opts.autoPlay=false;F.play();}},_afterZoomOut:function _afterZoomOut(obj){obj=obj||F.current;$('.fancybox-wrap').trigger('onReset').remove();$.extend(F,{group:{},opts:{},router:false,current:null,isActive:false,isOpened:false,isOpen:false,isClosing:false,wrap:null,skin:null,outer:null,inner:null});F.trigger('afterClose',obj);}});/*
	 *	Default transitions
	 */F.transitions={getOrigPosition:function getOrigPosition(){var current=F.current,element=current.element,orig=current.orig,pos={},width=50,height=50,hPadding=current.hPadding,wPadding=current.wPadding,viewport=F.getViewport();if(!orig&&current.isDom&&element.is(':visible')){orig=element.find('img:first');if(!orig.length){orig=element;}}if(isQuery(orig)){pos=orig.offset();if(orig.is('img')){width=orig.outerWidth();height=orig.outerHeight();}}else{pos.top=viewport.y+(viewport.h-height)*current.topRatio;pos.left=viewport.x+(viewport.w-width)*current.leftRatio;}if(F.wrap.css('position')==='fixed'||current.locked){pos.top-=viewport.y;pos.left-=viewport.x;}pos={top:getValue(pos.top-hPadding*current.topRatio),left:getValue(pos.left-wPadding*current.leftRatio),width:getValue(width+wPadding),height:getValue(height+hPadding)};return pos;},step:function step(now,fx){var ratio,padding,value,prop=fx.prop,current=F.current,wrapSpace=current.wrapSpace,skinSpace=current.skinSpace;if(prop==='width'||prop==='height'){ratio=fx.end===fx.start?1:(now-fx.start)/(fx.end-fx.start);if(F.isClosing){ratio=1-ratio;}padding=prop==='width'?current.wPadding:current.hPadding;value=now-padding;F.skin[prop](getScalar(prop==='width'?value:value-wrapSpace*ratio));F.inner[prop](getScalar(prop==='width'?value:value-wrapSpace*ratio-skinSpace*ratio));}},zoomIn:function zoomIn(){var current=F.current,startPos=current.pos,effect=current.openEffect,elastic=effect==='elastic',endPos=$.extend({opacity:1},startPos);// Remove "position" property that breaks older IE
delete endPos.position;if(elastic){startPos=this.getOrigPosition();if(current.openOpacity){startPos.opacity=0.1;}}else if(effect==='fade'){startPos.opacity=0.1;}F.wrap.css(startPos).animate(endPos,{duration:effect==='none'?0:current.openSpeed,easing:current.openEasing,step:elastic?this.step:null,complete:F._afterZoomIn});},zoomOut:function zoomOut(){var current=F.current,effect=current.closeEffect,elastic=effect==='elastic',endPos={opacity:0.1};if(elastic){endPos=this.getOrigPosition();if(current.closeOpacity){endPos.opacity=0.1;}}F.wrap.animate(endPos,{duration:effect==='none'?0:current.closeSpeed,easing:current.closeEasing,step:elastic?this.step:null,complete:F._afterZoomOut});},changeIn:function changeIn(){var current=F.current,effect=current.nextEffect,startPos=current.pos,endPos={opacity:1},direction=F.direction,distance=200,field;startPos.opacity=0.1;if(effect==='elastic'){field=direction==='down'||direction==='up'?'top':'left';if(direction==='down'||direction==='right'){startPos[field]=getValue(getScalar(startPos[field])-distance);endPos[field]='+='+distance+'px';}else{startPos[field]=getValue(getScalar(startPos[field])+distance);endPos[field]='-='+distance+'px';}}// Workaround for http://bugs.jquery.com/ticket/12273
if(effect==='none'){F._afterZoomIn();}else{F.wrap.css(startPos).animate(endPos,{duration:current.nextSpeed,easing:current.nextEasing,complete:F._afterZoomIn});}},changeOut:function changeOut(){var previous=F.previous,effect=previous.prevEffect,endPos={opacity:0.1},direction=F.direction,distance=200;if(effect==='elastic'){endPos[direction==='down'||direction==='up'?'top':'left']=(direction==='up'||direction==='left'?'-':'+')+'='+distance+'px';}previous.wrap.animate(endPos,{duration:effect==='none'?0:previous.prevSpeed,easing:previous.prevEasing,complete:function complete(){$(this).trigger('onReset').remove();}});}};/*
	 *	Overlay helper
	 */F.helpers.overlay={defaults:{closeClick:true,// if true, fancyBox will be closed when user clicks on the overlay
speedOut:200,// duration of fadeOut animation
showEarly:true,// indicates if should be opened immediately or wait until the content is ready
css:{},// custom CSS properties
locked:!isTouch,// if true, the content will be locked into overlay
fixed:true// if false, the overlay CSS position property will not be set to "fixed"
},overlay:null,// current handle
fixed:false,// indicates if the overlay has position "fixed"
el:$('html'),// element that contains "the lock"
// Public methods
create:function create(opts){opts=$.extend({},this.defaults,opts);if(this.overlay){this.close();}this.overlay=$('<div class="fancybox-overlay"></div>').appendTo(F.coming?F.coming.parent:opts.parent);this.fixed=false;if(opts.fixed&&F.defaults.fixed){this.overlay.addClass('fancybox-overlay-fixed');this.fixed=true;}},open:function open(opts){var that=this;opts=$.extend({},this.defaults,opts);if(this.overlay){this.overlay.unbind('.overlay').width('auto').height('auto');}else{this.create(opts);}if(!this.fixed){W.bind('resize.overlay',$.proxy(this.update,this));this.update();}if(opts.closeClick){this.overlay.bind('click.overlay',function(e){if($(e.target).hasClass('fancybox-overlay')){if(F.isActive){F.close();}else{that.close();}return false;}});}this.overlay.css(opts.css).show();},close:function close(){var scrollV,scrollH;W.unbind('resize.overlay');if(this.el.hasClass('fancybox-lock')){$('.fancybox-margin').removeClass('fancybox-margin');scrollV=W.scrollTop();scrollH=W.scrollLeft();this.el.removeClass('fancybox-lock');W.scrollTop(scrollV).scrollLeft(scrollH);}$('.fancybox-overlay').remove().hide();$.extend(this,{overlay:null,fixed:false});},// Private, callbacks
update:function update(){var width='100%',offsetWidth;// Reset width/height so it will not mess
this.overlay.width(width).height('100%');// jQuery does not return reliable result for IE
if(IE){offsetWidth=Math.max(document.documentElement.offsetWidth,document.body.offsetWidth);if(D.width()>offsetWidth){width=D.width();}}else if(D.width()>W.width()){width=D.width();}this.overlay.width(width).height(D.height());},// This is where we can manipulate DOM, because later it would cause iframes to reload
onReady:function onReady(opts,obj){var overlay=this.overlay;$('.fancybox-overlay').stop(true,true);if(!overlay){this.create(opts);}if(opts.locked&&this.fixed&&obj.fixed){if(!overlay){this.margin=D.height()>W.height()?$('html').css('margin-right').replace("px",""):false;}obj.locked=this.overlay.append(obj.wrap);obj.fixed=false;}if(opts.showEarly===true){this.beforeShow.apply(this,arguments);}},beforeShow:function beforeShow(opts,obj){var scrollV,scrollH;if(obj.locked){if(this.margin!==false){$('*').filter(function(){return $(this).css('position')==='fixed'&&!$(this).hasClass("fancybox-overlay")&&!$(this).hasClass("fancybox-wrap");}).addClass('fancybox-margin');this.el.addClass('fancybox-margin');}scrollV=W.scrollTop();scrollH=W.scrollLeft();this.el.addClass('fancybox-lock');W.scrollTop(scrollV).scrollLeft(scrollH);}this.open(opts);},onUpdate:function onUpdate(){if(!this.fixed){this.update();}},afterClose:function afterClose(opts){// Remove overlay if exists and fancyBox is not opening
// (e.g., it is not being open using afterClose callback)
//if (this.overlay && !F.isActive) {
if(this.overlay&&!F.coming){this.overlay.fadeOut(opts.speedOut,$.proxy(this.close,this));}}};/*
	 *	Title helper
	 */F.helpers.title={defaults:{type:'float',// 'float', 'inside', 'outside' or 'over',
position:'bottom'// 'top' or 'bottom'
},beforeShow:function beforeShow(opts){var current=F.current,text=current.title,type=opts.type,title,target;if($.isFunction(text)){text=text.call(current.element,current);}if(!isString(text)||$.trim(text)===''){return;}title=$('<div class="fancybox-title fancybox-title-'+type+'-wrap">'+text+'</div>');switch(type){case'inside':target=F.skin;break;case'outside':target=F.wrap;break;case'over':target=F.inner;break;default:// 'float'
target=F.skin;title.appendTo('body');if(IE){title.width(title.width());}title.wrapInner('<span class="child"></span>');//Increase bottom margin so this title will also fit into viewport
F.current.margin[2]+=Math.abs(getScalar(title.css('margin-bottom')));break;}title[opts.position==='top'?'prependTo':'appendTo'](target);}};// jQuery plugin initialization
$.fn.fancybox=function(options){var index,that=$(this),selector=this.selector||'',run=function run(e){var what=$(this).blur(),idx=index,relType,relVal;if(!(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey)&&!what.is('.fancybox-wrap')){relType=options.groupAttr||'data-fancybox-group';relVal=what.attr(relType);if(!relVal){relType='rel';relVal=what.get(0)[relType];}if(relVal&&relVal!==''&&relVal!=='nofollow'){what=selector.length?$(selector):that;what=what.filter('['+relType+'="'+relVal+'"]');idx=what.index(this);}options.index=idx;// Stop an event from bubbling if everything is fine
if(F.open(what,options)!==false){e.preventDefault();}}};options=options||{};index=options.index||0;if(!selector||options.live===false){that.unbind('click.fb-start').bind('click.fb-start',run);}else{D.undelegate(selector,'click.fb-start').delegate(selector+":not('.fancybox-item, .fancybox-nav')",'click.fb-start',run);}this.filter('[data-fancybox-start=1]').trigger('click');return this;};// Tests that need a body at doc ready
D.ready(function(){var w1,w2;if($.scrollbarWidth===undefined){// http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
$.scrollbarWidth=function(){var parent=$('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),child=parent.children(),width=child.innerWidth()-child.height(99).innerWidth();parent.remove();return width;};}if($.support.fixedPosition===undefined){$.support.fixedPosition=function(){var elem=$('<div style="position:fixed;top:20px;"></div>').appendTo('body'),fixed=elem[0].offsetTop===20||elem[0].offsetTop===15;elem.remove();return fixed;}();}$.extend(F.defaults,{scrollbarWidth:$.scrollbarWidth(),fixed:$.support.fixedPosition,parent:$('body')});//Get real width of page scroll-bar
w1=$(window).width();H.addClass('fancybox-lock-test');w2=$(window).width();H.removeClass('fancybox-lock-test');$("<style type='text/css'>.fancybox-margin{margin-right:"+(w2-w1)+"px;}</style>").appendTo("head");});})(window,document,jQuery);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(213);__webpack_require__(214);__webpack_require__(215);

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ActionTypes=__webpack_require__(101);var _workflow=__webpack_require__(217);var _workflow2=_interopRequireDefault(_workflow);var _mycalendar=__webpack_require__(502);var _mycalendar2=_interopRequireDefault(_mycalendar);var _rss=__webpack_require__(505);var _rss2=_interopRequireDefault(_rss);var _custompage=__webpack_require__(508);var _custompage2=_interopRequireDefault(_custompage);var _news=__webpack_require__(512);var _news2=_interopRequireDefault(_news);var _reportform=__webpack_require__(516);var _reportform2=_interopRequireDefault(_reportform);var _outdata=__webpack_require__(519);var _outdata2=_interopRequireDefault(_outdata);var _formmodecustomsearch=__webpack_require__(522);var _formmodecustomsearch2=_interopRequireDefault(_formmodecustomsearch);var _picture=__webpack_require__(527);var _picture2=_interopRequireDefault(_picture);var _view=__webpack_require__(551);var _view2=_interopRequireDefault(_view);var _morenews=__webpack_require__(552);var _morenews2=_interopRequireDefault(_morenews);var _stock=__webpack_require__(553);var _stock2=_interopRequireDefault(_stock);var _magazine=__webpack_require__(554);var _magazine2=_interopRequireDefault(_magazine);var _doccontent=__webpack_require__(556);var _doccontent2=_interopRequireDefault(_doccontent);var _audio=__webpack_require__(558);var _audio2=_interopRequireDefault(_audio);var _favourite=__webpack_require__(560);var _favourite2=_interopRequireDefault(_favourite);var _flash=__webpack_require__(561);var _flash2=_interopRequireDefault(_flash);var _imgslide=__webpack_require__(562);var _imgslide2=_interopRequireDefault(_imgslide);var _datacenter=__webpack_require__(565);var _datacenter2=_interopRequireDefault(_datacenter);var _video=__webpack_require__(567);var _video2=_interopRequireDefault(_video);var _weather=__webpack_require__(569);var _weather2=_interopRequireDefault(_weather);var _outtersys=__webpack_require__(571);var _outtersys2=_interopRequireDefault(_outtersys);var _scratchpad=__webpack_require__(573);var _scratchpad2=_interopRequireDefault(_scratchpad);var _slide=__webpack_require__(575);var _slide2=_interopRequireDefault(_slide);var _jobsinfo=__webpack_require__(577);var _jobsinfo2=_interopRequireDefault(_jobsinfo);var _searchengine=__webpack_require__(578);var _searchengine2=_interopRequireDefault(_searchengine);var _custommenu=__webpack_require__(580);var _custommenu2=_interopRequireDefault(_custommenu);var _notice=__webpack_require__(586);var _notice2=_interopRequireDefault(_notice);var _mail=__webpack_require__(588);var _mail2=_interopRequireDefault(_mail);var _coremail=__webpack_require__(592);var _coremail2=_interopRequireDefault(_coremail);var _blogstatus=__webpack_require__(593);var _blogstatus2=_interopRequireDefault(_blogstatus);var _contacts=__webpack_require__(596);var _contacts2=_interopRequireDefault(_contacts);var _addwf=__webpack_require__(600);var _addwf2=_interopRequireDefault(_addwf);var _task=__webpack_require__(604);var _task2=_interopRequireDefault(_task);var _newnotice=__webpack_require__(608);var _newnotice2=_interopRequireDefault(_newnotice);var _worktask=__webpack_require__(610);var _worktask2=_interopRequireDefault(_worktask);var _fnaBudgetAssistant=__webpack_require__(611);var _fnaBudgetAssistant2=_interopRequireDefault(_fnaBudgetAssistant);var _fnaBudgetAssistant3=__webpack_require__(612);var _fnaBudgetAssistant4=_interopRequireDefault(_fnaBudgetAssistant3);var _noreact=__webpack_require__(613);var _noreact2=_interopRequireDefault(_noreact);var _cooperation=__webpack_require__(614);var _cooperation2=_interopRequireDefault(_cooperation);var _meetingcalendar=__webpack_require__(617);var _meetingcalendar2=_interopRequireDefault(_meetingcalendar);var _myprojects=__webpack_require__(619);var _myprojects2=_interopRequireDefault(_myprojects);var _loginnews=__webpack_require__(622);var _loginnews2=_interopRequireDefault(_loginnews);var _login=__webpack_require__(626);var _login2=_interopRequireDefault(_login);var _newmeeting=__webpack_require__(636);var _newmeeting2=_interopRequireDefault(_newmeeting);var _dayplan=__webpack_require__(637);var _dayplan2=_interopRequireDefault(_dayplan);var _processtask=__webpack_require__(638);var _processtask2=_interopRequireDefault(_processtask);var _unreaddocs=__webpack_require__(639);var _unreaddocs2=_interopRequireDefault(_unreaddocs);var _newcustomers=__webpack_require__(640);var _newcustomers2=_interopRequireDefault(_newcustomers);var _messagereminding=__webpack_require__(641);var _messagereminding2=_interopRequireDefault(_messagereminding);var _news_dy=__webpack_require__(642);var _news_dy2=_interopRequireDefault(_news_dy);var _customelement=__webpack_require__(646);var _customelement2=_interopRequireDefault(_customelement);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//宁波市中级人民法院文档中心元素
//最新客户元素
//我的任务元素
//最新会议元素
//import Plan from './plan/';
//import MyCalendar from './mycalendar_fs/';
var Element=function(_React$Component){(0,_inherits3.default)(Element,_React$Component);function Element(props){(0,_classCallCheck3.default)(this,Element);var _this=(0,_possibleConstructorReturn3.default)(this,(Element.__proto__||(0,_getPrototypeOf2.default)(Element)).call(this,props));_this.state={fontSizeMp:{}};_this.getElementStyle=_this.getElementStyle.bind(_this);return _this;}(0,_createClass3.default)(Element,[{key:'getElementStyle',value:function getElementStyle(id,fontSizeMp){var config=this.props.config;var eid=config.item.eid;if(!(0,_lodash.isEmpty)(fontSizeMp)&&id==eid){this.setState({fontSizeMp:fontSizeMp});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'render',value:function render(){var config=this.props.config;var fontSizeMp=this.state.fontSizeMp;var _config$item=config.item,eid=_config$item.eid,ebaseid=_config$item.ebaseid;if(/^Custom_/.test(ebaseid)){return _react2.default.createElement(_customelement2.default,{key:eid,config:config});}switch(ebaseid){case _ActionTypes.ELEMENT_TYPES.WORKFLOW:return _react2.default.createElement(_workflow2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.RSS:return _react2.default.createElement(_rss2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.CUSTOMPAGE:return _react2.default.createElement(_custompage2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEWS:return _react2.default.createElement(_news2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.REPORTFORM:return _react2.default.createElement(_reportform2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.OUTDATA:return _react2.default.createElement(_outdata2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FORMMODECUSTOMSEARCH:return _react2.default.createElement(_formmodecustomsearch2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});//case ELEMENT_TYPES.MESSAGE_REMINDING:
//case ELEMENT_TYPES.NEW_CUSTOMERS:
//case ELEMENT_TYPES.NEW_MEETING:
case _ActionTypes.ELEMENT_TYPES.MONTH_TARGET://case ELEMENT_TYPES.DAY_PLAN:
case _ActionTypes.ELEMENT_TYPES.SUBSCRIBE_KONWLEDG://case ELEMENT_TYPES.UNREAD_DOCS:
//case ELEMENT_TYPES.UNREAD_COOPERATION:
//case ELEMENT_TYPES.MY_PROJECTS:
return _react2.default.createElement(_view2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.PICTURE:return _react2.default.createElement(_picture2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MORE_NEWS:return _react2.default.createElement(_morenews2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.STOCK:return _react2.default.createElement(_stock2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MAGAZINE:return _react2.default.createElement(_magazine2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.DOC_CONTENT:return _react2.default.createElement(_doccontent2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.AUDIO:return _react2.default.createElement(_audio2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FAVOURITE:return _react2.default.createElement(_favourite2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FLASH:return _react2.default.createElement(_flash2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.IMGSLIDE:return _react2.default.createElement(_imgslide2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.DATACENTER:return _react2.default.createElement(_datacenter2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.VIDEO:return _react2.default.createElement(_video2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.WEATHER:return _react2.default.createElement(_weather2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.OUTTERSYS:return _react2.default.createElement(_outtersys2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.SCRATCHPAD:return _react2.default.createElement(_scratchpad2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.SLIDE:return _react2.default.createElement(_slide2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.JOBSINFO:return _react2.default.createElement(_jobsinfo2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.SEARCHENGINE:return _react2.default.createElement(_searchengine2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.CUSTOMMENU:return _react2.default.createElement(_custommenu2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NOTICE:return _react2.default.createElement(_notice2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MAIL:return _react2.default.createElement(_mail2.default,{key:eid,config:config,fontSizeMp:fontSizeMp,getElementStyle:this.getElementStyle});case _ActionTypes.ELEMENT_TYPES.COREMAIL:return _react2.default.createElement(_coremail2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.BLOGSTATUS:return _react2.default.createElement(_blogstatus2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.CONTACTS:return _react2.default.createElement(_contacts2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.ADDWF:return _react2.default.createElement(_addwf2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.TASK:return _react2.default.createElement(_task2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEWNOTICE:return _react2.default.createElement(_newnotice2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.WORKTASK:return _react2.default.createElement(_worktask2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FNABUDGETASSISTANT:return _react2.default.createElement(_fnaBudgetAssistant2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.FNABUDGETASSISTANT1:return _react2.default.createElement(_fnaBudgetAssistant4.default,{key:eid,config:config,fontSizeMp:fontSizeMp});// case ELEMENT_TYPES.PLAN:
//     return <Plan key={eid} config={config}/>
case _ActionTypes.ELEMENT_TYPES.MYCALENDAR:return _react2.default.createElement(_mycalendar2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.UNREAD_COOPERATION:return _react2.default.createElement(_cooperation2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MEETINGCALENDAR:return _react2.default.createElement(_meetingcalendar2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MY_PROJECTS:return _react2.default.createElement(_myprojects2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.LOGIN:return _react2.default.createElement(_login2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.LOGIN_NEWS:return _react2.default.createElement(_loginnews2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEW_MEETING:return _react2.default.createElement(_newmeeting2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.DAY_PLAN:return _react2.default.createElement(_dayplan2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MYTASK:return _react2.default.createElement(_processtask2.default,{key:eid,config:config});case _ActionTypes.ELEMENT_TYPES.UNREAD_DOCS:return _react2.default.createElement(_unreaddocs2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEW_CUSTOMERS:return _react2.default.createElement(_newcustomers2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.MESSAGE_REMINDING:return _react2.default.createElement(_messagereminding2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});case _ActionTypes.ELEMENT_TYPES.NEW_DY:return _react2.default.createElement(_news_dy2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});/*          case ELEMENT_TYPES.ELEMENTTABLE:
                            return <ElementTable key={eid} config={config}/>*/default:return _react2.default.createElement(_noreact2.default,{key:eid,config:config,fontSizeMp:fontSizeMp});}}}]);return Element;}(_react2.default.Component);/*//通用列表组件
import ElementTable from './elementtable/';*///自定义元素
//消息提醒元素
//未读文档元素
//每日计划元素
//登录前门户元素
exports.default=Element;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(431);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Workflow=function(_React$Component){(0,_inherits3.default)(Workflow,_React$Component);function Workflow(props){(0,_classCallCheck3.default)(this,Workflow);var _this=(0,_possibleConstructorReturn3.default)(this,(Workflow.__proto__||(0,_getPrototypeOf2.default)(Workflow)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Workflow,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(window.element_workflow_refresh&&(0,_typeof3.default)(window.element_workflow_refresh)=='object'){delete element_workflow_refresh[this.props.config.params.eid];}}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});var params=this.props.config.params;this.handleEData(params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/workflow','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentWillMount',value:function componentWillMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting,counts=edata.counts;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,counts:counts,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Workflow;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Workflow=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Workflow);exports.default=Workflow;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var ls=_ecCom.WeaTools.ls;var homepage=void 0;var isSetting=void 0;var hpid=void 0;var subCompanyId=void 0;var intMoveEid=void 0;var srcItem=void 0;var srcGroupFlag=void 0;var divLoc=void 0;var dragobj={};var _callback=void 0;var topHeight=0;var leftWidth=0;var scrolldom_scrollTop=0;var scrolldom_scrollLeft=0;var onerror=function onerror(){return false;};function on_ini(){var agent=navigator.userAgent;window.isOpr=agent.indexOf("Opera")>-1;window.isIE=agent.indexOf("IE")>-1&&!isOpr;window.isMoz=agent.indexOf("Mozilla")>-1&&!isOpr&&!isIE;if(isMoz){Event.prototype.__defineGetter__("x",function(){return this.clientX+2;});Event.prototype.__defineGetter__("y",function(){return this.clientY+2;});}}var oDel=function oDel(obj){if($(obj)!=null){$(obj).remove();}};$(function(){on_ini();//初始化拖动
var o=$(".header");});function dragStart(e,target,callback){window.global_event=e;if(e)e=e.nativeEvent;_callback=callback;//alert("target");
e=e||event;//if(e) e = e.
var srcElement=e.srcElement||e.target;if(!(srcElement.className=="header"||srcElement.className=="title"||srcElement.className=="rc-tabs-nav-wrap"||srcElement.className=="title-font"))return;if(!(e.button==1||e.button==0)){return;}if(dragobj.o){return;}if(target.className=="rc-tabs-nav-wrap")target=target.parentNode.parentNode.parentNode.parentNode.parentNode;if(target.className=="title-font")target=target.parentNode.parentNode;homepage=$(target.parentNode).parents(".homepage")[0];isSetting=$(homepage).attr("data-issetting");hpid=$(homepage).attr("data-hpid");subCompanyId=$(homepage).attr("data-subcompanyid");leftWidth=$(homepage).offset().left;topHeight=$(homepage).offset().top;scrolldom_scrollTop=$(homepage).scrollTop();scrolldom_scrollLeft=$(homepage).scrollLeft();dragobj.o=target.parentNode;//alert(dragobj.o.className+"------"+target.className);
srcGroupFlag=$($(target).parents(".group")[0]).attr('data-areaflag');//对象左上的坐标
dragobj.xy=getxy(dragobj.o);//鼠标的相对位置
dragobj.xx=new Array(e.x-dragobj.xy[1]+leftWidth,e.y-dragobj.xy[0]+topHeight);dragobj.o.style.width=dragobj.xy[2]+"px";dragobj.o.style.height=dragobj.xy[3]+"px";dragobj.o.style.left=e.x-dragobj.xx[0]+"px";dragobj.o.style.top=e.y-dragobj.xx[1]+"px";dragobj.o.style.position="absolute";//创建临时对象用于记住其原始位置，占位
var om=document.createElement("div");dragobj.otemp=om;om.style.width=dragobj.xy[2]+"px";om.style.height=dragobj.xy[3]+"px";om.className="location";om.style.width="auto";dragobj.o.parentNode.insertBefore(om,dragobj.o);return false;}document.onselectstart=function(){if(dragobj.o!=null){return false;}};document.onmouseup=function(e){if(dragobj.o!=null){var _eid=-1;try{_eid=dragobj.o.id.split("item_")[1];}catch(e){}dragobj.otemp.parentNode.insertBefore(dragobj.o,dragobj.otemp);dragobj.o.style.position="static";dragobj.o.style.width="auto";dragobj.o.style.height="auto";var targetAreaFlag=$(dragobj.otemp).parents(".group").attr('data-areaflag');//自定义页面拖动后刷新元素
if(_callback)_callback();MoveEData(srcGroupFlag,targetAreaFlag,_eid);oDel(dragobj.otemp);//停止拖放
dragobj={};}};document.onmousemove=function(e){e=e||event;if(dragobj.o!=null){dragobj.o.style.zIndex="1";dragobj.o.style.left=e.x-dragobj.xx[0]+"px";dragobj.o.style.top=e.y-dragobj.xx[1]+"px";dragobj.o.style.left=e.clientX;dragobj.o.style.top=e.clientY+document.body.scrollTop;//自动调整布局，显示拖放效果
createtmpl(e);}};//取得鼠标的坐标
function mouseCoords(ev){if(ev.pageX||ev.pageY){return{x:ev.pageX+scrolldom_scrollLeft,y:ev.pageY+scrolldom_scrollTop};}return{x:ev.clientX+scrolldom_scrollLeft-leftWidth,y:ev.clientY+scrolldom_scrollTop-topHeight};}//取得位置分别为上，左，宽，高,所有元素必须在同一容器内
function getxy(e){var a=new Array();var t=e.offsetTop;var l=e.offsetLeft;var w=e.offsetWidth;var h=e.offsetHeight;while(e=e.offsetParent){t+=e.offsetTop;l+=e.offsetLeft;}a[0]=t;a[1]=l;a[2]=w;a[3]=h;return a;}//判断e与o的位置
function inner(o,e){var a=getxy(o);//鼠标是否在o的内部
if(e.x>a[1]&&e.x<a[1]+a[2]&&e.y>a[0]&&e.y<a[0]+a[3]){if(e.y<a[0]+a[3]/2)//上半部分
return 1;else return 2;}else{return 0;}}//
function createtmpl(e){var items=$(homepage).find(".item");for(var i=0;i<items.length;i++){if(!items[i]||items[i]==dragobj.o)continue;//修正鼠标坐标
var mousePos=mouseCoords(e);var b=inner(items[i],mousePos);if(b==0)continue;dragobj.otemp.style.width="auto";if(b==1){items[i].parentNode.insertBefore(dragobj.otemp,items[i]);}else{if(items[i].nextSibling==null){items[i].parentNode.appendChild(dragobj.otemp);}else{items[i].parentNode.insertBefore(dragobj.otemp,items[i].nextSibling);}}}//处理拖放至边界外的情况
var groups=$(homepage).find(".group");for(var j=0;j<groups.length;j++){if(groups[j].innerHTML.indexOf("div")>-1||groups[j].innerHTML.indexOf("DIV")>-1)continue;var op=getxy(groups[j]);if(e.x+scrolldom_scrollLeft>op[1]&&e.x+scrolldom_scrollLeft<op[1]+op[2]&&e.y+scrolldom_scrollTop>op[0]&&e.y+scrolldom_scrollTop<op[0]+op[3]){groups[j].appendChild(dragobj.otemp);dragobj.otemp.style.width=op[2]-10+"px";}}}function MoveEData(srcFlag,targetFlag,eid){var srcItemEids="";var areaflag='data-areaflag';$(homepage).find(".group["+areaflag+"="+srcFlag+"]>.item").each(function(i){if(this.className=="item"){srcItemEids+=$(this).attr("data-eid")+",";}});var targetItemEids="";$(homepage).find(".group["+areaflag+"="+targetFlag+"]>.item").each(function(i){if(this.className=="item"){targetItemEids+=$(this).attr("data-eid")+",";}});if(targetItemEids=="")return;var params={hpid:hpid,subCompanyId:subCompanyId,eid:eid,srcFlag:srcFlag,targetFlag:targetFlag,srcStr:srcItemEids,targetStr:targetItemEids};_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/drag','POST',params).then(function(result){if(result.status==='failed'){_antd.message.error(result.errormsg);}else{ls.set('portal-'+hpid+'-'+isSetting,null);}});}module.exports={dragStart:dragStart};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(20);var _reactDom2=_interopRequireDefault(_reactDom);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _ESetting=__webpack_require__(122);var _ESetting2=_interopRequireDefault(_ESetting);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Toolbar=function(_React$Component){(0,_inherits3.default)(Toolbar,_React$Component);function Toolbar(props){(0,_classCallCheck3.default)(this,Toolbar);var _this=(0,_possibleConstructorReturn3.default)(this,(Toolbar.__proto__||(0,_getPrototypeOf2.default)(Toolbar)).call(this,props));_this.state={islock:'',icon:'',moreRouteurl:''};_this.handleLock=_this.handleLock.bind(_this);_this.handleOnSetting=_this.handleOnSetting.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Toolbar,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//判断流程元素是否存在自定义more页面
var config=this.props.config;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var moreRouteurl='';if(ebaseid=='8'||ebaseid=='7'){_ecCom.WeaTools.callApi('/api/portal/customMore/getRouteurl','POST',{ebaseid:ebaseid,eid:eid}).then(function(result){if(result.status=='200'&&result.moreRouteurl){_this2.setState({moreRouteurl:result.moreRouteurl});}});}}},{key:'handleDelete',value:function handleDelete(){var _props=this.props,config=_props.config,handleDelete=_props.handleDelete;var _config$params2=config.params,eid=_config$params2.eid,hpid=_config$params2.hpid,subCompanyId=_config$params2.subCompanyId;var ls=_ecCom.WeaTools.ls;var group=$($("#item_"+eid).parents(".group")[0]);var flag=group.attr('data-areaflag');var eids="";group.find(".item").each(function(){if($(this).attr("data-eid")!=eid)eids+=$(this).attr("data-eid")+",";});var portalHpinfo_setting=ls.getJSONObj('portal-'+hpid+'-true');var portalHpinfo=ls.getJSONObj('portal-'+hpid+'-false');portalHpinfo_setting&&ls.set('portal-'+hpid+'-true',(0,_common.hpinfoHandle)(portalHpinfo_setting,eid));portalHpinfo&&ls.set('portal-'+hpid+'-false',(0,_common.hpinfoHandle)(portalHpinfo,eid));_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/delete','POST',{hpid:hpid,eid:eid,delFlag:flag,delAreaElement:eids,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){handleDelete();}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleLock',value:function handleLock(){var _this3=this;var islock=this.state.islock;var _props$config$params=this.props.config.params,eid=_props$config$params.eid,hpid=_props$config$params.hpid,subCompanyId=_props$config$params.subCompanyId;_ecCom.WeaTools.callApi('/api/portal/elementtoolbar/'+(islock?'unlock':'lock'),'POST',{eid:eid,hpid:hpid,subCompanyId:subCompanyId}).then(function(result){if(result.status=="sucess"){_this3.setState({islock:!islock,icon:result.icon});}else{_antd.message.error(getLabel(83912,'操作失败！'),3);}});}},{key:'handleOnSetting',value:function handleOnSetting(){var _props2=this.props,config=_props2.config,handleRefresh=_props2.handleRefresh,getElementStyle=_props2.getElementStyle,datas=_props2.datas;var isSynergySetting=config.isSynergySetting,synergyParams=config.synergyParams;var _config$params3=config.params,eid=_config$params3.eid,ebaseid=_config$params3.ebaseid,hpid=_config$params3.hpid,subCompanyId=_config$params3.subCompanyId;var readyElement=['1','7','8','11','12','6','13','14','15','16','9','10','17','18','19','25','29','32','34','audio','blogStatus','favourite','Flash','menu','notice','picture','reportForm','searchengine','Slide','video','weather','scratchpad','DataCenter','MyCalendar','Task','plan','jobsinfo','outterSys','contacts','addwf','imgSlide','newNotice','OutData','FormModeCustomSearch','MeetingCalendar','CalendarEle','bookshelf','newMobilePicture','fnaBudgetAssistant','fnaBudgetAssistant1','CoreMail','news','processTask','login','7_DY'];if((0,_common.isContain)(readyElement,ebaseid)||/^Custom_/.test(ebaseid)){_reactDom2.default.render(_react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement(_antd.Spin,null)),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);_ecCom.WeaTools.callApi('/api/portal/setting/esetting','POST',{eid:eid,ebaseid:ebaseid,hpid:hpid,subCompanyId:subCompanyId},'json').then(function(result){result.hpid=hpid;result.subCompanyId=subCompanyId;result.eid=eid;result.ebaseid=ebaseid;result.dyParams=datas.dyParams;result.sebaseid=datas.sebaseid;_reactDom2.default.render(_react2.default.createElement(_ESetting2.default,{data:result,isSynergySetting:isSynergySetting,synergyParams:synergyParams,handleRefresh:handleRefresh,isSetting:config.isSetting,getElementStyle:getElementStyle}),$('.homepage[data-isSetting='+config.isSetting+'] #setting_'+eid)[0]);});}else{(0,_common.onSetting)(eid,ebaseid,hpid,subCompanyId);}}},{key:'render',value:function render(){var _props3=this.props,config=_props3.config,islock=_props3.islock,actions=_props3.actions,handleRefresh=_props3.handleRefresh;var _config$item=config.item,eid=_config$item.eid,ebaseid=_config$item.ebaseid,header=_config$item.header;var toolbar=header.toolbar;var lock=toolbar.lock,refresh=toolbar.refresh,setting=toolbar.setting,close=toolbar.close,more=toolbar.more;var _state=this.state,icon=_state.icon,moreRouteurl=_state.moreRouteurl;return _react2.default.createElement('span',{className:'toolbar',style:{position:'absolute'},id:'toolbar_'+eid},_react2.default.createElement('ul',null,lock?_react2.default.createElement('li',null,_react2.default.createElement(_antd.Popconfirm,{title:getLabel(19745,'此操作可能花较长的时间，是否继续？'),onConfirm:this.handleLock,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{'data-status':islock?'locked':'unlocked',href:'javascript:void(0);',title:lock.title},_react2.default.createElement('img',{src:icon||lock.img,border:'0',alt:''})))):'',refresh?_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'javascript:void(0);',name:'refreshbtn',id:'refresh_'+eid,onClick:handleRefresh,title:refresh.title},_react2.default.createElement('img',{src:refresh.img,border:'0',alt:''}))):'',setting?_react2.default.createElement('li',null,_react2.default.createElement('a',{href:'javascript:void(0)',onClick:this.handleOnSetting,title:setting.title},_react2.default.createElement('img',{className:'img_setting',src:setting.img,border:'0',alt:''}))):'',close?_react2.default.createElement('li',null,_react2.default.createElement(_antd.Popconfirm,{placement:'leftTop',title:getLabel(19747,'此元素被删除后将不能被恢复，是否继续？'),onConfirm:this.handleDelete,cancelText:getLabel(31129,'取消'),okText:getLabel(826,'确定')},_react2.default.createElement('a',{href:'javascript:void(0);',title:close.title},_react2.default.createElement('img',{src:close.img,border:'0',alt:''})))):'',more?_react2.default.createElement('li',{style:{width:'34px'}},_react2.default.createElement('a',{id:'more_'+eid,href:'javascript:void(0);',onClick:_common.openMoreWin.bind(this,eid,ebaseid,more.morehref,moreRouteurl)},_react2.default.createElement('img',{className:'img_more',id:'imgMore',border:'0',src:more.img,title:more.title,alt:''}))):''));}}]);return Toolbar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Toolbar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Toolbar);exports.default=Toolbar;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Content_mobilePicture=__webpack_require__(223);var _Content_mobilePicture2=_interopRequireDefault(_Content_mobilePicture);var _Content_=__webpack_require__(224);var _Content_2=_interopRequireDefault(_Content_);var _Content_3=__webpack_require__(284);var _Content_4=_interopRequireDefault(_Content_3);var _Content_5=__webpack_require__(285);var _Content_6=_interopRequireDefault(_Content_5);var _Content_7=__webpack_require__(286);var _Content_8=_interopRequireDefault(_Content_7);var _Content_9=__webpack_require__(287);var _Content_10=_interopRequireDefault(_Content_9);var _Content_11=__webpack_require__(288);var _Content_12=_interopRequireDefault(_Content_11);var _Content_13_new=__webpack_require__(289);var _Content_13_new2=_interopRequireDefault(_Content_13_new);var _Content_13=__webpack_require__(290);var _Content_14=_interopRequireDefault(_Content_13);var _Content_15=__webpack_require__(291);var _Content_16=_interopRequireDefault(_Content_15);var _Content_17=__webpack_require__(292);var _Content_18=_interopRequireDefault(_Content_17);var _Content_19=__webpack_require__(293);var _Content_20=_interopRequireDefault(_Content_19);var _Content_10_new=__webpack_require__(294);var _Content_10_new2=_interopRequireDefault(_Content_10_new);var _Content_21=__webpack_require__(295);var _Content_22=_interopRequireDefault(_Content_21);var _Content_23=__webpack_require__(296);var _Content_24=_interopRequireDefault(_Content_23);var _Content_25=__webpack_require__(297);var _Content_26=_interopRequireDefault(_Content_25);var _Content_27=__webpack_require__(298);var _Content_28=_interopRequireDefault(_Content_27);var _Content_29=__webpack_require__(299);var _Content_30=_interopRequireDefault(_Content_29);var _Content_31=__webpack_require__(300);var _Content_32=_interopRequireDefault(_Content_31);var _Content_Task=__webpack_require__(301);var _Content_Task2=_interopRequireDefault(_Content_Task);var _Content_33=__webpack_require__(302);var _Content_34=_interopRequireDefault(_Content_33);var _Content_audio=__webpack_require__(303);var _Content_audio2=_interopRequireDefault(_Content_audio);var _Content_blogStatus=__webpack_require__(304);var _Content_blogStatus2=_interopRequireDefault(_Content_blogStatus);var _Content_favourite=__webpack_require__(305);var _Content_favourite2=_interopRequireDefault(_Content_favourite);var _Content_Flash=__webpack_require__(306);var _Content_Flash2=_interopRequireDefault(_Content_Flash);var _Content_menu=__webpack_require__(307);var _Content_menu2=_interopRequireDefault(_Content_menu);var _Content_notice=__webpack_require__(308);var _Content_notice2=_interopRequireDefault(_Content_notice);var _Content_picture=__webpack_require__(309);var _Content_picture2=_interopRequireDefault(_Content_picture);var _Content_reportForm=__webpack_require__(313);var _Content_reportForm2=_interopRequireDefault(_Content_reportForm);var _Content_searchengine=__webpack_require__(314);var _Content_searchengine2=_interopRequireDefault(_Content_searchengine);var _Content_Slide=__webpack_require__(315);var _Content_Slide2=_interopRequireDefault(_Content_Slide);var _Content_video=__webpack_require__(317);var _Content_video2=_interopRequireDefault(_Content_video);var _Content_weather=__webpack_require__(320);var _Content_weather2=_interopRequireDefault(_Content_weather);var _Content_scratchpad=__webpack_require__(321);var _Content_scratchpad2=_interopRequireDefault(_Content_scratchpad);var _Content_MyCalendar=__webpack_require__(322);var _Content_MyCalendar2=_interopRequireDefault(_Content_MyCalendar);var _Content_DataCenter=__webpack_require__(323);var _Content_DataCenter2=_interopRequireDefault(_Content_DataCenter);var _Content_plan=__webpack_require__(324);var _Content_plan2=_interopRequireDefault(_Content_plan);var _Content_jobsinfo=__webpack_require__(325);var _Content_jobsinfo2=_interopRequireDefault(_Content_jobsinfo);var _Content_outterSys=__webpack_require__(326);var _Content_outterSys2=_interopRequireDefault(_Content_outterSys);var _Content_contacts=__webpack_require__(327);var _Content_contacts2=_interopRequireDefault(_Content_contacts);var _Content_addwf=__webpack_require__(328);var _Content_addwf2=_interopRequireDefault(_Content_addwf);var _Content_imgSlide=__webpack_require__(329);var _Content_imgSlide2=_interopRequireDefault(_Content_imgSlide);var _Content_newNotice=__webpack_require__(331);var _Content_newNotice2=_interopRequireDefault(_Content_newNotice);var _Content_OutData=__webpack_require__(332);var _Content_OutData2=_interopRequireDefault(_Content_OutData);var _Content_FormModeCustomSearch=__webpack_require__(333);var _Content_FormModeCustomSearch2=_interopRequireDefault(_Content_FormModeCustomSearch);var _Content_MeetingCalendar=__webpack_require__(334);var _Content_MeetingCalendar2=_interopRequireDefault(_Content_MeetingCalendar);var _Content_CalendarEle=__webpack_require__(335);var _Content_CalendarEle2=_interopRequireDefault(_Content_CalendarEle);var _Content_bookshelf=__webpack_require__(336);var _Content_bookshelf2=_interopRequireDefault(_Content_bookshelf);var _Content_newMobilePicture=__webpack_require__(337);var _Content_newMobilePicture2=_interopRequireDefault(_Content_newMobilePicture);var _Content_fnaBudgetAssistant=__webpack_require__(338);var _Content_fnaBudgetAssistant2=_interopRequireDefault(_Content_fnaBudgetAssistant);var _Content_fnaBudgetAssistant3=__webpack_require__(339);var _Content_fnaBudgetAssistant4=_interopRequireDefault(_Content_fnaBudgetAssistant3);var _Content_CoreMail=__webpack_require__(340);var _Content_CoreMail2=_interopRequireDefault(_Content_CoreMail);var _Content_news=__webpack_require__(389);var _Content_news2=_interopRequireDefault(_Content_news);var _Content_ProcessTask=__webpack_require__(390);var _Content_ProcessTask2=_interopRequireDefault(_Content_ProcessTask);var _Content_login=__webpack_require__(391);var _Content_login2=_interopRequireDefault(_Content_login);var _Content_CustomElement=__webpack_require__(392);var _Content_CustomElement2=_interopRequireDefault(_Content_CustomElement);var _Content_dy=__webpack_require__(393);var _Content_dy2=_interopRequireDefault(_Content_dy);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//
// 登录系统元素
// 公司新闻
// 审批助手元素
// 移动图片
// 会议元素
// 建模查询中心
// 公告元素
// 新建流程
// 集成登录
// 计划报告元素
// 日历日程
// 天气元素
// 幻灯片
// 图表元素
// 公告栏元素
// Flash元素
// 微博动态
// 知识订阅
// 计划任务
// 文档内容
// 期刊中心
// 我的项目
// 我的邮件
// 当月目标
// 未读文档
//import Content_13 from './content/Content_13'; // 未读协作
// 最新客户
// 文档中心
// 手机图片元素
var Tab4Content=function(_React$Component){(0,_inherits3.default)(Tab4Content,_React$Component);function Tab4Content(){(0,_classCallCheck3.default)(this,Tab4Content);return(0,_possibleConstructorReturn3.default)(this,(Tab4Content.__proto__||(0,_getPrototypeOf2.default)(Tab4Content)).apply(this,arguments));}(0,_createClass3.default)(Tab4Content,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,eContent=_props.eContent,synergyParams=_props.synergyParams,dyParams=_props.dyParams,sebaseid=_props.sebaseid;var props=(0,_extends3.default)({hpid:hpid,eid:eid,ebaseid:ebaseid,eShareLevel:eShareLevel,dyParams:dyParams,sebaseid:sebaseid},eContent);if(/_DY$/.test(ebaseid)){return _react2.default.createElement(_Content_dy2.default,(0,_extends3.default)({ref:ebaseid},props));}if(/^Custom_/.test(ebaseid)){return _react2.default.createElement(_Content_CustomElement2.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));}var tab4Content=_react2.default.createElement('div',null);switch(ebaseid){// 手机图片元素
case'mobilePicture':tab4Content=_react2.default.createElement(_Content_mobilePicture2.default,(0,_extends3.default)({ref:ebaseid},props));break;// RSS阅读器
case'1':tab4Content=_react2.default.createElement(_Content_2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 文档中心
case'7':tab4Content=_react2.default.createElement(_Content_4.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 流程中心
case'8':tab4Content=_react2.default.createElement(_Content_6.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 最新客户
case'11':tab4Content=_react2.default.createElement(_Content_8.default,(0,_extends3.default)({ref:ebaseid},props));break;// 最新会议
case'12':tab4Content=_react2.default.createElement(_Content_10.default,(0,_extends3.default)({ref:ebaseid},props));break;// 未读文档
case'6':tab4Content=_react2.default.createElement(_Content_12.default,(0,_extends3.default)({ref:ebaseid},props));break;// 未读协作
//case '13':tab4Content=<Content_13 ref={ebaseid} {...props}/>;break;
case'13':tab4Content=_react2.default.createElement(_Content_13_new2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 当月目标
case'14':tab4Content=_react2.default.createElement(_Content_14.default,(0,_extends3.default)({ref:ebaseid},props));break;// 当日计划
case'15':tab4Content=_react2.default.createElement(_Content_16.default,(0,_extends3.default)({ref:ebaseid},props));break;// 我的邮件
case'16':tab4Content=_react2.default.createElement(_Content_18.default,(0,_extends3.default)({ref:ebaseid},props));break;// 消息提醒
case'9':tab4Content=_react2.default.createElement(_Content_20.default,(0,_extends3.default)({ref:ebaseid},props));break;// 我的项目
//case '10':tab4Content=<Content_10 ref={ebaseid} {...props}/>;break;
case'10':tab4Content=_react2.default.createElement(_Content_10_new2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 多新闻中心
case'17':tab4Content=_react2.default.createElement(_Content_22.default,(0,_extends3.default)({ref:ebaseid},props));break;// 期刊中心
case'18':tab4Content=_react2.default.createElement(_Content_24.default,(0,_extends3.default)({ref:ebaseid},props));break;// 股票元素
case'19':tab4Content=_react2.default.createElement(_Content_26.default,(0,_extends3.default)({ref:ebaseid},props));break;// 文档内容
case'25':tab4Content=_react2.default.createElement(_Content_28.default,(0,_extends3.default)({ref:ebaseid},props));break;// 自定义页面
case'29':tab4Content=_react2.default.createElement(_Content_30.default,(0,_extends3.default)({ref:ebaseid},props));break;// 计划任务
case'32':tab4Content=_react2.default.createElement(_Content_32.default,(0,_extends3.default)({ref:ebaseid},props));break;// 任务元素
case'Task':tab4Content=_react2.default.createElement(_Content_Task2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 知识订阅
case'34':tab4Content=_react2.default.createElement(_Content_34.default,(0,_extends3.default)({ref:ebaseid},props));break;// 音频元素
case'audio':tab4Content=_react2.default.createElement(_Content_audio2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 微博动态
case'blogStatus':tab4Content=_react2.default.createElement(_Content_blogStatus2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 收藏元素
case'favourite':tab4Content=_react2.default.createElement(_Content_favourite2.default,(0,_extends3.default)({ref:ebaseid},props));break;// Flash元素
case'Flash':tab4Content=_react2.default.createElement(_Content_Flash2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 自定义菜单
case'menu':tab4Content=_react2.default.createElement(_Content_menu2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 公告栏元素
case'notice':tab4Content=_react2.default.createElement(_Content_notice2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 图片元素
case'picture':tab4Content=_react2.default.createElement(_Content_picture2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 图表元素
case'reportForm':tab4Content=_react2.default.createElement(_Content_reportForm2.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 搜索元素
case'searchengine':tab4Content=_react2.default.createElement(_Content_searchengine2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 幻灯片
case'Slide':tab4Content=_react2.default.createElement(_Content_Slide2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 视频元素
case'video':tab4Content=_react2.default.createElement(_Content_video2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 天气元素
case'weather':tab4Content=_react2.default.createElement(_Content_weather2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 便签元素
case'scratchpad':tab4Content=_react2.default.createElement(_Content_scratchpad2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 日历日程
case'MyCalendar':tab4Content=_react2.default.createElement(_Content_MyCalendar2.default,(0,_extends3.default)({ref:ebaseid},props,{synergyParams:synergyParams}));break;// 个人数据
case'DataCenter':tab4Content=_react2.default.createElement(_Content_DataCenter2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 计划报告元素
case'plan':tab4Content=_react2.default.createElement(_Content_plan2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 多岗位办理事项
case'jobsinfo':tab4Content=_react2.default.createElement(_Content_jobsinfo2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 集成登录
case'outterSys':tab4Content=_react2.default.createElement(_Content_outterSys2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 通讯录
case'contacts':tab4Content=_react2.default.createElement(_Content_contacts2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 新建流程
case'addwf':tab4Content=_react2.default.createElement(_Content_addwf2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 多图元素
case'imgSlide':tab4Content=_react2.default.createElement(_Content_imgSlide2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 公告元素
case'newNotice':tab4Content=_react2.default.createElement(_Content_newNotice2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 外部数据元素
case'OutData':tab4Content=_react2.default.createElement(_Content_OutData2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 建模查询中心
case'FormModeCustomSearch':tab4Content=_react2.default.createElement(_Content_FormModeCustomSearch2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 会议日历元素
case'MeetingCalendar':tab4Content=_react2.default.createElement(_Content_MeetingCalendar2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 会议元素
case'CalendarEle':tab4Content=_react2.default.createElement(_Content_CalendarEle2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 书柜元素
case'bookshelf':tab4Content=_react2.default.createElement(_Content_bookshelf2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 移动门户图片
case'newMobilePicture':tab4Content=_react2.default.createElement(_Content_newMobilePicture2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 移动门户图片
case'fnaBudgetAssistant':tab4Content=_react2.default.createElement(_Content_fnaBudgetAssistant2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 移动门户图片
case'fnaBudgetAssistant1':tab4Content=_react2.default.createElement(_Content_fnaBudgetAssistant4.default,(0,_extends3.default)({ref:ebaseid},props));break;// CoreMail邮箱
case'CoreMail':tab4Content=_react2.default.createElement(_Content_CoreMail2.default,(0,_extends3.default)({ref:ebaseid},props));break;// CoreMail邮箱
case'news':tab4Content=_react2.default.createElement(_Content_news2.default,(0,_extends3.default)({ref:ebaseid},props));break;//登录系统元素
case'login':tab4Content=_react2.default.createElement(_Content_login2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 我的任务元素
case'processTask':tab4Content=_react2.default.createElement(_Content_ProcessTask2.default,(0,_extends3.default)({ref:ebaseid},props));break;// 默认
default:tab4Content=_react2.default.createElement('div',null);}return tab4Content;}},{key:'getSaveValues',value:function getSaveValues(ebaseid){return this.refs[ebaseid].getSaveValues();}}]);return Tab4Content;}(_react2.default.Component);// 自定义元素
// CoreMail邮箱
// 费用报销智能助手
// 书柜元素
// 会议日历元素
// 外部数据元素
// 多图元素
// 通讯录
// 多岗位办理事项
// 个人数据
// 便签元素
// 视频元素
// 搜索元素
// 图片元素
// 自定义菜单
// 收藏元素
// 音频元素
// 任务元素
// 自定义页面
// 股票元素
// 多新闻中心
// 消息提醒
//import Content_10 from './content/Content_10'; // 我的项目
// 当日计划
// 未读协作
// 最新会议
// 流程中心
// RSS阅读器
exports.default=Tab4Content;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 手机图片元素
var Content_mobilePicture=function(_React$Component){(0,_inherits3.default)(Content_mobilePicture,_React$Component);function Content_mobilePicture(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_mobilePicture);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_mobilePicture.__proto__||(0,_getPrototypeOf2.default)(Content_mobilePicture)).call.apply(_ref,[this].concat(args))),_this),_this.state={eScrollSpeed:_this.props.eScrollSpeed,eImageSource:_this.props.eImageSource},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_mobilePicture,[{key:'render',value:function render(){var _this2=this;var columns=[{title:getLabel(350,'图片'),dataIndex:'src',width:'40%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'src')});}},{title:getLabel(22931,'图片名称'),dataIndex:'title',width:'15%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'title')});}},{title:getLabel(22932,'图片链接'),dataIndex:'link',width:'25%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'link')});}},{title:getLabel(88,'顺序'),dataIndex:'orderNum',width:'10%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'orderNum')});}},{title:getLabel(30585,'操作'),dataIndex:'operation',width:'10%',render:function render(text,record){return _react2.default.createElement('span',{onClick:_this2.onDetailDelete.bind(_this2,record.key)},getLabel(91,'删除'));}}];return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,"滚动速度"),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:this.state.eScrollSpeed,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eScrollSpeed:value});}}))),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:'\u56FE\u7247\u6765\u6E90',needTigger:true,showGroup:true,customComponent:_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'},onClick:this.onDetailAdd.bind(this)},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}}))},_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:this.state.eImageSource,pagination:false})));}},{key:'onDetailChange',value:function onDetailChange(key,type,value){var eImageSource=this.state.eImageSource;eImageSource[key][type]=value;this.setState({eImageSource:eImageSource});}},{key:'onDetailDelete',value:function onDetailDelete(key){var eImageSource=this.state.eImageSource;for(var i=0,len=eImageSource.length;i<len;i++){if(eImageSource[i].key==key){eImageSource.splice(i,1);break;}}this.setState({eImageSource:eImageSource});}},{key:'onDetailAdd',value:function onDetailAdd(){var eImageSource=this.state.eImageSource;eImageSource.push({key:eImageSource.length,src:'',title:'',link:'',orderNum:'0'});this.setState({eImageSource:eImageSource});}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentScrollSpeed:this.state.eScrollSpeed,eContentImageSource:this.state.eImageSource};}}]);return Content_mobilePicture;}(_react2.default.Component);exports.default=Content_mobilePicture;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// RSS阅读器
var Content_1=function(_React$Component){(0,_inherits3.default)(Content_1,_React$Component);function Content_1(){(0,_classCallCheck3.default)(this,Content_1);return(0,_possibleConstructorReturn3.default)(this,(Content_1.__proto__||(0,_getPrototypeOf2.default)(Content_1)).apply(this,arguments));}(0,_createClass3.default)(Content_1,[{key:'render',value:function render(){var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'1'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_1;}(_react2.default.Component);exports.default=Content_1;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(226), __esModule: true };

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74);
__webpack_require__(227);
module.exports = __webpack_require__(18).Array.from;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(55);
var $export = __webpack_require__(25);
var toObject = __webpack_require__(45);
var call = __webpack_require__(228);
var isArrayIter = __webpack_require__(229);
var toLength = __webpack_require__(73);
var createProperty = __webpack_require__(230);
var getIterFn = __webpack_require__(124);

$export($export.S + $export.F * !__webpack_require__(231)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(35);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(53);
var ITERATOR = __webpack_require__(30)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(31);
var createDesc = __webpack_require__(42);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(30)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(233);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(236);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
__webpack_require__(74);
module.exports = __webpack_require__(235);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(125);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(53);
module.exports = __webpack_require__(18).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
__webpack_require__(74);
module.exports = __webpack_require__(238);


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var get = __webpack_require__(124);
module.exports = __webpack_require__(18).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getMultiBrowserType=exports.getSingleBrowserType=exports.isMultiBrowserType=exports.MULTI_BROWSER_TYPE=exports.getDateTypeName=exports.DATE_TYPES=exports.getSelectedName=undefined;var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 获取下拉选择框中选中项的名称
var getSelectedName=exports.getSelectedName=function getSelectedName(options,key){var name='';for(var i=0,len=options.length;i<len;i++){if(options[i].key==key){name=options[i].showname;break;}}return name;};// 日期类型
var DATE_TYPES=exports.DATE_TYPES=[{value:'0',name:getLabel(332,'全部')},{value:'1',name:getLabel(15537,'今天')},{value:'2',name:getLabel(15539,'本周')},{value:'3',name:getLabel(15541,'本月')},{value:'4',name:getLabel(21904,'本季')},{value:'5',name:getLabel(15384,'本年')},{value:'7',name:getLabel(27347,'上个月')},{value:'8',name:getLabel(81716,'上一年')},{value:'6',name:getLabel(32530,'指定日期范围')}];// 获取日期类型名称
var getDateTypeName=exports.getDateTypeName=function getDateTypeName(type){var name='';for(var i=0,len=DATE_TYPES.length;i<len;i++){if(DATE_TYPES[i].value==type){name=DATE_TYPES[i].name;break;}}return name;};// 多选浏览框类型
var MULTI_BROWSER_TYPE=exports.MULTI_BROWSER_TYPE=[17,18,37,57,65,135,152,162,166,168,170,184,194,257,278];// 判断是否是多选浏览框类型
var isMultiBrowserType=exports.isMultiBrowserType=function isMultiBrowserType(type){var isMulti=false;for(var i=0,len=MULTI_BROWSER_TYPE.length;i<len;i++){if(MULTI_BROWSER_TYPE[i]==type){isMulti=true;break;}}return isMulti;};// 获取单选浏览框类型
var getSingleBrowserType=exports.getSingleBrowserType=function getSingleBrowserType(type){return{17:1,18:7,37:9,57:4,65:267,135:8,152:16,162:161,166:165,168:167,170:169,184:87,194:164,257:256,278:24}[type];};// 获取多选浏览框类型
var getMultiBrowserType=exports.getMultiBrowserType=function getMultiBrowserType(type){return{1:17,7:18,9:37,4:57,267:65,8:135,16:152,161:162,165:166,167:168,169:170,87:184,164:194,256:257,24:278}[type];};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(241);

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _SynergySetting4Designer=__webpack_require__(102);var _SynergySetting4Designer2=_interopRequireDefault(_SynergySetting4Designer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SynergySetting4WfVersions=function(_React$Component){(0,_inherits3.default)(SynergySetting4WfVersions,_React$Component);function SynergySetting4WfVersions(props){(0,_classCallCheck3.default)(this,SynergySetting4WfVersions);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergySetting4WfVersions.__proto__||(0,_getPrototypeOf2.default)(SynergySetting4WfVersions)).call(this,props));_this.state={visible:false,loading:false,data:[],settingParams:{}};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(SynergySetting4WfVersions,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,loading=_state.loading,data=_state.data,settingParams=_state.settingParams;var columns=[{key:'workflowname',title:'流程名称',dataIndex:'workflowname',width:'70%'},{key:'operation',title:getLabel(30585,'操作'),width:'30%',render:function render(text,record){return _react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4d.onShow((0,_extends3.default)({},settingParams,{wfid:record.id}));}},getLabel(17632,'参数设置'));}}];return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:loading,title:'\u6D41\u7A0B\u53C2\u6570\u8BBE\u7F6E',icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',style:{width:500,height:240},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_SynergySetting4Designer2.default,{ref:function ref(ss4d){return _this2.ss4d=ss4d;}}),_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:data,pagination:false}));}},{key:'onShow',value:function onShow(params){var _this3=this;this.setState({visible:true,loading:true,settingParams:params});var eid=params.eid,tabid=params.tabid;_ecCom.WeaTools.callApi('/api/portal/synergy/getWfVersions','GET',{eid:eid,tabid:tabid}).then(function(data){_this3.setState({loading:false,data:data.data||[]});});}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(309,'关闭')));return buttons;}},{key:'onOk',value:function onOk(){this.onCancel();}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,data:[]});}}]);return SynergySetting4WfVersions;}(_react2.default.Component);exports.default=SynergySetting4WfVersions;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器，数据来源
var Content_1_DataSource=function(_React$Component){(0,_inherits3.default)(Content_1_DataSource,_React$Component);function Content_1_DataSource(props){(0,_classCallCheck3.default)(this,Content_1_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_1_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_1_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',showContent:_this.props.tabData.showContent,position:_this.props.tabData.position||_this.props.tabNew.position.selected,searchGroup:_this.props.tabData.searchGroup||_this.props.tabNew.searchGroup.selected,readType:_this.props.tabData.readType||_this.props.tabNew.readType.selected,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_1_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,showContent=_state.showContent,position=_state.position,searchGroup=_state.searchGroup,readType=_state.readType,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var tabNew=this.props.tabNew;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:285},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:showContent,viewAttr:3,onChange:function onChange(value){return _this2.setState({showContent:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-showfield'},'\xA0\xA0\xA0\xA0',eFieldNewUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19669,'所在位置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block',width:'150px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.position.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:position,detailtype:3,onChange:function onChange(value){_this2.setState({position:value});}})),_react2.default.createElement('span',{style:{marginLeft:'10px'}},getLabel(19672,'显示内容为关键字时此选项才起作用'))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24020,'查询组合'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block',width:'108px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.searchGroup.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:searchGroup,detailtype:3,onChange:function onChange(value){_this2.setState({searchGroup:value});}})),_react2.default.createElement('div',{style:{paddingLeft:'8px',paddingBottom:'6px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaHelpfulTip// width =  {196} //如果要自定义宽度，在这里设置
,{title:getLabel(386550,'关键字之间以空格分隔，选择 and 搜索包含全部关键词的信息；选择 or 搜索包含任意一个关键词的信息。'),isCenter:true}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24661,'读取方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.readType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:readType,detailtype:3,style:{width:'150px'},onChange:function onChange(value){_this2.setState({readType:value});}}))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title||this.state.showContent==undefined){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_1_DataSource;}(_react2.default.Component);exports.default=Content_1_DataSource;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);var _EOrderCol=__webpack_require__(126);var _EOrderCol2=_interopRequireDefault(_EOrderCol);var _EPicturesSettings=__webpack_require__(127);var _EPicturesSettings2=_interopRequireDefault(_EPicturesSettings);__webpack_require__(246);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 文档中心，数据来源
var Content_7_DataSource=function(_React$Component){(0,_inherits3.default)(Content_7_DataSource,_React$Component);function Content_7_DataSource(props){(0,_classCallCheck3.default)(this,Content_7_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_7_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_7_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',topDocs:_this.props.tabData.topDocs,docSourceType:_this.props.tabData.docSourceType||_this.props.tabNew.docSourceType.selected,newsCenters:_this.props.tabData.newsCenters,docCatalogs:_this.props.tabData.docCatalogs,virtualCatalogs:_this.props.tabData.virtualCatalogs,appointDocs:_this.props.tabData.appointDocs,showMode:_this.props.tabData.showMode||_this.props.tabNew.showMode.selected,scrollDirection:_this.props.tabData.scrollDirection||_this.props.tabNew.scrollDirection.selected,isOpenAttachment:_this.props.tabData.isOpenAttachment||_this.props.tabNew.isOpenAttachment.selected,topDocsNames:_this.props.tabData.topDocsNames,newsCentersNames:_this.props.tabData.newsCentersNames,docCatalogsNames:_this.props.tabData.docCatalogsNames,virtualCatalogsNames:_this.props.tabData.virtualCatalogsNames,appointDocsNames:_this.props.tabData.appointDocsNames,topStyle:_this.props.tabData.topStyle||_this.props.tabNew.topStyle.selected,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false,pictureWidth:_this.props.tabData.pictureWidth,pictureHeight:_this.props.tabData.pictureHeight,widthUnit:_this.props.tabData.widthUnit||'px',heightUnit:_this.props.tabData.heightUnit||'px',autoHeight:_this.props.tabData.autoHeight||false,orderColDataSource:lodash.isEmpty(_this.props.tabData.orderColDataSource)?_this.props.tabNew.orderColDataSource:_this.props.tabData.orderColDataSource,orderColUsedKeys:_this.props.tabData.orderColUsedKeys||[],orderColVisible:false,isShowSettingShowType:_this.props.tabData.isShowSettingShowType||_this.props.tabNew.isShowSettingShowType,showType:_this.props.tabData.showType||'0'};_this.getButtons=_this.getButtons.bind(_this);_this.onDocSourceTypeChange=_this.onDocSourceTypeChange.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeSize=_this.onChangeSize.bind(_this);return _this;}(0,_createClass3.default)(Content_7_DataSource,[{key:'render',value:function render(){var _this2=this,_React$createElement;var _state=this.state,title=_state.title,docSourceType=_state.docSourceType,showMode=_state.showMode,scrollDirection=_state.scrollDirection,isOpenAttachment=_state.isOpenAttachment,topDocsNames=_state.topDocsNames,newsCentersNames=_state.newsCentersNames,docCatalogs=_state.docCatalogs,docCatalogsNames=_state.docCatalogsNames,virtualCatalogsNames=_state.virtualCatalogsNames,topStyle=_state.topStyle,appointDocsNames=_state.appointDocsNames,eFieldNewVisible=_state.eFieldNewVisible,eFieldNewDataSource=_state.eFieldNewDataSource,_state$pictureWidth=_state.pictureWidth,pictureWidth=_state$pictureWidth===undefined?'120':_state$pictureWidth,_state$pictureHeight=_state.pictureHeight,pictureHeight=_state$pictureHeight===undefined?'108':_state$pictureHeight,widthUnit=_state.widthUnit,heightUnit=_state.heightUnit,autoHeight=_state.autoHeight,orderColDataSource=_state.orderColDataSource,orderColUsedKeys=_state.orderColUsedKeys,orderColVisible=_state.orderColVisible,isShowSettingShowType=_state.isShowSettingShowType;var eFieldNewUsedKeys=this.state.eFieldNewUsedKeys;var tabNew=this.props.tabNew;var type={newsCenters:'docnews',docCatalogs:'doccategory',virtualCatalogs:'docdummy',appointDocs:37};var isMultCheckbox={newsCenters:true,docCatalogs:true,virtualCatalogs:true,appointDocs:true};var replaceDatas={newsCenters:newsCentersNames,docCatalogs:docCatalogsNames,virtualCatalogs:virtualCatalogsNames,appointDocs:appointDocsNames};var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}var orderColComp=_react2.default.createElement('div',null);if(orderColVisible){var orderColProps={orderColDataSource:_.cloneDeep(orderColDataSource),orderColUsedKeys:_.cloneDeep(orderColUsedKeys),onOk:function onOk(data){_this2.setState({orderColDataSource:data.orderColDataSource,orderColUsedKeys:data.orderColUsedKeys,orderColVisible:false});},onCancel:function onCancel(){_this2.setState({orderColVisible:false});}};orderColComp=_react2.default.createElement(_EOrderCol2.default,orderColProps);}var orderColUsedNames=[];for(var _i=0,len=orderColUsedKeys.length;_i<len;_i++){for(var _j=0,len2=orderColDataSource.length;_j<len2;_j++){if(orderColUsedKeys[_i]==orderColDataSource[_j].key){orderColUsedNames.push(orderColDataSource[_j].fieldName+'-'+(orderColDataSource[_j].orderType=='0'?getLabel(340,'降序'):getLabel(339,'升序')));}}}var authoHeight=autoHeight?"portal-news-authoheight":'';var radioStyle={display:'inline-block',height:'30px',lineHeight:'30px',position:'relative'};return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog portal-news-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(507373,'标签页显示未读'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:isShowSettingShowType=='1'?[{key:'0',selected:true,showname:getLabel(23857,'不显示')},{key:'1',selected:false,showname:_react2.default.createElement('div',null,getLabel(507374,'显示未读标记'),_react2.default.createElement(_ecCom.WeaHelpfulTip,{className:'portal-news-showtype-tip',width:196,title:getLabel(507375,'只统计显示条数中的未读文档'),placement:'bottomLeft'}))},{key:'2',selected:false,showname:_react2.default.createElement('div',null,getLabel(81437,'显示未读数量'),_react2.default.createElement(_ecCom.WeaHelpfulTip,(_React$createElement={className:'portal-news-showtype-tip'},(0,_defineProperty3.default)(_React$createElement,'className','AAAAAAAA'),(0,_defineProperty3.default)(_React$createElement,'width',196),(0,_defineProperty3.default)(_React$createElement,'title',getLabel(507376,'开启后，只统计显示条数中的未读文档，且涉及跨目录统计，可能会有性能问题。')),(0,_defineProperty3.default)(_React$createElement,'placement','bottomLeft'),_React$createElement)))}]:[{key:'0',selected:true,showname:getLabel(23857,'不显示')},{key:'1',selected:false,showname:_react2.default.createElement('div',null,getLabel(507374,'显示未读标记'),_react2.default.createElement(_ecCom.WeaHelpfulTip,{className:'portal-news-showtype-tip',width:196,title:getLabel(507375,'只统计显示条数中的未读文档'),placement:'bottomLeft'}))}],value:isShowSettingShowType=='0'&&this.state.showType=='2'?'0':this.state.showType,detailtype:3,onChange:function onChange(value){_this2.setState({showType:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(23784,'文档置顶'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:37,title:getLabel(386382,'请选择'),isSingle:false,replaceDatas:topDocsNames,onChange:function onChange(ids,names,datas){return _this2.setState({topDocs:ids,topDocsNames:datas});},layout:document.body})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block',width:'160px'}},_react2.default.createElement(_antd.Select,{ref:'fillStyleSelect',size:'large',className:'eStyle-7 wea-select eeStyle-7',dropdownClassName:'droptwo',dropdownMatchSelectWidth:true,onChange:function onChange(value){_this2.setState({showMode:value,topStyle:''});},style:{width:'175px'},value:showMode},_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'1'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(19525,'列表式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',style:{marginRight:'15px'},src:'/spa/portal/images/news/listStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(19525,'列表式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'4'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(387382,"列表式2")},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/listStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(387382,"列表式2")))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'2'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(82760,'上图式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/abovePictureStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(82760,'上图式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'10'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(82760,'上图式')+2},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/abovePictureStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(82760,'上图式')+2))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'3'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(82759,'左图式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/leftPictureStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(82759,'左图式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'5'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(23804,'双列式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/doubleListStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(23804,'双列式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'6'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(387383,"摘要式")},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/summaryStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(387383,"摘要式")))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'7'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(387384,"摘要式2")},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/summaryStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(387384,"摘要式2")))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'8'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:getLabel(127292,'头条式')},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/topNewsStyle.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(127292,'头条式')))),_react2.default.createElement(Option,{className:'portal-imgSlide-images-option',value:'9'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type',title:'头条式2'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/news/topNewsStyle2.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},'头条式2'))))),this.state.showMode=='8'||this.state.showMode=='9'||this.state.showMode=='10'?_react2.default.createElement('span',{className:'portal-new-topStyle-select',style:{display:'inline-block',marginLeft:'66px',width:'160px'}},_react2.default.createElement(_antd.Select,{dropdownClassName:'droptwo',dropdownMatchSelectWidth:true,className:'eStyle-7 wea-select',style:{paddingTop:'0px!important',width:175},ref:'fillStyleSelect',size:'large',value:topStyle==''?'1':topStyle,onChange:function onChange(value){_this2.setState({topStyle:value});}},tabNew.topStyle.options.map(function(d){return _react2.default.createElement(Option,{value:d.key},d.showname);}))):''),showMode=='6'||showMode=='7'?'':_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'100%',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12",top:5},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('div',{title:eFieldNewUsedNames.join('，'),style:{marginTop:-18,"-webkit-line-clamp":2,"-webkit-box-orient":"vertical","cursor":"pointer"}},'\xA0\xA0\xA0\xA0',eFieldNewUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15512,'排序字段'),labelCol:{span:6},wrapperCol:{span:16}},orderColComp,_react2.default.createElement('div',{style:{height:'100%',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12",top:5},onClick:function onClick(){return _this2.setState({orderColVisible:true});}}),_react2.default.createElement('div',{title:orderColUsedNames.join('，'),style:{marginTop:-18,"-webkit-box-orient":"vertical","cursor":"pointer","-webkit-line-clamp":2}},'\xA0\xA0\xA0\xA0',orderColUsedNames.join('，')))),this.state.showMode=='1'||this.state.showMode=='5'||this.state.showMode=='8'?'':_react2.default.createElement(_EPicturesSettings2.default,{onChangeSize:this.onChangeSize,pictureWidth:pictureWidth,widthUnit:widthUnit,authoHeight:authoHeight,autoHeight:autoHeight,pictureHeight:pictureHeight,heightUnit:heightUnit}),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',{className:'portal-new-topStyle-select',style:{display:'inline-block',width:'160px'}},_react2.default.createElement(_antd.Select,{dropdownClassName:'dropcdone',dropdownMatchSelectWidth:true,className:'eStyle-7 wea-select ',ref:'fillStyleSelect',size:'large',style:{paddingTop:'0px!important',width:160},value:scrollDirection,onChange:function onChange(value){_this2.setState({scrollDirection:value});}},tabNew.scrollDirection.options.map(function(d){return _react2.default.createElement(Option,{value:d.key},d.value);})))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20895,'直接打开附件'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block',width:'45px',"line-height":27,height:27}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:isOpenAttachment,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){_this2.setState({isOpenAttachment:value});}})),_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(20896,'当文档内容为空，且此文档仅有一个附件时')}))),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(127253,'来源设置'),showGroup:true,center:true},tabNew.docSourceType.options.map(function(item,index){var dataParams={};var _type=item.type;if('docCatalogs'==_type)dataParams={filtercategoryid:docCatalogs,filtertype:3,noAllDirName:'1'};else dataParams={};var _typeNames=item.type+'Names';return _react2.default.createElement('div',{style:{position:'relative',padding:'8px 0'}},_react2.default.createElement(_antd.Checkbox,{key:index,checked:lodash.indexOf(docSourceType.split(','),item.value)!=-1,style:{position:'absolute',top:'14px',left:-26,width:'100px',textAlign:'left',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},onChange:function onChange(e){return _this2.onDocSourceTypeChange(item.value,e.target.checked);}},_react2.default.createElement('span',{title:item.label},item.label)),_react2.default.createElement('div',{style:{paddingLeft:121,width:507}},_react2.default.createElement(_ecCom.WeaBrowser,{title:getLabel(386382,'请选择'),type:type[_type],dataParams:dataParams,isSingle:false,replaceDatas:replaceDatas[_type],onChange:function onChange(ids,names,datas){var _this2$setState;_this2.setState((_this2$setState={},(0,_defineProperty3.default)(_this2$setState,_type,ids),(0,_defineProperty3.default)(_this2$setState,_typeNames,datas),_this2$setState));if(ids!=''){_this2.onDocSourceTypeChange(item.value,true);}},layout:document.body})));})));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onChangeSize',value:function onChangeSize(string,value){this.setState((0,_defineProperty3.default)({},string,value));}},{key:'onDocSourceTypeChange',value:function onDocSourceTypeChange(value,checked){var docSourceType=this.state.docSourceType;var docSourceTypeArr=docSourceType.split(',');lodash.pull(docSourceTypeArr,value);if(checked){docSourceTypeArr.push(value);}this.setState({docSourceType:docSourceTypeArr.join(',')});}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{var _state2=this.state,ds=_state2.orderColDataSource,keys=_state2.orderColUsedKeys,showMode=_state2.showMode;var orderColUsed=[];for(var i=0,len=keys.length;i<len;i++){for(var j=0,len2=ds.length;j<len2;j++){if(keys[i]==ds[j].key){orderColUsed.push(ds[j]);}}}if(showMode=='6'||showMode=='7'){this.props.onOk((0,_extends3.default)({},this.state,{orderColUsed:orderColUsed,eFieldNewUsedKeys:["7","10","11"]}));}else this.props.onOk((0,_extends3.default)({},this.state,{orderColUsed:orderColUsed}));}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_7_DataSource;}(_react2.default.Component);exports.default=Content_7_DataSource;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _EOrderCol=__webpack_require__(126);var _EOrderCol2=_interopRequireDefault(_EOrderCol);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TreeNode=_antd.Tree.TreeNode;// 流程中心，数据来源
var Content_8_DataSource=function(_React$Component){(0,_inherits3.default)(Content_8_DataSource,_React$Component);function Content_8_DataSource(props){(0,_classCallCheck3.default)(this,Content_8_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_8_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_8_DataSource)).call(this,props));_this.getButtons=_this.getButtons.bind(_this);_this.getTreeData=_this.getTreeData.bind(_this);_this.getTreeNodes=_this.getTreeNodes.bind(_this);_this.onLoadData=_this.onLoadData.bind(_this);_this.onExpand=_this.onExpand.bind(_this);_this.onCheck=_this.onCheck.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);var _props$tabNew=props.tabNew,tabNew=_props$tabNew===undefined?{}:_props$tabNew,_props$tabData=props.tabData,tabData=_props$tabData===undefined?{}:_props$tabData;var _tabData$workflowSour=tabData.workflowSource,workflowSource=_tabData$workflowSour===undefined?{}:_tabData$workflowSour;var typeids=workflowSource.typeids,flowids=workflowSource.flowids,nodeids=workflowSource.nodeids;var wftypeCheckedKeys=typeids?typeids.split(',').map(function(item){return'wftype_'+item;}):[];var wfCheckedKeys=flowids?flowids.split(',').map(function(item){return'wf_'+item;}):[];var nodeCheckedKeys=nodeids?nodeids.split(',').map(function(item){return'node_'+item;}):[];var viewType=tabData.viewType||tabNew.viewType.selected;var isShowNodeBtn=viewType=='1'||viewType=='2'||viewType=='4';// 待办、已办和我的请求显示是否开启节点按钮
var hasNodeData=!!nodeids;_this.state={visible:true,id:tabData.id,title:tabData.title||'',viewType:viewType,isComplete:tabData.isComplete||'0',showCopy:tabData.showCopy||'1',showCount:tabData.showCount||'0',isArrangement:tabData.isArrangement||'0',orderColVisible:false,eFieldNewVisible:false,orderColDataSource:lodash.isEmpty(tabData.orderColDataSource)?tabNew.orderColDataSource:tabData.orderColDataSource,orderColUsedKeys:tabData.orderColUsedKeys||[],isExclude:tabData.isExclude||tabNew.isExclude.selected,workflowSource:workflowSource,treeLoading:false,treeData:[],checkedKeys:{checked:[].concat((0,_toConsumableArray3.default)(wftypeCheckedKeys),(0,_toConsumableArray3.default)(wfCheckedKeys),(0,_toConsumableArray3.default)(nodeCheckedKeys)),halfChecked:[]},expandedKeys:wftypeCheckedKeys,isShowNodeBtn:isShowNodeBtn,isNeedNode:hasNodeData,hasNodeData:hasNodeData,eFieldNewDataSource:tabData.eFieldNewDataSource||tabNew.eFieldNewDataSource,eFieldNewUsedKeys:tabData.eFieldNewUsedKeys||[],scrollDirection:tabData.scrollDirection||tabNew.scrollDirection.selected,showView:tabData.showView||1,showReject:tabData.showReject||1,showTimeout:tabData.showTimeout,showNoReply:tabData.showNoReply||'1',showForward:tabData.showForward||'1',showCY:tabData.showCY||'1'};return _this;}(0,_createClass3.default)(Content_8_DataSource,[{key:'componentWillMount',value:function componentWillMount(){var _state=this.state,isExclude=_state.isExclude,isShowNodeBtn=_state.isShowNodeBtn,hasNodeData=_state.hasNodeData,viewType=_state.viewType;if(isExclude!='2'){// 选择或排除选择
this.getTreeData(isShowNodeBtn&&hasNodeData,viewType,isExclude);}}},{key:'render',value:function render(){var _this2=this;var tabNew=this.props.tabNew;var esettingDatas=tabNew.esettingDatas;var _state2=this.state,visible=_state2.visible,title=_state2.title,viewType=_state2.viewType,isComplete=_state2.isComplete,showCopy=_state2.showCopy,isArrangement=_state2.isArrangement,showCount=_state2.showCount,orderColVisible=_state2.orderColVisible,eFieldNewVisible=_state2.eFieldNewVisible,orderColDataSource=_state2.orderColDataSource,orderColUsedKeys=_state2.orderColUsedKeys,showTimeout=_state2.showTimeout,isExclude=_state2.isExclude,treeLoading=_state2.treeLoading,treeData=_state2.treeData,checkedKeys=_state2.checkedKeys,expandedKeys=_state2.expandedKeys,isShowNodeBtn=_state2.isShowNodeBtn,isNeedNode=_state2.isNeedNode,hasNodeData=_state2.hasNodeData,eFieldNewDataSource=_state2.eFieldNewDataSource,eFieldNewUsedKeys=_state2.eFieldNewUsedKeys,scrollDirection=_state2.scrollDirection,showView=_state2.showView,showReject=_state2.showReject,showNoReply=_state2.showNoReply,status=_state2.status,showForward=_state2.showForward,showCY=_state2.showCY;var field={showView:showView,showReject:showReject,showTimeout:showTimeout,isArrangement:isArrangement,showNoReply:showNoReply,showCopy:showCopy,showForward:showForward,showCY:showCY};var fieldTitle={showView:getLabel(391236,"勾选后，显示包含“转发给我”、“抄送给我”这些提交或查看均不影响流程流转的流程"),showReject:getLabel(391237,"勾选后，显示包含退回给“我”的流程"),showTimeout:getLabel(391238,"勾选后，将优先显示超时流程，再按设置的排序字段排序")};var orderColComp=_react2.default.createElement('div',null);if(orderColVisible){var orderColProps={orderColDataSource:_.cloneDeep(orderColDataSource),orderColUsedKeys:_.cloneDeep(orderColUsedKeys),onOk:function onOk(data){_this2.setState({orderColDataSource:data.orderColDataSource,orderColUsedKeys:data.orderColUsedKeys,orderColVisible:false});},onCancel:function onCancel(){_this2.setState({orderColVisible:false});}};orderColComp=_react2.default.createElement(_EOrderCol2.default,orderColProps);}var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var orderColUsedNames=[];for(var i=0,len=orderColUsedKeys.length;i<len;i++){for(var j=0,len2=orderColDataSource.length;j<len2;j++){if(orderColUsedKeys[i]==orderColDataSource[j].key){orderColUsedNames.push(orderColDataSource[j].fieldName+'-'+(orderColDataSource[j].orderType=='0'?getLabel(340,"降序"):getLabel(339,"升序")));}}}var eFieldNewUsedNames=[];for(var _i=0;_i<eFieldNewUsedKeys.length;_i++){for(var _j=0;_j<eFieldNewDataSource.length;_j++){if(eFieldNewUsedKeys[_i]==eFieldNewDataSource[_j].key){eFieldNewUsedNames.push(eFieldNewDataSource[_j].name);}}}var orderTitles="";for(var _i2=0;_i2<orderColUsedNames.length;_i2++){orderTitles=orderTitles+orderColUsedNames[_i2];}var eFieldTitles="";for(var _i3=0;_i3<eFieldNewUsedNames.length;_i3++){eFieldTitles=eFieldTitles+eFieldNewUsedNames[_i3];}var spanWidth='92px';var divWidth='136px';if(esettingDatas[viewType]&&esettingDatas[viewType].typesetting.typedatas&&esettingDatas[viewType].typesetting.typedatas.length<=1){spanWidth='auto';divWidth='auto';}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:visible,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:'700px'},resize:true,hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement('div',{style:{minHeight:'440px'}},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true,style:{maxHeight:parseInt(window.innerHeight)-300+'px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(17483,'查看类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaSelect,{options:esettingDatas.options,value:viewType,onChange:function onChange(value){var isShowNodeBtn=value=='1'||value=='2'||value=='4';_this2.getTreeData(isShowNodeBtn&&hasNodeData,value);_this2.setState({viewType:value,isShowNodeBtn:isShowNodeBtn,showCount:'0',showView:'1',showReject:'0',showTimeout:'0'});}})),esettingDatas[viewType]&&esettingDatas[viewType].typesetting&&_react2.default.createElement('div',{style:{height:'30px',marginTop:'10px'}},esettingDatas[viewType].typesetting.typedatas?esettingDatas[viewType].typesetting.typedatas.map(function(item){return _react2.default.createElement('div',{style:{"top":"3px",position:"relative","width":divWidth,"display":'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:field[item.field]||item.defaultVal,onChange:function onChange(value){_this2.setState((0,_defineProperty3.default)({},item.field,value));}})),_react2.default.createElement('span',{style:{margin:'0px 4px -3px 7px',width:spanWidth,overflow:" hidden",textOverflow:'ellipsis',whiteSpace:" nowrap",display:'inline-block'},title:item.labelname},item.labelname),item.field!='isArrangement'&&fieldTitle[item.field]&&_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:fieldTitle[item.field]}));}):_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:esettingDatas[viewType].typesetting.option,value:isComplete,onChange:function onChange(value){return _this2.setState({isComplete:value});}})))),esettingDatas[viewType]&&esettingDatas[viewType].showcount&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(390629,'显示数量 '),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{height:'30px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:esettingDatas[viewType].showcount.option,detailtype:3,value:showCount,onChange:function onChange(value){_this2.setState({showCount:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-showfield',title:eFieldTitles},'\xA0\xA0\xA0\xA0',eFieldNewUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15512,'排序字段'),labelCol:{span:6},wrapperCol:{span:16}},orderColComp,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({orderColVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-ordercol',title:orderTitles},'\xA0\xA0\xA0\xA0',orderColUsedNames.join('，')))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.scrollDirection.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:scrollDirection,onChange:function onChange(value){_this2.setState({scrollDirection:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21672,'流程来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.isExclude.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:isExclude,onChange:function onChange(value){_this2.setState({isExclude:value});if(isExclude=='2')_this2.setState({workflowSource:{}});if(value!='2'){_this2.getTreeData(isShowNodeBtn&&hasNodeData,viewType,value);}}})),isExclude!='2'?_react2.default.createElement(_antd.Spin,{spinning:treeLoading},_react2.default.createElement('div',{style:{width:'465px',height:'300px',overflow:'auto'}},isExclude!='3'&&isExclude!='4'&&_react2.default.createElement('div',{style:{display:isShowNodeBtn?'block':'none',position:'absolute',top:'10px',right:'20px'}},_react2.default.createElement(_antd.Button,{size:'small',title:isNeedNode?getLabel(386556,'包含节点'):getLabel(386557,'不包含节点'),onClick:function onClick(){return _this2.getTreeData(!isNeedNode,viewType);}},_react2.default.createElement('i',{className:isNeedNode?'icon-coms-DisplaySubordinates':'icon-coms-NoDisplayOfSubordinates',style:{color:isNeedNode?'rgb(45, 183, 245)':''}}))),_react2.default.createElement(_antd.Tree,{checkable:true,checkStrictly:true,expandedKeys:expandedKeys,checkedKeys:checkedKeys,onExpand:this.onExpand,loadData:this.onLoadData,onCheck:this.onCheck},this.getTreeNodes(treeData)))):''))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'getTreeData',value:function getTreeData(isNeedNode,viewType,isExclude){var _this3=this;this.setState({treeLoading:true,isNeedNode:isNeedNode});var api='/api/public/browser/data/-99991';if(isExclude=='3'||isExclude=='4'){api='/api/portal/workFlowType/getWorkFlowTypeDatas';}_ecCom.WeaTools.callApi(api||'/api/public/browser/data/-99991','GET',{isWfTree:1,needNode:isNeedNode?1:0,containsOfs:1,viewtype:viewType}).then(function(data){if(isExclude=='3'||isExclude=='4'){_this3.setState({treeLoading:false,treeData:data.wfType.datas});}else{_this3.setState({treeLoading:false,treeData:data.datas.subs});}if(isNeedNode&&isExclude!='3'&&isExclude=='4'){var workflowSource=_this3.state.workflowSource;var _workflowSource$flowi=workflowSource.flowids,flowids=_workflowSource$flowi===undefined?'':_workflowSource$flowi;var flowidarr=flowids.split(',');if(flowidarr&&flowidarr.length){for(var i=0,len=flowidarr.length;i<len;i++){_this3.onLoadData({props:{id:flowidarr[i]}},true);}}}});}},{key:'getTreeNodes',value:function getTreeNodes(treeData){var loop=function loop(data,pids){return data.map(function(item){var _pids=_.cloneDeep(pids);_pids.push(item.type+'_'+item.id);var children=item.subs;if(children&&children.length){return _react2.default.createElement(TreeNode,{key:item.type+'_'+item.id,id:item.id,pids:_pids,title:item.name,isLeaf:!item.isParent},loop(children,_pids));}else{return _react2.default.createElement(TreeNode,{key:item.type+'_'+item.id,id:item.id,pids:_pids,title:item.name,isLeaf:!item.isParent});}});};return loop(treeData,[]);}},{key:'onLoadData',value:function onLoadData(node,isInit){var _this4=this;var id=node.props.id;if(!isInit){this.setState({treeLoading:true});}_ecCom.WeaTools.callApi('/api/public/browser/data/-99991','GET',{isWfTree:1,needNode:1,type:'wf',id:id}).then(function(data){var loop=function loop(treeData,pid,data){for(var i=0,len=treeData.length;i<len;i++){if(treeData[i].id==pid&&treeData[i].type=='wf'){treeData[i].subs=data||[];break;}else{var children=treeData[i].subs;if(children&&children.length){loop(children,pid,data);}}}};var _state3=_this4.state,treeData=_state3.treeData,expandedKeys=_state3.expandedKeys;loop(treeData,id,data.datas);_this4.setState({treeLoading:false,treeData:treeData,expandedKeys:[].concat((0,_toConsumableArray3.default)(expandedKeys),['wf_'+id])});});}},{key:'onExpand',value:function onExpand(expandedKeys){this.setState({expandedKeys:expandedKeys});}},{key:'onCheck',value:function onCheck(checkedKeys,e){var _this5=this;var _e$node$props=e.node.props,eventKey=_e$node$props.eventKey,pids=_e$node$props.pids,_e$node$props$childre=_e$node$props.children,children=_e$node$props$childre===undefined?[]:_e$node$props$childre;var childrenKeys=this.getChildrenKeys(children);var grandSonKey='';children.map(function(item){if(item.props.children){var itemChildren=_this5.getChildrenKeys(item.props.children);if(itemChildren){grandSonKey=grandSonKey+','+itemChildren;};};});var grandSonKeys=grandSonKey.split(',');var checked=[];if(e.checked){var _ref;checked=(_ref=_).concat.apply(_ref,(0,_toConsumableArray3.default)(pids).concat((0,_toConsumableArray3.default)(childrenKeys),(0,_toConsumableArray3.default)(grandSonKeys),[checkedKeys.checked]));}else{checked=_.pullAll(checkedKeys.checked,_.concat(childrenKeys,grandSonKeys));}var _checked=_.uniq(checked);var _state4=this.state,isShowNodeBtn=_state4.isShowNodeBtn,isNeedNode=_state4.isNeedNode;var typeids='',flowids='',nodeids='';for(var i=0,len=_checked.length;i<len;i++){var _keys=_checked[i].split('_');if(_keys[0]=='wftype'){typeids+=_keys[1]+',';}else if(_keys[0]=='wf'){flowids+=_keys[1]+',';}else if(isShowNodeBtn&&isNeedNode&&_keys[0]=='node'){nodeids+=_keys[1]+',';}}this.setState({checkedKeys:{checked:_checked,halfChecked:[]},workflowSource:{typeids:typeids,flowids:flowids,nodeids:nodeids}});}},{key:'getChildrenKeys',value:function getChildrenKeys(children){var keys=[];for(var i=0,len=children.length;i<len;i++){var _children$i=children[i],key=_children$i.key,props=_children$i.props;keys.push(key);if(props.children){var _keys2=this.getChildrenKeys(props.children);_keys2.push.apply(_keys2,(0,_toConsumableArray3.default)(_keys2));}}return keys;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{var _state5=this.state,ds=_state5.orderColDataSource,keys=_state5.orderColUsedKeys;var orderColUsed=[];for(var i=0,len=keys.length;i<len;i++){for(var j=0,len2=ds.length;j<len2;j++){if(keys[i]==ds[j].key){orderColUsed.push(ds[j]);}}}var _state6=this.state,workflowSource=_state6.workflowSource,isShowNodeBtn=_state6.isShowNodeBtn,isNeedNode=_state6.isNeedNode,isExclude=_state6.isExclude;var typeids=workflowSource.typeids,flowids=workflowSource.flowids,nodeids=workflowSource.nodeids;if(isExclude=='3'||isExclude=='4'){flowids="";nodeids="";}nodeids=isShowNodeBtn&&isNeedNode?nodeids:'';this.props.onOk(_.omit((0,_extends3.default)({},this.state,{orderColUsed:orderColUsed,workflowSource:{typeids:typeids,flowids:flowids,nodeids:nodeids}}),'treeData'));}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_8_DataSource;}(_react2.default.Component);exports.default=Content_8_DataSource;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义页面，数据来源
var Content_29_DataSource=function(_React$Component){(0,_inherits3.default)(Content_29_DataSource,_React$Component);function Content_29_DataSource(props){(0,_classCallCheck3.default)(this,Content_29_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_29_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_29_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',href:_this.props.tabData.href,moreHref:_this.props.tabData.moreHref,showtype:_this.props.tabData.showtype||_this.props.tabNew.showtype.selected,pageHeight:_this.props.tabData.pageHeight,componentProps:_this.props.tabData.componentProps||[],contenttype:_this.props.tabData.contenttype||'1',isdelshow:-1};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.delProps=_this.delProps.bind(_this);_this.setProps=_this.setProps.bind(_this);_this.addProps=_this.addProps.bind(_this);return _this;}(0,_createClass3.default)(Content_29_DataSource,[{key:'addProps',value:function addProps(){var componentProps=this.state.componentProps;componentProps.push({name:'',value:''});this.setState({componentProps:componentProps});}},{key:'delProps',value:function delProps(i){var componentProps=this.state.componentProps;componentProps.splice(i,1);this.setState({componentProps:componentProps});}},{key:'setProps',value:function setProps(value,type,i){var componentProps=this.state.componentProps;var item=componentProps[i];item[type]=value;componentProps.splice(i,1,item);this.setState({componentProps:componentProps});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,href=_state.href,moreHref=_state.moreHref,showtype=_state.showtype,pageHeight=_state.pageHeight,contenttype=_state.contenttype,componentProps=_state.componentProps,isdelshow=_state.isdelshow;var tabNew=this.props.tabNew;var height=316;if(contenttype=='2'){var length=componentProps.length;if(length>3)length=3;height=362+length*35;}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:height},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20017,'引用地址'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:href,onChange:function onChange(value){return _this2.setState({href:value});}}),_react2.default.createElement('div',{style:{position:'absolute',top:'6px',right:'-22px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(386567,'外部地址，请在地址前加上http://或https://'),isCenter:true}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386568,'加载方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.showtype.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:showtype,style:{width:'100px'},onChange:function onChange(value){_this2.setState({showtype:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386563,'More地址'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:moreHref,onChange:function onChange(value){return _this2.setState({moreHref:value});}}),_react2.default.createElement('div',{style:{position:'absolute',top:'6px',right:'-22px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(386567,'外部地址，请在地址前加上http://或https://'),isCenter:true}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21568,'页面高度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:pageHeight,onChange:function onChange(value){return _this2.setState({pageHeight:value});}}),_react2.default.createElement('div',{style:{position:'absolute',top:'6px',right:'-22px'}},'px'))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_29_DataSource;}(_react2.default.Component);exports.default=Content_29_DataSource;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _SynergyParams4Report=__webpack_require__(250);var _SynergyParams4Report2=_interopRequireDefault(_SynergyParams4Report);var _echart=__webpack_require__(128);var _comsMobx=__webpack_require__(279);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 图表元素，数据来源
var Content_reportForm_DataSource=function(_React$Component){(0,_inherits3.default)(Content_reportForm_DataSource,_React$Component);function Content_reportForm_DataSource(props){(0,_classCallCheck3.default)(this,Content_reportForm_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_reportForm_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_reportForm_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',reportFormType:_this.props.tabData.reportFormType||_this.props.tabNew.reportFormType.selected,decimalDigits:_this.props.tabData.decimalDigits||_this.props.tabNew.decimalDigits,reportFormWidth:_this.props.tabData.reportFormWidth||_this.props.tabNew.reportFormWidth,reportFormHeight:_this.props.tabData.reportFormHeight||_this.props.tabNew.reportFormHeight,dataSource:_this.props.tabData.dataSource||_this.props.tabNew.dataSource.selected,reportFormSql:_this.props.tabData.reportFormSql,showLegend:_this.props.tabData.showLegend||'1',isSaveTemplate:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_reportForm_DataSource,[{key:'render',value:function render(){var _this2=this;var _props=this.props,eid=_props.eid,tabNew=_props.tabNew,tabData=_props.tabData,synergyParams=_props.synergyParams;var stype=synergyParams.stype,pagetype=synergyParams.pagetype,ispagedeal=synergyParams.ispagedeal;var _state=this.state,title=_state.title,reportFormType=_state.reportFormType,decimalDigits=_state.decimalDigits,reportFormWidth=_state.reportFormWidth,reportFormHeight=_state.reportFormHeight,dataSource=_state.dataSource,reportFormSql=_state.reportFormSql,isSaveTemplate=_state.isSaveTemplate,showLegend=_state.showLegend;return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:426},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84022,'图表标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaError,{style:{width:'100%'},ref:function ref(el){_this2.title=el;},error:getLabel(385021,'数据为空'),tipPosition:'bottom'},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84021,'图表类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_echart.EchartTemplate,{sysDatas:tabNew.reportFormType.options,value:reportFormType,onChange:function onChange(value){return _this2.setState({reportFormType:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15212,'小数位数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:decimalDigits,onChange:function onChange(value){return _this2.setState({decimalDigits:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84023,'图表大小'),labelCol:{span:6},wrapperCol:{span:16},style:{lineHeight:'30px'}},_react2.default.createElement('div',{style:{verticalAlign:'middle',width:'46px',display:'inline-block'}},getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:reportFormWidth,style:{width:'132px',marginRight:'30px'},onChange:function onChange(value){return _this2.setState({reportFormWidth:value});}}),_react2.default.createElement('div',{style:{verticalAlign:'middle',width:'46px',display:'inline-block'}},getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:reportFormHeight,style:{width:'132px'},onChange:function onChange(value){return _this2.setState({reportFormHeight:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28006,'数据来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.dataSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:dataSource// style={{width: '200px'}}
,onChange:function onChange(value){_this2.setState({dataSource:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(84025,'图表来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-reportform-template-btns'},_react2.default.createElement('div',{style:{display:'inline-block',paddingRight:'45px',lineHeight:'16px'}},_react2.default.createElement('span',{style:{paddingRight:'5px'}},getLabel(127215,"保存到模板库")),_react2.default.createElement(_ecCom.WeaCheckbox,{helpfulTip:getLabel(390861,"是否保存到模板库"),onChange:function onChange(){return _this2.setState({isSaveTemplate:!isSaveTemplate});}})),_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.sp4r.onShow();}},getLabel(33749,'系统变量')),stype=='wf'&&pagetype=='operat'&&ispagedeal=='1'?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.sp4r.onShow(synergyParams);}},getLabel(130009,'表单变量')):'',_react2.default.createElement(_ecCom.WeaBrowser,{type:'reportformsqltemplate',inputStyle:{width:'373px'},title:getLabel(386595,'选择SQL模板'),hasAdvanceSerach:true,isSingle:true,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',customized:true,onChange:function onChange(ids,names,datas){if(datas[0]){_this2.setState({reportFormSql:datas[0].reportformsql});}}},_react2.default.createElement('span',{className:'synergy-setting-btn'},getLabel(386596,'SQL模板'))),_react2.default.createElement(SQLTemplate,{ref:'SQLTemplate',onEdit:function onEdit(sqlitem){return _this2.refs.SaveSQLTemplate.setState((0,_extends3.default)({},sqlitem,{visible:true}));}})),_react2.default.createElement(_ecCom.WeaTextarea,{value:reportFormSql,minRows:5,onChange:function onChange(value){_this2.setState({reportFormSql:value});}}),_react2.default.createElement(_SynergyParams4Report2.default,{ref:function ref(sp4r){return _this2.sp4r=sp4r;}}),_react2.default.createElement(SaveSQLTemplate,{ref:'SaveSQLTemplate',onRefresh:function onRefresh(){return _this2.refs.SQLTemplate.getSessionKey();},reportFormSql:reportFormSql}),_react2.default.createElement(_ecCom.WeaCheckbox,{value:showLegend,onChange:function onChange(v){return _this2.setState({showLegend:v});},style:{margin:'12px 10px 0px 0px'}}),_react2.default.createElement('span',null,'显示图例'))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var isSaveTemplate=this.state.isSaveTemplate;if(!this.state.title){this.title.showError();}else{this.props.onOk(this.state);isSaveTemplate&&this.onAddSqlTemplate();}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'onAddSqlTemplate',value:function onAddSqlTemplate(){var _this3=this;var _state2=this.state,title=_state2.title,reportFormSql=_state2.reportFormSql;_ecCom.WeaTools.callApi('/api/portal/sqltemplate/update','POST',{id:'',title:title,reportFormSql:reportFormSql}).then(function(result){if(result.api_status=='2'){_antd.message.error(result.error_msg);}else{_antd.message.success(getLabel(83551,"保存成功！"));_this3.setState({visible:false});}});}}]);return Content_reportForm_DataSource;}(_react2.default.Component);exports.default=Content_reportForm_DataSource;var LogStore=_comsMobx.WeaLogView.LogStore;var logStore=new LogStore();var WeaLogViewComp=_comsMobx.WeaLogView.Component;var WeaTable=_comsMobx.WeaTableNew.WeaTable,TableStore=_comsMobx.WeaTableNew.TableStore;var tableStore=new TableStore();var SQLTemplate=function(_React$Component2){(0,_inherits3.default)(SQLTemplate,_React$Component2);function SQLTemplate(props){(0,_classCallCheck3.default)(this,SQLTemplate);var _this4=(0,_possibleConstructorReturn3.default)(this,(SQLTemplate.__proto__||(0,_getPrototypeOf2.default)(SQLTemplate)).call(this,props));_this4.getButtons=_this4.getButtons.bind(_this4);_this4.getSessionKey=_this4.getSessionKey.bind(_this4);_this4.getRightMenu=_this4.getRightMenu.bind(_this4);_this4.onRightMenuClick=_this4.onRightMenuClick.bind(_this4);_this4.onOperatesClick=_this4.onOperatesClick.bind(_this4);_this4.onSubmit=_this4.onSubmit.bind(_this4);_this4.doDelete=_this4.doDelete.bind(_this4);_this4.deleteRows=_this4.deleteRows.bind(_this4);_this4.onLogVisibleChange=_this4.onLogVisibleChange.bind(_this4);_this4.state={sessionkey:'',loading:false,visible:false,title:'',creator:'',replaceDatas:[],showSearchAd:false,selectedRowKeys:'',logVisible:false};return _this4;}(0,_createClass3.default)(SQLTemplate,[{key:'getSessionKey',value:function getSessionKey(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.setState({visible:true,loading:true});if(this.state.sessionkey){var _tableStore$current=tableStore.current,current=_tableStore$current===undefined?1:_tableStore$current;if(!params.current){params.current=current;}}if(params.title===undefined){params.title=this.state.title;}if(params.creator===undefined){params.creator=this.state.creator;}_ecCom.WeaTools.callApi('/api/portal/sqltemplate/datas','POST',params).then(function(data){var status=data.status||'1';if(status=='1'){_this5.setState({sessionkey:data.sessionkey,loading:false,title:params.title,creator:params.creator,showSearchAd:false,selectedRowKeys:''});tableStore.getDatas(data.sessionkey,params.current||1);}else if(status=='2'){_antd.message.error(data.errormsg);return;}});}},{key:'onSubmit',value:function onSubmit(){var _state3=this.state,id=_state3.id,reportFormSql=_state3.reportFormSql;if(id){this.props.onChange(reportFormSql);}this.setState({visible:false});}},{key:'getButtons',value:function getButtons(){var _this6=this;var selectedRowKeys=this.state.selectedRowKeys;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this6.props.onEdit({id:'',title:'',reportFormSql:'',type:'add'});}},getLabel(365,'新建')));btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.deleteRows,disabled:!selectedRowKeys},getLabel(32136,'批量删除')));return btns;}},{key:'deleteRows',value:function deleteRows(){var ids="";if(this.state.sessionkey){var selectedRowKeys=tableStore.selectedRowKeys;ids=selectedRowKeys.join(",");}this.doDelete(ids);}},{key:'doDelete',value:function doDelete(ids){var _this7=this;_antd.Modal.confirm({title:'信息确认',content:getLabel(15097,'确定要删除吗？'),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/portal/sqltemplate/delete','POST',{ids:ids}).then(function(data){if(data.api_status==='success'){_antd.message.success(getLabel(83472,"删除成功！"));_this7.getSessionKey();}else{_antd.message.error(getLabel(83473,"删除失败！"));}});}});}},{key:'getRightMenu',value:function getRightMenu(){var selectedRowKeys=this.state.selectedRowKeys;var btns=[];btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(365,'新建')});btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),disabled:!selectedRowKeys,content:getLabel(32136,'批量删除')});btns.push({key:'log',icon:_react2.default.createElement('i',{className:'icon-coms-Print-log'}),content:getLabel(83,'日志'),onClick:this.onLogVisibleChange});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.props.onEdit({id:'',title:'',reportFormSql:'',type:'add'});break;case'1':this.deleteRows();break;}}},{key:'onOperatesClick',value:function onOperatesClick(record,index,operate,flag){var id=record.randomFieldId;switch(operate.index){case'0':this.props.onEdit({id:id,title:record.title,reportFormSql:record.reportformsql,type:'edit'});break;case'1':this.doDelete(id);break;case'2':break;}}},{key:'onLogVisibleChange',value:function onLogVisibleChange(){var logVisible=this.state.logVisible;this.setState({logVisible:!logVisible});}},{key:'render',value:function render(){var _this8=this;var _state4=this.state,visible=_state4.visible,loading=_state4.loading,datas=_state4.datas,title=_state4.title,replaceDatas=_state4.replaceDatas,logVisible=_state4.logVisible;var rowSelection={onChange:function onChange(selectedRowKeys,selectedRows){_this8.setState({selectedRowKeys:''+selectedRowKeys});}};return _react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',null,_react2.default.createElement(_antd.Icon,{type:'setting',title:getLabel(388014,"sql模板管理"),className:'synergy-setting-btn synergy-setting-btn-setting',onClick:function onClick(){return _this8.getSessionKey({title:'',creator:'',current:1});}})),_react2.default.createElement(WeaLogViewComp,{visible:logVisible,onCancel:this.onLogVisibleChange,logStore:logStore,logType:'6',logSmallType:'25'}),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel(388014,"sql模板管理"),visible:visible,closable:true,onCancel:function onCancel(){return _this8.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:900,height:520}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',null,_react2.default.createElement('div',{style:{lineHeight:'60px'}},_react2.default.createElement(_ecCom.WeaTab,{datas:[],searchType:['base','advanced'],showSearchAd:this.state.showSearchAd,searchsBaseValue:title,setShowSearchAd:function setShowSearchAd(bool){_this8.setState({showSearchAd:bool});},buttonsAd:[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this8.getSessionKey();}},getLabel(197,'搜索')),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return _this8.setState({title:'',creator:'',replaceDatas:[]});}},getLabel(2022,'重置')),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return _this8.setState({showSearchAd:false});}},getLabel(31129,'取消'))],advanceHeight:108,searchsAd:_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:false,showGroup:true,items:[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33439,"名称"),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement('div',{style:{marginTop:'5px'}},_react2.default.createElement(_ecCom.WeaInput,{value:title,onChange:function onChange(value){return _this8.setState({title:value});}}))),colSpan:1},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(882,"创建人"),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement('div',{style:{marginTop:'19px'}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'17',replaceDatas:replaceDatas,hasAdvanceSerach:true,title:getLabel(83496,"多人力资源"),isSingle:false,onChange:function onChange(ids,names,datas){_this8.setState({creator:''+ids,replaceDatas:datas});}}))),colSpan:1}]}),keyParam:'viewcondition'//主键
,countParam:'groupid'//数量
,onSearch:function onSearch(){return _this8.getSessionKey();},onSearchChange:function onSearchChange(value){return _this8.setState({title:value});}})),_react2.default.createElement('div',null,_react2.default.createElement(WeaTable,{needScroll:true,rowSelection:rowSelection,comsWeaTableStore:tableStore,onOperatesClick:this.onOperatesClick}))))));}}]);return SQLTemplate;}(_react2.default.Component);var SaveSQLTemplate=function(_React$Component3){(0,_inherits3.default)(SaveSQLTemplate,_React$Component3);function SaveSQLTemplate(props){(0,_classCallCheck3.default)(this,SaveSQLTemplate);var _this9=(0,_possibleConstructorReturn3.default)(this,(SaveSQLTemplate.__proto__||(0,_getPrototypeOf2.default)(SaveSQLTemplate)).call(this,props));_this9.getButtons=_this9.getButtons.bind(_this9);_this9.getRightMenu=_this9.getRightMenu.bind(_this9);_this9.onRightMenuClick=_this9.onRightMenuClick.bind(_this9);_this9.onSubmit=_this9.onSubmit.bind(_this9);_this9.state={visible:false,id:'',type:'',title:'',reportFormSql:''};return _this9;}(0,_createClass3.default)(SaveSQLTemplate,[{key:'onSubmit',value:function onSubmit(){var _this10=this;var _state5=this.state,id=_state5.id,type=_state5.type,title=_state5.title,reportFormSql=_state5.reportFormSql;if(!title.trim()){this.title.showError();return;}_ecCom.WeaTools.callApi('/api/portal/sqltemplate/update','POST',{id:id,title:title,reportFormSql:reportFormSql}).then(function(result){if(result.api_status=='2'){_antd.message.error(result.error_msg);}else{_this10.props.onRefresh();_antd.message.success(getLabel(83551,"保存成功！"));_this10.setState({visible:false});}});}},{key:'getButtons',value:function getButtons(){var _this11=this;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onSubmit},getLabel(826,'确定')));btns.push(_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this11.setState({visible:false});}},getLabel(31129,'取消')));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(826,'确定')});btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.onSubmit();break;case'1':this.setState({visible:false});break;}}},{key:'render',value:function render(){var _this12=this;var _state6=this.state,title=_state6.title,visible=_state6.visible,reportFormSql=_state6.reportFormSql;var d_title=getLabel(388015,"编辑sql模板");return _react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaDialog,{title:d_title,visible:visible,closable:true,onCancel:function onCancel(){return _this12.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),zIndex:1051,style:{width:600,height:300}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{style:{width:'90%',margin:'0 auto',paddingTop:'22px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33439,'名称'),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaError,{style:{width:'100%'},ref:function ref(el){_this12.title=el;},error:getLabel(385021,'数据为空'),tipPosition:'bottom'},_react2.default.createElement(_ecCom.WeaInput,{viewAttr:3,style:{width:280},fieldName:'title',value:title,onChange:function onChange(value){return _this12.setState({title:value});}}))),_react2.default.createElement('div',{style:{marginTop:'35px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28479,"SQL语句"),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaTextarea,{value:reportFormSql,minRows:5,onChange:function onChange(value){_this12.setState({reportFormSql:value});}})))))));}}]);return SaveSQLTemplate;}(_react2.default.Component);

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SynergyParams4Report=function(_React$Component){(0,_inherits3.default)(SynergyParams4Report,_React$Component);function SynergyParams4Report(props){(0,_classCallCheck3.default)(this,SynergyParams4Report);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergyParams4Report.__proto__||(0,_getPrototypeOf2.default)(SynergyParams4Report)).call(this,props));_this.state={visible:false,loading:false,data:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(SynergyParams4Report,[{key:'render',value:function render(){var _state=this.state,visible=_state.visible,loading=_state.loading,data=_state.data;var columns=[{key:'paramName',title:getLabel(386542,'变量名'),dataIndex:'paramName',width:'50%'},{key:'paramShowName',title:getLabel(386543,'变量显示名'),dataIndex:'paramShowName',width:'25%'},{key:'paramType',title:getLabel(386544,'变量类型'),dataIndex:'paramType',width:'25%'}];return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:loading,title:getLabel(84027,'图表参数信息'),icon:'icon-coms-synergism',iconBgcolor:'#1a57a0',style:{width:500,height:460},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:data,pagination:false}));}},{key:'onShow',value:function onShow(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.setState({visible:true,loading:true});var _params$hpid=params.hpid,hpid=_params$hpid===undefined?'':_params$hpid;_ecCom.WeaTools.callApi('/api/portal/synergy/getReportParams','GET',{hpid:hpid}).then(function(data){_this2.setState({loading:false,data:data.data});});}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(309,'关闭')));return buttons;}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,data:[]});}}]);return SynergyParams4Report;}(_react2.default.Component);exports.default=SynergyParams4Report;

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//图表元素
var EChartView=function(_React$Component){(0,_inherits3.default)(EChartView,_React$Component);function EChartView(){(0,_classCallCheck3.default)(this,EChartView);return(0,_possibleConstructorReturn3.default)(this,(EChartView.__proto__||(0,_getPrototypeOf2.default)(EChartView)).apply(this,arguments));}(0,_createClass3.default)(EChartView,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.refs.chart&&this.refs.chart.resize();}},{key:'render',value:function render(){var _React$createElement;var _props=this.props,eid=_props.eid,width=_props.width,height=_props.height,option=_props.option,charttype=_props.charttype,key=_props.key;return _react2.default.createElement('div',{style:{width:width,height:height,margin:'0 auto'},id:'reportformchart_'+eid},option&&_react2.default.createElement(_ecCom.WeaEchart,(_React$createElement={chartName:'',ref:'chart',key:key,useDefault:true},(0,_defineProperty3.default)(_React$createElement,'key',charttype),(0,_defineProperty3.default)(_React$createElement,'option',option),(0,_defineProperty3.default)(_React$createElement,'series',option.series),_React$createElement)));}}]);return EChartView;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EChartView=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EChartView);exports.default=EChartView;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _objectAssign=__webpack_require__(37);var _objectAssign2=_interopRequireDefault(_objectAssign);var _ecCom=__webpack_require__(5);var _EchartList=__webpack_require__(254);var _EchartList2=_interopRequireDefault(_EchartList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EchartTemplate=function(_React$Component){(0,_inherits3.default)(EchartTemplate,_React$Component);function EchartTemplate(props){(0,_classCallCheck3.default)(this,EchartTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(EchartTemplate.__proto__||(0,_getPrototypeOf2.default)(EchartTemplate)).call(this,props));_this.state={datas:[]};_this.onSetDatas=_this.onSetDatas.bind(_this);_this.onEdit=_this.onEdit.bind(_this);return _this;}(0,_createClass3.default)(EchartTemplate,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;_ecCom.WeaTools.callApi('/api/portal/hpEcharts/datas','POST',{}).then(function(result){_this2.setState(result);});}},{key:'onSetDatas',value:function onSetDatas(type,item){var datas=[].concat((0,_toConsumableArray3.default)(this.state.datas));if(type=="add"){datas.push(item);}else if(type=="update"){datas.filter(function(obj,index,arr){if(obj.id==item.id){datas.splice(index,1,(0,_objectAssign2.default)({},obj,item));return true;}return false;});}this.setState({datas:datas});}},{key:'onEdit',value:function onEdit(){this.refs.EChartList.setState({visible:true});}},{key:'render',value:function render(){var _props=this.props,_onChange=_props.onChange,value=_props.value,sysDatas=_props.sysDatas;var _state=this.state,id=_state.id,datas=_state.datas;return _react2.default.createElement('div',{className:'portal-esetting-reportform-template'},_react2.default.createElement(_EchartList2.default,{ref:'EChartList',sysDatas:sysDatas,datas:datas,onChangeDatas:this.onSetDatas}),_react2.default.createElement(_ecCom.WeaSelect,{options:sysDatas.map(function(item,i){return{key:item.key,selected:false,showname:item.value};}),value:value// style={{width: '200px'}}
,onChange:function onChange(value){return _onChange(value);}}));}}]);return EchartTemplate;}(_react2.default.Component);exports.default=EchartTemplate;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EchartEditor=__webpack_require__(255);var _EchartEditor2=_interopRequireDefault(_EchartEditor);var _examples=__webpack_require__(268);var _examples2=_interopRequireDefault(_examples);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var EChartList=function(_React$Component){(0,_inherits3.default)(EChartList,_React$Component);function EChartList(props){(0,_classCallCheck3.default)(this,EChartList);var _this=(0,_possibleConstructorReturn3.default)(this,(EChartList.__proto__||(0,_getPrototypeOf2.default)(EChartList)).call(this,props));_this.state={visible:false};_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.onDelete=_this.onDelete.bind(_this);_this.onEdit=_this.onEdit.bind(_this);return _this;}(0,_createClass3.default)(EChartList,[{key:'getButtons',value:function getButtons(){var btns=[];btns.push(_react2.default.createElement('div',null,_react2.default.createElement('a',{href:'http://echarts.baidu.com/',target:'_blank'},getLabel(388003,"点击查看ECharts官方文档"))));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.setState({visible:false});break;}}},{key:'onDelete',value:function onDelete(item){var _this2=this;_antd.Modal.confirm({title:getLabel(386786,"信息确认"),content:getLabel(15097,"确定要删除吗？"),onOk:function onOk(){var _props=_this2.props,datas=_props.datas,onChangeDatas=_props.onChangeDatas;_ecCom.WeaTools.callApi('/api/portal/hpEcharts/delete','POST',{id:item.id}).then(function(result){if(result.api_status=='success'){_antd.message.success(getLabel(83472,"删除成功！"));datas.remove(item);onChangeDatas(datas);}else{_antd.message.error(getLabel(83473,"删除失败！"));}});}});}},{key:'onEdit',value:function onEdit(state){this.refs.EChartEditor.setState(state);}},{key:'render',value:function render(){var _this3=this;var visible=this.state.visible;var _props2=this.props,sysDatas=_props2.sysDatas,datas=_props2.datas,onChangeDatas=_props2.onChangeDatas;return _react2.default.createElement(_ecCom.WeaDialog,{title:getLabel(388004,"图表库"),visible:visible,closable:true,onCancel:function onCancel(){return _this3.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:1080,height:660}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{id:'portal-echartlist-container',className:'portal-echartlist-container'},_react2.default.createElement(_EchartEditor2.default,{ref:'EChartEditor',callback:onChangeDatas}),sysDatas.map(function(item){return _react2.default.createElement(EChartItem,{key:'sys-'+item.id,isSys:true,item:item,onEdit:_this3.onEdit,onDelete:_this3.onDelete});}),datas.map(function(item){return _react2.default.createElement(EChartItem,{key:'sys-'+item.id,item:item,onEdit:_this3.onEdit,onDelete:_this3.onDelete});}))));}}]);return EChartList;}(_react2.default.Component);var EChartItem=function(_React$Component2){(0,_inherits3.default)(EChartItem,_React$Component2);function EChartItem(props){(0,_classCallCheck3.default)(this,EChartItem);return(0,_possibleConstructorReturn3.default)(this,(EChartItem.__proto__||(0,_getPrototypeOf2.default)(EChartItem)).call(this,props));}(0,_createClass3.default)(EChartItem,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!(0,_lodash.isEqual)(prevProps.item,this.props.item)||prevProps.isSys!=this.props.isSys){this.refs.chart.clear();this.refs.chart.paint();}}},{key:'render',value:function render(){var _props3=this.props,item=_props3.item,isSys=_props3.isSys,onEdit=_props3.onEdit,onDelete=_props3.onDelete;var obj=item;if(isSys){obj={id:item.key,title:item.value,isSys:true,option:_examples2.default[item.key]};}else{obj.isSys=false;}var _obj=obj,title=_obj.title,option=_obj.option;return _react2.default.createElement('div',{className:'portal-echartlist-item',title:title,onMouseOver:function onMouseOver(e){$(e.currentTarget).find(".portal-echartlist-item-opts").show();},onMouseLeave:function onMouseLeave(e){$(e.currentTarget).find(".portal-echartlist-item-opts").hide();}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'chart',useDefault:true,chartName:title,option:option}),_react2.default.createElement('div',{className:'portal-echartlist-item-shadow'}),_react2.default.createElement('div',{className:'portal-echartlist-item-opts'},_react2.default.createElement('div',{'class':'portal-echartlist-item-edit',title:getLabel(26473,'编辑')},_react2.default.createElement(_antd.Icon,{type:'edit',onClick:onEdit.bind(this,(0,_extends3.default)({},obj,{visible:true}))})),!isSys&&_react2.default.createElement('div',{'class':'portal-echartlist-item-delete'},_react2.default.createElement(_antd.Icon,{type:'delete',onClick:onDelete.bind(this,obj)}))));}}]);return EChartItem;}(_react2.default.Component);var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EChartList=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EChartList);exports.default=EChartList;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _stringify=__webpack_require__(63);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _reactAce=__webpack_require__(256);var _reactAce2=_interopRequireDefault(_reactAce);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EchartSaveAs=__webpack_require__(266);var _EchartSaveAs2=_interopRequireDefault(_EchartSaveAs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var prettyJSONStringify=__webpack_require__(267);var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var EChartEditor=function(_React$Component){(0,_inherits3.default)(EChartEditor,_React$Component);function EChartEditor(props){(0,_classCallCheck3.default)(this,EChartEditor);var _this=(0,_possibleConstructorReturn3.default)(this,(EChartEditor.__proto__||(0,_getPrototypeOf2.default)(EChartEditor)).call(this,props));_this.state={visible:false,id:0,title:'',isSys:false,option:null,value:'',width:'60%',left:'40%',iserror:false,isMouseDown:false};_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.onReplace=_this.onReplace.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onRun=_this.onRun.bind(_this);return _this;}(0,_createClass3.default)(EChartEditor,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){$(window).mousemove(function(e){if(_this2.state.isMouseDown){var left_rate=e.clientX/window.innerWidth;left_rate=Math.min(0.9,Math.max(0.1,left_rate));var left=left_rate*100;_this2.setState({left:left+'%',width:100-left+'%'});_this2.onRun();}}).mouseup(function(){_this2.setState({isMouseDown:false});});},100);}},{key:'getButtons',value:function getButtons(){var _this3=this;var isSys=this.state.isSys;var btns=[];if(!isSys){btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onSave.bind(this,{})},getLabel(30986,'保存')));}btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){_this3.refs.EchartSaveAs.onSetState({visible:true});}},getLabel(350,'另存为')));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var isSys=this.state.isSys;var btns=[];btns.push({key:'run',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(131308,"运行")});if(!isSys){btns.push({key:'save',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(30986,'保存')});}btns.push({key:'saveas',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(350,'另存为')});btns.push({key:'cancel',icon:_react2.default.createElement('i',{className:'icon-coms-Web-service'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'run':this.onRun();break;case'save':this.onSave();break;case'saveas':this.refs.EchartSaveAs.onSetState({visible:true});break;case'cancel':this.setState({visible:false});break;}}},{key:'onSave',value:function onSave(_ref){var _this4=this;var type=_ref.type,title=_ref.title;var callback=this.props.callback;var _state=this.state,id=_state.id,option=_state.option;_ecCom.WeaTools.callApi('/api/portal/hpEcharts/update','POST',{id:type=='saveas'?'':id,option:(0,_stringify2.default)(option),title:title,type:type}).then(function(result){if(result.api_status=='success'){_antd.message.success(getLabel(83551,"保存成功！"));if(type=='saveas'){var maxid=result.maxid;if(typeof callback==='function'){callback('add',{id:maxid,title:title,option:option});}}else{if(typeof callback==='function'){callback('update',{id:id,option:option});}}_this4.setState({visible:false});}else{_antd.message.error(getLabel(84544,"保存失败！"));}});}},{key:'onRun',value:function onRun(){this.refs.ViewEChart.onPaint();}},{key:'onReplace',value:function onReplace(js_str){var _this5=this;var option=void 0;var app={};try{eval(js_str);if(!option||(typeof option==='undefined'?'undefined':(0,_typeof3.default)(option))!='object'){option=null;}setTimeout(function(){_this5.setState({option:option,iserror:false});_this5.refs.ViewEChart.getChart().paint();},500);}catch(e){window.console?console.log(getLabel(387999,"组件异常："),e):alert(getLabel(387999,"组件异常：")+e);this.setState({iserror:true});}}},{key:'render',value:function render(){var _this6=this;var _state2=this.state,title=_state2.title,visible=_state2.visible,left=_state2.left,width=_state2.width,option=_state2.option,iserror=_state2.iserror;var editor_value="";if(option){editor_value='option = '+prettyJSONStringify(option,{shouldExpand:function shouldExpand(object,level,key){if(Array.isArray(object))return false;return true;}}).replace(/"(\w+)" :/g,"$1 :");}return _react2.default.createElement(_ecCom.WeaDialog,{title:getLabel(388000,"图表编辑"),visible:visible,closable:true,onCancel:function onCancel(){return _this6.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:document.body.clientWidth-100,height:document.body.clientHeight-150,overflow:'hidden'}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{id:'content-container',className:'portal-echart-container'},_react2.default.createElement(_EchartSaveAs2.default,{ref:'EchartSaveAs',onSave:this.onSave}),_react2.default.createElement('div',{id:'code-container',className:'echart-code-container',style:{width:left}},_react2.default.createElement('div',{className:'echart-code-top'},_react2.default.createElement('div',{className:'echart-code-input'},_react2.default.createElement(ShowTime,null),_react2.default.createElement('span',{'class':'code-info-type-'+(iserror?'error':'info')},iserror?getLabel(388001,"编辑器内容有误！"):getLabel(388002,"图表已生成")+'}')),_react2.default.createElement('div',{className:'echart-code-run'},_react2.default.createElement('div',{onClick:this.onRun,className:'echart-code-run-btn'},getLabel(131308,"运行")))),_react2.default.createElement('div',{className:'echart-code-edit'},_react2.default.createElement(_reactAce2.default,{mode:'javascript',name:'javascript-editor',onChange:this.onReplace,fontSize:14,style:{width:'100%',height:'100%',padding:'10px'},showPrintMargin:true,showGutter:true,highlightActiveLine:true,keyboardHandler:true,value:editor_value,setOptions:{enableBasicAutocompletion:true,enableSnippets:true,enableLiveAutocompletion:true}}))),_react2.default.createElement('div',{id:'handler-container',className:'echart-handler',style:{left:left},onMouseDown:function onMouseDown(){return _this6.setState({isMouseDown:true});}}),_react2.default.createElement('div',{id:'view-container',className:'echart-view-container',style:{width:width,left:left}},_react2.default.createElement(EChartView,{ref:'ViewEChart',title:title,option:option})))));}}]);return EChartEditor;}(_react2.default.Component);var timer=null;var ShowTime=function(_React$Component2){(0,_inherits3.default)(ShowTime,_React$Component2);function ShowTime(props){(0,_classCallCheck3.default)(this,ShowTime);var _this7=(0,_possibleConstructorReturn3.default)(this,(ShowTime.__proto__||(0,_getPrototypeOf2.default)(ShowTime)).call(this,props));_this7.state={time:formatTime(new Date())};return _this7;}(0,_createClass3.default)(ShowTime,[{key:'componentDidMount',value:function componentDidMount(){var _this8=this;timer=window.setInterval(function(){_this8.setState({time:formatTime(new Date())});},1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.clearTimeout(timer);}},{key:'render',value:function render(){return _react2.default.createElement('span',{'class':'code-info-time'},this.state.time);}}]);return ShowTime;}(_react2.default.Component);var ViewEChart=function(_React$Component3){(0,_inherits3.default)(ViewEChart,_React$Component3);function ViewEChart(props){(0,_classCallCheck3.default)(this,ViewEChart);var _this9=(0,_possibleConstructorReturn3.default)(this,(ViewEChart.__proto__||(0,_getPrototypeOf2.default)(ViewEChart)).call(this,props));_this9.getChart=_this9.getChart.bind(_this9);_this9.onPaint=_this9.onPaint.bind(_this9);return _this9;}(0,_createClass3.default)(ViewEChart,[{key:'getChart',value:function getChart(){return this.refs.chart;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!(0,_lodash.isEqual)(prevProps.option,this.props.option)||prevProps.title!=this.props.title){this.onPaint();}}},{key:'onPaint',value:function onPaint(){this.refs.chart.clear();this.refs.chart.paint();}},{key:'render',value:function render(){var _props=this.props,title=_props.title,option=_props.option;return _react2.default.createElement(_ecCom.WeaEchart,{ref:'chart',useDefault:true,chartName:title,option:option});}}]);return ViewEChart;}(_react2.default.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);var EChartView=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ViewEChart);EChartEditor=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EChartEditor);exports.default=EChartEditor;function formatTime(time){var digits=[time.getHours(),time.getMinutes(),time.getSeconds()];var timeStr='';for(var i=0,len=digits.length;i<len;++i){timeStr+=(digits[i]<10?'0':'')+digits[i];if(i<len-1){timeStr+=':';}}return timeStr;}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diff = exports.split = undefined;

var _ace = __webpack_require__(257);

var _ace2 = _interopRequireDefault(_ace);

var _split = __webpack_require__(133);

var _split2 = _interopRequireDefault(_split);

var _diff = __webpack_require__(264);

var _diff2 = _interopRequireDefault(_diff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.split = _split2.default;
exports.diff = _diff2.default;
exports.default = _ace2.default;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _brace = __webpack_require__(129);

var _brace2 = _interopRequireDefault(_brace);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(131);

var _lodash2 = _interopRequireDefault(_lodash);

var _editorOptions = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ace$acequire = _brace2.default.acequire('ace/range'),
    Range = _ace$acequire.Range;

var ReactAce = function (_Component) {
  _inherits(ReactAce, _Component);

  function ReactAce(props) {
    _classCallCheck(this, ReactAce);

    var _this = _possibleConstructorReturn(this, (ReactAce.__proto__ || Object.getPrototypeOf(ReactAce)).call(this, props));

    _editorOptions.editorEvents.forEach(function (method) {
      _this[method] = _this[method].bind(_this);
    });
    _this.debounce = _editorOptions.debounce;
    return _this;
  }

  _createClass(ReactAce, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          onBeforeLoad = _props.onBeforeLoad,
          onValidate = _props.onValidate,
          mode = _props.mode,
          focus = _props.focus,
          theme = _props.theme,
          fontSize = _props.fontSize,
          value = _props.value,
          defaultValue = _props.defaultValue,
          cursorStart = _props.cursorStart,
          showGutter = _props.showGutter,
          wrapEnabled = _props.wrapEnabled,
          showPrintMargin = _props.showPrintMargin,
          _props$scrollMargin = _props.scrollMargin,
          scrollMargin = _props$scrollMargin === undefined ? [0, 0, 0, 0] : _props$scrollMargin,
          keyboardHandler = _props.keyboardHandler,
          onLoad = _props.onLoad,
          commands = _props.commands,
          annotations = _props.annotations,
          markers = _props.markers;


      this.editor = _brace2.default.edit(this.refEditor);

      if (onBeforeLoad) {
        onBeforeLoad(_brace2.default);
      }

      var editorProps = Object.keys(this.props.editorProps);
      for (var i = 0; i < editorProps.length; i++) {
        this.editor[editorProps[i]] = this.props.editorProps[editorProps[i]];
      }
      if (this.props.debounceChangePeriod) {
        this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
      }
      this.editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
      this.editor.getSession().setMode('ace/mode/' + mode);
      this.editor.setTheme('ace/theme/' + theme);
      this.editor.setFontSize(fontSize);
      this.editor.getSession().setValue(!defaultValue ? value : defaultValue, cursorStart);
      this.editor.navigateFileEnd();
      this.editor.renderer.setShowGutter(showGutter);
      this.editor.getSession().setUseWrapMode(wrapEnabled);
      this.editor.setShowPrintMargin(showPrintMargin);
      this.editor.on('focus', this.onFocus);
      this.editor.on('blur', this.onBlur);
      this.editor.on('copy', this.onCopy);
      this.editor.on('paste', this.onPaste);
      this.editor.on('change', this.onChange);
      this.editor.on('input', this.onInput);
      this.editor.getSession().selection.on('changeSelection', this.onSelectionChange);
      this.editor.getSession().selection.on('changeCursor', this.onCursorChange);
      if (onValidate) {
        this.editor.getSession().on('changeAnnotation', function () {
          var annotations = _this2.editor.getSession().getAnnotations();
          _this2.props.onValidate(annotations);
        });
      }
      this.editor.session.on('changeScrollTop', this.onScroll);
      this.editor.getSession().setAnnotations(annotations || []);
      if (markers && markers.length > 0) {
        this.handleMarkers(markers);
      }

      // get a list of possible options to avoid 'misspelled option errors'
      var availableOptions = this.editor.$options;
      for (var _i = 0; _i < _editorOptions.editorOptions.length; _i++) {
        var option = _editorOptions.editorOptions[_i];
        if (availableOptions.hasOwnProperty(option)) {
          this.editor.setOption(option, this.props[option]);
        } else if (this.props[option]) {
          console.warn('ReactAce: editor option ' + option + ' was activated but not found. Did you need to import a related tool or did you possibly mispell the option?');
        }
      }
      this.handleOptions(this.props);

      if (Array.isArray(commands)) {
        commands.forEach(function (command) {
          if (typeof command.exec == 'string') {
            _this2.editor.commands.bindKey(command.bindKey, command.exec);
          } else {
            _this2.editor.commands.addCommand(command);
          }
        });
      }

      if (keyboardHandler) {
        this.editor.setKeyboardHandler('ace/keyboard/' + keyboardHandler);
      }

      if (className) {
        this.refEditor.className += ' ' + className;
      }

      if (focus) {
        this.editor.focus();
      }

      if (onLoad) {
        onLoad(this.editor);
      }

      this.editor.resize();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var oldProps = this.props;

      for (var i = 0; i < _editorOptions.editorOptions.length; i++) {
        var option = _editorOptions.editorOptions[i];
        if (nextProps[option] !== oldProps[option]) {
          this.editor.setOption(option, nextProps[option]);
        }
      }

      if (nextProps.className !== oldProps.className) {
        var appliedClasses = this.refEditor.className;
        var appliedClassesArray = appliedClasses.trim().split(' ');
        var oldClassesArray = oldProps.className.trim().split(' ');
        oldClassesArray.forEach(function (oldClass) {
          var index = appliedClassesArray.indexOf(oldClass);
          appliedClassesArray.splice(index, 1);
        });
        this.refEditor.className = ' ' + nextProps.className + ' ' + appliedClassesArray.join(' ');
      }

      // First process editor value, as it may create a new session (see issue #300)
      if (this.editor && this.editor.getValue() !== nextProps.value) {
        // editor.setValue is a synchronous function call, change event is emitted before setValue return.
        this.silent = true;
        var pos = this.editor.session.selection.toJSON();
        this.editor.setValue(nextProps.value, nextProps.cursorStart);
        this.editor.session.selection.fromJSON(pos);
        this.silent = false;
      }

      if (nextProps.mode !== oldProps.mode) {
        this.editor.getSession().setMode('ace/mode/' + nextProps.mode);
      }
      if (nextProps.theme !== oldProps.theme) {
        this.editor.setTheme('ace/theme/' + nextProps.theme);
      }
      if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
        if (nextProps.keyboardHandler) {
          this.editor.setKeyboardHandler('ace/keyboard/' + nextProps.keyboardHandler);
        } else {
          this.editor.setKeyboardHandler(null);
        }
      }
      if (nextProps.fontSize !== oldProps.fontSize) {
        this.editor.setFontSize(nextProps.fontSize);
      }
      if (nextProps.wrapEnabled !== oldProps.wrapEnabled) {
        this.editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
      }
      if (nextProps.showPrintMargin !== oldProps.showPrintMargin) {
        this.editor.setShowPrintMargin(nextProps.showPrintMargin);
      }
      if (nextProps.showGutter !== oldProps.showGutter) {
        this.editor.renderer.setShowGutter(nextProps.showGutter);
      }
      if (!(0, _lodash2.default)(nextProps.setOptions, oldProps.setOptions)) {
        this.handleOptions(nextProps);
      }
      if (!(0, _lodash2.default)(nextProps.annotations, oldProps.annotations)) {
        this.editor.getSession().setAnnotations(nextProps.annotations || []);
      }
      if (!(0, _lodash2.default)(nextProps.markers, oldProps.markers) && Array.isArray(nextProps.markers)) {
        this.handleMarkers(nextProps.markers);
      }

      // this doesn't look like it works at all....
      if (!(0, _lodash2.default)(nextProps.scrollMargin, oldProps.scrollMargin)) {
        this.handleScrollMargins(nextProps.scrollMargin);
      }

      if (nextProps.focus && !oldProps.focus) {
        this.editor.focus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.height !== this.props.height || prevProps.width !== this.props.width) {
        this.editor.resize();
      }
    }
  }, {
    key: 'handleScrollMargins',
    value: function handleScrollMargins() {
      var margins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0];

      this.editor.renderer.setScrollMargins(margins[0], margins[1], margins[2], margins[3]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.editor.destroy();
      this.editor = null;
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      if (this.props.onChange && !this.silent) {
        var value = this.editor.getValue();
        this.props.onChange(value, event);
      }
    }
  }, {
    key: 'onSelectionChange',
    value: function onSelectionChange(event) {
      if (this.props.onSelectionChange) {
        var value = this.editor.getSelection();
        this.props.onSelectionChange(value, event);
      }
    }
  }, {
    key: 'onCursorChange',
    value: function onCursorChange(event) {
      if (this.props.onCursorChange) {
        var value = this.editor.getSelection();
        this.props.onCursorChange(value, event);
      }
    }
  }, {
    key: 'onInput',
    value: function onInput(event) {
      if (this.props.onInput) {
        this.props.onInput(event);
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus(event) {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(event) {
      if (this.props.onBlur) {
        this.props.onBlur(event, this.editor);
      }
    }
  }, {
    key: 'onCopy',
    value: function onCopy(text) {
      if (this.props.onCopy) {
        this.props.onCopy(text);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(text) {
      if (this.props.onPaste) {
        this.props.onPaste(text);
      }
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      if (this.props.onScroll) {
        this.props.onScroll(this.editor);
      }
    }
  }, {
    key: 'handleOptions',
    value: function handleOptions(props) {
      var setOptions = Object.keys(props.setOptions);
      for (var y = 0; y < setOptions.length; y++) {
        this.editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
      }
    }
  }, {
    key: 'handleMarkers',
    value: function handleMarkers(markers) {
      var _this3 = this;

      // remove foreground markers
      var currentMarkers = this.editor.getSession().getMarkers(true);
      for (var i in currentMarkers) {
        if (currentMarkers.hasOwnProperty(i)) {
          this.editor.getSession().removeMarker(currentMarkers[i].id);
        }
      }
      // remove background markers
      currentMarkers = this.editor.getSession().getMarkers(false);
      for (var _i2 in currentMarkers) {
        if (currentMarkers.hasOwnProperty(_i2)) {
          this.editor.getSession().removeMarker(currentMarkers[_i2].id);
        }
      }
      // add new markers
      markers.forEach(function (_ref) {
        var startRow = _ref.startRow,
            startCol = _ref.startCol,
            endRow = _ref.endRow,
            endCol = _ref.endCol,
            className = _ref.className,
            type = _ref.type,
            _ref$inFront = _ref.inFront,
            inFront = _ref$inFront === undefined ? false : _ref$inFront;

        var range = new Range(startRow, startCol, endRow, endCol);
        _this3.editor.getSession().addMarker(range, className, type, inFront);
      });
    }
  }, {
    key: 'updateRef',
    value: function updateRef(item) {
      this.refEditor = item;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          width = _props2.width,
          height = _props2.height,
          style = _props2.style;

      var divStyle = _extends({ width: width, height: height }, style);
      return _react2.default.createElement('div', { ref: this.updateRef,
        id: name,
        style: divStyle
      });
    }
  }]);

  return ReactAce;
}(_react.Component);

exports.default = ReactAce;


ReactAce.propTypes = {
  mode: _propTypes2.default.string,
  focus: _propTypes2.default.bool,
  theme: _propTypes2.default.string,
  name: _propTypes2.default.string,
  className: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  showGutter: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onCopy: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onInput: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  value: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  onLoad: _propTypes2.default.func,
  onSelectionChange: _propTypes2.default.func,
  onCursorChange: _propTypes2.default.func,
  onBeforeLoad: _propTypes2.default.func,
  onValidate: _propTypes2.default.func,
  minLines: _propTypes2.default.number,
  maxLines: _propTypes2.default.number,
  readOnly: _propTypes2.default.bool,
  highlightActiveLine: _propTypes2.default.bool,
  tabSize: _propTypes2.default.number,
  showPrintMargin: _propTypes2.default.bool,
  cursorStart: _propTypes2.default.number,
  debounceChangePeriod: _propTypes2.default.number,
  editorProps: _propTypes2.default.object,
  setOptions: _propTypes2.default.object,
  style: _propTypes2.default.object,
  scrollMargin: _propTypes2.default.array,
  annotations: _propTypes2.default.array,
  markers: _propTypes2.default.array,
  keyboardHandler: _propTypes2.default.string,
  wrapEnabled: _propTypes2.default.bool,
  enableBasicAutocompletion: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
  enableLiveAutocompletion: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
  commands: _propTypes2.default.array
};

ReactAce.defaultProps = {
  name: 'brace-editor',
  focus: false,
  mode: '',
  theme: '',
  height: '500px',
  width: '500px',
  value: '',
  fontSize: 12,
  showGutter: true,
  onChange: null,
  onPaste: null,
  onLoad: null,
  onScroll: null,
  minLines: null,
  maxLines: null,
  readOnly: false,
  highlightActiveLine: true,
  showPrintMargin: true,
  tabSize: 4,
  cursorStart: 1,
  editorProps: {},
  style: {},
  scrollMargin: [0, 0, 0, 0],
  setOptions: {},
  wrapEnabled: false,
  enableBasicAutocompletion: false,
  enableLiveAutocompletion: false
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(259);
var invariant = __webpack_require__(260);
var ReactPropTypesSecret = __webpack_require__(261);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 263 */
/***/ (function(module, exports) {

ace.define("ace/split",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/editor","ace/virtual_renderer","ace/edit_session"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var lang = acequire("./lib/lang");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;

var Editor = acequire("./editor").Editor;
var Renderer = acequire("./virtual_renderer").VirtualRenderer;
var EditSession = acequire("./edit_session").EditSession;


var Split = function(container, theme, splits) {
    this.BELOW = 1;
    this.BESIDE = 0;

    this.$container = container;
    this.$theme = theme;
    this.$splits = 0;
    this.$editorCSS = "";
    this.$editors = [];
    this.$orientation = this.BESIDE;

    this.setSplits(splits || 1);
    this.$cEditor = this.$editors[0];


    this.on("focus", function(editor) {
        this.$cEditor = editor;
    }.bind(this));
};

(function(){

    oop.implement(this, EventEmitter);

    this.$createEditor = function() {
        var el = document.createElement("div");
        el.className = this.$editorCSS;
        el.style.cssText = "position: absolute; top:0px; bottom:0px";
        this.$container.appendChild(el);
        var editor = new Editor(new Renderer(el, this.$theme));

        editor.on("focus", function() {
            this._emit("focus", editor);
        }.bind(this));

        this.$editors.push(editor);
        editor.setFontSize(this.$fontSize);
        return editor;
    };

    this.setSplits = function(splits) {
        var editor;
        if (splits < 1) {
            throw "The number of splits have to be > 0!";
        }

        if (splits == this.$splits) {
            return;
        } else if (splits > this.$splits) {
            while (this.$splits < this.$editors.length && this.$splits < splits) {
                editor = this.$editors[this.$splits];
                this.$container.appendChild(editor.container);
                editor.setFontSize(this.$fontSize);
                this.$splits ++;
            }
            while (this.$splits < splits) {
                this.$createEditor();
                this.$splits ++;
            }
        } else {
            while (this.$splits > splits) {
                editor = this.$editors[this.$splits - 1];
                this.$container.removeChild(editor.container);
                this.$splits --;
            }
        }
        this.resize();
    };
    this.getSplits = function() {
        return this.$splits;
    };
    this.getEditor = function(idx) {
        return this.$editors[idx];
    };
    this.getCurrentEditor = function() {
        return this.$cEditor;
    };
    this.focus = function() {
        this.$cEditor.focus();
    };
    this.blur = function() {
        this.$cEditor.blur();
    };
    this.setTheme = function(theme) {
        this.$editors.forEach(function(editor) {
            editor.setTheme(theme);
        });
    };
    this.setKeyboardHandler = function(keybinding) {
        this.$editors.forEach(function(editor) {
            editor.setKeyboardHandler(keybinding);
        });
    };
    this.forEach = function(callback, scope) {
        this.$editors.forEach(callback, scope);
    };


    this.$fontSize = "";
    this.setFontSize = function(size) {
        this.$fontSize = size;
        this.forEach(function(editor) {
           editor.setFontSize(size);
        });
    };

    this.$cloneSession = function(session) {
        var s = new EditSession(session.getDocument(), session.getMode());

        var undoManager = session.getUndoManager();
        if (undoManager) {
            var undoManagerProxy = new UndoManagerProxy(undoManager, s);
            s.setUndoManager(undoManagerProxy);
        }
        s.$informUndoManager = lang.delayedCall(function() { s.$deltas = []; });
        s.setTabSize(session.getTabSize());
        s.setUseSoftTabs(session.getUseSoftTabs());
        s.setOverwrite(session.getOverwrite());
        s.setBreakpoints(session.getBreakpoints());
        s.setUseWrapMode(session.getUseWrapMode());
        s.setUseWorker(session.getUseWorker());
        s.setWrapLimitRange(session.$wrapLimitRange.min,
                            session.$wrapLimitRange.max);
        s.$foldData = session.$cloneFoldData();

        return s;
    };
    this.setSession = function(session, idx) {
        var editor;
        if (idx == null) {
            editor = this.$cEditor;
        } else {
            editor = this.$editors[idx];
        }
        var isUsed = this.$editors.some(function(editor) {
           return editor.session === session;
        });

        if (isUsed) {
            session = this.$cloneSession(session);
        }
        editor.setSession(session);
        return session;
    };
    this.getOrientation = function() {
        return this.$orientation;
    };
    this.setOrientation = function(orientation) {
        if (this.$orientation == orientation) {
            return;
        }
        this.$orientation = orientation;
        this.resize();
    };
    this.resize = function() {
        var width = this.$container.clientWidth;
        var height = this.$container.clientHeight;
        var editor;

        if (this.$orientation == this.BESIDE) {
            var editorWidth = width / this.$splits;
            for (var i = 0; i < this.$splits; i++) {
                editor = this.$editors[i];
                editor.container.style.width = editorWidth + "px";
                editor.container.style.top = "0px";
                editor.container.style.left = i * editorWidth + "px";
                editor.container.style.height = height + "px";
                editor.resize();
            }
        } else {
            var editorHeight = height / this.$splits;
            for (var i = 0; i < this.$splits; i++) {
                editor = this.$editors[i];
                editor.container.style.width = width + "px";
                editor.container.style.top = i * editorHeight + "px";
                editor.container.style.left = "0px";
                editor.container.style.height = editorHeight + "px";
                editor.resize();
            }
        }
    };

}).call(Split.prototype);

 
function UndoManagerProxy(undoManager, session) {
    this.$u = undoManager;
    this.$doc = session;
}

(function() {
    this.execute = function(options) {
        this.$u.execute(options);
    };

    this.undo = function() {
        var selectionRange = this.$u.undo(true);
        if (selectionRange) {
            this.$doc.selection.setSelectionRange(selectionRange);
        }
    };

    this.redo = function() {
        var selectionRange = this.$u.redo(true);
        if (selectionRange) {
            this.$doc.selection.setSelectionRange(selectionRange);
        }
    };

    this.reset = function() {
        this.$u.reset();
    };

    this.hasUndo = function() {
        return this.$u.hasUndo();
    };

    this.hasRedo = function() {
        return this.$u.hasRedo();
    };
}).call(UndoManagerProxy.prototype);

exports.Split = Split;
});

ace.define("ace/ext/split",["require","exports","module","ace/split"], function(acequire, exports, module) {
"use strict";
module.exports = acequire("../split");

});
                (function() {
                    ace.acequire(["ace/ext/split"], function() {});
                })();
            

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _split = __webpack_require__(133);

var _split2 = _interopRequireDefault(_split);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _diffMatchPatch = __webpack_require__(265);

var _diffMatchPatch2 = _interopRequireDefault(_diffMatchPatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiffComponent = function (_Component) {
  _inherits(DiffComponent, _Component);

  function DiffComponent(props) {
    _classCallCheck(this, DiffComponent);

    var _this = _possibleConstructorReturn(this, (DiffComponent.__proto__ || Object.getPrototypeOf(DiffComponent)).call(this, props));

    _this.state = {
      value: _this.props.value
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.diff = _this.diff.bind(_this);
    return _this;
  }

  _createClass(DiffComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var value = props.value;


      if (value !== this.state.value) {
        this.setState({ value: value });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      this.setState({
        value: value
      });
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: 'diff',
    value: function diff() {
      var dmp = new _diffMatchPatch2.default();
      var lhString = this.state.value[0];
      var rhString = this.state.value[1];

      if (lhString.length === 0 && rhString.length === 0) {
        return [];
      }

      var diff = dmp.diff_main(lhString, rhString);
      dmp.diff_cleanupSemantic(diff);

      var diffedLines = this.generateDiffedLines(diff);
      var codeEditorSettings = this.setCodeMarkers(diffedLines);
      return codeEditorSettings;
    }
  }, {
    key: 'generateDiffedLines',
    value: function generateDiffedLines(diff) {
      var C = {
        DIFF_EQUAL: 0,
        DIFF_DELETE: -1,
        DIFF_INSERT: 1
      };

      var diffedLines = {
        left: [],
        right: []
      };

      var cursor = {
        left: 1,
        right: 1
      };

      diff.forEach(function (chunk) {
        var chunkType = chunk[0];
        var text = chunk[1];
        var lines = text.split('\n').length - 1;

        // diff-match-patch sometimes returns empty strings at random
        if (text.length === 0) {
          return;
        }

        var firstChar = text[0];
        var lastChar = text[text.length - 1];
        var linesToHighlight = 0;

        switch (chunkType) {
          case C.DIFF_EQUAL:
            cursor.left += lines;
            cursor.right += lines;

            break;
          case C.DIFF_DELETE:

            // If the deletion starts with a newline, push the cursor down to that line
            if (firstChar === '\n') {
              cursor.left++;
              lines--;
            }

            linesToHighlight = lines;

            // If the deletion does not include a newline, highlight the same line on the right
            if (linesToHighlight === 0) {
              diffedLines.right.push({
                startLine: cursor.right,
                endLine: cursor.right
              });
            }

            // If the last character is a newline, we don't want to highlight that line
            if (lastChar === '\n') {
              linesToHighlight -= 1;
            }

            diffedLines.left.push({
              startLine: cursor.left,
              endLine: cursor.left + linesToHighlight
            });

            cursor.left += lines;
            break;
          case C.DIFF_INSERT:

            // If the insertion starts with a newline, push the cursor down to that line
            if (firstChar === '\n') {
              cursor.right++;
              lines--;
            }

            linesToHighlight = lines;

            // If the insertion does not include a newline, highlight the same line on the left
            if (linesToHighlight === 0) {
              diffedLines.left.push({
                startLine: cursor.left,
                endLine: cursor.left
              });
            }

            // If the last character is a newline, we don't want to highlight that line
            if (lastChar === '\n') {
              linesToHighlight -= 1;
            }

            diffedLines.right.push({
              startLine: cursor.right,
              endLine: cursor.right + linesToHighlight
            });

            cursor.right += lines;
            break;
          default:
            throw new Error('Diff type was not defined.');
        }
      });
      return diffedLines;
    }

    // Receives a collection of line numbers and iterates through them to highlight appropriately
    // Returns an object that tells the render() method how to display the code editors

  }, {
    key: 'setCodeMarkers',
    value: function setCodeMarkers() {
      var diffedLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { left: [], right: [] };

      var codeEditorSettings = [];

      var newMarkerSet = {
        left: [],
        right: []
      };

      for (var i = 0; i < diffedLines.left.length; i++) {
        var markerObj = {
          startRow: diffedLines.left[i].startLine - 1,
          endRow: diffedLines.left[i].endLine,
          type: 'text',
          className: 'codeMarker'
        };
        newMarkerSet.left.push(markerObj);
      }

      for (var _i = 0; _i < diffedLines.right.length; _i++) {
        var _markerObj = {
          startRow: diffedLines.right[_i].startLine - 1,
          endRow: diffedLines.right[_i].endLine,
          type: 'text',
          className: 'codeMarker'
        };
        newMarkerSet.right.push(_markerObj);
      }

      codeEditorSettings[0] = newMarkerSet.left;
      codeEditorSettings[1] = newMarkerSet.right;

      return codeEditorSettings;
    }
  }, {
    key: 'render',
    value: function render() {
      var markers = this.diff();
      return _react2.default.createElement(_split2.default, {
        name: this.props.name,
        className: this.props.className,
        focus: this.props.focus,
        orientation: this.props.orientation,
        splits: this.props.splits,
        mode: this.props.mode,
        theme: this.props.theme,
        height: this.props.height,
        width: this.props.width,
        fontSize: this.props.fontSize,
        showGutter: this.props.showGutter,
        onChange: this.onChange,
        onPaste: this.props.onPaste,
        onLoad: this.props.onLoad,
        onScroll: this.props.onScroll,
        minLines: this.props.minLines,
        maxLines: this.props.maxLines,
        readOnly: this.props.readOnly,
        highlightActiveLine: this.props.highlightActiveLine,
        showPrintMargin: this.props.showPrintMargin,
        tabSize: this.props.tabSize,
        cursorStart: this.props.cursorStart,
        editorProps: this.props.editorProps,
        style: this.props.style,
        scrollMargin: this.props.scrollMargin,
        setOptions: this.props.setOptions,
        wrapEnabled: this.props.wrapEnabled,
        enableBasicAutocompletion: this.props.enableBasicAutocompletion,
        enableLiveAutocompletion: this.props.enableLiveAutocompletion,
        value: this.state.value,
        markers: markers
      });
    }
  }]);

  return DiffComponent;
}(_react.Component);

exports.default = DiffComponent;


DiffComponent.propTypes = {
  cursorStart: _propTypes2.default.number,
  editorProps: _propTypes2.default.object,
  enableBasicAutocompletion: _propTypes2.default.bool,
  enableLiveAutocompletion: _propTypes2.default.bool,
  focus: _propTypes2.default.bool,
  fontSize: _propTypes2.default.number,
  height: _propTypes2.default.string,
  highlightActiveLine: _propTypes2.default.bool,
  maxLines: _propTypes2.default.func,
  minLines: _propTypes2.default.func,
  mode: _propTypes2.default.string,
  name: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onLoad: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  orientation: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  scrollMargin: _propTypes2.default.array,
  setOptions: _propTypes2.default.object,
  showGutter: _propTypes2.default.bool,
  showPrintMargin: _propTypes2.default.bool,
  splits: _propTypes2.default.number,
  style: _propTypes2.default.object,
  tabSize: _propTypes2.default.number,
  theme: _propTypes2.default.string,
  value: _propTypes2.default.array,
  width: _propTypes2.default.string,
  wrapEnabled: _propTypes2.default.bool
};

DiffComponent.defaultProps = {
  cursorStart: 1,
  editorProps: {},
  enableBasicAutocompletion: false,
  enableLiveAutocompletion: false,
  focus: false,
  fontSize: 12,
  height: '500px',
  highlightActiveLine: true,
  maxLines: null,
  minLines: null,
  mode: '',
  name: 'brace-editor',
  onLoad: null,
  onScroll: null,
  onPaste: null,
  onChange: null,
  orientation: 'beside',
  readOnly: false,
  scrollMargin: [0, 0, 0, 0],
  setOptions: {},
  showGutter: true,
  showPrintMargin: true,
  splits: 2,
  style: {},
  tabSize: 4,
  theme: 'github',
  value: ['', ''],
  width: '500px',
  wrapEnabled: true
};

/***/ }),
/* 265 */
/***/ (function(module, exports) {

/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */

/**
 * Class containing the diff, match and patch methods.
 * @constructor
 */
function diff_match_patch() {

  // Defaults.
  // Redefine these in your program to override the defaults.

  // Number of seconds to map a diff before giving up (0 for infinity).
  this.Diff_Timeout = 1.0;
  // Cost of an empty edit operation in terms of edit characters.
  this.Diff_EditCost = 4;
  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
  this.Match_Threshold = 0.5;
  // How far to search for a match (0 = exact location, 1000+ = broad match).
  // A match this many characters away from the expected location will add
  // 1.0 to the score (0.0 is a perfect match).
  this.Match_Distance = 1000;
  // When deleting a large block of text (over ~64 characters), how close do
  // the contents have to be to match the expected contents. (0.0 = perfection,
  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
  // end points of a delete need to match.
  this.Patch_DeleteThreshold = 0.5;
  // Chunk size for context length.
  this.Patch_Margin = 4;

  // The number of bits in an int.
  this.Match_MaxBits = 32;
}


//  DIFF FUNCTIONS


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

/** @typedef {{0: number, 1: string}} */
diff_match_patch.Diff;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */
diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
    opt_deadline) {
  // Set a deadline by which time the diff must be complete.
  if (typeof opt_deadline == 'undefined') {
    if (this.Diff_Timeout <= 0) {
      opt_deadline = Number.MAX_VALUE;
    } else {
      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
  }
  var deadline = opt_deadline;

  // Check for null inputs.
  if (text1 == null || text2 == null) {
    throw new Error('Null input. (diff_main)');
  }

  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  if (typeof opt_checklines == 'undefined') {
    opt_checklines = true;
  }
  var checklines = opt_checklines;

  // Trim off common prefix (speedup).
  var commonlength = this.diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = this.diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = this.diff_compute_(text1, text2, checklines, deadline);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  this.diff_cleanupMerge(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
    deadline) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = this.diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  if (checklines && text1.length > 100 && text2.length > 100) {
    return this.diff_lineMode_(text1, text2, deadline);
  }

  return this.diff_bisect_(text1, text2, deadline);
};


/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
  // Scan the text on a line-by-line basis first.
  var a = this.diff_linesToChars_(text1, text2);
  text1 = a.chars1;
  text2 = a.chars2;
  var linearray = a.lineArray;

  var diffs = this.diff_main(text1, text2, false, deadline);

  // Convert the diff back to original text.
  this.diff_charsToLines_(diffs, linearray);
  // Eliminate freak matches (e.g. blank lines)
  this.diff_cleanupSemantic(diffs);

  // Rediff any replacement blocks, this time character-by-character.
  // Add a dummy entry at the end.
  diffs.push([DIFF_EQUAL, '']);
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete >= 1 && count_insert >= 1) {
          // Delete the offending records and add the merged ones.
          diffs.splice(pointer - count_delete - count_insert,
                       count_delete + count_insert);
          pointer = pointer - count_delete - count_insert;
          var a = this.diff_main(text_delete, text_insert, false, deadline);
          for (var j = a.length - 1; j >= 0; j--) {
            diffs.splice(pointer, 0, a[j]);
          }
          pointer = pointer + a.length;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
    pointer++;
  }
  diffs.pop();  // Remove the dummy entry at the end.

  return diffs;
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Bail out if deadline is reached.
    if ((new Date()).getTime() > deadline) {
      break;
    }

    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
    deadline) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = this.diff_main(text1a, text2a, false, deadline);
  var diffsb = this.diff_main(text1b, text2b, false, deadline);

  return diffs.concat(diffsb);
};


/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */
diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4

  // '\x00' is a valid character, but various debuggers don't like it.
  // So we'll insert a junk entry to avoid generating a null character.
  lineArray[0] = '';

  /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */
  function diff_linesToCharsMunge_(text) {
    var chars = '';
    // Walk the text, pulling out a substring for each line.
    // text.split('\n') would would temporarily double our memory footprint.
    // Modifying text would create many large strings to garbage collect.
    var lineStart = 0;
    var lineEnd = -1;
    // Keeping our own length variable is faster than looking it up.
    var lineArrayLength = lineArray.length;
    while (lineEnd < text.length - 1) {
      lineEnd = text.indexOf('\n', lineStart);
      if (lineEnd == -1) {
        lineEnd = text.length - 1;
      }
      var line = text.substring(lineStart, lineEnd + 1);
      lineStart = lineEnd + 1;

      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
          (lineHash[line] !== undefined)) {
        chars += String.fromCharCode(lineHash[line]);
      } else {
        chars += String.fromCharCode(lineArrayLength);
        lineHash[line] = lineArrayLength;
        lineArray[lineArrayLength++] = line;
      }
    }
    return chars;
  }

  var chars1 = diff_linesToCharsMunge_(text1);
  var chars2 = diff_linesToCharsMunge_(text2);
  return {chars1: chars1, chars2: chars2, lineArray: lineArray};
};


/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */
diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
  for (var x = 0; x < diffs.length; x++) {
    var chars = diffs[x][1];
    var text = [];
    for (var y = 0; y < chars.length; y++) {
      text[y] = lineArray[chars.charCodeAt(y)];
    }
    diffs[x][1] = text.join('');
  }
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */
diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  // Eliminate the null case.
  if (text1_length == 0 || text2_length == 0) {
    return 0;
  }
  // Truncate the longer string.
  if (text1_length > text2_length) {
    text1 = text1.substring(text1_length - text2_length);
  } else if (text1_length < text2_length) {
    text2 = text2.substring(0, text1_length);
  }
  var text_length = Math.min(text1_length, text2_length);
  // Quick check for the worst case.
  if (text1 == text2) {
    return text_length;
  }

  // Start by looking for a single character match
  // and increase length until no match is found.
  // Performance analysis: http://neil.fraser.name/news/2010/11/04/
  var best = 0;
  var length = 1;
  while (true) {
    var pattern = text1.substring(text_length - length);
    var found = text2.indexOf(pattern);
    if (found == -1) {
      return best;
    }
    length += found;
    if (found == 0 || text1.substring(text_length - length) ==
        text2.substring(0, length)) {
      best = length;
      length++;
    }
  }
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */
diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
  if (this.Diff_Timeout <= 0) {
    // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
  }
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }
  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
                                               shorttext.substring(j));
      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
                                               shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Number of characters that changed prior to the equality.
  var length_insertions1 = 0;
  var length_deletions1 = 0;
  // Number of characters that changed after the equality.
  var length_insertions2 = 0;
  var length_deletions2 = 0;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      equalities[equalitiesLength++] = pointer;
      length_insertions1 = length_insertions2;
      length_deletions1 = length_deletions2;
      length_insertions2 = 0;
      length_deletions2 = 0;
      lastequality = diffs[pointer][1];
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_INSERT) {
        length_insertions2 += diffs[pointer][1].length;
      } else {
        length_deletions2 += diffs[pointer][1].length;
      }
      // Eliminate an equality that is smaller or equal to the edits on both
      // sides of it.
      if (lastequality && (lastequality.length <=
          Math.max(length_insertions1, length_deletions1)) &&
          (lastequality.length <= Math.max(length_insertions2,
                                           length_deletions2))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        // Throw away the equality we just deleted.
        equalitiesLength--;
        // Throw away the previous equality (it needs to be reevaluated).
        equalitiesLength--;
        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
        length_insertions1 = 0;  // Reset the counters.
        length_deletions1 = 0;
        length_insertions2 = 0;
        length_deletions2 = 0;
        lastequality = null;
        changes = true;
      }
    }
    pointer++;
  }

  // Normalize the diff.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
  this.diff_cleanupSemanticLossless(diffs);

  // Find any overlaps between deletions and insertions.
  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
  //   -> <del>abc</del>xxx<ins>def</ins>
  // e.g: <del>xxxabc</del><ins>defxxx</ins>
  //   -> <ins>def</ins>xxx<del>abc</del>
  // Only extract an overlap if it is as big as the edit ahead or behind it.
  pointer = 1;
  while (pointer < diffs.length) {
    if (diffs[pointer - 1][0] == DIFF_DELETE &&
        diffs[pointer][0] == DIFF_INSERT) {
      var deletion = diffs[pointer - 1][1];
      var insertion = diffs[pointer][1];
      var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
      var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
      if (overlap_length1 >= overlap_length2) {
        if (overlap_length1 >= deletion.length / 2 ||
            overlap_length1 >= insertion.length / 2) {
          // Overlap found.  Insert an equality and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, insertion.substring(0, overlap_length1)]);
          diffs[pointer - 1][1] =
              deletion.substring(0, deletion.length - overlap_length1);
          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
          pointer++;
        }
      } else {
        if (overlap_length2 >= deletion.length / 2 ||
            overlap_length2 >= insertion.length / 2) {
          // Reverse overlap found.
          // Insert an equality and swap and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, deletion.substring(0, overlap_length2)]);
          diffs[pointer - 1][0] = DIFF_INSERT;
          diffs[pointer - 1][1] =
              insertion.substring(0, insertion.length - overlap_length2);
          diffs[pointer + 1][0] = DIFF_DELETE;
          diffs[pointer + 1][1] =
              deletion.substring(overlap_length2);
          pointer++;
        }
      }
      pointer++;
    }
    pointer++;
  }
};


/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
  /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */
  function diff_cleanupSemanticScore_(one, two) {
    if (!one || !two) {
      // Edges are the best.
      return 6;
    }

    // Each port of this function behaves slightly differently due to
    // subtle differences in each language's definition of things like
    // 'whitespace'.  Since this function's purpose is largely cosmetic,
    // the choice has been made to use each language's native features
    // rather than force total conformity.
    var char1 = one.charAt(one.length - 1);
    var char2 = two.charAt(0);
    var nonAlphaNumeric1 = char1.match(diff_match_patch.nonAlphaNumericRegex_);
    var nonAlphaNumeric2 = char2.match(diff_match_patch.nonAlphaNumericRegex_);
    var whitespace1 = nonAlphaNumeric1 &&
        char1.match(diff_match_patch.whitespaceRegex_);
    var whitespace2 = nonAlphaNumeric2 &&
        char2.match(diff_match_patch.whitespaceRegex_);
    var lineBreak1 = whitespace1 &&
        char1.match(diff_match_patch.linebreakRegex_);
    var lineBreak2 = whitespace2 &&
        char2.match(diff_match_patch.linebreakRegex_);
    var blankLine1 = lineBreak1 &&
        one.match(diff_match_patch.blanklineEndRegex_);
    var blankLine2 = lineBreak2 &&
        two.match(diff_match_patch.blanklineStartRegex_);

    if (blankLine1 || blankLine2) {
      // Five points for blank lines.
      return 5;
    } else if (lineBreak1 || lineBreak2) {
      // Four points for line breaks.
      return 4;
    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
      // Three points for end of sentences.
      return 3;
    } else if (whitespace1 || whitespace2) {
      // Two points for whitespace.
      return 2;
    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
      // One point for non-alphanumeric.
      return 1;
    }
    return 0;
  }

  var pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      var equality1 = diffs[pointer - 1][1];
      var edit = diffs[pointer][1];
      var equality2 = diffs[pointer + 1][1];

      // First, shift the edit as far left as possible.
      var commonOffset = this.diff_commonSuffix(equality1, edit);
      if (commonOffset) {
        var commonString = edit.substring(edit.length - commonOffset);
        equality1 = equality1.substring(0, equality1.length - commonOffset);
        edit = commonString + edit.substring(0, edit.length - commonOffset);
        equality2 = commonString + equality2;
      }

      // Second, step character by character right, looking for the best fit.
      var bestEquality1 = equality1;
      var bestEdit = edit;
      var bestEquality2 = equality2;
      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
          diff_cleanupSemanticScore_(edit, equality2);
      while (edit.charAt(0) === equality2.charAt(0)) {
        equality1 += edit.charAt(0);
        edit = edit.substring(1) + equality2.charAt(0);
        equality2 = equality2.substring(1);
        var score = diff_cleanupSemanticScore_(equality1, edit) +
            diff_cleanupSemanticScore_(edit, equality2);
        // The >= encourages trailing rather than leading whitespace on edits.
        if (score >= bestScore) {
          bestScore = score;
          bestEquality1 = equality1;
          bestEdit = edit;
          bestEquality2 = equality2;
        }
      }

      if (diffs[pointer - 1][1] != bestEquality1) {
        // We have an improvement, save it back to the diff.
        if (bestEquality1) {
          diffs[pointer - 1][1] = bestEquality1;
        } else {
          diffs.splice(pointer - 1, 1);
          pointer--;
        }
        diffs[pointer][1] = bestEdit;
        if (bestEquality2) {
          diffs[pointer + 1][1] = bestEquality2;
        } else {
          diffs.splice(pointer + 1, 1);
          pointer--;
        }
      }
    }
    pointer++;
  }
};

// Define some regex patterns for matching boundaries.
diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
diff_match_patch.whitespaceRegex_ = /\s/;
diff_match_patch.linebreakRegex_ = /[\r\n]/;
diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;

/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Is there an insertion operation before the last equality.
  var pre_ins = false;
  // Is there a deletion operation before the last equality.
  var pre_del = false;
  // Is there an insertion operation after the last equality.
  var post_ins = false;
  // Is there a deletion operation after the last equality.
  var post_del = false;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      if (diffs[pointer][1].length < this.Diff_EditCost &&
          (post_ins || post_del)) {
        // Candidate found.
        equalities[equalitiesLength++] = pointer;
        pre_ins = post_ins;
        pre_del = post_del;
        lastequality = diffs[pointer][1];
      } else {
        // Not a candidate, and can never become one.
        equalitiesLength = 0;
        lastequality = null;
      }
      post_ins = post_del = false;
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_DELETE) {
        post_del = true;
      } else {
        post_ins = true;
      }
      /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */
      if (lastequality && ((pre_ins && pre_del && post_ins && post_del) ||
                           ((lastequality.length < this.Diff_EditCost / 2) &&
                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        equalitiesLength--;  // Throw away the equality we just deleted;
        lastequality = null;
        if (pre_ins && pre_del) {
          // No changes made which could affect previous entry, keep going.
          post_ins = post_del = true;
          equalitiesLength = 0;
        } else {
          equalitiesLength--;  // Throw away the previous equality.
          pointer = equalitiesLength > 0 ?
              equalities[equalitiesLength - 1] : -1;
          post_ins = post_del = false;
        }
        changes = true;
      }
    }
    pointer++;
  }

  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = this.diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = this.diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */
diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
  var chars1 = 0;
  var chars2 = 0;
  var last_chars1 = 0;
  var last_chars2 = 0;
  var x;
  for (x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
      chars1 += diffs[x][1].length;
    }
    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
      chars2 += diffs[x][1].length;
    }
    if (chars1 > loc) {  // Overshot the location.
      break;
    }
    last_chars1 = chars1;
    last_chars2 = chars2;
  }
  // Was the location was deleted?
  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
    return last_chars2;
  }
  // Add the remaining character length.
  return last_chars2 + (loc - last_chars1);
};


/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */
diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
  var html = [];
  var pattern_amp = /&/g;
  var pattern_lt = /</g;
  var pattern_gt = />/g;
  var pattern_para = /\n/g;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];    // Operation (insert, delete, equal)
    var data = diffs[x][1];  // Text of change.
    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
    switch (op) {
      case DIFF_INSERT:
        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
        break;
      case DIFF_DELETE:
        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
        break;
      case DIFF_EQUAL:
        html[x] = '<span>' + text + '</span>';
        break;
    }
  }
  return html.join('');
};


/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */
diff_match_patch.prototype.diff_text1 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */
diff_match_patch.prototype.diff_text2 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_DELETE) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */
diff_match_patch.prototype.diff_levenshtein = function(diffs) {
  var levenshtein = 0;
  var insertions = 0;
  var deletions = 0;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];
    var data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        // A deletion and an insertion is one substitution.
        levenshtein += Math.max(insertions, deletions);
        insertions = 0;
        deletions = 0;
        break;
    }
  }
  levenshtein += Math.max(insertions, deletions);
  return levenshtein;
};


/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */
diff_match_patch.prototype.diff_toDelta = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    switch (diffs[x][0]) {
      case DIFF_INSERT:
        text[x] = '+' + encodeURI(diffs[x][1]);
        break;
      case DIFF_DELETE:
        text[x] = '-' + diffs[x][1].length;
        break;
      case DIFF_EQUAL:
        text[x] = '=' + diffs[x][1].length;
        break;
    }
  }
  return text.join('\t').replace(/%20/g, ' ');
};


/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
  var diffs = [];
  var diffsLength = 0;  // Keeping our own length var is faster in JS.
  var pointer = 0;  // Cursor in text1
  var tokens = delta.split(/\t/g);
  for (var x = 0; x < tokens.length; x++) {
    // Each token begins with a one character parameter which specifies the
    // operation of this token (delete, insert, equality).
    var param = tokens[x].substring(1);
    switch (tokens[x].charAt(0)) {
      case '+':
        try {
          diffs[diffsLength++] = [DIFF_INSERT, decodeURI(param)];
        } catch (ex) {
          // Malformed URI sequence.
          throw new Error('Illegal escape in diff_fromDelta: ' + param);
        }
        break;
      case '-':
        // Fall through.
      case '=':
        var n = parseInt(param, 10);
        if (isNaN(n) || n < 0) {
          throw new Error('Invalid number in diff_fromDelta: ' + param);
        }
        var text = text1.substring(pointer, pointer += n);
        if (tokens[x].charAt(0) == '=') {
          diffs[diffsLength++] = [DIFF_EQUAL, text];
        } else {
          diffs[diffsLength++] = [DIFF_DELETE, text];
        }
        break;
      default:
        // Blank tokens are ok (from a trailing \t).
        // Anything else is an error.
        if (tokens[x]) {
          throw new Error('Invalid diff operation in diff_fromDelta: ' +
                          tokens[x]);
        }
    }
  }
  if (pointer != text1.length) {
    throw new Error('Delta length (' + pointer +
        ') does not equal source text length (' + text1.length + ').');
  }
  return diffs;
};


//  MATCH FUNCTIONS


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */
diff_match_patch.prototype.match_main = function(text, pattern, loc) {
  // Check for null inputs.
  if (text == null || pattern == null || loc == null) {
    throw new Error('Null input. (match_main)');
  }

  loc = Math.max(0, Math.min(loc, text.length));
  if (text == pattern) {
    // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
  } else if (!text.length) {
    // Nothing to match.
    return -1;
  } else if (text.substring(loc, loc + pattern.length) == pattern) {
    // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
  } else {
    // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
  }
};


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */
diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
  if (pattern.length > this.Match_MaxBits) {
    throw new Error('Pattern too long for this browser.');
  }

  // Initialise the alphabet.
  var s = this.match_alphabet_(pattern);

  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */
  function match_bitapScore_(e, x) {
    var accuracy = e / pattern.length;
    var proximity = Math.abs(loc - x);
    if (!dmp.Match_Distance) {
      // Dodge divide by zero error.
      return proximity ? 1.0 : accuracy;
    }
    return accuracy + (proximity / dmp.Match_Distance);
  }

  // Highest score beyond which we give up.
  var score_threshold = this.Match_Threshold;
  // Is there a nearby exact match? (speedup)
  var best_loc = text.indexOf(pattern, loc);
  if (best_loc != -1) {
    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    // What about in the other direction? (speedup)
    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
    if (best_loc != -1) {
      score_threshold =
          Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
  }

  // Initialise the bit arrays.
  var matchmask = 1 << (pattern.length - 1);
  best_loc = -1;

  var bin_min, bin_mid;
  var bin_max = pattern.length + text.length;
  var last_rd;
  for (var d = 0; d < pattern.length; d++) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from 'loc' we can stray at this
    // error level.
    bin_min = 0;
    bin_mid = bin_max;
    while (bin_min < bin_mid) {
      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
        bin_min = bin_mid;
      } else {
        bin_max = bin_mid;
      }
      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
    }
    // Use the result from this iteration as the maximum for the next.
    bin_max = bin_mid;
    var start = Math.max(1, loc - bin_mid + 1);
    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;

    var rd = Array(finish + 2);
    rd[finish + 1] = (1 << d) - 1;
    for (var j = finish; j >= start; j--) {
      // The alphabet (s) is a sparse hash, so the following line generates
      // warnings.
      var charMatch = s[text.charAt(j - 1)];
      if (d === 0) {  // First pass: exact match.
        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
      } else {  // Subsequent passes: fuzzy match.
        rd[j] = (((rd[j + 1] << 1) | 1) & charMatch) |
                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
                last_rd[j + 1];
      }
      if (rd[j] & matchmask) {
        var score = match_bitapScore_(d, j - 1);
        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (score <= score_threshold) {
          // Told you so.
          score_threshold = score;
          best_loc = j - 1;
          if (best_loc > loc) {
            // When passing loc, don't exceed our current distance from loc.
            start = Math.max(1, 2 * loc - best_loc);
          } else {
            // Already passed loc, downhill from here on in.
            break;
          }
        }
      }
    }
    // No hope for a (better) match at greater error levels.
    if (match_bitapScore_(d + 1, loc) > score_threshold) {
      break;
    }
    last_rd = rd;
  }
  return best_loc;
};


/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */
diff_match_patch.prototype.match_alphabet_ = function(pattern) {
  var s = {};
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] = 0;
  }
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
  }
  return s;
};


//  PATCH FUNCTIONS


/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */
diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
  if (text.length == 0) {
    return;
  }
  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
  var padding = 0;

  // Look for the first and last matches of pattern in text.  If two different
  // matches are found, increase the pattern length.
  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
         pattern.length < this.Match_MaxBits - this.Patch_Margin -
         this.Patch_Margin) {
    padding += this.Patch_Margin;
    pattern = text.substring(patch.start2 - padding,
                             patch.start2 + patch.length1 + padding);
  }
  // Add one chunk for good luck.
  padding += this.Patch_Margin;

  // Add the prefix.
  var prefix = text.substring(patch.start2 - padding, patch.start2);
  if (prefix) {
    patch.diffs.unshift([DIFF_EQUAL, prefix]);
  }
  // Add the suffix.
  var suffix = text.substring(patch.start2 + patch.length1,
                              patch.start2 + patch.length1 + padding);
  if (suffix) {
    patch.diffs.push([DIFF_EQUAL, suffix]);
  }

  // Roll back the start points.
  patch.start1 -= prefix.length;
  patch.start2 -= prefix.length;
  // Extend the lengths.
  patch.length1 += prefix.length + suffix.length;
  patch.length2 += prefix.length + suffix.length;
};


/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
  var text1, diffs;
  if (typeof a == 'string' && typeof opt_b == 'string' &&
      typeof opt_c == 'undefined') {
    // Method 1: text1, text2
    // Compute diffs from text1 and text2.
    text1 = /** @type {string} */(a);
    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
    if (diffs.length > 2) {
      this.diff_cleanupSemantic(diffs);
      this.diff_cleanupEfficiency(diffs);
    }
  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
      typeof opt_c == 'undefined') {
    // Method 2: diffs
    // Compute text1 from diffs.
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
    text1 = this.diff_text1(diffs);
  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
      typeof opt_c == 'undefined') {
    // Method 3: text1, diffs
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
      opt_c && typeof opt_c == 'object') {
    // Method 4: text1, text2, diffs
    // text2 is not used.
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
  } else {
    throw new Error('Unknown call format to patch_make.');
  }

  if (diffs.length === 0) {
    return [];  // Get rid of the null case.
  }
  var patches = [];
  var patch = new diff_match_patch.patch_obj();
  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
  var char_count1 = 0;  // Number of characters into the text1 string.
  var char_count2 = 0;  // Number of characters into the text2 string.
  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
  // text2 (postpatch_text).  We recreate the patches one by one to determine
  // context info.
  var prepatch_text = text1;
  var postpatch_text = text1;
  for (var x = 0; x < diffs.length; x++) {
    var diff_type = diffs[x][0];
    var diff_text = diffs[x][1];

    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
      // A new patch starts here.
      patch.start1 = char_count1;
      patch.start2 = char_count2;
    }

    switch (diff_type) {
      case DIFF_INSERT:
        patch.diffs[patchDiffLength++] = diffs[x];
        patch.length2 += diff_text.length;
        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
                         postpatch_text.substring(char_count2);
        break;
      case DIFF_DELETE:
        patch.length1 += diff_text.length;
        patch.diffs[patchDiffLength++] = diffs[x];
        postpatch_text = postpatch_text.substring(0, char_count2) +
                         postpatch_text.substring(char_count2 +
                             diff_text.length);
        break;
      case DIFF_EQUAL:
        if (diff_text.length <= 2 * this.Patch_Margin &&
            patchDiffLength && diffs.length != x + 1) {
          // Small equality inside a patch.
          patch.diffs[patchDiffLength++] = diffs[x];
          patch.length1 += diff_text.length;
          patch.length2 += diff_text.length;
        } else if (diff_text.length >= 2 * this.Patch_Margin) {
          // Time for a new patch.
          if (patchDiffLength) {
            this.patch_addContext_(patch, prepatch_text);
            patches.push(patch);
            patch = new diff_match_patch.patch_obj();
            patchDiffLength = 0;
            // Unlike Unidiff, our patch lists have a rolling context.
            // http://code.google.com/p/google-diff-match-patch/wiki/Unidiff
            // Update prepatch text & pos to reflect the application of the
            // just completed patch.
            prepatch_text = postpatch_text;
            char_count1 = char_count2;
          }
        }
        break;
    }

    // Update the current character count.
    if (diff_type !== DIFF_INSERT) {
      char_count1 += diff_text.length;
    }
    if (diff_type !== DIFF_DELETE) {
      char_count2 += diff_text.length;
    }
  }
  // Pick up the leftover patch if not empty.
  if (patchDiffLength) {
    this.patch_addContext_(patch, prepatch_text);
    patches.push(patch);
  }

  return patches;
};


/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_deepCopy = function(patches) {
  // Making deep copies is hard in JavaScript.
  var patchesCopy = [];
  for (var x = 0; x < patches.length; x++) {
    var patch = patches[x];
    var patchCopy = new diff_match_patch.patch_obj();
    patchCopy.diffs = [];
    for (var y = 0; y < patch.diffs.length; y++) {
      patchCopy.diffs[y] = patch.diffs[y].slice();
    }
    patchCopy.start1 = patch.start1;
    patchCopy.start2 = patch.start2;
    patchCopy.length1 = patch.length1;
    patchCopy.length2 = patch.length2;
    patchesCopy[x] = patchCopy;
  }
  return patchesCopy;
};


/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */
diff_match_patch.prototype.patch_apply = function(patches, text) {
  if (patches.length == 0) {
    return [text, []];
  }

  // Deep copy the patches so that no changes are made to originals.
  patches = this.patch_deepCopy(patches);

  var nullPadding = this.patch_addPadding(patches);
  text = nullPadding + text + nullPadding;

  this.patch_splitMax(patches);
  // delta keeps track of the offset between the expected and actual location
  // of the previous patch.  If there are patches expected at positions 10 and
  // 20, but the first patch was found at 12, delta is 2 and the second patch
  // has an effective expected position of 22.
  var delta = 0;
  var results = [];
  for (var x = 0; x < patches.length; x++) {
    var expected_loc = patches[x].start2 + delta;
    var text1 = this.diff_text1(patches[x].diffs);
    var start_loc;
    var end_loc = -1;
    if (text1.length > this.Match_MaxBits) {
      // patch_splitMax will only provide an oversized pattern in the case of
      // a monster delete.
      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
                                  expected_loc);
      if (start_loc != -1) {
        end_loc = this.match_main(text,
            text1.substring(text1.length - this.Match_MaxBits),
            expected_loc + text1.length - this.Match_MaxBits);
        if (end_loc == -1 || start_loc >= end_loc) {
          // Can't find valid trailing context.  Drop this patch.
          start_loc = -1;
        }
      }
    } else {
      start_loc = this.match_main(text, text1, expected_loc);
    }
    if (start_loc == -1) {
      // No match found.  :(
      results[x] = false;
      // Subtract the delta for this failed patch from subsequent patches.
      delta -= patches[x].length2 - patches[x].length1;
    } else {
      // Found a match.  :)
      results[x] = true;
      delta = start_loc - expected_loc;
      var text2;
      if (end_loc == -1) {
        text2 = text.substring(start_loc, start_loc + text1.length);
      } else {
        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
      }
      if (text1 == text2) {
        // Perfect match, just shove the replacement text in.
        text = text.substring(0, start_loc) +
               this.diff_text2(patches[x].diffs) +
               text.substring(start_loc + text1.length);
      } else {
        // Imperfect match.  Run a diff to get a framework of equivalent
        // indices.
        var diffs = this.diff_main(text1, text2, false);
        if (text1.length > this.Match_MaxBits &&
            this.diff_levenshtein(diffs) / text1.length >
            this.Patch_DeleteThreshold) {
          // The end points match, but the content is unacceptably bad.
          results[x] = false;
        } else {
          this.diff_cleanupSemanticLossless(diffs);
          var index1 = 0;
          var index2;
          for (var y = 0; y < patches[x].diffs.length; y++) {
            var mod = patches[x].diffs[y];
            if (mod[0] !== DIFF_EQUAL) {
              index2 = this.diff_xIndex(diffs, index1);
            }
            if (mod[0] === DIFF_INSERT) {  // Insertion
              text = text.substring(0, start_loc + index2) + mod[1] +
                     text.substring(start_loc + index2);
            } else if (mod[0] === DIFF_DELETE) {  // Deletion
              text = text.substring(0, start_loc + index2) +
                     text.substring(start_loc + this.diff_xIndex(diffs,
                         index1 + mod[1].length));
            }
            if (mod[0] !== DIFF_DELETE) {
              index1 += mod[1].length;
            }
          }
        }
      }
    }
  }
  // Strip the padding off.
  text = text.substring(nullPadding.length, text.length - nullPadding.length);
  return [text, results];
};


/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */
diff_match_patch.prototype.patch_addPadding = function(patches) {
  var paddingLength = this.Patch_Margin;
  var nullPadding = '';
  for (var x = 1; x <= paddingLength; x++) {
    nullPadding += String.fromCharCode(x);
  }

  // Bump all the patches forward.
  for (var x = 0; x < patches.length; x++) {
    patches[x].start1 += paddingLength;
    patches[x].start2 += paddingLength;
  }

  // Add some padding on start of first diff.
  var patch = patches[0];
  var diffs = patch.diffs;
  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.unshift([DIFF_EQUAL, nullPadding]);
    patch.start1 -= paddingLength;  // Should be 0.
    patch.start2 -= paddingLength;  // Should be 0.
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[0][1].length) {
    // Grow first equality.
    var extraLength = paddingLength - diffs[0][1].length;
    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
    patch.start1 -= extraLength;
    patch.start2 -= extraLength;
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  // Add some padding on end of last diff.
  patch = patches[patches.length - 1];
  diffs = patch.diffs;
  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.push([DIFF_EQUAL, nullPadding]);
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
    // Grow last equality.
    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  return nullPadding;
};


/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */
diff_match_patch.prototype.patch_splitMax = function(patches) {
  var patch_size = this.Match_MaxBits;
  for (var x = 0; x < patches.length; x++) {
    if (patches[x].length1 <= patch_size) {
      continue;
    }
    var bigpatch = patches[x];
    // Remove the big old patch.
    patches.splice(x--, 1);
    var start1 = bigpatch.start1;
    var start2 = bigpatch.start2;
    var precontext = '';
    while (bigpatch.diffs.length !== 0) {
      // Create one of several smaller patches.
      var patch = new diff_match_patch.patch_obj();
      var empty = true;
      patch.start1 = start1 - precontext.length;
      patch.start2 = start2 - precontext.length;
      if (precontext !== '') {
        patch.length1 = patch.length2 = precontext.length;
        patch.diffs.push([DIFF_EQUAL, precontext]);
      }
      while (bigpatch.diffs.length !== 0 &&
             patch.length1 < patch_size - this.Patch_Margin) {
        var diff_type = bigpatch.diffs[0][0];
        var diff_text = bigpatch.diffs[0][1];
        if (diff_type === DIFF_INSERT) {
          // Insertions are harmless.
          patch.length2 += diff_text.length;
          start2 += diff_text.length;
          patch.diffs.push(bigpatch.diffs.shift());
          empty = false;
        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
                   patch.diffs[0][0] == DIFF_EQUAL &&
                   diff_text.length > 2 * patch_size) {
          // This is a large deletion.  Let it pass in one chunk.
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          empty = false;
          patch.diffs.push([diff_type, diff_text]);
          bigpatch.diffs.shift();
        } else {
          // Deletion or equality.  Only take as much as we can stomach.
          diff_text = diff_text.substring(0,
              patch_size - patch.length1 - this.Patch_Margin);
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          if (diff_type === DIFF_EQUAL) {
            patch.length2 += diff_text.length;
            start2 += diff_text.length;
          } else {
            empty = false;
          }
          patch.diffs.push([diff_type, diff_text]);
          if (diff_text == bigpatch.diffs[0][1]) {
            bigpatch.diffs.shift();
          } else {
            bigpatch.diffs[0][1] =
                bigpatch.diffs[0][1].substring(diff_text.length);
          }
        }
      }
      // Compute the head context for the next patch.
      precontext = this.diff_text2(patch.diffs);
      precontext =
          precontext.substring(precontext.length - this.Patch_Margin);
      // Append the end context for this patch.
      var postcontext = this.diff_text1(bigpatch.diffs)
                            .substring(0, this.Patch_Margin);
      if (postcontext !== '') {
        patch.length1 += postcontext.length;
        patch.length2 += postcontext.length;
        if (patch.diffs.length !== 0 &&
            patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
          patch.diffs[patch.diffs.length - 1][1] += postcontext;
        } else {
          patch.diffs.push([DIFF_EQUAL, postcontext]);
        }
      }
      if (!empty) {
        patches.splice(++x, 0, patch);
      }
    }
  }
};


/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */
diff_match_patch.prototype.patch_toText = function(patches) {
  var text = [];
  for (var x = 0; x < patches.length; x++) {
    text[x] = patches[x];
  }
  return text.join('');
};


/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.patch_fromText = function(textline) {
  var patches = [];
  if (!textline) {
    return patches;
  }
  var text = textline.split('\n');
  var textPointer = 0;
  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
  while (textPointer < text.length) {
    var m = text[textPointer].match(patchHeader);
    if (!m) {
      throw new Error('Invalid patch string: ' + text[textPointer]);
    }
    var patch = new diff_match_patch.patch_obj();
    patches.push(patch);
    patch.start1 = parseInt(m[1], 10);
    if (m[2] === '') {
      patch.start1--;
      patch.length1 = 1;
    } else if (m[2] == '0') {
      patch.length1 = 0;
    } else {
      patch.start1--;
      patch.length1 = parseInt(m[2], 10);
    }

    patch.start2 = parseInt(m[3], 10);
    if (m[4] === '') {
      patch.start2--;
      patch.length2 = 1;
    } else if (m[4] == '0') {
      patch.length2 = 0;
    } else {
      patch.start2--;
      patch.length2 = parseInt(m[4], 10);
    }
    textPointer++;

    while (textPointer < text.length) {
      var sign = text[textPointer].charAt(0);
      try {
        var line = decodeURI(text[textPointer].substring(1));
      } catch (ex) {
        // Malformed URI sequence.
        throw new Error('Illegal escape in patch_fromText: ' + line);
      }
      if (sign == '-') {
        // Deletion.
        patch.diffs.push([DIFF_DELETE, line]);
      } else if (sign == '+') {
        // Insertion.
        patch.diffs.push([DIFF_INSERT, line]);
      } else if (sign == ' ') {
        // Minor equality.
        patch.diffs.push([DIFF_EQUAL, line]);
      } else if (sign == '@') {
        // Start of next patch.
        break;
      } else if (sign === '') {
        // Blank line?  Whatever.
      } else {
        // WTF?
        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
      }
      textPointer++;
    }
  }
  return patches;
};


/**
 * Class representing one patch operation.
 * @constructor
 */
diff_match_patch.patch_obj = function() {
  /** @type {!Array.<!diff_match_patch.Diff>} */
  this.diffs = [];
  /** @type {?number} */
  this.start1 = null;
  /** @type {?number} */
  this.start2 = null;
  /** @type {number} */
  this.length1 = 0;
  /** @type {number} */
  this.length2 = 0;
};


/**
 * Emmulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indicies are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */
diff_match_patch.patch_obj.prototype.toString = function() {
  var coords1, coords2;
  if (this.length1 === 0) {
    coords1 = this.start1 + ',0';
  } else if (this.length1 == 1) {
    coords1 = this.start1 + 1;
  } else {
    coords1 = (this.start1 + 1) + ',' + this.length1;
  }
  if (this.length2 === 0) {
    coords2 = this.start2 + ',0';
  } else if (this.length2 == 1) {
    coords2 = this.start2 + 1;
  } else {
    coords2 = (this.start2 + 1) + ',' + this.length2;
  }
  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
  var op;
  // Escape the body of the patch with %xx notation.
  for (var x = 0; x < this.diffs.length; x++) {
    switch (this.diffs[x][0]) {
      case DIFF_INSERT:
        op = '+';
        break;
      case DIFF_DELETE:
        op = '-';
        break;
      case DIFF_EQUAL:
        op = ' ';
        break;
    }
    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
  }
  return text.join('').replace(/%20/g, ' ');
};


// The following export code was added by @ForbesLindesay
module.exports = diff_match_patch;
module.exports['diff_match_patch'] = diff_match_patch;
module.exports['DIFF_DELETE'] = DIFF_DELETE;
module.exports['DIFF_INSERT'] = DIFF_INSERT;
module.exports['DIFF_EQUAL'] = DIFF_EQUAL;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _mobxReact=__webpack_require__(103);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var EchartSaveAs=function(_React$Component){(0,_inherits3.default)(EchartSaveAs,_React$Component);function EchartSaveAs(props){(0,_classCallCheck3.default)(this,EchartSaveAs);var _this=(0,_possibleConstructorReturn3.default)(this,(EchartSaveAs.__proto__||(0,_getPrototypeOf2.default)(EchartSaveAs)).call(this,props));_this.onSetState=_this.onSetState.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.state={visible:false,title:''};return _this;}(0,_createClass3.default)(EchartSaveAs,[{key:'onSetState',value:function onSetState(state){this.setState(state);}},{key:'onSubmit',value:function onSubmit(){var onSave=this.props.onSave;var title=this.state.title;if(!title.trim()){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(127697,"模板名称不能为空！")});return;}onSave({type:'saveas',title:title});this.setState({visible:false});}},{key:'getButtons',value:function getButtons(){var btns=[];btns.push(React.createElement(_antd.Button,{type:'primary',onClick:this.onSubmit},getLabel(826,'确定')));btns.push(React.createElement(_antd.Button,{onClick:this.onSetState.bind(this,{visible:false})},getLabel(31129,'取消')));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];btns.push({icon:React.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(30986,'保存')});btns.push({icon:React.createElement('i',{className:'icon-coms-go-back'}),content:getLabel(31129,'取消')});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.onSubmit();break;case'1':this.setState({visible:false});break;}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,visible=_state.visible;return React.createElement(_ecCom.WeaDialog,{title:getLabel(350,'另存为'),visible:visible,closable:true,onCancel:this.onSetState.bind(this,{visible:false}),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:520,height:237}},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},React.createElement('div',{className:'portal-esetting-echart-saveas-title'},React.createElement(_ecCom.WeaFormItem,{label:getLabel(28050,"模板名称"),labelCol:{span:6},wrapperCol:{span:18}},React.createElement(_ecCom.WeaInput,{viewAttr:3,style:{width:280},fieldName:'title',value:title,onChange:function onChange(value){return _this2.setState({title:value});}})))));}}]);return EchartSaveAs;}(React.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);EchartSaveAs=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(EchartSaveAs);exports.default=EchartSaveAs;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;var defaultParams = {
    tab : '    ',
    spaceBeforeColon : ' ',
    spaceAfterColon : ' ',
    spaceAfterComma : ' ',
    spaceInsideObject : ' ',
    spaceInsideArray : '',
    shouldExpand : function(obj, level, index) {
        return JSON.stringify(obj).length > 25;
    }
}

function stringify(object, params, level, index) {
    if (!level) {
        var fullParams = {};
        Object.keys(defaultParams).forEach(function(key) {
            fullParams[key] = (params && key in params)? params[key] : defaultParams[key];
        });
        params = fullParams;
        object = JSON.parse(JSON.stringify(object));
        level = 0;
    }

    if (typeof object !== 'object' || object === null) return JSON.stringify(object);

    var isArray = Array.isArray(object),
        bra = isArray? '[' : '{',
        ket = isArray? ']' : '}';

    if (!Object.keys(object).length) return bra + ket;

    var hasExpandedChildren = false,
        children = (isArray? object : Object.keys(object)).reduce(function(children, item, itemIndex) {
            if (!isArray) {
                itemIndex = item;
                item = object[item];
            }
            if (!hasExpandedChildren && typeof item === 'object' && item !== null && params.shouldExpand(item, level + 1, itemIndex)) {
                hasExpandedChildren = true;
            }
            children[itemIndex] = stringify(item, params, level + 1, itemIndex);
            return children;
        }, isArray? [] : {}),
        shouldExpand = hasExpandedChildren || params.shouldExpand(object, level, index),
        indent = new Array(level + 1).join(params.tab),
        spaceInside = shouldExpand?
            '\n' + indent :
            params['spaceInside' + (isArray? 'Array' : 'Object')],
        joiner = shouldExpand?
            ',\n' + indent + params.tab :
            ',' + params.spaceAfterComma;

    if (!isArray) {
        children = Object.keys(children).reduce(function(res, key) {
            return res.concat(JSON.stringify(key) + params.spaceBeforeColon + ':' + params.spaceAfterColon + children[key]);
        }, []);
    }

    return bra + spaceInside + (shouldExpand? params.tab : '') + children.join(joiner) + spaceInside + ket;
}

if (typeof module == 'object' && typeof module.exports == 'object') {
    module.exports = stringify;
} else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return stringify; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else { 
    (window || global).prettyJSONStringify = stringify;
}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _area=__webpack_require__(269);var _area2=_interopRequireDefault(_area);var _bar2d=__webpack_require__(270);var _bar2d2=_interopRequireDefault(_bar2d);var _bar3d=__webpack_require__(271);var _bar3d2=_interopRequireDefault(_bar3d);var _bargraph=__webpack_require__(272);var _bargraph2=_interopRequireDefault(_bargraph);var _doughnut=__webpack_require__(273);var _doughnut2=_interopRequireDefault(_doughnut);var _gauge=__webpack_require__(274);var _gauge2=_interopRequireDefault(_gauge);var _line=__webpack_require__(275);var _line2=_interopRequireDefault(_line);var _pie2d=__webpack_require__(276);var _pie2d2=_interopRequireDefault(_pie2d);var _pie3d=__webpack_require__(277);var _pie3d2=_interopRequireDefault(_pie3d);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//饼图2d
//仪表盘
//柱状图3d
//柱状图2d
exports.default={1:_bar2d2.default,2:_bar3d2.default,3:_line2.default,4:_area2.default,5:_bargraph2.default,6:_pie2d2.default,7:_pie3d2.default,8:_doughnut2.default,11:_gauge2.default};//饼图3d
//折线图
//环形图
//柱状图3d
//面积图

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',boundaryGap:false,data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[820,932,901,934,1290,1330,1320],type:'line',areaStyle:{}}]};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[120,200,150,80,70,110,130],type:'bar'}]};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[120,200,150,80,70,110,130],type:'bar'}]};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'value'},yAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},series:[{data:[120,200,150,80,70,110,130],type:'bar'}]};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={tooltip:{trigger:'item',formatter:"{a} <br/>{b}: {c} ({d}%)"},legend:{orient:'vertical',x:'left',data:[getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]},series:[{name:getLabel(387997,"访问来源"),type:'pie',radius:['50%','70%'],avoidLabelOverlap:false,label:{normal:{show:false,position:'center'},emphasis:{show:true,textStyle:{fontSize:'30',fontWeight:'bold'}}},labelLine:{normal:{show:false}},data:[{value:335,name:getLabel(387994,"直接访问")},{value:310,name:getLabel(387995,"邮件营销")},{value:234,name:getLabel(387996,"联盟广告")}]}]};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={tooltip:{formatter:"{a} <br/>{b} : {c}%"},toolbox:{feature:{restore:{},saveAsImage:{}}},series:[{name:getLabel(387998,"业务指标"),type:'gauge',detail:{formatter:'{value}%'},data:[{value:50,name:getLabel(30447,"完成率")}]}]};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={xAxis:{type:'category',data:['Mon','Tue','Wed','Thu','Fri','Sat','Sun']},yAxis:{type:'value'},series:[{data:[820,932,901,934,1290,1330,1320],type:'line'}]};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={title:{x:'center'},tooltip:{trigger:'item',formatter:"{a} <br/>{b} : {c} ({d}%)"},legend:{orient:'vertical',left:'left',data:[getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]},series:[{name:getLabel(387997,"访问来源"),type:'pie',radius:'55%',center:['50%','60%'],data:[{value:335,name:getLabel(387994,"直接访问")},{value:310,name:getLabel(387995,"邮件营销")},{value:234,name:getLabel(387996,"联盟广告")}],itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;exports.default={title:{x:'center'},tooltip:{trigger:'item',formatter:"{a} <br/>{b} : {c} ({d}%)"},legend:{orient:'vertical',left:'left',data:[getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]},series:[{name:getLabel(387997,"访问来源"),type:'pie',radius:'55%',center:['50%','60%'],data:[{value:335,name:getLabel(387994,"直接访问")},{value:310,name:getLabel(387995,"邮件营销")},{value:234,name:getLabel(387996,"联盟广告")}],itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecCom=__webpack_require__(5);var getLabel=_ecCom.WeaLocaleProvider.getLabel;//获取柱状图option
function getBarOption(xAxisData){var series=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';series=series.map(function(item){item.itemStyle={normal:{label:{show:true,//是否展示
position:'top'}}};return item;});var legendData=series.map(function(item){item.type='bar';return item.name;});var option={title:{text:title,subtext:subTitle},tooltip:{trigger:'axis',axisPointer:{type:'shadow'}},legend:{show:showLegend=='1',data:legendData},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true},yAxis:{type:'value',boundaryGap:[0,0.01]},xAxis:{type:'category',data:xAxisData},series:series};return option;}//获取柱状图option
function getBar3dOption(xAxisData,series){var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var dimensions=['xName'];var source=[];var encode={x:'xName'};var tooltip=[0];series.map(function(item,i){if(i==0&&!encode.y)encode.y=item.name;if(i==1&&!encode.z)encode.z=item.name;tooltip.push(i+1);dimensions.push(item.name);});encode.tooltip=tooltip;xAxisData.map(function(xName,i){var arr=[];arr.push(xAxisData[i]);series.map(function(item,j){arr.push(item.data[i]);});source.push(arr);});var option={grid3D:{},tooltip:{},xAxis3D:{type:'category'},yAxis3D:{type:'category'},zAxis3D:{},visualMap:{show:showLegend=='1',max:1e8,dimension:'Population'},dataset:{dimensions:dimensions,source:source},series:[{type:'bar3D',// symbolSize: symbolSize,
shading:'lambert',encode:encode}]};return option;}function getLineOption(xAxisData,series){var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var legendData=series.map(function(item){item.type='line';return item.name;});var option={title:{text:title},tooltip:{trigger:'axis'},legend:{show:showLegend=='1',data:legendData},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true},toolbox:{feature:{saveAsImage:{}}},xAxis:{type:'category',boundaryGap:false,data:xAxisData},yAxis:{type:'value'},series:series};return option;}function getAreaOption(xAxisData){var series=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var legendData=series.map(function(item){item.type='line';item.stack=getLabel(388005,"总量");item.areaStyle={normal:{}};return item.name;});var option={title:{text:title},tooltip:{trigger:'axis',axisPointer:{type:'cross',label:{backgroundColor:'#6a7985'}}},legend:{show:showLegend=='1',data:legendData},toolbox:{feature:{saveAsImage:{}}},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true},xAxis:[{type:'category',boundaryGap:false,data:xAxisData}],yAxis:[{type:'value'}],series:series};return option;}function getBarGraphOption(xAxisData){var series=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var subTitle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var showLegend=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'1';var legendData=series.map(function(item){item.type='bar';item.itemStyle={normal:{label:{show:true,//是否展示
position:'right'}}};item.data=item.data.reverse();return item.name;});var option={title:{text:title,subtext:subTitle},tooltip:{trigger:'axis',axisPointer:{type:'shadow'}},legend:{show:showLegend=='1',data:legendData.reverse()},grid:{left:'3%',right:'4%',bottom:'3%',containLabel:true},xAxis:{type:'value',boundaryGap:[0,0.01]},yAxis:{type:'category',data:xAxisData.reverse()},series:series};return option;}function getPieOption(){var series=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var subTitle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var showLegend=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'1';var data=[];var legendData=series.data.map(function(item){data.push({name:item[0],value:item[1]});return item[0];});var option={title:{text:title,subtext:subTitle,x:'center'},tooltip:{trigger:'item',formatter:"{b} : {d}%"},legend:{show:showLegend=='1',orient:'vertical',left:'left',data:legendData},series:[{type:'pie',radius:'55%',center:['50%','60%'],data:data,itemStyle:{emphasis:{shadowBlur:10,shadowOffsetX:0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]};return option;}function getCircleOption(){var series=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var subTitle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var showLegend=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'1';var data=[];var legendData=series.data.map(function(item){data.push({name:item[0],value:item[1]});return item[0];});var option={title:{text:title,subtext:subTitle,x:'center'},tooltip:{trigger:'item',formatter:"{a} <br/>{b}: {c} ({d}%)"},legend:{show:showLegend=='1',orient:'vertical',x:'left',data:legendData},series:[{type:'pie',radius:['10%','80%'],avoidLabelOverlap:false,label:{normal:{show:false,position:'center'},emphasis:{show:false,textStyle:{fontSize:'30',fontWeight:'bold'}}},labelLine:{normal:{show:false}},data:data}]};return option;}function getGaugeOption(datas){var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var subTitle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var showLegend=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'1';var series=datas.series;var data=series.data;var startval=data.startval,middleval=data.middleval,realval=data.realval,endval=data.endval;var myIsNaN=function myIsNaN(value){var def=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;value=Number(value);if(typeof value==='number'&&isNaN(value)){return def;}return value;};var option={tooltip:{formatter:"{a} <br/>{c} {b}"},toolbox:{show:true,feature:{restore:{show:true},saveAsImage:{show:true}}},series:[{type:'gauge',z:3,min:myIsNaN(startval,0),max:myIsNaN(endval,1),splitNumber:10,radius:'50%',axisLine:{// 坐标轴线
lineStyle:{// 属性lineStyle控制线条样式
width:10}},axisTick:{// 坐标轴小标记
length:15,// 属性length控制线长
lineStyle:{// 属性lineStyle控制线条样式
color:'auto'}},splitLine:{// 分隔线
length:20,// 属性length控制线长
lineStyle:{// 属性lineStyle（详见lineStyle）控制线条样式
color:'auto'}},axisLabel:{backgroundColor:'auto',borderRadius:2,color:'#eee',padding:3,textShadowBlur:2,textShadowOffsetX:1,textShadowOffsetY:1,textShadowColor:'#222'},title:{// 其余属性默认使用全局文本样式，详见TEXTSTYLE
fontWeight:'bolder',fontSize:20,fontStyle:'italic'},// data: [{value: myIsNaN(realval, 0), name: '完成率'}]
data:[{value:myIsNaN(realval,0)}]}]};return option;}function getEChartOption(data){var charttype=data.charttype,showLegend=data.showLegend;var categories=data.categories,dot=data.dot,series=data.series,title=data.title,subTitle=data.subTitle;switch(charttype){case'bar':return getBarOption(categories,series,title,subTitle,showLegend);break;case'bar3d':return getBar3dOption(categories,series,title,subTitle,showLegend);break;case'line':return getLineOption(categories,series,title,subTitle,showLegend);break;case'area':return getAreaOption(categories,series,title,subTitle,showLegend);break;case'bar-graph':return getBarGraphOption(categories,series,title,subTitle,showLegend);break;case'pie':return getPieOption(series,title,subTitle,showLegend);break;case'circle':return getCircleOption(series,title,subTitle,showLegend);break;case'gauge':return getGaugeOption(data,title,subTitle);break;}}exports.default=getEChartOption;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_279__;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 外部数据元素，数据来源
var Content_OutData_DataSource=function(_React$Component){(0,_inherits3.default)(Content_OutData_DataSource,_React$Component);function Content_OutData_DataSource(props){(0,_classCallCheck3.default)(this,Content_OutData_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_OutData_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_OutData_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',sourceType:_this.props.tabData.sourceType||_this.props.tabNew.sourceType,dataSourceList:_this.props.tabData.dataSourceList||[],dataSourceType:_this.props.tabData.dataSourceType||_this.props.tabNew.dataSourceType.selected,dataSource:_this.props.tabData.dataSource||_this.props.tabNew.dataSource.selected,content:_this.props.tabData.content,primaryKey:_this.props.tabData.primaryKey,linkAddress:_this.props.tabData.linkAddress,integrateLogin:_this.props.tabData.integrateLogin||_this.props.tabNew.integrateLogin.selected,showFieldSetting:_this.props.tabData.showFieldSetting||[],dsModalVisible:true,wsaddress:'',method:'',parameters:'',ismatch:true,selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.onDelete=_this.onDelete.bind(_this);_this.onShowFieldChange=_this.onShowFieldChange.bind(_this);return _this;}(0,_createClass3.default)(Content_OutData_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,sourceType=_state.sourceType,dataSourceList=_state.dataSourceList,dataSourceType=_state.dataSourceType,dataSource=_state.dataSource,content=_state.content,primaryKey=_state.primaryKey,linkAddress=_state.linkAddress,integrateLogin=_state.integrateLogin,showFieldSetting=_state.showFieldSetting,wsaddress=_state.wsaddress,method=_state.method,parameters=_state.parameters;var tabNew=this.props.tabNew;var existSetting=_react2.default.createElement('div',null);var customSetting=_react2.default.createElement('div',null);var fieldSetting=_react2.default.createElement('div',null);var dataSourceSetting=_react2.default.createElement('div',null);if(dataSourceType=='1'){dataSourceSetting=_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(18076,"数据源"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.dataSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:dataSource,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({dataSource:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33368,"内容"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.content=el;},tipPosition:'bottom',error:getLabel(388425,"内容未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaTextarea,{className:'portal-eoutdata-submit',value:content,viewAttr:3,minRows:4,onChange:function onChange(value){_this2.setState({content:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21027,"主键"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.primaryKey=el;},tipPosition:'bottom',error:getLabel(388424,"主键未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{className:'portal-eoutdata-submit',value:primaryKey,viewAttr:3,onChange:function onChange(value){return _this2.setState({primaryKey:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16208,"链接地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:linkAddress,onChange:function onChange(value){return _this2.setState({linkAddress:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388008,"参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；并以'id='结束。")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125405,"集成登录设置"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:integrateLogin,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({integrateLogin:value});}})));}else if(dataSourceType=='2'){dataSourceSetting=_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(110,"地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.wsaddress=el;},tipPosition:'bottom',error:getLabel(388427,"地址未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:wsaddress,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({wsaddress:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(604,"方法"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.method=el;},tipPosition:'bottom',error:getLabel(388426,"方法未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:method,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({method:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(561,"参数"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:parameters,onChange:function onChange(value){return _this2.setState({parameters:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388009,"参数以xml格式输入,以root为根元素，并以属性名为子标签名（如：myName）")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21027,"主键"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.primaryKey=el;},tipPosition:'bottom',error:getLabel(388424,"主键未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:primaryKey,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({primaryKey:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16208,"链接地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:linkAddress,onChange:function onChange(value){return _this2.setState({linkAddress:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388008,"参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；并以'id='结束。")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125405,"集成登录设置"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:integrateLogin,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({integrateLogin:value});}})));}else if(dataSourceType=='3'){dataSourceSetting=_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33368,"内容"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.content=el;},tipPosition:'bottom',error:getLabel(388425,"内容未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaTextarea,{value:content,viewAttr:3,minRows:4,onChange:function onChange(value){_this2.setState({content:value});},className:'portal-eoutdata-submit'})),_react2.default.createElement('div',{style:{position:'absolute',right:'-24px',top:'40%'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388010,"可设置http链接，比如http://ip:端口/.../*.jsp、*.php、*.asp，或者servlet等，输出格式必须为xml格式。参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21027,"主键"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.primaryKey=el;},tipPosition:'bottom',error:getLabel(388424,"主键未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:primaryKey,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.setState({primaryKey:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16208,"链接地址"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{value:linkAddress,onChange:function onChange(value){return _this2.setState({linkAddress:value});}}),_react2.default.createElement('div',{style:{position:'absolute',right:'-20px',top:'6px'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(388008,"参数可设置如下内容：当前用户id，格式为{?userid}；当前用户登陆账号，格式为{?loginid}；当前用户姓名，格式为{?username}；当前用户编号，格式为{?workcode}；当前用户密码(MD5格式)，格式为{?password}；当前用户部门id，格式为{?departmentid}；当前用户部门编码，格式为{?departmentcode}；当前用户部门名称，格式为{?departmentname}；当前用户分部id，格式为{?subcompanyid}；当前用户分部编码，格式为{?subcompanycode}；当前用户分部名称，格式为{?subcompanyname}；并以'id='结束。")}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125405,"集成登录设置"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:integrateLogin,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({integrateLogin:value});}})));}if(sourceType=='1'){var columns=[{key:'sourceName',title:getLabel(30231,"数据来源名称"),dataIndex:'sourceName',width:'50%',render:function render(text,record){return _react2.default.createElement('span',null,record.sourceName);}},{key:'integrateLogin',title:getLabel(125405,"集成登录设置"),width:'50%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.integrateLogin.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:record.integrateLogin,onChange:function onChange(value){for(var i=0,len=_dataSourceList.length;i<len;i++){if(_dataSourceList[i].sourceId==record.sourceId){_dataSourceList[i].integrateLogin=value;break;}}_this2.setState({dataSourceList:_dataSourceList});}});}}];var _dataSourceList=this.state.dataSourceList;var sourceNamed=void 0;if(_dataSourceList.length>0){var sourceNames=_dataSourceList[0].sourceName;var sourceId=_dataSourceList[0].sourceId;sourceNamed=[{id:sourceId,name:sourceNames}];}existSetting=_react2.default.createElement('div',null,_react2.default.createElement('div',{style:{margin:'8px 0'}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.exterbaldata=el;},tipPosition:'bottom',error:getLabel(388428,"此项必写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'exterbaldata',isSingle:true,replaceDatas:sourceNamed||[],onChange:function onChange(id,name){_this2.setState({dataSourceList:[{key:id,sourceId:id,sourceName:name,integrateLogin:''}]});},viewAttr:3}))),_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:_dataSourceList,pagination:false}));}else if(this.state.sourceType=='2'){customSetting=_react2.default.createElement('div',{style:{marginLeft:'-30px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28006,"数据来源"),labelCol:{span:8},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.dataSourceType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:dataSourceType,style:{width:'120px'},onChange:function onChange(value){return _this2.setState({dataSourceType:value,content:'',primaryKey:'',linkAddress:'',wsaddress:'',method:'',parameters:''});}})),dataSourceSetting);// 记录选中的行
var _self=this;var rowSelection={selectedRowKeys:_self.state.selectedRowKeys,onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};var _columns=[{key:'showName',title:getLabel(15456,'字段显示名'),dataIndex:'showName',width:'30%',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2['showName'+index]=el;},tipPosition:'bottom',error:getLabel(388456,"字段显示名未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:record.showName,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.onShowFieldChange(record.key,'showName',value);}}));}},{key:'showField',title:getLabel(32320,"显示字段/XML路径"),width:'30%',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2['showField'+index]=el;},tipPosition:'bottom',error:getLabel(388457,"显示字段/XML路径未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{value:record.showField,viewAttr:3,className:'portal-eoutdata-submit',onChange:function onChange(value){return _this2.onShowFieldChange(record.key,'showField',value);}}));}},{key:'isTitle',title:getLabel(22965,'标题栏'),width:'10%',render:function render(text,record){return _react2.default.createElement(_antd.Checkbox,{checked:record.isTitle,onChange:function onChange(e){return _this2.onShowFieldChange(record.key,'isTitle',e.target.checked);}});}},{key:'transformMethod',title:_react2.default.createElement('div',null,_react2.default.createElement('span',null,getLabel(32321,"转换方法")),_react2.default.createElement(_ecCom.WeaHelpfulTip,{title:getLabel(131015,"参数可设置如下内容，格式为：select 最终字段 from tablename where 条件字段={?currentvalue}，{?currentvalue}表示当前值")})),width:'30%',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:record.transformMethod,onChange:function onChange(value){return _this2.onShowFieldChange(record.key,'transformMethod',value);}});}}];var selectedRowKeys=this.state.selectedRowKeys;fieldSetting=_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(21903,"字段设置"),needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',null,_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',onClick:this.onAdd},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',disabled:!(selectedRowKeys&&selectedRowKeys.length),onClick:this.onDelete},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,{rowSelection:rowSelection,columns:_columns,dataSource:showFieldSetting,pagination:false}));}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:500},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(24128,'基本设置'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:4},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.title=el;},tipPosition:'bottom',error:getLabel(388176,"标题未填写"),style:{width:'100%'}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,className:'portal-eoutdata-submit',value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value,oldtitle:title});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(125929,"数据类型"),labelCol:{span:4},wrapperCol:{span:18}},_react2.default.createElement('div',{style:{paddingTop:'5px'}},_react2.default.createElement(RadioGroup,{value:sourceType,onChange:function onChange(e){return _this2.setState({sourceType:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'1'},getLabel(81511,"已有数据集成")),_react2.default.createElement(_antd.Radio,{value:'2'},getLabel(32219,"自定义方式"))),existSetting,customSetting))),fieldSetting);}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this3=this;var _state2=this.state,title=_state2.title,_state2$content=_state2.content,content=_state2$content===undefined?'':_state2$content,dataSourceType=_state2.dataSourceType,sourceType=_state2.sourceType,dataSourceList=_state2.dataSourceList,showFieldSetting=_state2.showFieldSetting,_state2$primaryKey=_state2.primaryKey,primaryKey=_state2$primaryKey===undefined?'':_state2$primaryKey,wsaddress=_state2.wsaddress,method=_state2.method;var isPass=true;if(title==''){this.title.showError();isPass=false;}if(sourceType=='1'&&dataSourceList.length==0||dataSourceList[0]&&!dataSourceList[0].sourceName){this.exterbaldata.showError();isPass=false;}else if(sourceType=='2'){if(showFieldSetting.length=='0'){_antd.Modal.warning({title:getLabel(15172,'系统提示'),content:getLabel(388012,'必须设置显示字段！')});return;}else{var length=0;if(dataSourceType=='1'||dataSourceType=='3'){if(content==''){this.content.showError();isPass=false;}else if(primaryKey==''){this.primaryKey.showError();isPass=false;}}else if(dataSourceType=='2'){if(wsaddress==''){this.wsaddress.showError();isPass=false;}else if(method==''){this.method.showError();isPass=false;}else if(primaryKey==''){this.primaryKey.showError();isPass=false;}}if(isPass)this.props.onOk(this.state);showFieldSetting.map(function(item,index){_this3['tableEdit'+index]&&_this3['tableEdit'+index].refs.edit.doRequiredCheck();if(item.showName==''){_this3['showName'+index].showError();isPass=false;return;}else if(item.showField==''){_this3['showField'+index].showError();isPass=false;return;}if(!item.isTitle){length=length+1;}});if(length==showFieldSetting.length){_antd.Modal.warning({title:getLabel(15172,'系统提示'),content:getLabel(388013,'请设置标题栏字段！')});return;}}}if(isPass)this.props.onOk(this.state);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}},{key:'onAdd',value:function onAdd(){var showFieldSetting=this.state.showFieldSetting;var key=showFieldSetting.length;showFieldSetting.push({key:key,showName:'',showField:'',isTitle:false,transformMethod:''});this.setState({showFieldSetting:showFieldSetting});}},{key:'onDelete',value:function onDelete(){var _this4=this;var showFieldSetting=this.state.showFieldSetting;var selectedRowKeys=this.state.selectedRowKeys;_antd.Modal.confirm({title:getLabel(386786,'信息确认'),content:getLabel(385625,'确定要删除选择的记录吗？'),onOk:function onOk(){if(selectedRowKeys&&selectedRowKeys.length){var __selectedRowKeys=selectedRowKeys.slice();for(var i=0,len=__selectedRowKeys.length;i<len;i++){selectedRowKeys.splice(i,1);for(var j=0,len2=showFieldSetting.length;j<len2;j++){if(showFieldSetting[j].key==__selectedRowKeys[i]){showFieldSetting.splice(j,1);break;}}}_this4.setState({showFieldSetting:showFieldSetting});_this4.setState({selectedRowKeys:[]});}}});}},{key:'onShowFieldChange',value:function onShowFieldChange(key,type,value){var showFieldSetting=this.state.showFieldSetting;if(type=='isTitle'){for(var i=0,len=showFieldSetting.length;i<len;i++){showFieldSetting[i]['isTitle']=false;}showFieldSetting[key]['isTitle']=value;}else{showFieldSetting[key][type]=value;}this.setState({showFieldSetting:showFieldSetting});}}]);return Content_OutData_DataSource;}(_react2.default.Component);exports.default=Content_OutData_DataSource;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 我的协作，数据来源
var Content_13_DataSource=function(_React$Component){(0,_inherits3.default)(Content_13_DataSource,_React$Component);function Content_13_DataSource(props){(0,_classCallCheck3.default)(this,Content_13_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_13_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_13_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',cooperationSource:_this.props.tabData.cooperationSource,cooperationModule:_this.props.tabData.cooperationModule,viewType:_this.props.tabData.viewType,cooperationState:_this.props.tabData.cooperationState,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_13_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,cooperationSource=_state.cooperationSource,cooperationModule=_state.cooperationModule,viewType=_state.viewType,cooperationState=_state.cooperationState,id=_state.id,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var tabNew=this.props.tabNew;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386559,'协作来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.cooperationSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:cooperationSource||tabNew.cooperationSource.selected,onChange:function onChange(value){_this2.setState({cooperationSource:value});}})))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(83265,'协作板块'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.cooperationModule.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:cooperationModule||tabNew.cooperationModule.selected,onChange:function onChange(value){_this2.setState({cooperationModule:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(17483,'查看类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.viewType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:viewType||tabNew.viewType.selected,onChange:function onChange(value){_this2.setState({viewType:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386560,'协作状态'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.cooperationState.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:cooperationState||tabNew.cooperationState.selected,onChange:function onChange(value){_this2.setState({cooperationState:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，'))))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_13_DataSource;}(_react2.default.Component);exports.default=Content_13_DataSource;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 我的项目，数据来源
var Content_10_DataSource=function(_React$Component){(0,_inherits3.default)(Content_10_DataSource,_React$Component);function Content_10_DataSource(props){(0,_classCallCheck3.default)(this,Content_10_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_10_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_10_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',projectsSource:_this.props.tabData.projectsSource||_this.props.tabNew.projectsSource.selected,projectsState:_this.props.tabData.projectsState||_this.props.tabNew.projectsState.selected,isinclude:_this.props.tabData.isinclude||'0',eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_10_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,id=_state.id,projectsSource=_state.projectsSource,projectsState=_state.projectsState,isinclude=_state.isinclude,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var tabNew=this.props.tabNew;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28104,'项目来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{width:'100px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.projectsSource.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:projectsSource,onChange:function onChange(value){_this2.setState({projectsSource:value,isinclude:'0'});}})),this.state.projectsSource==='2'?_react2.default.createElement('div',{style:{marginLeft:10,display:'inline-flex'}},_react2.default.createElement('div',{style:{display:'inline-flex'}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:isinclude=='1',id:'test',onChange:function onChange(value){_this2.setState({isinclude:value});}})),_react2.default.createElement('span',{style:{margin:'5px 5px',display:'inline-block'}},getLabel(386558,'包含我负责的'))):_react2.default.createElement('div',null))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(587,'项目状态'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:tabNew.projectsState.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:projectsState,onChange:function onChange(value){_this2.setState({projectsState:value});}}))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',style:{position:"relative",zIndex:"12"},onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',{className:'pottal-element-showfield',style:{"margin-left":"20px"}},eFieldNewUsedNames.join('，'))))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_10_DataSource;}(_react2.default.Component);exports.default=Content_10_DataSource;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var lodash=_interopRequireWildcard(_lodash);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);var _EPicturesSettings=__webpack_require__(127);var _EPicturesSettings2=_interopRequireDefault(_EPicturesSettings);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 公司新闻，数据来源
var Content_news_DataSource=function(_React$Component){(0,_inherits3.default)(Content_news_DataSource,_React$Component);function Content_news_DataSource(props){(0,_classCallCheck3.default)(this,Content_news_DataSource);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_news_DataSource.__proto__||(0,_getPrototypeOf2.default)(Content_news_DataSource)).call(this,props));_this.state={id:_this.props.tabData.id,title:_this.props.tabData.title||'',newsCenter:_this.props.tabData.newsCenter,newsCentersNames:_this.props.tabData.newsCentersNames,eFieldNewDataSource:_this.props.tabData.eFieldNewDataSource||_this.props.tabNew.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.tabData.eFieldNewUsedKeys||[],eFieldNewVisible:false,eShowMoudle:_this.props.tabData.eShowMoudle||'1',pictureWidth:_this.props.tabData.pictureWidth,pictureHeight:_this.props.tabData.pictureHeight,widthUnit:_this.props.tabData.widthUnit||'px',heightUnit:_this.props.tabData.heightUnit||'px',autoHeight:_this.props.tabData.autoHeight||false};_this.getButtons=_this.getButtons.bind(_this);_this.onDocSourceTypeChange=_this.onDocSourceTypeChange.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeSize=_this.onChangeSize.bind(_this);return _this;}(0,_createClass3.default)(Content_news_DataSource,[{key:'render',value:function render(){var _this2=this;var _state=this.state,title=_state.title,newsCenter=_state.newsCenter,newsCentersNames=_state.newsCentersNames,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible,_state$eShowMoudle=_state.eShowMoudle,eShowMoudle=_state$eShowMoudle===undefined?'1':_state$eShowMoudle,_state$pictureWidth=_state.pictureWidth,pictureWidth=_state$pictureWidth===undefined?'120':_state$pictureWidth,_state$pictureHeight=_state.pictureHeight,pictureHeight=_state$pictureHeight===undefined?'108':_state$pictureHeight,widthUnit=_state.widthUnit,heightUnit=_state.heightUnit,autoHeight=_state.autoHeight;var authoHeight=autoHeight?"portal-news-authoheight":'';var tabNew=this.props.tabNew;var _tabNew$showMode=tabNew.showMode,showMode=_tabNew$showMode===undefined?{}:_tabNew$showMode;var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19480,'内容设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:660,height:507},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(33396,'设置项'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:title,viewAttr:3,onChange:function onChange(value){return _this2.setState({title:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22919,'新闻来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'docnews',isSingle:true,replaceDatas:newsCentersNames,onChange:function onChange(ids,names,datas){return _this2.setState({newsCenter:ids,newsCentersNames:datas});},layout:document.body})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{value:eShowMoudle,options:showMode.options||[],style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eShowMoudle:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))),this.state.eShowMoudle=='1'||this.state.eShowMoudle==''?'':_react2.default.createElement(_EPicturesSettings2.default,{onChangeSize:this.onChangeSize,pictureWidth:pictureWidth,widthUnit:widthUnit,authoHeight:authoHeight,pictureHeight:pictureHeight,heightUnit:heightUnit,autoHeight:autoHeight})));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onChangeSize',value:function onChangeSize(string,value){this.setState((0,_defineProperty3.default)({},string,value));}},{key:'onDocSourceTypeChange',value:function onDocSourceTypeChange(value,checked){var docSourceType=this.state.docSourceType;var docSourceTypeArr=docSourceType.split(',');lodash.pull(docSourceTypeArr,value);if(checked){docSourceTypeArr.push(value);}this.setState({docSourceType:docSourceTypeArr.join(',')});}},{key:'onOk',value:function onOk(){if(!this.state.title){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onOk(this.state);}}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_news_DataSource;}(_react2.default.Component);exports.default=Content_news_DataSource;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _ENewsMould=__webpack_require__(77);var _ENewsMould2=_interopRequireDefault(_ENewsMould);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 文档中心
var Content_7=function(_React$Component){(0,_inherits3.default)(Content_7,_React$Component);function Content_7(){(0,_classCallCheck3.default)(this,Content_7);return(0,_possibleConstructorReturn3.default)(this,(Content_7.__proto__||(0,_getPrototypeOf2.default)(Content_7)).apply(this,arguments));}(0,_createClass3.default)(Content_7,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:this.props.eRemindMode})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),//eContentField: this.refs['eField'].getSaveValues(),
eContentNewsMould:this.refs['eNewsMould']?this.refs['eNewsMould'].getSaveValues():this.props.eNewsMould.selected,eContentRemindMode:this.refs['eRemindMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_7;}(_react2.default.Component);exports.default=Content_7;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EScrollDirection=__webpack_require__(104);var _EScrollDirection2=_interopRequireDefault(_EScrollDirection);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 流程中心
var Content_8=function(_React$Component){(0,_inherits3.default)(Content_8,_React$Component);function Content_8(){(0,_classCallCheck3.default)(this,Content_8);return(0,_possibleConstructorReturn3.default)(this,(Content_8.__proto__||(0,_getPrototypeOf2.default)(Content_8)).apply(this,arguments));}(0,_createClass3.default)(Content_8,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:this.props.eRemindMode})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentScrollDirection:this.refs['eScrollDirection']?this.refs['eScrollDirection'].getSaveValues():this.props.eScrollDirection.selected,eContentRemindMode:this.refs['eRemindMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_8;}(_react2.default.Component);exports.default=Content_8;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 最新客户
var Content_11=function(_React$Component){(0,_inherits3.default)(Content_11,_React$Component);function Content_11(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_11);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_11.__proto__||(0,_getPrototypeOf2.default)(Content_11)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_11,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected==''?'2':this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_11;}(_react2.default.Component);exports.default=Content_11;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 最新会议
var Content_12=function(_React$Component){(0,_inherits3.default)(Content_12,_React$Component);function Content_12(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_12);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_12.__proto__||(0,_getPrototypeOf2.default)(Content_12)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_12,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_12;}(_react2.default.Component);exports.default=Content_12;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 未读文档
var Content_6=function(_React$Component){(0,_inherits3.default)(Content_6,_React$Component);function Content_6(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_6);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_6.__proto__||(0,_getPrototypeOf2.default)(Content_6)).call.apply(_ref,[this].concat(args))),_this),_this.state={docSourceType:_this.props.eDocSourceType.selected,docCatalogs:_this.props.docCatalogs,virtualCatalogs:_this.props.virtualCatalogs,docCatalogsNames:_this.props.docCatalogsNames,virtualCatalogsNames:_this.props.virtualCatalogsNames,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_6,[{key:'render',value:function render(){var _this2=this;var _state=this.state,docSourceType=_state.docSourceType,docCatalogs=_state.docCatalogs,docCatalogsNames=_state.docCatalogsNames,virtualCatalogsNames=_state.virtualCatalogsNames,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EDocFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){var type={docCatalogs:'doccategory',virtualCatalogs:'docdummy'};var isMultCheckbox={docCatalogs:true,virtualCatalogs:true};var replaceDatas={docCatalogs:docCatalogsNames,virtualCatalogs:virtualCatalogsNames};EDocFrom=_react2.default.createElement('div',{className:'portal_unreadDoc_dataSources'},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20532,'文档来源'),labelCol:{span:6},wrapperCol:{span:16},className:'portal_unreadDoc_dataSources'},_react2.default.createElement(RadioGroup,{value:docSourceType,onChange:function onChange(e){return _this2.setState({docSourceType:e.target.value});}},this.props.eDocSourceType.options.map(function(item,index){var __type=item.type;var __typeNames=item.type+'Names';var dataParams={};if('docCatalogs'==__type)dataParams={filtercategoryid:docCatalogs,filtertype:3,noAllDirName:'1'};else dataParams={};var style=item.type!='allDocs'?{display:'inline-block',width:'25%',textOverflow:'ellipsis',overflow:'hidden'}:{display:'inline-block',width:'74px',textOverflow:'ellipsis',overflow:'hidden',paddingBottom:'6px'};return _react2.default.createElement(_antd.Radio,{key:index,value:item.value,style:{display:'block'}},_react2.default.createElement('div',{style:{paddingTop:'11px'}},_react2.default.createElement('div',{title:item.label,style:style},item.label),item.type!='allDocs'?_react2.default.createElement('div',{style:{display:'inline-block',width:'75%',margin:'5px 10px',verticalAlign:'middle'}},_react2.default.createElement(_ecCom.WeaBrowser,{type:type[__type],dataParams:dataParams,isSingle:false,replaceDatas:replaceDatas[__type],onChange:function onChange(ids,names,datas){var _this2$setState;_this2.setState((_this2$setState={},(0,_defineProperty3.default)(_this2$setState,__type,ids),(0,_defineProperty3.default)(_this2$setState,__typeNames,datas),_this2$setState));if(ids!=''){_this2.setState({docSourceType:item.value});}}})):''));}))));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EDocFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentDocSourceType:this.state.docSourceType,eContentDocCatalogs:this.state.docCatalogs,eContentVirtualCatalogs:this.state.virtualCatalogs};}}]);return Content_6;}(_react2.default.Component);exports.default=Content_6;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 未读协作
var Content_13=function(_React$Component){(0,_inherits3.default)(Content_13,_React$Component);function Content_13(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_13);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_13.__proto__||(0,_getPrototypeOf2.default)(Content_13)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_13,[{key:'render',value:function render(){var eShowContent=this.state.eShowContent;var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'13'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),//eContentField: this.refs['eField'].getSaveValues(),
eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_13;}(_react2.default.Component);exports.default=Content_13;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 当月目标
var Content_14=function(_React$Component){(0,_inherits3.default)(Content_14,_React$Component);function Content_14(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_14);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_14.__proto__||(0,_getPrototypeOf2.default)(Content_14)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_14,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_14;}(_react2.default.Component);exports.default=Content_14;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 当日计划
var Content_15=function(_React$Component){(0,_inherits3.default)(Content_15,_React$Component);function Content_15(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_15);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_15.__proto__||(0,_getPrototypeOf2.default)(Content_15)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowDays:_this.props.eShowDays,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_15,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowDays=_state.eShowDays,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EShowDays=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowDays=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24021,'显示天数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eShowDays,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eShowDays:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EShowDays));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentShowDays:this.state.eShowDays};}}]);return Content_15;}(_react2.default.Component);exports.default=Content_15;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 我的邮件
var Content_16=function(_React$Component){(0,_inherits3.default)(Content_16,_React$Component);function Content_16(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_16);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_16.__proto__||(0,_getPrototypeOf2.default)(Content_16)).call.apply(_ref,[this].concat(args))),_this),_this.state={eContentFrom:_this.props.eContentFrom.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_16,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eContentFrom=_state.eContentFrom,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EContentFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EContentFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20885,'内容来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eContentFrom.options,value:eContentFrom,onChange:function onChange(checkedValue){return _this2.setState({eContentFrom:checkedValue});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'30px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EContentFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eContentFrom:this.state.eContentFrom};}}]);return Content_16;}(_react2.default.Component);exports.default=Content_16;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 消息提醒
var Content_9=function(_React$Component){(0,_inherits3.default)(Content_9,_React$Component);function Content_9(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_9);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_9.__proto__||(0,_getPrototypeOf2.default)(Content_9)).call.apply(_ref,[this].concat(args))),_this),_this.state={eMessageRemind:_this.props.eMessageRemind.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource||[],eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys||[],eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_9,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eMessageRemind=_state.eMessageRemind,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EMessageRemind=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EMessageRemind=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19085,'消息提醒'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-checkbox-group'},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eMessageRemind.options,value:eMessageRemind,onChange:function onChange(checkedValue){return _this2.setState({eMessageRemind:checkedValue});}})));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EMessageRemind));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentMessageRemind:this.state.eMessageRemind};}}]);return Content_9;}(_react2.default.Component);exports.default=Content_9;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 我的项目
var Content_10_new=function(_React$Component){(0,_inherits3.default)(Content_10_new,_React$Component);function Content_10_new(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_10_new);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_10_new.__proto__||(0,_getPrototypeOf2.default)(Content_10_new)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_10_new,[{key:'render',value:function render(){var eShowContent=this.state.eShowContent;var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'10'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),//eContentField: this.refs['eField'].getSaveValues(),
eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_10_new;}(_react2.default.Component);exports.default=Content_10_new;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);var _ENewsMould=__webpack_require__(77);var _ENewsMould2=_interopRequireDefault(_ENewsMould);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 多新闻中心
var Content_17=function(_React$Component){(0,_inherits3.default)(Content_17,_React$Component);function Content_17(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_17);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_17.__proto__||(0,_getPrototypeOf2.default)(Content_17)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNewsPageId:_this.props.eNewsPageId,eNewsMoreAddress:_this.props.eNewsMoreAddress,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_17,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eNewsPageId=_state.eNewsPageId,eNewsMoreAddress=_state.eNewsMoreAddress,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var ENewsModule=_react2.default.createElement('div',null);var ENewsPageId=_react2.default.createElement('div',null);var ENewsMoreAddress=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENewsModule=_react2.default.createElement(_ENewsMould2.default,{ref:'eNewsMould',options:this.props.eNewsMould.options,value:this.props.eNewsMould.selected});ENewsPageId=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386561,'新闻页ID'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNewsPageId,style:{width:'80%'},onChange:function onChange(value){return _this2.setState({eNewsPageId:value});}}),_react2.default.createElement('div',null,getLabel(386562,'多新闻页请用半角分号分开。如（1;2）')));ENewsMoreAddress=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386563,'More地址'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNewsMoreAddress,style:{width:'80%'},onChange:function onChange(value){return _this2.setState({eNewsMoreAddress:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,ENewsModule,ENewsPageId,ENewsMoreAddress,_react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:this.props.eRemindMode})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentNewsMould:this.refs['eNewsMould'].getSaveValues(),eContentNewsPageId:this.state.eNewsPageId,eContentNewsMoreAddress:this.state.eNewsMoreAddress,eContentRemindMode:this.refs['eRemindMode'].getSaveValues()};}}]);return Content_17;}(_react2.default.Component);exports.default=Content_17;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 期刊中心
var Content_18=function(_React$Component){(0,_inherits3.default)(Content_18,_React$Component);function Content_18(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_18);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_18.__proto__||(0,_getPrototypeOf2.default)(Content_18)).call.apply(_ref,[this].concat(args))),_this),_this.state={eMagazine:_this.props.eMagazine.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_18,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eMagazine=_state.eMagazine,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EMagazine=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EMagazine=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20052,'期刊列表'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-checkbox-group'},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eMagazine.options,value:eMagazine,onChange:function onChange(checkedValue){return _this2.setState({eMagazine:checkedValue});}})));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EMagazine));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentMagazine:this.state.eMagazine};}}]);return Content_18;}(_react2.default.Component);exports.default=Content_18;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 股票元素
var Content_19=function(_React$Component){(0,_inherits3.default)(Content_19,_React$Component);function Content_19(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_19);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_19.__proto__||(0,_getPrototypeOf2.default)(Content_19)).call.apply(_ref,[this].concat(args))),_this),_this.state={eStockImageSize:_this.props.eStockImageSize,eStockCode:_this.props.eStockCode,eAutoSwitch:_this.props.eAutoSwitch||'1',eSpeedSwitch:_this.props.eSpeedSwitch||3000},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_19,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eStockImageSize=_state.eStockImageSize,eStockCode=_state.eStockCode,eAutoSwitch=_state.eAutoSwitch,eSpeedSwitch=_state.eSpeedSwitch;var EStockImageSize='';var EStockCode='';var EAutoSwitch='';var ESpeedSwitch='';if(this.props.eShareLevel=='2'){EStockImageSize=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386564,'图片大小'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eStockImageSize.width,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eStockImageSize:(0,_extends3.default)({},eStockImageSize,{width:value})});}}),_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eStockImageSize.height,style:{width:'40px',marginRight:'8px'},onChange:function onChange(value){return _this2.setState({eStockImageSize:(0,_extends3.default)({},eStockImageSize,{height:value})});}}));EStockCode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20048,'股票代码'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eStockCode,style:{width:'80%'},onChange:function onChange(value){return _this2.setState({eStockCode:value});}}),_react2.default.createElement('div',null,getLabel(386565,'多股票请用半角分号分隔（SHA:000001;SHE:399001）')));}EAutoSwitch=_react2.default.createElement(_ecCom.WeaFormItem,{label:'自动切换',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eAutoSwitch,display:'switch',onChange:function onChange(value){return _this2.setState({eAutoSwitch:value});},style:{display:'inline'}}));ESpeedSwitch=_react2.default.createElement(_ecCom.WeaFormItem,{label:'切换速度',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eSpeedSwitch,style:{width:'10%',float:'left'},onChange:function onChange(value){return _this2.setState({eSpeedSwitch:value});}}),_react2.default.createElement('span',{style:{float:'left',marginTop:'5px'}},'ms'));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EStockImageSize,EStockCode,EAutoSwitch,eAutoSwitch=='1'&&ESpeedSwitch));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentStockImageSize:this.state.eStockImageSize,eContentStockCode:this.state.eStockCode,eContentAutoSwitch:this.state.eAutoSwitch,eContentSpeedSwitch:this.state.eSpeedSwitch};}}]);return Content_19;}(_react2.default.Component);exports.default=Content_19;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 文档内容
var Content_25=function(_React$Component){(0,_inherits3.default)(Content_25,_React$Component);function Content_25(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_25);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_25.__proto__||(0,_getPrototypeOf2.default)(Content_25)).call.apply(_ref,[this].concat(args))),_this),_this.state={eDocContentFormIds:_this.props.eDocContentFormIds,eDocContentForm:_this.props.eDocContentForm},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_25,[{key:'render',value:function render(){var _this2=this;var eDocContentForm=this.state.eDocContentForm;var linkUrl='';if(eDocContentForm.length>0){linkUrl='/spa/document/index.jsp?id='+eDocContentForm[0].id+'&router=1#/main/document/detail?id=';}var EDocContentFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EDocContentFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20885,'内容来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:9,hasAdvanceSerach:true,isUseTest:true,icon:'icon-toolbar-Organization-list',iconBgcolor:'#b32e37',quickSearchName:'docsubject',isMultCheckbox:true,searchsubject:false,isSingle:true,replaceDatas:eDocContentForm||[],linkUrl:linkUrl,onChange:function onChange(ids,names,datas){return _this2.setState({eDocContentFormIds:ids,eDocContentForm:datas});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EDocContentFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentDocContentForm:this.state.eDocContentFormIds};}}]);return Content_25;}(_react2.default.Component);exports.default=Content_25;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义页面
var Content_29=function(_React$Component){(0,_inherits3.default)(Content_29,_React$Component);function Content_29(){(0,_classCallCheck3.default)(this,Content_29);return(0,_possibleConstructorReturn3.default)(this,(Content_29.__proto__||(0,_getPrototypeOf2.default)(Content_29)).apply(this,arguments));}(0,_createClass3.default)(Content_29,[{key:'render',value:function render(){var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'29'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_29;}(_react2.default.Component);exports.default=Content_29;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 计划任务
var Content_32=function(_React$Component){(0,_inherits3.default)(Content_32,_React$Component);function Content_32(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_32);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_32.__proto__||(0,_getPrototypeOf2.default)(Content_32)).call.apply(_ref,[this].concat(args))),_this),_this.state={ePlanCreator:_this.props.ePlanCreator.checked,eUserRole:_this.props.eUserRole.checked,ePlanState:_this.props.ePlanState.checked,ePlanType:_this.props.ePlanType.checked,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_32,[{key:'render',value:function render(){var _this2=this;var _state=this.state,ePlanCreator=_state.ePlanCreator,eUserRole=_state.eUserRole,ePlanState=_state.ePlanState,ePlanType=_state.ePlanType,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EPlanCreator=_react2.default.createElement('div',null);var EUserRole=_react2.default.createElement('div',null);var EPlanState=_react2.default.createElement('div',null);var EPlanType=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EPlanCreator=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22319,'计划任务创建人'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.ePlanCreator.options,value:ePlanCreator,onChange:function onChange(checkedValue){return _this2.setState({ePlanCreator:checkedValue});}}));EUserRole=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22320,'用户扮演角色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eUserRole.options,value:eUserRole,onChange:function onChange(checkedValue){return _this2.setState({eUserRole:checkedValue});}}));EPlanState=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21947,'计划任务状态'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.ePlanState.options,value:ePlanState,onChange:function onChange(checkedValue){return _this2.setState({ePlanState:checkedValue});}}));EPlanType=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22321,'计划任务类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-esetting-checkbox-group'},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.ePlanType.options,value:ePlanType,onChange:function onChange(checkedValue){return _this2.setState({ePlanType:checkedValue});}})));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EPlanCreator,EUserRole,EPlanState,EPlanType));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentPlanCreator:this.state.ePlanCreator,eContentUserRole:this.state.eUserRole,eContentPlanState:this.state.ePlanState,eContentPlanType:this.state.ePlanType};}}]);return Content_32;}(_react2.default.Component);exports.default=Content_32;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 任务元素
var Content_Task=function(_React$Component){(0,_inherits3.default)(Content_Task,_React$Component);function Content_Task(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_Task);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_Task.__proto__||(0,_getPrototypeOf2.default)(Content_Task)).call.apply(_ref,[this].concat(args))),_this),_this.state={eCreator:_this.props.eCreator,eUser:_this.props.eUser,eStartDate:_this.props.eStartDate,eEndDate:_this.props.eEndDate,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_Task,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eCreator=_state.eCreator,eUser=_state.eUser,eStartDate=_state.eStartDate,eEndDate=_state.eEndDate,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentCreator:this.state.eCreator,eContentUser:this.state.eUser,eContentStartDate:this.state.eStartDate,eContentEndDate:this.state.eEndDate,eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_Task;}(_react2.default.Component);exports.default=Content_Task;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 知识订阅
var Content_34=function(_React$Component){(0,_inherits3.default)(Content_34,_React$Component);function Content_34(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_34);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_34.__proto__||(0,_getPrototypeOf2.default)(Content_34)).call.apply(_ref,[this].concat(args))),_this),_this.state={eSubscribeDocCatalogIds:_this.props.eSubscribeDocCatalogIds,eSubscribeDocCatalog:_this.props.eSubscribeDocCatalog,eSubscribeTheme:_this.props.eSubscribeTheme,eSubscribeStartDate:_this.props.eSubscribeStartDate,eSubscribeEndDate:_this.props.eSubscribeEndDate,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_34,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eSubscribeDocCatalog=_state.eSubscribeDocCatalog,eSubscribeTheme=_state.eSubscribeTheme,eSubscribeStartDate=_state.eSubscribeStartDate,eSubscribeEndDate=_state.eSubscribeEndDate,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var ESubscribeDocCatalog=_react2.default.createElement('div',null);var ESubscribeTheme=_react2.default.createElement('div',null);var ESubscribeStartDate=_react2.default.createElement('div',null);var ESubscribeEndDate=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ESubscribeDocCatalog=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(16398,'文档目录'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'doccategory',isMultCheckbox:true,isSingle:false,replaceDatas:eSubscribeDocCatalog||[],onChange:function onChange(ids,names,datas){return _this2.setState({eSubscribeDocCatalogIds:ids,eSubscribeDocCatalog:datas});}}));ESubscribeTheme=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24611,'订阅主题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eSubscribeTheme,onChange:function onChange(value){return _this2.setState({eSubscribeTheme:value});}}));ESubscribeStartDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24609,'订阅起始日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaDatePicker,{value:eSubscribeStartDate,onChange:function onChange(value){return _this2.setState({eSubscribeStartDate:value});}}));ESubscribeEndDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24610,'订阅最终日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaDatePicker,{value:eSubscribeEndDate,onChange:function onChange(value){return _this2.setState({eSubscribeEndDate:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,ESubscribeDocCatalog,ESubscribeTheme,ESubscribeStartDate,ESubscribeEndDate));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentSubscribeDocCatalog:this.state.eSubscribeDocCatalogIds,eContentSubscribeTheme:this.state.eSubscribeTheme,eContentSubscribeStartDate:this.state.eSubscribeStartDate,eContentSubscribeEndDate:this.state.eSubscribeEndDate};}}]);return Content_34;}(_react2.default.Component);exports.default=Content_34;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 音频元素
var Content_audio=function(_React$Component){(0,_inherits3.default)(Content_audio,_React$Component);function Content_audio(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_audio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_audio.__proto__||(0,_getPrototypeOf2.default)(Content_audio)).call.apply(_ref,[this].concat(args))),_this),_this.state={eAudioShow:_this.props.eAudioShow,eAudioForm:_this.props.eAudioForm},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_audio,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eAudioShow=_state.eAudioShow,eAudioForm=_state.eAudioForm;var EShowSetting=_react2.default.createElement('div',null);var EAudioFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33549,'显示设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eAudioShow.height,style:{width:'50px'},onChange:function onChange(value){return _this2.setState({eAudioShow:(0,_extends3.default)({},eAudioShow,{height:value})});}}),_react2.default.createElement(_antd.Checkbox,{checked:eAudioShow.autoPlay,style:{marginLeft:'10px'},onChange:function onChange(e){return _this2.setState({eAudioShow:(0,_extends3.default)({},eAudioShow,{autoPlay:e.target.checked})});}},getLabel(22840,'自动播放')));var radioStyle={display:'block',height:'30px',lineHeight:'30px',marginBottom:'5px'};EAudioFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(23786,'音频来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eAudioForm.type||'1',onChange:function onChange(e){return _this2.setState({eAudioForm:(0,_extends3.default)({},eAudioForm,{type:e.target.value})});}},_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'1'},getLabel(125333,'选择文件')),_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'2'},getLabel(386575,'URL路径'))),_react2.default.createElement('div',{style:{position:'absolute',top:0,left:0,width:'100%',marginLeft:'85px',paddingRight:'85px'}},_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_WeaMaterialLib2.default,{value:eAudioForm.src,onChange:function onChange(value){return _this2.setState({eAudioForm:(0,_extends3.default)({},eAudioForm,{src:value})});}})),_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_ecCom.WeaInput,{value:eAudioForm.url,onChange:function onChange(value){return _this2.setState({eAudioForm:(0,_extends3.default)({},eAudioForm,{url:value})});}}))));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowSetting,EAudioFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentAudioShow_height:this.state.eAudioShow.height,eContentAudioShow_autoPlay:this.state.eAudioShow.autoPlay,eContentAudioForm_type:this.state.eAudioForm.type||'1',eContentAudioForm_src:this.state.eAudioForm.src,eContentAudioForm_url:this.state.eAudioForm.url};}}]);return Content_audio;}(_react2.default.Component);exports.default=Content_audio;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 微博动态
var Content_blogStatus=function(_React$Component){(0,_inherits3.default)(Content_blogStatus,_React$Component);function Content_blogStatus(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_blogStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_blogStatus.__proto__||(0,_getPrototypeOf2.default)(Content_blogStatus)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_blogStatus,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_blogStatus;}(_react2.default.Component);exports.default=Content_blogStatus;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 收藏元素
var Content_favourite=function(_React$Component){(0,_inherits3.default)(Content_favourite,_React$Component);function Content_favourite(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_favourite);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_favourite.__proto__||(0,_getPrototypeOf2.default)(Content_favourite)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_favourite,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_favourite;}(_react2.default.Component);exports.default=Content_favourite;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// Flash元素
var Content_Flash=function(_React$Component){(0,_inherits3.default)(Content_Flash,_React$Component);function Content_Flash(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_Flash);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_Flash.__proto__||(0,_getPrototypeOf2.default)(Content_Flash)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFlashShow:_this.props.eFlashShow,eFlashForm:_this.props.eFlashForm},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_Flash,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFlashShow=_state.eFlashShow,eFlashForm=_state.eFlashForm;var EShowSetting=_react2.default.createElement('div',null);var EFlashFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33549,'显示设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eFlashShow.height,style:{width:'50px'},onChange:function onChange(value){return _this2.setState({eFlashShow:(0,_extends3.default)({},eFlashShow,{height:value})});}}));var radioStyle={display:'block',height:'30px',lineHeight:'30px',marginBottom:'5px'};EFlashFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386579,'Flash来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eFlashForm.type||'1',onChange:function onChange(e){return _this2.setState({eFlashForm:(0,_extends3.default)({},eFlashForm,{type:e.target.value})});}},_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'1'},getLabel(125333,'选择文件')),_react2.default.createElement(_antd.Radio,{style:radioStyle,value:'2'},getLabel(386575,'URL路径'))),_react2.default.createElement('div',{style:{position:'absolute',top:0,left:0,width:'100%',marginLeft:'85px',paddingRight:'85px'}},_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_WeaMaterialLib2.default,{value:eFlashForm.src,onChange:function onChange(value){return _this2.setState({eFlashForm:(0,_extends3.default)({},eFlashForm,{src:value})});}})),_react2.default.createElement('div',{style:radioStyle},_react2.default.createElement(_ecCom.WeaInput,{value:eFlashForm.url,onChange:function onChange(value){return _this2.setState({eFlashForm:(0,_extends3.default)({},eFlashForm,{url:value})});}}))));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowSetting,EFlashFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentFlashShow_height:this.state.eFlashShow.height,eContentFlashShow_autoPlay:this.state.eFlashShow.autoPlay,eContentFlashForm_type:this.state.eFlashForm.type||'1',eContentFlashForm_src:this.state.eFlashForm.src,eContentFlashForm_url:this.state.eFlashForm.url};}}]);return Content_Flash;}(_react2.default.Component);exports.default=Content_Flash;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义菜单
var Content_menu=function(_React$Component){(0,_inherits3.default)(Content_menu,_React$Component);function Content_menu(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_menu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_menu.__proto__||(0,_getPrototypeOf2.default)(Content_menu)).call.apply(_ref,[this].concat(args))),_this),_this.state={eMenuFrom:_this.props.eMenuFrom.selected,eMenuStyleType:_this.props.eMenuStyleType,eMenuHStyle:_this.props.eMenuHStyle.selected,eMenuVStyle:_this.props.eMenuVStyle.selected},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_menu,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eMenuFrom=_state.eMenuFrom,eMenuStyleType=_state.eMenuStyleType,eMenuHStyle=_state.eMenuHStyle,eMenuVStyle=_state.eMenuVStyle;var EMenuFrom=_react2.default.createElement('div',null);var EMenuStyle=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EMenuFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(18773,'自定义菜单'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eMenuFrom.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eMenuFrom,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eMenuFrom:value});}}));EMenuStyle=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22916,'菜单样式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eMenuStyleType,onChange:function onChange(e){return _this2.setState({eMenuStyleType:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'menuh'},getLabel(386591,'横向样式（仅支持一级菜单）')),_react2.default.createElement(_antd.Radio,{value:'menuv'},getLabel(386592,'纵向样式（仅支持二级菜单）'))),eMenuStyleType=='menuh'?_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eMenuHStyle.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eMenuHStyle,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eMenuHStyle:value});}}):_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eMenuVStyle.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eMenuVStyle,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eMenuVStyle:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EMenuFrom,EMenuStyle));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,// eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
eContentMenuFrom:this.state.eMenuFrom,eContentMenuStyleType:this.state.eMenuStyleType,eContentMenuHStyle:this.state.eMenuHStyle,eContentMenuVStyle:this.state.eMenuVStyle};}}]);return Content_menu;}(_react2.default.Component);exports.default=Content_menu;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 公告栏元素
var Content_notice=function(_React$Component){(0,_inherits3.default)(Content_notice,_React$Component);function Content_notice(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_notice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_notice.__proto__||(0,_getPrototypeOf2.default)(Content_notice)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNoticeIcon:_this.props.eNoticeIcon,eNoticeTitle:_this.props.eNoticeTitle,eNoticeContent:_this.props.eNoticeContent,eNoticeScrollDirection:_this.props.eNoticeScrollDirection,eNoticeScrollSpeed:_this.props.eNoticeScrollSpeed,eNoticeIsText:_this.props.eNoticeIsText},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_notice,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eNoticeIcon=_state.eNoticeIcon,eNoticeTitle=_state.eNoticeTitle,eNoticeContent=_state.eNoticeContent,eNoticeScrollDirection=_state.eNoticeScrollDirection,eNoticeScrollSpeed=_state.eNoticeScrollSpeed,eNoticeIsText=_state.eNoticeIsText;var ENoticeIcon=_react2.default.createElement('div',null);var ENoticeTitle=_react2.default.createElement('div',null);var ENoticeContent=_react2.default.createElement('div',null);var ENoticeScrollDirection=_react2.default.createElement('div',null);var ENoticeScrollSpeed=_react2.default.createElement('div',null);var ENoticeIsText=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENoticeIcon=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(82757,'图标'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_WeaMaterialLib2.default,{value:eNoticeIcon,onChange:function onChange(value){return _this2.setState({eNoticeIcon:value});}}));ENoticeTitle=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24986,'标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:eNoticeTitle,onChange:function onChange(value){return _this2.setState({eNoticeTitle:value});}}));ENoticeContent=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33368,'内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNoticeContent,onChange:function onChange(value){return _this2.setState({eNoticeContent:value});}}));ENoticeScrollDirection=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20281,'滚动方向'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eNoticeScrollDirection.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eNoticeScrollDirection,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eNoticeScrollDirection:value});}}));ENoticeScrollSpeed=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNoticeScrollSpeed,style:{width:'200px'},onChange:function onChange(value){return _this2.setState({eNoticeScrollSpeed:value});}}));ENoticeIsText=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19111,'纯文本格式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eNoticeIsText.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eNoticeIsText,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eNoticeIsText:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ENoticeIcon,ENoticeTitle,ENoticeContent,ENoticeScrollDirection,ENoticeScrollSpeed,ENoticeIsText));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentNoticeIcon:this.state.eNoticeIcon,eContentNoticeTitle:this.state.eNoticeTitle,eContentNoticeContent:this.state.eNoticeContent,eContentNoticeScrollDirection:this.state.eNoticeScrollDirection,eContentNoticeScrollSpeed:this.state.eNoticeScrollSpeed,eContentNoticeIsText:this.state.eNoticeIsText};}}]);return Content_notice;}(_react2.default.Component);exports.default=Content_notice;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_picture_detail_new=__webpack_require__(310);var _Content_picture_detail_new2=_interopRequireDefault(_Content_picture_detail_new);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// import Content_picture_detail from './Content_picture_detail';
// 图片元素
var Content_picture=function(_React$Component){(0,_inherits3.default)(Content_picture,_React$Component);function Content_picture(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_picture);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_picture.__proto__||(0,_getPrototypeOf2.default)(Content_picture)).call.apply(_ref,[this].concat(args))),_this),_this.state={ePopupSetting:_this.props.ePopupSetting,eDisplayMode:_this.props.eDisplayMode,eImageWidth:_this.props.eImageWidth,eImageHeight:_this.props.eImageHeight,eScrollAuto:_this.props.eScrollAuto,eScrollSpeed:_this.props.eScrollSpeed,eScrollPoint:_this.props.eScrollPoint,eInfoWordNum:_this.props.eInfoWordNum,eImageSource:_this.props.eImageSource,eIsAutoHiehgt:_this.props.isAutoHiehgt||'0',eImageWidthUnit:_this.props.imageWidthUnit||'px',eImageHeightUnit:_this.props.imageHeightUnit||'px',eRollingDirection:_this.props.rollingDirection||'1',showTitle:_this.props.showTitle||'1',fontSize:_this.props.fontSize||'16',detailModalVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_picture,[{key:'render',value:function render(){var _this2=this;var _state=this.state,ePopupSetting=_state.ePopupSetting,eDisplayMode=_state.eDisplayMode,eImageWidth=_state.eImageWidth,eImageHeight=_state.eImageHeight,eScrollAuto=_state.eScrollAuto,eScrollSpeed=_state.eScrollSpeed,eScrollPoint=_state.eScrollPoint,eInfoWordNum=_state.eInfoWordNum,eImageSource=_state.eImageSource,detailModalVisible=_state.detailModalVisible,eRollingDirection=_state.eRollingDirection,eImageWidthUnit=_state.eImageWidthUnit,eImageHeightUnit=_state.eImageHeightUnit,showTitle=_state.showTitle,fontSize=_state.fontSize;var eIsAutoHiehgt=this.state.eIsAutoHiehgt;if(eRollingDirection=='2'){eIsAutoHiehgt='0';}var options=[{key:"px",selected:true,showname:"px"},{key:"%",showname:"%"}];var EPopupSetting=_react2.default.createElement('div',null);var EDisplayMode=_react2.default.createElement('div',null);var EImageSize=_react2.default.createElement('div',null);var EPictureFrom=_react2.default.createElement('div',null);var ERollingDirection=_react2.default.createElement('div',null);var EScrollSpeed=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){var _ref2,_ref3,_ref4;EPopupSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24051,'弹出设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePopupSetting,onChange:function onChange(e){return _this2.setState({ePopupSetting:e.target.checked});}},getLabel(24052,"弹出图片")));EDisplayMode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eDisplayMode,onChange:function onChange(e){return _this2.setState({eDisplayMode:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'1'},getLabel(22920,'单张显示')),_react2.default.createElement(_antd.Radio,{value:'2'},getLabel(22921,'多张显示'))),this.state.eDisplayMode=='2'&&_react2.default.createElement('div',{style:{display:'inline-block',bottom:'3px'}},_react2.default.createElement('span',null,'\u5E03\u5C40'),_react2.default.createElement(_ecCom.WeaSelect,{value:eRollingDirection,options:[{key:"1",selected:true,showname:'横向'},{key:"2",showname:'纵向'}],style:{width:'80px',marginLeft:'10px'},onChange:function onChange(value){return _this2.setState({eRollingDirection:value});}})));EImageSize=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386564,'图片大小'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386529,'宽度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eImageWidth,style:{width:'40px',marginRight:'10px'},onChange:function onChange(value){return _this2.setState({eImageWidth:value});}}),_react2.default.createElement(_ecCom.WeaSelect,{value:eImageWidthUnit,options:options,style:{width:'70px',marginRight:'10px'},onChange:function onChange(value){return _this2.setState({eImageWidthUnit:value});}}),eIsAutoHiehgt!='1'&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eImageHeight,style:{width:'40px'},onChange:function onChange(value){return _this2.setState({eImageHeight:value});}}),_react2.default.createElement(_ecCom.WeaSelect,{value:eImageHeightUnit,options:options,style:{width:'70px',marginLeft:'10px'},onChange:function onChange(value){return _this2.setState({eImageHeightUnit:value});}})),eRollingDirection=='1'&&_react2.default.createElement('div',{style:(_ref2={display:'inline-block',position:'relative'},(0,_defineProperty3.default)(_ref2,'display','inline-block'),(0,_defineProperty3.default)(_ref2,'left','22px'),_ref2)},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eIsAutoHiehgt==1,onChange:function onChange(e){_this2.setState({eIsAutoHiehgt:e.target.checked?1:0});}},'自适应高度')));var modal2Detail=_react2.default.createElement('div',null);if(detailModalVisible){var detailProps={datas:eImageSource,showTitle:showTitle,fontSize:fontSize,onOk:function onOk(datas,showTitle,fontSize){_this2.setState({eImageSource:datas,detailModalVisible:false,showTitle:showTitle,fontSize:fontSize});},onCancel:function onCancel(){_this2.setState({detailModalVisible:false});}};modal2Detail=_react2.default.createElement(_Content_picture_detail_new2.default,detailProps);}EPictureFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22930,'图片来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{marginTop:'10px'}},_react2.default.createElement(_antd.Button,{type:'primary',size:'small',onClick:function onClick(){return _this2.setState({detailModalVisible:true});}},getLabel(22923,'图片设置'))),modal2Detail);EScrollSpeed=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eScrollSpeed,style:{width:'80px'},onChange:function onChange(value){return _this2.setState({eScrollSpeed:value});}}),_react2.default.createElement('span',{style:{top:' -4px',position:'relative'}},'ms'),_react2.default.createElement('div',{style:(_ref3={display:'inline-block',position:'relative'},(0,_defineProperty3.default)(_ref3,'display','inline-block'),(0,_defineProperty3.default)(_ref3,'left','22px'),_ref3)},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eScrollAuto,onChange:function onChange(e){_this2.setState({eScrollAuto:e.target.checked});}},getLabel(24548,'自动滚动'))),_react2.default.createElement('div',{style:(_ref4={display:'inline-block',position:'relative'},(0,_defineProperty3.default)(_ref4,'display','inline-block'),(0,_defineProperty3.default)(_ref4,'left','22px'),_ref4)},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eScrollPoint,onChange:function onChange(e){return _this2.setState({eScrollPoint:e.target.checked});}},getLabel(22928,'滚动指向'))));// ERollingDirection= (
//     <WeaFormItem label={'滚动方向'} labelCol={{span: 6}} wrapperCol={{span: 16}}>
//         <WeaSelect value={eRollingDirectionDetial} options={
//             eRollingDirection == '2' ?[{
//                 key: "0",
//                 selected: true,
//                 showname: '无'
//             },{
//                 key: "3",
//                 showname: '向上'
//             },{
//                 key: "4",
//                 showname: '向下',
//             }]:[{
//                 key: "0",
//                 selected: true,
//                 showname: '无'
//             },{
//                 key: "1",
//                 showname: '向左'
//             },{
//                 key: "2",
//                 showname: '向右',
//             }]
//         } style={{width: '80px', marginRight: '10px'}} onChange={value => this.setState({eRollingDirectionDetial: value})}></WeaSelect>
//         <Checkbox size="default" checked={eScrollPoint} onChange={e => this.setState({eScrollPoint: e.target.checked})}>{getLabel(22928, '滚动指向')}</Checkbox>
//     </WeaFormItem>
// );
}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EPopupSetting,EDisplayMode,EImageSize,eDisplayMode=='2'&&EScrollSpeed,EPictureFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentPopupSetting:this.state.ePopupSetting,eContentDisplayMode:this.state.eDisplayMode,eContentImageWidth:this.state.eImageWidth,eContentImageHeight:this.state.eImageHeight,eContentScrollAuto:this.state.eScrollAuto,eContentScrollSpeed:this.state.eScrollSpeed,eContentScrollPoint:this.state.eScrollPoint,eContentInfoWordNum:this.state.eInfoWordNum,eContentImageSource:this.state.eImageSource,eRollingDirection:this.state.eRollingDirection,eIsAutoHiehgt:this.state.eIsAutoHiehgt,eImageWidthUnit:this.state.eImageWidthUnit,eImageHeightUnit:this.state.eImageHeightUnit,eContentShowTitle:this.state.showTitle,eContentFontSize:this.state.fontSize};}}]);return Content_picture;}(_react2.default.Component);exports.default=Content_picture;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _keys=__webpack_require__(105);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaPortalPublic=__webpack_require__(65);var _Content_imgSlide_img=__webpack_require__(134);var _Content_imgSlide_img2=_interopRequireDefault(_Content_imgSlide_img);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 图片元素详细设置
var Content_picture_detail_new=function(_React$Component){(0,_inherits3.default)(Content_picture_detail_new,_React$Component);function Content_picture_detail_new(props){(0,_classCallCheck3.default)(this,Content_picture_detail_new);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_picture_detail_new.__proto__||(0,_getPrototypeOf2.default)(Content_picture_detail_new)).call(this,props));_this.state={visible:true,showTitle:props.showTitle,fontSize:props.fontSize,titles:getLabel(507,'图片上传'),datas:props.datas,selectedDatas:{},selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.getUuid=_this.getUuid.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeBgImage=_this.onChangeBgImage.bind(_this);_this.getColumns=_this.getColumns.bind(_this);_this.getItems=_this.getItems.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.deleteTabs=_this.deleteTabs.bind(_this);return _this;}(0,_createClass3.default)(Content_picture_detail_new,[{key:'onRowSelect',value:function onRowSelect(sRowKeys,rows,dataIndex,selectedDatas){var newState={};newState.selectedRowKeys=sRowKeys;if(selectedDatas){newState.selectedDatas=selectedDatas;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:'getUuid',value:function getUuid(){var s=[];var hexDigits="0123456789abcdef";for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]="4";// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the clock_seq_hi_and_reserved to 01
s[8]=s[13]=s[18]=s[23]="-";var uuid=s.join("");return uuid;}},{key:'onChangeBgImage',value:function onChangeBgImage(index,value){if(value){var _state$datas=this.state.datas,datas=_state$datas===undefined?[]:_state$datas;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var _value=value.split(",");if("multiCheck"==index){for(var i=0;i<_value.length;i++){_datas.push({src:_value[i],title:'',link:''});}}else{_datas[index].src=value;}var __datas=_datas.map(function(item,index){return(0,_extends3.default)({},item,{key:index});});this.setState({datas:__datas});}}},{key:'getColumns',value:function getColumns(){var _this2=this;var _state=this.state,datas=_state.datas,fontSize=_state.fontSize,showTitle=_state.showTitle;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var columns=[{title:getLabel(126949,'图片预览'),display:'true',key:'src',width:'30%',className:'wea-table-edit-prew',render:function render(text,record,index){return _react2.default.createElement(_Content_imgSlide_img2.default,{title:record.title,imgSrc:record.src,fontSize:fontSize,showTitle:showTitle});}},{title:getLabel(386586,'图片标题'),display:'true',width:'25%',key:'title',className:'wea-table-edit-title',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError//tipPosition='bottom'
,{ref:function ref(el){_this2['weaError_'+record.key]=el;},error:'\u6570\u636E\u4E3A\u7A7A'},_react2.default.createElement(_ecCom.WeaInput,{value:record.title||'',viewAttr:showTitle=='1'?3:2,onChange:function onChange(value){_datas[record.key].title=value;_this2.setState({datas:_datas});}}));}},{title:getLabel(22932,'图片链接'),display:'true',width:'25%',key:'link',className:'wea-table-edit-imgAddress',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaInput,{value:record.link,onChange:function onChange(value){_datas[record.key].link=value;_this2.setState({datas:_datas});}});}},{title:getLabel(20001,'上传图片'),display:'true',width:'15%',className:'wea-table-edit-upload',render:function render(text,record,index){return _react2.default.createElement('div',{className:'e9login-bg-images-btns-materiallib'},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:false,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary'},getLabel(127538,'更改图片'))));}}];return columns;}},{key:'getItems',value:function getItems(){var _this3=this;var _state2=this.state,showTitle=_state2.showTitle,fontSize=_state2.fontSize;var items=[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386587,'显示标题栏'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showTitle,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){return _this3.setState({showTitle:value});}}))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386588,'标题文字大小'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:fontSize,onChange:function onChange(value){return _this3.setState({fontSize:value});},style:{width:'82px',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'10px'}},'px')))}];return items;}},{key:'onDeleteTabs',value:function onDeleteTabs(){var _state3=this.state,selectedRowKeys=_state3.selectedRowKeys,datas=_state3.datas;for(var i=0;i<selectedRowKeys.length;i++){this.deleteTabs(selectedRowKeys[i]);}this.setState({selectedRowKeys:[]});}},{key:'deleteTabs',value:function deleteTabs(dataId){var _state4=this.state,datas=_state4.datas,selectedRowKeys=_state4.selectedRowKeys;for(var i=0;i<datas.length;i++){if(datas[i].key==dataId){datas.splice(i,1);break;}}this.setState({datas:datas,selectedRowKeys:[]});}},{key:'render',value:function render(){var _this4=this,_React$createElement;var _state5=this.state,visible=_state5.visible,eFieldNewDataSource=_state5.eFieldNewDataSource,eFieldNewUsedKeys=_state5.eFieldNewUsedKeys,searchName=_state5.searchName,title=_state5.title,items=_state5.items,isModalEdit=_state5.isModalEdit,datas=_state5.datas,titles=_state5.titles,selectedDatas=_state5.selectedDatas,selectedRowKeys=_state5.selectedRowKeys;// 记录选中的行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};console.log("--------datas :",datas);return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel,hasScroll:true},_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:getLabel(386589,'标题栏设置'),items:this.getItems(),col:1}),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:titles,needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:true,onChange:function onChange(value){return _this4.onChangeBgImage("multiCheck",value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'}},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})))),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),style:{borderRadius:0,margin:'0 10px',padding:'0 4px'},onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,(_React$createElement={ref:'tableEdit',draggable:true,isModalEdit:isModalEdit,dataSource:datas//title={titles}
},(0,_defineProperty3.default)(_React$createElement,'ref',function ref(el){_this4.table=el;}),(0,_defineProperty3.default)(_React$createElement,'rowSelection',rowSelection),(0,_defineProperty3.default)(_React$createElement,'selectedData',selectedDatas),(0,_defineProperty3.default)(_React$createElement,'selectedRowKeys',selectedRowKeys),(0,_defineProperty3.default)(_React$createElement,'columns',this.getColumns()),_React$createElement))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this5=this;var _state6=this.state,datas=_state6.datas,showTitle=_state6.showTitle,fontSize=_state6.fontSize;var isPass=true;var datasNew=datas.map(function(item,index){if(showTitle=='1'&&item.title==''){_this5['weaError_'+index]&&_this5['weaError_'+index].showError();isPass=false;return;}return(0,_extends3.default)({},item,{orderNum:index,key:index});});isPass&&this.props.onOk(datasNew,showTitle,fontSize);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_picture_detail_new;}(_react2.default.Component);exports.default=Content_picture_detail_new;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(312);
module.exports = __webpack_require__(18).Object.keys;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(45);
var $keys = __webpack_require__(43);

__webpack_require__(118)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 图表元素
var Content_reportForm=function(_React$Component){(0,_inherits3.default)(Content_reportForm,_React$Component);function Content_reportForm(){(0,_classCallCheck3.default)(this,Content_reportForm);return(0,_possibleConstructorReturn3.default)(this,(Content_reportForm.__proto__||(0,_getPrototypeOf2.default)(Content_reportForm)).apply(this,arguments));}(0,_createClass3.default)(Content_reportForm,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_reportForm;}(_react2.default.Component);exports.default=Content_reportForm;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ENewsMould=__webpack_require__(77);var _ENewsMould2=_interopRequireDefault(_ENewsMould);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 搜索元素
var Content_searchengine=function(_React$Component){(0,_inherits3.default)(Content_searchengine,_React$Component);function Content_searchengine(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_searchengine);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_searchengine.__proto__||(0,_getPrototypeOf2.default)(Content_searchengine)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNewsFrom:_this.props.eNewsFrom},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_searchengine,[{key:'render',value:function render(){var _this2=this;var eNewsFrom=this.state.eNewsFrom;var ENewsFrom=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENewsFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22919,'新闻来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:'docnews',isMultCheckbox:false,isSingle:true,replaceDatas:eNewsFrom,dataParams:{publishtype:0},completeParams:{publishtype:0},onChange:function onChange(ids,names,datas){return _this2.setState({eNewsFromIds:ids,eNewsFrom:datas});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ENewsFrom,_react2.default.createElement(_ENewsMould2.default,{ref:'eNewsMould',options:this.props.eNewsMould.options,value:this.props.eNewsMould.selected})));}},{key:'getSaveValues',value:function getSaveValues(){var eNewsFrom=this.state.eNewsFrom;return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentNewsFrom:eNewsFrom&&eNewsFrom.length?eNewsFrom[0].id:'',eContentNewsMould:this.refs['eNewsMould'].getSaveValues()};}}]);return Content_searchengine;}(_react2.default.Component);exports.default=Content_searchengine;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_Slide_detail=__webpack_require__(316);var _Content_Slide_detail2=_interopRequireDefault(_Content_Slide_detail);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 幻灯片
var Content_Slide=function(_React$Component){(0,_inherits3.default)(Content_Slide,_React$Component);function Content_Slide(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_Slide);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_Slide.__proto__||(0,_getPrototypeOf2.default)(Content_Slide)).call.apply(_ref,[this].concat(args))),_this),_this.state={eAutoScrollTime:_this.props.eAutoScrollTime||1000,eChangeEffect:_this.props.eChangeEffect.selected,eSmoothMoveTime:_this.props.eSmoothMoveTime||1000,eNavDisplayPosition:_this.props.eNavDisplayPosition,eSlideDetail:_this.props.eSlideDetail,eDisplayMode:_this.props.eDisplayMode.selected,detailModalVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_Slide,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eAutoScrollTime=_state.eAutoScrollTime,eChangeEffect=_state.eChangeEffect,eSmoothMoveTime=_state.eSmoothMoveTime,eNavDisplayPosition=_state.eNavDisplayPosition,eSlideDetail=_state.eSlideDetail,detailModalVisible=_state.detailModalVisible,eDisplayMode=_state.eDisplayMode;var EAutoScrollTime=_react2.default.createElement('div',null);var EChangeEffect=_react2.default.createElement('div',null);var ESmoothMoveTime=_react2.default.createElement('div',null);var ENavDisplayPosition=_react2.default.createElement('div',null);var EModal2Detail=_react2.default.createElement('div',null);var EDisplayMode=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EAutoScrollTime=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(26286,'自动滚动时间'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eAutoScrollTime,style:{width:'50px',marginRight:'10px'},onChange:function onChange(value){return _this2.setState({eAutoScrollTime:value});}}),_react2.default.createElement('span',null,getLabel(26287,'毫秒')));EChangeEffect=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(26288,'切换效果'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eChangeEffect.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eChangeEffect,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eChangeEffect:value});}}));ESmoothMoveTime=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(26289,'平滑移动时间'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eSmoothMoveTime,style:{width:'50px',marginRight:'10px'},onChange:function onChange(value){return _this2.setState({eSmoothMoveTime:value});}}),_react2.default.createElement('span',null,getLabel(26287,'毫秒')));var modal2Detail=_react2.default.createElement('div',null);if(detailModalVisible){var detailProps={eSlideDetail:eSlideDetail,onOk:function onOk(value){_this2.setState({eSlideDetail:value,detailModalVisible:false});},onCancel:function onCancel(){_this2.setState({detailModalVisible:false});}};modal2Detail=_react2.default.createElement(_Content_Slide_detail2.default,detailProps);}EModal2Detail=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19342,'详细设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Button,{style:{marginTop:5},type:'primary',size:'small',onClick:function onClick(){return _this2.setState({detailModalVisible:true});}},getLabel(19342,'详细设置')),modal2Detail);ENavDisplayPosition=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386597,'导航显示位置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{value:eNavDisplayPosition,onChange:function onChange(e){return _this2.setState({eNavDisplayPosition:e.target.value});}},_react2.default.createElement(_antd.Radio,{value:'1'},getLabel(22986,'左')),_react2.default.createElement(_antd.Radio,{value:'2'},getLabel(22988,'右')),_react2.default.createElement(_antd.Radio,{value:'3'},getLabel(23010,'下'))));EDisplayMode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(81763,'图片显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eDisplayMode.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eDisplayMode,style:{width:'200px'},detailtype:3,onChange:function onChange(value){_this2.setState({eDisplayMode:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EAutoScrollTime,EChangeEffect,ESmoothMoveTime,ENavDisplayPosition,EDisplayMode,EModal2Detail));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentAutoScrollTime:this.state.eAutoScrollTime,eContentChangeEffect:this.state.eChangeEffect,eContentSmoothMoveTime:this.state.eSmoothMoveTime,eContentNavDisplayPosition:this.state.eNavDisplayPosition,eContentSlideDetail:this.state.eSlideDetail,eContenteDisplayMode:this.state.eDisplayMode};}}]);return Content_Slide;}(_react2.default.Component);exports.default=Content_Slide;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 幻灯片详细设置
var Content_Slide_detail=function(_React$Component){(0,_inherits3.default)(Content_Slide_detail,_React$Component);function Content_Slide_detail(props){(0,_classCallCheck3.default)(this,Content_Slide_detail);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_Slide_detail.__proto__||(0,_getPrototypeOf2.default)(Content_Slide_detail)).call(this,props));_this.state={eSlideDetail:_this.props.eSlideDetail};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(Content_Slide_detail,[{key:'render',value:function render(){var _this2=this;var columns=[{title:getLabel(26283,'主图片'),dataIndex:'mainImage',render:function render(text,record){return _react2.default.createElement(_WeaMaterialLib2.default,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'mainImage')});}},{title:getLabel(26284,'导航样式背景图'),dataIndex:'bgImage',render:function render(text,record){return _react2.default.createElement(_WeaMaterialLib2.default,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'bgImage')});}},{title:getLabel(386598,'导航样式前景图'),dataIndex:'fgImage',render:function render(text,record){return _react2.default.createElement(_WeaMaterialLib2.default,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'fgImage')});}},{title:getLabel(24986,'标题'),dataIndex:'title',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'title')});}},{title:getLabel(433,'描述'),dataIndex:'desc',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'desc')});}},{title:getLabel(22932,'图片链接'),dataIndex:'link',render:function render(text,record){return _react2.default.createElement(_ecCom.WeaInput,{value:text,onChange:_this2.onDetailChange.bind(_this2,record.key,'link')});}}];return _react2.default.createElement(_ecCom.WeaDialog,{className:'portal-esetting-dialog',visible:true,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:1037,height:492},zIndex:1000,hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaTable,{columns:columns,dataSource:this.state.eSlideDetail,pagination:false}),_react2.default.createElement('div',{style:{margin:'25px'}},_react2.default.createElement('div',null,_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(125776,"说明:"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(390855,"1、建议主图片大小为2000像素*160像素"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(390856,"2、建议导航样式背景图大小为150像素*40像素"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(390857,"3、建议导航样式前景图大小为165像素*40像素"))),_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'portal_slide_detail'},getLabel(502246,"4、设置了主图片，建议设置导航图"))))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onDetailChange',value:function onDetailChange(key,type,value){var eSlideDetail=this.state.eSlideDetail;eSlideDetail[key][type]=value;this.setState({eSlideDetail:eSlideDetail});}},{key:'onOk',value:function onOk(){this.props.onOk(this.state.eSlideDetail);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_Slide_detail;}(_react2.default.Component);exports.default=Content_Slide_detail;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_video_detailedSetting=__webpack_require__(318);var _Content_video_detailedSetting2=_interopRequireDefault(_Content_video_detailedSetting);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 视频元素
var Content_video=function(_React$Component){(0,_inherits3.default)(Content_video,_React$Component);function Content_video(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_video);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_video.__proto__||(0,_getPrototypeOf2.default)(Content_video)).call.apply(_ref,[this].concat(args))),_this),_this.state={eVideoShow:_this.props.eVideoShow,eVideoForm:_this.props.eVideoForm,eShowType:_this.props.eVideoShowType||'1',eAutoHeight:_this.props.eAutoHeight||false,eShowMulitline:_this.props.showMulitline||false,eShowNums:_this.props.showNums||1,eDetailedSettingible:false,showTitle:_this.props.showTitle||'0',fontSize:_this.props.fontSize||'16',datas:_this.props.datas},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_video,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eVideoShow=_state.eVideoShow,eVideoForm=_state.eVideoForm,eShowType=_state.eShowType,eAutoHeight=_state.eAutoHeight,eDetailedSettingible=_state.eDetailedSettingible,datas=_state.datas,showTitle=_state.showTitle,fontSize=_state.fontSize,eShowMulitline=_state.eShowMulitline,eShowNums=_state.eShowNums;var VideoDetailedSetting=_react2.default.createElement('div',null);var eDSProps={};if(eDetailedSettingible){var videoDatas=datas.map(function(item,index){item.key=index;return item;});eDSProps={datas:videoDatas,showTitle:showTitle,fontSize:fontSize,onOk:function onOk(datas,showTitle,fontSize){_this2.setState({datas:datas,showTitle:showTitle,fontSize:fontSize,eDetailedSettingible:false});},onCancel:function onCancel(){_this2.setState({eDetailedSettingible:false});}};VideoDetailedSetting=_react2.default.createElement(_Content_video_detailedSetting2.default,eDSProps);}var options=[{key:"1",selected:true,showname:"单个显示"},{key:"2",selected:false,showname:"多个显示"}];var EShowSetting=_react2.default.createElement('div',null);var EVideoFrom=_react2.default.createElement('div',null);var EShowType=_react2.default.createElement('div',null);var EShowFullScreen=_react2.default.createElement('div',null);var EAutoPlay=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:"视频高度",labelCol:{span:6},wrapperCol:{span:16}},!eAutoHeight&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eVideoShow.height,style:{width:'50px'},onChange:function onChange(value){return _this2.setState({eVideoShow:(0,_extends3.default)({},eVideoShow,{height:value})});}}),_react2.default.createElement('span',{style:{display:'inline-block',marginBottom:'6px',marginLeft:'9px'}},'px')),_react2.default.createElement(_antd.Checkbox,{checked:eAutoHeight,style:{marginLeft:!eAutoHeight?'10px':0},onChange:function onChange(e){return _this2.setState({eAutoHeight:e.target.checked});}},'自适应高度'));EShowType=_react2.default.createElement(_ecCom.WeaFormItem,{label:"显示方式",labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{style:{width:'200px'},options:options,detailtype:3,value:eShowType,onChange:function onChange(value){if(value=='1'){_this2.setState({eShowType:value,eShowMulitline:false,eShowNums:1});}else{_this2.setState({eShowType:value});}}}),eShowType=='2'&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_antd.Checkbox,{checked:eShowMulitline,style:{marginLeft:!eAutoHeight?'10px':0,display:'inline-block'},onChange:function onChange(e){return _this2.setState({eShowMulitline:e.target.checked});}},'多行显示'),_react2.default.createElement('span',{style:{display:'inline-block'}},'每行显示个数'),_react2.default.createElement(_ecCom.WeaInput,{value:eShowNums,onChange:function onChange(value){return _this2.setState({eShowNums:value});},style:{display:'inline-block',width:'100px',position:'absolute',top:'-3px'}})));EShowFullScreen=_react2.default.createElement(_ecCom.WeaFormItem,{label:"允许全屏显示",labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{display:'switch',value:eVideoShow.showFullScreen,onChange:function onChange(v){_this2.setState({eVideoShow:(0,_extends3.default)({},eVideoShow,{showFullScreen:v==1})});}}));EAutoPlay=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22840,'自动播放'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{display:'switch',value:eVideoShow.autoPlay,onChange:function onChange(v){_this2.setState({eVideoShow:(0,_extends3.default)({},eVideoShow,{autoPlay:v==1})});}}));EVideoFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22841,'视频来源'),labelCol:{span:6},wrapperCol:{span:16}},VideoDetailedSetting,_react2.default.createElement('div',{style:{marginTop:7},onClick:function onClick(){return _this2.setState({eDetailedSettingible:true});}},_react2.default.createElement('a',{href:'javascript:void(0);'},'设置')));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowSetting,EShowType,EShowFullScreen,eShowType=='1'&&EAutoPlay,EVideoFrom));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentVideoShow_height:this.state.eVideoShow.height,eContentShowType:this.state.eShowType,eContentAutoHeight:this.state.eAutoHeight,eContentShowMulitline:this.state.eShowMulitline,eContentShowNums:this.state.eShowNums,eContentVideoShow_showFullScreen:this.state.eVideoShow.showFullScreen,eContentVideoShow_autoPlay:this.state.eVideoShow.autoPlay,eContentDatas:this.state.datas,eContentShowTitle:this.state.showTitle,eContentFontSize:this.state.fontSize};}}]);return Content_video;}(_react2.default.Component);exports.default=Content_video;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _keys=__webpack_require__(105);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaPortalPublic=__webpack_require__(65);var _Content_video_prew=__webpack_require__(319);var _Content_video_prew2=_interopRequireDefault(_Content_video_prew);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 多图元素详细设置
var Content_video_detailedSetting=function(_React$Component){(0,_inherits3.default)(Content_video_detailedSetting,_React$Component);function Content_video_detailedSetting(props){(0,_classCallCheck3.default)(this,Content_video_detailedSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_video_detailedSetting.__proto__||(0,_getPrototypeOf2.default)(Content_video_detailedSetting)).call(this,props));_this.state={visible:true,showTitle:props.showTitle,fontSize:props.fontSize,titles:_react2.default.createElement('div',{style:{display:'-webkit-box',position:'absolute'}},getLabel(508352,'视频设置'),_react2.default.createElement('span',{style:{whiteSpace:'nowrap',fontSize:'12px',color:'rgb(153, 153, 153)',display:'table',position:'absolute',top:'0',left:'70px'}},getLabel(501054,'视频元素目前只支持Ogg、MPEG4、WebM三种格式'))),datas:props.datas,selectedDatas:{},selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.getUuid=_this.getUuid.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeBgImage=_this.onChangeBgImage.bind(_this);_this.getColumns=_this.getColumns.bind(_this);_this.getItems=_this.getItems.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.deleteTabs=_this.deleteTabs.bind(_this);_this.onAddTabs=_this.onAddTabs.bind(_this);return _this;}(0,_createClass3.default)(Content_video_detailedSetting,[{key:'onRowSelect',value:function onRowSelect(sRowKeys,rows,dataIndex,selectedDatas){var newState={};newState.selectedRowKeys=sRowKeys;if(selectedDatas){newState.selectedDatas=selectedDatas;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:'getUuid',value:function getUuid(){var s=[];var hexDigits="0123456789abcdef";for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]="4";// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the clock_seq_hi_and_reserved to 01
s[8]=s[13]=s[18]=s[23]="-";var uuid=s.join("");return uuid;}},{key:'onChangeBgImage',value:function onChangeBgImage(index,value){if(value){var _state$datas=this.state.datas,datas=_state$datas===undefined?{}:_state$datas;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var _value=value.split(",");if("multiCheck"==index){for(var i=0;i<_value.length;i++){_datas.push({key:this.getUuid(),videoUrl:_value[i],title:'',addType:'1'});}}else{_datas[index].videoUrl=value;}var __datas=_datas.map(function(item,index){return(0,_extends3.default)({},item,{key:index});});this.setState({datas:__datas});}}},{key:'getColumns',value:function getColumns(){var _this2=this;var _state=this.state,_state$datas2=_state.datas,datas=_state$datas2===undefined?{}:_state$datas2,fontSize=_state.fontSize,showTitle=_state.showTitle;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var options=[{key:"1",selected:true,showname:"选择文件"},{key:"2",showname:"URL路径"}];var columns=[{title:'视频来源',display:'true',width:'33%',className:'wea-table-edit-upload',render:function render(text,record,index){return _react2.default.createElement('div',{className:'e9login-bg-images-btns-materiallib'},_react2.default.createElement(_ecCom.WeaSelect,{style:{width:'60%',paddingBottom:'30px'},options:options,value:record.addType,onChange:function onChange(value){_datas[record.key].addType=value;_this2.setState({datas:_datas});}}),record.addType=='1'?_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{value:record.videoUrl,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);}}):_react2.default.createElement(_ecCom.WeaInput,{value:record.videoUrl,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);}}));}},{title:'视频预览',display:'true',key:'img',width:'33%',className:'wea-table-edit-prew',render:function render(text,record,index){return _react2.default.createElement(_Content_video_prew2.default,{title:record.title,imgSrc:record.videoUrl,fontSize:fontSize,showTitle:showTitle});}},{title:'视频标题',display:'true',width:'33%',key:'title',className:'wea-table-edit-title',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError//tipPosition='bottom'
,{ref:function ref(el){_this2['weaError_'+index]=el;},error:'\u6570\u636E\u4E3A\u7A7A'},_react2.default.createElement(_ecCom.WeaInput,{value:record.title||'',viewAttr:showTitle=='1'?3:2,onChange:function onChange(value){_datas[record.key].title=value;_this2.setState({datas:_datas});}}));}}];return columns;}},{key:'getItems',value:function getItems(){var _this3=this;var _state2=this.state,showTitle=_state2.showTitle,fontSize=_state2.fontSize;var items=[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386587,'显示标题栏'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showTitle,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){return _this3.setState({showTitle:value});}}))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386588,'标题文字大小'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:fontSize,onChange:function onChange(value){return _this3.setState({fontSize:value});},style:{width:'82px',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'10px'}},'px')))}];return items;}},{key:'onDeleteTabs',value:function onDeleteTabs(){var _state3=this.state,selectedRowKeys=_state3.selectedRowKeys,datas=_state3.datas;for(var i=0;i<selectedRowKeys.length;i++){this.deleteTabs(selectedRowKeys[i]);}this.setState({selectedRowKeys:[]});}},{key:'onAddTabs',value:function onAddTabs(){var _state$datas3=this.state.datas,datas=_state$datas3===undefined?{}:_state$datas3;var _datas=[].concat((0,_toConsumableArray3.default)(datas));_datas.push({key:_datas.length,videoUrl:'',title:'',addType:'2'});this.setState({datas:_datas});}},{key:'deleteTabs',value:function deleteTabs(dataId){var _state4=this.state,datas=_state4.datas,selectedRowKeys=_state4.selectedRowKeys;for(var i=0;i<datas.length;i++){if(datas[i].key==dataId){datas.splice(i,1);break;}}this.setState({datas:datas,selectedRowKeys:[]});}},{key:'render',value:function render(){var _this4=this,_React$createElement;var _state5=this.state,visible=_state5.visible,eFieldNewDataSource=_state5.eFieldNewDataSource,eFieldNewUsedKeys=_state5.eFieldNewUsedKeys,searchName=_state5.searchName,title=_state5.title,items=_state5.items,isModalEdit=_state5.isModalEdit,datas=_state5.datas,titles=_state5.titles,selectedDatas=_state5.selectedDatas,selectedRowKeys=_state5.selectedRowKeys;// 记录选中的行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};console.log("-------datas :",datas);return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel,hasScroll:true},_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:getLabel(386589,'标题栏设置'),items:this.getItems(),col:1}),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:titles,needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'},title:getLabel(125333,'选择文件')},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:true,onChange:function onChange(value){return _this4.onChangeBgImage("multiCheck",value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'}},_react2.default.createElement(_antd.Icon,{type:'search',style:{color:'#fff'}})))),_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,margin:'0 10px',padding:'0 4px'},onClick:this.onAddTabs,title:getLabel(384113,'添加')},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),title:getLabel(506969,'删除'),style:{borderRadius:0,padding:'0 4px'},onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,(_React$createElement={ref:'tableEdit',draggable:true,isModalEdit:isModalEdit,dataSource:datas//title={titles}
},(0,_defineProperty3.default)(_React$createElement,'ref',function ref(el){_this4.table=el;}),(0,_defineProperty3.default)(_React$createElement,'rowSelection',rowSelection),(0,_defineProperty3.default)(_React$createElement,'selectedData',selectedDatas),(0,_defineProperty3.default)(_React$createElement,'selectedRowKeys',selectedRowKeys),(0,_defineProperty3.default)(_React$createElement,'columns',this.getColumns()),_React$createElement))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this5=this;var _state6=this.state,datas=_state6.datas,showTitle=_state6.showTitle,fontSize=_state6.fontSize;var isPass=true;if(showTitle=='1'){datas.map(function(item,index){if(item.title==''){_this5['weaError_'+index]&&_this5['weaError_'+index].showError();isPass=false;return;}});}isPass&&this.props.onOk(datas,showTitle,fontSize);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_video_detailedSetting;}(_react2.default.Component);exports.default=Content_video_detailedSetting;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content_video_prew=function(_React$Component){(0,_inherits3.default)(Content_video_prew,_React$Component);function Content_video_prew(){(0,_classCallCheck3.default)(this,Content_video_prew);return(0,_possibleConstructorReturn3.default)(this,(Content_video_prew.__proto__||(0,_getPrototypeOf2.default)(Content_video_prew)).apply(this,arguments));}(0,_createClass3.default)(Content_video_prew,[{key:'render',value:function render(){var _props=this.props,title=_props.title,imgSrc=_props.imgSrc,fontSize=_props.fontSize,showTitle=_props.showTitle;return _react2.default.createElement('div',{style:{padding:'0px',position:'relative',width:'230px'}},_react2.default.createElement('div',{style:{position:'relative',zIndex:1}},_react2.default.createElement('video',{src:imgSrc,ref:this.vidRef,style:{width:'230px',height:'150px',verticalAlign:'middle'},height:'150px',loop:'loop',controlsList:'nodownload',controls:'controls'})),_react2.default.createElement('div',{style:{zIndex:3,bottom:0,color:'black',height:'35px',lineHeight:'35px',textAlign:'center',width:'100%',fontSize:fontSize+'px',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},showTitle=='1'?title:''));}}]);return Content_video_prew;}(_react2.default.Component);exports.default=Content_video_prew;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=_antd.Radio.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 天气元素
var Content_weather=function(_React$Component){(0,_inherits3.default)(Content_weather,_React$Component);function Content_weather(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_weather);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_weather.__proto__||(0,_getPrototypeOf2.default)(Content_weather)).call.apply(_ref,[this].concat(args))),_this),_this.state={eCityName:_this.props.eCityName,eAutoScroll:_this.props.eAutoScroll.selected,eShowWidth:_this.props.eShowWidth},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_weather,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eCityName=_state.eCityName,eAutoScroll=_state.eAutoScroll,eShowWidth=_state.eShowWidth;var ECityName=_react2.default.createElement('div',null);var EAutoScroll=_react2.default.createElement('div',null);var EShowWidth=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ECityName=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15246,'城市名称'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eCityName,style:{width:'50%'},onChange:function onChange(value){return _this2.setState({eCityName:value});}}),_react2.default.createElement('div',{style:{padding:'7px 7px',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaHelpfulTip,{width:196//如果要自定义宽度，在这里设置
,title:getLabel(386599,'请确认服务器可以访问www.weather.com.cn'),isCenter:true})),_react2.default.createElement('div',null,getLabel(25899,'多城市名称请用半角逗号分隔（上海,北京）')));EAutoScroll=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24548,'自动滚动'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(RadioGroup,{size:'default',value:eAutoScroll,onChange:function onChange(e){return _this2.setState({eAutoScroll:e.target.value});}},this.props.eAutoScroll.options.map(function(item,index){return _react2.default.createElement(_antd.Radio,{key:index,value:item.value},item.label);})));EShowWidth=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(24561,'显示宽度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eShowWidth,style:{width:'50%'},onChange:function onChange(value){return _this2.setState({eShowWidth:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ECityName,EAutoScroll,EShowWidth));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentCityName:this.state.eCityName,eContentAutoScroll:this.state.eAutoScroll,eContentShowWidth:this.state.eShowWidth};}}]);return Content_weather;}(_react2.default.Component);exports.default=Content_weather;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 便签元素
var Content_scratchpad=function(_React$Component){(0,_inherits3.default)(Content_scratchpad,_React$Component);function Content_scratchpad(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_scratchpad);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_scratchpad.__proto__||(0,_getPrototypeOf2.default)(Content_scratchpad)).call.apply(_ref,[this].concat(args))),_this),_this.state={eNoteSetting:_this.props.eNoteSetting},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_scratchpad,[{key:'render',value:function render(){var _this2=this;var eNoteSetting=this.state.eNoteSetting;var ENoteSetting=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENoteSetting=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33549,'显示设置'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386530,'高度：')),_react2.default.createElement(_ecCom.WeaInput,{value:eNoteSetting.height,style:{width:'50px'},onChange:function onChange(value){return _this2.setState({eNoteSetting:(0,_extends3.default)({},eNoteSetting,{height:value})});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',ENoteSetting));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentNoteHeight:this.state.eNoteSetting.height};}}]);return Content_scratchpad;}(_react2.default.Component);exports.default=Content_scratchpad;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _SynergySetting4Designer=__webpack_require__(102);var _SynergySetting4Designer2=_interopRequireDefault(_SynergySetting4Designer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 日历日程
var Content_MyCalendar=function(_React$Component){(0,_inherits3.default)(Content_MyCalendar,_React$Component);function Content_MyCalendar(){(0,_classCallCheck3.default)(this,Content_MyCalendar);return(0,_possibleConstructorReturn3.default)(this,(Content_MyCalendar.__proto__||(0,_getPrototypeOf2.default)(Content_MyCalendar)).apply(this,arguments));}(0,_createClass3.default)(Content_MyCalendar,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams;var stype=synergyParams.stype,pagetype=synergyParams.pagetype,ispagedeal=synergyParams.ispagedeal;var customComponent=_react2.default.createElement('div',null);if(eShareLevel=='2'){customComponent=_react2.default.createElement('div',null,hpid<0&&stype=='wf'&&pagetype=='operat'&&ispagedeal=='1'?_react2.default.createElement('span',{className:'synergy-setting-btn',onClick:function onClick(){return _this2.ss4d.onShow((0,_extends3.default)({},synergyParams,{hpid:hpid,ebaseid:ebaseid,eid:eid,isGlobal:true}));}},getLabel(17632,'参数设置')):'');}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true,customComponent:customComponent},_react2.default.createElement(_SynergySetting4Designer2.default,{ref:function ref(ss4d){return _this2.ss4d=ss4d;}}),_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle};}}]);return Content_MyCalendar;}(_react2.default.Component);exports.default=Content_MyCalendar;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends4=__webpack_require__(8);var _extends5=_interopRequireDefault(_extends4);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 个人数据
var Content_DataCenter=function(_React$Component){(0,_inherits3.default)(Content_DataCenter,_React$Component);function Content_DataCenter(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_DataCenter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_DataCenter.__proto__||(0,_getPrototypeOf2.default)(Content_DataCenter)).call.apply(_ref,[this].concat(args))),_this),_this.state={eSyncContent:_this.props.eSyncContent,eSyncContentAll:false,eContentShowType:_this.props.eContentShowType||'0',eShowContent4Person:_this.props.eShowContent4Person},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_DataCenter,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eSyncContent=_state.eSyncContent,eSyncContentAll=_state.eSyncContentAll,eShowContent4Person=_state.eShowContent4Person;var ESyncContent=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'&&!!eSyncContent){ESyncContent=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(32328,'同步内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Switch,{size:'small',checked:eSyncContentAll,onChange:function onChange(checked){return _this2.setState({eSyncContentAll:checked});}}));}var eShowContent4PersonList=[];var _loop=function _loop(key){if(eShowContent4Person.hasOwnProperty(key)){eShowContent4PersonList.push(_react2.default.createElement('li',{style:{height:'35px'}},_react2.default.createElement('div',{style:{width:120,display:"inline-block"}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eShowContent4Person[key].checked,onChange:function onChange(e){return _this2.setState({eShowContent4Person:(0,_extends5.default)({},eShowContent4Person,(0,_defineProperty3.default)({},key,(0,_extends5.default)({},eShowContent4Person[key],{checked:e.target.checked})))});}},eShowContent4Person[key].label)),_react2.default.createElement(_ecCom.WeaColorPicker,{value:eShowContent4Person[key].color,onChange:function onChange(value){return _this2.setState({eShowContent4Person:(0,_extends5.default)({},eShowContent4Person,(0,_defineProperty3.default)({},key,(0,_extends5.default)({},eShowContent4Person[key],{color:value})))});}})));}};for(var key in eShowContent4Person){_loop(key);}var EShowContent4Person=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{ref:'eShowContent4Person'},eShowContent4PersonList));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),_react2.default.createElement(_ecCom.WeaFormItem,{label:'展现方式',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:"0",showname:"图标"},{key:"1",showname:"内容文字"}],value:this.state.eContentShowType,detailtype:3,onChange:function onChange(value){_this2.setState({eContentShowType:value});}})),ESyncContent,EShowContent4Person));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentSync:this.state.eSyncContent,eContentShowType:this.state.eContentShowType,eContentSyncAll:this.state.eSyncContentAll,eContentShow:this.state.eShowContent4Person};}}]);return Content_DataCenter;}(_react2.default.Component);exports.default=Content_DataCenter;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 计划报告元素
var Content_plan=function(_React$Component){(0,_inherits3.default)(Content_plan,_React$Component);function Content_plan(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_plan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_plan.__proto__||(0,_getPrototypeOf2.default)(Content_plan)).call.apply(_ref,[this].concat(args))),_this),_this.state={eClassify:_this.props.eClassify,ePlanStartDate:_this.props.ePlanStartDate,ePlanEndDate:_this.props.ePlanEndDate,ePlanDays:_this.props.ePlanDays,eWeekly:_this.props.eWeekly,eMonthly:_this.props.eMonthly},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_plan,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eClassify=_state.eClassify,ePlanStartDate=_state.ePlanStartDate,ePlanEndDate=_state.ePlanEndDate,ePlanDays=_state.ePlanDays,eWeekly=_state.eWeekly,eMonthly=_state.eMonthly;var EClassify=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(455,'分类'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eClassify,onChange:function onChange(e){return _this2.setState({eClassify:e.target.checked});}}));var EPlanStartDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22168,'计划开始日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePlanStartDate,onChange:function onChange(e){return _this2.setState({ePlanStartDate:e.target.checked});}}));var EPlanEndDate=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22170,'计划结束日期'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePlanEndDate,onChange:function onChange(e){return _this2.setState({ePlanEndDate:e.target.checked});}}));var EPlanDays=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33625,'计划天数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:ePlanDays,onChange:function onChange(e){return _this2.setState({ePlanDays:e.target.checked});}}));var EWeekly=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20619,'周报'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eWeekly,onChange:function onChange(e){return _this2.setState({eWeekly:e.target.checked});}}));var EMonthly=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20617,'月报'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eMonthly,onChange:function onChange(e){return _this2.setState({eMonthly:e.target.checked});}}));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EClassify,EPlanStartDate,EPlanEndDate,EPlanDays,EWeekly,EMonthly));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentClassify:this.state.eClassify,eContentPlanStartDate:this.state.ePlanStartDate,eContentPlanEndDate:this.state.ePlanEndDate,eContentPlanDays:this.state.ePlanDays,eContentWeekly:this.state.eWeekly,eContentMonthly:this.state.eMonthly};}}]);return Content_plan;}(_react2.default.Component);exports.default=Content_plan;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 多岗位办理事项
var Content_jobsinfo=function(_React$Component){(0,_inherits3.default)(Content_jobsinfo,_React$Component);function Content_jobsinfo(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_jobsinfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_jobsinfo.__proto__||(0,_getPrototypeOf2.default)(Content_jobsinfo)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowClassify:_this.props.eShowClassify.checked},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_jobsinfo,[{key:'render',value:function render(){var _this2=this;var eShowClassify=this.state.eShowClassify;var EShowClassify=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowClassify=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386590,'显示类别'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(CheckboxGroup,{size:'default',options:this.props.eShowClassify.options,value:eShowClassify,onChange:function onChange(checkedValue){return _this2.setState({eShowClassify:checkedValue});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EShowClassify));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentShowClassify:this.state.eShowClassify};}}]);return Content_jobsinfo;}(_react2.default.Component);exports.default=Content_jobsinfo;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(8);var _extends4=_interopRequireDefault(_extends3);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 集成登录
var Content_outterSys=function(_React$Component){(0,_inherits3.default)(Content_outterSys,_React$Component);function Content_outterSys(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_outterSys);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_outterSys.__proto__||(0,_getPrototypeOf2.default)(Content_outterSys)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowField:_this.props.eShowField,eShowMode:_this.props.eShowMode.selected,eShowLayout:_this.props.eShowLayout.selected,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_outterSys,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowField=_state.eShowField,eShowMode=_state.eShowMode,eShowLayout=_state.eShowLayout,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EShowField=_react2.default.createElement('div',null);var EShowMode=_react2.default.createElement('div',null);var EShowLayout=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){var eShowFieldList=[];var _loop=function _loop(key){if(eShowField.hasOwnProperty(key)){eShowFieldList.push(_react2.default.createElement('li',null,_react2.default.createElement(_antd.Checkbox,{checked:eShowField[key].checked,onChange:function onChange(e){_this2.setState({eShowField:(0,_extends4.default)({},eShowField,(0,_defineProperty3.default)({},key,(0,_extends4.default)({},eShowField[key],{checked:e.target.checked})))});}},eShowField[key].label)));}};for(var key in eShowField){_loop(key);}EShowField=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('ul',{style:{lineHeight:'23px'}},eShowFieldList));EShowMode=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21653,'显示方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eShowMode.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eShowMode,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eShowMode:value});}}));EShowLayout=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(82134,'显示布局'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eShowLayout.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eShowLayout,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eShowLayout:value});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'30px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,EShowMode,EShowLayout));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentShowMode:this.state.eShowMode,eContentShowLayout:this.state.eShowLayout};}}]);return Content_outterSys;}(_react2.default.Component);exports.default=Content_outterSys;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 通讯录
var Content_contacts=function(_React$Component){(0,_inherits3.default)(Content_contacts,_React$Component);function Content_contacts(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_contacts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_contacts.__proto__||(0,_getPrototypeOf2.default)(Content_contacts)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowSubordinates:_this.props.eShowSubordinates,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_contacts,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowSubordinates=_state.eShowSubordinates,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EShowSubordinates=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowSubordinates=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(83783,'显示下级下属'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Checkbox,{size:'default',checked:eShowSubordinates,onChange:function onChange(e){return _this2.setState({eShowSubordinates:e.target.checked});}}));}var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EFieldNew,EShowSubordinates));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentShowSubordinates:this.state.eShowSubordinates,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue}};}}]);return Content_contacts;}(_react2.default.Component);exports.default=Content_contacts;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 新建流程
var Content_addwf=function(_React$Component){(0,_inherits3.default)(Content_addwf,_React$Component);function Content_addwf(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_addwf);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_addwf.__proto__||(0,_getPrototypeOf2.default)(Content_addwf)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowLayout4AddWf:_this.props.eShowLayout4AddWf.selected},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_addwf,[{key:'render',value:function render(){var _this2=this;var eShowLayout4AddWf=this.state.eShowLayout4AddWf;var EShowLayout4AddWf=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){EShowLayout4AddWf=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(82134,'显示布局'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eShowLayout4AddWf.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eShowLayout4AddWf,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eShowLayout4AddWf:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EShowLayout4AddWf));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eContentShowLayout:this.state.eShowLayout4AddWf};}}]);return Content_addwf;}(_react2.default.Component);exports.default=Content_addwf;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _Content_imgSlide_detailedSetting=__webpack_require__(330);var _Content_imgSlide_detailedSetting2=_interopRequireDefault(_Content_imgSlide_detailedSetting);var _antd=__webpack_require__(7);__webpack_require__(123);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Option=_antd.Select.Option;// 多图元素
var Content_imgSlide=function(_React$Component){(0,_inherits3.default)(Content_imgSlide,_React$Component);function Content_imgSlide(props){(0,_classCallCheck3.default)(this,Content_imgSlide);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_imgSlide.__proto__||(0,_getPrototypeOf2.default)(Content_imgSlide)).call(this,props));_this.state={eAutoSwitchTime:_this.props.autoSwitchTime||4000,datas:_this.props.datas,showTitle:_this.props.showTitle,fontSize:_this.props.fontSize||'16',eDetailedSettingible:false,fillStyle:_this.props.fillStyle||'fill'};return _this;}(0,_createClass3.default)(Content_imgSlide,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eAutoSwitchTime=_state.eAutoSwitchTime,eDetailedSettingible=_state.eDetailedSettingible,datas=_state.datas,showTitle=_state.showTitle,fontSize=_state.fontSize,fillStyle=_state.fillStyle;var eDSProps={};var ImgSlideDetailedSetting=_react2.default.createElement('div',null);if(eDetailedSettingible){eDSProps={datas:datas,showTitle:showTitle,fontSize:fontSize,onOk:function onOk(datas,showTitle,fontSize){_this2.setState({datas:datas,showTitle:showTitle,fontSize:fontSize,eDetailedSettingible:false});},onCancel:function onCancel(){_this2.setState({eDetailedSettingible:false});}};ImgSlideDetailedSetting=_react2.default.createElement(_Content_imgSlide_detailedSetting2.default,eDSProps);}var EAutoSwitchTime=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386581,'自动切换时间'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:eAutoSwitchTime,onChange:function onChange(value){return _this2.setState({eAutoSwitchTime:value});},style:{width:'40%',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'12px'}},_react2.default.createElement('span',null,getLabel(26287,'毫秒')))));var EFillStyle=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{className:'portal-imgSlide-images_select',label:getLabel(386582,'填充方式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.Select,{ref:'fillStyleSelect',size:'large',onChange:function onChange(value){return _this2.setState({fillStyle:value});},style:{width:'216px',height:'46px'},value:fillStyle||'stretch'},_react2.default.createElement(Option,{value:'fill'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/fill.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(128030,'填充')))),_react2.default.createElement(Option,{value:'adapt'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/adapt.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(386583,'适应')))),_react2.default.createElement(Option,{value:'stretch'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/stretch.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(386584,'拉伸')))),_react2.default.createElement(Option,{value:'tile'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/tile.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(19852,'平铺')))),_react2.default.createElement(Option,{value:'center'},_react2.default.createElement('div',{className:'portal-imgSlide-images-style-content-type'},_react2.default.createElement('img',{className:'portal-imgSlide-images-style-content-image',src:'/spa/portal/images/center.png',alt:''}),_react2.default.createElement('span',{className:'portal-imgSlide-images-style-content-span'},getLabel(16203,'居中'))))));var EDetailedSetting=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386585,'图片详细设置'),labelCol:{span:6},wrapperCol:{span:16}},ImgSlideDetailedSetting,_react2.default.createElement('div',{style:{marginTop:7},onClick:function onClick(){return _this2.setState({eDetailedSettingible:true});}},_react2.default.createElement('a',{href:'javascript:void(0);'},getLabel(19342,'详细设置'))));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EAutoSwitchTime,EFillStyle,EDetailedSetting));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentDatas:this.state.datas,eContentShowTitle:this.state.showTitle,eContentFontSize:this.state.fontSize,eContentFillStyle:this.state.fillStyle,eContentAutoSwitchTime:this.state.eAutoSwitchTime};}}]);return Content_imgSlide;}(_react2.default.Component);exports.default=Content_imgSlide;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _keys=__webpack_require__(105);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaPortalPublic=__webpack_require__(65);var _Content_imgSlide_img=__webpack_require__(134);var _Content_imgSlide_img2=_interopRequireDefault(_Content_imgSlide_img);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 多图元素详细设置
var Content_imgSlide_detailedSetting=function(_React$Component){(0,_inherits3.default)(Content_imgSlide_detailedSetting,_React$Component);function Content_imgSlide_detailedSetting(props){(0,_classCallCheck3.default)(this,Content_imgSlide_detailedSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_imgSlide_detailedSetting.__proto__||(0,_getPrototypeOf2.default)(Content_imgSlide_detailedSetting)).call(this,props));_this.state={visible:true,showTitle:props.showTitle,fontSize:props.fontSize,titles:getLabel(507,'图片上传'),datas:props.datas,selectedDatas:{},selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.getUuid=_this.getUuid.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChangeBgImage=_this.onChangeBgImage.bind(_this);_this.getColumns=_this.getColumns.bind(_this);_this.getItems=_this.getItems.bind(_this);_this.onDeleteTabs=_this.onDeleteTabs.bind(_this);_this.deleteTabs=_this.deleteTabs.bind(_this);return _this;}(0,_createClass3.default)(Content_imgSlide_detailedSetting,[{key:'onRowSelect',value:function onRowSelect(sRowKeys,rows,dataIndex,selectedDatas){var newState={};newState.selectedRowKeys=sRowKeys;if(selectedDatas){newState.selectedDatas=selectedDatas;}(0,_keys2.default)(newState).length>0&&this.setState(newState);}},{key:'getUuid',value:function getUuid(){var s=[];var hexDigits="0123456789abcdef";for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]="4";// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the clock_seq_hi_and_reserved to 01
s[8]=s[13]=s[18]=s[23]="-";var uuid=s.join("");return uuid;}},{key:'onChangeBgImage',value:function onChangeBgImage(index,value){if(value){var datas=this.state.datas;var length=datas.length;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var _value=value.split(",");if("multiCheck"==index){for(var i=0;i<_value.length;i++){_datas.push({key:length+i,imgsrc:_value[i],title:'',imgaddress:''});}}else{_datas[index].imgsrc=value;}this.setState({datas:_datas});}}},{key:'getColumns',value:function getColumns(){var _this2=this;var _state=this.state,datas=_state.datas,fontSize=_state.fontSize,showTitle=_state.showTitle;var _datas=[].concat((0,_toConsumableArray3.default)(datas));var columns=[{title:getLabel(126949,'图片预览'),display:'true',key:'img',width:'30%',className:'wea-table-edit-prew',render:function render(text,record,index){return _react2.default.createElement(_Content_imgSlide_img2.default,{title:record.title,imgSrc:record.imgsrc,fontSize:fontSize,showTitle:showTitle});}},{title:getLabel(386586,'图片标题'),display:'true',width:'25%',key:'title',className:'wea-table-edit-title',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaError//tipPosition='bottom'
,{ref:function ref(el){_this2['weaError_'+record.key]=el;},error:'\u6570\u636E\u4E3A\u7A7A'},_react2.default.createElement(_ecCom.WeaInput,{value:record.title,viewAttr:showTitle=='1'?3:2,onChange:function onChange(value){_datas[record.key].title=value;_this2.setState({datas:_datas});}}));}},{title:getLabel(22932,'图片链接'),display:'true',width:'25%',key:'imgAddress',className:'wea-table-edit-imgAddress',render:function render(text,record,index){return _react2.default.createElement(_ecCom.WeaInput,{value:record.imgAddress,onChange:function onChange(value){_datas[record.key].imgAddress=value;_this2.setState({datas:_datas});}});}},{title:getLabel(20001,'上传图片'),display:'true',width:'15%',className:'wea-table-edit-upload',render:function render(text,record,index){return _react2.default.createElement('div',{className:'e9login-bg-images-btns-materiallib'},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:false,onChange:function onChange(value){return _this2.onChangeBgImage(record.key,value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary'},getLabel(127538,'更改图片'))));}}];return columns;}},{key:'getItems',value:function getItems(){var _this3=this;var _state2=this.state,showTitle=_state2.showTitle,fontSize=_state2.fontSize;var items=[{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386587,'显示标题栏'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showTitle,display:'switch',id:'test',style:{display:'inline'},onChange:function onChange(value){return _this3.setState({showTitle:value});}}))},{com:_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386588,'标题文字大小'),labelCol:{span:8},wrapperCol:{span:14}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:fontSize,onChange:function onChange(value){return _this3.setState({fontSize:value});},style:{width:'82px',display:'inline-block'}}),_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'10px'}},'px')))}];return items;}},{key:'onDeleteTabs',value:function onDeleteTabs(){var _state3=this.state,selectedRowKeys=_state3.selectedRowKeys,datas=_state3.datas;for(var i=0;i<selectedRowKeys.length;i++){this.deleteTabs(selectedRowKeys[i]);}this.setState({selectedRowKeys:[]});}},{key:'deleteTabs',value:function deleteTabs(dataId){var _state4=this.state,datas=_state4.datas,selectedRowKeys=_state4.selectedRowKeys;for(var i=0;i<datas.length;i++){if(datas[i].key==dataId){datas.splice(i,1);break;}}var datasNew=datas.map(function(item,idnex){return(0,_extends3.default)({},item,{key:idnex});});this.setState({datas:datasNew,selectedRowKeys:[]});}},{key:'render',value:function render(){var _this4=this,_React$createElement;var _state5=this.state,visible=_state5.visible,eFieldNewDataSource=_state5.eFieldNewDataSource,eFieldNewUsedKeys=_state5.eFieldNewUsedKeys,searchName=_state5.searchName,title=_state5.title,items=_state5.items,isModalEdit=_state5.isModalEdit,datas=_state5.datas,titles=_state5.titles,selectedDatas=_state5.selectedDatas,selectedRowKeys=_state5.selectedRowKeys;// 记录选中的行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,title:getLabel(19342,'详细设置'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:792,height:490},buttons:this.getButtons(),onCancel:this.onCancel,hasScroll:true},_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:getLabel(386589,'标题栏设置'),items:this.getItems(),col:1}),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:titles,needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_weaPortalPublic.WeaMaterialLib,{multiCheck:true,onChange:function onChange(value){return _this4.onChangeBgImage("multiCheck",value);},type:'button'},_react2.default.createElement(_antd.Button,{type:'primary',style:{borderRadius:0,padding:'0 4px'}},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})))),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),style:{borderRadius:0,margin:'0 10px',padding:'0 4px'},onClick:this.onDeleteTabs},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,(_React$createElement={ref:'tableEdit',draggable:true,isModalEdit:isModalEdit,dataSource:datas//title={titles}
},(0,_defineProperty3.default)(_React$createElement,'ref',function ref(el){_this4.table=el;}),(0,_defineProperty3.default)(_React$createElement,'rowSelection',rowSelection),(0,_defineProperty3.default)(_React$createElement,'selectedData',selectedDatas),(0,_defineProperty3.default)(_React$createElement,'selectedRowKeys',selectedRowKeys),(0,_defineProperty3.default)(_React$createElement,'columns',this.getColumns()),_React$createElement))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.onOk},getLabel(826,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onOk',value:function onOk(){var _this5=this;var _state6=this.state,datas=_state6.datas,showTitle=_state6.showTitle,fontSize=_state6.fontSize;var isPass=true;if(showTitle=='1'){datas.map(function(item,index){if(item.title==''){_this5['weaError_'+index].showError();isPass=false;return;}});}isPass&&this.props.onOk(datas,showTitle,fontSize);}},{key:'onCancel',value:function onCancel(){this.props.onCancel();}}]);return Content_imgSlide_detailedSetting;}(_react2.default.Component);exports.default=Content_imgSlide_detailedSetting;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);var _EScrollDirection=__webpack_require__(104);var _EScrollDirection2=_interopRequireDefault(_EScrollDirection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 公告元素
var Content_newNotice=function(_React$Component){(0,_inherits3.default)(Content_newNotice,_React$Component);function Content_newNotice(props){(0,_classCallCheck3.default)(this,Content_newNotice);var _this=(0,_possibleConstructorReturn3.default)(this,(Content_newNotice.__proto__||(0,_getPrototypeOf2.default)(Content_newNotice)).call(this,props));_this.state={eNewNoticeFrom:_this.props.eNewNoticeFrom.selected,eNewNoticePublisher:_this.props.eNewNoticePublisher,eNewNoticePublisherNames:_this.props.eNewNoticePublisherNames,eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false,eNoticeIsText:_this.props.eNewNoticeIsText,eMultiPage:_this.props.eNewNoticeMultiPage,eNoticeScrollSpeed:_this.props.eNewScrollSpeed||'3',eNoticeNew:_this.props.eNewNoticeNew||'0',ePageSize:_this.props.eNewNoticePageSize||'3',status:_this.props.eScrollDirection.selected||'0'};_this.onChangeStatus=_this.onChangeStatus.bind(_this);return _this;}(0,_createClass3.default)(Content_newNotice,[{key:'onChangeStatus',value:function onChangeStatus(v){this.setState({status:v});if(v!='0')this.setState({eMultiPage:'0'});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,eNewNoticeFrom=_state.eNewNoticeFrom,eNewNoticePublisherNames=_state.eNewNoticePublisherNames,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible,eNoticeIsText=_state.eNoticeIsText,eMultiPage=_state.eMultiPage,eNoticeScrollSpeed=_state.eNoticeScrollSpeed,eNoticeNew=_state.eNoticeNew,ePageSize=_state.ePageSize,status=_state.status;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';var ENewNoticeFrom=_react2.default.createElement('div',null);var ENewNoticePublisher=_react2.default.createElement('div',null);var ENoticeIsText=_react2.default.createElement('div',null);var EMultiPage=_react2.default.createElement('div',null);var ENoticeScrollSpeed=_react2.default.createElement('div',null);var ENoticeNew=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){ENewNoticeFrom=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(20885,'内容来源'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:this.props.eNewNoticeFrom.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eNewNoticeFrom,style:{width:'200px'},onChange:function onChange(value){_this2.setState({eNewNoticeFrom:value});}}));ENewNoticePublisher=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(1861,'发布人'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaBrowser,{type:17,isSingle:false,replaceDatas:eNewNoticePublisherNames||[],onChange:function onChange(ids,names,datas){return _this2.setState({eNewNoticePublisher:ids,eNewNoticePublisherNames:datas});},layout:document.body}));EMultiPage=_react2.default.createElement(_ecCom.WeaFormItem,{label:'多页显示',labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'60px',position:'relative'}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eMultiPage,display:'switch',style:{display:'inline'},onChange:function onChange(v){var value=v;if(v=='1')value=0;_this2.setState({eMultiPage:v,eNoticeIsText:value});}})),eMultiPage=='1'&&_react2.default.createElement('div',{style:{display:'inline-block',position:'absolute',left:'42px',bottom:'7px'}},_react2.default.createElement('div',{style:{display:'inline-block',marginLeft:'15px'}},'\u6BCF\u9875\u6761\u6570'),_react2.default.createElement('div',{style:{display:'inline-flex',width:'60px',marginLeft:'20px'}},_react2.default.createElement(_ecCom.WeaInput,{value:ePageSize,onChange:function onChange(v){_this2.setState({ePageSize:v});}}))));ENoticeScrollSpeed=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22927,'滚动速度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eNoticeScrollSpeed,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({eNoticeScrollSpeed:value});}}),_react2.default.createElement('div',{style:{display:'inline-block',margin:'8px 15px'}},'ms'));ENoticeNew=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(-81503,'显示新建按钮'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eNoticeNew,display:'switch',style:{display:'inline'},onChange:function onChange(v){_this2.setState({eNoticeNew:v});}}));ENoticeIsText=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19111,'纯文本格式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eNoticeIsText,display:'switch',style:{display:'inline'},onChange:function onChange(v){var value=v;if(v=='1')value=0;_this2.setState({eNoticeIsText:v,eMultiPage:value});}}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),eNewNoticeFrom=='2'&&_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),EFieldNew,ENewNoticeFrom,ENewNoticePublisher,this.props.eShareLevel=='2'?_react2.default.createElement(_EScrollDirection2.default,{ref:'eScrollDirection',options:this.props.eScrollDirection.options,value:this.props.eScrollDirection.selected,onChange:this.onChangeStatus}):'',status=='0'?EMultiPage:ENoticeScrollSpeed,eNewNoticeFrom=='2'&&(status=='2'||status=='4')?ENoticeIsText:null,eNewNoticeFrom=='2'?ENoticeNew:null));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode']&&this.refs['eLinkMode'].getSaveValues()||'1',eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys,eContentNewNoticeFrom:this.state.eNewNoticeFrom,eContentNewNoticePublisher:this.state.eNewNoticePublisher,eContentScrollDirection:this.refs['eScrollDirection']?this.refs['eScrollDirection'].getSaveValues():this.props.eScrollDirection.selected,eContentNoticeIsText:this.state.eNoticeIsText,eContentNoticeNew:this.state.eNoticeNew,eContentMultiPage:this.state.eMultiPage,eContentNoticeScrollSpeed:this.state.eNoticeScrollSpeed,eContentPageSize:this.state.ePageSize};}}]);return Content_newNotice;}(_react2.default.Component);exports.default=Content_newNotice;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 外部数据元素
var Content_OutData=function(_React$Component){(0,_inherits3.default)(Content_OutData,_React$Component);function Content_OutData(){(0,_classCallCheck3.default)(this,Content_OutData);return(0,_possibleConstructorReturn3.default)(this,(Content_OutData.__proto__||(0,_getPrototypeOf2.default)(Content_OutData)).apply(this,arguments));}(0,_createClass3.default)(Content_OutData,[{key:'render',value:function render(){var __DataSourceTable=_react2.default.createElement('div',null);if(this.props.eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',ebaseid:'OutData'},this.props.eTabs));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_OutData;}(_react2.default.Component);exports.default=Content_OutData;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EScrollDirection=__webpack_require__(104);var _EScrollDirection2=_interopRequireDefault(_EScrollDirection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 建模查询中心
var Content_FormModeCustomSearch=function(_React$Component){(0,_inherits3.default)(Content_FormModeCustomSearch,_React$Component);function Content_FormModeCustomSearch(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_FormModeCustomSearch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_FormModeCustomSearch.__proto__||(0,_getPrototypeOf2.default)(Content_FormModeCustomSearch)).call.apply(_ref,[this].concat(args))),_this),_this.state={eIsShowTitle:_this.props.eIsShowTitle,weaCubeLoaded:true},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_FormModeCustomSearch,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载表单建模模块静态资源
eventRegister.loadModule('b_cube',function(){setTimeout(function(){return _this2.setState({weaCubeLoaded:true});},100);},function(){});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,eIsShowTitle=_state.eIsShowTitle,weaCubeLoaded=_state.weaCubeLoaded;return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:(this.props.eLinkMode.selected=='-1'?'1':this.props.eLinkMode.selected)||'1'}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(127782,'是否显示标题'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{className:'portal-FormModeCustomSearch-perpage'},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eIsShowTitle,onChange:function onChange(value){return _this3.setState({eIsShowTitle:value=='1'});}}))):'',this.props.eShareLevel=='2'?_react2.default.createElement(_EScrollDirection2.default,{ref:'eScrollDirection',options:this.props.eScrollDirection.options,value:this.props.eScrollDirection.selected}):'',this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386580,'查询列表来源'),labelCol:{span:6},wrapperCol:{span:16}},weaCubeLoaded&&window.weaCubeEngine&&window.weaCubeEngine.com?_react2.default.createElement(window.weaCubeEngine.com.CubeQueryCenterSet,{isCustom:true,eid:this.props.eid,hpid:this.props.hpid}):_react2.default.createElement('div',null)):''));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentIsShowTitle:this.state.eIsShowTitle,eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eContentScrollDirection:this.refs['eScrollDirection']?this.refs['eScrollDirection'].getSaveValues():this.props.eScrollDirection.selected};}}]);return Content_FormModeCustomSearch;}(_react2.default.Component);exports.default=Content_FormModeCustomSearch;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 日历日程
var Content_MeetingCalendar=function(_React$Component){(0,_inherits3.default)(Content_MeetingCalendar,_React$Component);function Content_MeetingCalendar(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_MeetingCalendar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_MeetingCalendar.__proto__||(0,_getPrototypeOf2.default)(Content_MeetingCalendar)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:_this.props.meetingType.selected},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_MeetingCalendar,[{key:'render',value:function render(){var _this2=this;var meetingType=this.props.meetingType;var ShowContents=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:meetingType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:this.state.selected,onChange:function onChange(value){_this2.setState({selected:value});}})));var ShowContents1=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15935,'显示内容'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'100px',textAlign:'center',lineHeight:'2.3'}},_react2.default.createElement(_ecCom.WeaSelect,{options:meetingType.options.map(function(item){return{key:item.key,selected:false,showname:item.value};}),viewAttr:1,value:this.state.selected,onChange:function onChange(value){_this2.setState({selected:value});}})));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',this.props.eShareLevel=='2'?ShowContents:ShowContents1));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentMeetingType:this.state.selected};}}]);return Content_MeetingCalendar;}(_react2.default.Component);exports.default=Content_MeetingCalendar;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField=__webpack_require__(106);var _EField2=_interopRequireDefault(_EField);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器
var Content_CalendarEle=function(_React$Component){(0,_inherits3.default)(Content_CalendarEle,_React$Component);function Content_CalendarEle(){(0,_classCallCheck3.default)(this,Content_CalendarEle);return(0,_possibleConstructorReturn3.default)(this,(Content_CalendarEle.__proto__||(0,_getPrototypeOf2.default)(Content_CalendarEle)).apply(this,arguments));}(0,_createClass3.default)(Content_CalendarEle,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues()};}}]);return Content_CalendarEle;}(_react2.default.Component);exports.default=Content_CalendarEle;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField=__webpack_require__(106);var _EField2=_interopRequireDefault(_EField);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器
var Content_bookshelf=function(_React$Component){(0,_inherits3.default)(Content_bookshelf,_React$Component);function Content_bookshelf(){(0,_classCallCheck3.default)(this,Content_bookshelf);return(0,_possibleConstructorReturn3.default)(this,(Content_bookshelf.__proto__||(0,_getPrototypeOf2.default)(Content_bookshelf)).apply(this,arguments));}(0,_createClass3.default)(Content_bookshelf,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues()};}}]);return Content_bookshelf;}(_react2.default.Component);exports.default=Content_bookshelf;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField=__webpack_require__(106);var _EField2=_interopRequireDefault(_EField);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// RSS阅读器
var Content_newMobilePicture=function(_React$Component){(0,_inherits3.default)(Content_newMobilePicture,_React$Component);function Content_newMobilePicture(){(0,_classCallCheck3.default)(this,Content_newMobilePicture);return(0,_possibleConstructorReturn3.default)(this,(Content_newMobilePicture.__proto__||(0,_getPrototypeOf2.default)(Content_newMobilePicture)).apply(this,arguments));}(0,_createClass3.default)(Content_newMobilePicture,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues()};}}]);return Content_newMobilePicture;}(_react2.default.Component);exports.default=Content_newMobilePicture;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 费用报销智能助手
var Content_fnaBudgetAssistant=function(_React$Component){(0,_inherits3.default)(Content_fnaBudgetAssistant,_React$Component);function Content_fnaBudgetAssistant(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_fnaBudgetAssistant);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_fnaBudgetAssistant.__proto__||(0,_getPrototypeOf2.default)(Content_fnaBudgetAssistant)).call.apply(_ref,[this].concat(args))),_this),_this.state={ePersonalBorrowinInformation:_this.props.ePersonalBorrowinInformation,eReimbursementInformation:_this.props.eReimbursementInformation,eReimbursementChart:_this.props.eReimbursementChart},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_fnaBudgetAssistant,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eReimbursementInformation=_state.eReimbursementInformation,ePersonalBorrowinInformation=_state.ePersonalBorrowinInformation,eReimbursementChart=_state.eReimbursementChart;var EPersonalBorrowinInformation=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126747,'个人借款信息'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:ePersonalBorrowinInformation,onChange:function onChange(value){return _this2.setState({ePersonalBorrowinInformation:value});}}));var EReimbursementInformation=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126748,'报销信息'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eReimbursementInformation,onChange:function onChange(value){return _this2.setState({eReimbursementInformation:value});}}));var EReimbursementChart=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126750,'报销图表'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eReimbursementChart,onChange:function onChange(value){return _this2.setState({eReimbursementChart:value});}}));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EPersonalBorrowinInformation,EReimbursementInformation,EReimbursementChart));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentPersonalBorrowinInformation:this.state.ePersonalBorrowinInformation,eContentReimbursementInformation:this.state.eReimbursementInformation,eContentReimbursementChart:this.state.eReimbursementChart};}}]);return Content_fnaBudgetAssistant;}(_react2.default.Component);exports.default=Content_fnaBudgetAssistant;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 审批助手元素
var Content_fnaBudgetAssistant1=function(_React$Component){(0,_inherits3.default)(Content_fnaBudgetAssistant1,_React$Component);function Content_fnaBudgetAssistant1(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_fnaBudgetAssistant1);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_fnaBudgetAssistant1.__proto__||(0,_getPrototypeOf2.default)(Content_fnaBudgetAssistant1)).call.apply(_ref,[this].concat(args))),_this),_this.state={eDepartment:_this.props.eDepartment||0,eBranch:_this.props.eBranch||0,ePersonal:_this.props.ePersonal||0,eCostCenter:_this.props.eCostCenter||0},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_fnaBudgetAssistant1,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eDepartment=_state.eDepartment,eBranch=_state.eBranch,ePersonal=_state.ePersonal,eCostCenter=_state.eCostCenter;var EDepartment=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(6087,'个人'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eDepartment,onChange:function onChange(value){return _this2.setState({eDepartment:value});}}));var EBranch=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(27511,'部门'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eBranch,onChange:function onChange(value){return _this2.setState({eBranch:value});}}));var EPersonal=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(33553,'分部'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:ePersonal,onChange:function onChange(value){return _this2.setState({ePersonal:value});}}));var ECostCenter=_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(515,'成本中心'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eCostCenter,onChange:function onChange(value){return _this2.setState({eCostCenter:value});}}));return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',EDepartment,EBranch,EPersonal,ECostCenter));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentDepartment:this.state.eDepartment,eContentBranch:this.state.eBranch,ContentPersonal:this.state.ePersonal,ContentCostCenter:this.state.eCostCenter};}}]);return Content_fnaBudgetAssistant1;}(_react2.default.Component);exports.default=Content_fnaBudgetAssistant1;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _weaColorInput=__webpack_require__(341);var _weaColorInput2=_interopRequireDefault(_weaColorInput);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=_antd.Checkbox.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// CoreMail邮件
var Content_CoreMail=function(_React$Component){(0,_inherits3.default)(Content_CoreMail,_React$Component);function Content_CoreMail(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_CoreMail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_CoreMail.__proto__||(0,_getPrototypeOf2.default)(Content_CoreMail)).call.apply(_ref,[this].concat(args))),_this),_this.state={eShowUnreadList:_this.props.eShowUnreadList,eCoreMailPerpage:_this.props.eCoreMailPerpage,eShowPromptInformation:_this.props.eShowPromptInformation,eSingleSignOn:_this.props.eSingleSignOn||'',eHintText:_this.props.eHintText,eUnreadMailQuantityColor:_this.props.eUnreadMailQuantityColor,eSingleSignOnLinkColor:_this.props.eSingleSignOnLinkColor,eExplain:_this.props.eExplain,eCoreMailLinkMode:_this.props.eCoreMailLinkMode,// 链接方式
eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_CoreMail,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShowUnreadList=_state.eShowUnreadList,eCoreMailPerpage=_state.eCoreMailPerpage,eShowPromptInformation=_state.eShowPromptInformation,eSingleSignOn=_state.eSingleSignOn,eHintText=_state.eHintText,eUnreadMailQuantityColor=_state.eUnreadMailQuantityColor,eSingleSignOnLinkColor=_state.eSingleSignOnLinkColor,eCoreMailTitle=_state.eCoreMailTitle,eCoreMailUser=_state.eCoreMailUser,eCoreMailTime=_state.eCoreMailTime,eCoreMailLinkMode=_state.eCoreMailLinkMode,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EShowUnreadList=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386576,'显示未读列表'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eShowUnreadList,onChange:function onChange(value){return _this2.setState({eShowUnreadList:value});}}));var ECoreMailPerpage=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19493,'显示条数'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:eCoreMailPerpage,onChange:function onChange(value){return _this2.setState({eCoreMailPerpage:value});},style:{width:'22%'}}));var EShowPromptInformation=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386577,'显示提示信息'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaCheckbox,{value:eShowPromptInformation,onChange:function onChange(value){return _this2.setState({eShowPromptInformation:value});}}));var ESingleSignOn=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(126789,'单点登录'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaError,{ref:function ref(el){_this2.weaError=el;},error:getLabel(129952,'请选择或新建CoreMail集成登录设置！'),style:{width:'22%'}},_react2.default.createElement(_ecCom.WeaSelect,{value:eSingleSignOn,viewAttr:'3',options:this.props.coreMailSysids.options,onChange:function onChange(value){return _this2.setState({eSingleSignOn:value});},style:{width:'100%'}})));var EHintText=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(129937,'提示文字'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaTextarea,{value:eHintText,onChange:function onChange(value){return _this2.setState({eHintText:value});},style:{width:'300px'}}));var EUnreadMailQuantityColor=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(129938,'未读邮件数量颜色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_weaColorInput2.default,{color:eUnreadMailQuantityColor,onChange:function onChange(value){return _this2.setState({eUnreadMailQuantityColor:value});}}));var ESingleSignOnLinkColor=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(129939,'单点登录链接颜色'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_weaColorInput2.default,{color:eSingleSignOnLinkColor,onChange:function onChange(value){return _this2.setState({eSingleSignOnLinkColor:value});}}));var EExplain=this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(25734,'说明'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaTextarea,{value:"&nbsp;$NoReadCnt$ : "+getLabel(129940,'未读邮件数量')+"\n $LoginLinkStart$ : "+getLabel(129941,'单点登录链接开始')+"\n $LoginLinkEnd$ : "+getLabel(129942,'单点登录链接结束'),viewAttr:1}));var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNew=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):''),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(386578,'未读列表'),needTigger:true,showGroup:true},EShowUnreadList,ECoreMailPerpage,_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected}),ESingleSignOn,_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNew,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，'))))),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(24960,'提示信息'),needTigger:true,showGroup:true},EShowPromptInformation,EHintText,EUnreadMailQuantityColor,ESingleSignOnLinkColor,EExplain));}},{key:'getSaveValues',value:function getSaveValues(){if(this.state.eSingleSignOn==''){this.weaError.showError();return false;}return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,//eContentShowNum: this.refs['eShowNum'].getSaveValues(),
eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),//eContentField: this.refs['eField'].getSaveValues(),
eContentShowUnreadList:this.state.eShowUnreadList,eContentCoreMailPerpage:this.state.eCoreMailPerpage,eContentSingleSignOn:this.state.eSingleSignOn,eContentShowPromptInformation:this.state.eShowPromptInformation,eContentHintText:this.state.eHintText,eContentUnreadMailQuantityColor:this.state.eUnreadMailQuantityColor,eContentSingleSignOnLinkColor:this.state.eSingleSignOnLinkColor,eContentCoreMailLinkMode:this.state.eCoreMailLinkMode,eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_CoreMail;}(_react2.default.Component);exports.default=Content_CoreMail;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);__webpack_require__(342);var _rcColorPicker=__webpack_require__(343);var _ecCom=__webpack_require__(5);__webpack_require__(387);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaColorInput=function(_React$Component){(0,_inherits3.default)(WeaColorInput,_React$Component);function WeaColorInput(props){(0,_classCallCheck3.default)(this,WeaColorInput);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaColorInput.__proto__||(0,_getPrototypeOf2.default)(WeaColorInput)).call(this,props));_this.onChange=_this.onChange.bind(_this);return _this;}(0,_createClass3.default)(WeaColorInput,[{key:'onChange',value:function onChange(value){this.props.onChange(value);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$color=_props.color,color=_props$color===undefined?'#000':_props$color,layout=_props.layout;return _react2.default.createElement('div',{className:'portal-wea-ci'},_react2.default.createElement(_antd.Popover,{content:_react2.default.createElement(_rcColorPicker.Panel,{enableAlpha:false,color:color,onChange:function onChange(obj){return _this2.onChange(obj.color);},mode:'RGB'}),trigger:'click',getTooltipContainer:function getTooltipContainer(){return layout||document.body;},overlayClassName:'portal-wea-ci-popover'},_react2.default.createElement('div',{className:'portal-wea-ci-btn',style:{backgroundColor:color}})),_react2.default.createElement(_ecCom.WeaInput,{value:color,onChange:this.onChange}));}}]);return WeaColorInput;}(_react2.default.Component);exports.default=WeaColorInput;

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(344);
module.exports.Panel = __webpack_require__(145);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcTrigger = __webpack_require__(345);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

var _Panel = __webpack_require__(145);

var _Panel2 = _interopRequireDefault(_Panel);

var _placements = __webpack_require__(386);

var _placements2 = _interopRequireDefault(_placements);

var _color = __webpack_require__(67);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function refFn(field, component) {
  this[field] = component;
}

function prevent(e) {
  e.preventDefault();
}

var ColorPicker = function (_React$Component) {
  _inherits(ColorPicker, _React$Component);

  function ColorPicker(props) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var alpha = typeof props.alpha === 'undefined' ? props.defaultAlpha : Math.min(props.alpha, props.defaultAlpha);

    _this.state = {
      color: props.color || props.defaultColor,
      alpha: alpha,
      open: false
    };

    var events = ['onTriggerClick', 'onChange', 'onBlur', 'getPickerElement', 'getRootDOMNode', 'getTriggerDOMNode', 'onVisibleChange', 'onPanelMount', 'setOpen', 'open', 'close', 'focus'];

    events.forEach(function (e) {
      _this[e] = _this[e].bind(_this);
    });

    _this.saveTriggerRef = refFn.bind(_this, 'triggerInstance');
    return _this;
  }

  ColorPicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.color) {
      this.setState({
        color: nextProps.color
      });
    }
    if (nextProps.alpha !== null && nextProps.alpha !== undefined) {
      this.setState({
        alpha: nextProps.alpha
      });
    }
  };

  ColorPicker.prototype.onTriggerClick = function onTriggerClick() {
    this.setState({
      open: !this.state.open
    });
  };

  ColorPicker.prototype.onChange = function onChange(colors) {
    var _this2 = this;

    this.setState(_extends({}, colors), function () {
      _this2.props.onChange(_this2.state);
    });
  };

  ColorPicker.prototype.onBlur = function onBlur() {
    this.setOpen(false);
  };

  ColorPicker.prototype.onVisibleChange = function onVisibleChange(open) {
    this.setOpen(open);
  };

  ColorPicker.prototype.onPanelMount = function onPanelMount(panelDOMRef) {
    if (this.state.open) {
      setTimeout(function () {
        panelDOMRef.focus();
      }, 1);
    }
  };

  ColorPicker.prototype.setOpen = function setOpen(open, callback) {
    var _this3 = this;

    if (this.state.open !== open) {
      this.setState({
        open: open
      }, function () {
        if (typeof callback === 'function') callback();
        var _props = _this3.props,
            onOpen = _props.onOpen,
            onClose = _props.onClose;

        if (_this3.state.open) {
          onOpen(_this3.state);
        } else {
          onClose(_this3.state);
        }
      });
    }
  };

  ColorPicker.prototype.getRootDOMNode = function getRootDOMNode() {
    return (0, _reactDom.findDOMNode)(this);
  };

  ColorPicker.prototype.getTriggerDOMNode = function getTriggerDOMNode() {
    return (0, _reactDom.findDOMNode)(this.triggerInstance);
  };

  ColorPicker.prototype.getPickerElement = function getPickerElement() {
    // const state = this.state;
    return _react2["default"].createElement(_Panel2["default"], {
      onMount: this.onPanelMount,
      defaultColor: this.state.color,
      alpha: this.state.alpha,
      enableAlpha: this.props.enableAlpha,
      prefixCls: this.props.prefixCls + '-panel',
      onChange: this.onChange,
      onBlur: this.onBlur,
      mode: this.props.mode,
      className: this.props.className
    });
  };

  ColorPicker.prototype.open = function open(callback) {
    this.setOpen(true, callback);
  };

  ColorPicker.prototype.close = function close(callback) {
    this.setOpen(false, callback);
  };

  ColorPicker.prototype.focus = function focus() {
    if (!this.state.open) {
      (0, _reactDom.findDOMNode)(this).focus();
    }
  };

  ColorPicker.prototype.render = function render() {
    var props = this.props;
    var state = this.state;
    var classes = [props.prefixCls + '-wrap', props.className];
    if (state.open) {
      classes.push(props.prefixCls + '-open');
    }

    var children = props.children;

    var _RGB = _slicedToArray(new _color2["default"](this.state.color).RGB, 3),
        r = _RGB[0],
        g = _RGB[1],
        b = _RGB[2];

    var RGBA = [r, g, b];

    RGBA.push(this.state.alpha / 100);

    if (children) {
      children = _react2["default"].cloneElement(children, {
        ref: this.saveTriggerRef,
        unselectable: 'unselectable',
        style: {
          backgroundColor: 'rgba(' + RGBA.join(',') + ')'
        },
        onClick: this.onTriggerClick,
        onMouseDown: prevent
      });
    }

    var prefixCls = props.prefixCls,
        placement = props.placement,
        style = props.style,
        getCalendarContainer = props.getCalendarContainer,
        align = props.align,
        animation = props.animation,
        disabled = props.disabled,
        transitionName = props.transitionName;


    return _react2["default"].createElement(
      'div',
      { className: classes.join(' ') },
      _react2["default"].createElement(
        _rcTrigger2["default"],
        {
          popup: this.getPickerElement(),
          popupAlign: align,
          builtinPlacements: _placements2["default"],
          popupPlacement: placement,
          action: disabled ? [] : ['click'],
          destroyPopupOnHide: true,
          getPopupContainer: getCalendarContainer,
          popupStyle: style,
          popupAnimation: animation,
          popupTransitionName: transitionName,
          popupVisible: state.open,
          onPopupVisibleChange: this.onVisibleChange,
          prefixCls: prefixCls
        },
        children
      )
    );
  };

  return ColorPicker;
}(_react2["default"].Component);

exports["default"] = ColorPicker;


ColorPicker.propTypes = {
  defaultColor: _propTypes2["default"].string,
  defaultAlpha: _propTypes2["default"].number,
  // can custom
  alpha: _propTypes2["default"].number,
  children: _propTypes2["default"].node.isRequired,
  className: _propTypes2["default"].string,
  color: _propTypes2["default"].string,
  enableAlpha: _propTypes2["default"].bool,
  mode: _propTypes2["default"].oneOf(['RGB', 'HSL', 'HSB']),
  onChange: _propTypes2["default"].func,
  onClose: _propTypes2["default"].func,
  onOpen: _propTypes2["default"].func,
  placement: _propTypes2["default"].oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
  prefixCls: _propTypes2["default"].string.isRequired,
  style: _propTypes2["default"].object
};

ColorPicker.defaultProps = {
  defaultColor: '#F00',
  defaultAlpha: 100,
  onChange: function onChange() {},
  onOpen: function onOpen() {},
  onClose: function onClose() {},

  children: _react2["default"].createElement('span', { className: 'rc-color-picker-trigger' }),
  className: '',
  enableAlpha: true,
  placement: 'topLeft',
  prefixCls: 'rc-color-picker',
  style: {}
};
module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin__);











function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var isMobile = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/(Android|iPhone|iPad|iPod|iOS|UCWEB)/i);

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];

var Trigger = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'Trigger',
  propTypes: {
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    action: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)]),
    showAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    hideAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    popup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]).isRequired,
    popupStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    prefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    popupClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    popupPlacement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    builtinPlacements: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    popupTransitionName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
    popupAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    zIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    focusDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    blurDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    getPopupContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    getDocument: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    mask: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    maskClosable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    onPopupAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    popupAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    popupVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    maskTransitionName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
    maskAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin___default()({
    autoMount: false,

    isVisible: function isVisible(instance) {
      return instance.state.popupVisible;
    },
    getContainer: function getContainer(instance) {
      var props = instance.props;

      var popupContainer = document.createElement('div');
                  popupContainer.style.position = 'absolute';
      popupContainer.style.top = '0';
      popupContainer.style.left = '0';
      popupContainer.style.width = '100%';
      var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(instance)) : props.getDocument().body;
      mountNode.appendChild(popupContainer);
      return popupContainer;
    }
  })],

  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rc-trigger-popup',
      getPopupClassNameFromAlign: returnEmptyString,
      getDocument: returnDocument,
      onPopupVisibleChange: noop,
      afterPopupVisibleChange: noop,
      onPopupAlign: noop,
      popupClassName: '',
      mouseEnterDelay: 0,
      mouseLeaveDelay: 0.1,
      focusDelay: 0,
      blurDelay: 0.15,
      popupStyle: {},
      destroyPopupOnHide: false,
      popupAlign: {},
      defaultPopupVisible: false,
      mask: false,
      maskClosable: true,
      action: [],
      showAction: [],
      hideAction: []
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }
    return {
      popupVisible: popupVisible
    };
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
  },
  componentDidMount: function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    this.renderComponent(null, function () {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    });

                    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && this.isClickToHide()) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default()(currentDocument, 'mousedown', this.onDocumentClick);
      }
                              if (!this.touchOutsideHandler && isMobile) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default()(currentDocument, 'click', this.onDocumentClick);
      }
      return;
    }

    this.clearOutsideHandler();
  },
  componentWillUnmount: function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
  },
  onMouseEnter: function onMouseEnter(e) {
    this.fireEvents('onMouseEnter', e);
    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
  },
  onMouseLeave: function onMouseLeave(e) {
    this.fireEvents('onMouseLeave', e);
    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
  },
  onPopupMouseEnter: function onPopupMouseEnter() {
    this.clearDelayTimer();
  },
  onPopupMouseLeave: function onPopupMouseLeave(e) {
            if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(this._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
  },
  onFocus: function onFocus(e) {
    this.fireEvents('onFocus', e);
        this.clearDelayTimer();
    if (this.isFocusToShow()) {
      this.focusTime = Date.now();
      this.delaySetPopupVisible(true, this.props.focusDelay);
    }
  },
  onMouseDown: function onMouseDown(e) {
    this.fireEvents('onMouseDown', e);
    this.preClickTime = Date.now();
  },
  onTouchStart: function onTouchStart(e) {
    this.fireEvents('onTouchStart', e);
    this.preTouchTime = Date.now();
  },
  onBlur: function onBlur(e) {
    this.fireEvents('onBlur', e);
    this.clearDelayTimer();
    if (this.isBlurToHide()) {
      this.delaySetPopupVisible(false, this.props.blurDelay);
    }
  },
  onClick: function onClick(event) {
    this.fireEvents('onClick', event);
        if (this.focusTime) {
      var preTime = void 0;
      if (this.preClickTime && this.preTouchTime) {
        preTime = Math.min(this.preClickTime, this.preTouchTime);
      } else if (this.preClickTime) {
        preTime = this.preClickTime;
      } else if (this.preTouchTime) {
        preTime = this.preTouchTime;
      }
      if (Math.abs(preTime - this.focusTime) < 20) {
        return;
      }
      this.focusTime = 0;
    }
    this.preClickTime = 0;
    this.preTouchTime = 0;
    event.preventDefault();
    var nextVisible = !this.state.popupVisible;
    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
      this.setPopupVisible(!this.state.popupVisible);
    }
  },
  onDocumentClick: function onDocumentClick(event) {
    if (this.props.mask && !this.props.maskClosable) {
      return;
    }
    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this);
    var popupNode = this.getPopupDomNode();
    if (!Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target)) {
      this.close();
    }
  },
  getPopupDomNode: function getPopupDomNode() {
        if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  },
  getRootDomNode: function getRootDomNode() {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this);
  },
  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
    var className = [];
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        builtinPlacements = props.builtinPlacements,
        prefixCls = props.prefixCls;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* getPopupClassNameFromAlign */])(builtinPlacements, prefixCls, align));
    }
    if (props.getPopupClassNameFromAlign) {
      className.push(props.getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  },
  getPopupAlign: function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  },
  getComponent: function getComponent() {
    var props = this.props,
        state = this.state;

    var mouseProps = {};
    if (this.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = this.onPopupMouseEnter;
    }
    if (this.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = this.onPopupMouseLeave;
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: props.prefixCls,
        destroyPopupOnHide: props.destroyPopupOnHide,
        visible: state.popupVisible,
        className: props.popupClassName,
        action: props.action,
        align: this.getPopupAlign(),
        onAlign: props.onPopupAlign,
        animation: props.popupAnimation,
        getClassNameFromAlign: this.getPopupClassNameFromAlign
      }, mouseProps, {
        getRootDomNode: this.getRootDomNode,
        style: props.popupStyle,
        mask: props.mask,
        zIndex: props.zIndex,
        transitionName: props.popupTransitionName,
        maskAnimation: props.maskAnimation,
        maskTransitionName: props.maskTransitionName
      }),
      typeof props.popup === 'function' ? props.popup() : props.popup
    );
  },
  setPopupVisible: function setPopupVisible(popupVisible) {
    this.clearDelayTimer();
    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({
          popupVisible: popupVisible
        });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }
  },
  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible);
    }
  },
  clearDelayTimer: function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  },
  clearOutsideHandler: function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  },
  createTwoChains: function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  },
  isClickToShow: function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  },
  isClickToHide: function isClickToHide() {
    var _props2 = this.props,
        action = _props2.action,
        hideAction = _props2.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  },
  isMouseEnterToShow: function isMouseEnterToShow() {
    var _props3 = this.props,
        action = _props3.action,
        showAction = _props3.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  },
  isMouseLeaveToHide: function isMouseLeaveToHide() {
    var _props4 = this.props,
        action = _props4.action,
        hideAction = _props4.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  },
  isFocusToShow: function isFocusToShow() {
    var _props5 = this.props,
        action = _props5.action,
        showAction = _props5.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  },
  isBlurToHide: function isBlurToHide() {
    var _props6 = this.props,
        action = _props6.action,
        hideAction = _props6.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  },
  forcePopupAlign: function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  },
  fireEvents: function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  },
  close: function close() {
    this.setPopupVisible(false);
  },
  render: function render() {
    var props = this.props;
    var children = props.children;
    var child = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children);
    var newChildProps = {};
    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(child, newChildProps);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (Trigger);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(347);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(349);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var emptyObject = __webpack_require__(350);
var _invariant = __webpack_require__(351);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventBaseObject = __webpack_require__(354);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(37);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = void 0;
    var deltaY = void 0;
    var delta = void 0;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = void 0;
    var doc = void 0;
    var body = void 0;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2["default"].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = void 0;
  var l = void 0;
  var prop = void 0;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2["default"].prototype;

(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },
  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports["default"] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */

function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },
  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },
  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },
  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_align__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_animate__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PopupInner__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LazyRenderBox__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(144);














var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

    _initialiseProps.call(_this);

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_12__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_12__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Popup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.rootNode = this.getPopupDomNode();
    }
  }, {
    key: 'getPopupDomNode',
    value: function getPopupDomNode() {
      return __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.popupInstance);
    }
  }, {
    key: 'getMaskTransitionName',
    value: function getMaskTransitionName() {
      var props = this.props;
      var transitionName = props.maskTransitionName;
      var animation = props.maskAnimation;
      if (!transitionName && animation) {
        transitionName = props.prefixCls + '-' + animation;
      }
      return transitionName;
    }
  }, {
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'getClassName',
    value: function getClassName(currentAlignClassName) {
      return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
    }
  }, {
    key: 'getPopupElement',
    value: function getPopupElement() {
      var savePopupRef = this.savePopupRef,
          props = this.props;
      var align = props.align,
          style = props.style,
          visible = props.visible,
          prefixCls = props.prefixCls,
          destroyPopupOnHide = props.destroyPopupOnHide;

      var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
      var hiddenClassName = prefixCls + '-hidden';
      if (!visible) {
        this.currentAlignClassName = null;
      }
      var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, this.getZIndexStyle());
      var popupInnerProps = {
        className: className,
        prefixCls: prefixCls,
        ref: savePopupRef,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        style: newStyle
      };
      if (destroyPopupOnHide) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
          {
            component: '',
            exclusive: true,
            transitionAppear: true,
            transitionName: this.getTransitionName()
          },
          visible ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_rc_align__["a" /* default */],
            {
              target: this.getTarget,
              key: 'popup',
              ref: this.saveAlignRef,
              monitorWindowResize: true,
              align: align,
              onAlign: this.onAlign
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__PopupInner__["a" /* default */],
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                visible: true
              }, popupInnerProps),
              props.children
            )
          ) : null
        );
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName(),
          showProp: 'xVisible'
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_align__["a" /* default */],
          {
            target: this.getTarget,
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            xVisible: visible,
            childrenProps: { visible: 'xVisible' },
            disabled: !visible,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              hiddenClassName: hiddenClassName
            }, popupInnerProps),
            props.children
          )
        )
      );
    }
  }, {
    key: 'getZIndexStyle',
    value: function getZIndexStyle() {
      var style = {};
      var props = this.props;
      if (props.zIndex !== undefined) {
        style.zIndex = props.zIndex;
      }
      return style;
    }
  }, {
    key: 'getMaskElement',
    value: function getMaskElement() {
      var props = this.props;
      var maskElement = void 0;
      if (props.mask) {
        var maskTransition = this.getMaskTransitionName();
        maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LazyRenderBox__["a" /* default */], {
          style: this.getZIndexStyle(),
          key: 'mask',
          className: props.prefixCls + '-mask',
          hiddenClassName: props.prefixCls + '-mask-hidden',
          visible: props.visible
        });
        if (maskTransition) {
          maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
            {
              key: 'mask',
              showProp: 'visible',
              transitionAppear: true,
              component: '',
              transitionName: maskTransition
            },
            maskElement
          );
        }
      }
      return maskElement;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        this.getMaskElement(),
        this.getPopupElement()
      );
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this2.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this2.currentAlignClassName !== currentAlignClassName) {
      _this2.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this2.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.getTarget = function () {
    return _this2.props.getRootDomNode();
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(357);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_align__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(367);











function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Align.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    // if parent ref not attached .... use document.getElementById
    this.forceAlign();
    if (!props.disabled && props.monitorWindowResize) {
      this.startMonitorWindowResize();
    }
  };

  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var reAlign = false;
    var props = this.props;

    if (!props.disabled) {
      var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var sourceRect = source ? source.getBoundingClientRect() : null;

      if (prevProps.disabled) {
        reAlign = true;
      } else {
        var lastElement = getElement(prevProps.target);
        var currentElement = getElement(props.target);
        var lastPoint = getPoint(prevProps.target);
        var currentPoint = getPoint(props.target);

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(currentElement)) {
          // Skip if is window
          reAlign = false;
        } else if (lastElement !== currentElement || // Element change
        lastElement && !currentElement && currentPoint || // Change from element to point
        lastPoint && currentPoint && currentElement || // Change from point to element
        currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
          reAlign = true;
        }

        // If source element size changed
        var preRect = this.sourceRect || {};
        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
          reAlign = true;
        }
      }

      this.sourceRect = sourceRect;
    }

    if (reAlign) {
      this.forceAlign();
    }

    if (props.monitorWindowResize && !props.disabled) {
      this.startMonitorWindowResize();
    } else {
      this.stopMonitorWindowResize();
    }
  };

  Align.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopMonitorWindowResize();
  };

  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
    if (!this.resizeHandler) {
      this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
      this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
    }
  };

  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
    if (this.resizeHandler) {
      this.bufferMonitor.clear();
      this.resizeHandler.remove();
      this.resizeHandler = null;
    }
  };

  Align.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        childrenProps = _props.childrenProps,
        children = _props.children;

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    if (childrenProps) {
      var newProps = {};
      var propList = Object.keys(childrenProps);
      propList.forEach(function (prop) {
        newProps[prop] = _this2.props[childrenProps[prop]];
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, newProps);
    }
    return child;
  };

  return Align;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_alignElement__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__["a"]; });





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a" /* default */]);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(139);





function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  return Object(__WEBPACK_IMPORTED_MODULE_0__align__["a" /* default */])(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

alignElement.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (alignElement);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(46);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(46);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(364);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align__ = __webpack_require__(136);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX = void 0;
  var pageY = void 0;

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(el);
  var win = doc.defaultView || doc.parentWindow;

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };

  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];

  return Object(__WEBPACK_IMPORTED_MODULE_1__align__["a" /* default */])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
}

/* harmony default export */ __webpack_exports__["a"] = (alignPoint);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback);
}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = isWindow;
function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(142);










var defaultKey = 'rc_animate_' + Date.now();


function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                return _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else {
      if (type === 'appear') {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowAppearCallback(props)) {
          props.onAppear(key);
          props.onEnd(key, true);
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowEnterCallback(props)) {
          props.onEnter(key);
          props.onEnd(key, true);
        }
      }
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(370);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_css_animation__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(142);











var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_8_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_8_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
      var baseEvents = EVENT_NAME_MAP[baseEventName];
      for (var styleName in baseEvents) {
        if (styleName in style) {
          endEvents.push(baseEvents[styleName]);
          break;
        }
      }
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },


  endEvents: endEvents,

  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(141);
} catch (err) {
  var index = __webpack_require__(141);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LazyRenderBox__ = __webpack_require__(143);








var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PopupInner.__proto__ || Object.getPrototypeOf(PopupInner)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PopupInner, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var className = props.className;
      if (!props.visible) {
        className += ' ' + props.hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          className: className,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave,
          style: props.style
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__LazyRenderBox__["a" /* default */],
          { className: props.prefixCls + '-content', visible: props.visible },
          props.children
        )
      );
    }
  }]);

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

exports['default'] = getContainerRenderMixin;

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function defaultGetContainer() {
  var container = document.createElement('div');
  document.body.appendChild(container);
  return container;
}

function getContainerRenderMixin(config) {
  var _config$autoMount = config.autoMount,
      autoMount = _config$autoMount === undefined ? true : _config$autoMount,
      _config$autoDestroy = config.autoDestroy,
      autoDestroy = _config$autoDestroy === undefined ? true : _config$autoDestroy,
      isVisible = config.isVisible,
      isForceRender = config.isForceRender,
      getComponent = config.getComponent,
      _config$getContainer = config.getContainer,
      getContainer = _config$getContainer === undefined ? defaultGetContainer : _config$getContainer;


  var mixin = void 0;

  function _renderComponent(instance, componentArg, ready) {
    if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
      if (!instance._container) {
        instance._container = getContainer(instance);
      }
      var component = void 0;
      if (instance.getComponent) {
        component = instance.getComponent(componentArg);
      } else {
        component = getComponent(instance, componentArg);
      }
      _reactDom2['default'].unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
        instance._component = this;
        if (ready) {
          ready.call(this);
        }
      });
    }
  }

  if (autoMount) {
    mixin = (0, _extends3['default'])({}, mixin, {
      componentDidMount: function componentDidMount() {
        _renderComponent(this);
      },
      componentDidUpdate: function componentDidUpdate() {
        _renderComponent(this);
      }
    });
  }

  if (!autoMount || !autoDestroy) {
    mixin = (0, _extends3['default'])({}, mixin, {
      renderComponent: function renderComponent(componentArg, ready) {
        _renderComponent(this, componentArg, ready);
      }
    });
  }

  function _removeContainer(instance) {
    if (instance._container) {
      var container = instance._container;
      _reactDom2['default'].unmountComponentAtNode(container);
      container.parentNode.removeChild(container);
      instance._container = null;
    }
  }

  if (autoDestroy) {
    mixin = (0, _extends3['default'])({}, mixin, {
      componentWillUnmount: function componentWillUnmount() {
        _removeContainer(this);
      }
    });
  } else {
    mixin = (0, _extends3['default'])({}, mixin, {
      removeContainer: function removeContainer() {
        _removeContainer(this);
      }
    });
  }

  return mixin;
}
module.exports = exports['default'];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(80);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _color = __webpack_require__(67);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var WIDTH = 200;
var HEIGHT = 150;

var Board = function (_React$Component) {
  _inherits(Board, _React$Component);

  function Board(props) {
    _classCallCheck(this, Board);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onBoardMouseDown = function (e) {
      var buttons = e.buttons;

      // only work on left click
      // @see https://developer.mozilla.org/en-US/docs/Web/Events/mousedown
      if (buttons !== 1) return;

      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
      _this.dragListener = (0, _addEventListener2["default"])(window, 'mousemove', _this.onBoardDrag);
      _this.dragUpListener = (0, _addEventListener2["default"])(window, 'mouseup', _this.onBoardDragEnd);
    };

    _this.onBoardTouchStart = function (e) {
      if (e.touches.length !== 1) {
        return;
      }
      _this.removeTouchListeners();
      var x = e.targetTouches[0].clientX;
      var y = e.targetTouches[0].clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.touchMoveListener = (0, _addEventListener2["default"])(window, 'touchmove', _this.onBoardTouchMove);
      _this.touchEndListener = (0, _addEventListener2["default"])(window, 'touchend', _this.onBoardTouchEnd);
    };

    _this.onBoardTouchMove = function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      var x = e.targetTouches[0].clientX;
      var y = e.targetTouches[0].clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onBoardTouchEnd = function () {
      _this.removeTouchListeners();
    };

    _this.onBoardDrag = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onBoardDragEnd = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-board';
    };

    _this.removeTouchListeners = function () {
      if (_this.touchMoveListener) {
        _this.touchMoveListener.remove();
        _this.touchMoveListener = null;
      }
      if (_this.touchEndListener) {
        _this.touchEndListener.remove();
        _this.touchEndListener = null;
      }
    };

    _this.removeListeners = function () {
      if (_this.dragListener) {
        _this.dragListener.remove();
        _this.dragListener = null;
      }
      if (_this.dragUpListener) {
        _this.dragUpListener.remove();
        _this.dragUpListener = null;
      }
    };

    _this.pointMoveTo = function (pos) {
      var rect = _reactDom2["default"].findDOMNode(_this).getBoundingClientRect();
      var left = pos.x - rect.left;
      var top = pos.y - rect.top;

      var rWidth = rect.width || WIDTH;
      var rHeight = rect.height || HEIGHT;

      left = Math.max(0, left);
      left = Math.min(left, rWidth);
      top = Math.max(0, top);
      top = Math.min(top, rHeight);

      var color = _this.props.color;


      color.saturation = left / rWidth;
      color.brightness = 1 - top / rHeight;

      _this.props.onChange(color);
    };

    return _this;
  }

  Board.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeListeners();
    this.removeTouchListeners();
  };

  /**
   * 移动光标位置到
   * @param  {object} pos X Y 全局坐标点
   */


  Board.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    var color = this.props.color;

    var hueHsv = {
      h: color.hue,
      s: 1,
      v: 1
    };

    var hueColor = new _color2["default"](hueHsv).toHexString();

    var xRel = color.saturation * 100;
    var yRel = (1 - color.brightness) * 100;

    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-hsv', style: { backgroundColor: hueColor } },
        _react2["default"].createElement('div', { className: prefixCls + '-value' }),
        _react2["default"].createElement('div', { className: prefixCls + '-saturation' })
      ),
      _react2["default"].createElement('span', { style: { left: xRel + '%', top: yRel + '%' } }),
      _react2["default"].createElement('div', {
        className: prefixCls + '-handler',
        onMouseDown: this.onBoardMouseDown,
        onTouchStart: this.onBoardTouchStart
      })
    );
  };

  return Board;
}(_react2["default"].Component);

/**
 * hsv
 * h: range(0, 359)
 * s: range(0, 1)
 * v: range(0, 1)
 */

exports["default"] = Board;
Board.propTypes = {
  color: _propTypes2["default"].object,
  onChange: _propTypes2["default"].func,
  rootPrefixCls: _propTypes2["default"].string
};
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = __webpack_require__(67);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Preview = function (_React$Component) {
  _inherits(Preview, _React$Component);

  function Preview() {
    var _temp, _this, _ret;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onChange = function (e) {
      var value = e.target.value;
      var color = new _color2["default"](value);
      _this.props.onChange(color);
      e.stopPropagation();
    }, _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-preview';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Preview.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    var hex = this.props.color.toHexString();
    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement('span', {
        style: {
          backgroundColor: hex,
          opacity: this.props.alpha / 100
        }
      }),
      _react2["default"].createElement('input', {
        type: 'color',
        value: hex,
        onChange: this.onChange,
        onClick: this.props.onInputClick
      })
    );
  };

  return Preview;
}(_react2["default"].Component);

exports["default"] = Preview;


Preview.propTypes = {
  rootPrefixCls: _propTypes2["default"].string,
  color: _propTypes2["default"].object,
  alpha: _propTypes2["default"].number,
  onChange: _propTypes2["default"].func,
  onInputClick: _propTypes2["default"].func
};
module.exports = exports['default'];

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(80);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Ribbon = function (_React$Component) {
  _inherits(Ribbon, _React$Component);

  function Ribbon(props) {
    _classCallCheck(this, Ribbon);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onMouseDown = function (e) {
      var x = e.clientX;
      var y = e.clientY;

      _this.pointMoveTo({
        x: x,
        y: y
      });

      _this.dragListener = (0, _addEventListener2["default"])(window, 'mousemove', _this.onDrag);
      _this.dragUpListener = (0, _addEventListener2["default"])(window, 'mouseup', _this.onDragEnd);
    };

    _this.onDrag = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onDragEnd = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-ribbon';
    };

    _this.pointMoveTo = function (coords) {
      var rect = _reactDom2["default"].findDOMNode(_this).getBoundingClientRect();
      var width = rect.width;
      var left = coords.x - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, width);

      var huePercent = left / width;
      var hue = huePercent * 360;

      var color = _this.props.color;


      color.hue = hue;

      _this.props.onChange(color);
    };

    _this.removeListeners = function () {
      if (_this.dragListener) {
        _this.dragListener.remove();
        _this.dragListener = null;
      }
      if (_this.dragUpListener) {
        _this.dragUpListener.remove();
        _this.dragUpListener = null;
      }
    };

    return _this;
  }

  Ribbon.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeListeners();
  };

  Ribbon.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    var hue = this.props.color.hue;
    var per = hue / 360 * 100;

    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement('span', { ref: 'point', style: { left: per + '%' } }),
      _react2["default"].createElement('div', { className: prefixCls + '-handler', onMouseDown: this.onMouseDown })
    );
  };

  return Ribbon;
}(_react2["default"].Component);

exports["default"] = Ribbon;


Ribbon.propTypes = {
  rootPrefixCls: _propTypes2["default"].string,
  color: _propTypes2["default"].object,
  onChange: _propTypes2["default"].func
};
module.exports = exports['default'];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(80);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function rgbaColor(r, g, b, a) {
  return 'rgba(' + [r, g, b, a / 100].join(',') + ')';
}

var Alpha = function (_React$Component) {
  _inherits(Alpha, _React$Component);

  function Alpha(props) {
    _classCallCheck(this, Alpha);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onMouseDown = function (e) {
      var x = e.clientX;
      var y = e.clientY;

      _this.pointMoveTo({
        x: x,
        y: y
      });

      _this.dragListener = (0, _addEventListener2["default"])(window, 'mousemove', _this.onDrag);
      _this.dragUpListener = (0, _addEventListener2["default"])(window, 'mouseup', _this.onDragEnd);
    };

    _this.onDrag = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
    };

    _this.onDragEnd = function (e) {
      var x = e.clientX;
      var y = e.clientY;
      _this.pointMoveTo({
        x: x,
        y: y
      });
      _this.removeListeners();
    };

    _this.getBackground = function () {
      var _this$props$color = _this.props.color,
          red = _this$props$color.red,
          green = _this$props$color.green,
          blue = _this$props$color.blue;

      var opacityGradient = 'linear-gradient(to right, ' + rgbaColor(red, green, blue, 0) + ' , ' + rgbaColor(red, green, blue, 100) + ')'; // eslint-disable-line max-len
      return opacityGradient;
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-alpha';
    };

    _this.pointMoveTo = function (coords) {
      var rect = (0, _reactDom.findDOMNode)(_this).getBoundingClientRect();
      var width = rect.width;
      var left = coords.x - rect.left;

      left = Math.max(0, left);
      left = Math.min(left, width);

      var alpha = Math.round(left / width * 100);

      _this.props.onChange(alpha);
    };

    _this.removeListeners = function () {
      if (_this.dragListener) {
        _this.dragListener.remove();
        _this.dragListener = null;
      }
      if (_this.dragUpListener) {
        _this.dragUpListener.remove();
        _this.dragUpListener = null;
      }
    };

    return _this;
  }

  Alpha.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeListeners();
  };

  Alpha.prototype.render = function render() {
    var prefixCls = this.getPrefixCls();
    return _react2["default"].createElement(
      'div',
      { className: prefixCls },
      _react2["default"].createElement('div', { ref: 'bg', className: prefixCls + '-bg', style: { background: this.getBackground() } }),
      _react2["default"].createElement('span', { style: { left: this.props.alpha + '%' } }),
      _react2["default"].createElement('div', { className: prefixCls + '-handler', onMouseDown: this.onMouseDown })
    );
  };

  return Alpha;
}(_react2["default"].Component);

exports["default"] = Alpha;


Alpha.propTypes = {
  color: _propTypes2["default"].object,
  onChange: _propTypes2["default"].func,
  rootPrefixCls: _propTypes2["default"].string,
  alpha: _propTypes2["default"].number
};
module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(41);

var _classnames2 = _interopRequireDefault(_classnames);

var _color = __webpack_require__(67);

var _color2 = _interopRequireDefault(_color);

var _percentage = __webpack_require__(384);

var _percentage2 = _interopRequireDefault(_percentage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var modesMap = ['RGB', 'HSB'];

var Params = function (_React$Component) {
  _inherits(Params, _React$Component);

  function Params(props) {
    _classCallCheck(this, Params);

    // 管理 input 的状态
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getChannelInRange = function (value, index) {
      var channelMap = {
        RGB: [[0, 255], [0, 255], [0, 255]],
        HSB: [[0, 359], [0, 100], [0, 100]]
      };
      var mode = _this.state.mode;
      var range = channelMap[mode][index];
      var result = parseInt(value, 10);
      if (isNaN(result)) {
        result = 0;
      }
      result = Math.max(range[0], result);
      result = Math.min(result, range[1]);
      return result;
    };

    _this.getPrefixCls = function () {
      return _this.props.rootPrefixCls + '-params';
    };

    _this.handleHexBlur = function () {
      var hex = _this.state.hex;

      var color = null;

      if (_color2["default"].isValidHex(hex)) {
        color = new _color2["default"](hex);
      }

      if (color !== null) {
        _this.setState({
          color: color,
          hex: hex
        });
        _this.props.onChange(color, false);
      }
    };

    _this.handleHexPress = function (event) {
      var hex = _this.state.hex;
      if (event.nativeEvent.which === 13) {
        var color = null;

        if (_color2["default"].isValidHex(hex)) {
          color = new _color2["default"](hex);
        }

        if (color !== null) {
          _this.setState({
            color: color,
            hex: hex
          });
          _this.props.onChange(color, false);
        }
      }
    };

    _this.handleHexChange = function (event) {
      var hex = event.target.value;

      _this.setState({
        hex: hex
      });
    };

    _this.handleModeChange = function () {
      var mode = _this.state.mode;

      var modeIndex = (modesMap.indexOf(mode) + 1) % modesMap.length;

      mode = modesMap[modeIndex];

      _this.setState({
        mode: mode
      });
    };

    _this.handleAlphaHandler = function (event) {
      var alpha = parseInt(event.target.value, 10);

      if (isNaN(alpha)) {
        alpha = 0;
      }
      alpha = Math.max(0, alpha);
      alpha = Math.min(alpha, 100);

      _this.props.onAlphaChange(alpha);
    };

    _this.updateColorByChanel = function (channel, value) {
      var color = _this.props.color;
      var mode = _this.state.mode;


      if (mode === 'HSB') {
        if (channel === 'H') {
          color.hue = parseInt(value, 10);
        } else if (channel === 'S') {
          color.saturation = parseInt(value, 10) / 100;
        } else if (channel === 'B') {
          color.brightness = parseInt(value, 10) / 100;
        }
      } else {
        if (channel === 'R') {
          color.red = parseInt(value, 10);
        } else if (channel === 'G') {
          color.green = parseInt(value, 10);
        } else if (channel === 'B') {
          color.blue = parseInt(value, 10);
        }
      }

      return color;
    };

    _this.handleColorChannelChange = function (index, event) {
      var value = _this.getChannelInRange(event.target.value, index);
      var mode = _this.state.mode;

      var channel = mode[index];

      var color = _this.updateColorByChanel(channel, value);

      _this.setState({
        hex: color.hex,
        color: color
      }, function () {
        _this.props.onChange(color, false);
      });
    };

    _this.state = {
      mode: props.mode,
      hex: props.color.hex,
      color: props.color // instanceof tinycolor
    };
    return _this;
  }

  Params.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextColor = nextProps.color;


    this.setState({
      color: nextColor,
      hex: nextColor.hex
    });
  };

  Params.prototype.render = function render() {
    var _cx;

    var prefixCls = this.getPrefixCls();

    var enableAlpha = this.props.enableAlpha;
    var _state = this.state,
        mode = _state.mode,
        color = _state.color;

    var colorChannel = color[mode];

    if (mode === 'HSB') {
      colorChannel[0] = parseInt(colorChannel[0], 10);
      colorChannel[1] = (0, _percentage2["default"])(colorChannel[1]);
      colorChannel[2] = (0, _percentage2["default"])(colorChannel[2]);
    }

    var paramsClasses = (0, _classnames2["default"])((_cx = {}, _defineProperty(_cx, prefixCls, true), _defineProperty(_cx, prefixCls + '-has-alpha', enableAlpha), _cx));

    return _react2["default"].createElement(
      'div',
      { className: paramsClasses },
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-input' },
        _react2["default"].createElement('input', {
          className: prefixCls + '-hex',
          type: 'text',
          maxLength: '6',
          onKeyPress: this.handleHexPress,
          onBlur: this.handleHexBlur,
          onChange: this.handleHexChange,
          value: this.state.hex.toLowerCase()
        }),
        _react2["default"].createElement('input', {
          type: 'number',
          ref: 'channel_0',
          value: colorChannel[0],
          onChange: this.handleColorChannelChange.bind(null, 0)
        }),
        _react2["default"].createElement('input', {
          type: 'number',
          ref: 'channel_1',
          value: colorChannel[1],
          onChange: this.handleColorChannelChange.bind(null, 1)
        }),
        _react2["default"].createElement('input', {
          type: 'number',
          ref: 'channel_2',
          value: colorChannel[2],
          onChange: this.handleColorChannelChange.bind(null, 2)
        }),
        enableAlpha && _react2["default"].createElement('input', {
          type: 'number',
          value: Math.round(this.props.alpha),
          onChange: this.handleAlphaHandler
        })
      ),
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-lable' },
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-hex' },
          'Hex'
        ),
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-number', onClick: this.handleModeChange },
          mode[0]
        ),
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-number', onClick: this.handleModeChange },
          mode[1]
        ),
        _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-number', onClick: this.handleModeChange },
          mode[2]
        ),
        enableAlpha && _react2["default"].createElement(
          'label',
          { className: prefixCls + '-lable-alpha' },
          'A'
        )
      )
    );
  };

  return Params;
}(_react2["default"].Component);

exports["default"] = Params;


Params.propTypes = {
  alpha: _propTypes2["default"].number,
  enableAlpha: _propTypes2["default"].bool,
  color: _propTypes2["default"].object.isRequired,
  mode: _propTypes2["default"].oneOf(modesMap),
  onAlphaChange: _propTypes2["default"].func,
  onChange: _propTypes2["default"].func,
  rootPrefixCls: _propTypes2["default"].string
};

Params.defaultProps = {
  mode: modesMap[0],
  enableAlpha: true
};
module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = percentage;
function percentage(input) {
  return Math.round(input * 100);
}
module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function validationColor(props, propName, componentName) {
  if (props[propName] && !/^#[0-9a-fA-F]{3,6}$/.test(props[propName])) {
    return new Error(componentName + ".props." + propName + " Validation failed!");
  }
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -5],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -5],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 5],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 5],
    targetOffset: targetOffset
  }
};

exports["default"] = placements;
module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(388);

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 公司新闻
var Content_news=function(_React$Component){(0,_inherits3.default)(Content_news,_React$Component);function Content_news(){(0,_classCallCheck3.default)(this,Content_news);return(0,_possibleConstructorReturn3.default)(this,(Content_news.__proto__||(0,_getPrototypeOf2.default)(Content_news)).apply(this,arguments));}(0,_createClass3.default)(Content_news,[{key:'render',value:function render(){var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams,_props$eLinkMode=_props.eLinkMode,eLinkMode=_props$eLinkMode===undefined?{}:_props$eLinkMode;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:ebaseid},this.props.eTabs,{synergyParams:synergyParams}));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:eLinkMode.options,value:eLinkMode.selected})),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_news;}(_react2.default.Component);exports.default=Content_news;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _EField_New=__webpack_require__(17);var _EField_New2=_interopRequireDefault(_EField_New);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 我的任务元素
var Content_ProcessTask=function(_React$Component){(0,_inherits3.default)(Content_ProcessTask,_React$Component);function Content_ProcessTask(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Content_ProcessTask);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Content_ProcessTask.__proto__||(0,_getPrototypeOf2.default)(Content_ProcessTask)).call.apply(_ref,[this].concat(args))),_this),_this.state={eFieldNewDataSource:_this.props.eFieldNewDataSource,eFieldNewUsedKeys:_this.props.eFieldNewUsedKeys,eFieldNewVisible:false},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Content_ProcessTask,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eFieldNewDataSource=_state.eFieldNewDataSource,eFieldNewUsedKeys=_state.eFieldNewUsedKeys,eFieldNewVisible=_state.eFieldNewVisible;var EFieldNewshow=_react2.default.createElement('div',null);var EFieldNew=_react2.default.createElement('div',null);if(eFieldNewVisible){var eFieldNewProps={eFieldNewDataSource:_.cloneDeep(eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(eFieldNewUsedKeys),onOk:function onOk(data){_this2.setState({eFieldNewDataSource:_.cloneDeep(data.eFieldNewDataSource),eFieldNewUsedKeys:_.cloneDeep(data.eFieldNewUsedKeys),eFieldNewVisible:false});},onCancel:function onCancel(){_this2.setState({eFieldNewVisible:false});}};EFieldNewshow=_react2.default.createElement(_EField_New2.default,eFieldNewProps);}var eFieldNewUsedNames=[];for(var i=0;i<eFieldNewUsedKeys.length;i++){for(var j=0;j<eFieldNewDataSource.length;j++){if(eFieldNewUsedKeys[i]==eFieldNewDataSource[j].key){eFieldNewUsedNames.push(eFieldNewDataSource[j].name);}}}EFieldNew=this.props.eShareLevel=='2'?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19495,'显示字段'),labelCol:{span:6},wrapperCol:{span:16}},EFieldNewshow,_react2.default.createElement('div',{style:{height:'30px',lineHeight:'23px'}},_react2.default.createElement('i',{className:'icon-coms-Flow-setting portal-esetting-btn',onClick:function onClick(){return _this2.setState({eFieldNewVisible:true});}}),_react2.default.createElement('span',null,eFieldNewUsedNames.join('，')))):'';return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:this.props.eShowNum}),_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected==''?'2':this.props.eLinkMode.selected}),EFieldNew));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentFieldNewUsedKeys:this.state.eFieldNewUsedKeys};}}]);return Content_ProcessTask;}(_react2.default.Component);exports.default=Content_ProcessTask;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 登录系统元素
var Content_login=function(_React$Component){(0,_inherits3.default)(Content_login,_React$Component);function Content_login(){(0,_classCallCheck3.default)(this,Content_login);return(0,_possibleConstructorReturn3.default)(this,(Content_login.__proto__||(0,_getPrototypeOf2.default)(Content_login)).apply(this,arguments));}(0,_createClass3.default)(Content_login,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',_react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:this.props.eLinkMode.options,value:this.props.eLinkMode.selected})));}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentLinkMode:this.refs['eLinkMode'].getSaveValues()};}}]);return Content_login;}(_react2.default.Component);exports.default=Content_login;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 自定义元素
var Content_CustomElement=function(_React$Component){(0,_inherits3.default)(Content_CustomElement,_React$Component);function Content_CustomElement(props){(0,_classCallCheck3.default)(this,Content_CustomElement);return(0,_possibleConstructorReturn3.default)(this,(Content_CustomElement.__proto__||(0,_getPrototypeOf2.default)(Content_CustomElement)).call(this,props));}(0,_createClass3.default)(Content_CustomElement,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,_props$eCustom=_props.eCustom,eCustom=_props$eCustom===undefined?{}:_props$eCustom,_props$synergyParams=_props.synergyParams,synergyParams=_props$synergyParams===undefined?{}:_props$synergyParams;var packagename=eCustom.packagename,settingcompname=eCustom.settingcompname;var ECustomSetting=null;if(window.rewritePortalCusEleSetting&&typeof window.rewritePortalCusEleSetting=='function'){var props=(0,_extends3.default)({},this.props);var options={getInstance:function getInstance(eCustomSetting){return _this2.eCustomSetting=eCustomSetting;},id:eid,eid:eid,ebaseid:ebaseid,params:{hpid:hpid,eid:eid,ebaseid:ebaseid},synergyParams:synergyParams};ECustomSetting=window.rewritePortalCusEleSetting(props,options);}if(ECustomSetting==null&&window[packagename]&&window[packagename]['com']&&window[packagename]['com'][settingcompname]){var ECustomSettingTemp=window[packagename]['com'][settingcompname];ECustomSetting=_react2.default.createElement(ECustomSettingTemp,{getInstance:function getInstance(eCustomSetting){return _this2.eCustomSetting=eCustomSetting;},params:{hpid:hpid,eid:eid,ebaseid:ebaseid},synergyParams:synergyParams});}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle,hasLink:false}):''),this.props.eShareLevel=='2'&&_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(20885,'内容来源'),needTigger:true,showGroup:true},ECustomSetting));}},{key:'getSaveValues',value:function getSaveValues(){var result=this.eCustomSetting&&this.eCustomSetting.onSave();if(result===false){return null;}return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle};}}]);return Content_CustomElement;}(_react2.default.Component);exports.default=Content_CustomElement;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _EType=__webpack_require__(11);var _EType2=_interopRequireDefault(_EType);var _ETitle=__webpack_require__(12);var _ETitle2=_interopRequireDefault(_ETitle);var _EShowNum=__webpack_require__(16);var _EShowNum2=_interopRequireDefault(_EShowNum);var _ELinkMode=__webpack_require__(14);var _ELinkMode2=_interopRequireDefault(_ELinkMode);var _ENewsMould=__webpack_require__(77);var _ENewsMould2=_interopRequireDefault(_ENewsMould);var _ERemindMode=__webpack_require__(78);var _ERemindMode2=_interopRequireDefault(_ERemindMode);var _DataSourceTable=__webpack_require__(24);var _DataSourceTable2=_interopRequireDefault(_DataSourceTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//import EField from './base/EField';
// 文档中心
var Content_dy=function(_React$Component){(0,_inherits3.default)(Content_dy,_React$Component);function Content_dy(){(0,_classCallCheck3.default)(this,Content_dy);return(0,_possibleConstructorReturn3.default)(this,(Content_dy.__proto__||(0,_getPrototypeOf2.default)(Content_dy)).apply(this,arguments));}(0,_createClass3.default)(Content_dy,[{key:'render',value:function render(){var _this2=this;var _props=this.props,hpid=_props.hpid,eid=_props.eid,ebaseid=_props.ebaseid,eShareLevel=_props.eShareLevel,synergyParams=_props.synergyParams,_props$dyParams=_props.dyParams,dyParams=_props$dyParams===undefined?[]:_props$dyParams,sebaseid=_props.sebaseid;var __DataSourceTable=_react2.default.createElement('div',null);if(eShareLevel=='2'){__DataSourceTable=_react2.default.createElement(_DataSourceTable2.default,(0,_extends3.default)({ref:'dataSourceTable',hpid:hpid,eid:eid,ebaseid:sebaseid},this.props.eTabs,{synergyParams:synergyParams}));}var settingInfo=dyParams.map(function(dpitem){switch(dpitem.type){case'EShowNum':return _react2.default.createElement(_EShowNum2.default,{ref:'eShowNum',value:_this2.props.eShowNum});break;case'ELinkMode':return _react2.default.createElement(_ELinkMode2.default,{ref:'eLinkMode',options:_this2.props.eLinkMode.options,value:_this2.props.eLinkMode.selected});break;case'ERemindMode':return _react2.default.createElement(_ERemindMode2.default,{ref:'eRemindMode',value:_this2.props.eRemindMode});break;default:return null;}});return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_EType2.default,{ref:'eType',value:this.props.eBaseName}),this.props.eShareLevel=='2'?_react2.default.createElement(_ETitle2.default,{ref:'eTitle',eid:this.props.eid,value:this.props.eTitle}):'',settingInfo),__DataSourceTable);}},{key:'getSaveValues',value:function getSaveValues(){return{eContentTitle:this.refs['eTitle']?this.refs['eTitle'].getSaveValues():this.props.eTitle,eContentShowNum:this.refs['eShowNum'].getSaveValues(),eContentLinkMode:this.refs['eLinkMode'].getSaveValues(),eContentRemindMode:this.refs['eRemindMode'].getSaveValues(),eContentTabWidth:{tabwidth:this.props.etabwidth,methodvalue:this.props.methodvalue},eTabs:this.refs['dataSourceTable']?this.refs['dataSourceTable'].getSaveValues():{}};}}]);return Content_dy;}(_react2.default.Component);exports.default=Content_dy;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _WeaMaterialLib=__webpack_require__(64);var _WeaMaterialLib2=_interopRequireDefault(_WeaMaterialLib);var _ETabWidth=__webpack_require__(395);var _ETabWidth2=_interopRequireDefault(_ETabWidth);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Tab4Style=function(_React$Component){(0,_inherits3.default)(Tab4Style,_React$Component);function Tab4Style(props){(0,_classCallCheck3.default)(this,Tab4Style);var _this=(0,_possibleConstructorReturn3.default)(this,(Tab4Style.__proto__||(0,_getPrototypeOf2.default)(Tab4Style)).call(this,props));_this.state={eShareLevel:_this.props.eShareLevel,eStyleOptions:_this.props.eStyle.eStyleList.options,eStyleSelected:_this.props.eStyle.eStyleList.selected,eIcon:_this.props.eStyle.eIcon,eHeight:_this.props.eStyle.eHeight,eSpacing:_this.props.eStyle.eSpacing};_this.getSaveValues=_this.getSaveValues.bind(_this);return _this;}(0,_createClass3.default)(Tab4Style,[{key:'render',value:function render(){var _this2=this;var _state=this.state,eShareLevel=_state.eShareLevel,eStyleOptions=_state.eStyleOptions,eStyleSelected=_state.eStyleSelected,eIcon=_state.eIcon,eHeight=_state.eHeight,eSpacing=_state.eSpacing;var _props$eContent=this.props.eContent,eContent=_props$eContent===undefined?{}:_props$eContent;var disabled=!(eShareLevel=='2');return _react2.default.createElement('div',{className:'portal-mesetting-style'},_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(22913,'元素样式'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:eStyleOptions.map(function(item){return{key:item.key,selected:false,showname:item.value};}),value:eStyleSelected,style:{width:'200px'},disabled:disabled,onChange:function onChange(value){_this2.setState({eStyleSelected:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(19492,'元素图标'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_WeaMaterialLib2.default,{value:eIcon,disabled:disabled,onChange:function onChange(value){return _this2.setState({eIcon:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(207,'高度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaInput,{value:''+eHeight,style:{width:'50px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eHeight:value});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386531,'自适应高度（0）'))),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(15932,'间距'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('span',null,getLabel(386532,'上间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.top,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{top:value})});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386533,'右间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.right,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{right:value})});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386534,'下间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.bottom,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{bottom:value})});}}),_react2.default.createElement('span',{style:{marginLeft:'8px'}},getLabel(386535,'左间距：')),_react2.default.createElement(_ecCom.WeaInput,{value:eSpacing.left,style:{width:'40px'},disabled:disabled,onChange:function onChange(value){return _this2.setState({eSpacing:(0,_extends3.default)({},eSpacing,{left:value})});}})),eContent.etabwidth&&eContent.methodvalue&&_react2.default.createElement(_ETabWidth2.default,{ref:'eTabWidth',tabwidth:eContent.etabwidth,methodvalue:eContent.methodvalue,disabled:disabled})));}},{key:'getSaveValues',value:function getSaveValues(){var _props$eContent2=this.props.eContent,eContent=_props$eContent2===undefined?{}:_props$eContent2;if(eContent.etabwidth&&eContent.methodvalue){return{eStyleList:this.state.eStyleSelected,eStyleIcon:this.state.eIcon,eStyleHeight:this.state.eHeight,eStyleSpacing:this.state.eSpacing,eContentTabWidth:this.refs['eTabWidth'].getSaveValues()};}else{return{eStyleList:this.state.eStyleSelected,eStyleIcon:this.state.eIcon,eStyleHeight:this.state.eHeight,eStyleSpacing:this.state.eSpacing};}}}]);return Tab4Style;}(_react2.default.Component);exports.default=Tab4Style;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ETabWidth=function(_React$Component){(0,_inherits3.default)(ETabWidth,_React$Component);function ETabWidth(props){(0,_classCallCheck3.default)(this,ETabWidth);var _this=(0,_possibleConstructorReturn3.default)(this,(ETabWidth.__proto__||(0,_getPrototypeOf2.default)(ETabWidth)).call(this,props));_this.state={tabwidth:_this.props.tabwidth||'76',methodvalue:_this.props.methodvalue||'2'};return _this;}(0,_createClass3.default)(ETabWidth,[{key:'getSaveValues',value:function getSaveValues(){var _state=this.state,tabwidth=_state.tabwidth,methodvalue=_state.methodvalue;var data={};if(methodvalue=='2'){data={tabwidth:'76',methodvalue:'2'};}else data={tabwidth:tabwidth,methodvalue:methodvalue};return data;}},{key:'render',value:function render(){var _this2=this;var _state2=this.state,tabwidth=_state2.tabwidth,methodvalue=_state2.methodvalue;var disabled=this.props.disabled;var options=[{key:"1",showname:getLabel(501539,'固定宽度')},{key:"2",selected:true,showname:getLabel(128975,'自适应')}];return _react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(501540,'tab页宽度'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{width:'90px',display:'inline-block',float:'left'}},_react2.default.createElement(_ecCom.WeaSelect,{options:options,value:methodvalue,onChange:function onChange(v){_this2.setState({methodvalue:v});},disabled:disabled})),methodvalue=='1'&&_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{value:tabwidth,disabled:disabled,style:{width:'54px',marginLeft:'15px'},onChange:function onChange(v){_this2.setState({tabwidth:v});}}),_react2.default.createElement('div',{style:{display:'inline-block',marginBottom:'6px',marginLeft:'15px'}},'px')));}}]);return ETabWidth;}(_react2.default.Component);exports.default=ETabWidth;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Tab4Share=function(_React$Component){(0,_inherits3.default)(Tab4Share,_React$Component);function Tab4Share(props){(0,_classCallCheck3.default)(this,Tab4Share);var _this=(0,_possibleConstructorReturn3.default)(this,(Tab4Share.__proto__||(0,_getPrototypeOf2.default)(Tab4Share)).call(this,props));_this.state={key:0,sharetype:'7',sharevalue:'',includeSub:false,seclevelmin:0,seclevelmax:100,seclevel:'0-100',rolelevel:'0',jobtitlelevel:'1',jobtitlesharevalue:'',shareTypeName:'',shareValueName:'',jobtitlesharevaluename:'',objReplaceDatas:[],jobReplaceDatas:[],selectedRowKeys:[],eHasShareRight:_this.props.eShare.eHasShareRight,eOldShareList:_this.props.eShare.eOldShareList||[],// 老版共享数据
eShareList:_this.props.eShare.eShareList||[]// 新版共享数据
};_this.getSaveValues=_this.getSaveValues.bind(_this);return _this;}(0,_createClass3.default)(Tab4Share,[{key:'render',value:function render(){var _this2=this;var eHasShareRight=this.state.eHasShareRight;if(eHasShareRight){var _state=this.state,sharetype=_state.sharetype,sharevalue=_state.sharevalue,shareValueName=_state.shareValueName,includeSub=_state.includeSub,seclevelmin=_state.seclevelmin,seclevelmax=_state.seclevelmax,rolelevel=_state.rolelevel,jobtitlelevel=_state.jobtitlelevel,jobtitlesharevalue=_state.jobtitlesharevalue,jobtitlesharevaluename=_state.jobtitlesharevaluename,objReplaceDatas=_state.objReplaceDatas,jobReplaceDatas=_state.jobReplaceDatas,selectedRowKeys=_state.selectedRowKeys;var objItemVisible=true;var seclevelItemVisible=true;var rolelevelItemVisible=false;var jobtitlelevelItemVisible=false;var objItem='';var rolelevelItem='';var jobtitlelevelItem='';if(sharetype==='3'){// 部门
objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:57,isSingle:false,title:getLabel(27511,'部门'),replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],viewAttr:3,onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});}else if(sharetype==='2'){// 分部
objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:194,isSingle:false,title:getLabel(33553,'分部'),tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],viewAttr:3,onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});}else if(sharetype==='7'){// 安全级别
objItemVisible=false;}else if(sharetype==='1'){// 人力资源
seclevelItemVisible=false;objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:17,isSingle:false,title:getLabel(179,'人力资源'),viewAttr:3,replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});}else if(sharetype==='6'){// 角色
rolelevelItemVisible=true;objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:267,quickSearchName:'rolesmark',isSingle:true,title:getLabel(122,'角色'),viewAttr:3,replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});rolelevelItem=_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'0',selected:false,showname:getLabel(27511,'部门')},{key:'1',selected:false,showname:getLabel(33553,'分部')},{key:'2',selected:false,showname:getLabel(140,'总部')}],value:rolelevel,onChange:function onChange(value){return _this2.setState({rolelevel:value});}});}else if(sharetype==='8'){// 岗位
seclevelItemVisible=false;jobtitlelevelItemVisible=true;objItem=_react2.default.createElement(_ecCom.WeaBrowser,{type:278,isSingle:false,title:getLabel(6086,'岗位'),viewAttr:3,replaceDatas:sharevalue!=''&&shareValueName!=''?[{id:sharevalue,name:shareValueName}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({sharevalue:ids,shareValueName:names});}});var jobtitlelevelObj='';if(jobtitlelevel=='2'){jobtitlelevelObj=_react2.default.createElement(_ecCom.WeaBrowser,{type:57,isSingle:false,title:getLabel(27511,'部门'),tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],viewAttr:3,replaceDatas:jobtitlesharevalue!=''&&jobtitlesharevaluename!=''?[{id:jobtitlesharevalue,name:jobtitlesharevaluename}]:[],onChange:function onChange(ids,names,datas){return _this2.setState({jobtitlesharevalue:ids,jobtitlesharevaluename:names});}});}else if(jobtitlelevel=='3'){jobtitlelevelObj=_react2.default.createElement(_ecCom.WeaBrowser,{type:194,isSingle:false,title:getLabel(33553,'分部'),tabs:[{key:'1',name:getLabel(384541,'按组织架构'),selected:false},{key:'2',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1}}],replaceDatas:jobtitlesharevalue!=''&&jobtitlesharevaluename!=''?[{id:jobtitlesharevalue,name:jobtitlesharevaluename}]:[],viewAttr:3,onChange:function onChange(ids,names,datas){return _this2.setState({jobtitlesharevalue:ids,jobtitlesharevaluename:names});}});}jobtitlelevelItem=_react2.default.createElement(_antd.Row,{gutter:16},_react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'1',selected:false,showname:getLabel(140,'总部')},{key:'2',selected:false,showname:getLabel(19438,'指定部门')},{key:'3',selected:false,showname:getLabel(19437,'指定分部')}],value:jobtitlelevel,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({jobtitlelevel:value,jobReplaceDatas:[],jobtitlesharevalue:'',jobtitlesharevaluename:''});}})),_react2.default.createElement(_antd.Col,{span:16},jobtitlelevelObj));}// 记录选中的tab数据行
var _self=this;var rowSelection={onChange:function onChange(selectedRowKeys){// if(selectedRowKeys==''){
//     $('#shareDel').css("background-color","");
// }else{
//     $('#shareDel').css("background-color","#55a1f8");
// }
_self.setState({selectedRowKeys:selectedRowKeys});}};// 表格数据源
var dataSource=this.state.eOldShareList.concat(this.state.eShareList);// 表格列
var columns=[{title:getLabel(21956,'对象类型'),dataIndex:'shareTypeName'},{title:getLabel(106,'对象'),dataIndex:'shareValueName'},{title:getLabel(683,'安全级别'),dataIndex:'securityLevel'}];return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(81711,'基本信息'),needTigger:true,showGroup:true},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21956,'对象类型'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_ecCom.WeaSelect,{options:[{key:'3',selected:false,showname:getLabel(27511,'部门')},{key:'2',selected:false,showname:getLabel(33553,'分部')},{key:'7',selected:false,showname:getLabel(1340,'所有人')},{key:'1',selected:false,showname:getLabel(179,'人力资源')},{key:'6',selected:false,showname:getLabel(122,'角色')},{key:'8',selected:false,showname:getLabel(6086,'岗位')}],value:sharetype,style:{width:'100px'},onChange:function onChange(value){return _this2.setState({sharetype:value,objReplaceDatas:[],jobReplaceDatas:[],sharevalue:'',shareValueName:'',jobtitlesharevalue:'',jobtitlesharevaluename:''});}})),objItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(106,'对象'),labelCol:{span:6},wrapperCol:{span:16}},sharetype==='3'||sharetype==='2'?_react2.default.createElement(_antd.Row,{gutter:16},_react2.default.createElement(_antd.Col,{span:16},objItem),_react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Checkbox,{checked:includeSub,onChange:function onChange(e){return _this2.setState({includeSub:e.target.checked});}},getLabel(125963,'含下级')))):objItem):'',rolelevelItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(21958,'角色级别'),labelCol:{span:6},wrapperCol:{span:16}},rolelevelItem):'',jobtitlelevelItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(28169,'岗位级别'),labelCol:{span:6},wrapperCol:{span:16}},jobtitlelevelItem):'',seclevelItemVisible?_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(683,'安全级别'),labelCol:{span:6},wrapperCol:{span:16}},_react2.default.createElement(_antd.InputNumber,{defaultValue:seclevelmin,onChange:function onChange(value){return _this2.setState({seclevelmin:value});}}),_react2.default.createElement('span',{style:{margin:'0 5px'}},'-'),_react2.default.createElement(_antd.InputNumber,{defaultValue:seclevelmax,onChange:function onChange(value){return _this2.setState({seclevelmax:value});}})):''),_react2.default.createElement(_ecCom.WeaSearchGroup,{title:getLabel(1279,'共享信息'),needTigger:true,showGroup:true,customComponent:_react2.default.createElement('div',null,_react2.default.createElement(_antd.Button,{type:'primary',className:'portal-esetting-wsg-btn',onClick:this.onAdd.bind(this)},_react2.default.createElement(_antd.Icon,{type:'plus',style:{color:'#fff'}})),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!(selectedRowKeys&&selectedRowKeys.length),id:'shareDel',className:'portal-esetting-wsg-btn',onClick:this.onDelete.bind(this)},_react2.default.createElement(_antd.Icon,{type:'minus',style:{color:'#fff'}})))},_react2.default.createElement(_ecCom.WeaTable,{rowSelection:rowSelection,columns:columns,dataSource:dataSource,pagination:false})));}else{return _react2.default.createElement('div',{style:{width:'100%',height:'50px',lineHeight:'50px',borderBottom:'1px solid #e9e9e9',textAlign:'center'}},_react2.default.createElement(_antd.Icon,{type:'exclamation-circle',style:{marginRight:'8px',color:'#fa0'}}),_react2.default.createElement('span',null,getLabel(2012,'对不起，您暂时没有权限！')));}}},{key:'onAdd',value:function onAdd(){var _state2=this.state,sharetype=_state2.sharetype,sharevalue=_state2.sharevalue,includeSub=_state2.includeSub,seclevelmin=_state2.seclevelmin,seclevelmax=_state2.seclevelmax,seclevel=_state2.seclevel,rolelevel=_state2.rolelevel,jobtitlelevel=_state2.jobtitlelevel,jobtitlesharevalue=_state2.jobtitlesharevalue;var _state3=this.state,key=_state3.key,shareTypeName=_state3.shareTypeName,shareValueName=_state3.shareValueName,jobtitlesharevaluename=_state3.jobtitlesharevaluename,eShareList=_state3.eShareList;if(sharetype!='7'&&(!sharevalue.trim()||jobtitlelevel!='1'&&!jobtitlesharevalue.trim())){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{// 部门(3)、分部(2)、所有人(7)、人力资源(1)、角色(6)、岗位(8)
shareTypeName={3:getLabel(27511,'部门'),2:getLabel(33553,'分部'),7:getLabel(1340,'所有人'),1:getLabel(179,'人力资源'),6:getLabel(122,'角色'),8:getLabel(6086,'岗位')}[sharetype];if((sharetype=='3'||sharetype=='2')&&includeSub){shareValueName+='('+getLabel(125963,'含下级')+')';}else if(sharetype=='7'){shareValueName=getLabel(1340,'所有人');}else if(sharetype=='6'){if(rolelevel==2){shareValueName+='/'+getLabel(140,'总部');}else if(rolelevel==1){shareValueName+='/'+getLabel(33553,'分部');}else if(rolelevel==0){shareValueName+='/'+getLabel(27511,'部门');}}else if(sharetype=='8'){if(jobtitlelevel==1){shareValueName+='/'+getLabel(140,'总部');}else if(jobtitlelevel==2){shareValueName+='/'+getLabel(19438,'指定部门')+'/'+jobtitlesharevaluename;}else if(jobtitlelevel==3){shareValueName+='/'+getLabel(19437,'指定分部')+'/'+jobtitlesharevaluename;}}eShareList.push({key:--key,shareType:sharetype,shareValue:sharevalue,includeSub:includeSub,roleLevel:rolelevel,securityMinLevel:seclevelmin,securityMaxLevel:seclevelmax,securityLevel:sharetype=='1'||sharetype=='8'?'':seclevelmin+'-'+seclevelmax,jobShareLevel:jobtitlelevel,jobShareValue:jobtitlesharevalue,shareTypeName:shareTypeName,shareValueName:shareValueName});this.setState({key:key,eShareList:eShareList});}}},{key:'onDelete',value:function onDelete(){var _state4=this.state,selectedRowKeys=_state4.selectedRowKeys,eOldShareList=_state4.eOldShareList,eShareList=_state4.eShareList;var isOld=false;if(selectedRowKeys&&selectedRowKeys.length){var __selectedRowKeys=selectedRowKeys.slice();for(var i=0,len=__selectedRowKeys.length;i<len;i++){selectedRowKeys.splice(i,1);for(var j=0,len2=eOldShareList.length;j<len2;j++){if(eOldShareList[j].key==__selectedRowKeys[i]){eOldShareList.splice(j,1);isOld=true;break;}}if(!isOld){for(var k=0,len3=eShareList.length;k<len3;k++){if(eShareList[k].key==__selectedRowKeys[i]){eShareList.splice(k,1);break;}}}}}this.setState({eOldShareList:eOldShareList,eShareList:eShareList});}},{key:'getSaveValues',value:function getSaveValues(){return{eOldShareList:this.state.eOldShareList,eShareList:this.state.eShareList};}}]);return Tab4Share;}(_react2.default.Component);exports.default=Tab4Share;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var ElementTemplate=function(_React$Component){(0,_inherits3.default)(ElementTemplate,_React$Component);function ElementTemplate(props){(0,_classCallCheck3.default)(this,ElementTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(ElementTemplate.__proto__||(0,_getPrototypeOf2.default)(ElementTemplate)).call(this,props));_this.state={visible:false,title:getLabel(386539,'元素模板'),templateTitle:props.templateTitle,desc:'',loading:false};_this.onShow=_this.onShow.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenus=_this.getRightMenus.bind(_this);return _this;}(0,_createClass3.default)(ElementTemplate,[{key:'onShow',value:function onShow(){this.setState({visible:true});}},{key:'onSave',value:function onSave(){this.setState({loading:true});var _props=this.props,eid=_props.eid,onSave=_props.onSave;var _state=this.state,templateTitle=_state.templateTitle,desc=_state.desc;if(!templateTitle.trim()){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(15859,'必要信息不完整！')});return;}onSave({type:'save&saveTemplate',templateTitle:templateTitle,desc:desc});}},{key:'getButtons',value:function getButtons(){var loading=this.state.loading;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{disabled:loading,type:'primary',onClick:this.onSave},getLabel(30986,'保存')));btns.push(_react2.default.createElement(_ecCom.WeaMoreButton,{datas:this.getRightMenus()}));return btns;}},{key:'getRightMenus',value:function getRightMenus(){var btns=[];btns.push({key:'1',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(30986,'保存'),onClick:this.onSave});return btns;}},{key:'render',value:function render(){var _this2=this;var _state2=this.state,visible=_state2.visible,title=_state2.title,templateTitle=_state2.templateTitle,desc=_state2.desc,loading=_state2.loading;return _react2.default.createElement(_ecCom.WeaDialog,{title:title,visible:visible,closable:true,loading:loading,onCancel:function onCancel(){return _this2.setState({visible:false});},icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:600}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenus()},_react2.default.createElement('div',{className:'portal-form-group'},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(386540,'模板标题'),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaInput,{inputType:'multilang',isBase64:true,value:templateTitle,viewAttr:3,onChange:function onChange(value){return _this2.setState({templateTitle:value});}})),_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel(433,'描述'),labelCol:{span:6},wrapperCol:{span:18}},_react2.default.createElement(_ecCom.WeaTextarea,{value:desc,minRows:4,onChange:function onChange(value){return _this2.setState({desc:value});}})))));}}]);return ElementTemplate;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ElementTemplate=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ElementTemplate);exports.default=ElementTemplate;

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabPane__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabContent__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_1__TabPane__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_2__TabContent__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__KeyCode__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabPane__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Sentinel__ = __webpack_require__(147);
















function noop() {}

function getDefaultActiveKey(props) {
  var activeKey = void 0;
  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(props.children, function (child) {
    if (child && !activeKey && !child.props.disabled) {
      activeKey = child.key;
    }
  });
  return activeKey;
}

function activeKeyIsValid(props, key) {
  var keys = __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.map(props.children, function (child) {
    return child && child.key;
  });
  return keys.indexOf(key) >= 0;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _initialiseProps.call(_this);

    var activeKey = void 0;
    if ('activeKey' in props) {
      activeKey = props.activeKey;
    } else if ('defaultActiveKey' in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    _this.state = {
      activeKey: activeKey
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: nextProps.activeKey
        });
      } else if (!activeKeyIsValid(nextProps, this.state.activeKey)) {
        // https://github.com/ant-design/ant-design/issues/7093
        this.setState({
          activeKey: getDefaultActiveKey(nextProps)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroy = true;
      __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
    }

    // Sentinel for tab index

  }, {
    key: 'updateSentinelContext',
    value: function updateSentinelContext() {
      var _this2 = this;

      if (this.destroy) return;

      __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
      this.sentinelId = __WEBPACK_IMPORTED_MODULE_10_raf___default()(function () {
        _this2.forceUpdate();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;

      var prefixCls = props.prefixCls,
          navWrapper = props.navWrapper,
          tabBarPosition = props.tabBarPosition,
          className = props.className,
          renderTabContent = props.renderTabContent,
          renderTabBar = props.renderTabBar,
          destroyInactiveTabPane = props.destroyInactiveTabPane,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane']);

      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-' + tabBarPosition, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, !!className), _classnames));

      this.tabBar = renderTabBar();

      var tabBar = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(this.tabBar, {
        prefixCls: prefixCls,
        navWrapper: navWrapper,
        key: 'tabBar',
        onKeyDown: this.onNavKeyDown,
        tabBarPosition: tabBarPosition,
        onTabClick: this.onTabClick,
        panels: props.children,
        activeKey: this.state.activeKey
      });

      var tabContent = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(renderTabContent(), {
        prefixCls: prefixCls,
        tabBarPosition: tabBarPosition,
        activeKey: this.state.activeKey,
        destroyInactiveTabPane: destroyInactiveTabPane,
        children: props.children,
        onChange: this.setActiveKey,
        key: 'tabContent'
      });

      var sentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Sentinel__["c" /* default */], {
        key: 'sentinelStart',
        setRef: this.setSentinelStart,
        nextElement: this.panelSentinelStart
      });
      var sentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Sentinel__["c" /* default */], {
        key: 'sentinelEnd',
        setRef: this.setSentinelEnd,
        prevElement: this.panelSentinelEnd
      });

      var contents = [];
      if (tabBarPosition === 'bottom') {
        contents.push(sentinelStart, tabContent, sentinelEnd, tabBar);
      } else {
        contents.push(tabBar, sentinelStart, tabContent, sentinelEnd);
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14__Sentinel__["b" /* SentinelProvider */],
        {
          value: {
            sentinelStart: this.sentinelStart,
            sentinelEnd: this.sentinelEnd,
            setPanelSentinelStart: this.setPanelSentinelStart,
            setPanelSentinelEnd: this.setPanelSentinelEnd
          }
        },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: cls,
            style: props.style
          }, Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getDataAttr */])(restProps), {
            onScroll: this.onScroll
          }),
          contents
        )
      );
    }
  }]);

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onTabClick = function (activeKey, e) {
    if (_this3.tabBar.props.onTabClick) {
      _this3.tabBar.props.onTabClick(activeKey, e);
    }
    _this3.setActiveKey(activeKey);
  };

  this.onNavKeyDown = function (e) {
    var eventKeyCode = e.keyCode;
    if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].RIGHT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].DOWN) {
      e.preventDefault();
      var nextKey = _this3.getNextActiveKey(true);
      _this3.onTabClick(nextKey);
    } else if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].LEFT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].UP) {
      e.preventDefault();
      var previousKey = _this3.getNextActiveKey(false);
      _this3.onTabClick(previousKey);
    }
  };

  this.onScroll = function (_ref) {
    var target = _ref.target,
        currentTarget = _ref.currentTarget;

    if (target === currentTarget && target.scrollLeft > 0) {
      target.scrollLeft = 0;
    }
  };

  this.setSentinelStart = function (node) {
    _this3.sentinelStart = node;
  };

  this.setSentinelEnd = function (node) {
    _this3.sentinelEnd = node;
  };

  this.setPanelSentinelStart = function (node) {
    if (node !== _this3.panelSentinelStart) {
      _this3.updateSentinelContext();
    }
    _this3.panelSentinelStart = node;
  };

  this.setPanelSentinelEnd = function (node) {
    if (node !== _this3.panelSentinelEnd) {
      _this3.updateSentinelContext();
    }
    _this3.panelSentinelEnd = node;
  };

  this.setActiveKey = function (activeKey) {
    if (_this3.state.activeKey !== activeKey) {
      if (!('activeKey' in _this3.props)) {
        _this3.setState({
          activeKey: activeKey
        });
      }
      _this3.props.onChange(activeKey);
    }
  };

  this.getNextActiveKey = function (next) {
    var activeKey = _this3.state.activeKey;
    var children = [];
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(_this3.props.children, function (c) {
      if (c && !c.props.disabled) {
        if (next) {
          children.push(c);
        } else {
          children.unshift(c);
        }
      }
    });
    var length = children.length;
    var ret = length && children[0].key;
    children.forEach(function (child, i) {
      if (child.key === activeKey) {
        if (i === length - 1) {
          ret = children[0].key;
        } else {
          ret = children[i + 1].key;
        }
      }
    });
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Tabs);


Tabs.propTypes = {
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  renderTabBar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  renderTabContent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  navWrapper: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

Tabs.defaultProps = {
  prefixCls: 'rc-tabs',
  destroyInactiveTabPane: false,
  onChange: noop,
  navWrapper: function navWrapper(arg) {
    return arg;
  },
  tabBarPosition: 'top',
  children: null,
  style: {}
};

Tabs.TabPane = __WEBPACK_IMPORTED_MODULE_12__TabPane__["a" /* default */];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(401);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(403)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(404)))

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(408);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(409);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(410);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(411);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(107);











var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          className = props.className,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin;
      var style = props.style;

      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-content', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
      if (animated) {
        var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getActiveIndex */])(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* getMarginStyle */])(activeIndex, tabBarPosition) : Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getTransformPropValue */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getTransformByIndex */])(activeIndex, tabBarPosition));
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, animatedStyle);
        } else {
          style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
            display: 'none'
          });
        }
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TabContent);


TabContent.propTypes = {
  animated: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animatedWithMargin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

TabContent.defaultProps = {
  animated: true
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(15);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(47);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabContent = function (_React$Component) {
  (0, _inherits3['default'])(TabContent, _React$Component);

  function TabContent() {
    (0, _classCallCheck3['default'])(this, TabContent);
    return (0, _possibleConstructorReturn3['default'])(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabContent, [{
    key: 'getTabPanes',
    value: function getTabPanes() {
      var props = this.props;
      var activeKey = props.activeKey;
      var children = props.children;
      var newChildren = [];

      _react2['default'].Children.forEach(children, function (child) {
        if (!child) {
          return;
        }
        var key = child.key;
        var active = activeKey === key;
        newChildren.push(_react2['default'].cloneElement(child, {
          active: active,
          destroyInactiveTabPane: props.destroyInactiveTabPane,
          rootPrefixCls: props.prefixCls
        }));
      });

      return newChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;
      var prefixCls = props.prefixCls,
          children = props.children,
          activeKey = props.activeKey,
          className = props.className,
          tabBarPosition = props.tabBarPosition,
          animated = props.animated,
          animatedWithMargin = props.animatedWithMargin;
      var style = props.style;

      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
      if (animated) {
        var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
        if (activeIndex !== -1) {
          var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition));
          style = (0, _extends3['default'])({}, style, animatedStyle);
        } else {
          style = (0, _extends3['default'])({}, style, {
            display: 'none'
          });
        }
      }
      return _react2['default'].createElement(
        'div',
        {
          className: classes,
          style: style
        },
        this.getTabPanes()
      );
    }
  }]);
  return TabContent;
}(_react2['default'].Component);

exports['default'] = TabContent;


TabContent.propTypes = {
  animated: _propTypes2['default'].bool,
  animatedWithMargin: _propTypes2['default'].bool,
  prefixCls: _propTypes2['default'].string,
  children: _propTypes2['default'].node,
  activeKey: _propTypes2['default'].string,
  style: _propTypes2['default'].any,
  tabBarPosition: _propTypes2['default'].string,
  className: _propTypes2['default'].string
};

TabContent.defaultProps = {
  animated: true
};
module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(66);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InkTabBarNode = __webpack_require__(415);

var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);

var _TabBarTabsNode = __webpack_require__(416);

var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);

var _TabBarRootNode = __webpack_require__(418);

var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);

var _ScrollableTabBarNode = __webpack_require__(419);

var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);

var _SaveRef = __webpack_require__(429);

var _SaveRef2 = _interopRequireDefault(_SaveRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ScrollableInkTabBar = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableInkTabBar, _React$Component);

  function ScrollableInkTabBar() {
    (0, _classCallCheck3['default'])(this, ScrollableInkTabBar);
    return (0, _possibleConstructorReturn3['default'])(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
  }

  (0, _createClass3['default'])(ScrollableInkTabBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          renderTabBarNode = _props.children,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['children']);


      return _react2['default'].createElement(
        _SaveRef2['default'],
        null,
        function (saveRef, getRef) {
          return _react2['default'].createElement(
            _TabBarRootNode2['default'],
            (0, _extends3['default'])({ saveRef: saveRef }, restProps),
            _react2['default'].createElement(
              _ScrollableTabBarNode2['default'],
              (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps),
              _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, renderTabBarNode: renderTabBarNode }, restProps)),
              _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps))
            )
          );
        }
      );
    }
  }]);
  return ScrollableInkTabBar;
}(_react2['default'].Component); /* eslint-disable react/prefer-stateless-function */


exports['default'] = ScrollableInkTabBar;


ScrollableInkTabBar.propTypes = {
  children: _propTypes2['default'].func
};
module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(15);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(47);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _componentDidUpdate(component, init) {
  var _component$props = component.props,
      styles = _component$props.styles,
      panels = _component$props.panels,
      activeKey = _component$props.activeKey;

  var rootNode = component.props.getRef('root');
  var wrapNode = component.props.getRef('nav') || rootNode;
  var inkBarNode = component.props.getRef('inkBar');
  var activeTab = component.props.getRef('activeTab');
  var inkBarNodeStyle = inkBarNode.style;
  var tabBarPosition = component.props.tabBarPosition;
  var activeIndex = (0, _utils.getActiveIndex)(panels, activeKey);
  if (init) {
    // prevent mount animation
    inkBarNodeStyle.display = 'none';
  }
  if (activeTab) {
    var tabNode = activeTab;
    var transformSupported = (0, _utils.isTransform3dSupported)(inkBarNodeStyle);

    // Reset current style
    (0, _utils.setTransform)(inkBarNodeStyle, '');
    inkBarNodeStyle.width = '';
    inkBarNodeStyle.height = '';
    inkBarNodeStyle.left = '';
    inkBarNodeStyle.top = '';
    inkBarNodeStyle.bottom = '';
    inkBarNodeStyle.right = '';

    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
      var left = (0, _utils.getLeft)(tabNode, wrapNode);
      var width = tabNode.offsetWidth;

      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
      // It means no css working, then ink bar should not have width until css is loaded
      // Fix https://github.com/ant-design/ant-design/issues/7564
      if (width === rootNode.offsetWidth) {
        width = 0;
      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
        width = parseFloat(styles.inkBar.width, 10);
        if (width) {
          left += (tabNode.offsetWidth - width) / 2;
        }
      }

      // use 3d gpu to optimize render
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
      } else {
        inkBarNodeStyle.left = left + 'px';
      }
      inkBarNodeStyle.width = width + 'px';
    } else {
      var top = (0, _utils.getTop)(tabNode, wrapNode, true);
      var height = tabNode.offsetHeight;
      if (styles.inkBar && styles.inkBar.height !== undefined) {
        height = parseFloat(styles.inkBar.height, 10);
        if (height) {
          top += (tabNode.offsetHeight - height) / 2;
        }
      }
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
        inkBarNodeStyle.top = '0';
      } else {
        inkBarNodeStyle.top = top + 'px';
      }
      inkBarNodeStyle.height = height + 'px';
    }
  }
  inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
}

var InkTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(InkTabBarNode, _React$Component);

  function InkTabBarNode() {
    (0, _classCallCheck3['default'])(this, InkTabBarNode);
    return (0, _possibleConstructorReturn3['default'])(this, (InkTabBarNode.__proto__ || Object.getPrototypeOf(InkTabBarNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(InkTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // ref https://github.com/ant-design/ant-design/issues/8678
      // ref https://github.com/react-component/tabs/issues/135
      // InkTabBarNode need parent/root ref for calculating position
      // since parent componentDidMount triggered after child componentDidMount
      // we're doing a quick fix here to use setTimeout to calculate position
      // after parent/root component mounted
      this.timeout = setTimeout(function () {
        _componentDidUpdate(_this2, true);
      }, 0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      _componentDidUpdate(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          styles = _props.styles,
          inkBarAnimated = _props.inkBarAnimated;

      var className = prefixCls + '-ink-bar';
      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
      return _react2['default'].createElement('div', {
        style: styles.inkBar,
        className: classes,
        key: 'inkBar',
        ref: this.props.saveRef('inkBar')
      });
    }
  }]);
  return InkTabBarNode;
}(_react2['default'].Component);

exports['default'] = InkTabBarNode;


InkTabBarNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  styles: _propTypes2['default'].object,
  inkBarAnimated: _propTypes2['default'].bool,
  saveRef: _propTypes2['default'].func
};

InkTabBarNode.defaultProps = {
  prefixCls: '',
  inkBarAnimated: true,
  styles: {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(15);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(417);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarTabsNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarTabsNode, _React$Component);

  function TabBarTabsNode() {
    (0, _classCallCheck3['default'])(this, TabBarTabsNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarTabsNode.__proto__ || Object.getPrototypeOf(TabBarTabsNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarTabsNode, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.panels,
          activeKey = _props.activeKey,
          prefixCls = _props.prefixCls,
          tabBarGutter = _props.tabBarGutter,
          saveRef = _props.saveRef,
          tabBarPosition = _props.tabBarPosition,
          renderTabBarNode = _props.renderTabBarNode;

      var rst = [];

      _react2['default'].Children.forEach(children, function (child, index) {
        if (!child) {
          return;
        }
        var key = child.key;
        var cls = activeKey === key ? prefixCls + '-tab-active' : '';
        cls += ' ' + prefixCls + '-tab';
        var events = {};
        if (child.props.disabled) {
          cls += ' ' + prefixCls + '-tab-disabled';
        } else {
          events = {
            onClick: _this2.props.onTabClick.bind(_this2, key)
          };
        }
        var ref = {};
        if (activeKey === key) {
          ref.ref = saveRef('activeTab');
        }

        var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;
        var style = (0, _defineProperty3['default'])({}, (0, _utils.isVertical)(tabBarPosition) ? 'marginBottom' : 'marginRight', gutter);
        (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');

        var node = _react2['default'].createElement(
          'div',
          (0, _extends3['default'])({
            role: 'tab',
            'aria-disabled': child.props.disabled ? 'true' : 'false',
            'aria-selected': activeKey === key ? 'true' : 'false'
          }, events, {
            className: cls,
            key: key,
            style: style
          }, ref),
          child.props.tab
        );

        if (renderTabBarNode) {
          node = renderTabBarNode(node);
        }

        rst.push(node);
      });

      return _react2['default'].createElement(
        'div',
        { ref: saveRef('navTabsContainer') },
        rst
      );
    }
  }]);
  return TabBarTabsNode;
}(_react2['default'].Component);

exports['default'] = TabBarTabsNode;


TabBarTabsNode.propTypes = {
  activeKey: _propTypes2['default'].string,
  panels: _propTypes2['default'].node,
  prefixCls: _propTypes2['default'].string,
  tabBarGutter: _propTypes2['default'].number,
  onTabClick: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func,
  renderTabBarNode: _propTypes2['default'].func,
  tabBarPosition: _propTypes2['default'].string
};

TabBarTabsNode.defaultProps = {
  panels: [],
  prefixCls: [],
  tabBarGutter: null,
  onTabClick: function onTabClick() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(15);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(66);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(47);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBarRootNode = function (_React$Component) {
  (0, _inherits3['default'])(TabBarRootNode, _React$Component);

  function TabBarRootNode() {
    (0, _classCallCheck3['default'])(this, TabBarRootNode);
    return (0, _possibleConstructorReturn3['default'])(this, (TabBarRootNode.__proto__ || Object.getPrototypeOf(TabBarRootNode)).apply(this, arguments));
  }

  (0, _createClass3['default'])(TabBarRootNode, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          onKeyDown = _props.onKeyDown,
          className = _props.className,
          extraContent = _props.extraContent,
          style = _props.style,
          tabBarPosition = _props.tabBarPosition,
          children = _props.children,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition', 'children']);

      var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
      var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
      var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
      var newChildren = children;
      if (extraContent) {
        newChildren = [(0, _react.cloneElement)(extraContent, {
          key: 'extra',
          style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
        }), (0, _react.cloneElement)(children, { key: 'content' })];
        newChildren = topOrBottom ? newChildren : newChildren.reverse();
      }
      return _react2['default'].createElement(
        'div',
        (0, _extends3['default'])({
          role: 'tablist',
          className: cls,
          tabIndex: '0',
          ref: this.props.saveRef('root'),
          onKeyDown: onKeyDown,
          style: style
        }, (0, _utils.getDataAttr)(restProps)),
        newChildren
      );
    }
  }]);
  return TabBarRootNode;
}(_react2['default'].Component);

exports['default'] = TabBarRootNode;


TabBarRootNode.propTypes = {
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  style: _propTypes2['default'].object,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  children: _propTypes2['default'].node,
  extraContent: _propTypes2['default'].node,
  onKeyDown: _propTypes2['default'].func,
  saveRef: _propTypes2['default'].func
};

TabBarRootNode.defaultProps = {
  prefixCls: '',
  className: '',
  style: {},
  tabBarPosition: 'top',
  extraContent: null,
  children: null,
  onKeyDown: function onKeyDown() {},
  saveRef: function saveRef() {}
};
module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(15);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames5 = __webpack_require__(47);

var _classnames6 = _interopRequireDefault(_classnames5);

var _debounce = __webpack_require__(420);

var _debounce2 = _interopRequireDefault(_debounce);

var _resizeObserverPolyfill = __webpack_require__(151);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _utils = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ScrollableTabBarNode = function (_React$Component) {
  (0, _inherits3['default'])(ScrollableTabBarNode, _React$Component);

  function ScrollableTabBarNode(props) {
    (0, _classCallCheck3['default'])(this, ScrollableTabBarNode);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBarNode.__proto__ || Object.getPrototypeOf(ScrollableTabBarNode)).call(this, props));

    _this.prevTransitionEnd = function (e) {
      if (e.propertyName !== 'opacity') {
        return;
      }
      var container = _this.props.getRef('container');
      _this.scrollToActiveTab({
        target: container,
        currentTarget: container
      });
    };

    _this.scrollToActiveTab = function (e) {
      var activeTab = _this.props.getRef('activeTab');
      var navWrap = _this.props.getRef('navWrap');
      if (e && e.target !== e.currentTarget || !activeTab) {
        return;
      }

      // when not scrollable or enter scrollable first time, don't emit scrolling
      var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;
      _this.lastNextPrevShown = _this.isNextPrevShown();
      if (!needToSroll) {
        return;
      }

      var activeTabWH = _this.getScrollWH(activeTab);
      var navWrapNodeWH = _this.getOffsetWH(navWrap);
      var offset = _this.offset;

      var wrapOffset = _this.getOffsetLT(navWrap);
      var activeTabOffset = _this.getOffsetLT(activeTab);
      if (wrapOffset > activeTabOffset) {
        offset += wrapOffset - activeTabOffset;
        _this.setOffset(offset);
      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
        _this.setOffset(offset);
      }
    };

    _this.prev = function (e) {
      _this.props.onPrevClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset + navWrapNodeWH);
    };

    _this.next = function (e) {
      _this.props.onNextClick(e);
      var navWrapNode = _this.props.getRef('navWrap');
      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
      var offset = _this.offset;

      _this.setOffset(offset - navWrapNodeWH);
    };

    _this.offset = 0;

    _this.state = {
      next: false,
      prev: false
    };
    return _this;
  }

  (0, _createClass3['default'])(ScrollableTabBarNode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.componentDidUpdate();
      this.debouncedResize = (0, _debounce2['default'])(function () {
        _this2.setNextPrev();
        _this2.scrollToActiveTab();
      }, 200);
      this.resizeObserver = new _resizeObserverPolyfill2['default'](this.debouncedResize);
      this.resizeObserver.observe(this.props.getRef('container'));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
        this.setOffset(0);
        return;
      }
      var nextPrev = this.setNextPrev();
      // wait next, prev show hide
      /* eslint react/no-did-update-set-state:0 */
      if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
        this.setState({}, this.scrollToActiveTab);
      } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
        // can not use props.activeKey
        this.scrollToActiveTab();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.debouncedResize && this.debouncedResize.cancel) {
        this.debouncedResize.cancel();
      }
    }
  }, {
    key: 'setNextPrev',
    value: function setNextPrev() {
      var navNode = this.props.getRef('nav');
      var navTabsContainer = this.props.getRef('navTabsContainer');
      var navNodeWH = this.getScrollWH(navTabsContainer || navNode);
      // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
      // https://github.com/ant-design/ant-design/issues/13423
      var containerWH = this.getOffsetWH(this.props.getRef('container')) + 1;
      var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
      var offset = this.offset;

      var minOffset = containerWH - navNodeWH;
      var _state = this.state,
          next = _state.next,
          prev = _state.prev;

      if (minOffset >= 0) {
        next = false;
        this.setOffset(0, false);
        offset = 0;
      } else if (minOffset < offset) {
        next = true;
      } else {
        next = false;
        // Fix https://github.com/ant-design/ant-design/issues/8861
        // Test with container offset which is stable
        // and set the offset of the nav wrap node
        var realOffset = navWrapNodeWH - navNodeWH;
        this.setOffset(realOffset, false);
        offset = realOffset;
      }

      if (offset < 0) {
        prev = true;
      } else {
        prev = false;
      }

      this.setNext(next);
      this.setPrev(prev);
      return {
        next: next,
        prev: prev
      };
    }
  }, {
    key: 'getOffsetWH',
    value: function getOffsetWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'offsetWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'offsetHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getScrollWH',
    value: function getScrollWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'scrollWidth';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'scrollHeight';
      }
      return node[prop];
    }
  }, {
    key: 'getOffsetLT',
    value: function getOffsetLT(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'left';
      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'top';
      }
      return node.getBoundingClientRect()[prop];
    }
  }, {
    key: 'setOffset',
    value: function setOffset(offset) {
      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var target = Math.min(0, offset);
      if (this.offset !== target) {
        this.offset = target;
        var navOffset = {};
        var tabBarPosition = this.props.tabBarPosition;
        var navStyle = this.props.getRef('nav').style;
        var transformSupported = (0, _utils.isTransform3dSupported)(navStyle);
        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
          if (transformSupported) {
            navOffset = {
              value: 'translate3d(0,' + target + 'px,0)'
            };
          } else {
            navOffset = {
              name: 'top',
              value: target + 'px'
            };
          }
        } else if (transformSupported) {
          navOffset = {
            value: 'translate3d(' + target + 'px,0,0)'
          };
        } else {
          navOffset = {
            name: 'left',
            value: target + 'px'
          };
        }
        if (transformSupported) {
          (0, _utils.setTransform)(navStyle, navOffset.value);
        } else {
          navStyle[navOffset.name] = navOffset.value;
        }
        if (checkNextPrev) {
          this.setNextPrev();
        }
      }
    }
  }, {
    key: 'setPrev',
    value: function setPrev(v) {
      if (this.state.prev !== v) {
        this.setState({
          prev: v
        });
      }
    }
  }, {
    key: 'setNext',
    value: function setNext(v) {
      if (this.state.next !== v) {
        this.setState({
          next: v
        });
      }
    }
  }, {
    key: 'isNextPrevShown',
    value: function isNextPrevShown(state) {
      if (state) {
        return state.next || state.prev;
      }
      return this.state.next || this.state.prev;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2, _classnames3, _classnames4;

      var _state2 = this.state,
          next = _state2.next,
          prev = _state2.prev;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          scrollAnimated = _props.scrollAnimated,
          navWrapper = _props.navWrapper,
          prevIcon = _props.prevIcon,
          nextIcon = _props.nextIcon;

      var showNextPrev = prev || next;

      var prevButton = _react2['default'].createElement(
        'span',
        {
          onClick: prev ? this.prev : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
          onTransitionEnd: this.prevTransitionEnd
        },
        prevIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
      );

      var nextButton = _react2['default'].createElement(
        'span',
        {
          onClick: next ? this.next : null,
          unselectable: 'unselectable',
          className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
        },
        nextIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
      );

      var navClassName = prefixCls + '-nav';
      var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));

      return _react2['default'].createElement(
        'div',
        {
          className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
          key: 'container',
          ref: this.props.saveRef('container')
        },
        prevButton,
        nextButton,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') },
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-nav-scroll' },
            _react2['default'].createElement(
              'div',
              { className: navClasses, ref: this.props.saveRef('nav') },
              navWrapper(this.props.children)
            )
          )
        )
      );
    }
  }]);
  return ScrollableTabBarNode;
}(_react2['default'].Component);

exports['default'] = ScrollableTabBarNode;


ScrollableTabBarNode.propTypes = {
  activeKey: _propTypes2['default'].string,
  getRef: _propTypes2['default'].func.isRequired,
  saveRef: _propTypes2['default'].func.isRequired,
  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
  prefixCls: _propTypes2['default'].string,
  scrollAnimated: _propTypes2['default'].bool,
  onPrevClick: _propTypes2['default'].func,
  onNextClick: _propTypes2['default'].func,
  navWrapper: _propTypes2['default'].func,
  children: _propTypes2['default'].node,
  prevIcon: _propTypes2['default'].node,
  nextIcon: _propTypes2['default'].node
};

ScrollableTabBarNode.defaultProps = {
  tabBarPosition: 'left',
  prefixCls: '',
  scrollAnimated: true,
  onPrevClick: function onPrevClick() {},
  onNextClick: function onNextClick() {},
  navWrapper: function navWrapper(ele) {
    return ele;
  }
};
module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(148),
    now = __webpack_require__(421),
    toNumber = __webpack_require__(423);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(149);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(148),
    isSymbol = __webpack_require__(424);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(425),
    isObjectLike = __webpack_require__(428);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(150),
    getRawTag = __webpack_require__(426),
    objectToString = __webpack_require__(427);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(150);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SaveRef = function (_React$Component) {
  (0, _inherits3['default'])(SaveRef, _React$Component);

  function SaveRef() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, SaveRef);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SaveRef.__proto__ || Object.getPrototypeOf(SaveRef)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (name) {
      return _this[name];
    }, _this.saveRef = function (name) {
      return function (node) {
        if (node) {
          _this[name] = node;
        }
      };
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(SaveRef, [{
    key: 'render',
    value: function render() {
      return this.props.children(this.saveRef, this.getRef);
    }
  }]);
  return SaveRef;
}(_react2['default'].Component);

exports['default'] = SaveRef;


SaveRef.propTypes = {
  children: _propTypes2['default'].func
};

SaveRef.defaultProps = {
  children: function children() {
    return null;
  }
};
module.exports = exports['default'];

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(432);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _common=__webpack_require__(10);var _WfCenterLogList=__webpack_require__(433);var _WfCenterLogList2=_interopRequireDefault(_WfCenterLogList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.openWfCenterLogList=_this.openWfCenterLogList.bind(_this);if(window.element_workflow_refresh&&(typeof window==='undefined'?'undefined':(0,_typeof3.default)(window))=='object'){window.element_workflow_refresh[props.config.params.eid]=_this.handleTabData.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.handleTabData.bind(_this);window.element_workflow_refresh=obj;}return _this;}(0,_createClass3.default)(EContent,[{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);this.openWfCenterLogList();try{if(window._ListenerCtrl)_ListenerCtrl.bind();}catch(e){window.console?console.log(getLabel(388033,"流程元素Ctrl绑定出错了："),e):alert(getLabel(388033,"流程元素Ctrl绑定出错了：")+e);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){try{if(window._ListenerCtrl)_ListenerCtrl.unbind();}catch(e){window.console?console.log(getLabel(388034,"流程元素Ctrl解除绑定出错了："),e):alert(getLabel(388034,"流程元素Ctrl解除绑定出错了：")+e);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(!(0,_lodash.isEqual)(this.props,nextProps)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var tabid_fr=tabid;var config=this.props.config;var _state$tabdata=this.state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata;var _tabdata=tabdata,_tabdata$tabsetting=_tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var more=tabsetting.more;var params=config.params,isremembertab=config.isremembertab;var currentTab=this.state.currentTab;if(!tabid)tabid=currentTab;tabdata=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)==null?{}:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);// if(!tabid_fr){ // 点击流程列表标题时
//     if(tabdata){
//         if(more) {
//             let arr = more.split(',');
//             let pass = false;
//             //判断是否是待办
//             for(let i = 0; i<arr.length; i++){
//                 if(arr[i] == "\"viewType\":\"1\""){
//                     pass = true;
//                     break;
//                 }
//             }
//             if(!pass) return;
//         }
//     }
// }
this.setState({refresh:tabid!==currentTab,currentTab:tabid,tabdata:tabdata});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=tabdata;ls.set('edata-'+params.eid,edata);}}_ecCom.WeaTools.callApi('/api/portal/element/workflowtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var _edata=ls.getJSONObj('edata-'+params.eid);if(_edata){_edata.currenttab=tabid;_edata.data=result;ls.set('edata-'+params.eid,_edata);}}}});}},{key:'openWfCenterLogList',value:function openWfCenterLogList(params){this.refs.wfCenterLogList.signviewPoistion(params);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,_state$tabdata2=_state.tabdata,tabdata=_state$tabdata2===undefined?{}:_state$tabdata2,currentTab=_state.currentTab,refresh=_state.refresh;var _tabdata$tabsetting2=tabdata.tabsetting,tabsetting=_tabdata$tabsetting2===undefined?{}:_tabdata$tabsetting2;var tabids=edata.tabids,titles=edata.titles,counts=edata.counts,viewtypes=edata.viewtypes,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var more="{}";var currCount="";if(tabdata&&tabdata.data){for(var i=0;i<tabids.length;i++){currCount=tabsetting.count;if(currCount){var cc=parseInt(currCount);if(cc>99){currCount=99;}if(tabids[i]===currentTab){counts[i]=currCount;}}}more=tabsetting.more;var list=tabdata.data.map(function(item,index){return(0,_extends3.default)({key:index},item);});contentHtml=_react2.default.createElement(_MarqueeCom2.default,{tabdata:tabdata,eid:eid,scolltype:tabdata.tabsetting.scrollDirection},_react2.default.createElement('div',{className:'portal_element_workflow'},_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(list[0],esetting,this.openWfCenterLogList),showHeader:false,pagination:false,dataSource:list})));}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,counts:counts,more:more,currCount:currCount,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml),_react2.default.createElement(_WfCenterLogList2.default,{eid:eid,tabid:currentTab,refresh:refresh,more:more,ref:'wfCenterLogList'})));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;// WEBPACK FOOTER //
// ./pc/portal_fs/elements/components/workflow/EContent.js

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'setMoreHref',value:function setMoreHref(){//urger: 是否督办
var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&eid="+eid+"&tabid="+currentTab,urger:false};}else{window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&eid="+eid+"&tabid="+currentTab,urger:true};}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var _props4=this.props,currentTab=_props4.currentTab,_props4$config=_props4.config,config=_props4$config===undefined?{}:_props4$config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,_props4$counts=_props4.counts,counts=_props4$counts===undefined?[]:_props4$counts,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _isEqual=__webpack_require__(434);var _isEqual2=_interopRequireDefault(_isEqual);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadjs=window.loadjs;var WfCenterLogList=function(_React$Component){(0,_inherits3.default)(WfCenterLogList,_React$Component);function WfCenterLogList(props){(0,_classCallCheck3.default)(this,WfCenterLogList);var _this=(0,_possibleConstructorReturn3.default)(this,(WfCenterLogList.__proto__||(0,_getPrototypeOf2.default)(WfCenterLogList)).call(this,props));_this.state={hasLoad:false,store:null,visiable:false,requestid:''};_this.signviewPoistion=_this.signviewPoistion.bind(_this);_this.onCancel=_this.onCancel.bind(_this);return _this;}(0,_createClass3.default)(WfCenterLogList,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props=this.props,eid=_props.eid,tabid=_props.tabid,refresh=_props.refresh;if(nextProps.tabid!==tabid||refresh!==nextProps.refresh){}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_isEqual2.default)(this.state,nextState)||!(0,_isEqual2.default)(this.props,nextProps);}},{key:'signviewPoistion',value:function signviewPoistion(value){var _this2=this;if(value){var init=function init(){var _props2=_this2.props,_props2$requestid=_props2.requestid,requestid=_props2$requestid===undefined?-1:_props2$requestid,_props2$visible=_props2.visible,visible=_props2$visible===undefined?false:_props2$visible;var WfCenterLogListStore=window.weaWorkflowPublic.WfCenterLogListStore;var store=new WfCenterLogListStore();_this2.setState({hasLoad:true,store:store});};loadjs.isDefined('workflowPublic')?loadjs.ready('workflowPublic',init):loadjs(["/spa/workflow/static4public/index.js","/spa/workflow/static4public/index.css"],'workflowPublic',init);}this.setState({visiable:true,requestid:value});}},{key:'onCancel',value:function onCancel(v){this.setState({visiable:false,requestid:-1});window.element_workflow_reLoad();}},{key:'render',value:function render(){var _this3=this;var _state=this.state,hasLoad=_state.hasLoad,store=_state.store,visiable=_state.visiable,requestid=_state.requestid;var more=this.props.more;if(hasLoad){var _WfCenterLogList=window.weaWorkflowPublic.WfCenterLogList;if(visiable&&requestid>-1){if(more&&JSON.parse(more).viewType!="6"){store.init({requestid:requestid},visiable);}else{store.init({requestid:requestid,urger:1},visiable);}}return _react2.default.createElement(_WfCenterLogList,{onCancel:function onCancel(v){return _this3.onCancel(v);},wfCenterLogListStore:store});}else{return _react2.default.createElement('div',null);}}}]);return WfCenterLogList;}(_react2.default.Component);exports.default=WfCenterLogList;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(435);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(436),
    isObjectLike = __webpack_require__(86);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(437),
    equalArrays = __webpack_require__(158),
    equalByTag = __webpack_require__(471),
    equalObjects = __webpack_require__(475),
    getTag = __webpack_require__(497),
    isArray = __webpack_require__(110),
    isBuffer = __webpack_require__(159),
    isTypedArray = __webpack_require__(160);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81),
    stackClear = __webpack_require__(443),
    stackDelete = __webpack_require__(444),
    stackGet = __webpack_require__(445),
    stackHas = __webpack_require__(446),
    stackSet = __webpack_require__(447);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81),
    Map = __webpack_require__(108),
    MapCache = __webpack_require__(157);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(153),
    isMasked = __webpack_require__(451),
    isObject = __webpack_require__(155),
    toSource = __webpack_require__(156);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(109);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(452);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(38);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(455),
    ListCache = __webpack_require__(81),
    Map = __webpack_require__(108);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(456),
    hashDelete = __webpack_require__(457),
    hashGet = __webpack_require__(458),
    hashHas = __webpack_require__(459),
    hashSet = __webpack_require__(460);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 462 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(157),
    setCacheAdd = __webpack_require__(467),
    setCacheHas = __webpack_require__(468);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 469 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 470 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(109),
    Uint8Array = __webpack_require__(472),
    eq = __webpack_require__(152),
    equalArrays = __webpack_require__(158),
    mapToArray = __webpack_require__(473),
    setToArray = __webpack_require__(474);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(38);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 474 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(476);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(477),
    getSymbols = __webpack_require__(479),
    keys = __webpack_require__(482);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(478),
    isArray = __webpack_require__(110);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(480),
    stubArray = __webpack_require__(481);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(483),
    baseKeys = __webpack_require__(492),
    isArrayLike = __webpack_require__(496);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(484),
    isArguments = __webpack_require__(485),
    isArray = __webpack_require__(110),
    isBuffer = __webpack_require__(159),
    isIndex = __webpack_require__(488),
    isTypedArray = __webpack_require__(160);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 484 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(486),
    isObjectLike = __webpack_require__(86);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(83),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(83),
    isLength = __webpack_require__(161),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(154);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)(module)))

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(493),
    nativeKeys = __webpack_require__(494);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(495);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(153),
    isLength = __webpack_require__(161);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(498),
    Map = __webpack_require__(108),
    Promise = __webpack_require__(499),
    Set = __webpack_require__(500),
    WeakMap = __webpack_require__(501),
    baseGetTag = __webpack_require__(83),
    toSource = __webpack_require__(156);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(54),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(54),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(54),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(54),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _CalendarTemplate=__webpack_require__(503);var _CalendarTemplate2=_interopRequireDefault(_CalendarTemplate);__webpack_require__(504);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MyCalendar=function(_React$Component){(0,_inherits3.default)(MyCalendar,_React$Component);function MyCalendar(props){(0,_classCallCheck3.default)(this,MyCalendar);var _this=(0,_possibleConstructorReturn3.default)(this,(MyCalendar.__proto__||(0,_getPrototypeOf2.default)(MyCalendar)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MyCalendar,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/workplan/calendar/MyCalendar','POST',{viewType:'3',selectDate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd")}).then(function(data){ls.set('edata-'+eid,data);_this2.setState({edata:data,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params,layoutid=config.layoutid;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_CalendarTemplate2.default,(0,_defineProperty3.default)({eid:eid,data:edata,hpid:params.hpid,layoutid:layoutid,subCompanyId:params.subCompanyId},'eid',eid));}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return MyCalendar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MyCalendar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MyCalendar);exports.default=MyCalendar;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//日历日程元素
var CalendarTemplate=function(_React$Component){(0,_inherits3.default)(CalendarTemplate,_React$Component);function CalendarTemplate(props){(0,_classCallCheck3.default)(this,CalendarTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(CalendarTemplate.__proto__||(0,_getPrototypeOf2.default)(CalendarTemplate)).call(this,props));var _date=new Date();_this.state={weaWorkplanLoaded:false,refresh:false,data:props.data,workplanData:[],createVisible:false,createType:'create',workPlanId:'',currentDate:(0,_common.formatDate)(_date,"yyyy-MM-dd"),currentMonth:(0,_common.formatDate)(_date,"yyyy-MM"),activeKey:'1',type:'month',selectYear:(0,_common.formatDate)(_date,"yyyy")};_this.doAdd=_this.doAdd.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.onClickData=_this.onClickData.bind(_this);_this.dateCellRender=_this.dateCellRender.bind(_this);_this.monthCellRender=_this.monthCellRender.bind(_this);_this.clickCalendarMonth=_this.clickCalendarMonth.bind(_this);_this.getWorkplanData=_this.getWorkplanData.bind(_this);// if(window.window_clickCalendarDay){
//      window.window_clickCalendarDay['fn'+props.eid] = this.clickCalendarDay.bind(this);
// }else{
//     let obj = {};
//     obj['fn'+props.eid] = this.clickCalendarDay.bind(this);
//     window.window_clickCalendarDay = obj;
// }
_this.clickCalendarDay=_this.clickCalendarDay.bind(_this);return _this;}(0,_createClass3.default)(CalendarTemplate,[{key:'onPanelChange',value:function onPanelChange(value,type){var _this2=this;var selectYear=(0,_common.formatDate)(new Date(),"yyyy");if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))=='object'){selectYear=value.fields[1];}this.setState({type:type,selectYear:selectYear});var _props=this.props,eid=_props.eid,hpid=_props.hpid,subCompanyId=_props.subCompanyId;var selectdate="";if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))==='object'){var year=value.getYear();var month=value.getMonth()+1<10?'0'+(value.getMonth()+1):value.getMonth()+1;var currentMonth=year+'-'+month;selectdate=year+'-'+month+'-01';var _month=(0,_common.formatDate)(new Date(),"yyyy-MM");if(selectdate===_month+"-01"){this.setState({currentDate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),currentMonth:_month});}else{this.setState({currentDate:selectdate,currentMonth:year+'-'+month});}}else{selectdate=value;this.setState({currentDate:selectdate});}_ecCom.WeaTools.callApi('/api/workplan/calendar/MyCalendar','POST',{viewType:'3',selectDate:selectdate}).then(function(data){$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");$("#calendar_"+eid).find(".ant-fullcalendar-event").removeClass("ant-fullcalendar-event");$("#calendar_"+eid).find(".ant-fullcalendar-event-old").removeClass("ant-fullcalendar-event-old");ls.set('edata-'+eid,data);_this2.setState({data:data,refresh:false});});}},{key:'componentWillMount',value:function componentWillMount(){var _this3=this;// 异步加载日程模块静态资源
eventRegister.loadModule('f_workplan',function(){_this3.setState({weaWorkplanLoaded:true});},function(){});}},{key:'componentDidMount',value:function componentDidMount(){// $("#calendar_" + this.props.eid + " .ant-fullcalendar-cell").attr("onclick", "window_clickCalendarDay['fn"+this.props.eid+"'](this)");
this.getWorkplanData(new Date());}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){// if(nextState.type == 'month' && this.state.type == 'year'){
//     this.setState( {type: nextState.type},() => {$("#calendar_" + this.props.eid + " .ant-fullcalendar-cell").attr("onclick", "window_clickCalendarDay['fn"+this.props.eid+"'](this)")})
// }else if(nextState.type == 'year' && this.state.type == 'month'){
//     this.setState( {type: nextState.type},() => {$("#calendar_" + this.props.eid + " .ant-fullcalendar-month-panel-cell").attr("onclick", "window_clickCalendarDay['fn"+this.props.eid+"'](this)")})
// }
if(nextState.type=='month'&&this.state.type=='year'){this.setState({type:nextState.type});}else if(nextState.type=='year'&&this.state.type=='month'){this.setState({type:nextState.type});}return true;}},{key:'doAdd',value:function doAdd(){this.setState({createVisible:true,createType:'create'});}},{key:'onClose',value:function onClose(){this.onPanelChange(this.state.currentDate);this.setState({createVisible:false,activeKey:'1'});this.getWorkplanData(this.state.currentDate);}},{key:'onClickData',value:function onClickData(id){this.setState({createVisible:true,createType:'preview',workPlanId:id});}},{key:'getWorkplanData',value:function getWorkplanData(currentDate){var _this4=this;_ecCom.WeaTools.callApi('/api/workplan/calendar/MyCalendar','POST',{viewType:'1',isCalendar:0,ismobile:1,selectDate:(0,_common.formatDate)(new Date(currentDate),"yyyy-MM-dd")}).then(function(data){_this4.setState({workplanData:data});});}},{key:'render',value:function render(){var _this5=this;var _props2=this.props,eid=_props2.eid,layoutid=_props2.layoutid;var _state=this.state,weaWorkplanLoaded=_state.weaWorkplanLoaded,type=_state.type,createVisible=_state.createVisible,createType=_state.createType,currentDate=_state.currentDate,workPlanId=_state.workPlanId,activeKey=_state.activeKey,data=_state.data,workplanData=_state.workplanData;var createConditionParams=['','',currentDate,(0,_common.formatDate)(new Date(),"hh:mm"),currentDate,'23:59','0'];return _react2.default.createElement('div',{id:'calendar_'+eid},_react2.default.createElement(_antd.Calendar,{onSelect:this.clickCalendarDay,fullscreen:false,onPanelChange:this.onPanelChange.bind(this),monthCellRender:this.monthCellRender(eid),value:new Date(currentDate),dateCellRender:this.dateCellRender.bind(this,eid,data)}),_react2.default.createElement(CalendarData,{workplanData:workplanData,data:data,type:type,currentDate:currentDate,handleClick:this.onClickData}),_react2.default.createElement('div',{className:'portal-element-calender-add'},_react2.default.createElement(_antd.Icon,{type:'plus-circle-o',title:getLabel(611,'添加'),onClick:this.doAdd})),weaWorkplanLoaded&&window.weaWorkplan&&window.weaWorkplan.com?_react2.default.createElement(window.weaWorkplan.com.WorkPlanCreate,{isCustom:parseInt(layoutid)>5,type:createType//新建为'create',查看为'preview',编辑edit,共享share
,visible:createVisible//显隐受控
,doClose:this.onClose//关闭回调
,onlyClose:function onlyClose(){return _this5.setState({createVisible:false,activeKey:'1'});}//关闭回调
,workPlanId:workPlanId//日程id，查看日程时用到
,createConditionParams:createConditionParams//创建的默认值日期和时间,没有传[]
,activeKey:activeKey//查看页面显示的面板1是基本信息，7是相关交流
,changeTab:function changeTab(value){return _this5.setState({activeKey:value});}//查看页面切换面板的回调
,selectUser:''//新建日程的创建人id
}):'');}},{key:'dateCellRender',value:function dateCellRender(eid,data,value){var currentDate=this.state.currentDate;var dataStr1=(0,_common.formatDate)(new Date(value.time),'yyyy-M-d');var dateStr=(0,_common.formatDate)(new Date(value.time),'yyyy-MM-dd');var events=data.events;var timer=setTimeout(function(){events.map(function(arr){var startDate=(0,_common.formatDate)(new Date(arr[2]),'yyyy-MM-dd');var endDate=(0,_common.formatDate)(new Date(arr[3]),'yyyy-MM-dd');if(dateStr>=startDate&&dateStr<=endDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-event");}});if(dateStr===currentDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-current");}clearTimeout(timer);},100);}},{key:'monthCellRender',value:function monthCellRender(eid){$("#calendar_"+eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}},{key:'clickCalendarDay',value:function clickCalendarDay(obj){var eid=this.props.eid;var _state2=this.state,currentDate=_state2.currentDate,currentMonth=_state2.currentMonth,type=_state2.type;if(type=='year'){this.clickCalendarMonth(obj);return;}$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");var title=(0,_common.formatDate)(new Date(obj.time),"yyyy-MM-dd");var ndate="";var currentMonthStr="";if(title){var titlearr=title.split("-");ndate=titlearr[0];currentMonthStr=titlearr[0];ndate=ndate+"-"+titlearr[1];currentMonthStr=currentMonthStr+"-"+titlearr[1];ndate=ndate+"-"+titlearr[2];}if(ndate){this.setState({currentDate:ndate});}this.getWorkplanData(ndate);//判断点击的是否为当前显示月份，否的话刷新新月份的日历日程，并默认选中所点击的日期
if(currentMonthStr!==currentMonth){this.setState({currentMonth:currentMonthStr});this.onPanelChange(this.state.currentDate,"month");}}},{key:'clickCalendarMonth',value:function clickCalendarMonth(obj){var _this6=this;var eid=this.props.eid;var selectYear=this.state.selectYear;var dateStr=(0,_common.formatDate)(new Date(),'MM');var date=(0,_common.formatDate)(new Date(obj.time),"MM");var _state3=this.state,currentDate=_state3.currentDate,currentMonth=_state3.currentMonth;var monthMatch={"01":getLabel("25825","1月"),"02":getLabel("25826","2月"),"03":getLabel("25827","3月"),"04":getLabel("25828","4月"),"05":getLabel("25829","5月"),"06":getLabel("25830","6月"),"07":getLabel("25831","7月"),"08":getLabel("25832","8月"),"09":getLabel("25833","9月"),"10":getLabel("25834","10月"),"11":getLabel("25835","11月"),"12":getLabel("25836","12月")};var x=Math.ceil(dateStr/3);var y=dateStr-(x-1)*3;var a=Math.ceil(date/3);var b=date-(a-1)*3;if(monthMatch[dateStr].trim()!==date+'月'){// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").addClass("ant-fullcalendar-month-panel-current-cell");
$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).addClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[a-1].children[b-1]).find('div')[0]).find(".ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}else{$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});// $("#calendar_" + eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");
$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).removeClass("ant-fullcalendar-month-panel-current-cell");// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").removeClass("ant-fullcalendar-month-panel-current-cell");
$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}var selectMonth='';for(var key in monthMatch){if(monthMatch[key]==date+'月'){selectMonth=key;break;}}var firstDay=(0,_common.formatDate)(new Date(selectYear,selectMonth-1,1),"yyyy-MM-dd");//这个月的第一天
_ecCom.WeaTools.callApi('/api/workplan/calendar/MyCalendar','POST',{viewType:'3',selectDate:firstDay}).then(function(data){ls.set('edata-'+eid,data);_this6.setState({data:data,refresh:false});});}}]);return CalendarTemplate;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CalendarTemplate=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CalendarTemplate);exports.default=CalendarTemplate;var CalendarData=function(_React$Component3){(0,_inherits3.default)(CalendarData,_React$Component3);function CalendarData(){(0,_classCallCheck3.default)(this,CalendarData);return(0,_possibleConstructorReturn3.default)(this,(CalendarData.__proto__||(0,_getPrototypeOf2.default)(CalendarData)).apply(this,arguments));}(0,_createClass3.default)(CalendarData,[{key:'tc',value:function tc(d){function zc(c,i){var d="666666888888aaaaaabbbbbbdddddda32929cc3333d96666e69999f0c2c2b1365fdd4477e67399eea2bbf5c7d67a367a994499b373b3cca2cce1c7e15229a36633cc8c66d9b399e6d1c2f029527a336699668cb399b3ccc2d1e12952a33366cc668cd999b3e6c2d1f01b887a22aa9959bfb391d5ccbde6e128754e32926265ad8999c9b1c2dfd00d78131096184cb05288cb8cb8e0ba52880066aa008cbf40b3d580d1e6b388880eaaaa11bfbf4dd5d588e6e6b8ab8b00d6ae00e0c240ebd780f3e7b3be6d00ee8800f2a640f7c480fadcb3b1440edd5511e6804deeaa88f5ccb8865a5aa87070be9494d4b8b8e5d4d47057708c6d8ca992a9c6b6c6ddd3dd4e5d6c6274878997a5b1bac3d0d6db5a69867083a894a2beb8c1d4d4dae54a716c5c8d8785aaa5aec6c3cedddb6e6e41898951a7a77dc4c4a8dcdccb8d6f47b08b59c4a883d8c5ace7dcce";return"#"+d.substring(c*30+i*6,c*30+(i+1)*6);}var c=d!=null&&d!=undefined?d:option.theme;return[zc(c,0),zc(c,1),zc(c,2),zc(c,3)];}},{key:'render',value:function render(){var _this9=this;var _props3=this.props,data=_props3.data,currentDate=_props3.currentDate,handleClick=_props3.handleClick,eid=_props3.eid,_props3$type=_props3.type,type=_props3$type===undefined?'month':_props3$type,workplanData=_props3.workplanData;var mobileEvents=workplanData.mobileEvents,start=workplanData.start;var events=data.events;var index=0;var color='#a32929';if(mobileEvents&&mobileEvents.length){if(type=='month'){var datas=[];var html=mobileEvents.map(function(arr){if(arr[7])color=_this9.tc(arr[7])[2];if(arr.color)color=_this9.tc(arr.color)[2];// let sdate = new Date(arr[2]);
// let edate = new Date(arr[3]);
var startStr=(0,_common.formatDate)(new Date(arr.beginDate),"yyyy-MM-dd");var endStr=(0,_common.formatDate)(new Date(arr.endDate),"yyyy-MM-dd");var id=arr.id;var name=arr.planName;var stime=arr.beginTime;var ss="";if(!isNaN(parseInt(stime))){ss=parseInt(stime)>=12?'PM':'AM';}if(currentDate>=startStr&&currentDate<=endStr){index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this9,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:color}}),_react2.default.createElement('div',{className:'dataEvent2'},_react2.default.createElement('div',{className:'dataEvent2_1'},stime,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));}});var height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html))));}else{var hasEvent=false;var _html=events.map(function(arr){var sdate=new Date(arr[2]);var id=arr[0];var name=arr[1];var mdata=(0,_common.formatDate)(sdate,'MM-dd  hh:mm');var ss=parseInt((0,_common.formatDate)(sdate,'hh'))>=12?'PM':'AM';hasEvent=true;index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this9,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:'#a32929'}}),_react2.default.createElement('div',{className:'dataEvent2',style:{width:'111px'}},_react2.default.createElement('div',{className:'dataEvent2_1'},mdata,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));});var _height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html))));}}return _react2.default.createElement('div',null);}}]);return CalendarData;}(_react2.default.Component);

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(506);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Rss=function(_React$Component){(0,_inherits3.default)(Rss,_React$Component);function Rss(props){(0,_classCallCheck3.default)(this,Rss);var _this=(0,_possibleConstructorReturn3.default)(this,(Rss.__proto__||(0,_getPrototypeOf2.default)(Rss)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Rss,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/rss','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);window.elements_more_params[eid]={isRouteUrl:true,tabid:result.currenttab||''};_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Rss;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Rss=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Rss);exports.default=Rss;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(507);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/rsstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});window.elements_more_params[params.eid]={isRouteUrl:true,tabid:tabid};if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);if(tabdata){if(tabdata.data&&tabdata.data.length){contentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.data[0],esetting),showHeader:false,pagination:false,dataSource:tabdata.data,size:'small'});}else{contentHtml=_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,' ',_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));}var tabsetting=tabdata.tabsetting;var isIE=tabsetting.isIE,readType=tabsetting.readType,mess=tabsetting.mess;if(readType=='1'&&isIE!='true')contentHtml=_react2.default.createElement('div',null,'\xA0\xA0',mess);}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(509);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//元素组件
var CustomPage=function(_React$Component){(0,_inherits3.default)(CustomPage,_React$Component);function CustomPage(props){(0,_classCallCheck3.default)(this,CustomPage);var _this=(0,_possibleConstructorReturn3.default)(this,(CustomPage.__proto__||(0,_getPrototypeOf2.default)(CustomPage)).call(this,props));_this.state={edata:null};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(CustomPage,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});}},{key:'handleRefresh',value:function handleRefresh(){this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;if(this.refs.econtent){this.refs.econtent.handleRefresh(true);}_ecCom.WeaTools.callApi(api||'/api/portal/element/custompage','POST',(0,_extends3.default)({},params)).then(function(result){if(_this2.refs.econtent){_this2.refs.econtent.handleRefresh(false);}if(result.data){window.elements_more_params[eid]={isRouteUrl:true,moreurl:result.data.moreUrl};}if(!(0,_lodash.isEqual)(_this2.state.edata,result)){_this2.setState({edata:result});}});}},{key:'componentWillMount',value:function componentWillMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,_item$contentview=item.contentview,contentview=_item$contentview===undefined?{}:_item$contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){var requestid='-1';if(edata.params&&edata.params.requestid){requestid=edata.params.requestid;}if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{ref:'econtent',onRef:this.onRef,requestid:requestid,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},EContentHtml),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return CustomPage;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomPage=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomPage);exports.default=CustomPage;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(510);var _Title2=_interopRequireDefault(_Title);var _Iframe=__webpack_require__(511);var _Iframe2=_interopRequireDefault(_Iframe);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'handleRefresh',value:function handleRefresh(refresh){this.setState({refresh:refresh});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(this.props.edata,nextProps.edata)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({currentTab:tabid,refresh:true});_ecCom.WeaTools.callApi('/api/portal/element/custompagetab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});window.elements_more_params[params.eid]={moreurl:result.moreUrl};}});}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,requestid=_props.requestid,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var _edata$tabids=edata.tabids,tabids=_edata$tabids===undefined?[]:_edata$tabids,_edata$titles=edata.titles,titles=_edata$titles===undefined?[]:_edata$titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);if(tabdata){var contenttype=tabdata.contenttype,componentName=tabdata.componentName;if(contenttype=='1'){contentHtml=_react2.default.createElement(_Iframe2.default,{isSetting:config.isSetting,requestid:requestid,refresh:refresh,data:tabdata,eid:eid,tabid:currentTab,cstyle:contentview.style});}else if(contenttype=='2'&&componentName){try{var componentModule=tabdata.componentModule,componentProps=tabdata.componentProps;if(componentModule){contentHtml=_react2.default.createElement('div',null,window[componentModule][componentName](componentProps));}else{contentHtml=_react2.default.createElement('div',null,window[componentName](componentProps));}}catch(e){window.console?console.log(getLabel(387999,"组件异常："),e):alert(getLabel(387999,"组件异常：")+e);}}}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//自定义页面元素
var Iframe=function(_React$Component){(0,_inherits3.default)(Iframe,_React$Component);function Iframe(props){(0,_classCallCheck3.default)(this,Iframe);var _this=(0,_possibleConstructorReturn3.default)(this,(Iframe.__proto__||(0,_getPrototypeOf2.default)(Iframe)).call(this,props));_this.setFrameData=_this.setFrameData.bind(_this);_this.wirteDataToFrame=_this.wirteDataToFrame.bind(_this);return _this;}(0,_createClass3.default)(Iframe,[{key:'setFrameData',value:function setFrameData(curProps){var that=this;var eid=curProps.eid,data=curProps.data,tabid=curProps.tabid,isSetting=curProps.isSetting,requestid=curProps.requestid;$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({scrolling:"auto",noresize:"noresize",border:"0"});var ifrmUrl=data.url;if(ifrmUrl){if(ifrmUrl.indexOf("?")==-1){ifrmUrl+='?requestid='+requestid;}else{ifrmUrl+='&requestid='+requestid;}if(ifrmUrl.indexOf("http://")==0||ifrmUrl.indexOf("https://")==0||data.showtype!='2'){var srcUrl=$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr("src");if(srcUrl!=ifrmUrl){$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:ifrmUrl});}}else{$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:'about:blank'});var arr=ifrmUrl.split(".");var last=arr[arr.length-1];var index=last.indexOf("htm");var ifrmsdata=ls.getStr("custompage-"+eid+"-"+tabid);var aa=ifrmsdata?true:false;if(ifrmsdata){//解决刷新加载缓存空白的问题
that.wirteDataToFrame(ifrmsdata,eid,isSetting);//解决改变url或URL返回的内容改变时不更新的问题
$.ajax({type:"GET",url:ifrmUrl,dataType:"html",success:function success(data){//判断返回的数据是否有变化，有的话更新缓存并重新渲染
if(data!==ifrmsdata){ls.set("custompage-"+eid+"-"+tabid,data);that.wirteDataToFrame(data,eid,isSetting);}},error:function error(xhr){that.wirteDataToFrame(xhr.responseText,eid,isSetting);}});}else{$.ajax({type:"GET",url:ifrmUrl,dataType:"html",success:function success(data){if(index>=0){ls.set("custompage-"+eid+"-"+tabid,data);}that.wirteDataToFrame(data,eid,isSetting);},error:function error(xhr){that.wirteDataToFrame(xhr.responseText,eid,isSetting);}});}}}else{$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:'about:blank'});}}},{key:'wirteDataToFrame',value:function wirteDataToFrame(data,eid,isSetting){var _ifrm=$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid)[0];if(_ifrm){_ifrm.contentWindow.document.write(data);_ifrm.contentWindow.document.close();try{_ifrm.contentWindow.customPageInit();}catch(e){}}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!nextProps.refresh;}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.props.refresh){try{this.setFrameData(this.props);}catch(e){}}}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,_props$config=_props.config,config=_props$config===undefined?{}:_props$config;var layoutid=config.layoutid,areaflag=config.areaflag,subCompanyId=config.subCompanyId;if(!this.props.refresh){try{this.setFrameData(this.props);}catch(e){}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _props2=this.props,eid=_props2.eid,isSetting=_props2.isSetting;$(".homepage[data-issetting="+isSetting+"]").find("#ifrm_"+eid).attr({src:'about:blank'});}},{key:'render',value:function render(){var _props3=this.props,eid=_props3.eid,data=_props3.data,tabid=_props3.tabid,refresh=_props3.refresh,cstyle=_props3.cstyle;var html=_react2.default.createElement('iframe',{id:'ifrm_'+eid,frameBorder:'no',className:'custompageIframe',height:data.height==''?parseInt(cstyle.height)+'':data.height,src:'about:blank',style:{borderCollapse:'collapse',width:'100%',display:'block'},name:'ifrm_'+eid});return _react2.default.createElement('div',null,html);}}]);return Iframe;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Iframe=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Iframe);exports.default=Iframe;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(513);var _EContent2=_interopRequireDefault(_EContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var News=function(_React$Component){(0,_inherits3.default)(News,_React$Component);function News(props){(0,_classCallCheck3.default)(this,News);var _this=(0,_possibleConstructorReturn3.default)(this,(News.__proto__||(0,_getPrototypeOf2.default)(News)).call(this,props));_this.state={edata:null,refresh:false,color:'#939393',isShowAdd:false,canEdit:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);_this.onChangeShowAdd=_this.onChangeShowAdd.bind(_this);_this.onChangeCanEdit=_this.onChangeCanEdit.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(News,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/news','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'handleOpen',value:function handleOpen(){var edata=this.state.edata;var _edata$data=edata.data,data=_edata$data===undefined?{}:_edata$data;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'onChangeShowAdd',value:function onChangeShowAdd(value){this.setState({isShowAdd:value});}},{key:'onChangeCanEdit',value:function onChangeCanEdit(value){this.setState({canEdit:value});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting,counts=edata.counts,_edata$data2=edata.data,data=_edata$data2===undefined?{}:_edata$data2;var _data$tabsetting2=data.tabsetting,tabsetting=_data$tabsetting2===undefined?{}:_data$tabsetting2;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,counts:counts,isShowSettingShowType:tabsetting.isShowSettingShowType,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var edata_img={data:{}};if(!(0,_lodash.isEmpty)(edata)&&isHasRight){edata_img=(0,_lodash.cloneDeep)(edata);if(edata_img.data&&edata_img.data.tabsetting)edata_img.data.tabsetting.imgs=[];}var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,ref:"eContent",fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:!refresh?edata:edata_img,onChangeShowAdd:this.onChangeShowAdd,onChangeCanEdit:this.onChangeCanEdit});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeM:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',height:'100%'}},_react2.default.createElement('div',{style:{width:'auto',height:'100%',position:'relative'}},this.state.canEdit&&_react2.default.createElement('div',(0,_defineProperty3.default)({title:'\u65B0\u5EFA\u6587\u6863',style:{right:'30px',bottom:'20px',position:'absolute'},className:'portal-element-news-doc-add-icon '+(this.state.isShowAdd?'':'portal-element-news-doc-add-hidden'),onMouseOver:function onMouseOver(){_this3.setState({color:'#434343'});_this3.onChangeShowAdd(true);},onMouseLeave:function onMouseLeave(){_this3.setState({color:'#939393'});_this3.onChangeShowAdd(false);},onClick:function onClick(){_this3.refs&&_this3.refs.eContent.handleOpen();}},'style',{color:this.state.color}),_react2.default.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),edata.tabids&&edata.tabids.length>1?_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)):_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height},onMouseOver:function onMouseOver(){_this3.onChangeShowAdd(true);},onMouseLeave:function onMouseLeave(){return _this3.onChangeShowAdd(false);}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid}))));}}]);return News;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);News=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(News);exports.default=News;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(514);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _NewsType=__webpack_require__(515);var _NewsType2=_interopRequireDefault(_NewsType);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.toggleTabPage=_this.toggleTabPage.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);_this.canOnclick=_this.canOnclick.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);if(window.element_news_refresh&&(typeof window==='undefined'?'undefined':(0,_typeof3.default)(window))=='object'){window.element_news_refresh[props.config.params.eid]=_this.refreshTabData.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.refreshTabData.bind(_this);window.element_news_refresh=obj;}return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillMount',value:function componentWillMount(){this.canOnclick();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'toggleTabPage',value:function toggleTabPage(tabid){var currentTab=this.state.currentTab;this.setState({refresh:!(tabid===currentTab)});this.handleTabData(tabid);}},{key:'refreshTabData',value:function refreshTabData(){var currentTab=this.state.currentTab;this.setState({refresh:true});this.handleTabData(currentTab);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var tabdata_local=ls.getJSONObj('tabdata-'+params.eid+'-'+tabid);this.setState({currentTab:tabid,tabdata:tabdata_local==null?{}:tabdata_local});_ecCom.WeaTools.callApi('/api/portal/element/newstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'handleOpen',value:function handleOpen(){var tabdata=this.state.tabdata;var _tabdata$tabsetting=tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'canOnclick',value:function canOnclick(){var currentTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.state.currentTab;var _props=this.props,config=_props.config,edata=_props.edata,onChangeCanEdit=_props.onChangeCanEdit;var _state$tabdata=this.state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata;var data=edata.data;var eid=config.params.eid;var _tabdata$docParams=tabdata.docParams,docParams=_tabdata$docParams===undefined?{}:_tabdata$docParams;var docCatalogIds=docParams.docCatalogIds;if(docCatalogIds&&docCatalogIds.length>0){var rightArr=ls.getJSONObj('portal-doc-right');var params={ids:docCatalogIds.join()};if(rightArr==null){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);ls.set('portal-doc-right',[{eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right}]);});}else{var isHave=false;rightArr.map(function(item){if(item.eid==eid&&item.tabid==currentTab){onChangeCanEdit(item.right);isHave=true;return;}});if(!isHave){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);rightArr.push({eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right});ls.set('portal-doc-right',rightArr);});}}}else{onChangeCanEdit(false);}}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp,onChangeShowAdd=_props2.onChangeShowAdd;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var _edata$tabids=edata.tabids,tabids=_edata$tabids===undefined?[]:_edata$tabids,_edata$titles=edata.titles,titles=_edata$titles===undefined?[]:_edata$titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting,counts=edata.counts;var _tabdata$tabsetting2=tabdata.tabsetting,tabsetting=_tabdata$tabsetting2===undefined?{}:_tabdata$tabsetting2;var eid=config.params.eid;var fontStyle=config.item.fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var more='';var tabdata_img={};if(!(0,_lodash.isEmpty)(tabdata)){tabdata_img=_.cloneDeep(tabdata);tabdata_img.tabsetting.imgs=[];}if(tabdata&&tabdata.data){var currCount="";if(tabdata.data){for(var i=0;i<tabids.length;i++){currCount=tabsetting.count;if(currCount&&currCount.noReadNum){var noReadNum=parseInt(currCount.noReadNum);if(noReadNum>99){noReadNum=99;}if(tabids[i]===currentTab){counts[i].noReadNum=currCount.noReadNum;}}else if(currCount&&currCount.isHaveNoRead){var isHaveNoRead=currCount.isHaveNoRead;if(tabids[i]===currentTab){counts[i].isHaveNoRead=currCount.isHaveNoRead;}}}}more=tabsetting.more;contentHtml=_react2.default.createElement(_MarqueeCom2.default,{tabdata:!refresh?tabdata:tabdata_img,eid:eid,scolltype:tabsetting.rollDirection},_react2.default.createElement(_NewsType2.default,{contentview:contentview,eid:eid,data:!refresh?tabdata:tabdata_img,esetting:esetting}));}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,more:more,counts:counts,isShowSettingShowType:tabsetting.isShowSettingShowType,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.toggleTabPage};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,onMouseOver:function onMouseOver(){_this3.canOnclick();onChangeShowAdd(true);},style:{height:cstyle.height},onMouseLeave:function onMouseLeave(){return onChangeShowAdd(false);}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Base64=ecCom.WeaTools.Base64;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+Base64.encode(more.toString())};}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&tabid="+currentTab};}}},{key:'render',value:function render(){var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _objectAssign=__webpack_require__(37);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//文档中心元素
var NewsType=function(_React$Component){(0,_inherits3.default)(NewsType,_React$Component);function NewsType(props){(0,_classCallCheck3.default)(this,NewsType);return(0,_possibleConstructorReturn3.default)(this,(NewsType.__proto__||(0,_getPrototypeOf2.default)(NewsType)).call(this,props));}(0,_createClass3.default)(NewsType,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'render',value:function render(){var _this2=this,_ref;var _props=this.props,eid=_props.eid,_props$data=_props.data,data=_props$data===undefined?{}:_props$data,_props$esetting=_props.esetting,esetting=_props$esetting===undefined?{}:_props$esetting,canEdit=_props.canEdit,_props$contentview=_props.contentview,contentview=_props$contentview===undefined?{}:_props$contentview;var linkmode=esetting.linkmode;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting,_data$srcStyle=data.srcStyle,srcStyle=_data$srcStyle===undefined?{}:_data$srcStyle;var _tabsetting$style=tabsetting.style,dataStyle=_tabsetting$style===undefined?{}:_tabsetting$style;var _srcStyle$autoheight=srcStyle.autoheight,autoheight=_srcStyle$autoheight===undefined?'0':_srcStyle$autoheight,_srcStyle$pictureheig=srcStyle.pictureheight,pictureheight=_srcStyle$pictureheig===undefined?'108px':_srcStyle$pictureheig,_srcStyle$picturewidt=srcStyle.picturewidth,picturewidth=_srcStyle$picturewidt===undefined?'120px':_srcStyle$picturewidt;var _dataStyle$abstractCo=dataStyle.abstractColor,abstractColor=_dataStyle$abstractCo===undefined?'#797979':_dataStyle$abstractCo,_dataStyle$abstractFo=dataStyle.abstractFont,abstractFont=_dataStyle$abstractFo===undefined?'微软雅黑':_dataStyle$abstractFo,_dataStyle$abstractSi=dataStyle.abstractSize,abstractSize=_dataStyle$abstractSi===undefined?'12':_dataStyle$abstractSi,abstractstyle=dataStyle.abstractstyle,_dataStyle$abstractWe=dataStyle.abstractWeight,abstractWeight=_dataStyle$abstractWe===undefined?'0':_dataStyle$abstractWe,_dataStyle$titleColor=dataStyle.titleColor,titleColor=_dataStyle$titleColor===undefined?'#000000':_dataStyle$titleColor,_dataStyle$titleFont=dataStyle.titleFont,titleFont=_dataStyle$titleFont===undefined?'微软雅黑':_dataStyle$titleFont,_dataStyle$titleSize=dataStyle.titleSize,titleSize=_dataStyle$titleSize===undefined?'16':_dataStyle$titleSize,titlestyle=dataStyle.titlestyle,_dataStyle$titleWeigh=dataStyle.titleWeight,titleWeight=_dataStyle$titleWeigh===undefined?'0':_dataStyle$titleWeigh;var list=data.data;if(list&&list.length===0){return React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,' ',React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));}//tab设置信息
var height=tabsetting.height,width=tabsetting.width,showModeId=tabsetting.showModeId,imgs=tabsetting.imgs,_tabsetting$imgsWithD=tabsetting.imgsWithDocSubject,imgsWithDocSubject=_tabsetting$imgsWithD===undefined?[]:_tabsetting$imgsWithD;var columns=new Array();var imgStyle={width:picturewidth,height:pictureheight};var style={verticalAlign:'top',width:picturewidth,height:pictureheight};if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}var listStyle2={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1&&imgStyle.width.indexOf('px')!=-1){listStyle2={width:imgStyle.width,height:imgStyle.height};}var docHtml='';switch(parseInt(showModeId)){case 2://上图式
imgStyle['margin']='0 auto';var lHtml=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:img});}}var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{id:'news_'+eid},React.createElement('div',{style:imgStyle},imghtml),React.createElement('div',{style:{width:imgStyle.width,margin:'0 auto',paddingTop:'10px'}},item.docsubject?React.createElement('div',{style:{marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{display:'-webkit-box',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'2',WebkitBoxOrient:'vertical'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%',height:'32px'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px',width:'60px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind,undefined,undefined,'7',eid)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',bottom:'15px',float:'right',width:'calc(100% - 60px - 10px)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,lHtml);break;case 3://左图式
var html=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){img=img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{style:{overflow:'auto',overflowY:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},item.docsubject?React.createElement('div',{style:{marginTop:'10px',marginRight:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',null,React.createElement('span',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'1',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',position:'absolute',bottom:'15px',float:'right',width:'100%'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',paddingLeft:'5px',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,html);break;case 4://列表式2
var html4=null;var imghtml=null;var imghtml2=[];var j=0;var imgs_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs_new.length>1){imgs.map(function(item,i){imghtml2[j]=imgs[i];j++;});if(imghtml2.length==0){imghtml2[0]='/images/homepage/noimgdefault_wev8.jpg';}var ihtml=imghtml2.map(function(item,i){var img=imghtml2[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}// if (img.indexOf("|") !== -1) img = img.split("|")[0];
return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},ihtml));}else{var img=imgs_new[0];var x=0;imgs.map(function(item,index){if(item!='/images/homepage/noimgdefault_wev8.jpg'){x=index;}});if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[x]&&imgsWithDocSubject[x].docsubject&&imgsWithDocSubject[x].docsubject.link,style:listStyle2,eid:eid,src:img})));}}columns=(0,_common.formatData)(list[0],esetting);style['paddingTop']='6px';html4=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'}))));docHtml=React.createElement('div',null,html4);break;case 5://双列式
columns=(0,_common.formatData)(list[0],esetting);var evenData=new Array();var oddData=new Array();list.map(function(item,i){if(i%2===0){evenData.push(item);}else{oddData.push(item);}});if((0,_lodash.isEmpty)(evenData)&&(0,_lodash.isEmpty)(oddData)){docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')))));}else{docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12,order:1},!(0,_lodash.isEmpty)(evenData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:evenData,size:'small'})),React.createElement(_antd.Col,{span:12,order:2},!(0,_lodash.isEmpty)(oddData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:oddData,size:'small'}))));}break;case 6://摘要式
var html6=list.map(function(item,i){var docsubject=item.docsubject||{};var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var _img=imgs[i];if((typeof _img==='undefined'?'undefined':(0,_typeof3.default)(_img))=='object'&&_img.length>1){_img=_img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,eid:eid,src:_img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left'});return React.createElement('div',{style:{width:'100%',paddingBottom:'20px',marginBottom:'5px',borderBottom:i!==list.length-1?'1px solid #dedede':'',overflow:'hidden'}},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{verticalAlign:'middle',marginTop:'-25px',marginLeft:'5px',cursor:'pointer'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{height:'60px',lineHeight:'30px',color:'rgb(105, 104, 104)',textOverflow:'ellipsis',width:'99%',overflow:'hidden',WebkitLineClamp:'2',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)));});docHtml=React.createElement('div',null,html6);break;case 7://摘要式2
var listStyle3={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1){listStyle3={width:'100%',height:imgStyle.height};}var imghtml7=null;var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var imghtml3=[];var m=0;var imgs2_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs.length>1){imgs.map(function(item,i){imghtml3[m]=imgs[i];m++;});if(imghtml3.length==0){imghtml3=['/images/homepage/noimgdefault_wev8.jpg'];}var _ihtml=imghtml3.map(function(item,i){var img=imghtml3[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}if(img.indexOf("|")!==-1)img=img.split("|")[0];return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,style:listStyle3,eid:eid,src:img}));});imghtml7=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_ihtml));}else{var _img2=imgs2_new[0];if(!_img2)_img2='/images/homepage/noimgdefault_wev8.jpg';if(_img2.indexOf("|")!==-1)_img2=_img2.split("|")[0];imghtml7=React.createElement('div',{style:{height:'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[0]&&imgsWithDocSubject[0].docsubject&&imgsWithDocSubject[0].docsubject.link,style:listStyle3,eid:eid,src:_img2})));}}var html7=list.map(function(item,i){var docsubject=item.docsubject||{};return React.createElement('div',{style:{float:'left',paddingLeft:'10px',width:'100%',borderBottom:i!==list.length-1?'1px solid #dedede':''}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{display:'-webkit-box',maxHeight:'60px',width:'99%',lineHeight:'30px',color:'#696868',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',marginBottom:'10px'}},item.summary));});docHtml=React.createElement('div',null,React.createElement('div',{style:{width:'100%',marginBottom:'10px'}},React.createElement('div',{style:style_fs},' ',imghtml7),React.createElement('div',{style:{overflow:'hidden'}},html7)));break;case 8://头条式
var item=list[0];var docsubject=item.docsubject||{};var tableHtml='';var newList=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns=(0,_common.formatData)(list[1],esetting);tableHtml=React.createElement(_ecCom.WeaTable,{columns:_columns,showHeader:false,pagination:false,dataSource:newList.slice(1,list.length),size:'small'});}docHtml=React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:{width:'100%'}},React.createElement('div',{style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(this,docsubject.link,esetting.linkmode),style:{fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer',width:'100%'}},docsubject.name,docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject.img}):'')),React.createElement('div',{title:item.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)))),tableHtml);break;case 9://头条式2
var item2=list[0];var docsubject2=item2.docsubject||{};var tableHtml2='';var newList2=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns2=(0,_common.formatData)(list[1],esetting);tableHtml2=React.createElement(_ecCom.WeaTable,{columns:_columns2,showHeader:false,pagination:false,dataSource:newList2.slice(1,list.length),size:'small'});}var imghtml9=[];var j9=0;var imgs9_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs9_new.length>1){imgs.map(function(item,i){imghtml9[j9]=imgs[i];j9++;});if(imghtml9.length==0){imghtml9[0]='/images/homepage/noimgdefault_wev8.jpg';}var _ihtml2=imghtml9.map(function(item,i){var img=imghtml9[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}// if (img.indexOf("|") !== -1) img = img.split("|")[0];
return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[i]&&imgsWithDocSubject[i].docsubject&&imgsWithDocSubject[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_ihtml2));}else{var _img3=imgs9_new[0];if(!_img3)_img3='/images/homepage/noimgdefault_wev8.jpg';if(_img3.indexOf("|")!==-1)_img3=_img3.split("|")[0];imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[0]&&imgsWithDocSubject[0].docsubject&&imgsWithDocSubject[0].docsubject.link,style:listStyle2,eid:eid,src:_img3})));}}docHtml=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:{width:'100%'}},React.createElement('div',{style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject2.name,onClick:_common.openLinkUrl.bind(this,docsubject2.link,esetting.linkmode),style:{fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'-webkit-box',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer',width:'100%'}},docsubject2.name,docsubject2.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject2.img}):'')),React.createElement('div',{title:item2.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item2.summary)))),tableHtml2))));break;case 10://上图式2
imgStyle['margin']='0 auto';var item10=list[0];var tableHtml10='';var docsubject10=item10.docsubject||{};var newList10=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns3=(0,_common.formatData)(list[1],esetting);tableHtml10=React.createElement(_ecCom.WeaTable,{columns:_columns3,showHeader:false,pagination:false,dataSource:newList10.slice(1,list.length),size:'small'});}var imghtml10=null;if(!(0,_lodash.isEmpty)(imgs)){var _img4=imgs[0];if((typeof _img4==='undefined'?'undefined':(0,_typeof3.default)(_img4))=='object'&&_img4.length>1){imghtml10=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_img4.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[0]&&imgsWithDocSubject[0].docsubject&&imgsWithDocSubject[0].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml10=React.createElement(ImgCom,{linkmode:linkmode,link:imgsWithDocSubject[0]&&imgsWithDocSubject[0].docsubject&&imgsWithDocSubject[0].docsubject.link,eid:eid,src:_img4});}}var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{id:'news_'+eid},React.createElement('div',{style:imgStyle},imghtml10),React.createElement('div',{style:{width:imgStyle.width,margin:'0 auto',paddingTop:'10px'}},React.createElement('td',{width:'*',style:{display:'block',width:'100%'},className:'valign'},React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:{width:'100%'}},React.createElement('div',{style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject10.name,onClick:_common.openLinkUrl.bind(this,docsubject10.link,esetting.linkmode),style:(_ref={fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer',width:'calc(100% - 90px)',WebkitBoxRrient:'vertical'},(0,_defineProperty3.default)(_ref,'display','-webkit-box'),(0,_defineProperty3.default)(_ref,'float','left'),(0,_defineProperty3.default)(_ref,'wordBreak','break-all'),_ref)},docsubject10.name,docsubject10.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject10.img}):''),item10.doccreatedate&&React.createElement('div',{title:item10.doccreatedate,style:{lineHeight:'32px',display:'inline-block',overflow:'hidden',marginLeft:'10px'}},item10.doccreatedate)),React.createElement('div',{title:item10.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item10.summary)))),tableHtml10))));docHtml=React.createElement('div',null,lHtml2);break;case 1://列表式
default:columns=(0,_common.formatData)(list[0],esetting);docHtml=React.createElement(_ecCom.WeaTable,{style:{fontSize:'20px'},columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'});break;}// return <AddNewCom canEdit={this.props.canEdit} catalogIds={tabsetting.catalogIds} catalogId={tabsetting.catalogId}>{docHtml}</AddNewCom>
return docHtml;}}]);return NewsType;}(React.Component);var AddNewCom=function(_React$Component2){(0,_inherits3.default)(AddNewCom,_React$Component2);function AddNewCom(props){(0,_classCallCheck3.default)(this,AddNewCom);var _this3=(0,_possibleConstructorReturn3.default)(this,(AddNewCom.__proto__||(0,_getPrototypeOf2.default)(AddNewCom)).call(this,props));_this3.state={isShowAdd:false,color:'#939393'};_this3.handleOpen=_this3.handleOpen.bind(_this3);return _this3;}(0,_createClass3.default)(AddNewCom,[{key:'handleOpen',value:function handleOpen(){var _props2=this.props,catalogId=_props2.catalogId,catalogIds=_props2.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'render',value:function render(){var _this4=this;var _props3=this.props,children=_props3.children,canEdit=_props3.canEdit;if(canEdit){return React.createElement('div',{className:' portal-element-news-doc-add',onMouseOver:function onMouseOver(){return _this4.setState({isShowAdd:true});},onMouseLeave:function onMouseLeave(){return _this4.setState({isShowAdd:false});}},React.createElement('div',{title:'\u65B0\u5EFA\u6587\u6863',className:'portal-element-news-doc-add-icon '+(this.state.isShowAdd?'':'portal-element-news-doc-add-hidden'),onMouseOver:function onMouseOver(){return _this4.setState({color:'#434343'});},onMouseLeave:function onMouseLeave(){return _this4.setState({color:'#939393'});},onClick:this.handleOpen,style:{color:this.state.color}},React.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),children);}return React.createElement('div',null,children);}}]);return AddNewCom;}(React.Component);var ImgCom=function(_React$Component3){(0,_inherits3.default)(ImgCom,_React$Component3);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this5=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this5.aClick=_this5.aClick.bind(_this5);return _this5;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props4=this.props,_props4$link=_props4.link,link=_props4$link===undefined?'':_props4$link,_props4$linkmode=_props4.linkmode,linkmode=_props4$linkmode===undefined?'1':_props4$linkmode;if(link!=''){(0,_common.openLinkUrl)(link,linkmode);// window.open(link, linkmode);
}else return false;}},{key:'render',value:function render(){var _props5=this.props,_props5$src=_props5.src,src=_props5$src===undefined?'':_props5$src,_props5$style=_props5.style,style=_props5$style===undefined?{width:'100%',height:'100%'}:_props5$style;return React.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},React.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(React.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);NewsType=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(NewsType);exports.default=NewsType;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(517);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var ReportForm=function(_React$Component){(0,_inherits3.default)(ReportForm,_React$Component);function ReportForm(props){(0,_classCallCheck3.default)(this,ReportForm);var _this=(0,_possibleConstructorReturn3.default)(this,(ReportForm.__proto__||(0,_getPrototypeOf2.default)(ReportForm)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(ReportForm,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/reportform','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,fontSizeMp:fontSizeMp,config:config,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return ReportForm;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ReportForm=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ReportForm);exports.default=ReportForm;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(518);var _Title2=_interopRequireDefault(_Title);var _echart=__webpack_require__(128);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/reportformtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var option=void 0;var contentHtml=_react2.default.createElement('div',null);if(tabdata&&tabdata.series){option=(0,_echart.getEChartOption)(tabdata);contentHtml=_react2.default.createElement(_echart.EchartView,{eid:eid,key:currentTab,width:tabdata.width,charttype:tabdata.charttype,height:tabdata.height,option:option});}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:cstyle},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(520);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var OutData=function(_React$Component){(0,_inherits3.default)(OutData,_React$Component);function OutData(props){(0,_classCallCheck3.default)(this,OutData);var _this=(0,_possibleConstructorReturn3.default)(this,(OutData.__proto__||(0,_getPrototypeOf2.default)(OutData)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(OutData,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/outdata','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);window.elements_more_params[config.params.eid]={isRouteUrl:true,tabid:edata.currenttab||'1'};if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return OutData;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OutData=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OutData);exports.default=OutData;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _Title=__webpack_require__(521);var _Title2=_interopRequireDefault(_Title);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/outdatatab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});window.elements_more_params[params.eid]={isRouteUrl:true,tabid:tabid};}},{key:'render',value:function render(){var _props=this.props,_props$config2=_props.config,config=_props$config2===undefined?{}:_props$config2,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=tabdata&&tabdata.data.length?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.data[0],esetting),showHeader:true,pagination:false,dataSource:tabdata.data,size:'small'}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(523);var _EContent2=_interopRequireDefault(_EContent);__webpack_require__(526);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var FormModeCustomSearch=function(_React$Component){(0,_inherits3.default)(FormModeCustomSearch,_React$Component);function FormModeCustomSearch(props){(0,_classCallCheck3.default)(this,FormModeCustomSearch);var _this=(0,_possibleConstructorReturn3.default)(this,(FormModeCustomSearch.__proto__||(0,_getPrototypeOf2.default)(FormModeCustomSearch)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(FormModeCustomSearch,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/formmodecustomsearch','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);window.elements_more_params[eid]={isRouteUrl:true,morehref:result.data&&result.data.morehref,customid:result.data&&result.data.customid||''};_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.econtent.handleTabData(tabid);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{ref:function ref(e){_this3.econtent=e;},onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return FormModeCustomSearch;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FormModeCustomSearch=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FormModeCustomSearch);exports.default=FormModeCustomSearch;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(524);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _FmcsTable=__webpack_require__(525);var _FmcsTable2=_interopRequireDefault(_FmcsTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/formmodecustomsearchtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);var customid=result.customid;var morehref=result.morehref;if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});window.elements_more_params[params.eid]={isRouteUrl:true,morehref:morehref,customid:customid};if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,_state$tabdata=_state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var _tabdata$tabsetting=tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;esetting.widths=tabsetting.widths;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var rolltype='none';if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='1'){rolltype='up';}else if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='2'){rolltype='right';}else if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='3'){rolltype='down';}else if(tabdata.tabsetting&&tabdata.tabsetting.rolltype=='4'){rolltype='left';}var contentHtml=tabdata?_react2.default.createElement(_MarqueeCom2.default,{eid:eid,scolltype:rolltype},_react2.default.createElement(_FmcsTable2.default,{eid:eid,isshowtitle:tabdata.tabsetting?tabdata.tabsetting.isshowtitle:false,isPageAutoWrap:tabdata.isPageAutoWrap||'1',data:tabdata,esetting:esetting})):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var _tdStyle;var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle=(_tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',height:'32px',backgroundSize:'100% 100%'},(0,_defineProperty3.default)(_tdStyle,'height','32px'),(0,_defineProperty3.default)(_tdStyle,'marginTop','-16px'),_tdStyle);var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//建模查询中心元素
var FmcsTable=function(_React$Component){(0,_inherits3.default)(FmcsTable,_React$Component);function FmcsTable(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,FmcsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=FmcsTable.__proto__||(0,_getPrototypeOf2.default)(FmcsTable)).call.apply(_ref,[this].concat(args))),_this),_this.updateAutoWrap=function(){var isPageAutoWrap=_this.props.isPageAutoWrap;//需要某个td不受配置控制，则将对应column的className设为customWrap
var $td=jQuery(" table td:not(.wea-table-operates, .customWrap, .customWrap *)",ReactDOM.findDOMNode(_this));if(!isPageAutoWrap){$td.find('font').css('white-space','nowrap').css('word-break','keep-all');$td.find(">div").removeClass("autoWrap").addClass("noWrap");$td.find("a").removeClass("autoWrap").addClass("noWrap");$td.removeClass("autoWrap").addClass("noWrap");$td.find("a").map(function(i,a){a.title=a.innerText;});$td.find(".wea-url").map(function(i,d){d.title=d.innerText;});}else{$td.find('font').css('white-space','normal').css('word-break','normal');$td.find(">div").removeClass("noWrap").addClass("autoWrap");$td.find("a").removeClass("noWrap").addClass("autoWrap");$td.removeClass("noWrap").addClass("autoWrap");}},_this.getColumns=function(){var _this$props=_this.props,data=_this$props.data,esetting=_this$props.esetting;var imgSymbol=esetting.imgSymbol,linkmode=esetting.linkmode,widths=esetting.widths,titles=esetting.titles,ebaseid=esetting.ebaseid,_esetting$fontStyle=esetting.fontStyle,fontStyle=_esetting$fontStyle===undefined?{}:_esetting$fontStyle;var _fontStyle$contentfon=fontStyle.contentfontsize,contentfontsize=_fontStyle$contentfon===undefined?'12':_fontStyle$contentfon;var columns=new Array();var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting;var _tabsetting$alignment=tabsetting.alignmentList,alignmentList=_tabsetting$alignment===undefined?{}:_tabsetting$alignment;var _alignmentList$classn=alignmentList.classname,classname=_alignmentList$classn===undefined?[]:_alignmentList$classn;for(var i=0;i<alignmentList.length;i++){classname[i]=alignmentList[i]=='column-text-right'?'right':alignmentList[i]=='column-text-center'?'center':'left';// console.log(classname[i]);	//获取对齐方式
}//加载行小图标
if(imgSymbol){var iObj={dataIndex:'imgSymbol',key:'imgSymbol',width:ebaseid=='FormModeCustomSearch'?'1%':'8px',render:function render(){return _react2.default.createElement('img',{style:{marginBottom:'4px'},name:'esymbol',src:imgSymbol});}};columns.push(iObj);}if(!titles){return[];}var _loop=function _loop(_i){colObj=new Object();colObj={dataIndex:'value'+_i,key:'value'+_i,render:function render(text,record,index){if(text&&(typeof text==='undefined'?'undefined':(0,_typeof3.default)(text))==='object'&&text.constructor===Array){//链接字段
return _react2.default.createElement('div',{style:{textAlign:classname[_i]}},_this.loadListName(contentfontsize,text,linkmode));}else{//普通文本
if(typeof text==='string'){if(_this.isHtml(text)){//判断字符串是否含有html
return _react2.default.createElement('font',{style:{display:'block',textAlign:classname[_i]},className:text.indexOf("class='font'")==-1?'font wea-f'+contentfontsize:'wea-f'+contentfontsize,dangerouslySetInnerHTML:{__html:text}});}else{return _react2.default.createElement('font',{style:{display:'block',textAlign:classname[_i]},className:'font wea-f'+contentfontsize},text);}}else{return _react2.default.createElement('font',{style:{display:'block',textAlign:classname[_i]},className:'font wea-f'+contentfontsize});}}}};if(titles)colObj['title']=_react2.default.createElement('div',{style:{textAlign:classname[_i]}},titles[_i]);// if (titles) colObj['title'] = titles[i];
var width=colObj.dataIndex&&widths[colObj.dataIndex];if(widths[colObj.dataIndex]!=''&&widths[colObj.dataIndex]!='*'){if(width&&width.indexOf('%')==-1){width+='px';}}if(widths)colObj['width']=width;columns.push(colObj);};for(var _i=0;_i<titles.length;_i++){var colObj;_loop(_i);}return columns;},_this.loadListName=function(contentfontsize,list,linkmode){if(!list||list.length===0)return _react2.default.createElement('span',null);var html=list.map(function(obj,o){var dotstr=o===0?"":" , ";if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Object){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('font',null,dotstr,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return(0,_common.openLinkUrl)(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name)));}else if(obj&&(typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))==='object'&&obj.constructor===Array){var shtml=obj.map(function(obj,s){if(obj.userid){var ahtml="<a href='javascript:openhrm("+obj.userid+");' onclick='pointerXY(event)' title="+obj.name+"><font style='color:#000000;' class='font wea-f"+contentfontsize+"'>"+dotstr+obj.name+"</font></a>";return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:ahtml}});}return _react2.default.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return(0,_common.openLinkUrl)(obj.link,linkmode,e);},title:obj.name},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},obj.name));});return _react2.default.createElement('font',null,dotstr,shtml);}});var flag=_react2.default.createElement('span',null);if(list[0].img){flag=_react2.default.createElement('span',{style:{verticalAlign:'top',marginLeft:3}},_react2.default.createElement('img',{src:list[0].img,title:list[0].desc,complete:'complete'}));}return _react2.default.createElement('span',{className:'td-span-formmodecustomsearch'},html,flag);},_this.isHtml=function(htmlStr){if(!htmlStr)return false;var reg=/<[^>]+>/g;return reg.test(htmlStr)||htmlStr.indexOf("&")>-1;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(FmcsTable,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting,isshowtitle=_props.isshowtitle;if(data.isRight==false){return _react2.default.createElement('div',{style:{height:'40px',lineHeight:'40px',textAlign:'center'}},data.data);}var _data$tabsetting2=data.tabsetting,tabsetting=_data$tabsetting2===undefined?{}:_data$tabsetting2,_data$childrenColumnN=data.childrenColumnName,childrenColumnName=_data$childrenColumnN===undefined?'':_data$childrenColumnN,_data$treeList=data.treeList,treeList=_data$treeList===undefined?[]:_data$treeList;var list=data.data||[];var _tabsetting$widths=tabsetting.widths,widths=_tabsetting$widths===undefined?[]:_tabsetting$widths,titles=tabsetting.titles;esetting['widths']=widths;esetting['titles']=titles;var showHeader=true;var index=0;for(var k in list[0]){index+=1;}if(index===1){showHeader=false;}var html=void 0;if(childrenColumnName=='1'){html=_react2.default.createElement(_ecCom.WeaTable,{showHeader:isshowtitle=='1'?true:false,columns:treeList,pagination:false,dataSource:list,childrenColumnName:'sublist',className:'cube-list-table'});}else{html=_react2.default.createElement(_ecCom.WeaTable,{showHeader:isshowtitle=='1'?true:false,columns:this.getColumns(),pagination:false,dataSource:list,size:'small'});}return _react2.default.createElement('div',{className:'formmodesearch'},html);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateAutoWrap();}},{key:'componentDidMount',value:function componentDidMount(){this.updateAutoWrap();}//处理属性为集合的数据
}]);return FmcsTable;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FmcsTable=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FmcsTable);exports.default=FmcsTable;

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _Picture=__webpack_require__(528);var _Picture2=_interopRequireDefault(_Picture);var _Sliders=__webpack_require__(529);var _Sliders2=_interopRequireDefault(_Sliders);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Picture=function(_React$Component){(0,_inherits3.default)(Picture,_React$Component);function Picture(props){(0,_classCallCheck3.default)(this,Picture);var _this=(0,_possibleConstructorReturn3.default)(this,(Picture.__proto__||(0,_getPrototypeOf2.default)(Picture)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Picture,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/picture','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){// if(!isEmpty(edata)) EContentHtml = <PictureCom isSetting={config.isSetting} eid={eid} data={edata.data} esetting={edata.esetting}/>;
if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Sliders2.default,{isSetting:config.isSetting,eid:eid,data:edata.data,esetting:edata.esetting,height:style1.height});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view content_view_slider',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Picture;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Picture=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Picture);exports.default=Picture;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _loadjs=__webpack_require__(162);var _loadjs2=_interopRequireDefault(_loadjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//图片元素
global.globalIntervalVariable;var PictureCom=function(_React$Component){(0,_inherits3.default)(PictureCom,_React$Component);function PictureCom(props){(0,_classCallCheck3.default)(this,PictureCom);var _this=(0,_possibleConstructorReturn3.default)(this,(PictureCom.__proto__||(0,_getPrototypeOf2.default)(PictureCom)).call(this,props));_this.imageCarousel=_this.imageCarousel.bind(_this);var staticVersion='?v'+(_ecCom.WeaTools&&_ecCom.WeaTools.ls&&_ecCom.WeaTools.ls.getStr("staticVersion")||0);(0,_loadjs2.default)(['/social/js/drageasy/drageasy.js'+staticVersion,'/social/js/bootstrap/js/bootstrap.js'+staticVersion,'/social/im/js/IMUtil_wev8.js'+staticVersion,'/social/js/imcarousel/imcarousel.js'+staticVersion]);return _this;}(0,_createClass3.default)(PictureCom,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,eid=_props.eid,esetting=_props.esetting;var width=esetting.width,speed=esetting.speed,open=esetting.open;if(global.globalIntervalVariable){clearInterval(global.globalIntervalVariable);}global.globalIntervalVariable=loadPictureJs(eid,width,speed,open,"update");}},{key:'componentDidMount',value:function componentDidMount(){var _props2=this.props,eid=_props2.eid,esetting=_props2.esetting;var width=esetting.width,speed=esetting.speed,open=esetting.open;global.globalIntervalVariable=loadPictureJs(eid,width,speed,open,"mount");}//图片放大轮播
},{key:'imageCarousel',value:function imageCarousel(imgObj,e){var imgPool=[];var indexNum=0;jQuery(".portal-picture-img").each(function(){var imgsrc=!!jQuery(this).attr("data-imgsrc")?jQuery(this).attr("data-imgsrc"):jQuery(this).attr("src");imgPool.push(imgsrc);});var imgsrc=jQuery(e.target).attr("src");for(var i=0;i<imgPool.length;i++){if(imgsrc==imgPool[i]){indexNum=i;break;}}//console.log("imgPool--",imgPool,"indexNum--",indexNum);
window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);}},{key:'render',value:function render(){var _this2=this;var aStyle={cursor:'default'};var tdStyle={verticalAlign:'middle',width:'35px'};var _props3=this.props,eid=_props3.eid,data=_props3.data,esetting=_props3.esetting;var showType=esetting.showType,button=esetting.button,width=esetting.width,height=esetting.height,open=esetting.open;var cursor='default';var imgStyle={width:width+'px',height:height+'px'};var liStyle={overflow:'hidden',float:'left',width:width+'px',height:parseInt(height)+3+'px'};var html=null;if(showType==='1'){var item=data[0];var link=item.link;if(''===link){link='#';}else{cursor='pointer';}var img=_react2.default.createElement('img',{title:item.name,src:item.url,border:'0',style:imgStyle});html='1'===open?_react2.default.createElement('div',{className:'jCarouselLite'},''!==item.url?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:item.url,target:'_blank'},' ',img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img)):_react2.default.createElement('div',null,'#'!==link?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:link,target:'_blank'},img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img));}else{var btnBack=null;var btnNext=null;if('1'===button){btnBack=_react2.default.createElement('td',{style:tdStyle},_react2.default.createElement('div',{id:'pictureback_'+eid,className:'pictureback',style:{cursor:'hand'}}));btnNext=_react2.default.createElement('td',{style:tdStyle},_react2.default.createElement('div',{id:'picturenext_'+eid,className:'picturenext',style:{cursor:'hand'}}));}var liHtml=data.map(function(item,i){var link=''===item.link?'#':item.link;var img=_react2.default.createElement('img',{className:'portal-picture-img',title:item.name,src:item.url,border:'0',style:imgStyle,onClick:function onClick(e){return _this2.imageCarousel(_this2,e);}});return _react2.default.createElement('li',{style:liStyle},'1'===open?_react2.default.createElement('div',{className:'jCarouselLite'},''!==item.url?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:item.url,target:'_blank'},img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img)):_react2.default.createElement('div',null,'#'!==link?_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link,href:link,target:'_blank'},img):_react2.default.createElement('a',{className:'highslide',style:{cursor:cursor},title:item.name,'data-ref':link},img)));});html=_react2.default.createElement('table',{width:'100%',style:{borderSpacing:'0'},border:'0'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,btnBack,_react2.default.createElement('td',{id:'picturetd_'+eid,nowrap:'nowrap',style:{overflow:'hidden',textAlign:'center'}},_react2.default.createElement('div',{className:'jCarouselLite',id:'jCarouselLite_'+eid},_react2.default.createElement('ul',null,liHtml))),btnNext)));}return _react2.default.createElement('div',{id:'pictureTable_'+eid,style:{backgroundColor:'#FFFFFF',height:height,width:'100%',margin:'0px',textAlign:'center'}},html);}}]);return PictureCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);PictureCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(PictureCom);exports.default=PictureCom;function loadPictureJs(eid,picturewidth,autoShowSpeed,highopen,loadStatus){var width=$("#jCarouselLite_"+eid).parent().width();var intervalVariable;var count=parseInt(width/picturewidth);if($('#jCarouselLite_'+eid).find("ul").length>0){var auto=autoShowSpeed*50;if($('#jCarouselLite_'+eid).find("li").length<count){auto=0;count=$('#jCarouselLite_'+eid).find("li").length;var temp=$('#jCarouselLite_'+eid);var ul=$("ul",temp),tLi=$("li",ul);if(loadStatus=="update"){for(var i=-count;i<=count;i++){tLi.eq(i).remove();}}temp.jCarouselLite({btnPrev:'#pictureback_'+eid,btnNext:'#picturenext_'+eid,auto:auto,speed:1000,visible:count,scroll:1,circular:false},temp);intervalVariable=temp.getInterval();/*			$("#pictureback_" + eid).hide();
			$("#picturenext_" + eid).hide();*/$("#picturetd_"+eid).attr("align","center");var settingWidth=parseInt(count*picturewidth);$("#jCarouselLite_"+eid).width(settingWidth);}else{var temp=$('#jCarouselLite_'+eid);var ul=$("ul",temp),tLi=$("li",ul);if(loadStatus=="update"){for(var _i=-count;_i<count;_i++){tLi.eq(_i).remove();}}temp.jCarouselLite({btnPrev:'#pictureback_'+eid,btnNext:'#picturenext_'+eid,auto:auto,speed:1000,visible:count,scroll:1,circular:true},temp);intervalVariable=temp.getInterval();$("#jCarouselLite_"+eid).width(width);}}if("1"===highopen){$('#jCarouselLite_'+eid).find("a").each(function(){var $img=$(this);$($img).fancybox({wrapCSS:'fancybox-custom',closeClick:true,closeBtn:false,openEffect:'none',helpers:{title:{type:'inside'},overlay:{css:{'background':'rgba(238,238,238,0.85)'}}},afterLoad:function afterLoad(){var refstr=$($img).attr("data-ref");if($.trim(refstr)!="#"){this.title='<a href="'+refstr+'" style="color:#000000!important;text-decoration:none!important;" target="_blank">'+this.title+'</a> ';}}});});}return intervalVariable;}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _parseFloat=__webpack_require__(530);var _parseFloat2=_interopRequireDefault(_parseFloat);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactSlick=__webpack_require__(164);var _reactSlick2=_interopRequireDefault(_reactSlick);var _ecCom=__webpack_require__(5);var _loadjs=__webpack_require__(162);var _loadjs2=_interopRequireDefault(_loadjs);var _lodash=__webpack_require__(9);__webpack_require__(549);__webpack_require__(550);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import '../css/Sliders.css';
var Sliders=function(_Component){(0,_inherits3.default)(Sliders,_Component);function Sliders(){(0,_classCallCheck3.default)(this,Sliders);var _this=(0,_possibleConstructorReturn3.default)(this,(Sliders.__proto__||(0,_getPrototypeOf2.default)(Sliders)).call(this));_this.state={count:0,width:0};_this.imageCarousel=_this.imageCarousel.bind(_this);var staticVersion='?v'+(_ecCom.WeaTools&&_ecCom.WeaTools.ls&&_ecCom.WeaTools.ls.getStr("staticVersion")||0);(0,_loadjs2.default)(['/social/js/drageasy/drageasy.js'+staticVersion,'/social/js/bootstrap/js/bootstrap.js'+staticVersion,'/social/im/js/IMUtil_wev8.js'+staticVersion,'/social/js/imcarousel/imcarousel.js'+staticVersion]);return _this;}//图片放大轮播
(0,_createClass3.default)(Sliders,[{key:'imageCarousel',value:function imageCarousel(){var imgObj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var e=arguments[1];var imgPool=[];var indexNum=0;jQuery(".portal-picture-img").each(function(){var imgsrc=!!jQuery(this).attr("data-imgsrc")?jQuery(this).attr("data-imgsrc"):jQuery(this).attr("src");imgPool.push(imgsrc);});var imgsrc=jQuery(e.target).attr("src");var _imgPool=[];var data=imgObj.props.data;data.map(function(item){_imgPool.push(item.url);});for(var i=0;i<_imgPool.length;i++){if(imgsrc==_imgPool[i]){indexNum=i;break;}}window.IMCarousel.showImgScanner4Pool(true,_imgPool,indexNum,null,window.top);}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,esetting=_props.esetting,_props$height=_props.height,height=_props$height===undefined?$(this.refs.Slider).height():_props$height;var widthImg=this.state.width;var pictureWidth=esetting.width,_esetting$imageWidthU=esetting.imageWidthUnit,imageWidthUnit=_esetting$imageWidthU===undefined?'px':_esetting$imageWidthU,_esetting$rollingDire=esetting.rollingDirection,rollingDirection=_esetting$rollingDire===undefined?'1':_esetting$rollingDire,pictureHeight=esetting.height,_esetting$imageHeight=esetting.imageHeightUnit,imageHeightUnit=_esetting$imageHeight===undefined?'px':_esetting$imageHeight;var width=$(this.refs.Slider).width();var widthPicture=parseInt(pictureWidth);if(width!=0&&imageWidthUnit=='%'){widthPicture=parseInt(width*parseFloat(pictureWidth+''))/100;}if(imageWidthUnit=='px'&&pictureWidth>width){widthPicture=width;}var count=parseInt(width/widthPicture);if(rollingDirection=='2'&&height&&pictureHeight&&imageHeightUnit=='px'){count=parseInt(parseInt(height)/pictureHeight);}this.setState({count:count,width:width});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,esetting=_props2.esetting,_props2$height=_props2.height,height=_props2$height===undefined?200:_props2$height;var _state=this.state,counted=_state.count,widthed=_state.width;var pictureWidth=esetting.width,button=esetting.button,_esetting$rollingDire2=esetting.rollingDirection,rollingDirection=_esetting$rollingDire2===undefined?'1':_esetting$rollingDire2,_esetting$imageWidthU2=esetting.imageWidthUnit,imageWidthUnit=_esetting$imageWidthU2===undefined?'px':_esetting$imageWidthU2,pictureHeight=esetting.height,imageHeightUnit=esetting.imageHeightUnit;var width=$(this.refs.Slider).width();if(pictureWidth==0)return;var widthImg=parseInt(pictureWidth);if(width!=0&&imageWidthUnit=='%'){widthImg=parseInt(width*parseFloat(pictureWidth+''))/100;}if(imageWidthUnit=='px'&&pictureWidth>width){widthImg=parseInt(width);}var count=parseInt(width/widthImg);if(rollingDirection=='2'&&height&&imageHeightUnit=='px'){count=parseInt(parseInt(height)/pictureHeight);if(pictureHeight>parseInt(height)){count=1;}}if(!isNaN(count)&&count!==counted)this.setState({count:count});if(width!==widthed)this.setState({width:width});}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,eid=_props3.eid,data=_props3.data,esetting=_props3.esetting,isSetting=_props3.isSetting;var elementHeight=this.props.height;if((0,_lodash.isEmpty)(data))return _react2.default.createElement('div',null);var _state2=this.state,count=_state2.count,widthImg=_state2.width;var showType=esetting.showType,button=esetting.button,width=esetting.width,imageWidthUnit=esetting.imageWidthUnit,height=esetting.height,imageHeightUnit=esetting.imageHeightUnit,open=esetting.open,speed=esetting.speed,_esetting$rollingDire3=esetting.rollingDirection,rollingDirection=_esetting$rollingDire3===undefined?'1':_esetting$rollingDire3,_esetting$isAutoHiehg=esetting.isAutoHiehgt,isAutoHiehgt=_esetting$isAutoHiehg===undefined?'0':_esetting$isAutoHiehg;var _esetting$autoShow=esetting.autoShow,autoShow=_esetting$autoShow===undefined?'1':_esetting$autoShow,_esetting$showTitle=esetting.showTitle,showTitle=_esetting$showTitle===undefined?'1':_esetting$showTitle,_esetting$fontSize=esetting.fontSize,fontSize=_esetting$fontSize===undefined?'16':_esetting$fontSize;if(count>data.length){autoShow='0';count=data.length;}if(rollingDirection=='2'&&!elementHeight){elementHeight=200;}var style1={width:'100%',margin:'0 auto',height:elementHeight};// const style  = {width: showType == '1' ? '100%': divWidth2, margin: '0 auto', maxWidth: '92%'};
var style={width:divWidth2,margin:'0 auto',maxWidth:'87%',height:elementHeight};if(imageHeightUnit=='%'){style.height='100%';}if(imageHeightUnit=='px'){style1.height='100%';}var imgStyle={width:width+imageWidthUnit,height:height+imageHeightUnit,margin:'0 auto',display:'flex',alignItems:'center'};if(rollingDirection=='2'&&elementHeight&&imageHeightUnit=='px'&&parseInt(elementHeight)<parseInt(height)){imgStyle.height=elementHeight;}if(rollingDirection=='2'&&imageHeightUnit=='%'){var heigthPercent=parseFloat(height)/100;imgStyle.height=heigthPercent*parseInt(elementHeight);count=parseInt(1/heigthPercent);style.height=parseInt(elementHeight);}if(width>widthImg&&imageWidthUnit=='px'){imgStyle.width=widthImg+'px';}if(widthImg!=0&&imageWidthUnit=='%'){if(width>100){count=1;imgStyle.width=100*parseFloat(widthImg+'')/100+'px';}else{imgStyle.width=width*parseFloat(widthImg+'')/100+'px';}}if(isAutoHiehgt=='1'&&rollingDirection!='2'){imgStyle.height='auto';}var divStyle={width:width+4+'px',height:height+'px',display:'flex',alignItems:'center'};var divWidth2=0;var sliderComs=data.map(function(item){divWidth2+=(0,_parseFloat2.default)(width)+5;if(open=='1'){return _react2.default.createElement('div',{title:item.name,style:divStyle},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',height:imgStyle.height}},_react2.default.createElement('img',{className:'portal-picture-img',src:item.url,alt:'',style:(0,_extends3.default)({},imgStyle,{height:'100%'}),onClick:function onClick(e){return _this2.imageCarousel(_this2,e);}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},item.name))));}else{return _react2.default.createElement('div',{title:item.name,style:{display:'flex'},onClick:function onClick(){if(item.link==''){return;}else window.open(item.link,"target");}},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',height:imgStyle.height}},_react2.default.createElement('img',{className:'portal-picture-img',src:item.url,alt:'',style:(0,_extends3.default)({},imgStyle,{height:'100%'})}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},item.name))));}});var settings={infinite:true,autoplaySpeed:parseInt(speed),className:"center",dots:false,slidesToShow:count,slidesToScroll:1,autoplay:autoShow=='1',vertical:rollingDirection=='2',pauseOnHover:true,draggable:false,nextArrow:_react2.default.createElement(SampleNextArrow,{button:button,eid:eid}),prevArrow:_react2.default.createElement(SamplePrevArrow,{button:button,eid:eid})};var divWidth="92%";if(button!=="1"){divWidth="100%";}else if(showType=="1"){divWidth="100%";}var carouselCom=_react2.default.createElement(_reactSlick2.default,settings,sliderComs);var className="";if(rollingDirection=='1'){className="portal-picture-slider-across";}return _react2.default.createElement('div',{ref:'Slider',className:'portal-picture-slider '+className,id:'Slider-'+eid+'-'+isSetting,style:showType=='1'?style1:style},showType=='2'?carouselCom:_react2.default.createElement('div',{style:{overflow:'hidden',height:'100%'}},open=='1'?_react2.default.createElement('div',{title:data[0].name,style:(0,_extends3.default)({},imgStyle,{margin:'0 auto',position:'relative'})},_react2.default.createElement('img',{className:'portal-picture-img',src:data[0].url,alt:'',style:{width:'100%',height:'100%'},onClick:function onClick(e){return _this2.imageCarousel(_this2,e);}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},data[0].name))):_react2.default.createElement('div',{style:(0,_extends3.default)({},imgStyle,{margin:'0 auto',position:'relative'})},data[0].link!=''?_react2.default.createElement('a',{title:data[0].name,href:data[0].link,target:'_blank',style:{width:'100%',height:'100%'}},_react2.default.createElement('img',{src:data[0].url,alt:'',style:{width:'100%',height:'100%'}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},data[0].name))):_react2.default.createElement('div',{title:data[0].name,style:{width:'100%',height:'100%'}},_react2.default.createElement('img',{src:data[0].url,alt:'',style:{width:'100%',height:'100%'}}),showTitle=='1'&&_react2.default.createElement('div',{style:{position:'absolute',bottom:'0',backgroundColor:'rgba(51, 51, 51, 0.6)',width:imgStyle.width,height:'15%',fontSize:fontSize+'px',color:'white',textAlign:'center',left:'0px'}},_react2.default.createElement('span',{style:{margin:'0 auto',display:'block'}},data[0].name))))));}}]);return Sliders;}(_react.Component);exports.default=Sliders;;function SampleNextArrow(props){var className=props.className,style=props.style,onClick=props.onClick,button=props.button,eid=props.eid;if('1'!==button)return _react2.default.createElement('div',null);return _react2.default.createElement('div',{style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/next-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px",right:"0px","margin-right":"-7%",cursor:"pointer"}),onClick:onClick}));}function SamplePrevArrow(props){var className=props.className,style=props.style,onClick=props.onClick,button=props.button,eid=props.eid;if('1'!==button)return _react2.default.createElement('div',null);return _react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/prev-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px","margin-left":"-7%",cursor:"pointer"}),onClick:onClick});}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(531), __esModule: true };

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(532);
module.exports = __webpack_require__(18).Number.parseFloat;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
var $parseFloat = __webpack_require__(533);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(23).parseFloat;
var $trim = __webpack_require__(534).trim;

module.exports = 1 / $parseFloat(__webpack_require__(163) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
var defined = __webpack_require__(44);
var fails = __webpack_require__(29);
var spaces = __webpack_require__(163);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(536);

var _json2mq = __webpack_require__(542);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(544);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(545);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(537);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(538);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(41);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(87);

var _track = __webpack_require__(539);

var _dots = __webpack_require__(540);

var _arrows = __webpack_require__(541);

var _resizeObserverPolyfill = __webpack_require__(151);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(41);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(41);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(41);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(543);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 543 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(546);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(547);
var Util = __webpack_require__(165);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(548);
var each = __webpack_require__(165).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var View=function(_React$Component){(0,_inherits3.default)(View,_React$Component);function View(props){(0,_classCallCheck3.default)(this,View);var _this=(0,_possibleConstructorReturn3.default)(this,(View.__proto__||(0,_getPrototypeOf2.default)(View)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(View,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){//  const { eid, api } = params;
//  this.setState({
//      edata: ls.getJSONObj('edata-'+eid),
//  });
//  WeaTools.callApi(api || '/api/portal/element/view', 'POST', {...params}).then(result=> {
//      ls.set('edata-'+eid, result);
//      this.setState({
//          edata: result,
//          refresh: false,
//      });
// });
this.setState({edata:[],refresh:false});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return View;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);View=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(View);exports.default=View;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MoreNews=function(_React$Component){(0,_inherits3.default)(MoreNews,_React$Component);function MoreNews(props){(0,_classCallCheck3.default)(this,MoreNews);var _this=(0,_possibleConstructorReturn3.default)(this,(MoreNews.__proto__||(0,_getPrototypeOf2.default)(MoreNews)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MoreNews,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/morenews','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){EContentHtml=edata.data.map(function(item){return _react2.default.createElement('div',{style:{marginBottom:'8px'}},item.img!==''?_react2.default.createElement('div',{style:{float:'left'}},_react2.default.createElement('img',{height:'142',width:'142',src:item.img})):null,_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(item.data?item.data[0]:{},edata.esetting),showHeader:false,pagination:false,dataSource:item.data,size:'small'}));});}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return MoreNews;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MoreNews=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MoreNews);exports.default=MoreNews;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Stock=function(_React$Component){(0,_inherits3.default)(Stock,_React$Component);function Stock(props){(0,_classCallCheck3.default)(this,Stock);var _this=(0,_possibleConstructorReturn3.default)(this,(Stock.__proto__||(0,_getPrototypeOf2.default)(Stock)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Stock,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/stock','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){var esetting=edata.esetting;var linkmode=esetting.linkmode,width=esetting.width,height=esetting.height,eAutoSwitch=esetting.eAutoSwitch,eSpeedSwitch=esetting.eSpeedSwitch;var tdata=edata.data;var carouselSettings={slidesToShow:1,slidesToScroll:1,autoplay:eAutoSwitch=='1',autoplaySpeed:eSpeedSwitch};EContentHtml=_react2.default.createElement('div',{style:{textAlign:'center'}},tdata.length==1?_react2.default.createElement('div',null,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(this,tdata[0].linkUrl,linkmode)},_react2.default.createElement('img',{style:{width:width+'px',height:height+'px',margin:'0 auto'},src:tdata[0].imgUrl,border:'0'}))):_react2.default.createElement(_antd.Carousel,carouselSettings,tdata.map(function(item){return _react2.default.createElement('div',null,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(_this3,item.linkUrl,linkmode)},_react2.default.createElement('img',{style:{width:width+'px',height:height+'px',margin:'0 auto'},src:item.imgUrl,border:'0'})));})));}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Stock;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Stock=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Stock);exports.default=Stock;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Magazine=__webpack_require__(555);var _Magazine2=_interopRequireDefault(_Magazine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Magazine=function(_React$Component){(0,_inherits3.default)(Magazine,_React$Component);function Magazine(props){(0,_classCallCheck3.default)(this,Magazine);var _this=(0,_possibleConstructorReturn3.default)(this,(Magazine.__proto__||(0,_getPrototypeOf2.default)(Magazine)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Magazine,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/magazine','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Magazine2.default,{eid:eid,data:edata.data,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Magazine;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Magazine=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Magazine);exports.default=Magazine;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Option=_antd.Select.Option;//期刊中心
var MagazineCom=function(_React$Component){(0,_inherits3.default)(MagazineCom,_React$Component);function MagazineCom(){(0,_classCallCheck3.default)(this,MagazineCom);return(0,_possibleConstructorReturn3.default)(this,(MagazineCom.__proto__||(0,_getPrototypeOf2.default)(MagazineCom)).apply(this,arguments));}(0,_createClass3.default)(MagazineCom,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting;return _react2.default.createElement('table',{id:'_contenttable_'+eid,className:'Econtent',width:'100%',cellPadding:'0',cellSpacing:'0'},_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:'1px'}),_react2.default.createElement('td',{width:'*',className:'valign'},_react2.default.createElement('table',{width:'100%',cellPadding:'0',cellSpacing:'0'},data.map(function(item){return _react2.default.createElement(MagazineItem,{item:item,esetting:esetting});}))),_react2.default.createElement('td',{width:'1px'})));}}]);return MagazineCom;}(_react2.default.Component);var MagazineItem=function(_React$Component2){(0,_inherits3.default)(MagazineItem,_React$Component2);function MagazineItem(props){(0,_classCallCheck3.default)(this,MagazineItem);var _this2=(0,_possibleConstructorReturn3.default)(this,(MagazineItem.__proto__||(0,_getPrototypeOf2.default)(MagazineItem)).call(this,props));_this2.state={linkUrl:''};_this2.handleChange=_this2.handleChange.bind(_this2);return _this2;}(0,_createClass3.default)(MagazineItem,[{key:'handleChange',value:function handleChange(key,value){var _this3=this;var list=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];list.map(function(item){if(item.id==key){_this3.setState({linkUrl:item.link});}});}},{key:'componentWillMount',value:function componentWillMount(){var item=this.props.item;var _item$list=item.list,list=_item$list===undefined?[]:_item$list;if(list.length>0){this.setState({linkUrl:list[0].link});}}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,_props2$item=_props2.item,item=_props2$item===undefined?{}:_props2$item,esetting=_props2.esetting;var width=esetting.width,height=esetting.height,linkmode=esetting.linkmode;var _item$docsubject=item.docsubject,docsubject=_item$docsubject===undefined?{}:_item$docsubject,_item$summary=item.summary,summary=_item$summary===undefined?'':_item$summary,_item$images=item.images,images=_item$images===undefined?[]:_item$images,_item$list2=item.list,list=_item$list2===undefined?[]:_item$list2;var link=docsubject.link,name=docsubject.name;var strImg='/images/go_wev8.gif';var style={tableLayout:'fixed'};var tstyle={tableLayout:'fixed',paddingBottom:'15px',paddingLeft:'3px'};var imgstyle={width:width};if(height!=='0'){imgstyle.height=height;}var imghtml=null;var imghtml1=[];var j=0;if(!(0,_lodash.isEmpty)(images)){if(images.length>1){images.map(function(item,i){if(images[i]!='/images/homepage/noimgdefault_wev8.jpg'){imghtml1[j]=images[i];j++;}});if(imghtml1.length==0){imghtml1=['/images/homepage/noimgdefault_wev8.jpg'];}var ihtml=imghtml1.map(function(item,i){var img=imghtml1[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];return _react2.default.createElement('div',null,_react2.default.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,style:{width:'100%',height:'100%'},src:img}));});imghtml=_react2.default.createElement('td',{className:'valign',width:parseInt(width)+5},_react2.default.createElement('div',{className:'news-silde',style:{marginBottom:'10px'}},_react2.default.createElement(_antd.Carousel,{autoplay:true},ihtml)));}else{var img=images[0];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=_react2.default.createElement('td',{className:'valign',width:parseInt(width)+5},_react2.default.createElement('div',{style:{height:'100%',marginBottom:'10px'},className:'news-silde'},_react2.default.createElement(_antd.Carousel,null,_react2.default.createElement('div',null,_react2.default.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[0]&&list[0].docsubject&&list[0].docsubject.link,style:{width:'100%',height:'100%'},src:img})))));}}else{var _img='/images/homepage/noimgdefault_wev8.jpg';imghtml=_react2.default.createElement('td',{className:'valign',width:parseInt(width)+5},_react2.default.createElement('div',{style:{height:'100%',marginBottom:'10px'},className:'news-silde'},_react2.default.createElement(_antd.Carousel,null,_react2.default.createElement('div',null,_react2.default.createElement(ImgCom,{style:{width:'100%',height:'100%'},src:_img})))));}return _react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('table',{width:'100%',className:'valign',style:style},_react2.default.createElement('tr',null,imghtml,_react2.default.createElement('td',{width:'*',className:'valign'},_react2.default.createElement('table',{width:'100%',className:'magzine',style:tstyle},_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('a',{href:'javascript:void(0);',style:{color:'#666'},onClick:_common.openLinkUrl.bind(this,link,linkmode)},name))),_react2.default.createElement('tr',{className:'sparator',style:{height:'1px'}},_react2.default.createElement('td',{style:{padding:'0px'}})),_react2.default.createElement('tr',null,_react2.default.createElement('td',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,webkitBoxOrient:'vertical',display:'-webkit-box'}},summary))),_react2.default.createElement('table',{width:'100%',cellPadding:'0',cellSpacing:'0',style:tstyle},_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement(_ecCom.WeaSelect,{style:{width:'90%'},options:list.map(function(item,index){var arr={key:item.id,showname:item.name};if(index==0){arr={key:item.id,showname:item.name,selected:true};}return arr;}),onChange:function onChange(key,value){return _this4.handleChange(key,value,list);}// hasAddBtn
// options={options}
// viewAttr={viewAttr}
// value={value}
// onSelectRepeat={(v=>{console.log('onSelectRepeat', v)})}
// onChange={this.handleChange.bind(this)}
}),'\xA0',_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(this,this.state.linkUrl,linkmode)},_react2.default.createElement('img',{style:{marginBottom:'-5px'},src:strImg}))))))))));}}]);return MagazineItem;}(_react2.default.Component);var ImgCom=function(_React$Component3){(0,_inherits3.default)(ImgCom,_React$Component3);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this5=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this5.aClick=_this5.aClick.bind(_this5);return _this5;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props$link=this.props.link,link=_props$link===undefined?'':_props$link;if(link!=''){window.open(link);}else return false;}},{key:'render',value:function render(){var _props3=this.props,_props3$src=_props3.src,src=_props3$src===undefined?'':_props3$src,_props3$style=_props3.style,style=_props3$style===undefined?{width:'100%',height:'100%'}:_props3$style;return _react2.default.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},_react2.default.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MagazineCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MagazineCom);exports.default=MagazineCom;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);__webpack_require__(557);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var DocContent=function(_React$Component){(0,_inherits3.default)(DocContent,_React$Component);function DocContent(props){(0,_classCallCheck3.default)(this,DocContent);var _this=(0,_possibleConstructorReturn3.default)(this,(DocContent.__proto__||(0,_getPrototypeOf2.default)(DocContent)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(DocContent,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/doccontent','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var item=this.props.config.item;var width=$("#content_view_id_"+item.eid).width()||0;this.setState({width:width});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement('div',{className:'portal-element-doc-content',style:{width:width},id:'__content__'+eid,dangerouslySetInnerHTML:{__html:edata.data}});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height,overflow:'auto'}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return DocContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DocContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DocContent);exports.default=DocContent;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Audio=__webpack_require__(559);var _Audio2=_interopRequireDefault(_Audio);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Audio=function(_React$Component){(0,_inherits3.default)(Audio,_React$Component);function Audio(props){(0,_classCallCheck3.default)(this,Audio);var _this=(0,_possibleConstructorReturn3.default)(this,(Audio.__proto__||(0,_getPrototypeOf2.default)(Audio)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Audio,[{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/audio','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var config=this.props.config;var _state=this.state,edata=_state.edata,refresh=_state.refresh;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Audio2.default,{data:edata.data,eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Audio;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Audio=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Audio);exports.default=Audio;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//音频元素
var AudioCom=function(_React$Component){(0,_inherits3.default)(AudioCom,_React$Component);function AudioCom(){(0,_classCallCheck3.default)(this,AudioCom);return(0,_possibleConstructorReturn3.default)(this,(AudioCom.__proto__||(0,_getPrototypeOf2.default)(AudioCom)).apply(this,arguments));}(0,_createClass3.default)(AudioCom,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,esetting=_props.esetting;var autoPlay=esetting.autoPlay,isie=esetting.isie;if(!isie){var attrs={controls:'controls'};if(autoPlay==='on'){attrs['autoplay']='autoplay';}$("#audio_play_"+eid+" audio").attr(attrs);}else{var oAttrs={classid:'clsid:d27cdb6e-ae6d-11cf-96b8-444553540000',codebase:'https://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,0,0'};$("#audioplayer_"+eid).attr(oAttrs);var eAttrs={mce_src:'flash/top.swf',menu:'false',quality:'high',allowscriptaccess:'sameDomain',pluginspage:'https://www.macromedia.com/go/getflashplayer'};$("#audioplayer_"+eid+" embed").attr(eAttrs);}}},{key:'render',value:function render(){var _props2=this.props,eid=_props2.eid,data=_props2.data,esetting=_props2.esetting;var autoPlay=esetting.autoPlay,ePath=esetting.ePath,height=esetting.height,width=esetting.width,isie=esetting.isie;var html=null;var style={width:'100%',height:height};if(isie){html=_react2.default.createElement('object',{id:'audioplayer_'+eid,style:{height:height,textAlign:'middle',width:'100%'}},_react2.default.createElement('param',{name:'quality',value:'best'}),_react2.default.createElement('param',{name:'SAlign',value:'LT'}),_react2.default.createElement('param',{name:'allowScriptAccess',value:'never'}),_react2.default.createElement('param',{name:'wmode',value:'transparent'}),_react2.default.createElement('param',{name:'movie',value:ePath+'resource/js/audio-player.swf?audioUrl='+data.url+'&'+(autoPlay==='on'?'autoPlay=true':'')}),_react2.default.createElement('embed',{src:'"'+ePath+'resource/js/audio-player.swf?audioUrl='+data.url+'&'+(autoPlay==='on'?'autoPlay=true':''),wmode:'transparent',width:'100%',height:height,type:'application/x-shockwave-flash'}));}else{html=_react2.default.createElement('audio',{src:data.url,style:{width:'100%'},controlsList:'nodownload',height:height});}return _react2.default.createElement('div',{id:'audio_play_'+eid,style:style},html);}}]);return AudioCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);AudioCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(AudioCom);exports.default=AudioCom;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Favourite=function(_React$Component){(0,_inherits3.default)(Favourite,_React$Component);function Favourite(props){(0,_classCallCheck3.default)(this,Favourite);var _this=(0,_possibleConstructorReturn3.default)(this,(Favourite.__proto__||(0,_getPrototypeOf2.default)(Favourite)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Favourite,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/favourite','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Favourite;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Favourite=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Favourite);exports.default=Favourite;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Flash=function(_React$Component){(0,_inherits3.default)(Flash,_React$Component);function Flash(props){(0,_classCallCheck3.default)(this,Flash);var _this=(0,_possibleConstructorReturn3.default)(this,(Flash.__proto__||(0,_getPrototypeOf2.default)(Flash)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Flash,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/flash','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){var _edata$data=edata.data,height=_edata$data.height,url=_edata$data.url;EContentHtml=_react2.default.createElement('div',{id:'flash_play_'+eid,style:{width:'100%',height:height+'px',overflowY:'hidden'}},_react2.default.createElement('embed',{width:'100%',height:height+'px',wmode:'opaque',name:'plugin',src:url,type:'application/x-shockwave-flash'}));}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Flash;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Flash=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Flash);exports.default=Flash;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _immutable=__webpack_require__(563);var _immutable2=_interopRequireDefault(_immutable);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _ImgSlide=__webpack_require__(564);var _ImgSlide2=_interopRequireDefault(_ImgSlide);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var is=_immutable2.default.is,fromJS=_immutable2.default.fromJS;var ls=_ecCom.WeaTools.ls;//元素组件
var ImgSlide=function(_React$Component){(0,_inherits3.default)(ImgSlide,_React$Component);function ImgSlide(props){(0,_classCallCheck3.default)(this,ImgSlide);var _this=(0,_possibleConstructorReturn3.default)(this,(ImgSlide.__proto__||(0,_getPrototypeOf2.default)(ImgSlide)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(ImgSlide,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi('/api/portal/element/imgslide','POST',params).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var config=this.props.config;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,isSetting=config.isSetting;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ImgSlide2.default,{isSetting:isSetting,data:edata.data,eid:eid});// if(!isEmpty(edata)) EContentHtml = <Sliders isSetting={isSetting} data={edata.data} eid={eid}/>;
}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}if(refresh)EContentHtml=_react2.default.createElement(_antd.Spin,null,EContentHtml);return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},EContentHtml),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return ImgSlide;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:"对不起，流程元素加载异常，请联系管理员！"});}}]);return MyErrorHandler;}(_react2.default.Component);ImgSlide=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ImgSlide);exports.default=ImgSlide;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//多图元素
var ImgSlideCom=function(_React$Component){(0,_inherits3.default)(ImgSlideCom,_React$Component);function ImgSlideCom(props){(0,_classCallCheck3.default)(this,ImgSlideCom);var _this=(0,_possibleConstructorReturn3.default)(this,(ImgSlideCom.__proto__||(0,_getPrototypeOf2.default)(ImgSlideCom)).call(this,props));_this.state={ewidth:0,eheight:0};_this.aClick=_this.aClick.bind(_this);_this.autoCarousel=_this.autoCarousel.bind(_this);_this.initSlide=_this.initSlide.bind(_this);return _this;}(0,_createClass3.default)(ImgSlideCom,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,data=_props.data,isSetting=_props.isSetting;var imgsrclist=data.imgsrclist,imgdesclist=data.imgdesclist,height=data.height,displaydesc=data.displaydesc,cellwidth=data.cellwidth,autoSwitchTime=data.autoSwitchTime;var rowcount=parseInt(data.rowcount);this.initSlide(eid,rowcount,autoSwitchTime);var mleft="-"+18*rowcount/2+'px';$('#banner_'+eid+"_"+isSetting+' ul').css('margin-left',mleft);this.setState({ewidth:$('#content_'+eid).width(),eheight:$('#content_'+eid).height()});}},{key:'aClick',value:function aClick(){var link=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';if(link!=''){window.open(link);}else return false;}},{key:'autoCarousel',value:function autoCarousel(rowcount,autoSwitchTime,_n){var _props2=this.props,eid=_props2.eid,isSetting=_props2.isSetting;if(rowcount>1){clearInterval(window['_t_'+isSetting+'_'+eid]);window['_t_'+isSetting+'_'+eid]=setInterval(function(){_n=_n>=rowcount-1?0:++_n;// $("#banner_"+eid+"_"+isSetting+" li").eq(_n).trigger('click');
bannerClick(eid,_n,rowcount,isSetting);},autoSwitchTime);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'initSlide',value:function initSlide(eid,rowcount,autoSwitchTime){var _this2=this;var isSetting=this.props.isSetting;var _n=0;var _count=0;var temp=rowcount;_count=$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img").length;$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img:not(:first-child)").hide();$("#banner_info_"+eid+"_"+isSetting).click(function(){});$("#banner_"+eid+"_"+isSetting+" li, #banner_info_"+eid+"_"+isSetting+" .slidebox_info_item").click(function(){var i=$(this).attr("data-index")-1;//
_n=i;if(i>=rowcount)return;$("#banner_info_"+eid+"_"+isSetting).unbind().click(function(){});$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img").filter(":visible").css("display","none").parent().children().eq(i).css("display","block");// document.getElementById("banner_"+eid+"_"+isSetting).style.background = "";
if(document.getElementById("banner_"+eid+"_"+isSetting)){document.getElementById("banner_"+eid+"_"+isSetting).style.background="";}$("#banner_"+eid+"_"+isSetting+" li").eq(i).toggleClass("on");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").removeClass("slidebox_info_item_slt");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").eq(i).addClass("slidebox_info_item_slt");$(this).siblings().removeAttr("class");});if(rowcount>1){//_t = setInterval(showAuto.bind(this,eid), autoSwitchTime);
clearInterval(window['_t_'+isSetting+'_'+eid]);window['_t_'+isSetting+'_'+eid]=setInterval(function(){_n=_n>=rowcount-1?0:++_n;// $("#banner_"+eid+"_"+isSetting+" li").eq(_n).trigger('click');
bannerClick(eid,_n,rowcount,isSetting);},autoSwitchTime);}$("#banner_"+eid+"_"+isSetting).hover(function(){// clearInterval(this._t)
$("#settingico_"+eid).parent().show();},function(){_this2.autoCarousel(rowcount,autoSwitchTime,_n);});}},{key:'render',value:function render(){var _this3=this;var _props3=this.props,eid=_props3.eid,data=_props3.data,isSetting=_props3.isSetting;var _state=this.state,ewidth=_state.ewidth,eheight=_state.eheight;var imgsrclist=data.imgsrclist,imgdesclist=data.imgdesclist,_data$height=data.height,height=_data$height===undefined?'0':_data$height,rowcount=data.rowcount,displaydesc=data.displaydesc,cellwidth=data.cellwidth,type=data.type,imgAddress=data.imgAddress,_data$fontSize=data.fontSize,fontSize=_data$fontSize===undefined?'16':_data$fontSize;var style={fontFamily:'微软雅黑'};var style1={display:'none'};if(displaydesc!=1){style={fontFamily:'微软雅黑',display:'none'};style1={};}var col1=new Array();var col2=new Array();for(var j=0;j<parseInt(rowcount);j++){col1.push(_react2.default.createElement('col',{width:cellwidth+'%'}));col2.push(_react2.default.createElement('col',{width:'1px'}));}var liHtml=new Array();var aHtml=new Array();var dHtml=new Array();imgdesclist.map(function(item,i){var astyle={background:'url('+imgsrclist[i]+') center center no-repeat',backgroundSize:'100% 100%',height:'100%'};switch(type){case'adapt':astyle={background:'url('+imgsrclist[i]+') center center no-repeat',backgroundSize:'auto 100%',height:'100%'};break;case'fill':astyle.backgroundRepeat='no-repeat';astyle.backgroundSize='cover';// astyle.width = ewidth;
// astyle.height = eheight;
break;case'tile':astyle={background:'url('+imgsrclist[i]+') repeat',height:'100%'};break;case'center':astyle={background:'url('+imgsrclist[i]+')',backgroundPosition:'center center',backgroundRepeat:'no-repeat'};break;default:astyle.backgroundRepeat='no-repeat';astyle.backgroundSize='100% 100%';astyle.mozBackgroundSize='100% 100%';break;}liHtml.push(_react2.default.createElement('li',{className:i===0?'on':'','data-index':i+1}));if(type=='adapt'){aHtml.push(_react2.default.createElement('div',{className:'portal-imgslide-img',onClick:function onClick(){return _this3.aClick(imgAddress[i]);}},_react2.default.createElement('img',{src:imgsrclist[i],style:{width:'100%'},alt:''})));{/*<a href="javascript:void(0)" onClick={()=>this.aClick(imgAddress[i])}>*/}{/*/!*aHtml.push(<a href={} target="_blank">*!/*/}{/*<div className="slidebox_list_item" style={astyle}>*/}{/*</div>*/}{/*</a>*/}}else{aHtml.push(_react2.default.createElement('a',{className:'portal-imgslide-img',href:'javascript:void(0)',onClick:function onClick(){return _this3.aClick(imgAddress[i]);}},_react2.default.createElement('div',{className:'slidebox_list_item',style:astyle})));}dHtml.push(_react2.default.createElement('td',null,_react2.default.createElement('div',{className:'slidebox_info_item '+(i===0?'slidebox_info_item_slt':''),style:{fontSize:fontSize+'px'},'data-index':i+1},item)));});return _react2.default.createElement('div',{id:'imgslide_'+eid,style:{width:'100%',height:type=='adapt'?'':height+'px'}},_react2.default.createElement('div',{id:'banner_'+eid+'_'+isSetting,className:'slidebox_block',style:{height:'100%'}},_react2.default.createElement('div',{id:'banner_info_'+eid+'_'+isSetting,className:'slidebox_info',style:style},_react2.default.createElement('table',{width:'100%',height:'100%',cellpadding:'0',cellspacing:'0'},_react2.default.createElement('colgroup',null,col1),_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,dHtml)))),_react2.default.createElement('ul',{style:style1},liHtml),_react2.default.createElement('div',{id:'banner_list_'+eid+'_'+isSetting,className:'slidebox_list',style:{height:'100%'}},aHtml)));}}]);return ImgSlideCom;}(_react2.default.Component);function bannerClick(eid,_n,rowcount,isSetting){var i=_n;//
if(i>=rowcount)return;$("#banner_info_"+eid+"_"+isSetting).unbind().click(function(){});$("#banner_list_"+eid+"_"+isSetting+" .portal-imgslide-img").filter(":visible").css("display","none").parent().children().eq(i).css("display","block");if(document.getElementById("banner_"+eid+"_"+isSetting)){document.getElementById("banner_"+eid+"_"+isSetting).style.background="";}$("#banner_"+eid+"_"+isSetting+" li").eq(i).toggleClass("on");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").removeClass("slidebox_info_item_slt");$("#banner_info_"+eid+"_"+isSetting).find(".slidebox_info_item").eq(i).addClass("slidebox_info_item_slt");$(this).siblings().removeAttr("class");}var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ImgSlideCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ImgSlideCom);exports.default=ImgSlideCom;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _DataCenter=__webpack_require__(566);var _DataCenter2=_interopRequireDefault(_DataCenter);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var DataCenter=function(_React$Component){(0,_inherits3.default)(DataCenter,_React$Component);function DataCenter(props){(0,_classCallCheck3.default)(this,DataCenter);var _this=(0,_possibleConstructorReturn3.default)(this,(DataCenter.__proto__||(0,_getPrototypeOf2.default)(DataCenter)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(DataCenter,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/datacenter','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_DataCenter2.default,{config:config,data:edata.data,eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return DataCenter;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DataCenter=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DataCenter);exports.default=DataCenter;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//个人数据元素
var DataCenterCom=function(_React$Component){(0,_inherits3.default)(DataCenterCom,_React$Component);function DataCenterCom(props){(0,_classCallCheck3.default)(this,DataCenterCom);var _this=(0,_possibleConstructorReturn3.default)(this,(DataCenterCom.__proto__||(0,_getPrototypeOf2.default)(DataCenterCom)).call(this,props));_this.state={list:props.data,eContentShowType:_this.props.esetting.eContentShowType};_this.callBack=_this.callBack.bind(_this);return _this;}(0,_createClass3.default)(DataCenterCom,[{key:'componentDidMount',value:function componentDidMount(){this.callBack();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;this.setState({list:nextProps.data},function(){_this2.callBack();});}},{key:'callBack',value:function callBack(){var eid=this.props.eid;var openlink=this.props.esetting.linkmode;var eContentShowType=this.props.esetting.eContentShowType;if(eContentShowType!='1'){$('#content_view_id_'+eid+' .module').hover(function(dom){$(this).css("background-image","none");$(this).find(".mtitle").show().css("padding-top","52px");$(this).css("opacity",'0.8');},function(){$(this).css("background-image","url(/images/homepage/portalcenter/"+$(this).attr("data-type")+"_wev8.png)");$(this).find(".mtitle").hide();$(this).css("opacity",'1');});}else{$('#content_view_id_'+eid+' .module').hover(function(dom){$(this).css("background-image","none");$(this).find(".mtitle").show().css("padding-top","52px");$(this).css("opacity",'0.8');},function(){$(this).css("background-image","none");$(this).find(".mtitle").show();$(this).css("opacity",'1');});}//去除点击事件绑定
$('#content_view_id_'+eid+' .module').unbind("click");// $(".module").attr("onclick","");
//再绑定点击事件
$('#content_view_id_'+eid+' .module').click(function(){var dataUrl=$(this).attr("data-url");(0,_common.openLinkUrl)(dataUrl,openlink);});}},{key:'render',value:function render(){var list=this.state.list;var esetting=this.props.esetting;var html=null;switch(list.length){case 1:case 2:case 3:html=list.map(function(item){return _react2.default.createElement(_antd.Col,{span:24/list.length},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'240'}));});break;case 4:html=list.map(function(item){return _react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));});break;case 5:html=list.map(function(item,i){switch(i){case 0:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}),_react2.default.createElement(Module,{esetting:esetting,item:list[i+3],height:'120'}));case 1:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'240'}));case 2:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}),_react2.default.createElement(Module,{esetting:esetting,item:list[i+2],height:'120'}));default:return _react2.default.createElement('div',null);}});break;case 6:html=list.map(function(item,i){return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));});break;case 7:html=list.map(function(item,i){switch(i){case 1:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'})),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:list[i+1],height:'120'}))));case 2:return _react2.default.createElement('div',null);default:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));}});break;case 8:html=list.map(function(item,i){switch(i){case 1:case 4:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'})),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:list[i+1],height:'120'}))));case 2:case 5:return _react2.default.createElement('div',null);default:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));}});break;case 9:html=list.map(function(item,i){switch(i){case 1:case 4:case 7:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'})),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement(Module,{esetting:esetting,item:list[i+1],height:'120'}))));case 2:case 5:case 8:return _react2.default.createElement('div',null);default:return _react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement(Module,{esetting:esetting,item:item,height:'120'}));}});break;}return _react2.default.createElement(_antd.Row,null,html);}}]);return DataCenterCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DataCenterCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DataCenterCom);exports.default=DataCenterCom;var Module=function Module(_ref){var _ref$esetting=_ref.esetting,esetting=_ref$esetting===undefined?{}:_ref$esetting,item=_ref.item,height=_ref.height;if(esetting.eContentShowType=='1'){return _react2.default.createElement('div',{className:'module '+item.model,'data-type':item.model,'data-url':item.url,style:{backgroundColor:item.color,height:height+'px',backgroundImage:'none'}},_react2.default.createElement('div',{className:'num'},item.value),_react2.default.createElement('div',{className:'mtitle',style:{display:'block',paddingTop:'52px'}},item.label));}else{return _react2.default.createElement('div',{className:'module '+item.model,'data-type':item.model,'data-url':item.url,style:{backgroundColor:item.color,height:height+'px'}},_react2.default.createElement('div',{className:'num'},item.value),_react2.default.createElement('div',{className:'mtitle'},item.label));}};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Video=__webpack_require__(568);var _Video2=_interopRequireDefault(_Video);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Video=function(_React$Component){(0,_inherits3.default)(Video,_React$Component);function Video(props){(0,_classCallCheck3.default)(this,Video);var _this=(0,_possibleConstructorReturn3.default)(this,(Video.__proto__||(0,_getPrototypeOf2.default)(Video)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Video,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/video','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Video2.default,{data:edata.data,eid:eid,datas:edata.datas});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Video;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Video=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Video);exports.default=Video;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactSlick=__webpack_require__(164);var _reactSlick2=_interopRequireDefault(_reactSlick);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//视频元素
var VideoCom=function(_React$Component){(0,_inherits3.default)(VideoCom,_React$Component);function VideoCom(props){(0,_classCallCheck3.default)(this,VideoCom);var _this=(0,_possibleConstructorReturn3.default)(this,(VideoCom.__proto__||(0,_getPrototypeOf2.default)(VideoCom)).call(this,props));_this.state={width:0};return _this;}(0,_createClass3.default)(VideoCom,[{key:'componentDidMount',value:function componentDidMount(){var eid=this.props.eid;var width=$('#content_view_id_'+eid).width();this.setState({width:parseInt(parseInt(width)*parseInt("87%")/100)});var fullScreen=this.props.data.fullScreen;if(fullScreen=='on'){}else{if($('#video_play_style_'+eid).length==0){$('<style id=\'video_play_style_'+eid+'\'>#video_play_'+eid+' video::-webkit-media-controls-fullscreen-button{ display: none; } </style>').appendTo('head');}}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var eid=this.props.eid;var nextfullScreen=nextProps.data.fullScreen;var fullScreen=this.props.data.fullScreen;if(fullScreen!=nextfullScreen){if(nextfullScreen=='on'){$('#video_play_style_'+eid).remove();}else{$('<style id=\'video_play_style_'+eid+'\'>#video_play_'+eid+' video::-webkit-media-controls-fullscreen-button{ display: none; } </style>').appendTo('head');}}return true;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,eid=_props.eid,data=_props.data,datas=_props.datas;var width=this.state.width;var height=data.height,quality=data.quality,fullScreen=data.fullScreen,url=data.url,autoPlay=data.autoPlay,isie=data.isie,eVideoShowType=data.eVideoShowType,showMulitline=data.showMulitline,showNums=data.showNums,showTitle=data.showTitle,fontSize=data.fontSize;var isAutoPlay=autoPlay==='on';var isFullScreen=fullScreen==='on';// document.getElementById("myVideo").play()
var EVideoCom=_react2.default.createElement('div',null);if(eVideoShowType=='1'){//单个视频显示
EVideoCom=_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',marginLeft:'10px',marginRight:'10px'}},_react2.default.createElement(VideoItem,{props:this.props,data:data,datas:datas[0],videoRef:this.videoRef,vidRef:this.vidRef}),showTitle=='1'&&_react2.default.createElement('div',{style:(0,_defineProperty3.default)({height:'15%',fontSize:'16px',color:'black',textAlign:'center',width:'100%'},'fontSize',fontSize+'px')},_react2.default.createElement('div',{style:{margin:'0 auto',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},datas[0].title)));}else{//多个视频显示
var settings={className:"center",dots:false,infinite:true,slidesToShow:parseInt(showNums),slidesToScroll:1,autoplay:false,nextArrow:_react2.default.createElement(SampleNextArrow,{eid:eid}),prevArrow:_react2.default.createElement(SamplePrevArrow,{eid:eid})};var sliderComs=_react2.default.createElement('div',null);if(showMulitline){// 多行
EVideoCom=_react2.default.createElement('div',null,datas.map(function(item){return _react2.default.createElement('div',{title:item.title,style:{float:'left',width:parseInt((width-showNums*20)/showNums)+'px',display:'inline-block'}},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',marginLeft:'10px',marginRight:'10px'}},_react2.default.createElement(VideoItem,{props:_this2.props,data:data,datas:item}),showTitle=='1'&&_react2.default.createElement('div',{style:(0,_defineProperty3.default)({height:'15%',fontSize:'16px',color:'black',textAlign:'center',width:'100%'},'fontSize',fontSize+'px')},_react2.default.createElement('div',{style:{margin:'0 auto',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},item.title))));}));}else{//单行
sliderComs=datas.map(function(item){return _react2.default.createElement('div',{title:item.title},_react2.default.createElement('div',{style:{position:'relative',margin:'0 auto',marginLeft:'10px',marginRight:'10px'}},_react2.default.createElement(VideoItem,{props:_this2.props,data:data,datas:item}),showTitle=='1'&&_react2.default.createElement('div',{style:(0,_defineProperty3.default)({height:'15%',fontSize:'16px',color:'black',textAlign:'center',width:'100%'},'fontSize',fontSize+'px')},_react2.default.createElement('div',{style:{margin:'0 auto',overflow:'hidden',textOverflow:'ellipsis',wordBreak:'normal',whiteSpace:'nowrap'}},item.title))));});EVideoCom=_react2.default.createElement(_reactSlick2.default,settings,sliderComs);}}var style={width:'87%',margin:'0 auto'};if(eVideoShowType=='1')style={width:'100%',height:height};return _react2.default.createElement('div',{id:'video_play_'+eid,style:style},EVideoCom);}}]);return VideoCom;}(_react2.default.Component);var VideoItem=function(_React$Component2){(0,_inherits3.default)(VideoItem,_React$Component2);function VideoItem(){var _ref4;var _temp,_this3,_ret;(0,_classCallCheck3.default)(this,VideoItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=(0,_possibleConstructorReturn3.default)(this,(_ref4=VideoItem.__proto__||(0,_getPrototypeOf2.default)(VideoItem)).call.apply(_ref4,[this].concat(args))),_this3),_this3.videoRef=function(obj){if(obj!=null){obj.play();}},_this3.vidRef=function(obj){if(obj!=null){obj.pause();}},_temp),(0,_possibleConstructorReturn3.default)(_this3,_ret);}//开启自动播放 让video继续播放
//关闭自动播放 让video暂停
(0,_createClass3.default)(VideoItem,[{key:'render',value:function render(){var _props2=this.props,eid=_props2.eid,data=_props2.data,datas=_props2.datas,videoRef=_props2.videoRef,vidRef=_props2.vidRef;var height=data.height,quality=data.quality,fullScreen=data.fullScreen,url=data.url,autoPlay=data.autoPlay,isie=data.isie,eAutoHeight=data.eAutoHeight,eVideoShowType=data.eVideoShowType;var isAutoPlay=autoPlay==='on'&&eVideoShowType=='1';var isFullScreen=fullScreen==='on';return _react2.default.createElement('video',{ref:isAutoPlay?this.videoRef:this.vidRef,src:datas&&datas.videoUrl?datas.videoUrl:url,style:{width:'100%'},height:eAutoHeight?'auto':height,loop:'loop',controlsList:'nodownload',controls:'controls'});}}]);return VideoItem;}(_react2.default.Component);function SampleNextArrow(props){var className=props.className,style=props.style,onClick=props.onClick,eid=props.eid;return _react2.default.createElement('div',{style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/next-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px",right:"0px","margin-right":"-7%",cursor:"pointer"}),onClick:onClick}));}function SamplePrevArrow(props){var className=props.className,style=props.style,onClick=props.onClick,eid=props.eid;return _react2.default.createElement('div',{style:(0,_extends3.default)({},style,{background:'transparent url(/page/element/Picture/resource/image/prev-horizontal_wev9.png) no-repeat 0 0',width:'32px',height:'32px',"position":"absolute",top:"50%","margin-top":"-16px","margin-left":"-7%",cursor:"pointer"}),onClick:onClick});}var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);VideoCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(VideoCom);exports.default=VideoCom;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Weather=__webpack_require__(570);var _Weather2=_interopRequireDefault(_Weather);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Weather=function(_React$Component){(0,_inherits3.default)(Weather,_React$Component);function Weather(props){(0,_classCallCheck3.default)(this,Weather);var _this=(0,_possibleConstructorReturn3.default)(this,(Weather.__proto__||(0,_getPrototypeOf2.default)(Weather)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Weather,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/weather','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Weather2.default,{data:edata.data,eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Weather;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Weather=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Weather);exports.default=Weather;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//天气元素
var WeatherCom=function(_React$Component){(0,_inherits3.default)(WeatherCom,_React$Component);function WeatherCom(){(0,_classCallCheck3.default)(this,WeatherCom);return(0,_possibleConstructorReturn3.default)(this,(WeatherCom.__proto__||(0,_getPrototypeOf2.default)(WeatherCom)).apply(this,arguments));}(0,_createClass3.default)(WeatherCom,[{key:'componentDidMount',value:function componentDidMount(){$("#weather_"+this.props.eid).attr("align","center");$("#asdad").attr("align","center");}},{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting;var width=esetting.width,autoScroll=esetting.autoScroll;var tabStyle={overflow:'hidden',backgroundColor:'#FFFFFF',width:'100%',tableLayout:'fixed',textAlign:'center'};var trHtml=_react2.default.createElement('td',{width:'*',align:'top'},_react2.default.createElement('span',{height:'20',style:{paddingTop:'5px'}},_react2.default.createElement('img',{src:'/images/icon_wev8.gif'}),'\xA0\xA0',getLabel(386599,'请确认服务器可以访问www.weather.com.cn')));if(data.length!==0){var tdHtml=data.map(function(item,i){return _react2.default.createElement('td',{width:'80',style:{textAlign:'center'}},_react2.default.createElement('div',{className:'wetCityName',style:{height:'20px'}},item.city),_react2.default.createElement('div',{className:'wetCityName',id:'curConditionDiv',style:{width:'80px',cursor:'pointer',height:'40px',lineHeight:'20px'}},_react2.default.createElement('p',{title:item.weather},item.weather)),_react2.default.createElement('div',{style:{width:'80px',bottom:'10px'}},item.img===''?null:_react2.default.createElement('img',{src:item.img,title:item.weather})),_react2.default.createElement('br',null),item.temperature);});var wHtml=_react2.default.createElement('table',{style:{textAlign:'center',margin:'0 auto'},cellpadding:'0',cellspace:'0',border:'0'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{id:'weather_'+eid+'_1',className:'valign',style:{float:'left'}},_react2.default.createElement('table',null,_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,tdHtml)))),_react2.default.createElement('td',{id:'weather_'+eid+'_2',className:'valign'}))));if(autoScroll==='1'){wHtml=_react2.default.createElement('marquee',{direction:'left',scrollamount:'2',onMouseOver:stop(),onMouseOut:start()},wHtml);}trHtml=_react2.default.createElement('tr',null,_react2.default.createElement('td',{style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{id:'weatherback_'+eid,style:{cursor:'hand'},className:'',onClick:backWeatherMarquee(eid)})),_react2.default.createElement('td',{id:'asdad',style:{textAlign:'center'}},_react2.default.createElement('div',{id:'weather_'+eid,style:{textAlign:'center !important'}},_react2.default.createElement('div',{id:'weather_'+eid+'_0',style:{margin:'0 auto',overflow:'hidden',width:width+'px',textAlign:'center'}},wHtml))),_react2.default.createElement('td',{valign:'middle',style:{verticalAlign:'middle',width:'35px'}},_react2.default.createElement('div',{id:'weathernext_'+eid,className:'',style:{cursor:'hand'},onClick:nextWeatherMarquee(eid)})));}return _react2.default.createElement('table',{id:'weatherTable_'+eid,style:tabStyle,onresize:''},_react2.default.createElement('tbody',null,trHtml));}}]);return WeatherCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);WeatherCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(WeatherCom);exports.default=WeatherCom;function backWeatherMarquee(eid){$("weather_"+eid+"_0").attr("scrollLeft",parseInt($("weather_"+eid+"_0").attr("scrollLeft"))-75);}function start(){}function stop(){}function nextWeatherMarquee(eid){$("weather_"+eid+"_0").attr("scrollLeft",parseInt($("weather_"+eid+"_0").attr("scrollLeft"))+75);}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _OutterSys=__webpack_require__(572);var _OutterSys2=_interopRequireDefault(_OutterSys);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var OutterSys=function(_React$Component){(0,_inherits3.default)(OutterSys,_React$Component);function OutterSys(props){(0,_classCallCheck3.default)(this,OutterSys);var _this=(0,_possibleConstructorReturn3.default)(this,(OutterSys.__proto__||(0,_getPrototypeOf2.default)(OutterSys)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(OutterSys,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/outtersys','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_OutterSys2.default,{data:edata.data||[],eid:eid,esetting:edata.esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return OutterSys;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OutterSys=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OutterSys);exports.default=OutterSys;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//集成登录元素
var OutterSysCom=function(_React$Component){(0,_inherits3.default)(OutterSysCom,_React$Component);function OutterSysCom(props){(0,_classCallCheck3.default)(this,OutterSysCom);var _this=(0,_possibleConstructorReturn3.default)(this,(OutterSysCom.__proto__||(0,_getPrototypeOf2.default)(OutterSysCom)).call(this,props));_this.handleOnClick=_this.handleOnClick.bind(_this);return _this;}(0,_createClass3.default)(OutterSysCom,[{key:'handleOnClick',value:function handleOnClick(routeUrl,linkUrl){var _props$esetting=this.props.esetting,esetting=_props$esetting===undefined?{}:_props$esetting;var _esetting$linkmode=esetting.linkmode,linkmode=_esetting$linkmode===undefined?'1':_esetting$linkmode;var url='';if(routeUrl!==''&&routeUrl!==undefined){// url = '/wui/index.jsp#/main' + routeUrl;
url='/spa/integration/static4engine/engine.html#/main'+routeUrl;}else{url=linkUrl;}if(url){if(linkmode=='1'){// 当前页打开
if(window.doThemeAction){window.doThemeAction('onLoadMain',{url:url});}else{window.location.href=url;}}else{window.open(url,'_blank');}}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,esetting=_props.esetting;var displaytype=esetting.displaytype,linkmode=esetting.linkmode,displayLayout=esetting.displayLayout;var num=parseInt(displayLayout);//显示布局 几列
var colArr=new Array();for(var i=0;i<num;i++){colArr.push(i);}var style={};if(num=='2'){style={width:'50%',float:'left',paddingLeft:'25%'};}else if(num=='3'){style={width:'33%',float:'left',paddingLeft:'11%'};}var html=colArr.map(function(i){if('1'===displaytype){//左图式
var dhtml=new Array();var ihtml=new Array();(0,_common.intervalMap)(data,function(obj,j){var n=i+j;var item=data[n];if(item){var name=item.name,routeUrl=item.routeUrl,linkUrl=item.linkUrl,url=item.url,width=item.width,height=item.height;height=height||'35';width=width||'35';name&&dhtml.push(_react2.default.createElement('div',{style:{height:parseInt(height)+3,lineHeight:parseInt(height)+3+'px',marginLeft:'10px'}},_react2.default.createElement('a',{style:{color:'#000000'},href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},name)));url&&ihtml.push(_react2.default.createElement('div',null,_react2.default.createElement('a',{target:Number(linkmode)===2?"_blank":"_self",href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},_react2.default.createElement('img',{height:height,width:width,src:url}))));}},num);return _react2.default.createElement('div',{style:style},_react2.default.createElement('div',{style:{float:'left'}},ihtml),_react2.default.createElement('div',{style:{float:'left'}},dhtml));}else{//上图式
var ohtml=(0,_common.intervalMap)(data,function(obj,j){var n=i+j;var item=data[n];var dHtml=_react2.default.createElement('div',null);var iHtml=_react2.default.createElement('div',null);if(item){var name=item.name,routeUrl=item.routeUrl,linkUrl=item.linkUrl,url=item.url,width=item.width,height=item.height;height=height||'35px';width=width||'35px';dHtml=_react2.default.createElement('div',{style:{height:height,lineHeight:height+'px'}},_react2.default.createElement('a',{style:{color:'#000000'},href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},name));iHtml=_react2.default.createElement('div',null,_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_this2.handleOnClick.bind(_this2,routeUrl,linkUrl)},_react2.default.createElement('img',{height:height,width:width,src:url})));}return _react2.default.createElement('div',null,iHtml,dHtml);},num);return _react2.default.createElement('div',{style:{textAlign:'center'}},_react2.default.createElement(_antd.Col,{span:24/num},ohtml));}});return _react2.default.createElement(_antd.Row,null,html);}}]);return OutterSysCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);OutterSysCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(OutterSysCom);exports.default=OutterSysCom;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Scratchpad=__webpack_require__(574);var _Scratchpad2=_interopRequireDefault(_Scratchpad);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Scratchpad=function(_React$Component){(0,_inherits3.default)(Scratchpad,_React$Component);function Scratchpad(props){(0,_classCallCheck3.default)(this,Scratchpad);var _this=(0,_possibleConstructorReturn3.default)(this,(Scratchpad.__proto__||(0,_getPrototypeOf2.default)(Scratchpad)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Scratchpad,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/scratchpad','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Scratchpad2.default,{data:edata.data,eid:eid});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Scratchpad;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Scratchpad=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Scratchpad);exports.default=Scratchpad;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ls=_ecCom.WeaTools.ls;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//便签元素
var ScratchpadCom=function(_React$Component){(0,_inherits3.default)(ScratchpadCom,_React$Component);function ScratchpadCom(props){(0,_classCallCheck3.default)(this,ScratchpadCom);var _this=(0,_possibleConstructorReturn3.default)(this,(ScratchpadCom.__proto__||(0,_getPrototypeOf2.default)(ScratchpadCom)).call(this,props));_this.state={text:props.data.text,disabled:false};_this.getBytesLength=_this.getBytesLength.bind(_this);_this.subStringByBytes=_this.subStringByBytes.bind(_this);_this.saveScratchpad=_this.saveScratchpad.bind(_this);_this.saveContent=_this.saveContent.bind(_this);return _this;}(0,_createClass3.default)(ScratchpadCom,[{key:'getBytesLength',value:function getBytesLength(str){// 在GBK编码里，除了ASCII字符，其它都占两个字符宽
return str.replace(/[^\x00-\xff]/g,'xx').length;}},{key:'subStringByBytes',value:function subStringByBytes(val,maxBytesLen){var len=maxBytesLen;var result=val.slice(0,len);while(getBytesLength(result)>maxBytesLen){result=result.slice(0,--len);}return result;}},{key:'saveScratchpad',value:function saveScratchpad(padcontent){this.state={text:padcontent,disabled:true};this.onSave(padcontent);}},{key:'onSave',value:function onSave(text){var len=this.getBytesLength(text);if(len>4000){var reply=confirm(getLabel(388031,"便签内容超过4000字节,内容将被截取,是否保存?"));if(reply){text=subStringByBytes(padcontent,4000);this.saveContent(text);}else{this.state={disabled:false};}}else{this.saveContent(text);}}},{key:'saveContent',value:function saveContent(padcontent){var _this2=this;var _props=this.props,eid=_props.eid,data=_props.data;var userid=data.userid;ls.set('edata-'+eid,padcontent);_ecCom.WeaTools.callApi('/api/portal/scratchpad/saveScratchpad','POST',{eid:eid,userid:userid,operation:'save',padcontent:padcontent},'text').then(function(result){_this2.state={disabled:false};});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(this.state.text,nextProps.data.text)){this.setState({text:nextProps.data.text});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(!(0,_lodash.isEqual)(this.state.text,nextProps.data.text)||!(0,_lodash.isEqual)(this.props.data.height,nextProps.data.height)){return true;}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var text=this.state.text;this.onSave(text);}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,eid=_props2.eid,data=_props2.data;var _state=this.state,text=_state.text,disabled=_state.disabled;return _react2.default.createElement('div',{id:'scratchpad_'+eid},_react2.default.createElement(_ecCom.WeaTextarea,{id:'scratchpadarea_'+eid,minRows:parseInt(data.height)/20,value:text,viewAttr:disabled?1:2,onChange:function onChange(v){_this3.setState({text:v});},onBlur:this.saveScratchpad}));}}]);return ScratchpadCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ScratchpadCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ScratchpadCom);exports.default=ScratchpadCom;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Slide=__webpack_require__(576);var _Slide2=_interopRequireDefault(_Slide);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Slide=function(_React$Component){(0,_inherits3.default)(Slide,_React$Component);function Slide(props){(0,_classCallCheck3.default)(this,Slide);var _this=(0,_possibleConstructorReturn3.default)(this,(Slide.__proto__||(0,_getPrototypeOf2.default)(Slide)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Slide,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/slide','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Slide2.default,{eid:eid,data:!refresh?edata.data:[],esetting:edata.esetting,isSetting:config.isSetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Slide;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Slide=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Slide);exports.default=Slide;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _common=__webpack_require__(10);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//幻灯片元素
var SlideCom=function(_React$Component){(0,_inherits3.default)(SlideCom,_React$Component);function SlideCom(){(0,_classCallCheck3.default)(this,SlideCom);return(0,_possibleConstructorReturn3.default)(this,(SlideCom.__proto__||(0,_getPrototypeOf2.default)(SlideCom)).apply(this,arguments));}(0,_createClass3.default)(SlideCom,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,eid=_props.eid,isSetting=_props.isSetting,esetting=_props.esetting;var iconImgList=esetting.iconImgList,iconImg_overList=esetting.iconImg_overList,values=esetting.values;if(values){loadSlideCss(eid,isSetting,iconImgList,iconImg_overList,values);}}},{key:'componentDidMount',value:function componentDidMount(){var _props2=this.props,eid=_props2.eid,isSetting=_props2.isSetting,esetting=_props2.esetting;var iconImgList=esetting.iconImgList,iconImg_overList=esetting.iconImg_overList,values=esetting.values;if(values){loadSlideCss(eid,isSetting,iconImgList,iconImg_overList,values);}}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,eid=_props3.eid,_props3$data=_props3.data,data=_props3$data===undefined?[]:_props3$data,_props3$esetting=_props3.esetting,esetting=_props3$esetting===undefined?{}:_props3$esetting;var values=esetting.values;var sposition=values?values['slide_t_position']:'0';var isAuto=values?values['slide_t_picShow']:'normal';var sdStyle={background:'url(\"\") no-repeat',cursor:'pointer'};var scStyle={cursor:'pointer'};var imgStyle=isAuto=='auto'?{}:{width:'100%',height:'100%'};var imgHtml=data.map(function(item,i){return _react2.default.createElement('div',{className:'slideDiv','data-index':i,alt:item.title+'...',style:sdStyle},_react2.default.createElement('img',{style:imgStyle,onClick:_common.openLinkUrl.bind(_this2,item.linkUrl,'3'),src:item.url,alt:''}),_react2.default.createElement('div',{className:'slideDiv',onClick:_common.openLinkUrl.bind(_this2,item.linkUrl,'3'),style:scStyle}));});var html=null;switch(sposition){case'1':html=_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{style:{width:'150px'}},_react2.default.createElement('div',{className:'slideTitle'},_react2.default.createElement('div',{className:'slideTitleFloat'}),_react2.default.createElement('div',{className:'slideTitleNavContainer'}))),_react2.default.createElement('td',{width:'*'},_react2.default.createElement('div',{className:'slideContinar',style:scStyle},imgHtml))));break;case'2':html=_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{width:'*'},_react2.default.createElement('div',{className:'slideContinar',style:scStyle},imgHtml)),_react2.default.createElement('td',{style:{width:'150px'}},_react2.default.createElement('div',{className:'slideTitle'},_react2.default.createElement('div',{className:'slideTitleFloat'}),_react2.default.createElement('div',{className:'slideTitleNavContainer'})))));break;default:html=_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('div',{className:'slideContinar',style:scStyle},imgHtml))),_react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('div',{className:'slideTitle'},_react2.default.createElement('div',{className:'slideTitleFloat'}),_react2.default.createElement('div',{className:'slideTitleNavContainer'})))));break;}return _react2.default.createElement('table',{style:{width:'100%',height:'165px',tableLayout:'fixed',borderSpacing:0},id:'slideArea_'+eid,border:'0'},html);}}]);return SlideCom;}(_react2.default.Component);//幻灯片播放图片效果
var loadSlideCss=function loadSlideCss(eid){var isSetting=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var iconImgList=arguments[2];var iconImg_overList=arguments[3];var values=arguments[4];$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitleNavContainer').empty();$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').cycle({//turnUp   //fade  //uncover
fx:values['slide_t_changeStyle'],//blindX     * blindY    * blindZ    * cover    * curtainX    * curtainY    * fade    * fadeZoom    * growX    * growY    * none   * scrollUp    * scrollDown    * scrollLeft    * scrollRight    * scrollHorz    * scrollVert    * shuffle    * slideX    * lideY   * toss    * turnUp    * turnDown    * turnLeft    * turnRight    * uncover    * wipe    * zoom*/
timeout:(0,_common._s2Int)(values['slide_t_AutoChangeTime']),pager:'.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitleNavContainer',pagerAnchorBuilder:pagerFactory,before:function before(currSlideElement,nextSlideElement,options,forwardFlag){var nextIndex=$(nextSlideElement).attr("data-index");var slidnavtitleArray=$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slidnavtitle");var newTop=0;var newLeft=0;if(slidnavtitleArray.length!=0){var nextSlidnavtitle=$($(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slidnavtitle")[nextIndex]);newTop=nextSlidnavtitle.position().top;if(values['slide_t_position']==='2'){newLeft=nextSlidnavtitle.position().right;}else{newLeft=nextSlidnavtitle.position().left;}}var topvalue=values['slide_t_position']==='3'?newTop-10:newTop;var backgroundsize=values['slide_t_picShow']=="normal"?"100% 100% ":"";if(values['slide_t_position']==='2'){$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slideTitleFloat").css({"display":"block","top":topvalue,"right":newLeft,"background":"url("+iconImg_overList[nextIndex]+") no-repeat","background-size":backgroundsize});}else{$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slideTitleFloat").css({"display":"block","top":topvalue,"left":newLeft,"background":"url("+iconImg_overList[nextIndex]+") no-repeat","background-size":backgroundsize});}},fit:1,width:'100%',height:'100%'});$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').addClass("slideritem");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').css("width","100%");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar').css("overflow","hidden");$('.homepage[data-isSetting='+isSetting+'] #content_view_id_'+eid).css("overflow","hidden");function pagerFactory(idx,slide){if(values['slide_t_position']==='3'){var s=idx>3?' style="display:true"':'';}else{var s=idx>3?' style="display:none"':'';}var className="";if(idx===0){className="activeSlide";}if(values['slide_t_picShow']=="normal"){return'<div '+s+' class="slidnavtitle '+className+'"  style="background:url('+iconImgList[idx]+') no-repeat;background-size:100% 100%;">&nbsp;</div>';}else{return'<div '+s+' class="slidnavtitle '+className+'"  style="background:url('+iconImgList[idx]+') no-repeat;">&nbsp;</div>';}};if(values['slide_t_position']==='3'){$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid).find(".slideTitleNavContainer").css({"margin":"0 auto"});$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid+" .slideTitleFloat").css({"margin":"0 auto","top":10+Math.round($(".slideTitleFloat").offset().top)+"px"});}$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("z-index","1001");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("position","relative");if(values['slide_t_position']==='1'){$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("width","150px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("float","left");}if(values['slide_t_position']==='2'){$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("width","150px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("float","right");}if(values['slide_t_position']==='3'){$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("height","40px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("padding-top","10px");$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle').css("text-align","center");}var slidnavtitle=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitle  .slidnavtitle');slidnavtitle.css("cursor","pointer");if(values['slide_t_position']==='3'){slidnavtitle.css("margin-right","5px");slidnavtitle.css("height","40px");slidnavtitle.css("width","75px");slidnavtitle.css("float","left");}else{slidnavtitle.css("height","40px");}var slidnavtitle=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideTitleFloat');slidnavtitle.css("position","absolute");slidnavtitle.css("display","block");if(values['slide_t_position']==='3'){slidnavtitle.css("height","40px");slidnavtitle.css("width","79px");}else{slidnavtitle.css("height","40px");slidnavtitle.css("width","165px");}var slideContinar=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideContinar');var slideDev=$('.homepage[data-isSetting='+isSetting+'] #slideArea_'+eid+' .slideDiv');slideContinar.css("padding","0");slideContinar.css("overflow","hidden");slideContinar.css("table-layout","fixed");slideContinar.css("width","100%");slideContinar.css("margin","0");if(values['slide_t_position']==='3'){slideContinar.css("height","220px");slideDev.css("height","220px");}else{slideContinar.css("height","160px");slideDev.css("height","160px");}var slideTitleNavContainer=$(".homepage[data-isSetting="+isSetting+"] #slideArea_"+eid).find(".slideTitleNavContainer");if(values['slide_t_position']==='3'){slideTitleNavContainer.css("display","inline-block");slideTitleNavContainer.css("_display","block");}};var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SlideCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SlideCom);exports.default=SlideCom;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var JobsInfo=function(_React$Component){(0,_inherits3.default)(JobsInfo,_React$Component);function JobsInfo(props){(0,_classCallCheck3.default)(this,JobsInfo);var _this=(0,_possibleConstructorReturn3.default)(this,(JobsInfo.__proto__||(0,_getPrototypeOf2.default)(JobsInfo)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(JobsInfo,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/jobsinfo','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return JobsInfo;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);JobsInfo=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(JobsInfo);exports.default=JobsInfo;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _SearchEngine=__webpack_require__(579);var _SearchEngine2=_interopRequireDefault(_SearchEngine);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var SearchEngine=function(_React$Component){(0,_inherits3.default)(SearchEngine,_React$Component);function SearchEngine(props){(0,_classCallCheck3.default)(this,SearchEngine);var _this=(0,_possibleConstructorReturn3.default)(this,(SearchEngine.__proto__||(0,_getPrototypeOf2.default)(SearchEngine)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(SearchEngine,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/searchengine','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_SearchEngine2.default,{data:edata.data,eid:eid});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return SearchEngine;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SearchEngine=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SearchEngine);exports.default=SearchEngine;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(41);var _classnames2=_interopRequireDefault(_classnames);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var InputGroup=_antd.Input.Group;//搜索元素
var SearchEngineCom=function(_React$Component){(0,_inherits3.default)(SearchEngineCom,_React$Component);function SearchEngineCom(){(0,_classCallCheck3.default)(this,SearchEngineCom);return(0,_possibleConstructorReturn3.default)(this,(SearchEngineCom.__proto__||(0,_getPrototypeOf2.default)(SearchEngineCom)).apply(this,arguments));}(0,_createClass3.default)(SearchEngineCom,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data;return _react2.default.createElement('div',{id:'searchengine_'+eid,style:{paddingTop:'10px',paddingBottom:"10px"}},_react2.default.createElement(SearchInput,{placeholder:getLabel(388032,"请输入您要搜索的内容"),onSearch:function onSearch(value){return window.open(data.url+'&keyword='+value);},style:{width:300}}));}}]);return SearchEngineCom;}(_react2.default.Component);var SearchInput=_react2.default.createClass({displayName:'SearchInput',getInitialState:function getInitialState(){return{value:'',focus:false};},handleInputChange:function handleInputChange(e){this.setState({value:e.target.value});},handleFocusBlur:function handleFocusBlur(e){this.setState({focus:e.target===document.activeElement});},handleSearch:function handleSearch(){if(this.props.onSearch){this.props.onSearch(this.state.value);}},render:function render(){var _props2=this.props,style=_props2.style,size=_props2.size,placeholder=_props2.placeholder;var btnCls=(0,_classnames2.default)({'ant-search-btn':true,'ant-search-btn-noempty':!!this.state.value.trim(),'portal-serachButton':true});var searchCls=(0,_classnames2.default)({'ant-search-input':true,'ant-search-input-focus':this.state.focus});return _react2.default.createElement('div',{className:'ant-search-input-wrapper',style:style},_react2.default.createElement(InputGroup,{className:searchCls},_react2.default.createElement(_antd.Input,{placeholder:placeholder,value:this.state.value,onChange:this.handleInputChange,onFocus:this.handleFocusBlur,onBlur:this.handleFocusBlur,onPressEnter:this.handleSearch}),_react2.default.createElement('div',{className:'ant-input-group-wrap'},_react2.default.createElement(_antd.Button,{icon:'search',height:'26px',className:btnCls,size:size,onClick:this.handleSearch}))));}});var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SearchEngineCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SearchEngineCom);exports.default=SearchEngineCom;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _CustomMenu=__webpack_require__(581);var _CustomMenu2=_interopRequireDefault(_CustomMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var CustomMenu=function(_React$Component){(0,_inherits3.default)(CustomMenu,_React$Component);function CustomMenu(props){(0,_classCallCheck3.default)(this,CustomMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(CustomMenu.__proto__||(0,_getPrototypeOf2.default)(CustomMenu)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(CustomMenu,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/custommenu','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var menuType=esetting.menuType;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_CustomMenu2.default,{config:config,data:edata.data,eid:eid,esetting:esetting});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),// menuType && menuType =='menuh' ? <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%', minHeight: '46px'}}>
//     <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
//         <div style={{position: 'absolute', zIndex: '10'}}>
//             <Spin spinning={refresh}>{EContentHtml}</Spin>
//         </div>
//     </div>
//     <div style = {{textAlign:'right'}} id={`footer_${eid}`}></div>
// </div>
//     :
_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return CustomMenu;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomMenu=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomMenu);exports.default=CustomMenu;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);__webpack_require__(582);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//自定义菜单元素
var CustomMenuCom=function(_React$Component){(0,_inherits3.default)(CustomMenuCom,_React$Component);function CustomMenuCom(){(0,_classCallCheck3.default)(this,CustomMenuCom);return(0,_possibleConstructorReturn3.default)(this,(CustomMenuCom.__proto__||(0,_getPrototypeOf2.default)(CustomMenuCom)).apply(this,arguments));}(0,_createClass3.default)(CustomMenuCom,[{key:'render',value:function render(){var _props=this.props,eid=_props.eid,esetting=_props.esetting,data=_props.data;var menuType=esetting.menuType;var menuHtml='';if(menuType=='menuh'){menuHtml=getMenuHHtml(data,0);}else if(menuType=='menuv'){menuHtml=getMenuVHtml(data,0);}return _react2.default.createElement('div',{id:'menu_'+eid},_react2.default.createElement('div',{className:menuType},menuHtml));}}]);return CustomMenuCom;}(_react2.default.Component);var getMenuHHtml=function getMenuHHtml(data,level,linkmode){return _react2.default.createElement('ul',null,data.map(function(item){var status="";if(level==0){status="/js/jquery/plugins/menu/menuh/down_wev8.gif";}else{status="/js/jquery/plugins/menu/menuh/right_wev8.gif";}return _react2.default.createElement('li',null,_react2.default.createElement('a',{href:'javascript:;',onClick:function onClick(){return(0,_common.openLinkUrl)(item.href);},className:level==0?'main':'sub'},item.name,item.children.length!=0?_react2.default.createElement('img',{style:{position:"absolute",top:"10px",right:"10px"},src:status}):null),getMenuHHtml(item.children,level+1));}));};var getMenuVHtml=function getMenuVHtml(data,level){return data.map(function(item,index){return _react2.default.createElement('div',{className:index==0?'mainBg_top':'mainBg'},_react2.default.createElement('a',{href:'javascript:;',onClick:function onClick(){return(0,_common.openLinkUrl)(item.href,item.target=='mainFrame'?'1':'2');},className:'mainFont'},item.name),item.children.map(function(item){return _react2.default.createElement('a',{href:'javascript:;',onClick:function onClick(){return(0,_common.openLinkUrl)(item.href,item.target=='mainFrame'?'1':'2');},className:'sub'},item.name);}));});};var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CustomMenuCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CustomMenuCom);exports.default=CustomMenuCom;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(583);__webpack_require__(584);__webpack_require__(585);

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _Notice=__webpack_require__(587);var _Notice2=_interopRequireDefault(_Notice);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Notice=function(_React$Component){(0,_inherits3.default)(Notice,_React$Component);function Notice(props){(0,_classCallCheck3.default)(this,Notice);var _this=(0,_possibleConstructorReturn3.default)(this,(Notice.__proto__||(0,_getPrototypeOf2.default)(Notice)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Notice,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/notice','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_Notice2.default,{data:edata.data,eid:eid});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Notice;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Notice=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Notice);exports.default=Notice;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//公告栏元素
var NoticeCom=function(_React$Component){(0,_inherits3.default)(NoticeCom,_React$Component);function NoticeCom(){(0,_classCallCheck3.default)(this,NoticeCom);return(0,_possibleConstructorReturn3.default)(this,(NoticeCom.__proto__||(0,_getPrototypeOf2.default)(NoticeCom)).apply(this,arguments));}(0,_createClass3.default)(NoticeCom,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,eid=_props.eid,data=_props.data;var direction=data.direction,scrollDelay=data.scrollDelay;$("#notice_marq"+eid).attr({direction:direction,onmouseout:'this.start()',onmouseover:'this.stop()',scrollAmount:'1',align:'bottom',scrollDelay:scrollDelay,scrollleft:'0',scrolltop:'0'});}},{key:'render',value:function render(){var _props2=this.props,eid=_props2.eid,data=_props2.data;var content=data.content,onlytext=data.onlytext,title=data.title,img=data.img;var chtml=onlytext==='yes'?_react2.default.createElement('span',null,content):_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:content}});var width='95%';var thtml=null;if(title){width='75%';thtml=_react2.default.createElement('div',{style:{float:'left',marginLeft:'5px',width:'20%'}},title);}return _react2.default.createElement('div',null,_react2.default.createElement('div',{style:{float:'left',marginLeft:'5px'}},_react2.default.createElement('img',{src:img})),thtml,_react2.default.createElement('div',{style:{float:'right',marginLeft:'10px',width:width}},_react2.default.createElement('marquee',{id:'notice_marq'+eid},chtml)));}}]);return NoticeCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NoticeCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NoticeCom);exports.default=NoticeCom;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(589);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Mail=function(_React$Component){(0,_inherits3.default)(Mail,_React$Component);function Mail(props){(0,_classCallCheck3.default)(this,Mail);var _this=(0,_possibleConstructorReturn3.default)(this,(Mail.__proto__||(0,_getPrototypeOf2.default)(Mail)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Mail,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/mail','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'unread':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,getElementStyle:this.props.getElementStyle,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Mail;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Mail=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Mail);exports.default=Mail;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _Title=__webpack_require__(590);var _Title2=_interopRequireDefault(_Title);var _Mail=__webpack_require__(591);var _Mail2=_interopRequireDefault(_Mail);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));var currentTab=props.edata.currenttab||props.edata.tabids[0];_this.state={tabdata:props.edata.data[currentTab],currentTab:currentTab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){var currentTab=nextProps.edata.currenttab||nextProps.edata.tabids[0];this.setState({tabdata:nextProps.edata.data[currentTab],currentTab:currentTab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props=this.props,edata=_props.edata,config=_props.config;var params=config.params;var currentTab=this.state.currentTab;this.setState({currentTab:tabid,tabdata:edata.data[tabid],refresh:tabid===currentTab});setTimeout(function(){_this2.setState({refresh:false});},100);}},{key:'render',value:function render(){var contentHtml=_react2.default.createElement('div',null);var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting,data=edata.data;var goUrl=data.goUrl;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};if(tabdata){contentHtml=_react2.default.createElement(_Mail2.default,{list:tabdata,currTab:currentTab,esetting:esetting,olist:edata.data.oplist,goUrl:goUrl});}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//我的邮件
var MailCom=function(_React$Component){(0,_inherits3.default)(MailCom,_React$Component);function MailCom(){(0,_classCallCheck3.default)(this,MailCom);return(0,_possibleConstructorReturn3.default)(this,(MailCom.__proto__||(0,_getPrototypeOf2.default)(MailCom)).apply(this,arguments));}(0,_createClass3.default)(MailCom,[{key:'render',value:function render(){var _props=this.props,currTab=_props.currTab,list=_props.list,esetting=_props.esetting,olist=_props.olist,goUrl=_props.goUrl;var operHtml=null;var receiveUrl=goUrl+'&'+olist.map(function(item){return'receivemailid='+item.id;}).join('&');if(esetting.opershow&&currTab==='unread'){operHtml=_react2.default.createElement('div',{className:'mail-sparator'},_react2.default.createElement('font',{className:'mail-sparator-font'},getLabel(388018,"邮件服务器上的新邮件:"),'\xA0',olist.map(function(item){return _react2.default.createElement('span',null,item.name,'(',item.number,')');}),'\xA0',_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_common.openLinkUrl.bind(this,receiveUrl)},getLabel(20267,"进入我的邮件收取"))));}return _react2.default.createElement('div',null,list.length!==0?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(list[0],esetting),showHeader:false,pagination:false,dataSource:list,size:'small'}):_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,' ',_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据'))),operHtml);}}]);return MailCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MailCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MailCom);exports.default=MailCom;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(63);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var CoreMail=function(_React$Component){(0,_inherits3.default)(CoreMail,_React$Component);function CoreMail(props){(0,_classCallCheck3.default)(this,CoreMail);var _this=(0,_possibleConstructorReturn3.default)(this,(CoreMail.__proto__||(0,_getPrototypeOf2.default)(CoreMail)).call(this,props));_this.state={edata:null,refresh:false,weaCoreMailLoaded:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(CoreMail,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/coremail','POST',(0,_extends3.default)({},params)).then(function(result){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+(0,_stringify2.default)(result)};ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillMount',value:function componentWillMount(){var _this3=this;// 异步加载集成模块静态资源
eventRegister.loadModule('b_integration',function(){setTimeout(function(){return _this3.setState({weaCoreMailLoaded:true});},100);},function(){});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,weaCoreMailLoaded=_state.weaCoreMailLoaded;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){EContentHtml=weaCoreMailLoaded&&window.weaIntegrationEngine&&window.weaIntegrationEngine.com?_react2.default.createElement(window.weaIntegrationEngine.com.CoremailForPortal,{params:edata}):_react2.default.createElement('div',null);}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return CoreMail;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CoreMail=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CoreMail);exports.default=CoreMail;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(594);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var BlogStatus=function(_React$Component){(0,_inherits3.default)(BlogStatus,_React$Component);function BlogStatus(props){(0,_classCallCheck3.default)(this,BlogStatus);var _this=(0,_possibleConstructorReturn3.default)(this,(BlogStatus.__proto__||(0,_getPrototypeOf2.default)(BlogStatus)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(BlogStatus,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/blogstatus','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var currenttab=edata.currenttab,tabids=edata.tabids,titles=edata.titles,counts=edata.counts,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,counts:counts,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return BlogStatus;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);BlogStatus=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(BlogStatus);exports.default=BlogStatus;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(595);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));var currentTab=props.edata.currenttab||props.edata.tabids[0];_this.state={tabdata:props.edata.data[currentTab],currentTab:currentTab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){var currentTab=nextProps.edata.currenttab||nextProps.edata.tabids[0];this.setState({tabdata:nextProps.edata.data[currentTab],currentTab:currentTab,refresh:false});}}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props=this.props,edata=_props.edata,config=_props.config;var params=config.params;var currentTab=this.state.currentTab;this.setState({currentTab:tabid,tabdata:edata.data[tabid],refresh:tabid===currentTab});setTimeout(function(){_this2.setState({refresh:false});},100);}},{key:'render',value:function render(){var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var eid=config.item.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting,counts=edata.counts;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var contentHtml=tabdata&&tabdata.length?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata[0],esetting),showHeader:false,pagination:false,dataSource:tabdata,size:'small'}):_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,' ',_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,counts:counts,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,config=_props3.config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,_props3$counts=_props3.counts,counts=_props3$counts===undefined?[]:_props3$counts,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$item3=config.item,eid=_config$item3.eid,ebaseid=_config$item3.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(597);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Contacts=function(_React$Component){(0,_inherits3.default)(Contacts,_React$Component);function Contacts(props){(0,_classCallCheck3.default)(this,Contacts);var _this=(0,_possibleConstructorReturn3.default)(this,(Contacts.__proto__||(0,_getPrototypeOf2.default)(Contacts)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Contacts,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/contacts','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentWillMount',value:function componentWillMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,fontSizeMp:fontSizeMp,config:config,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Contacts;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Contacts=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Contacts);exports.default=Contacts;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(598);var _Title2=_interopRequireDefault(_Title);var _Contacts=__webpack_require__(599);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.searchContacts=_this.searchContacts.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid,value){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/contactstab','POST',(0,_extends3.default)({},params,{tabid:tabid,key:typeof value=='string'?value:''})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'searchContacts',value:function searchContacts(value){this.handleTabData(this.state.currentTab,value);}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=tabdata&&tabdata.data.length?_react2.default.createElement(_Contacts.ContactsCom,{eid:eid,list:tabdata.data,esetting:esetting}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,tabwimethodvaluedth:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Contacts.SearchInput,{placeholder:getLabel(83815,"搜索姓名/首字母/手机号"),type:'contacts',onSearch:this.searchContacts,style:{width:'300px',marginTop:'5px'}}),_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _classnames=__webpack_require__(41);var _classnames2=_interopRequireDefault(_classnames);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InputGroup=_antd.Input.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ContactsCom=function(_React$Component){(0,_inherits3.default)(ContactsCom,_React$Component);function ContactsCom(){(0,_classCallCheck3.default)(this,ContactsCom);return(0,_possibleConstructorReturn3.default)(this,(ContactsCom.__proto__||(0,_getPrototypeOf2.default)(ContactsCom)).apply(this,arguments));}(0,_createClass3.default)(ContactsCom,[{key:'openHrm',value:function openHrm(url){if(url)window.open(url);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,eid=_props.eid,list=_props.list,esetting=_props.esetting;var widths=esetting.widths,imgSymbol=esetting.imgSymbol,_esetting$fontStyle=esetting.fontStyle,fontStyle=_esetting$fontStyle===undefined?{}:_esetting$fontStyle;var _fontStyle$contentfon=fontStyle.contentfontsize,contentfontsize=_fontStyle$contentfon===undefined?'12':_fontStyle$contentfon;var trArr=new Array();list.map(function(item,i){var size=1;var tdArr=new Array();var index=0;tdArr.push(_react2.default.createElement('td',{height:'31',width:'8px'},imgSymbol?_react2.default.createElement('img',{name:'esymbol',src:imgSymbol}):null));for(var k in item){if('name'===k){tdArr.push(_react2.default.createElement('td',{style:{minWidth:'90px'},height:'31','data-order':size-1},_react2.default.createElement('a',{href:'javascript:void(0);',onClick:_this2.openHrm.bind(_this2,item[k].link)},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize,style:{cursor:'pointer'}},item[k].name))));}if('department'===k){tdArr.push(_react2.default.createElement('td',{width:'*','data-order':size-1,height:'31',style:{textAlign:'left'}},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},item[k])));}if('subcompany'===k){tdArr.push(_react2.default.createElement('td',{width:widths[index],height:'31','data-order':size-1,style:{textAlign:'left'}},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},item[k])));}if('tel'===k){tdArr.push(_react2.default.createElement('td',{width:widths[index],height:'31','data-order':size-1,style:{textAlign:'left'}},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},item[k])));}if('mobile'===k){tdArr.push(_react2.default.createElement('td',{width:widths[index],height:'31','data-order':size-1,style:{textAlign:'left'}},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},item[k])));}if('email'===k){tdArr.push(_react2.default.createElement('td',{width:widths[index],height:'31','data-order':size-1,style:{textAlign:'left'}},_react2.default.createElement('font',{className:'font wea-f'+contentfontsize},item[k])));}index+=1;}trArr.push(_react2.default.createElement('tr',{height:'31'},tdArr));});return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_contacts_scrollId',height:250},_react2.default.createElement('table',{id:'_contenttable_'+eid,className:'Econtent elementdatatable',style:{tableLayout:'auto',margin:0},width:'100%'},_react2.default.createElement('tbody',null,trArr)));}}]);return ContactsCom;}(_react2.default.Component);var SearchInput=_react2.default.createClass({displayName:'SearchInput',getInitialState:function getInitialState(){return{value:'',focus:false};},handleInputChange:function handleInputChange(e){var _this3=this;this.setState({value:e.target.value});setTimeout(function(){return _this3.props.onSearch(_this3.state.value);},500);},handleFocusBlur:function handleFocusBlur(e){this.setState({focus:e.target===document.activeElement});},handleSearch:function handleSearch(){if(this.props.onSearch){this.props.onSearch(this.state.value);}},render:function render(){var _props2=this.props,style=_props2.style,size=_props2.size,placeholder=_props2.placeholder;var btnCls=(0,_classnames2.default)({'ant-search-btn':true,'ant-search-btn-noempty':!!this.state.value.trim(),'portal-serachButton':true});var searchCls=(0,_classnames2.default)({'ant-search-input':true,'ant-search-input-focus':this.state.focus});return _react2.default.createElement('div',{className:'ant-search-input-wrapper',style:style},_react2.default.createElement(InputGroup,{className:searchCls},_react2.default.createElement(_antd.Input,{placeholder:placeholder,value:this.state.value,onChange:this.handleInputChange,onFocus:this.handleFocusBlur,onBlur:this.handleFocusBlur,onPressEnter:this.handleSearch}),_react2.default.createElement('div',{className:'ant-input-group-wrap'},_react2.default.createElement(_antd.Button,{icon:'search',className:btnCls,size:size,onClick:this.handleSearch}))));}});module.exports={ContactsCom:ContactsCom,SearchInput:SearchInput};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(601);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var AddWf=function(_React$Component){(0,_inherits3.default)(AddWf,_React$Component);function AddWf(props){(0,_classCallCheck3.default)(this,AddWf);var _this=(0,_possibleConstructorReturn3.default)(this,(AddWf.__proto__||(0,_getPrototypeOf2.default)(AddWf)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(AddWf,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/addwf','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return AddWf;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);AddWf=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(AddWf);exports.default=AddWf;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(602);var _Title2=_interopRequireDefault(_Title);var _lodash=__webpack_require__(9);var _AddWf=__webpack_require__(603);var _AddWf2=_interopRequireDefault(_AddWf);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/addwftab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var contentHtml=_react2.default.createElement('div',{width:'100%'});var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};if(!(0,_lodash.isEmpty)(tabdata)){contentHtml=_react2.default.createElement(_AddWf2.default,{eid:eid,data:tabdata,esetting:esetting,contentview:contentview});}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;// 新建流程元素
var AddWfCom=function(_React$Component){(0,_inherits3.default)(AddWfCom,_React$Component);function AddWfCom(props){(0,_classCallCheck3.default)(this,AddWfCom);var _this=(0,_possibleConstructorReturn3.default)(this,(AddWfCom.__proto__||(0,_getPrototypeOf2.default)(AddWfCom)).call(this,props));_this.state={height:40};return _this;}(0,_createClass3.default)(AddWfCom,[{key:'componentDidMount',value:function componentDidMount(){var _height=jQuery('#element_addwf_scrollId .ant-table-row').height();this.setState({height:_height});}},{key:'render',value:function render(){var _props=this.props,data=_props.data,esetting=_props.esetting,contentview=_props.contentview;var height=this.state.height;var __height=5*height;if(contentview&&contentview.style&&contentview.style.height){__height=contentview.style.height;}var list=data.data;var columns=(0,_common.formatData)(list[0],esetting);if("1"===esetting.displayLayout)return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_addwf_scrollId',height:__height},_react2.default.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'}));var evenData=new Array();var oddData=new Array();(0,_common.intervalMap)(list,function(item,i){oddData.push(item);if(list[i+1]!==undefined)evenData.push(list[i+1]);},2);return _react2.default.createElement(_antd.Row,null,_react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_addwf_scrollId',height:__height},(0,_lodash.isEmpty)(evenData)&&(0,_lodash.isEmpty)(oddData)?_react2.default.createElement('div',null,_react2.default.createElement(_antd.Row,null,_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('span',null,_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据'))))):_react2.default.createElement('div',null,_react2.default.createElement(_antd.Col,{span:12,order:1},!(0,_lodash.isEmpty)(oddData)&&_react2.default.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:oddData,size:'small'})),_react2.default.createElement(_antd.Col,{span:12,order:2},!(0,_lodash.isEmpty)(evenData)&&_react2.default.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:evenData,size:'small'})))));}}]);return AddWfCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);AddWfCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(AddWfCom);exports.default=AddWfCom;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(605);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Task=function(_React$Component){(0,_inherits3.default)(Task,_React$Component);function Task(props){(0,_classCallCheck3.default)(this,Task);var _this=(0,_possibleConstructorReturn3.default)(this,(Task.__proto__||(0,_getPrototypeOf2.default)(Task)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(Task,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/task','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Task;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Task=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Task);exports.default=Task;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(606);var _Title2=_interopRequireDefault(_Title);var _Task=__webpack_require__(607);var _Task2=_interopRequireDefault(_Task);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/tasktab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,counts=edata.counts,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=tabdata?_react2.default.createElement(_Task2.default,{eid:eid,data:tabdata,esetting:esetting}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,counts:counts,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props3=this.props,currentTab=_props3.currentTab,_props3$config=_props3.config,config=_props3$config===undefined?{}:_props3$config,_props3$tabids=_props3.tabids,tabids=_props3$tabids===undefined?[]:_props3$tabids,_props3$titles=_props3.titles,titles=_props3$titles===undefined?[]:_props3$titles,counts=_props3.counts,handleRefresh=_props3.handleRefresh,handleDelete=_props3.handleDelete,handleTabData=_props3.handleTabData,fontSizeMp=_props3.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}// let tHtml=titles.map((title, i)=> {
//     if (!isEmpty(counts)) {
//         if ('0' !== counts[i]) {
//              title += ' (<font style="color:red">' + counts[i] + '</font>)';
//         }
//     }
//     let name = title;
//     title=title.replace(`<font style="color:red">`,"");
//     title=title.replace(`</font>`,"");
//     const className = tabids[i] == currentTab ? `tab2selected wea-f${fontStyle.tab1fontsize || 12}` : `tab2unselected wea-f${fontStyle.tab2fontsize || 12}`;
//     return <td title={title} data-tabid={tabids[i]} style={this.props.methodvalue == '2'? tdStyle1 : tdStyle} className={className} onClick={handleTabData.bind(this, tabids[i])} dangerouslySetInnerHTML={{__html:name}}></td>
// });
var className=tabids.length<=1?'nodisplay':'';return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//任务元素
var TaskCom=function(_React$Component){(0,_inherits3.default)(TaskCom,_React$Component);function TaskCom(){(0,_classCallCheck3.default)(this,TaskCom);return(0,_possibleConstructorReturn3.default)(this,(TaskCom.__proto__||(0,_getPrototypeOf2.default)(TaskCom)).apply(this,arguments));}(0,_createClass3.default)(TaskCom,[{key:'render',value:function render(){var _props=this.props,data=_props.data,esetting=_props.esetting;var display=esetting.display;var list=data.data;var nlist=new Array();list.map(function(item){var i=0;var obj=new Object();for(var k in item){if(display[i]===1){obj[k]=item[k];}i+=1;}nlist.push(obj);});return nlist.length?_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(nlist[0],esetting),pagination:false,dataSource:nlist,size:'small'}):_react2.default.createElement('div',null);}}]);return TaskCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);TaskCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(TaskCom);exports.default=TaskCom;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _NewNotice=__webpack_require__(609);var _NewNotice2=_interopRequireDefault(_NewNotice);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;var Base64=ecCom.WeaTools.Base64;//元素组件
var NewNotice=function(_React$Component){(0,_inherits3.default)(NewNotice,_React$Component);function NewNotice(props){(0,_classCallCheck3.default)(this,NewNotice);var _this=(0,_possibleConstructorReturn3.default)(this,(NewNotice.__proto__||(0,_getPrototypeOf2.default)(NewNotice)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(NewNotice,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/newnotice','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);window.elements_more_params[eid]={canAddNotice:result.esetting&&result.esetting.canAddNotice,isRouteUrl:true,createMethod:result.esetting&&result.esetting.createMethod||'1',paramsStr:result.esetting&&result.esetting.createMethod=='2'?"&jsonstr="+Base64.encode(result.esetting.more.toString()):''};_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;if((0,_lodash.isEmpty)(edata))return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var _esetting$eScrollDire=esetting.eScrollDirection,eScrollDirection=_esetting$eScrollDire===undefined?{}:_esetting$eScrollDire,scrollSpeed=esetting.scrollSpeed,noticeIsText=esetting.noticeIsText;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);var scolltype='none';if(eScrollDirection.selected){switch(eScrollDirection.selected){case'1':scolltype='up';break;case'2':scolltype='right';break;case'3':scolltype='down';break;case'4':scolltype='left';break;default:scolltype='none';}}if(isHasRight){if(!(0,_lodash.isEmpty)(edata)){// EContentHtml = <MarqueeCom tabdata={edata} eid={eid} scolltype={scolltype} scrollSpeed={scrollSpeed}><NewNoticeCom eid={eid} data={edata.data} esetting={edata.esetting} handleRefresh={this.handleRefresh} scolltype={scolltype} scrollSpeed={scrollSpeed}/></MarqueeCom>;
EContentHtml=_react2.default.createElement(_NewNotice2.default,{eid:eid,data:edata.data,esetting:edata.esetting,handleRefresh:this.handleRefresh,scolltype:scolltype,scrollSpeed:scrollSpeed});}}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'ant-spin-container'}),_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement('div',{id:'tabcontant_'+eid},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml))),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return NewNotice;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewNotice=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewNotice);exports.default=NewNotice;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _common=__webpack_require__(10);var _weaPortalPublic=__webpack_require__(65);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//公告元素
var NewNoticeCom=function(_React$Component){(0,_inherits3.default)(NewNoticeCom,_React$Component);function NewNoticeCom(props){(0,_classCallCheck3.default)(this,NewNoticeCom);var _this=(0,_possibleConstructorReturn3.default)(this,(NewNoticeCom.__proto__||(0,_getPrototypeOf2.default)(NewNoticeCom)).call(this,props));_this.handleAddNotice=_this.handleAddNotice.bind(_this);_this.onSubmitDoc=_this.onSubmitDoc.bind(_this);return _this;}(0,_createClass3.default)(NewNoticeCom,[{key:'handleAddNotice',value:function handleAddNotice(state){this.refs.addNotice.onSetState(state);}},{key:'onSubmitDoc',value:function onSubmitDoc(ids,names,datas){var _props=this.props,eid=_props.eid,handleRefresh=_props.handleRefresh;_ecCom.WeaTools.callApi('/api/portal/noticeadd/addNotice','POST',{eid:eid,docids:ids}).then(function(result){if(result.status=='2'){_antd.message.error(result.errormsg);}else{_antd.message.success("添加成功！");handleRefresh();}});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,eid=_props2.eid,data=_props2.data,esetting=_props2.esetting,handleRefresh=_props2.handleRefresh,scolltype=_props2.scolltype,scrollSpeed=_props2.scrollSpeed;var canAddNotice=esetting.canAddNotice,showContent=esetting.showContent,showImg=esetting.showImg,noticeNew=esetting.noticeNew,showTitle=esetting.showTitle,createMethod=esetting.createMethod,pageSize=esetting.pageSize,multiPage=esetting.multiPage,noticeIsText=esetting.noticeIsText,eScrollDirection=esetting.eScrollDirection,linkmode=esetting.linkmode,perpage_old=esetting.perpage;var perpage=parseInt(pageSize);var __perpage=perpage;if(multiPage=='0'){perpage=parseInt(data.length);__perpage=perpage_old;};var __showImg=showImg;if(eScrollDirection.selected=='2'||eScrollDirection.selected=='4'){__perpage=1;__showImg=false;}var html=[];var repalceDatas=[];(0,_common.intervalMap)(data.slice(0,perpage_old),function(obj,i){var arr=[];for(var j=0;j<__perpage;j++){var n=i+j;var item=data.slice(0,perpage_old)[n];if(item){repalceDatas.push({id:item.id,name:item.title});arr.push(_react2.default.createElement(NoticeItem,{handleClick:_this2.handleAddNotice,showImg:__showImg,showTitle:showTitle,showContent:showContent,createMethod:createMethod,item:item,linkmode:linkmode}));}}html.push(_react2.default.createElement('div',null,arr));},perpage);var htmlMultiPage=_react2.default.createElement('div',null);if(multiPage=='0')htmlMultiPage=html;//不分页
else htmlMultiPage=_react2.default.createElement(_antd.Carousel,{autoplay:html.length>1,dots:html.length>1},html);// 分页
// 纯文本
if(noticeIsText=='1'&&data.length!==0){htmlMultiPage=_react2.default.createElement('div',{className:'portal-element-doc-content',id:'__content__'+eid,dangerouslySetInnerHTML:{__html:data[0].title+'&nbsp'+data[0].content}});}// 纯文本并且向左向右滚动
if(eScrollDirection.selected&&noticeIsText=='1'&&data.length!==0&&(eScrollDirection.selected=='2'||eScrollDirection.selected=='4')){htmlMultiPage=_react2.default.createElement('div',{className:'portal-element-doc-content',dangerouslySetInnerHTML:{__html:data[0].title+'&nbsp'+data[0].content}});}return _react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid},_react2.default.createElement(_MarqueeCom2.default,{tabdata:data,eid:eid,scolltype:scolltype,scrollSpeed:scrollSpeed,ebaseid:'notice'},_react2.default.createElement('div',{className:'newnotice-add-Carousel'},html.length?htmlMultiPage:'')),_react2.default.createElement(_weaPortalPublic.WeaAddNotice,{ref:'addNotice',eid:eid,handleRefresh:handleRefresh,canAddNotice:canAddNotice}),canAddNotice&&noticeNew=='1'&&createMethod=='2'?_react2.default.createElement('div',{className:'noticeitemnew'},_react2.default.createElement(_ecCom.WeaBrowser,{type:'37',title:getLabel(386382,"请选择"),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',onChange:this.onSubmitDoc,customized:true,memorise:true,isSingle:false,replaceDatas:repalceDatas},_react2.default.createElement('div',{className:'portal-element-newnotice-add'},_react2.default.createElement('img',{src:'/page/element/newNotice/resource/image/new.png',title:getLabel(388030,"添加公告"),alt:''})))):null,canAddNotice&&createMethod=='1'?_react2.default.createElement('div',{className:'noticeitemnew'},_react2.default.createElement('div',{className:'portal-element-newnotice-add',onClick:this.handleAddNotice.bind(this,{isNew:true,visible:true,isView:false,id:'',title:'',imgsrc:'',content:''})},_react2.default.createElement('img',{className:'portal-element-newnotice-add-icon',src:'/page/element/newNotice/resource/image/new.png',title:getLabel(388030,"添加公告"),alt:''}))):null);}}]);return NewNoticeCom;}(_react2.default.Component);var NoticeItem=function(_React$Component2){(0,_inherits3.default)(NoticeItem,_React$Component2);function NoticeItem(props){(0,_classCallCheck3.default)(this,NoticeItem);var _this3=(0,_possibleConstructorReturn3.default)(this,(NoticeItem.__proto__||(0,_getPrototypeOf2.default)(NoticeItem)).call(this,props));_this3.handleClick=_this3.handleClick.bind(_this3);return _this3;}(0,_createClass3.default)(NoticeItem,[{key:'handleClick',value:function handleClick(){var _props3=this.props,createMethod=_props3.createMethod,item=_props3.item,handleClick=_props3.handleClick,linkmode=_props3.linkmode;var imgsrc=item.imgsrc,title=item.title,content=item.content,id=item.id,linkUrl=item.linkUrl;if(createMethod=='1'){handleClick({imgsrc:imgsrc,title:title,content:content,id:id,visible:true,isView:true});}else if(createMethod=='2'&&linkUrl){(0,_common.openLinkUrl)(linkUrl,linkmode);}}},{key:'render',value:function render(){var _props4=this.props,showImg=_props4.showImg,showTitle=_props4.showTitle,showContent=_props4.showContent,item=_props4.item,handleClick=_props4.handleClick;var imgsrc=item.imgsrc,title=item.title,content=item.content,id=item.id;var imgurl='';if(imgsrc==''){imgurl="/images/homepage/noimgdefault_wev8.jpg";}else{imgurl=imgsrc;}return _react2.default.createElement('div',{className:'portal-element-newnotice-item',onClick:this.handleClick},showImg?_react2.default.createElement('div',{className:'portal-element-newnotice-item-img'},_react2.default.createElement('img',{src:imgurl,alt:''})):'',_react2.default.createElement('div',{className:'portal-element-newnotice-item-content',style:{width:showImg?'calc(100% - 107px)':'100%'}},_react2.default.createElement('div',{className:'portal-element-newnotice-item-title'},showTitle?title:''),_react2.default.createElement('div',{className:'portal-element-newnotice-item-summary',style:{WebkitBoxOrient:'vertical'}},showContent?content.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig,"").replace(/&ldquo;/ig,'“').replace(/&rdquo;/ig,'”').replace(/&quot;/ig,'"').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&mdash;/g,'—').replace(/&hellip;/g,'…'):'')));}}]);return NoticeItem;}(_react2.default.Component);var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewNoticeCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewNoticeCom);exports.default=NewNoticeCom;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var WorkTask=function(_React$Component){(0,_inherits3.default)(WorkTask,_React$Component);function WorkTask(props){(0,_classCallCheck3.default)(this,WorkTask);var _this=(0,_possibleConstructorReturn3.default)(this,(WorkTask.__proto__||(0,_getPrototypeOf2.default)(WorkTask)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(WorkTask,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/worktask','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return WorkTask;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);WorkTask=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(WorkTask);exports.default=WorkTask;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var FnaBudgetAssistant=function(_React$Component){(0,_inherits3.default)(FnaBudgetAssistant,_React$Component);function FnaBudgetAssistant(props){(0,_classCallCheck3.default)(this,FnaBudgetAssistant);var _this=(0,_possibleConstructorReturn3.default)(this,(FnaBudgetAssistant.__proto__||(0,_getPrototypeOf2.default)(FnaBudgetAssistant)).call(this,props));_this.state={edata:null,refresh:false,weaFnaLoaded:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(FnaBudgetAssistant,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});ls.set('edata-'+eid,{});this.setState({edata:{},refresh:false});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载财务模块静态资源
eventRegister.loadModule('b_fna',function(){setTimeout(function(){return _this2.setState({weaFnaLoaded:true});},100);},function(){});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,weaFnaLoaded=_state.weaFnaLoaded;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){EContentHtml=weaFnaLoaded&&window.weaFnaEngine&&window.weaFnaEngine.com?_react2.default.createElement(window.weaFnaEngine.com.BudgetAssistantPage,{queryData:params}):_react2.default.createElement('div',null);}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return FnaBudgetAssistant;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FnaBudgetAssistant=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FnaBudgetAssistant);exports.default=FnaBudgetAssistant;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var FnaBudgetAssistant1=function(_React$Component){(0,_inherits3.default)(FnaBudgetAssistant1,_React$Component);function FnaBudgetAssistant1(props){(0,_classCallCheck3.default)(this,FnaBudgetAssistant1);var _this=(0,_possibleConstructorReturn3.default)(this,(FnaBudgetAssistant1.__proto__||(0,_getPrototypeOf2.default)(FnaBudgetAssistant1)).call(this,props));_this.state={edata:null,refresh:false,weaFnaLoaded:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(FnaBudgetAssistant1,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});ls.set('edata-'+eid,{});this.setState({edata:{},refresh:false});}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载财务模块静态资源
eventRegister.loadModule('b_fna',function(){setTimeout(function(){return _this2.setState({weaFnaLoaded:true});},100);},function(){});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,weaFnaLoaded=_state.weaFnaLoaded;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){EContentHtml=weaFnaLoaded&&window.weaFnaEngine&&window.weaFnaEngine.com?_react2.default.createElement(window.weaFnaEngine.com.ApprovalAssistantPage,{queryData:params}):_react2.default.createElement('div',null);}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return FnaBudgetAssistant1;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);FnaBudgetAssistant1=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(FnaBudgetAssistant1);exports.default=FnaBudgetAssistant1;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//元素组件
var NoReact=function(_React$Component){(0,_inherits3.default)(NoReact,_React$Component);function NoReact(props){(0,_classCallCheck3.default)(this,NoReact);var _this=(0,_possibleConstructorReturn3.default)(this,(NoReact.__proto__||(0,_getPrototypeOf2.default)(NoReact)).call(this,props));_this.state={edata:{}};_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.loadHtml=_this.loadHtml.bind(_this);return _this;}(0,_createClass3.default)(NoReact,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});}},{key:'handleRefresh',value:function handleRefresh(){var _props$config=this.props.config,item=_props$config.item,isSetting=_props$config.isSetting;var eid=item.eid,contentview=item.contentview;this.loadHtml(eid,contentview.url,isSetting);}},{key:'loadHtml',value:function loadHtml(eid,url,isSetting){var _this2=this;if(url){_ecCom.WeaTools.callApi(url,'GET',{},'html').then(function(result){if(_this2.props.config.isHasRight){$(".homepage[data-isSetting="+isSetting+"] #content_view_id_"+eid).html(result);}});}}},{key:'componentDidMount',value:function componentDidMount(){var _props$config2=this.props.config,item=_props$config2.item,isSetting=_props$config2.isSetting;var eid=item.eid,contentview=item.contentview;this.loadHtml(eid,contentview.url,isSetting);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config3=this.props.config,item=_props$config3.item,params=_props$config3.params,isHasRight=_props$config3.isHasRight,isSetting=_props$config3.isSetting;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){var _nextProps$config$ite=nextProps.config.item,eid=_nextProps$config$ite.eid,contentview=_nextProps$config$ite.contentview;this.loadHtml(eid,contentview.url,isSetting);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config4=this.props.config,item=_props$config4.item,params=_props$config4.params,isHasRight=_props$config4.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(!isHasRight){EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return NoReact;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NoReact=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NoReact);exports.default=NoReact;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _cooperation=__webpack_require__(615);var _cooperation2=_interopRequireDefault(_cooperation);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Cooperation=function(_React$Component){(0,_inherits3.default)(Cooperation,_React$Component);function Cooperation(props){(0,_classCallCheck3.default)(this,Cooperation);var _this=(0,_possibleConstructorReturn3.default)(this,(Cooperation.__proto__||(0,_getPrototypeOf2.default)(Cooperation)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(Cooperation,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/cooperation','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);// window.elements_more_params[config.params.eid] = {isRouteUrl: true, tabid: edata.currenttab || '1'};
if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_cooperation2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Cooperation;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Cooperation=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Cooperation);exports.default=Cooperation;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(616);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var CooperationCom=function(_React$Component){(0,_inherits3.default)(CooperationCom,_React$Component);function CooperationCom(props){(0,_classCallCheck3.default)(this,CooperationCom);var _this=(0,_possibleConstructorReturn3.default)(this,(CooperationCom.__proto__||(0,_getPrototypeOf2.default)(CooperationCom)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(CooperationCom,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/cooperationtab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var viewType='0';var typeid='0';var status='0';var jointype='0';if(tabdata){if(!$.isEmptyObject(tabdata)&&tabdata.datas.coworkList){contentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.datas.coworkList[0],esetting),showHeader:false,pagination:false,dataSource:tabdata.datas.coworkList,size:'small'});}viewType=tabdata.datas&&tabdata.datas.viewType;typeid=tabdata.datas&&tabdata.datas.typeid;status=tabdata.datas&&tabdata.datas.status;jointype=tabdata.datas&&tabdata.datas.jointype;}var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,viewType:viewType,typeid:typeid,status:status,jointype:jointype,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return CooperationCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);CooperationCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(CooperationCom);exports.default=CooperationCom;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,viewType=_props3.viewType,typeid=_props3.typeid,status=_props3.status,jointype=_props3.jointype,currentTab=_props3.currentTab;var eid=config.item.eid;window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"?viewType="+viewType+"&typeid="+typeid+"&jointype="+jointype+"&status="+status};}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _MeetingCalendar=__webpack_require__(618);var _MeetingCalendar2=_interopRequireDefault(_MeetingCalendar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MeetingCalendar=function(_React$Component){(0,_inherits3.default)(MeetingCalendar,_React$Component);function MeetingCalendar(props){(0,_classCallCheck3.default)(this,MeetingCalendar);var _this=(0,_possibleConstructorReturn3.default)(this,(MeetingCalendar.__proto__||(0,_getPrototypeOf2.default)(MeetingCalendar)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MeetingCalendar,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/meetingCalendar','POST',{eid:eid}).then(function(result){_ecCom.WeaTools.callApi('/api/meeting/calendar/getData','POST',{viewType:'3',selectdate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),meetingType:result.meetingtype}).then(function(data){ls.set('edata-'+eid,data);_this2.setState({edata:data,refresh:false});});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item,params=config.params,layoutid=config.layoutid;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_MeetingCalendar2.default,(0,_defineProperty3.default)({handleRefresh:this.handleRefresh,eid:eid,data:edata,hpid:params.hpid,layoutid:layoutid,subCompanyId:params.subCompanyId},'eid',eid));}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:true}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return MeetingCalendar;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MeetingCalendar=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MeetingCalendar);exports.default=MeetingCalendar;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//会议日历元素
var MeetingCalendarTemplate=function(_React$Component){(0,_inherits3.default)(MeetingCalendarTemplate,_React$Component);function MeetingCalendarTemplate(props){(0,_classCallCheck3.default)(this,MeetingCalendarTemplate);var _this=(0,_possibleConstructorReturn3.default)(this,(MeetingCalendarTemplate.__proto__||(0,_getPrototypeOf2.default)(MeetingCalendarTemplate)).call(this,props));var _date=new Date();_this.state={refresh:false,data:props.data,createVisible:false,createType:'create',currentDate:(0,_common.formatDate)(_date,"yyyy-MM-dd"),currentMonth:(0,_common.formatDate)(_date,"yyyy-MM"),activeKey:'1',meetingId:'',RoomPlanContainer:false,meetingtype:'0',weaMeetingLoaded:false,type:'month',selectYear:(0,_common.formatDate)(_date,"yyyy")};_this.doAdd=_this.doAdd.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.onClickData=_this.onClickData.bind(_this);_this.dateCellRender=_this.dateCellRender.bind(_this);_this.setAll=_this.setAll.bind(_this);_this.setMeetingId=_this.setMeetingId.bind(_this);_this.setRoomPlan=_this.setRoomPlan.bind(_this);_this.setDialog=_this.setDialog.bind(_this);_this.setType=_this.setType.bind(_this);_this.doRefesh=_this.doRefesh.bind(_this);_this.monthCellRender=_this.monthCellRender.bind(_this);_this.clickMeetingCalendarMonth=_this.clickMeetingCalendarMonth.bind(_this);if(window.window_clickMeetingCalendarDay){window.window_clickMeetingCalendarDay['fn'+props.eid]=_this.clickMeetingCalendarDay.bind(_this);}else{var obj={};obj['fn'+props.eid]=_this.clickMeetingCalendarDay.bind(_this);window.window_clickMeetingCalendarDay=obj;}return _this;}(0,_createClass3.default)(MeetingCalendarTemplate,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;// 异步加载会议模块静态资源
eventRegister.loadModule('f_meeting',function(){_this2.setState({weaMeetingLoaded:true});},function(){});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){this.setState({data:newProps.data});}},{key:'onPanelChange',value:function onPanelChange(value,type){var _this3=this;var selectYear=(0,_common.formatDate)(new Date(),"yyyy");if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))=='object'){selectYear=value.fields[1];}this.setState({type:type,selectYear:selectYear});var meetingtype=this.state.meetingtype;var _props=this.props,eid=_props.eid,hpid=_props.hpid,subCompanyId=_props.subCompanyId;var selectdate="";if((typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))==='object'){var year=value.getYear();var month=value.getMonth()+1<10?'0'+(value.getMonth()+1):value.getMonth()+1;var currentMonth=year+'-'+month;selectdate=year+'-'+month+'-01';var _month=(0,_common.formatDate)(new Date(),"yyyy-MM");if(selectdate===_month+"-01"){this.setState({currentDate:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),currentMonth:_month});}else{this.setState({currentDate:selectdate,currentMonth:year+'-'+month});}}else{selectdate=value;this.setState({currentDate:selectdate});}_ecCom.WeaTools.callApi('/api/meeting/calendar/getData','POST',{viewType:'3',selectDate:selectdate,meetingType:meetingtype}).then(function(data){ls.set('edata-'+eid,data);_this3.setState({data:data,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){$("#calendar_"+this.props.eid+" .ant-fullcalendar-cell").attr("onclick","window_clickMeetingCalendarDay['fn"+this.props.eid+"'](this)");}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _this4=this;if(nextState.type=='month'&&this.state.type=='year'){this.setState({type:nextState.type},function(){$("#calendar_"+_this4.props.eid+" .ant-fullcalendar-cell").attr("onclick","window_clickMeetingCalendarDay['fn"+_this4.props.eid+"'](this)");});}else if(nextState.type=='year'&&this.state.type=='month'){this.setState({type:nextState.type},function(){$("#calendar_"+_this4.props.eid+" .ant-fullcalendar-month-panel-cell").attr("onclick","window_clickMeetingCalendarDay['fn"+_this4.props.eid+"'](this)");});}return true;}},{key:'doAdd',value:function doAdd(){this.setState({createVisible:true,createType:'create'});}},{key:'onClose',value:function onClose(){this.onPanelChange(this.state.currentDate);this.setState({createVisible:false,activeKey:'1'});}},{key:'onClickData',value:function onClickData(id){this.setState({createVisible:true,createType:'preview',meetingId:id});}},{key:'setAll',value:function setAll(meetingId,bool,type){this.setState({meetingId:meetingId,createVisible:bool,createType:type});}},{key:'setMeetingId',value:function setMeetingId(meetingId){this.setState({meetingId:meetingId});}},{key:'setRoomPlan',value:function setRoomPlan(bool){this.setState({RoomPlanContainer:bool});}},{key:'setDialog',value:function setDialog(bool){this.setState({createVisible:bool});}},{key:'setType',value:function setType(type){this.setState({createType:type});}},{key:'doRefesh',value:function doRefesh(){var handleRefresh=this.props.handleRefresh;handleRefresh();}},{key:'render',value:function render(){var _this5=this;var _props2=this.props,eid=_props2.eid,layoutid=_props2.layoutid;var _state=this.state,createVisible=_state.createVisible,weaMeetingLoaded=_state.weaMeetingLoaded,createType=_state.createType,currentDate=_state.currentDate,workPlanId=_state.workPlanId,activeKey=_state.activeKey,data=_state.data,meetingId=_state.meetingId,_date=_state._date,RoomPlanContainer=_state.RoomPlanContainer,type=_state.type;var createConditionParams=['','',currentDate,(0,_common.formatDate)(new Date(),"hh:mm"),currentDate,'23:59','0'];return _react2.default.createElement('div',{id:'calendar_'+eid},_react2.default.createElement(_antd.Calendar,{fullscreen:false,onPanelChange:this.onPanelChange.bind(this),monthCellRender:this.monthCellRender(eid),value:new Date(currentDate),dateCellRender:this.dateCellRender.bind(this,eid,data)}),_react2.default.createElement(CalendarData,{data:data,type:type,currentDate:currentDate,handleClick:this.onClickData}),_react2.default.createElement('div',{className:'portal-element-calender-add'},_react2.default.createElement(_antd.Icon,{type:'plus-circle-o',title:getLabel(611,'添加'),onClick:this.doAdd})),weaMeetingLoaded&&window.weaMeeting&&window.weaMeeting.com?_react2.default.createElement(window.weaMeeting.com.MeetingDialog,{isCustom:true,setRoomPlan:this.setRoomPlan,setDialog:this.setDialog,setType:this.setType,setMeetingId:this.setMeetingId,setAll:this.setAll,type:createType//新建为'create',查看为'preview',编辑edit,会议决议---decision
,visible:createVisible//显隐受控
,doRefesh:function doRefesh(){_this5.doRefesh();}//自定义刷新页面，不会关掉弹出框
,meetingId:createType=='create'?'':meetingId//会议id，查看会议时用到
,isInterval:false//新建会议类型，true是周期会议， false是普通会议
,meetingDate:currentDate//新建日期
}):'',weaMeetingLoaded&&window.weaMeeting&&window.weaMeeting.com?_react2.default.createElement(window.weaMeeting.com.MeetingRoomPlan,{isCustom:true,setRoomPlan:this.setRoomPlan,canCreate:false,height:600,visible:RoomPlanContainer}):'');}},{key:'dateCellRender',value:function dateCellRender(eid,data,value){var _state2=this.state,currentDate=_state2.currentDate,currentMonth=_state2.currentMonth;$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");$("#calendar_"+eid).find(".ant-fullcalendar-event").removeClass("ant-fullcalendar-event");$("#calendar_"+eid).find(".ant-fullcalendar-current").removeClass("ant-fullcalendar-current");var dataStr1=(0,_common.formatDate)(new Date(value.time),'yyyy-M-d');var dateStr=(0,_common.formatDate)(new Date(value.time),'yyyy-MM-dd');var events=data.events;var timer=setTimeout(function(){events.map(function(arr){var startDate=(0,_common.formatDate)(new Date(arr.begindate),'yyyy-MM-dd');var endDate=(0,_common.formatDate)(new Date(arr.enddate),'yyyy-MM-dd');if(dateStr>=startDate&&dateStr<=endDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-event");}});if(dateStr===currentDate){$("#calendar_"+eid+" .ant-fullcalendar-cell[title='"+dataStr1+"'] .ant-fullcalendar-value").addClass("ant-fullcalendar-current");}clearTimeout(timer);},100);}},{key:'monthCellRender',value:function monthCellRender(eid){$("#calendar_"+eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}},{key:'clickMeetingCalendarDay',value:function clickMeetingCalendarDay(obj){var _state3=this.state,currentDate=_state3.currentDate,currentMonth=_state3.currentMonth,type=_state3.type;var eid=this.props.eid;if(type=='year'){this.clickMeetingCalendarMonth(obj);return;}var title=$(obj).attr("title");var ndate="";var currentMonthStr="";if(title){var titlearr=title.split("-");ndate=titlearr[0];currentMonthStr=titlearr[0];if(parseInt(titlearr[1])<10){ndate=ndate+"-0"+titlearr[1];currentMonthStr=currentMonthStr+"-0"+titlearr[1];}else{ndate=ndate+"-"+titlearr[1];currentMonthStr=currentMonthStr+"-"+titlearr[1];}if(parseInt(titlearr[2])<10){ndate=ndate+"-0"+titlearr[2];}else{ndate=ndate+"-"+titlearr[2];}}if(ndate){this.setState({currentDate:ndate});}//判断点击的是否为当前显示月份，否的话刷新新月份的日历日程，并默认选中所点击的日期
if(currentMonthStr!==currentMonth){this.setState({currentMonth:currentMonthStr});this.onPanelChange(this.state.currentDate,"month");}}},{key:'clickMeetingCalendarMonth',value:function clickMeetingCalendarMonth(obj){var _this6=this;var eid=this.props.eid;var _state4=this.state,selectYear=_state4.selectYear,meetingtype=_state4.meetingtype;var dateStr=(0,_common.formatDate)(new Date(),'MM');var _state5=this.state,currentDate=_state5.currentDate,currentMonth=_state5.currentMonth;var monthMatch={"01":getLabel("25825","1月"),"02":getLabel("25826","2月"),"03":getLabel("25827","3月"),"04":getLabel("25828","4月"),"05":getLabel("25829","5月"),"06":getLabel("25830","6月"),"07":getLabel("25831","7月"),"08":getLabel("25832","8月"),"09":getLabel("25833","9月"),"10":getLabel("25834","10月"),"11":getLabel("25835","11月"),"12":getLabel("25836","12月")};var x=Math.ceil(dateStr/3);var y=dateStr-(x-1)*3;if(monthMatch[dateStr].trim()!==obj.innerText.trim()){// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").addClass("ant-fullcalendar-month-panel-current-cell");
$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).addClass("ant-fullcalendar-month-panel-current-cell");$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});$($(obj)[0].children[0].children[0]).css({border:'#2db7f5 solid 1px'});}else{$("#calendar_"+eid+" .ant-fullcalendar-month-panel-cell .ant-fullcalendar-value").css({border:'initial'});$("#calendar_"+eid).find(".ant-fullcalendar-month-panel-selected-cell").removeClass("ant-fullcalendar-month-panel-current-cell");$($($("#calendar_"+eid+" .ant-fullcalendar").find('tr')[x-1].children[y-1]).find('div')[0]).removeClass("ant-fullcalendar-month-panel-current-cell");// $("#calendar_" + eid + " .ant-fullcalendar-month-panel-cell[title='" + monthMatch[dateStr].trim() + "'] >div").removeClass("ant-fullcalendar-month-panel-current-cell");
$("#calendar_"+eid+" .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month .ant-fullcalendar-value").css({border:'#2db7f5 solid 1px'});}var selectMonth='';for(var key in monthMatch){if(monthMatch[key]==obj.innerText.trim()){selectMonth=key;break;}}var firstDay=(0,_common.formatDate)(new Date(selectYear,selectMonth-1,1),"yyyy-MM-dd");//这个月的第一天
_ecCom.WeaTools.callApi('/api/meeting/calendar/getData','POST',{viewType:'3',selectdate:firstDay,meetingType:meetingtype}).then(function(data){ls.set('edata-'+eid,data);_this6.setState({data:data,refresh:false});});}}]);return MeetingCalendarTemplate;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MeetingCalendarTemplate=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MeetingCalendarTemplate);exports.default=MeetingCalendarTemplate;var CalendarData=function(_React$Component3){(0,_inherits3.default)(CalendarData,_React$Component3);function CalendarData(){(0,_classCallCheck3.default)(this,CalendarData);return(0,_possibleConstructorReturn3.default)(this,(CalendarData.__proto__||(0,_getPrototypeOf2.default)(CalendarData)).apply(this,arguments));}(0,_createClass3.default)(CalendarData,[{key:'tc',value:function tc(d){function zc(c,i){var d="666666888888aaaaaabbbbbbdddddda32929cc3333d96666e69999f0c2c2b1365fdd4477e67399eea2bbf5c7d67a367a994499b373b3cca2cce1c7e15229a36633cc8c66d9b399e6d1c2f029527a336699668cb399b3ccc2d1e12952a33366cc668cd999b3e6c2d1f01b887a22aa9959bfb391d5ccbde6e128754e32926265ad8999c9b1c2dfd00d78131096184cb05288cb8cb8e0ba52880066aa008cbf40b3d580d1e6b388880eaaaa11bfbf4dd5d588e6e6b8ab8b00d6ae00e0c240ebd780f3e7b3be6d00ee8800f2a640f7c480fadcb3b1440edd5511e6804deeaa88f5ccb8865a5aa87070be9494d4b8b8e5d4d47057708c6d8ca992a9c6b6c6ddd3dd4e5d6c6274878997a5b1bac3d0d6db5a69867083a894a2beb8c1d4d4dae54a716c5c8d8785aaa5aec6c3cedddb6e6e41898951a7a77dc4c4a8dcdccb8d6f47b08b59c4a883d8c5ace7dcce";return"#"+d.substring(c*30+i*6,c*30+(i+1)*6);}var c=d!=null&&d!=undefined?d:option.theme;return[zc(c,0),zc(c,1),zc(c,2),zc(c,3)];}},{key:'render',value:function render(){var _this9=this;var _props3=this.props,data=_props3.data,currentDate=_props3.currentDate,handleClick=_props3.handleClick,eid=_props3.eid,_props3$type=_props3.type,type=_props3$type===undefined?'month':_props3$type;var events=data.events;var index=0;var color='#a32929';if(events&&events.length){if(type=='month'){var hasEvent=false;var datas=[];var html=events.map(function(arr){if(arr[7])color=_this9.tc(arr[7])[2];var sdate=new Date(arr.begindate);var edate=new Date(arr.enddate);var startStr=(0,_common.formatDate)(sdate,'yyyy-MM-dd');var endStr=(0,_common.formatDate)(edate,'yyyy-MM-dd');var id=arr.id;var name=arr.name;var stime=arr.begintime;var ss=parseInt(stime)>=12?'PM':'AM';if(currentDate>=startStr&&currentDate<=endStr){hasEvent=true;index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this9,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:color}}),_react2.default.createElement('div',{className:'dataEvent2'},_react2.default.createElement('div',{className:'dataEvent2_1'},stime,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));}});var height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:height}},html))));}else{if(events&&events.length){var _hasEvent=false;var _html=events.map(function(arr){var sdate=new Date(arr.begindate);var id=arr.id;var name=arr.name;var mdata=(0,_common.formatDate)(sdate,'MM-dd  hh:mm');var ss=parseInt((0,_common.formatDate)(sdate,'hh'))>=12?'PM':'AM';_hasEvent=true;index+=1;return _react2.default.createElement('div',{className:'hand dataEvent',style:{height:'34px'},onClick:handleClick.bind(_this9,id),title:name},_react2.default.createElement('div',{className:'dataEvent1',style:{background:'#a32929'}}),_react2.default.createElement('div',{className:'dataEvent2',style:{width:'111px'}},_react2.default.createElement('div',{className:'dataEvent2_1'},mdata,'\xA0\xA0',ss)),_react2.default.createElement('div',{'class':'dataEvent3'},name));});var _height=index*34;if(index<3){return _react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html)));}return _react2.default.createElement(_ecCom.WeaNewScroll,{scrollId:'element_calendar_scroll',height:103},_react2.default.createElement('div',{id:'calendar_content'+eid},_react2.default.createElement('div',{id:'planDataEvent',className:'planDataEvent',style:{height:_height+1,overflowY:'hidden',outline:'none'}},_react2.default.createElement('div',{id:'planDataEventchd',style:{height:_height}},_html))));}}}else{return _react2.default.createElement('div',null);}}}]);return CalendarData;}(_react2.default.Component);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _MyProjects=__webpack_require__(620);var _MyProjects2=_interopRequireDefault(_MyProjects);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//我的项目元素组件
var MyProjects=function(_React$Component){(0,_inherits3.default)(MyProjects,_React$Component);function MyProjects(props){(0,_classCallCheck3.default)(this,MyProjects);var _this=(0,_possibleConstructorReturn3.default)(this,(MyProjects.__proto__||(0,_getPrototypeOf2.default)(MyProjects)).call(this,props));_this.state={edata:null,refresh:false,currentTab:'1',handleTabData:{}};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(MyProjects,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/projects','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){// this.props.onRef(this);
this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp)||!this.econtent;}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData||function(){},tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_MyProjects2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:edata});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return MyProjects;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MyProjects=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MyProjects);exports.default=MyProjects;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(621);var _Title2=_interopRequireDefault(_Title);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var MyProjectsCom=function(_React$Component){(0,_inherits3.default)(MyProjectsCom,_React$Component);function MyProjectsCom(props){(0,_classCallCheck3.default)(this,MyProjectsCom);var _this=(0,_possibleConstructorReturn3.default)(this,(MyProjectsCom.__proto__||(0,_getPrototypeOf2.default)(MyProjectsCom)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(MyProjectsCom,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// if(!isEqual(nextProps, this.props)){
this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});// }
}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;var currentTab=this.state.currentTab;this.setState({refresh:tabid===currentTab,currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/projectstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var searchtype='';var cmanager='';var status='';var eid=config.params.eid;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);if(tabdata){if(tabdata.datas.coworkList){contentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(tabdata.datas.coworkList[0],esetting),showHeader:false,pagination:false,dataSource:tabdata.datas.coworkList,size:'small'});}/*          const tabsetting = tabdata.tabsetting;
                        const { isIE, readType, mess } = tabsetting;
                        if(readType == '1' && isIE != 'true') contentHtml = <div>&nbsp;&nbsp;{mess}</div>;*/searchtype=tabdata.datas.searchtype;cmanager=tabdata.datas.cmanager;status=tabdata.datas.status;}var _titleProps={currentTab:currentTab,config:config,searchtype:searchtype,cmanager:cmanager,status:status,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.handleTabData};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return MyProjectsCom;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MyProjectsCom=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MyProjectsCom);exports.default=MyProjectsCom;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(){(0,_classCallCheck3.default)(this,Title);return(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).apply(this,arguments));}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref=this.setMoreHref.bind(this);this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,searchtype=_props3.searchtype,cmanager=_props3.cmanager,status=_props3.status,currentTab=_props3.currentTab;var eid=config.item.eid;if(searchtype){if(status){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"?searchtype="+searchtype+"&cmanager="+cmanager+"&status="+status};}else{window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"?searchtype="+searchtype+"&cmanager="+cmanager};}}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&tabid="+currentTab};}}/*setMoreHref() {
        const { config, more, currentTab } = this.props;
        const { eid } = config.item;
        if (more) {
            window.elements_more_params[eid] = {isRouteUrl: true, paramsStr: "?searchtype=" + escape(more)};
        } else {
            window.elements_more_params[eid] = {isRouteUrl: false, paramsStr: "&tabid="+currentTab};
        }
    }*/},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'render',value:function render(){var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-8px'};var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-7px'};var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;var header=config.item.header;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(623);var _EContent2=_interopRequireDefault(_EContent);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var LoginNews=function(_React$Component){(0,_inherits3.default)(LoginNews,_React$Component);function LoginNews(props){(0,_classCallCheck3.default)(this,LoginNews);var _this=(0,_possibleConstructorReturn3.default)(this,(LoginNews.__proto__||(0,_getPrototypeOf2.default)(LoginNews)).call(this,props));_this.state={edata:null,refresh:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(LoginNews,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/loginnews','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue};var edata_img={};if(!(0,_lodash.isEmpty)(edata)&&isHasRight){edata_img=_.cloneDeep(edata);edata_img.data.tabsetting.imgs=[];}var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:!refresh?edata:edata_img});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return LoginNews;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);LoginNews=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(LoginNews);exports.default=LoginNews;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(624);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _NewsType=__webpack_require__(625);var _NewsType2=_interopRequireDefault(_NewsType);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.handleTabData=_this.handleTabData.bind(_this);_this.toggleTabPage=_this.toggleTabPage.bind(_this);return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'toggleTabPage',value:function toggleTabPage(tabid){var currentTab=this.state.currentTab;this.setState({refresh:!(tabid===currentTab)});this.handleTabData(tabid);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;this.setState({currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/loginnewstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'render',value:function render(){var _props=this.props,config=_props.config,edata=_props.edata,handleRefresh=_props.handleRefresh,handleDelete=_props.handleDelete,fontSizeMp=_props.fontSizeMp;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var tabids=edata.tabids,titles=edata.titles,esetting=edata.esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var more='';if(tabdata){more=tabdata.more;}var tabdata_img={};if(!(0,_lodash.isEmpty)(tabdata)){tabdata_img=_.cloneDeep(tabdata);tabdata_img.tabsetting.imgs=[];}var contentHtml=!(0,_lodash.isEmpty)(tabdata)?_react2.default.createElement(_NewsType2.default,{eid:eid,data:!refresh?tabdata:tabdata_img,esetting:esetting}):_react2.default.createElement('div',null);var _titleProps={currentTab:currentTab,config:config,titles:titles,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,more:more,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.toggleTabPage};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,style:{height:cstyle.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+escape(more)};}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&tabid="+currentTab};}}},{key:'render',value:function render(){var tdStyle={width:this.props.tabwidth+'px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var tdStyle1={width:'auto',marginRight:'10px',paddingTop:'5px',verticalAlign:'top',backgroundSize:'100% 100%',height:'32px',marginTop:'-16px'};var _props4=this.props,currentTab=_props4.currentTab,_props4$config=_props4.config,config=_props4$config===undefined?{}:_props4$config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,tdStyle:tdStyle,tdStyle1:tdStyle1,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _objectAssign=__webpack_require__(37);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//公司新闻元素
var NewsType=function(_React$Component){(0,_inherits3.default)(NewsType,_React$Component);function NewsType(props){(0,_classCallCheck3.default)(this,NewsType);return(0,_possibleConstructorReturn3.default)(this,(NewsType.__proto__||(0,_getPrototypeOf2.default)(NewsType)).call(this,props));}(0,_createClass3.default)(NewsType,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'render',value:function render(){var _props=this.props,eid=_props.eid,data=_props.data,esetting=_props.esetting;var tabsetting=data.tabsetting,_data$srcStyle=data.srcStyle,srcStyle=_data$srcStyle===undefined?{}:_data$srcStyle;var _srcStyle$autoheight=srcStyle.autoheight,autoheight=_srcStyle$autoheight===undefined?'0':_srcStyle$autoheight,_srcStyle$pictureheig=srcStyle.pictureheight,pictureheight=_srcStyle$pictureheig===undefined?'108px':_srcStyle$pictureheig,_srcStyle$picturewidt=srcStyle.picturewidth,picturewidth=_srcStyle$picturewidt===undefined?'120px':_srcStyle$picturewidt,tabid=srcStyle.tabid;var list=data.data;//tab设置信息
var height=tabsetting.height,width=tabsetting.width,showModeId=tabsetting.showModeId,imgs=tabsetting.imgs;var columns=new Array();var imgStyle={width:width,height:height==0?parseInt(width)*0.8:height};var style={verticalAlign:'top',width:picturewidth=='px'?'108px':picturewidth,height:pictureheight=='px'?'120px':pictureheight};var listStyle2={width:'100%',height:'100%'};if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1){listStyle2={width:imgStyle.width,height:imgStyle.height};}if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}var docHtml='';switch(parseInt(showModeId)){case 3://左图式
var html=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'){imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{style:{overflow:'auto',overflowY:'hidden',width:'100%',marginBottom:'10px'}},!(imgs.length==1&&imgs[0]=='/images/homepage/noimgdefault_wev8.jpg')&&React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},item.docsubject?React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'1',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',position:'absolute',bottom:'15px',float:'right',width:'100%'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',paddingLeft:'5px',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,html);break;case 2://列表式2
var html4=null;var imghtml=null;var imghtml1=[];var j=0;if(!(0,_lodash.isEmpty)(imgs)){if(imgs.length>1){imgs.map(function(item,i){if(imgs[i]!='/images/homepage/noimgdefault_wev8.jpg'){imghtml1[j]=imgs[i];j++;}});if(imghtml1.length==0){imghtml1=['/images/homepage/noimgdefault_wev8.jpg'];}var ihtml=imghtml1.map(function(item,i){var img=imghtml1[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];return React.createElement('div',null,React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[i]&&list[i].docsubject&&list[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},ihtml));}else{var img=imgs[0];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=React.createElement('div',{style:{height:'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,null,React.createElement('div',null,React.createElement(ImgCom,{link:img!='/images/homepage/noimgdefault_wev8.jpg'&&list[0]&&list[0].docsubject&&list[0].docsubject.link,style:listStyle2,eid:eid,src:img}))));}}columns=(0,_common.formatData)(list[0],esetting);style['paddingTop']='6px';html4=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'}))));docHtml=React.createElement('div',null,html4);break;case 1://列表式
default:columns=(0,_common.formatData)(list[0],esetting);docHtml=React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'});break;}return React.createElement('div',null,docHtml);}}]);return NewsType;}(React.Component);var ImgCom=function(_React$Component2){(0,_inherits3.default)(ImgCom,_React$Component2);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this2=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this2.aClick=_this2.aClick.bind(_this2);return _this2;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props$link=this.props.link,link=_props$link===undefined?'':_props$link;if(link!=''){window.open(link);}else return false;}},{key:'render',value:function render(){var _props2=this.props,_props2$src=_props2.src,src=_props2$src===undefined?'':_props2$src,_props2$style=_props2.style,style=_props2$style===undefined?{width:'100%',height:'100%'}:_props2$style;return React.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},React.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(React.Component);var MyErrorHandler=function(_React$Component3){(0,_inherits3.default)(MyErrorHandler,_React$Component3);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);NewsType=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(NewsType);exports.default=NewsType;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);var _LoginUtil=__webpack_require__(627);var _E9QRCode=__webpack_require__(628);var _E9QRCode2=_interopRequireDefault(_E9QRCode);var _objectAssign=__webpack_require__(37);var _objectAssign2=_interopRequireDefault(_objectAssign);__webpack_require__(635);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var Login=function(_React$Component){(0,_inherits3.default)(Login,_React$Component);function Login(props){(0,_classCallCheck3.default)(this,Login);var _this=(0,_possibleConstructorReturn3.default)(this,(Login.__proto__||(0,_getPrototypeOf2.default)(Login)).call(this,props));_this.state=(0,_objectAssign2.default)({},{edata:null,win_width:jQuery(window).width(),win_height:jQuery(window).height(),isLogging:false,hasMultiLang:false,multiLangVisible:false,loginFormHiddenItems:[],loginSetting:{},validateCode:'/weaver/weaver.file.MakeValidateCode',queryParams:{logintype:'1'},loginFormItems:[],multiLangs:[],refresh:false,qrCode:{}},(0,_objectAssign2.default)({},(0,_LoginUtil.getLSValue)('portal_login','loginCache'),{loginType:(0,_LoginUtil.getLSValue)('portal_login','loginType')||'form',langId:(0,_LoginUtil.getLSValue)('portal_login','langId')||_ecCom.WeaTools.ls.getJSONObj('languageidweaver')||'7',langText:(0,_LoginUtil.getLSValue)('portal_login','langText')||'简体中文',isRememberAccount:(0,_LoginUtil.getLSValue)('portal_login','isRememberAccount')||false,isRememberPassword:(0,_LoginUtil.getLSValue)('portal_login','isRememberPassword')||false,cacheAccount:(0,_LoginUtil.getLSValue)('portal_login','cacheAccount')||'',cachePassword:(0,_LoginUtil.getLSValue)('portal_login','cachePassword')||'',initialSlide:(0,_LoginUtil.getLSValue)('portal_login','initialSlide')||0,autoCarousel:(0,_LoginUtil.getLSValue)('portal_login','autoCarousel')||false,carouselTime:(0,_LoginUtil.getLSValue)('portal_login','carouselTime')||3}));_this.handleDelete=_this.handleDelete.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.onPasswordForget=_this.onPasswordForget.bind(_this);_this.onRememberChange=_this.onRememberChange.bind(_this);_this.onValidateCodeChange=_this.onValidateCodeChange.bind(_this);_this.getLoginForm=_this.getLoginForm.bind(_this);_this.onQCLogin=_this.onQCLogin.bind(_this);_this.getMultiLangs=_this.getMultiLangs.bind(_this);_this.onLogin=_this.onLogin.bind(_this);return _this;}(0,_createClass3.default)(Login,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _state=this.state,loginId=_state.cacheAccount,langId=_state.langId;_ecCom.WeaLocaleProvider.getLocaleLabelByLang(['common','portal'],langId).then(function(){_this2.getLoginForm({loginId:loginId,langId:langId});});this.getMultiLangs();}},{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.getLoginForm();}},{key:'getLoginForm',value:function getLoginForm(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.setState({edata:ls.getJSONObj('edata-'+this.props.config.params.eid)});var _state2=this.state,queryParams=_state2.queryParams,langid=_state2.langId;var _queryParams$logintyp=queryParams.logintype,logintype=_queryParams$logintyp===undefined?'1':_queryParams$logintyp;var _params$loginId=params.loginId,loginId=_params$loginId===undefined?'':_params$loginId,_params$langId=params.langId,langId=_params$langId===undefined?langid:_params$langId;window.doLoginAction&&window.doLoginAction('getLoginForm',{queryParams:queryParams,logintype:logintype,loginid:loginId,langid:langId,callback:function callback(result){var _result$hasMultiLang=result.hasMultiLang,hasMultiLang=_result$hasMultiLang===undefined?false:_result$hasMultiLang,_result$loginFormItem=result.loginFormItems,loginFormItems=_result$loginFormItem===undefined?[]:_result$loginFormItem,_result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,_result$qrCode=result.qrCode,qrCode=_result$qrCode===undefined?{}:_result$qrCode;ls.set('edata-'+_this3.props.config.params.eid,result);_this3.setState({hasMultiLang:hasMultiLang,loginFormItems:loginFormItems,loginSetting:loginSetting,qrCode:qrCode,edata:result});}});}},{key:'onPasswordForget',value:function onPasswordForget(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _params$langId2=params.langId,langId=_params$langId2===undefined?this.state.langId:_params$langId2;window.doLoginAction&&window.doLoginAction('forgetPassword',{langid:langId});}},{key:'onRememberChange',value:function onRememberChange(type,checked){var _state3=this.state,isRememberAccount=_state3.isRememberAccount,isRememberPassword=_state3.isRememberPassword;if('account'==type){this.setState({isRememberAccount:checked,isRememberPassword:!checked?checked:isRememberPassword});}else if('password'==type){this.setState({isRememberAccount:checked?checked:isRememberAccount,isRememberPassword:checked});}}},{key:'onValidateCodeChange',value:function onValidateCodeChange(){var _this4=this;setTimeout(function(){return _this4.setState({validateCode:'/weaver/weaver.file.MakeValidateCode?seriesnum_='+ ++_this4.seriesnum_});},50);}},{key:'onQCLogin',value:function onQCLogin(){var _state4=this.state,langId=_state4.langId,langText=_state4.langText,qrCode=_state4.qrCode;_ecCom.WeaTools.callApi('/mobile/plugin/login/QCLoginStatus.jsp','POST',{langid:langId,loginkey:qrCode.loginkey,isie:!!_ecCom.WeaTools.ua.browser==="IE"},'text').then(function(result){if(jQuery.trim(result)!='0'&&jQuery.trim(result)!='9'&&jQuery.trim(result)!='-99'){jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();(0,_LoginUtil.setLSValue)('portal_login','langId',langId);(0,_LoginUtil.setLSValue)('portal_login','langText',langText);_ecCom.WeaTools.ls.set('languageidweaver',langId);window.open('/wui/index.html?#/main','_blank');}});}// getMultiLangs(params = {}) {
//     WeaTools.callApi('/api/system/language/base/getActiveLanguage', 'GET', params).then((result) => {
//         if (result.status == '1') {
//             const {activeLanguageInfo, activeLanguageIds, languageIdentify} = result;
//             this.multiLangs = activeLanguageInfo;
//         }
//     });
// }
},{key:'getMultiLangs',value:function getMultiLangs(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_ecCom.WeaTools.callApi('/api/system/language/base/getActiveLanguage','GET',params).then(function(result){if(result.status=='1'){var activeLanguageInfo=result.activeLanguageInfo,activeLanguageIds=result.activeLanguageIds,languageIdentify=result.languageIdentify;_this5.setState({multiLangs:activeLanguageInfo});(0,_LoginUtil.setLSValue)('portal_login','multiLangs',activeLanguageInfo);_ecCom.WeaTools.ls.set('activeLanguageIds',activeLanguageIds);_ecCom.WeaTools.ls.set('languageIdentify',languageIdentify);}});}},{key:'onLogin',value:function onLogin(){var _this6=this;var _state5=this.state,queryParams=_state5.queryParams,langId=_state5.langId,langText=_state5.langText,isRememberAccount=_state5.isRememberAccount,isRememberPassword=_state5.isRememberPassword,loginSetting=_state5.loginSetting;var _queryParams$logintyp2=queryParams.logintype,logintype=_queryParams$logintyp2===undefined?'1':_queryParams$logintyp2;this.setState({isLogging:true});window.doLoginAction&&window.doLoginAction('login',{queryParams:queryParams,logintype:logintype,langid:langId,loginSetting:loginSetting,success:function success(username,password){jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();var cacheAccount='';var cachePassword='';if(isRememberAccount)cacheAccount=username;if(isRememberPassword)cachePassword=password;_this6.setState({isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,cacheAccount:cacheAccount,cachePassword:cachePassword});(0,_LoginUtil.setLSValue)('portal_login','langId',langId);(0,_LoginUtil.setLSValue)('portal_login','langText',langText);(0,_LoginUtil.setLSValue)('portal_login','cacheAccount',cacheAccount);(0,_LoginUtil.setLSValue)('portal_login','cachePassword',cachePassword);(0,_LoginUtil.setLSValue)('portal_login','isRememberAccount',isRememberAccount);(0,_LoginUtil.setLSValue)('portal_login','isRememberPassword',isRememberPassword);(0,_LoginUtil.initLSValue)(username,langId);_ecCom.WeaTools.ls.set('languageidweaver',langId);if(logintype=='2'){window.location.href='/spa/crmPortal/mobx/index.html#/main';}else{// 判断当前登录日期和上次登录的日期是否为同一天，不是同一天则刷新页面
var date=new Date();var logindate=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();var _logindate=_ecCom.WeaTools.ls.getStr('logindate');if(logindate!=_logindate){_ecCom.WeaTools.ls.set('logindate',logindate);}window.open('/wui/index.html?#/main','_blank');}_this6.setState({isLogging:false});},failure:function failure(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(params.reflashValidateCode){_this6.onValidateCodeChange();}_this6.getLoginForm();_this6.setState({isLogging:false});}});}},{key:'render',value:function render(){var _this7=this;var _state6=this.state,isLogging=_state6.isLogging,isRememberPW=_state6.isRememberPW,isRememberAccount=_state6.isRememberAccount,isRememberPassword=_state6.isRememberPassword,cacheAccount=_state6.cacheAccount,cachePassword=_state6.cachePassword,langId=_state6.langId,_state6$loginSettingI=_state6.loginSettingInfo,loginSettingInfo=_state6$loginSettingI===undefined?{}:_state6$loginSettingI,loginFormHiddenItems=_state6.loginFormHiddenItems,_state6$loginSetting=_state6.loginSetting,loginSetting=_state6$loginSetting===undefined?{}:_state6$loginSetting,validateCode=_state6.validateCode,loginType=_state6.loginType,_state6$loginFormItem=_state6.loginFormItems,loginFormItems=_state6$loginFormItem===undefined?[]:_state6$loginFormItem,hasMultiLang=_state6.hasMultiLang,multiLangs=_state6.multiLangs,loginId=_state6.loginId,edata=_state6.edata;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config)return _react2.default.createElement('div',null);var item=config.item,isHasRight=config.isHasRight;var eid=item.eid,ebaseid=item.ebaseid,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var color=loginForm.color,backgroundColor=loginForm.backgroundColor;var needforgotpassword=loginSetting.needforgotpassword;if(!config)return _react2.default.createElement('div',null);var EmultiLang='';if(isHasRight){if((0,_lodash.isEmpty)(edata))return _react2.default.createElement('div',null);}else{return _react2.default.createElement(_common.NoRightCom,null);}if(!hasMultiLang){EmultiLang=_react2.default.createElement('div',{className:'login-multiLang'});}else{var langlId=langId+"";EmultiLang=_react2.default.createElement('div',{className:'login-multiLang',style:{display:'inline-block'}},_react2.default.createElement('div',{style:{display:'inline-block'}},_react2.default.createElement(_ecCom.WeaSelect,{value:langlId,style:{marginLeft:'10px',border:'none',width:'82px'},options:multiLangs.map(function(item){return{key:item.id,showname:item.language};}),onChange:function onChange(value,showname){_ecCom.WeaLocaleProvider.getLocaleLabelByLang(['common','portal'],value).then(function(){_this7.setState({langId:value,langText:showname});_this7.getLoginForm({langId:value});});}})),_react2.default.createElement('div',{className:'login-toggle login-draggable-display portal-login-element'},loginType=='form'?_react2.default.createElement('i',{className:'icon-coms-Scan',style:{color:'#BFBFBF'},onClick:function onClick(){return _this7.setState({loginType:'QRCode'});}}):_react2.default.createElement('i',{className:'icon-coms-Revoke2',style:{color:'#BFBFBF'},onClick:function onClick(){return _this7.setState({loginType:'form'});}})));}var verificationCode=_react2.default.createElement('div',null);loginFormItems.map(function(item,index){if(item.atype=='validatecode'){verificationCode=_react2.default.createElement('div',{key:index,className:'login-form-item',style:{color:color,borderBottom:'none',display:'inline-block'}},_react2.default.createElement(_ecCom.WeaInput,{type:item.type,name:item.name,id:item.id,style:{width:'128px',display:'inline-block',position:'relative'},placeholder:item.label}),_react2.default.createElement('div',{style:{width:'112px',height:'38px',display:'inline-block',marginLeft:'20px',position:'absolute',top:'-4px'}},_react2.default.createElement('img',{src:validateCode,alt:'',onClick:_this7.onValidateCodeChange})));}});return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'login-form-box login-draggable-display portal-login-element'},EmultiLang,loginType=='form'?_react2.default.createElement('div',{className:'login-form'},loginFormItems.map(function(item,index){var defaultValue='';if(item.atype=='account'){defaultValue=cacheAccount;}else if(item.atype=='password'){defaultValue=cachePassword;}var itemComp=_react2.default.createElement('div',{key:index,className:'login-form-item',style:{color:color}},_react2.default.createElement('span',{className:'login-form-label',onClick:_this7.onLabelClick},item.label,':'),_react2.default.createElement(_ecCom.WeaInput,{type:item.type,name:item.name,id:item.id,className:'login-form-input',defaultValue:defaultValue}));if(item.atype=='validatecode'){itemComp=_react2.default.createElement('div',null);}return itemComp;}),loginFormHiddenItems.map(function(item,index){return _react2.default.createElement('div',{key:index,style:{display:'none'},dangerouslySetInnerHTML:{__html:item.html}});}),_react2.default.createElement('div',{className:'login-form-remember',style:{color:color}},needforgotpassword=='1'&&_react2.default.createElement('div',{className:'login-form-remember-forget',title:getLabel(81614,'忘记密码')},_react2.default.createElement('span',{onClick:function onClick(){return _this7.onPasswordForget();}},getLabel(81614,'忘记密码'))),_react2.default.createElement('div',{className:'login-form-remember-content'},_react2.default.createElement('div',{className:'login-form-remember-account',title:getLabel(381949,'记住账号')},_react2.default.createElement(_antd.Checkbox,{checked:isRememberAccount,onChange:function onChange(e){return _this7.onRememberChange('account',e.target.checked);}},getLabel(381949,'记住账号'))),_react2.default.createElement('div',{className:'login-form-remember-password',title:getLabel(25722,'记住密码')},_react2.default.createElement(_antd.Checkbox,{checked:isRememberPassword,onChange:function onChange(e){return _this7.onRememberChange('password',e.target.checked);}},getLabel(25722,'记住密码')))),_react2.default.createElement('div',{className:'login-form-clear'})),verificationCode,_react2.default.createElement('div',{className:'login-form-submit',style:{paddingLeft:'71px',marginTop:'32px'}},_react2.default.createElement(_antd.Button,{loading:isLogging,className:'login-form-submit-btn',onClick:this.onLogin},getLabel(388151,'登陆')))):_react2.default.createElement(_E9QRCode2.default,{datas:this.state,getLoginForm:this.getLoginForm,onQCLogin:this.onQCLogin}),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return Login;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Login=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Login);exports.default=Login;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getLoginBgImageStyle=exports.getDefaultPathname=exports.initLSValue=exports.setLSValue=exports.getLSValue=undefined;var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 获取本地缓存数据
 *
 * @param key1
 * @param key2
 * @returns {*}
 */var getLSValue=exports.getLSValue=function getLSValue(key1,key2){var obj=_ecCom.WeaTools.ls.getJSONObj(key1);return obj&&obj[key2];};/**
 * 设置本地缓存数据
 *
 * @param key1
 * @param key2
 * @param value
 * @returns {*}
 */var setLSValue=exports.setLSValue=function setLSValue(key1,key2,value){var obj=_ecCom.WeaTools.ls.getJSONObj(key1)||{};obj[key2]=value;_ecCom.WeaTools.ls.set(key1,obj);};/**
 * 初始化本地缓存数据
 *
 * @param loginid 登录账号
 * @param languageidweaver 登录语言
 */var initLSValue=exports.initLSValue=function initLSValue(loginid,languageidweaver){var _loginid=_ecCom.WeaTools.ls.getStr('loginid');var _languageidweaver=_ecCom.WeaTools.ls.getStr('languageidweaver');var ls=window.localStorage;var keys=[];if(loginid!=_loginid){for(var i=0,len=ls.length;i<len;i++){var key=ls.key(i);if(/^theme-/.test(key)||/^portal-/.test(key)||/^edata-/.test(key)||/^tabdata-/.test(key)){keys.push(key);}}}if(languageidweaver!=_languageidweaver){keys.push('theme-backEndMenu');keys.push('theme-topMenu');keys.push('theme-portalMenu');}for(var j=0,len2=keys.length;j<len2;j++){ls.removeItem(keys[j]);}_ecCom.WeaTools.ls.set('loginid',loginid);_ecCom.WeaTools.ls.set('languageidweaver',languageidweaver);};/**
 * 获取登录成功后跳转的默认路径名
 *
 * @returns {string}
 */var getDefaultPathname=exports.getDefaultPathname=function getDefaultPathname(){return'/main';};/**
 * 获取登录背景图片样式
 *
 * @param loginInfo 登录背景图片信息
 * @returns {*}
 */var getLoginBgImageStyle=exports.getLoginBgImageStyle=function getLoginBgImageStyle(loginInfo){var fillStyle=loginInfo.fillStyle;var src=getLSValue('login','loginBgImage')||loginInfo.imgsrc;var width=getLSValue('login','loginBgImageWidth')||loginInfo.width;var height=getLSValue('login','loginBgImageHeight')||loginInfo.height;var style={backgroundImage:'url('+src+')'};switch(fillStyle){case'adapt':case'fill':style.backgroundRepeat='no-repeat';style.backgroundSize='cover';var _style={};var win_width=jQuery(window).width();var win_height=jQuery(window).height();win_width=win_width<800?800:win_width;win_height=win_height<712?712:win_height;var rate=width/height;var _rate=win_width/win_height;if(rate>_rate){if(fillStyle=='adapt'){_style={width:win_width,height:win_width/rate,marginTop:(win_height-win_width/rate)/2};}if(fillStyle=='fill'){_style={width:win_height*rate,height:win_height,marginLeft:-((win_height*rate-win_width)/2)};}}else if(rate<_rate){if(fillStyle=='adapt'){_style={width:win_height*rate,height:win_height,marginLeft:(win_width-win_height*rate)/2};}if(fillStyle=='fill'){_style={width:win_width,height:win_width/rate};}}else{_style={width:win_width,height:win_height};}style=(0,_extends3.default)({},style,_style);break;case'tile':style.backgroundRepeat='repeat';break;case'center':style.backgroundPosition='center';style.backgroundRepeat='no-repeat';break;default:style.backgroundRepeat='no-repeat';style.backgroundSize='100% 100%';break;}return style;};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _qrcode=__webpack_require__(629);var _qrcode2=_interopRequireDefault(_qrcode);var _ecCom=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E9QRCode=function(_React$Component){(0,_inherits3.default)(E9QRCode,_React$Component);function E9QRCode(props){(0,_classCallCheck3.default)(this,E9QRCode);var _this=(0,_possibleConstructorReturn3.default)(this,(E9QRCode.__proto__||(0,_getPrototypeOf2.default)(E9QRCode)).call(this,props));_this.getQRCode=_this.getQRCode.bind(_this);_this.scanQRCode=_this.scanQRCode.bind(_this);return _this;}(0,_createClass3.default)(E9QRCode,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,getLoginForm=_props.getLoginForm,_props$datas=_props.datas,datas=_props$datas===undefined?{}:_props$datas;var loginId=datas.cacheAccount,langId=datas.langId;this.getQRCode();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.getQRCode();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.clearInterval(this.scanInterval);}},{key:'render',value:function render(){var _props$datas2=this.props.datas,datas=_props$datas2===undefined?{}:_props$datas2;var _datas$loginSettingIn=datas.loginSettingInfo,loginSettingInfo=_datas$loginSettingIn===undefined?{}:_datas$loginSettingIn,qrCode=datas.qrCode;var _loginSettingInfo$log=loginSettingInfo.loginForm,loginForm=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var size=this.props.size||180;var color=this.props.color||loginForm.color||'#fff';return _react2.default.createElement('div',{className:'login-QRCode'},_react2.default.createElement('div',{className:'login-QRCode-area'},!!qrCode?_react2.default.createElement(_qrcode2.default,{value:qrCode.text,size:size,fgColor:'#404549',bgColor:'#eaeaea'}):''),_react2.default.createElement('div',{className:'login-QRCode-describe'},getLabel(84272,'请使用e-mobile扫描二维码以登录')));}},{key:'getQRCode',value:function getQRCode(){var _props$datas3=this.props.datas,datas=_props$datas3===undefined?{}:_props$datas3;var qrCode=datas.qrCode;if(!!qrCode){window.clearInterval(this.scanInterval);this.scanInterval=window.setInterval(this.scanQRCode.bind(this),1000);}}},{key:'scanQRCode',value:function scanQRCode(){var onQCLogin=this.props.onQCLogin;onQCLogin();}}]);return E9QRCode;}(_react2.default.Component);exports.default=E9QRCode;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = __webpack_require__(0);

var PropTypes = __webpack_require__(26); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __webpack_require__(630);

var ErrorCorrectLevel = __webpack_require__(167);

function getBackingStorePixelRatio(ctx) {
  return (// $FlowFixMe
    ctx.webkitBackingStorePixelRatio || // $FlowFixMe
    ctx.mozBackingStorePixelRatio || // $FlowFixMe
    ctx.msBackingStorePixelRatio || // $FlowFixMe
    ctx.oBackingStorePixelRatio || // $FlowFixMe
    ctx.backingStorePixelRatio || 1
  );
} // Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/


function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000'
};
var PROP_TYPES = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string
};

var QRCodeCanvas =
/*#__PURE__*/
function (_React$Component) {
  _inherits(QRCodeCanvas, _React$Component);

  function QRCodeCanvas() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = QRCodeCanvas.__proto__ || Object.getPrototypeOf(QRCodeCanvas)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "_canvas", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    }), _temp));
  }

  _createClass(QRCodeCanvas, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this2.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _props = this.props,
          value = _props.value,
          size = _props.size,
          level = _props.level,
          bgColor = _props.bgColor,
          fgColor = _props.fgColor; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var tileW = size / cells.length;
        var tileH = size / cells.length;
        var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
        canvas.height = canvas.width = size * scale;
        ctx.scale(scale, scale);
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            ctx && (ctx.fillStyle = cell ? fgColor : bgColor);
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
            ctx && ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          value = _props2.value,
          size = _props2.size,
          level = _props2.level,
          bgColor = _props2.bgColor,
          fgColor = _props2.fgColor,
          style = _props2.style,
          otherProps = _objectWithoutProperties(_props2, ["value", "size", "level", "bgColor", "fgColor", "style"]);

      var canvasStyle = _extends({
        height: size,
        width: size
      }, style);

      return React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this3._canvas = _ref2;
        }
      }, otherProps));
    }
  }]);

  return QRCodeCanvas;
}(React.Component);

Object.defineProperty(QRCodeCanvas, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeCanvas, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCodeSVG =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(QRCodeSVG, _React$Component2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, (QRCodeSVG.__proto__ || Object.getPrototypeOf(QRCodeSVG)).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this4 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this4.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          value = _props3.value,
          size = _props3.size,
          level = _props3.level,
          bgColor = _props3.bgColor,
          fgColor = _props3.fgColor,
          otherProps = _objectWithoutProperties(_props3, ["value", "size", "level", "bgColor", "fgColor"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return;
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var ops = [];
      cells.forEach(function (row, y) {
        var lastIsDark = false;
        var start = null;
        row.forEach(function (cell, x) {
          if (!cell && start !== null) {
            // M0 0h7v1H0z injects the space with the move and dropd the comma,
            // saving a char per operation
            ops.push("M".concat(start, " ").concat(y, "h").concat(x - start, "v1H").concat(start, "z"));
            start = null;
            return;
          } // end of row, clean up or skip


          if (x === row.length - 1) {
            if (!cell) {
              // We would have closed the op above already so this can only mean
              // 2+ light modules in a row.
              return;
            }

            if (start === null) {
              // Just a single dark module.
              ops.push("M".concat(x, ",").concat(y, " h1v1H").concat(x, "z"));
            } else {
              // Otherwise finish the current line.
              ops.push("M".concat(start, ",").concat(y, " h").concat(x + 1 - start, "v1H").concat(start, "z"));
            }

            return;
          }

          if (cell && start === null) {
            start = x;
          }
        });
      });
      return React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(cells.length, " ").concat(cells.length)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(cells.length, "v").concat(cells.length, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: ops.join('')
      }));
    }
  }]);

  return QRCodeSVG;
}(React.Component);

Object.defineProperty(QRCodeSVG, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeSVG, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _extends({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(631);
var RSBlock = __webpack_require__(632);
var BitBuffer = __webpack_require__(633);
var util = __webpack_require__(634);
var Polynomial = __webpack_require__(168);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(166);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(167);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(166);
var Polynomial = __webpack_require__(168);
var math = __webpack_require__(169);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var NewMeeting=function(_React$Component){(0,_inherits3.default)(NewMeeting,_React$Component);function NewMeeting(props){(0,_classCallCheck3.default)(this,NewMeeting);var _this=(0,_possibleConstructorReturn3.default)(this,(NewMeeting.__proto__||(0,_getPrototypeOf2.default)(NewMeeting)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(NewMeeting,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/newmeeting','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return NewMeeting;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewMeeting=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewMeeting);exports.default=NewMeeting;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var DayPlan=function(_React$Component){(0,_inherits3.default)(DayPlan,_React$Component);function DayPlan(props){(0,_classCallCheck3.default)(this,DayPlan);var _this=(0,_possibleConstructorReturn3.default)(this,(DayPlan.__proto__||(0,_getPrototypeOf2.default)(DayPlan)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(DayPlan,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/dayplan','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return DayPlan;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(388017,"对不起，元素加载异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);DayPlan=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(DayPlan);exports.default=DayPlan;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var ProcessTask=function(_React$Component){(0,_inherits3.default)(ProcessTask,_React$Component);function ProcessTask(props){(0,_classCallCheck3.default)(this,ProcessTask);var _this=(0,_possibleConstructorReturn3.default)(this,(ProcessTask.__proto__||(0,_getPrototypeOf2.default)(ProcessTask)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(ProcessTask,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/view','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid},' '),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return ProcessTask;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ProcessTask=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ProcessTask);exports.default=ProcessTask;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Base64=ecCom.WeaTools.Base64;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var UnreadDocs=function(_React$Component){(0,_inherits3.default)(UnreadDocs,_React$Component);function UnreadDocs(props){(0,_classCallCheck3.default)(this,UnreadDocs);var _this=(0,_possibleConstructorReturn3.default)(this,(UnreadDocs.__proto__||(0,_getPrototypeOf2.default)(UnreadDocs)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);if(window.element_unReadDoc_refresh&&(typeof window==='undefined'?'undefined':(0,_typeof3.default)(window))=='object'){window.element_unReadDoc_refresh[props.config.params.eid]=_this.handleRefresh.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.handleRefresh.bind(_this);window.element_unReadDoc_refresh=obj;}return _this;}(0,_createClass3.default)(UnreadDocs,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/view','POST',(0,_extends3.default)({},params)).then(function(result){var more=result.more||"";window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+Base64.encode(more.toString())};ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],(0,_extends3.default)({eid:eid,ebaseid:ebaseid},esetting)),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid},' '),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return UnreadDocs;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);UnreadDocs=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(UnreadDocs);exports.default=UnreadDocs;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var NewCustomers=function(_React$Component){(0,_inherits3.default)(NewCustomers,_React$Component);function NewCustomers(props){(0,_classCallCheck3.default)(this,NewCustomers);var _this=(0,_possibleConstructorReturn3.default)(this,(NewCustomers.__proto__||(0,_getPrototypeOf2.default)(NewCustomers)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(NewCustomers,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/view','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return NewCustomers;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);NewCustomers=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(NewCustomers);exports.default=NewCustomers;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var MessageReminding=function(_React$Component){(0,_inherits3.default)(MessageReminding,_React$Component);function MessageReminding(props){(0,_classCallCheck3.default)(this,MessageReminding);var _this=(0,_possibleConstructorReturn3.default)(this,(MessageReminding.__proto__||(0,_getPrototypeOf2.default)(MessageReminding)).call(this,props));_this.state={edata:null,refresh:false,width:0};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(MessageReminding,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;var loadContent=function loadContent(){var width=$("#content_view_id_"+eid).width()||0;_this2.setState({edata:ls.getJSONObj('edata-'+eid),width:width});_ecCom.WeaTools.callApi(api||'/api/portal/element/dayplan','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});};if($("#content_view_id_"+eid)[0]){loadContent();}else{var timer=setTimeout(function(){loadContent();clearTimeout(timer);},100);}}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config);}},{key:'render',value:function render(){var _state=this.state,edata=_state.edata,refresh=_state.refresh,width=_state.width;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata)&&edata.data&&edata.data.length)EContentHtml=_react2.default.createElement(_ecCom.WeaTable,{columns:(0,_common.formatData)(edata.data[0],edata.esetting),showHeader:false,pagination:false,dataSource:edata.data,size:'small'});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:(0,_extends3.default)({},style,{height:style1.height,marginTop:'10px'}),id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}}]);return MessageReminding;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);MessageReminding=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(MessageReminding);exports.default=MessageReminding;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(15);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _common=__webpack_require__(10);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _EContent=__webpack_require__(643);var _EContent2=_interopRequireDefault(_EContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//元素组件
var News=function(_React$Component){(0,_inherits3.default)(News,_React$Component);function News(props){(0,_classCallCheck3.default)(this,News);var _this=(0,_possibleConstructorReturn3.default)(this,(News.__proto__||(0,_getPrototypeOf2.default)(News)).call(this,props));_this.state={edata:null,refresh:false,color:'#939393',isShowAdd:false,canEdit:false};_this.handleEData=_this.handleEData.bind(_this);_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);_this.onChangeShowAdd=_this.onChangeShowAdd.bind(_this);_this.onChangeCanEdit=_this.onChangeCanEdit.bind(_this);_this.onRef=_this.onRef.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);return _this;}(0,_createClass3.default)(News,[{key:'handleDelete',value:function handleDelete(){this.setState({edata:null});ls.set('edata-'+this.props.config.params.eid,null);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(window.element_news_refresh&&(0,_typeof3.default)(window.element_news_refresh)=='object'){delete element_news_refresh[this.props.config.params.eid];}}},{key:'handleRefresh',value:function handleRefresh(){this.setState({refresh:true});this.handleEData(this.props.config.params);}},{key:'handleEData',value:function handleEData(params){var _this2=this;var eid=params.eid,api=params.api;this.setState({edata:ls.getJSONObj('edata-'+eid)});_ecCom.WeaTools.callApi(api||'/api/portal/element/news','POST',(0,_extends3.default)({},params)).then(function(result){ls.set('edata-'+eid,result);_this2.setState({edata:result,refresh:false});});}},{key:'handleOpen',value:function handleOpen(){var edata=this.state.edata;var _edata$data=edata.data,data=_edata$data===undefined?{}:_edata$data;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'onChangeShowAdd',value:function onChangeShowAdd(value){this.setState({isShowAdd:value});}},{key:'onChangeCanEdit',value:function onChangeCanEdit(value){this.setState({canEdit:value});}},{key:'componentDidMount',value:function componentDidMount(){this.handleEData(this.props.config.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props$config=this.props.config,item=_props$config.item,params=_props$config.params,isHasRight=_props$config.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};if(!(0,_lodash.isEqual)(config,_config)||nextProps.config.isRender){this.handleEData(nextProps.config.params);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var _props$config2=this.props.config,item=_props$config2.item,params=_props$config2.params,isHasRight=_props$config2.isHasRight;var config={item:item,params:params,isHasRight:isHasRight};var _config={item:nextProps.config.item,params:nextProps.config.params,isHasRight:nextProps.config.isHasRight};return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(config,_config)||!(0,_lodash.isEmpty)(nextProps.fontSizeMp);}},{key:'onRef',value:function onRef(ref){this.child=ref;}},{key:'handleTabData',value:function handleTabData(tabid){this.child.handleTabData(tabid);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,_state$edata=_state.edata,edata=_state$edata===undefined?{}:_state$edata,refresh=_state.refresh;var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;if(!config||!edata)return _react2.default.createElement('div',null);var _edata$currenttab=edata.currenttab,currenttab=_edata$currenttab===undefined?'1':_edata$currenttab,tabids=edata.tabids,titles=edata.titles,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var eShowNum=esetting.eShowNum,eLinkMode=esetting.eLinkMode,eRemindMode=esetting.eRemindMode;var isHasRight=config.isHasRight,item=config.item;var eid=item.eid,ebaseid=item.ebaseid,content=item.content,header=item.header,contentview=item.contentview,style=item.style;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var dyParams=[{key:'1',type:'EShowNum',ref:'eShowNum',value:eShowNum},{key:'2',type:'ELinkMode',ref:'eLinkMode',value:eLinkMode},{key:'3',type:'ERemindMode',ref:'eRemindMode',value:eRemindMode}];var datas={currentTab:currenttab,tabids:tabids,titles:titles,handleTabData:this.handleTabData,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,dyParams:dyParams,sebaseid:'7'};var edata_img={data:{}};if(!(0,_lodash.isEmpty)(edata)&&isHasRight){edata_img=(0,_lodash.cloneDeep)(edata);if(edata_img.data&&edata_img.data.tabsetting)edata_img.data.tabsetting.imgs=[];}var EContentHtml=_react2.default.createElement('div',null);if(isHasRight){if(!(0,_lodash.isEmpty)(edata))EContentHtml=_react2.default.createElement(_EContent2.default,{onRef:this.onRef,config:config,ref:"eContent",fontSizeMp:fontSizeMp,handleDelete:this.handleDelete,handleRefresh:this.handleRefresh,edata:!refresh?edata:edata_img,onChangeShowAdd:this.onChangeShowAdd,onChangeCanEdit:this.onChangeCanEdit});}else{EContentHtml=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{datas:datas,config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeM:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',height:'100%'}},_react2.default.createElement('div',{style:{width:'auto',height:'100%',position:'relative'}},this.state.canEdit&&_react2.default.createElement('div',(0,_defineProperty3.default)({title:'\u65B0\u5EFA\u6587\u6863',style:{right:'30px',bottom:'20px',position:'absolute'},className:'portal-element-news-doc-add-icon '+(this.state.isShowAdd?'':'portal-element-news-doc-add-hidden'),onMouseOver:function onMouseOver(){_this3.setState({color:'#434343'});_this3.onChangeShowAdd(true);},onMouseLeave:function onMouseLeave(){_this3.setState({color:'#939393'});_this3.onChangeShowAdd(false);},onClick:function onClick(){_this3.refs&&_this3.refs.eContent.handleOpen();}},'style',{color:this.state.color}),_react2.default.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),edata.tabids&&edata.tabids.length>1?_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)):_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height},onMouseOver:function onMouseOver(){_this3.onChangeShowAdd(true);},onMouseLeave:function onMouseLeave(){return _this3.onChangeShowAdd(false);}},_react2.default.createElement(_antd.Spin,{spinning:refresh},EContentHtml)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid}))));}}]);return News;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);News=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(News);exports.default=News;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _Title=__webpack_require__(644);var _Title2=_interopRequireDefault(_Title);var _MarqueeCom=__webpack_require__(48);var _MarqueeCom2=_interopRequireDefault(_MarqueeCom);var _NewsType=__webpack_require__(645);var _NewsType2=_interopRequireDefault(_NewsType);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ls=_ecCom.WeaTools.ls;//内容组件
var EContent=function(_React$Component){(0,_inherits3.default)(EContent,_React$Component);function EContent(props){(0,_classCallCheck3.default)(this,EContent);var _this=(0,_possibleConstructorReturn3.default)(this,(EContent.__proto__||(0,_getPrototypeOf2.default)(EContent)).call(this,props));_this.state={tabdata:props.edata.data,currentTab:props.edata.currenttab,refresh:false};_this.toggleTabPage=_this.toggleTabPage.bind(_this);_this.handleTabData=_this.handleTabData.bind(_this);_this.canOnclick=_this.canOnclick.bind(_this);_this.handleOpen=_this.handleOpen.bind(_this);if(window.element_news_refresh&&(typeof element_news_refresh==='undefined'?'undefined':(0,_typeof3.default)(element_news_refresh))=='object'){window.element_news_refresh[props.config.params.eid]=_this.handleTabData.bind(_this);}else{var obj={};obj[props.config.params.eid]=_this.handleTabData.bind(_this);window.element_news_refresh=obj;}return _this;}(0,_createClass3.default)(EContent,[{key:'componentWillMount',value:function componentWillMount(){this.canOnclick();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(nextProps,this.props)){this.setState({tabdata:nextProps.edata.data,currentTab:nextProps.edata.currenttab,refresh:false});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.state,nextState)||!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'componentDidMount',value:function componentDidMount(){this.props.onRef(this);}},{key:'toggleTabPage',value:function toggleTabPage(tabid){var currentTab=this.state.currentTab;this.setState({refresh:!(tabid===currentTab)});this.handleTabData(tabid);}},{key:'handleTabData',value:function handleTabData(tabid){var _this2=this;var _props$config=this.props.config,params=_props$config.params,isremembertab=_props$config.isremembertab;this.setState({currentTab:tabid,tabdata:ls.getJSONObj('tabdata-'+params.eid+'-'+tabid)});_ecCom.WeaTools.callApi('/api/portal/element/newstab','POST',(0,_extends3.default)({},params,{tabid:tabid})).then(function(result){ls.set('tabdata-'+params.eid+'-'+tabid,result);if(tabid===_this2.state.currentTab){_this2.setState({tabdata:result,refresh:false});if(isremembertab){var edata=ls.getJSONObj('edata-'+params.eid);if(edata){edata.currenttab=tabid;edata.data=result;ls.set('edata-'+params.eid,edata);}}}});}},{key:'handleOpen',value:function handleOpen(){var tabdata=this.state.tabdata;var _tabdata$tabsetting=tabdata.tabsetting,tabsetting=_tabdata$tabsetting===undefined?{}:_tabdata$tabsetting;var catalogId=tabsetting.catalogId,catalogIds=tabsetting.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'canOnclick',value:function canOnclick(){var currentTab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.state.currentTab;var _props=this.props,config=_props.config,edata=_props.edata,onChangeCanEdit=_props.onChangeCanEdit;var _state$tabdata=this.state.tabdata,tabdata=_state$tabdata===undefined?{}:_state$tabdata;var data=edata.data;var eid=config.params.eid;var _tabdata$docParams=tabdata.docParams,docParams=_tabdata$docParams===undefined?{}:_tabdata$docParams;var docCatalogIds=docParams.docCatalogIds;if(docCatalogIds&&docCatalogIds.length>0){var rightArr=ls.getJSONObj('portal-doc-right');var params={ids:docCatalogIds.join()};if(rightArr==null){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);ls.set('portal-doc-right',[{eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right}]);});}else{var isHave=false;rightArr.map(function(item){if(item.eid==eid&&item.tabid==currentTab){onChangeCanEdit(item.right);isHave=true;return;}});if(!isHave){_ecCom.WeaTools.callApi('/api/portal/elementsetdoc/docsetright','POST',params).then(function(result){var right=result.canEdit=='true'?true:false;onChangeCanEdit(right);rightArr.push({eid:eid,tabid:currentTab,data:(0,_common.formatDate)(new Date(),"yyyy-MM-dd"),right:right});ls.set('portal-doc-right',rightArr);});}}}else{onChangeCanEdit(false);}}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,config=_props2.config,edata=_props2.edata,handleRefresh=_props2.handleRefresh,handleDelete=_props2.handleDelete,fontSizeMp=_props2.fontSizeMp,onChangeShowAdd=_props2.onChangeShowAdd;var _state=this.state,tabdata=_state.tabdata,currentTab=_state.currentTab,refresh=_state.refresh;var _edata$tabids=edata.tabids,tabids=_edata$tabids===undefined?[]:_edata$tabids,_edata$titles=edata.titles,titles=_edata$titles===undefined?[]:_edata$titles,counts=edata.counts,_edata$esetting=edata.esetting,esetting=_edata$esetting===undefined?{}:_edata$esetting;var eid=config.params.eid;var fontStyle=config.item.fontStyle;var _config$item$contentv=config.item.contentview,contentview=_config$item$contentv===undefined?{}:_config$item$contentv;if(!(0,_lodash.isEmpty)(fontSizeMp))fontStyle=fontSizeMp;esetting.fontStyle=fontStyle;var cstyle=tabids&&tabids.length>1&&contentview.style&&contentview.style.height?{height:parseInt(contentview.style.height)-32+"px",overflow:"auto"}:{};var contentHtml=_react2.default.createElement('div',null);var more='';var tabdata_img={};if(!(0,_lodash.isEmpty)(tabdata)){tabdata_img=_.cloneDeep(tabdata);tabdata_img.tabsetting.imgs=[];}if(tabdata){more=tabdata.tabsetting.more;contentHtml=_react2.default.createElement(_MarqueeCom2.default,{tabdata:!refresh?tabdata:tabdata_img,eid:eid,scolltype:tabdata.tabsetting.rollDirection},_react2.default.createElement(_NewsType2.default,{eid:eid,data:!refresh?tabdata:tabdata_img,esetting:esetting}));}var _titleProps={currentTab:currentTab,config:config,titles:titles,counts:counts,tabids:tabids,handleRefresh:handleRefresh,handleDelete:handleDelete,more:more,fontSizeMp:fontSizeMp,tabwidth:esetting.tabwidth,methodvalue:esetting.methodvalue,handleTabData:this.toggleTabPage};return _react2.default.createElement('div',null,_react2.default.createElement(_Title2.default,_titleProps),_react2.default.createElement('div',{className:'tabContant',id:'tabcontant_'+eid,onMouseOver:function onMouseOver(){_this3.canOnclick();onChangeShowAdd(true);},style:{height:cstyle.height},onMouseLeave:function onMouseLeave(){return onChangeShowAdd(false);}},_react2.default.createElement(_antd.Spin,{spinning:refresh},contentHtml)));}}]);return EContent;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);EContent=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(EContent);exports.default=EContent;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _OpToolbar=__webpack_require__(22);var _OpToolbar2=_interopRequireDefault(_OpToolbar);var _TitleTabPane=__webpack_require__(21);var _TitleTabPane2=_interopRequireDefault(_TitleTabPane);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//tab的标题组件
var Title=function(_React$Component){(0,_inherits3.default)(Title,_React$Component);function Title(props){(0,_classCallCheck3.default)(this,Title);var _this=(0,_possibleConstructorReturn3.default)(this,(Title.__proto__||(0,_getPrototypeOf2.default)(Title)).call(this,props));_this.setMoreHref=_this.setMoreHref.bind(_this);return _this;}(0,_createClass3.default)(Title,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,config=_props.config,tabids=_props.tabids;var _config$item=config.item,eid=_config$item.eid,header=_config$item.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,config=_props2.config,tabids=_props2.tabids;var _config$item2=config.item,eid=_config$item2.eid,header=_config$item2.header;this.setMoreHref();(0,_common.handleWidth)(eid,config.params.hpid,tabids.length,header.canHeadbar,header.displayPosition);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!(0,_lodash.isEqual)(this.props,nextProps);}},{key:'setMoreHref',value:function setMoreHref(){var _props3=this.props,config=_props3.config,more=_props3.more,currentTab=_props3.currentTab;var eid=config.item.eid;if(more&&JSON.parse(more).viewType!="6"){window.elements_more_params[eid]={isRouteUrl:true,paramsStr:"&jsonstr="+escape(more)};}else{window.elements_more_params[eid]={isRouteUrl:false,paramsStr:"&tabid="+currentTab};}}},{key:'render',value:function render(){var _props4=this.props,currentTab=_props4.currentTab,config=_props4.config,_props4$tabids=_props4.tabids,tabids=_props4$tabids===undefined?[]:_props4$tabids,_props4$titles=_props4.titles,titles=_props4$titles===undefined?[]:_props4$titles,handleRefresh=_props4.handleRefresh,handleDelete=_props4.handleDelete,handleTabData=_props4.handleTabData,fontSizeMp=_props4.fontSizeMp;var _config$params=config.params,eid=_config$params.eid,ebaseid=_config$params.ebaseid;var header=config.item.header;var _config$item$fontStyl=config.item.fontStyle,fontStyle=_config$item$fontStyl===undefined?{}:_config$item$fontStyl;if(!(0,_lodash.isEmpty)(fontSizeMp)){fontStyle=fontSizeMp;}var className=tabids.length<=1?'nodisplay':'';if(header.displayPosition&&header.displayPosition=='bottom'){return _react2.default.createElement('div',{id:'titleContainer_'+eid,className:'titlecontainer '+className},_react2.default.createElement(_TitleTabPane2.default,{datas:this.props,fontStyle:fontStyle,ebaseid:ebaseid}),!config.item.header.canHeadbar?_react2.default.createElement(_OpToolbar2.default,{config:config,clsname:className,handleRefresh:handleRefresh,handleDelete:handleDelete}):'');}else{return _react2.default.createElement('div',null);}}}]);return Title;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);Title=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(Title);exports.default=Title;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(40);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _typeof2=__webpack_require__(19);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _lodash=__webpack_require__(9);var _common=__webpack_require__(10);var _objectAssign=__webpack_require__(37);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//文档中心元素
var NewsType=function(_React$Component){(0,_inherits3.default)(NewsType,_React$Component);function NewsType(props){(0,_classCallCheck3.default)(this,NewsType);return(0,_possibleConstructorReturn3.default)(this,(NewsType.__proto__||(0,_getPrototypeOf2.default)(NewsType)).call(this,props));}(0,_createClass3.default)(NewsType,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!(0,_lodash.isEqual)(this.props,nextProps)||!(0,_lodash.isEqual)(this.state,nextState);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,eid=_props.eid,data=_props.data,_props$esetting=_props.esetting,esetting=_props$esetting===undefined?{}:_props$esetting,canEdit=_props.canEdit;var linkmode=esetting.linkmode;var _data$tabsetting=data.tabsetting,tabsetting=_data$tabsetting===undefined?{}:_data$tabsetting,_data$srcStyle=data.srcStyle,srcStyle=_data$srcStyle===undefined?{}:_data$srcStyle;var _srcStyle$autoheight=srcStyle.autoheight,autoheight=_srcStyle$autoheight===undefined?'0':_srcStyle$autoheight,_srcStyle$pictureheig=srcStyle.pictureheight,pictureheight=_srcStyle$pictureheig===undefined?'108px':_srcStyle$pictureheig,_srcStyle$picturewidt=srcStyle.picturewidth,picturewidth=_srcStyle$picturewidt===undefined?'120px':_srcStyle$picturewidt;var _tabsetting$style=tabsetting.style,_tabsetting$style$abs=_tabsetting$style.abstractColor,abstractColor=_tabsetting$style$abs===undefined?'#797979':_tabsetting$style$abs,_tabsetting$style$abs2=_tabsetting$style.abstractFont,abstractFont=_tabsetting$style$abs2===undefined?'微软雅黑':_tabsetting$style$abs2,_tabsetting$style$abs3=_tabsetting$style.abstractSize,abstractSize=_tabsetting$style$abs3===undefined?'12':_tabsetting$style$abs3,abstractstyle=_tabsetting$style.abstractstyle,_tabsetting$style$abs4=_tabsetting$style.abstractWeight,abstractWeight=_tabsetting$style$abs4===undefined?'0':_tabsetting$style$abs4,_tabsetting$style$tit=_tabsetting$style.titleColor,titleColor=_tabsetting$style$tit===undefined?'#000000':_tabsetting$style$tit,_tabsetting$style$tit2=_tabsetting$style.titleFont,titleFont=_tabsetting$style$tit2===undefined?'微软雅黑':_tabsetting$style$tit2,_tabsetting$style$tit3=_tabsetting$style.titleSize,titleSize=_tabsetting$style$tit3===undefined?'16':_tabsetting$style$tit3,titlestyle=_tabsetting$style.titlestyle,_tabsetting$style$tit4=_tabsetting$style.titleWeight,titleWeight=_tabsetting$style$tit4===undefined?'0':_tabsetting$style$tit4;var list=data.data;if(list.length===0){return React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,' ',React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')));}//tab设置信息
var height=tabsetting.height,width=tabsetting.width,showModeId=tabsetting.showModeId,imgs=tabsetting.imgs;var columns=new Array();var imgStyle={width:picturewidth,height:pictureheight};var style={verticalAlign:'top',width:picturewidth,height:pictureheight};if(autoheight=='1'){imgStyle={verticalAlign:'top',width:picturewidth,height:'auto'};style={verticalAlign:'top',width:picturewidth,height:'auto'};}var listStyle2={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1&&imgStyle.width.indexOf('px')!=-1){listStyle2={width:imgStyle.width,height:imgStyle.height};}var docHtml='';switch(parseInt(showModeId)){case 2://上图式
imgStyle['margin']='0 auto';var lHtml=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:img});}}var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{id:'news_'+eid},React.createElement('div',{style:imgStyle},imghtml),React.createElement('div',{style:{width:imgStyle.width,margin:'0 auto',paddingTop:'10px'}},item.docsubject?React.createElement('div',{style:{marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{display:'-webkit-box',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'2',WebkitBoxOrient:'vertical'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%',height:'32px'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px',width:'60px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',bottom:'15px',float:'right',width:'calc(100% - 60px - 10px)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,lHtml);break;case 3://左图式
var html=list.map(function(item,i){var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var img=imgs[i];if((typeof img==='undefined'?'undefined':(0,_typeof3.default)(img))=='object'&&img.length>1){img=img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var list_new=[];for(var i in item){if(i!='summary'&&i!='docsubject'&&i!='doccreater'){list_new.push(item[i]);}}return React.createElement('div',{style:{overflow:'auto',overflowY:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},item.docsubject?React.createElement('div',{style:{marginTop:'10px',marginRight:'10px'}},(0,_common.loadRemind)(item.docsubject,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid,style={fontFamily:'PingFangSC-Regular',fontSize:'14px !important',color:'#333333',letterSpacing:'-0.09px'})):React.createElement('div',{style:{marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),item.summary&&React.createElement('div',null,React.createElement('span',{style:{width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:'1',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)),React.createElement('div',{style:{display:'inline-block',position:'relative',width:'100%'}},item.doccreater?React.createElement('div',{style:{display:'inline-block',marginRight:'10px',marginBottom:'10px'}},(0,_common.loadRemind)(item.doccreater,esetting.linkmode,esetting.isremind,undefined,undefined,'7_DY',eid)):React.createElement('div',{style:{display:'inline-block',marginTop:'10px',marginRight:'10px',marginBottom:'10px'}}),React.createElement('div',{style:{display:'inline-block',position:'absolute',bottom:'15px',float:'right',width:'100%'}},list_new.map(function(item_new){return React.createElement('div',{style:{display:'inline-block',paddingLeft:'5px',fontSize:'12px',color:'#999999',letterSpacing:'-0.08px'}},item_new);})))));});docHtml=React.createElement('div',null,html);break;case 4://列表式2
var html4=null;var imghtml=null;var imghtml2=[];var j=0;var imgs_new=imgs.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});if(!(0,_lodash.isEmpty)(imgs)){if(imgs_new.length>1){imgs.map(function(item,i){imghtml2[j]=imgs[i];j++;});if(imghtml2.length==0){imghtml2[0]='/images/homepage/noimgdefault_wev8.jpg';}var ihtml=imghtml2.map(function(item,i){var img=imghtml2[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img=='/images/homepage/noimgdefault_wev8.jpg'){return;}// if (img.indexOf("|") !== -1) img = img.split("|")[0];
return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,style:listStyle2,eid:eid,src:img}));});imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},ihtml));}else{var img=imgs_new[0];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];imghtml=React.createElement('div',{style:{height:style.height||'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[0]&&list[0].docsubject&&list[0].docsubject.link,style:listStyle2,eid:eid,src:img})));}}columns=(0,_common.formatData)(list[0],esetting);style['paddingTop']='6px';html4=React.createElement('table',{style:{width:'100%',tableLayout:'fixed'}},React.createElement('tr',null,React.createElement('td',{style:style},imghtml),React.createElement('td',{width:'*',className:'valign'},React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'}))));docHtml=React.createElement('div',null,html4);break;case 5://双列式
columns=(0,_common.formatData)(list[0],esetting);var evenData=new Array();var oddData=new Array();list.map(function(item,i){if(i%2===0){evenData.push(item);}else{oddData.push(item);}});if(!(0,_lodash.isEmpty)(evenData)&&!(0,_lodash.isEmpty)(oddData)){docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement('div',{className:'ant-table-placeholder'},React.createElement('span',null,React.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据')))));}else{docHtml=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12,order:1},!(0,_lodash.isEmpty)(evenData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:evenData,size:'small'})),React.createElement(_antd.Col,{span:12,order:2},!(0,_lodash.isEmpty)(oddData)&&React.createElement(_ecCom.WeaTable,{columns:columns,showHeader:false,pagination:false,dataSource:oddData,size:'small'}))));}break;case 6://摘要式
var html6=list.map(function(item,i){var docsubject=item.docsubject||{};var imghtml=null;if(!(0,_lodash.isEmpty)(imgs)){var _img=imgs[i];if((typeof _img==='undefined'?'undefined':(0,_typeof3.default)(_img))=='object'&&_img.length>1){_img=_img.filter(function(item){if(item!='/images/homepage/noimgdefault_wev8.jpg'){return item;}});imghtml=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_img.map(function(o){return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:o,style:listStyle2}));})));}else{imghtml=React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,eid:eid,src:_img});}}var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left'});return React.createElement('div',{style:{width:'100%',paddingBottom:'20px',marginBottom:'5px',borderBottom:i!==list.length-1?'1px solid #dedede':'',overflow:'hidden'}},React.createElement('div',{style:style_fs},' ',imghtml),React.createElement('div',{style:{overflow:'hidden',paddingLeft:'3px'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{verticalAlign:'middle',marginTop:'-25px',marginLeft:'5px',cursor:'pointer'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{height:'60px',lineHeight:'30px',color:'rgb(105, 104, 104)',textOverflow:'ellipsis',width:'99%',overflow:'hidden',WebkitLineClamp:'2',WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)));});docHtml=React.createElement('div',null,html6);break;case 7://摘要式2
var listStyle3={width:'100%',height:'100%'};if(autoheight=='0'&&imgStyle.height&&imgStyle.height.indexOf('px')!=-1){listStyle3={width:'100%',height:imgStyle.height};}var imghtml7=null;var style_fs=(0,_objectAssign2.default)({},imgStyle,{float:'left',marginBottom:'15px'});var imghtml3=[];var m=0;if(!(0,_lodash.isEmpty)(imgs)){if(imgs.length>1){imgs.map(function(item,i){if(imgs[i]!='/images/homepage/noimgdefault_wev8.jpg'){imghtml3[m]=imgs[i];m++;}});if(imghtml3.length==0){imghtml3=['/images/homepage/noimgdefault_wev8.jpg'];}var _ihtml=imghtml3.map(function(item,i){var img=imghtml3[i];if(!img)img='/images/homepage/noimgdefault_wev8.jpg';if(img.indexOf("|")!==-1)img=img.split("|")[0];return React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[i]&&list[i].docsubject&&list[i].docsubject.link,style:listStyle3,eid:eid,src:img}));});imghtml7=React.createElement('div',{id:'news_silde_'+eid,className:'news-silde'},React.createElement(_antd.Carousel,{autoplay:true},_ihtml));}else{var _img2=imgs_new[0];if(!_img2)_img2='/images/homepage/noimgdefault_wev8.jpg';if(_img2.indexOf("|")!==-1)_img2=_img2.split("|")[0];imghtml7=React.createElement('div',{style:{height:'100%'},id:'news_silde_'+eid,className:'news-silde'},React.createElement('div',null,React.createElement(ImgCom,{linkmode:linkmode,link:list[0]&&list[0].docsubject&&list[0].docsubject.link,style:listStyle3,eid:eid,src:_img2})));}}var html7=list.map(function(item,i){var docsubject=item.docsubject||{};return React.createElement('div',{style:{float:'left',paddingLeft:'10px',width:'100%',borderBottom:i!==list.length-1?'1px solid #dedede':''}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(_this2,docsubject.link,esetting.linkmode),style:{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer'}},docsubject.name),docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject.img}):''),React.createElement('div',{title:item.summary,style:{display:'-webkit-box',maxHeight:'60px',width:'99%',lineHeight:'30px',color:'#696868',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',marginBottom:'10px'}},item.summary));});docHtml=React.createElement('div',null,React.createElement('div',{style:{width:'100%',marginBottom:'10px'}},React.createElement('div',{style:style_fs},' ',imghtml7),React.createElement('div',{style:{overflow:'hidden'}},html7)));break;case 8://头条式
var item=list[0];var docsubject=item.docsubject||{};var tableHtml='';var newList=[].concat((0,_toConsumableArray3.default)(list));if(list.length>1){var _columns=(0,_common.formatData)(list[1],esetting);tableHtml=React.createElement(_ecCom.WeaTable,{columns:_columns,showHeader:false,pagination:false,dataSource:newList.slice(1,list.length),size:'small'});}docHtml=React.createElement('div',null,React.createElement('div',{style:{overflow:'hidden',width:'100%',marginBottom:'10px'}},React.createElement('div',{style:{width:'100%'}},React.createElement('div',{style:{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}},React.createElement('div',{style:{height:'32px',width:'99%'}},React.createElement('div',{title:docsubject.name,onClick:_common.openLinkUrl.bind(this,docsubject.link,esetting.linkmode),style:{fontSize:titleSize.indexOf("px")>0?titleSize:titleSize+'px'||'16px',color:titleColor||'#000000',fontFamily:titleFont||'微软雅黑',fontWeight:titleWeight=='0'?'normal':'bold ',fontStyle:titlestyle||'normal',display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:1,WebkitBoxOrient:'vertical',cursor:'pointer',width:'100%'}},docsubject.name,docsubject.img?React.createElement(ImgCom,{linkmode:linkmode,eid:eid,style:{margin:'0 0 11px 2px'},alt:'',src:docsubject.img}):'')),React.createElement('div',{title:item.summary,style:{fontSize:abstractSize.indexOf('px')>0?abstractSize:abstractSize+'px'||'16px',color:abstractColor||'#000000',fontFamily:abstractFont||'微软雅黑',fontWeight:abstractWeight=='0'?'normal':'bold',fontStyle:abstractstyle||'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',marginBottom:'10px'}},item.summary)))),tableHtml);break;case 1://列表式
default:columns=(0,_common.formatData)(list[0],esetting);docHtml=React.createElement(_ecCom.WeaTable,{style:{fontSize:'20px'},columns:columns,showHeader:false,pagination:false,dataSource:list,size:'small'});break;}// return <AddNewCom canEdit={this.props.canEdit} catalogIds={tabsetting.catalogIds} catalogId={tabsetting.catalogId}>{docHtml}</AddNewCom>
return docHtml;}}]);return NewsType;}(React.Component);var AddNewCom=function(_React$Component2){(0,_inherits3.default)(AddNewCom,_React$Component2);function AddNewCom(props){(0,_classCallCheck3.default)(this,AddNewCom);var _this3=(0,_possibleConstructorReturn3.default)(this,(AddNewCom.__proto__||(0,_getPrototypeOf2.default)(AddNewCom)).call(this,props));_this3.state={isShowAdd:false,color:'#939393'};_this3.handleOpen=_this3.handleOpen.bind(_this3);return _this3;}(0,_createClass3.default)(AddNewCom,[{key:'handleOpen',value:function handleOpen(){var _props2=this.props,catalogId=_props2.catalogId,catalogIds=_props2.catalogIds;if(catalogId){(0,_common.openLinkUrl)('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');}else{(0,_common.openLinkUrl)('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');}}},{key:'render',value:function render(){var _this4=this;var _props3=this.props,children=_props3.children,canEdit=_props3.canEdit;if(canEdit){return React.createElement('div',{className:' portal-element-news-doc-add',onMouseOver:function onMouseOver(){return _this4.setState({isShowAdd:true});},onMouseLeave:function onMouseLeave(){return _this4.setState({isShowAdd:false});}},React.createElement('div',{title:'\u65B0\u5EFA\u6587\u6863',className:'portal-element-news-doc-add-icon '+(this.state.isShowAdd?'':'portal-element-news-doc-add-hidden'),onMouseOver:function onMouseOver(){return _this4.setState({color:'#434343'});},onMouseLeave:function onMouseLeave(){return _this4.setState({color:'#939393'});},onClick:this.handleOpen,style:{color:this.state.color}},React.createElement('img',{src:'/spa/portal/images/news_add.png',alt:''})),children);}return React.createElement('div',null,children);}}]);return AddNewCom;}(React.Component);var ImgCom=function(_React$Component3){(0,_inherits3.default)(ImgCom,_React$Component3);function ImgCom(props){(0,_classCallCheck3.default)(this,ImgCom);var _this5=(0,_possibleConstructorReturn3.default)(this,(ImgCom.__proto__||(0,_getPrototypeOf2.default)(ImgCom)).call(this,props));_this5.aClick=_this5.aClick.bind(_this5);return _this5;}(0,_createClass3.default)(ImgCom,[{key:'aClick',value:function aClick(){var _props4=this.props,_props4$link=_props4.link,link=_props4$link===undefined?'':_props4$link,_props4$linkmode=_props4.linkmode,linkmode=_props4$linkmode===undefined?'1':_props4$linkmode;if(link!=''){(0,_common.openLinkUrl)(link,linkmode);// window.open(link, linkmode);
}else return false;}},{key:'render',value:function render(){var _props5=this.props,_props5$src=_props5.src,src=_props5$src===undefined?'':_props5$src,_props5$style=_props5.style,style=_props5$style===undefined?{width:'100%',height:'100%'}:_props5$style;return React.createElement('a',{href:'javascript:void(0)',onClick:this.aClick},React.createElement('img',{alt:'',style:style,src:src}));}}]);return ImgCom;}(React.Component);var MyErrorHandler=function(_React$Component4){(0,_inherits3.default)(MyErrorHandler,_React$Component4);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return React.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(React.Component);NewsType=_ecCom.WeaTools.tryCatch(React,MyErrorHandler,{error:""})(NewsType);exports.default=NewsType;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _EHeader=__webpack_require__(13);var _EHeader2=_interopRequireDefault(_EHeader);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 自定义元素
var CustomElement=function(_React$Component){(0,_inherits3.default)(CustomElement,_React$Component);function CustomElement(props){(0,_classCallCheck3.default)(this,CustomElement);var _this=(0,_possibleConstructorReturn3.default)(this,(CustomElement.__proto__||(0,_getPrototypeOf2.default)(CustomElement)).call(this,props));_this.state={loading:false,deleted:false};_this.handleRefresh=_this.handleRefresh.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);return _this;}(0,_createClass3.default)(CustomElement,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props$config=this.props.config,config=_props$config===undefined?{}:_props$config;var _config$item=config.item,item=_config$item===undefined?{}:_config$item;var _item$custom=item.custom,custom=_item$custom===undefined?{}:_item$custom;var modulename=custom.modulename,packagename=custom.packagename;if(modulename&&!window[packagename]){this.setState({loading:true});_ecCom.WeaTools.loadDevModules(modulename,packagename).then(function(){var _interval=window.setInterval(function(){if(window[packagename]){_this2.setState({loading:false});window.clearInterval(_interval);}},100);});}}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,deleted=_state.deleted;// 元素已删除，返回空
if(deleted)return _react2.default.createElement('div',null);var _props=this.props,config=_props.config,fontSizeMp=_props.fontSizeMp;var isHasRight=config.isHasRight,isSetting=config.isSetting,item=config.item,params=config.params,synergyParams=config.synergyParams;var eid=item.eid,ebaseid=item.ebaseid,style=item.style,contentview=item.contentview,_item$custom2=item.custom,custom=_item$custom2===undefined?{}:_item$custom2;var _contentview$style=contentview.style,style1=_contentview$style===undefined?{}:_contentview$style;var packagename=custom.packagename,viewcompname=custom.viewcompname,moreurl=custom.moreurl;try{if(moreurl){if(config.item.header&&config.item.header.toolbar&&config.item.header.toolbar.more){if(moreurl.indexOf('?')!=-1){moreurl+='&eid='+eid;}else{moreurl+='?eid='+eid;}config.item.header.toolbar.more.morehref=moreurl;}}else{config.item.header.toolbar.more=null;}}catch(e){}var EContent=null;if(isHasRight){if(!loading){if(window.rewritePortalCusEle&&typeof rewritePortalCusEle=='function'){var props=(0,_extends3.default)({},this.props);var options={config:config,fontSizeMp:fontSizeMp,isSetting:isSetting,id:eid,eid:eid,ebaseid:ebaseid,params:params,synergyParams:synergyParams};EContent=window.rewritePortalCusEle(props,options);}if(EContent==null&&window[packagename]&&window[packagename]['com']&&window[packagename]['com'][viewcompname]){var EContentTemp=window[packagename]['com'][viewcompname];EContent=_react2.default.createElement(EContentTemp,(0,_extends3.default)({},this.props,{config:config,fontSizeMp:fontSizeMp,isSetting:isSetting,id:eid,eid:eid,params:params,synergyParams:synergyParams}));}}else{EContent=_react2.default.createElement('div',{style:{width:'100%',height:'60px'}});}}else{EContent=_react2.default.createElement(_common.NoRightCom,null);}return _react2.default.createElement('div',{className:'item',style:style,id:'item_'+eid,'data-eid':eid,'data-ebaseid':ebaseid,'data-needRefresh':item.needRefresh,'data-cornerTop':item.cornerTop,'data-cornerTopRadian':item.cornerTopRadian,'data-cornerBottom':item.cornerBottom,'data-cornerBottomRadian':item.cornerBottomRadian},_react2.default.createElement(_EHeader2.default,{config:config,handleRefresh:this.handleRefresh,handleDelete:this.handleDelete,fontSizeMp:fontSizeMp}),_react2.default.createElement('div',{className:'setting',id:'setting_'+eid}),_react2.default.createElement('div',{className:'content',id:'content_'+eid,style:{width:'auto',_width:'100%'}},_react2.default.createElement('div',{className:'content_view',id:'content_view_id_'+eid,style:{height:style1.height}},_react2.default.createElement(_antd.Spin,{spinning:loading},EContent)),_react2.default.createElement('div',{style:{textAlign:'right'},id:'footer_'+eid})));}},{key:'handleRefresh',value:function handleRefresh(){var _this3=this;this.setState({loading:true});setTimeout(function(){return _this3.setState({loading:false});},100);}},{key:'handleDelete',value:function handleDelete(){this.setState({deleted:true});}}]);return CustomElement;}(_react2.default.Component);exports.default=CustomElement;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(9);var _ecCom=__webpack_require__(5);var _elements=__webpack_require__(100);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;//引入元素组件
var ElementIndie=function(_React$Component){(0,_inherits3.default)(ElementIndie,_React$Component);function ElementIndie(props){(0,_classCallCheck3.default)(this,ElementIndie);var _this=(0,_possibleConstructorReturn3.default)(this,(ElementIndie.__proto__||(0,_getPrototypeOf2.default)(ElementIndie)).call(this,props));_this.state={config:null,eCss:''};_this.getElementData=_this.getElementData.bind(_this);return _this;}(0,_createClass3.default)(ElementIndie,[{key:'getElementData',value:function getElementData(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var url=params.elementtype=='elementtemplate'?'/api/portal/elementtemplate/preview':'/api/portal/elementindie/elementinfo';_ecCom.WeaTools.callApi(url,'POST',params).then(function(data){if(data.status==='2'){message.error(data.errormsg);}else{_this2.setState({config:data.config,eCss:data.eCss});}});}},{key:'componentWillMount',value:function componentWillMount(){this.getElementData(this.props.params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!(0,_lodash.isEqual)(this.props.params,nextProps.params)){this.getElementData(nextProps.params);}}},{key:'render',value:function render(){var _state=this.state,config=_state.config,eCss=_state.eCss;if(!config)return _react2.default.createElement('div',null);var styleStr="<style type='text/css'>"+eCss.replace(/\"/g,"")+"</style>";return _react2.default.createElement('div',null,_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:styleStr}}),_react2.default.createElement(_elements.Element,{config:config}));}}]);return ElementIndie;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);ElementIndie=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(ElementIndie);exports.default=ElementIndie;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(5);var _Homepage=__webpack_require__(69);var _Homepage2=_interopRequireDefault(_Homepage);var _Synergy=__webpack_require__(649);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Synergy=function(_React$Component){(0,_inherits3.default)(Synergy,_React$Component);function Synergy(props){(0,_classCallCheck3.default)(this,Synergy);var _this=(0,_possibleConstructorReturn3.default)(this,(Synergy.__proto__||(0,_getPrototypeOf2.default)(Synergy)).call(this,props));_this.state={hpid:0,isuse:false,width:_Synergy.SYNERGY_WIDTH,visible:false,btnHover:false};_this.getSynergyPortal=_this.getSynergyPortal.bind(_this);_this.isShowSynergy=_this.isShowSynergy.bind(_this);return _this;}(0,_createClass3.default)(Synergy,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,pathname=_props.pathname,workflowid=_props.workflowid,requestid=_props.requestid;if(pathname!='/workflow/req'||pathname=='/workflow/req'&&!!workflowid&&!!requestid){this.getSynergyPortal(this.props);}}},{key:'componentDidMount',value:function componentDidMount(){window.isShowSynergy=this.isShowSynergy;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var isNeedReq=this.props.pathname!=nextProps.pathname||this.props.workflowid!=nextProps.workflowid||this.props.requestid!=nextProps.requestid||this.props.secid!=nextProps.secid||this.props.docid!=nextProps.docid;if(isNeedReq){this.getSynergyPortal(nextProps);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.state.hpid!=nextState.hpid||this.state.isuse!=nextState.isuse||this.state.visible!=nextState.visible||this.state.btnHover!=nextState.btnHover||this.props.formData!=nextProps.formData;}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,_props2$workflowid=_props2.workflowid,workflowid=_props2$workflowid===undefined?-1:_props2$workflowid,_props2$requestid=_props2.requestid,requestid=_props2$requestid===undefined?-1:_props2$requestid,_props2$formData=_props2.formData,formData=_props2$formData===undefined?{}:_props2$formData;var _state=this.state,hpid=_state.hpid,isuse=_state.isuse,width=_state.width,visible=_state.visible,btnHover=_state.btnHover;if(hpid!=0&&isuse){var content=_react2.default.createElement('div',null);if(visible){content=_react2.default.createElement('div',{style:{position:'absolute',top:0,right:0,zIndex:998,width:'100%',height:'100%',padding:'10px',overflow:'auto',background:'#f6f7f9',borderLeft:'1px solid #e2e2e2'}},_react2.default.createElement(_Homepage2.default,{hpid:hpid,workflowid:workflowid,requestid:requestid,formData:formData}));}var style={position:'absolute',top:'50%',left:'1px',zIndex:999,width:'16px',height:'60px',background:'url('+('/spa/portal/images/synergy/'+(visible?''+(btnHover?'right_hover.png':'right.png'):''+(btnHover?'left_hover.png':'left.png')))+') center no-repeat',cursor:'pointer'};if(!visible){style={position:'absolute',top:'50%',right:'0',zIndex:999,width:'16px',height:'60px',background:'url('+('/spa/portal/images/synergy/'+(visible?''+(btnHover?'right_hover.png':'right.png'):''+(btnHover?'left_hover.png':'left.png')))+') center no-repeat',cursor:'pointer'};}return _react2.default.createElement('div',{style:{position:'absolute',top:0,right:0,height:'100%',width:visible?width:0}},content,_react2.default.createElement('div',{style:style,title:visible?getLabel(387991,"隐藏协同区"):getLabel(387992,"显示协同区"),onClick:function onClick(){return _this2.setState({visible:!visible});},onMouseOver:function onMouseOver(){return _this2.setState({btnHover:true});},onMouseOut:function onMouseOut(){return _this2.setState({btnHover:false});}}));}else{return _react2.default.createElement('div',null);}}},{key:'getSynergyPortal',value:function getSynergyPortal(params){var _this3=this;var pathname=params.pathname,_params$workflowid=params.workflowid,workflowid=_params$workflowid===undefined?-1:_params$workflowid,_params$requestid=params.requestid,requestid=_params$requestid===undefined?-1:_params$requestid,_params$secid=params.secid,secid=_params$secid===undefined?-1:_params$secid,_params$docid=params.docid,docid=_params$docid===undefined?-1:_params$docid;if(pathname=='/workflow/req'&&requestid==-1){pathname='/workflow/req?iscreate=1';}var pathObj=_Synergy.SYNERGY_PATH_OBJ[pathname]||{};_ecCom.WeaTools.callApi('/api/portal/synergy/getSynergyPortal','GET',{path:pathObj.path||'',pathparam:pathObj.pathparam||'',workflowid:workflowid,requestid:requestid,secid:secid,docid:docid}).then(function(data){_this3.setState({hpid:data.hpid||0,isuse:data.isuse||false,width:data.width||_Synergy.SYNERGY_WIDTH,visible:data.defaultExpand==1?true:false});});}},{key:'isShowSynergy',value:function isShowSynergy(visible){this.setState({visible:visible});}}]);return Synergy;}(_react2.default.Component);exports.default=Synergy;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var SYNERGY_PATH_OBJ=exports.SYNERGY_PATH_OBJ={'/workflow/add':{path:'/workflow/request/RequestTypeShow.jsp',pathparam:''},'/workflow/listDoing':{path:'/workflow/search/WFSearchResult.jsp',pathparam:'scope=doing'},'/workflow/listDone':{path:'/workflow/search/WFSearchResult.jsp',pathparam:'scope=done'},'/workflow/listMine':{path:'/workflow/search/WFSearchResult.jsp',pathparam:'scope=mine'},'/workflow/supervise':{path:'/workflow/search/WFSuperviseList.jsp',pathparam:''},'/workflow/agent':{path:'/workflow/request/wfAgentList.jsp',pathparam:'scope=1'},'/workflow/monitorResult':{path:'/system/systemmonitor/workflow/WorkflowMonitorList.jsp',pathparam:''},'/workflow/queryFlowResult':{path:'/workflow/search/WFSearchShow.jsp',pathparam:''},'/workflow/req?iscreate=1':{path:'/workflow/request/AddRequest.jsp',pathparam:''},'/workflow/req':{path:'/workflow/request/ViewRequest.jsp',pathparam:''},'/document/add':{path:'/docs/docs/DocList.jsp',pathparam:''},'/document/center':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=5'},'/document/search':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=14'},'/document/dummy':{path:'/docs/docdummy/DocDummyRight.jsp',pathparam:''},'/document/subscribe':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=7'},'/document/share':{path:'/docs/search/DocCommonContent.jsp',pathparam:'scope=13'},'/document/move':{path:'/docs/tools/DocCopyMove.jsp',pathparam:''},'/document/monitor':{path:'/system/systemmonitor/docs/DocMonitor.jsp',pathparam:''},'/document/edit':{path:'/docs/docs/DocAdd.jsp',pathparam:''},'/document/detail':{path:'/docs/docs/DocDsp.jsp',pathparam:''}};var SYNERGY_WIDTH=exports.SYNERGY_WIDTH='430px';

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(8);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(6);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(7);var _ecCom=__webpack_require__(5);var _HpBaseElement=__webpack_require__(121);var _HpBaseElement2=_interopRequireDefault(_HpBaseElement);var _Homepage=__webpack_require__(69);var _Homepage2=_interopRequireDefault(_Homepage);var _rcmenu=__webpack_require__(76);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Item=_antd.Menu.Item;var getLabel=_ecCom.WeaLocaleProvider.getLabel;//门户组件
var SynergyPortalSetting=function(_React$Component){(0,_inherits3.default)(SynergyPortalSetting,_React$Component);function SynergyPortalSetting(props){(0,_classCallCheck3.default)(this,SynergyPortalSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(SynergyPortalSetting.__proto__||(0,_getPrototypeOf2.default)(SynergyPortalSetting)).call(this,props));_this.state={params:{},loading:false,data:{hpbaseelements:[],hpsettingmenu:[],rcmenu:[]},showLeft:true,showDrop:false,isShrink:false};_this.onChangeLabel=_this.onChangeLabel.bind(_this);_this.onShowDrop=_this.onShowDrop.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.handleRefreshPortal=_this.handleRefreshPortal.bind(_this);_this.handleAddElementToPortalStart=_this.handleAddElementToPortalStart.bind(_this);_this.handleAddElementToPortal=_this.handleAddElementToPortal.bind(_this);return _this;}(0,_createClass3.default)(SynergyPortalSetting,[{key:'onShowDrop',value:function onShowDrop(){this.setState({showDrop:!this.state.showDrop});}},{key:'getButtons',value:function getButtons(){var _this2=this;var btns=[];var hpsettingmenu=this.state.data.hpsettingmenu;hpsettingmenu.map(function(menu,i){if(menu.key=='more'){btns.push(_react2.default.createElement(OperateMenu,{dropMenuDatas:_this2.getRightMenu(),onShowDrop:_this2.onShowDrop,onDropMenuClick:_this2.onRightMenuClick,showDrop:_this2.state.showDrop},_react2.default.createElement(_antd.Button,{onClick:_this2.onShowDrop},menu.label)));}else{btns.push(_react2.default.createElement(_antd.Button,{type:i===4?'':'primary',onClick:_this2.onRightMenuClick.bind(_this2,menu.key)},menu.label));}});return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];var rcmenu=this.state.data.rcmenu;if(rcmenu){rcmenu.map(function(menu){btns.push({key:menu.key,icon:_react2.default.createElement('i',{className:menu.icon}),content:menu.label});});}return btns;}},{key:'onChangeLabel',value:function onChangeLabel(list,key,bool,label1,lable2){for(var i=0;i<list.length;i++){var item=list[i]||{};if(item.key==key){if(bool){item.label=label1;}else{item.label=lable2;}break;}}}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var _state=this.state,params=_state.params,showLeft=_state.showLeft,isShrink=_state.isShrink,data=_state.data;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;switch(key){case'updatesynihp':case'completesynihp':(0,_rcmenu.handlePortalSynize)({hpid:hpid,subCompanyId:subCompanyId,method:key});break;case'shrinkAll':this.setState({isShrink:!isShrink});this.onChangeLabel(data.rcmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(18466,'全部展开'));this.onChangeLabel(data.hpsettingmenu,'shrinkAll',this.state.isShrink,getLabel(18466,'全部收缩'),getLabel(18466,'全部展开'));(0,_rcmenu.onShowOrHideAllE)(isSetting);break;case'store':(0,_rcmenu.openFavouriteBrowser)();break;case'help':(0,_rcmenu.showHelp)();break;case'hiddenElementLib':this.setState({showLeft:!showLeft});this.onChangeLabel(data.rcmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));this.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',this.state.showLeft,getLabel(19613,"显示元素库"),getLabel(19614,"隐藏元素库"));break;}}},{key:'componentWillMount',value:function componentWillMount(){var params=this.props.params;this.getData(params);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var params=this.props.params;var nextParams=nextProps.params;if(params.hpid!=nextParams.hpid){this.getData(nextParams);}}},{key:'getData',value:function getData(params){var _this3=this;this.setState({loading:true});_ecCom.WeaTools.callApi('/api/portal/hpsetting/hpsettinginfo','POST',(0,_extends3.default)({},params,{isSynergySetting:true})).then(function(data){if(data.status=='2'){_antd.message.error(data.errormsg);return;}_this3.setState({params:params,loading:false,data:data});});}},{key:'handleRefreshPortal',value:function handleRefreshPortal(params){this.refs.homepage.handleRefresh(params);}},{key:'handleAddElementToPortalStart',value:function handleAddElementToPortalStart(){this.setState({loading:true});}},{key:'handleAddElementToPortal',value:function handleAddElementToPortal(element,areaflag,index){this.setState({loading:false});this.refs.homepage.handleAddElement(element,areaflag,index);}},{key:'render',value:function render(){var _this4=this;var _state2=this.state,params=_state2.params,data=_state2.data,showLeft=_state2.showLeft;var hpid=params.hpid,subCompanyId=params.subCompanyId,isSetting=params.isSetting;if(!hpid)return _react2.default.createElement('div',null);return _react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement(_ecCom.WeaLeftRightLayout,{isNew:true,showLeft:showLeft,leftWidth:150,leftCom:_react2.default.createElement(_HpBaseElement2.default,{isSynergySetting:true,handleRefreshPortal:this.handleRefreshPortal,handleAddStart:this.handleAddElementToPortalStart,handleAdd:this.handleAddElementToPortal,params:params,list:data.hpbaseelements}),onCollapse:function onCollapse(bool){_this4.setState({showLeft:bool});_this4.onChangeLabel(data.rcmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel(19613,"显示元素库"));_this4.onChangeLabel(data.hpsettingmenu,'hiddenElementLib',bool,getLabel(19614,"隐藏元素库"),getLabel(19613,"显示元素库"));}},_react2.default.createElement('div',{id:'e9PortalSetting',className:'portal-e9setting',style:{height:'100%'}},_react2.default.createElement(_Homepage2.default,{ref:'homepage',hpid:hpid,isSetting:true,isSynergySetting:true,synergyParams:params})))));}}]);return SynergyPortalSetting;}(_react2.default.Component);var MyErrorHandler=function(_React$Component2){(0,_inherits3.default)(MyErrorHandler,_React$Component2);function MyErrorHandler(){(0,_classCallCheck3.default)(this,MyErrorHandler);return(0,_possibleConstructorReturn3.default)(this,(MyErrorHandler.__proto__||(0,_getPrototypeOf2.default)(MyErrorHandler)).apply(this,arguments));}(0,_createClass3.default)(MyErrorHandler,[{key:'render',value:function render(){var hasErrorMsg=this.props.error&&this.props.error!=="";return _react2.default.createElement(_ecCom.WeaErrorPage,{msg:hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")});}}]);return MyErrorHandler;}(_react2.default.Component);SynergyPortalSetting=_ecCom.WeaTools.tryCatch(_react2.default,MyErrorHandler,{error:""})(SynergyPortalSetting);exports.default=SynergyPortalSetting;var OperateMenu=function(_React$Component3){(0,_inherits3.default)(OperateMenu,_React$Component3);function OperateMenu(){(0,_classCallCheck3.default)(this,OperateMenu);return(0,_possibleConstructorReturn3.default)(this,(OperateMenu.__proto__||(0,_getPrototypeOf2.default)(OperateMenu)).apply(this,arguments));}(0,_createClass3.default)(OperateMenu,[{key:'render',value:function render(){var _props=this.props,dropMenuDatas=_props.dropMenuDatas,onDropMenuClick=_props.onDropMenuClick,onShowDrop=_props.onShowDrop,showDrop=_props.showDrop,children=_props.children;var menu=dropMenuDatas?_react2.default.createElement(_antd.Menu,{mode:'vertical',onClick:function onClick(o){if(typeof onDropMenuClick==='function')onDropMenuClick(o.key);dropMenuDatas.forEach(function(d){if(d.key===o.key&&typeof d.onClick==='function')d.onClick(o.key);});}},dropMenuDatas.map(function(d,i){return _react2.default.createElement(Item,{key:d.key||i,disabled:d.disabled},_react2.default.createElement('span',{className:'wea-right-menu-icon'},d.icon),d.content);})):'';return _react2.default.createElement('div',{className:'portal-portalsetting-moremenu-pop'},_react2.default.createElement('div',{className:'wea-new-top-drop-menu wea-right-menu',style:{display:showDrop?'block':'none'},onMouseLeave:onShowDrop},_react2.default.createElement('div',{className:'wea-right-menu-icon-background'}),menu),children);}}]);return OperateMenu;}(_react2.default.Component);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js?v=90bec3ad